//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ConfigService } from './_services/config.service';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class ClientBase {

  constructor(private configService: ConfigService) {
  }

  protected getBaseUrl(defaultUrl: string){ 
    return this.configService.config.api.baseUrl;
  }

  protected transformOptions(options: any) {
    if (this.configService && this.configService.config !== undefined) {
      const tokenInfo = sessionStorage.getItem(`oidc.user:${this.configService.config.ids4.authorityUrl}:${this.configService.config.ids4.clientId}`);

      if (tokenInfo) {
        const token = JSON.parse(tokenInfo);

        if (token) {
           options.headers.append('Authorization', "Bearer " + token.access_token);
           options.headers.append('X-id-token', token.id_token);
        } 
      }
    }

    options.headers.append('Cache-Control', 'no-cache');
    options.headers.append('Pragma', 'no-cache');

    return Promise.resolve(options);
  }
}

export interface IErrorClient {
    error(): Observable<FileResponse>;
}

@Injectable()
export class ErrorClient extends ClientBase implements IErrorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    error(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processError(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IAutomationProcessClient {
    forceExecution(id: string, nextStep: ProcessStep): Observable<boolean>;
}

@Injectable()
export class AutomationProcessClient extends ClientBase implements IAutomationProcessClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    forceExecution(id: string, nextStep: ProcessStep): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/process/{id}/execute/{nextStep}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (nextStep === undefined || nextStep === null)
            throw new Error("The parameter 'nextStep' must be defined.");
        url_ = url_.replace("{nextStep}", encodeURIComponent("" + nextStep));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processForceExecution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceExecution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForceExecution(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IAvailableMissionsClient {
    getFilters(): Observable<GetAvailableMissionListFiltersViewModel>;
    getList(pageNumber: number | undefined, pageSize: number | undefined, filter: GetAvailableMissionListFilter): Observable<GetAvailableMissionListViewModel>;
}

@Injectable()
export class AvailableMissionsClient extends ClientBase implements IAvailableMissionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getFilters(): Observable<GetAvailableMissionListFiltersViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/available-missions/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAvailableMissionListFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAvailableMissionListFiltersViewModel>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<GetAvailableMissionListFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableMissionListFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAvailableMissionListFiltersViewModel>(null as any);
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, filter: GetAvailableMissionListFilter): Observable<GetAvailableMissionListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/available-missions?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAvailableMissionListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAvailableMissionListViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetAvailableMissionListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableMissionListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAvailableMissionListViewModel>(null as any);
    }
}

export interface ICorporateWidgetOptionsClient {
    getCorporateWidgetOptions(subscriptionServiceId: string, projectId: string): Observable<GetCorporateWidgetOptionsListViewModel>;
    upsertCorporateWidgetOptions(subscriptionServiceId: string, projectId: string, widgetType: GetWidgetOptionsWidgetType, dto: UpsertCorporateWidgetOptionsDto): Observable<UpsertCorporateWidgetOptionsViewModel>;
}

@Injectable()
export class CorporateWidgetOptionsClient extends ClientBase implements ICorporateWidgetOptionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getCorporateWidgetOptions(subscriptionServiceId: string, projectId: string): Observable<GetCorporateWidgetOptionsListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/corporateWidgetOptions";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCorporateWidgetOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorporateWidgetOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCorporateWidgetOptionsListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCorporateWidgetOptionsListViewModel>;
        }));
    }

    protected processGetCorporateWidgetOptions(response: HttpResponseBase): Observable<GetCorporateWidgetOptionsListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCorporateWidgetOptionsListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCorporateWidgetOptionsListViewModel>(null as any);
    }

    upsertCorporateWidgetOptions(subscriptionServiceId: string, projectId: string, widgetType: GetWidgetOptionsWidgetType, dto: UpsertCorporateWidgetOptionsDto): Observable<UpsertCorporateWidgetOptionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/corporateWidgetOptions/{widgetType}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (widgetType === undefined || widgetType === null)
            throw new Error("The parameter 'widgetType' must be defined.");
        url_ = url_.replace("{widgetType}", encodeURIComponent("" + widgetType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpsertCorporateWidgetOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCorporateWidgetOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertCorporateWidgetOptionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertCorporateWidgetOptionsViewModel>;
        }));
    }

    protected processUpsertCorporateWidgetOptions(response: HttpResponseBase): Observable<UpsertCorporateWidgetOptionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertCorporateWidgetOptionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertCorporateWidgetOptionsViewModel>(null as any);
    }
}

export interface IDashboardClient {
    getDashboards(filterSet: GetRealTimeDashboardFilterSet): Observable<GetDashboardListViewModel>;
    getDashboardFilters(subscriptionId: string | null | undefined): Observable<GetDashboardListFiltersViewModel>;
    getSummaryDashboards(filterSet: GetSummaryDashboardsFilterSet): Observable<GetSummaryDashboardsViewModel>;
    getProgression(periodMissionConfigId: string): Observable<GetProgressionViewModel>;
    getStats(periodMissionConfigId: string): Observable<GetStatisticsViewModel>;
    getAutomatisationList(periodMissionConfigId: string, paginatedRequest: PaginatedRequest): Observable<GetAutomatisationListViewModel>;
    getBasicDashboardInfo(periodMissionConfigId: string): Observable<GetBasicDashboardInfoViewModel>;
    getAvailableMissions(periodMissionConfigId: string, pageNumber: number | undefined, pageSize: number | undefined, branchName: string | null | undefined): Observable<AvailableMissionsViewModel>;
    getAssignedMissions(periodMissionConfigId: string, pageNumber: number | undefined, pageSize: number | undefined): Observable<MissionsAssignationsViewModel>;
    getMissionOverview(periodMissionConfigId: string): Observable<GetMissionOverviewViewModel>;
    getCallListEntries(periodMissionConfigId: string, filters: GetCallListEntriesFilter): Observable<GetCallListEntriesViewModel>;
    getCallListEntriesFilter(periodMissionConfigId: string): Observable<GetCallListEntriesFilterViewModel>;
    getCallListDetails(periodMissionConfigId: string, mysteryShopperId: string): Observable<GetCallListEntriesDetailsViewModel>;
}

@Injectable()
export class DashboardClient extends ClientBase implements IDashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getDashboards(filterSet: GetRealTimeDashboardFilterSet): Observable<GetDashboardListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSet);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardListViewModel>;
        }));
    }

    protected processGetDashboards(response: HttpResponseBase): Observable<GetDashboardListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDashboardListViewModel>(null as any);
    }

    getDashboardFilters(subscriptionId: string | null | undefined): Observable<GetDashboardListFiltersViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/filters?";
        if (subscriptionId !== undefined && subscriptionId !== null)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDashboardFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardListFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardListFiltersViewModel>;
        }));
    }

    protected processGetDashboardFilters(response: HttpResponseBase): Observable<GetDashboardListFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardListFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDashboardListFiltersViewModel>(null as any);
    }

    getSummaryDashboards(filterSet: GetSummaryDashboardsFilterSet): Observable<GetSummaryDashboardsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSet);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummaryDashboards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryDashboards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSummaryDashboardsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSummaryDashboardsViewModel>;
        }));
    }

    protected processGetSummaryDashboards(response: HttpResponseBase): Observable<GetSummaryDashboardsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSummaryDashboardsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSummaryDashboardsViewModel>(null as any);
    }

    getProgression(periodMissionConfigId: string): Observable<GetProgressionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/{periodMissionConfigId}/progression";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProgression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgressionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgressionViewModel>;
        }));
    }

    protected processGetProgression(response: HttpResponseBase): Observable<GetProgressionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProgressionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgressionViewModel>(null as any);
    }

    getStats(periodMissionConfigId: string): Observable<GetStatisticsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/{periodMissionConfigId}/stats";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStatisticsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStatisticsViewModel>;
        }));
    }

    protected processGetStats(response: HttpResponseBase): Observable<GetStatisticsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStatisticsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStatisticsViewModel>(null as any);
    }

    getAutomatisationList(periodMissionConfigId: string, paginatedRequest: PaginatedRequest): Observable<GetAutomatisationListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/{periodMissionConfigId}/automatisation-list";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paginatedRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAutomatisationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomatisationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAutomatisationListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAutomatisationListViewModel>;
        }));
    }

    protected processGetAutomatisationList(response: HttpResponseBase): Observable<GetAutomatisationListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAutomatisationListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAutomatisationListViewModel>(null as any);
    }

    getBasicDashboardInfo(periodMissionConfigId: string): Observable<GetBasicDashboardInfoViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/{periodMissionConfigId}/basic-info";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBasicDashboardInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicDashboardInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBasicDashboardInfoViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBasicDashboardInfoViewModel>;
        }));
    }

    protected processGetBasicDashboardInfo(response: HttpResponseBase): Observable<GetBasicDashboardInfoViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBasicDashboardInfoViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBasicDashboardInfoViewModel>(null as any);
    }

    getAvailableMissions(periodMissionConfigId: string, pageNumber: number | undefined, pageSize: number | undefined, branchName: string | null | undefined): Observable<AvailableMissionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/{periodMissionConfigId}/available-missions?";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (branchName !== undefined && branchName !== null)
            url_ += "branchName=" + encodeURIComponent("" + branchName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAvailableMissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableMissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableMissionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableMissionsViewModel>;
        }));
    }

    protected processGetAvailableMissions(response: HttpResponseBase): Observable<AvailableMissionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailableMissionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailableMissionsViewModel>(null as any);
    }

    getAssignedMissions(periodMissionConfigId: string, pageNumber: number | undefined, pageSize: number | undefined): Observable<MissionsAssignationsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/{periodMissionConfigId}/assigned-missions?";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAssignedMissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedMissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MissionsAssignationsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MissionsAssignationsViewModel>;
        }));
    }

    protected processGetAssignedMissions(response: HttpResponseBase): Observable<MissionsAssignationsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MissionsAssignationsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MissionsAssignationsViewModel>(null as any);
    }

    getMissionOverview(periodMissionConfigId: string): Observable<GetMissionOverviewViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/{periodMissionConfigId}/missions/overview";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionOverviewViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionOverviewViewModel>;
        }));
    }

    protected processGetMissionOverview(response: HttpResponseBase): Observable<GetMissionOverviewViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionOverviewViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionOverviewViewModel>(null as any);
    }

    getCallListEntries(periodMissionConfigId: string, filters: GetCallListEntriesFilter): Observable<GetCallListEntriesViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/{periodMissionConfigId}/call-list";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCallListEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCallListEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCallListEntriesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCallListEntriesViewModel>;
        }));
    }

    protected processGetCallListEntries(response: HttpResponseBase): Observable<GetCallListEntriesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCallListEntriesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCallListEntriesViewModel>(null as any);
    }

    getCallListEntriesFilter(periodMissionConfigId: string): Observable<GetCallListEntriesFilterViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/{periodMissionConfigId}/call-list/filters";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCallListEntriesFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCallListEntriesFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCallListEntriesFilterViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCallListEntriesFilterViewModel>;
        }));
    }

    protected processGetCallListEntriesFilter(response: HttpResponseBase): Observable<GetCallListEntriesFilterViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCallListEntriesFilterViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCallListEntriesFilterViewModel>(null as any);
    }

    getCallListDetails(periodMissionConfigId: string, mysteryShopperId: string): Observable<GetCallListEntriesDetailsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/dashboards/{periodMissionConfigId}/call-list/{mysteryShopperId}/details";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCallListDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCallListDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCallListEntriesDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCallListEntriesDetailsViewModel>;
        }));
    }

    protected processGetCallListDetails(response: HttpResponseBase): Observable<GetCallListEntriesDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCallListEntriesDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCallListEntriesDetailsViewModel>(null as any);
    }
}

export interface IFakeValidationsClient {
    getFakeValidations(projectId: string, formId: string, versionId: string): Observable<GetFakeValidationViewModel>;
    createOrUpdateFakeValidations(projectId: string, formId: string, versionId: string, fakeValidations: CreateOrUpdateFakeValidationCommandViewModel): Observable<string[]>;
    deleteFakeValidation(versionId: string, projectId: string, formId: string, validationId: string | undefined): Observable<boolean>;
    generateFakeValidations(projectId: string, formId: string, versionId: string): Observable<boolean>;
}

@Injectable()
export class FakeValidationsClient extends ClientBase implements IFakeValidationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getFakeValidations(projectId: string, formId: string, versionId: string): Observable<GetFakeValidationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/projects/{projectId}/forms/{formId}/versions/{versionId}/fakevalidations";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFakeValidations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFakeValidations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFakeValidationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFakeValidationViewModel>;
        }));
    }

    protected processGetFakeValidations(response: HttpResponseBase): Observable<GetFakeValidationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFakeValidationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFakeValidationViewModel>(null as any);
    }

    createOrUpdateFakeValidations(projectId: string, formId: string, versionId: string, fakeValidations: CreateOrUpdateFakeValidationCommandViewModel): Observable<string[]> {
        let url_ = this.baseUrl + "/api/ms/superadmin/projects/{projectId}/forms/{formId}/versions/{versionId}/fakevalidations";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fakeValidations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateFakeValidations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateFakeValidations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processCreateOrUpdateFakeValidations(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    deleteFakeValidation(versionId: string, projectId: string, formId: string, validationId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/projects/{projectId}/forms/{formId}/versions/{versionId}/fakevalidations?";
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (validationId === null)
            throw new Error("The parameter 'validationId' cannot be null.");
        else if (validationId !== undefined)
            url_ += "validationId=" + encodeURIComponent("" + validationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteFakeValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFakeValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteFakeValidation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    generateFakeValidations(projectId: string, formId: string, versionId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/projects/{projectId}/forms/{formId}/versions/{versionId}/fakevalidations/generate";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateFakeValidations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateFakeValidations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGenerateFakeValidations(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IFormsClient {
    getWizard(subscriptionServiceId: string, projectId: string): Observable<GetCreateFormWizardViewModel>;
    getForms(subscriptionServiceId: string, projectId: string): Observable<GetFormListViewModel>;
    createForm(subscriptionServiceId: string, projectId: string, formVersionId: string | null | undefined, data: CreateFormDto): Observable<string>;
    getMetadata(subscriptionServiceId: string, projectId: string, formId: string): Observable<GetMetadataViewModel>;
    getForm(subscriptionServiceId: string, projectId: string, formId: string): Observable<GetFormViewModel>;
    updateForm(subscriptionServiceId: string, projectId: string, formId: string, data: UpdateFormCultureDto[]): Observable<boolean>;
    publishFormVersion(subscriptionServiceId: string, projectId: string, formId: string, versionId: string): Observable<boolean>;
    duplicateFormVersion(subscriptionServiceId: string, projectId: string, formId: string, versionId: string): Observable<DuplicateFormVersionResponseViewModel>;
    getSpecificFormJson(subscriptionServiceId: string, projectId: string, formId: string, versionId: string): Observable<string>;
    getWordExport(subscriptionServiceId: string, projectId: string, formId: string, versionId: string, dto: WordExportDto): Observable<FileResponse>;
    enqueueFormVersion(subscriptionServiceId: string, projectId: string, formId: string, versionId: string): Observable<boolean>;
    addFormVersion(subscriptionServiceId: string, projectId: string, formId: string, version: MysteryShoppingFormVersionDto): Observable<MysteryShoppingFormVersionViewModel>;
    updateFormVersion(subscriptionServiceId: string, projectId: string, formId: string, versionId: string, version: MysteryShoppingFormVersionDto): Observable<boolean>;
    getValidations(subscriptionServiceId: string, projectId: string, formId: string, versionId: string): Observable<GetValidationViewModel>;
    addFormVersion2(subscriptionServiceId: string, projectId: string, formVersionId: string, dto: FormVersionTransferDto): Observable<boolean>;
    get(formId: string, projectId: string, subscriptionServiceId: string): Observable<GetFormByIdViewModel>;
    delete(formId: string, projectId: string, subscriptionServiceId: string): Observable<DeleteFormViewModel>;
    create(projectId: string, subscriptionServiceId: string, createFormCommandDto: CreateFormCommandDto): Observable<CreateFormViewModel>;
    update(projectId: string, subscriptionServiceId: string, updateFormCommandDto: UpdateFormCommandDto): Observable<UpdateFormViewModel>;
}

@Injectable()
export class FormsClient extends ClientBase implements IFormsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getWizard(subscriptionServiceId: string, projectId: string): Observable<GetCreateFormWizardViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/wizard";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWizard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWizard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCreateFormWizardViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCreateFormWizardViewModel>;
        }));
    }

    protected processGetWizard(response: HttpResponseBase): Observable<GetCreateFormWizardViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateFormWizardViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCreateFormWizardViewModel>(null as any);
    }

    getForms(subscriptionServiceId: string, projectId: string): Observable<GetFormListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFormListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFormListViewModel>;
        }));
    }

    protected processGetForms(response: HttpResponseBase): Observable<GetFormListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFormListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormListViewModel>(null as any);
    }

    createForm(subscriptionServiceId: string, projectId: string, formVersionId: string | null | undefined, data: CreateFormDto): Observable<string> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formVersionId !== undefined && formVersionId !== null)
            url_ += "formVersionId=" + encodeURIComponent("" + formVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateForm(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getMetadata(subscriptionServiceId: string, projectId: string, formId: string): Observable<GetMetadataViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/metadata";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMetadataViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMetadataViewModel>;
        }));
    }

    protected processGetMetadata(response: HttpResponseBase): Observable<GetMetadataViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMetadataViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMetadataViewModel>(null as any);
    }

    getForm(subscriptionServiceId: string, projectId: string, formId: string): Observable<GetFormViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFormViewModel>;
        }));
    }

    protected processGetForm(response: HttpResponseBase): Observable<GetFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormViewModel>(null as any);
    }

    updateForm(subscriptionServiceId: string, projectId: string, formId: string, data: UpdateFormCultureDto[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateForm(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    publishFormVersion(subscriptionServiceId: string, projectId: string, formId: string, versionId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{versionId}/publish";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPublishFormVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishFormVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPublishFormVersion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    duplicateFormVersion(subscriptionServiceId: string, projectId: string, formId: string, versionId: string): Observable<DuplicateFormVersionResponseViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{versionId}/duplicate";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDuplicateFormVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateFormVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DuplicateFormVersionResponseViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DuplicateFormVersionResponseViewModel>;
        }));
    }

    protected processDuplicateFormVersion(response: HttpResponseBase): Observable<DuplicateFormVersionResponseViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DuplicateFormVersionResponseViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DuplicateFormVersionResponseViewModel>(null as any);
    }

    getSpecificFormJson(subscriptionServiceId: string, projectId: string, formId: string, versionId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{versionId}/json";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSpecificFormJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecificFormJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSpecificFormJson(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getWordExport(subscriptionServiceId: string, projectId: string, formId: string, versionId: string, dto: WordExportDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{versionId}/word-export";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWordExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWordExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetWordExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    enqueueFormVersion(subscriptionServiceId: string, projectId: string, formId: string, versionId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{versionId}/enqueue";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEnqueueFormVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnqueueFormVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEnqueueFormVersion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    addFormVersion(subscriptionServiceId: string, projectId: string, formId: string, version: MysteryShoppingFormVersionDto): Observable<MysteryShoppingFormVersionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(version);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddFormVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFormVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MysteryShoppingFormVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MysteryShoppingFormVersionViewModel>;
        }));
    }

    protected processAddFormVersion(response: HttpResponseBase): Observable<MysteryShoppingFormVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MysteryShoppingFormVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MysteryShoppingFormVersionViewModel>(null as any);
    }

    updateFormVersion(subscriptionServiceId: string, projectId: string, formId: string, versionId: string, version: MysteryShoppingFormVersionDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{versionId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(version);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFormVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFormVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateFormVersion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getValidations(subscriptionServiceId: string, projectId: string, formId: string, versionId: string): Observable<GetValidationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{versionId}/validations";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetValidations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetValidationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetValidationViewModel>;
        }));
    }

    protected processGetValidations(response: HttpResponseBase): Observable<GetValidationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetValidationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetValidationViewModel>(null as any);
    }

    addFormVersion2(subscriptionServiceId: string, projectId: string, formVersionId: string, dto: FormVersionTransferDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/{subscriptionServiceId}/projects/{projectId}/forms/transfer-version/{formVersionId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formVersionId === undefined || formVersionId === null)
            throw new Error("The parameter 'formVersionId' must be defined.");
        url_ = url_.replace("{formVersionId}", encodeURIComponent("" + formVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddFormVersion2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFormVersion2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddFormVersion2(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    get(formId: string, projectId: string, subscriptionServiceId: string): Observable<GetFormByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/forms/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFormByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFormByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetFormByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFormByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormByIdViewModel>(null as any);
    }

    delete(formId: string, projectId: string, subscriptionServiceId: string): Observable<DeleteFormViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/forms/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteFormViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteFormViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, createFormCommandDto: CreateFormCommandDto): Observable<CreateFormViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/forms";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createFormCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateFormViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateFormViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, updateFormCommandDto: UpdateFormCommandDto): Observable<UpdateFormViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/forms";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFormCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateFormViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateFormViewModel>(null as any);
    }
}

export interface IGptValidationClient {
    getAIValidationsByQuestionId(pageNumber: number | undefined, pageSize: number | undefined, filters: GptValidationFilter): Observable<GptValidationResultViewModel>;
    getFilters(): Observable<GetGptValidationFiltersViewModel>;
    propagateAiValidationsStatus(data: { [key: string]: boolean; }): Observable<PropagateAiValidationStatusViewModel>;
    getValidatedImage(peerReviewValidationId: string): Observable<GetImageDataViewModel>;
}

@Injectable()
export class GptValidationClient extends ClientBase implements IGptValidationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getAIValidationsByQuestionId(pageNumber: number | undefined, pageSize: number | undefined, filters: GptValidationFilter): Observable<GptValidationResultViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/GptValidation?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAIValidationsByQuestionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAIValidationsByQuestionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GptValidationResultViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GptValidationResultViewModel>;
        }));
    }

    protected processGetAIValidationsByQuestionId(response: HttpResponseBase): Observable<GptValidationResultViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GptValidationResultViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GptValidationResultViewModel>(null as any);
    }

    getFilters(): Observable<GetGptValidationFiltersViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/GptValidation/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGptValidationFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGptValidationFiltersViewModel>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<GetGptValidationFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGptValidationFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGptValidationFiltersViewModel>(null as any);
    }

    propagateAiValidationsStatus(data: { [key: string]: boolean; }): Observable<PropagateAiValidationStatusViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/GptValidation/propagate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPropagateAiValidationsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPropagateAiValidationsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PropagateAiValidationStatusViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PropagateAiValidationStatusViewModel>;
        }));
    }

    protected processPropagateAiValidationsStatus(response: HttpResponseBase): Observable<PropagateAiValidationStatusViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropagateAiValidationStatusViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PropagateAiValidationStatusViewModel>(null as any);
    }

    getValidatedImage(peerReviewValidationId: string): Observable<GetImageDataViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/GptValidation/{peerReviewValidationId}/image";
        if (peerReviewValidationId === undefined || peerReviewValidationId === null)
            throw new Error("The parameter 'peerReviewValidationId' must be defined.");
        url_ = url_.replace("{peerReviewValidationId}", encodeURIComponent("" + peerReviewValidationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetValidatedImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidatedImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetImageDataViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetImageDataViewModel>;
        }));
    }

    protected processGetValidatedImage(response: HttpResponseBase): Observable<GetImageDataViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetImageDataViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetImageDataViewModel>(null as any);
    }
}

export interface IIndicatorsClient {
    getIndicators(subscriptionServiceId: string, projectId: string): Observable<GetIndicatorListViewModel>;
    createIndicator(subscriptionServiceId: string, projectId: string, indicator: CreateIndicatorDto): Observable<CreateIndicatorViewModel>;
    getIndicator(subscriptionServiceId: string, projectId: string, indicatorId: string): Observable<GetIndicatorViewModel>;
    updateIndicator(subscriptionServiceId: string, projectId: string, indicatorId: string, indicator: UpdateIndicatorRequest): Observable<boolean>;
    deleteIndicator(subscriptionServiceId: string, projectId: string, indicatorId: string): Observable<boolean>;
}

@Injectable()
export class IndicatorsClient extends ClientBase implements IIndicatorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getIndicators(subscriptionServiceId: string, projectId: string): Observable<GetIndicatorListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/indicators";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetIndicators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIndicators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIndicatorListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIndicatorListViewModel>;
        }));
    }

    protected processGetIndicators(response: HttpResponseBase): Observable<GetIndicatorListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIndicatorListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIndicatorListViewModel>(null as any);
    }

    createIndicator(subscriptionServiceId: string, projectId: string, indicator: CreateIndicatorDto): Observable<CreateIndicatorViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/indicators";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(indicator);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateIndicator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIndicator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateIndicatorViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateIndicatorViewModel>;
        }));
    }

    protected processCreateIndicator(response: HttpResponseBase): Observable<CreateIndicatorViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateIndicatorViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateIndicatorViewModel>(null as any);
    }

    getIndicator(subscriptionServiceId: string, projectId: string, indicatorId: string): Observable<GetIndicatorViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/indicators/{indicatorId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (indicatorId === undefined || indicatorId === null)
            throw new Error("The parameter 'indicatorId' must be defined.");
        url_ = url_.replace("{indicatorId}", encodeURIComponent("" + indicatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetIndicator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIndicator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIndicatorViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIndicatorViewModel>;
        }));
    }

    protected processGetIndicator(response: HttpResponseBase): Observable<GetIndicatorViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIndicatorViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIndicatorViewModel>(null as any);
    }

    updateIndicator(subscriptionServiceId: string, projectId: string, indicatorId: string, indicator: UpdateIndicatorRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/indicators/{indicatorId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (indicatorId === undefined || indicatorId === null)
            throw new Error("The parameter 'indicatorId' must be defined.");
        url_ = url_.replace("{indicatorId}", encodeURIComponent("" + indicatorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(indicator);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateIndicator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIndicator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateIndicator(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    deleteIndicator(subscriptionServiceId: string, projectId: string, indicatorId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/indicators/{indicatorId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (indicatorId === undefined || indicatorId === null)
            throw new Error("The parameter 'indicatorId' must be defined.");
        url_ = url_.replace("{indicatorId}", encodeURIComponent("" + indicatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteIndicator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteIndicator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteIndicator(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IMissionAssignationsClient {
    getFilters(): Observable<GetMissionAssignationListFiltersViewModel>;
    getSummary(filter: GetMissionAssignationListFilter): Observable<GetMissionAssignationListSummaryViewModel>;
    getList(pageNumber: number | undefined, pageSize: number | undefined, filter: GetMissionAssignationListFilter): Observable<GetMissionAssignationListViewModel>;
    concludePeerReviewsValidation(missionAssignationId: string): Observable<void>;
    setPeerReviewValidation(missionAnswerId: string, validationId: string, model: SetPeerReviewValidationViewModel): Observable<void>;
}

@Injectable()
export class MissionAssignationsClient extends ClientBase implements IMissionAssignationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getFilters(): Observable<GetMissionAssignationListFiltersViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/mission-assignations/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionAssignationListFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionAssignationListFiltersViewModel>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<GetMissionAssignationListFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionAssignationListFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionAssignationListFiltersViewModel>(null as any);
    }

    getSummary(filter: GetMissionAssignationListFilter): Observable<GetMissionAssignationListSummaryViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/mission-assignations/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionAssignationListSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionAssignationListSummaryViewModel>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<GetMissionAssignationListSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionAssignationListSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionAssignationListSummaryViewModel>(null as any);
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, filter: GetMissionAssignationListFilter): Observable<GetMissionAssignationListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/mission-assignations?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionAssignationListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionAssignationListViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetMissionAssignationListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionAssignationListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionAssignationListViewModel>(null as any);
    }

    concludePeerReviewsValidation(missionAssignationId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/mission-assignations/{missionAssignationId}/peer-reviews/conclude";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processConcludePeerReviewsValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConcludePeerReviewsValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConcludePeerReviewsValidation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    setPeerReviewValidation(missionAnswerId: string, validationId: string, model: SetPeerReviewValidationViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/mission-assignations/{missionAnswerId}/peer-reviews/{validationId}";
        if (missionAnswerId === undefined || missionAnswerId === null)
            throw new Error("The parameter 'missionAnswerId' must be defined.");
        url_ = url_.replace("{missionAnswerId}", encodeURIComponent("" + missionAnswerId));
        if (validationId === undefined || validationId === null)
            throw new Error("The parameter 'validationId' must be defined.");
        url_ = url_.replace("{validationId}", encodeURIComponent("" + validationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetPeerReviewValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPeerReviewValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetPeerReviewValidation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IMissionConfigurationGroupsClient {
    getList(subscriptionServiceId: string, projectId: string, missionConfigurationGroupSortField: MissionConfigurationGroupSortingField | undefined, sortingDirection: SortingDirection | undefined, searchText: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<MissionConfigurationGroupListViewModel>;
    add(subscriptionServiceId: string, projectId: string, missionConfigurationGroupDto: CreateMissionConfigurationGroupDto): Observable<CreateMissionConfigurationGroupViewModel>;
    get(subscriptionServiceId: string, projectId: string, missionConfigurationGroupId: string): Observable<MissionConfigurationGroupViewModel>;
    delete(subscriptionServiceId: string, projectId: string, missionConfigurationGroupId: string): Observable<DeleteMissionConfigurationGroupViewModel>;
    update(subscriptionServiceId: string, projectId: string, missionConfigurationGroupId: string, missionConfigurationGroupDto: UpdateMissionConfigurationGroupDto): Observable<UpdateMissionConfigurationGroupViewModel>;
}

@Injectable()
export class MissionConfigurationGroupsClient extends ClientBase implements IMissionConfigurationGroupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(subscriptionServiceId: string, projectId: string, missionConfigurationGroupSortField: MissionConfigurationGroupSortingField | undefined, sortingDirection: SortingDirection | undefined, searchText: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<MissionConfigurationGroupListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configuration-groups?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (missionConfigurationGroupSortField === null)
            throw new Error("The parameter 'missionConfigurationGroupSortField' cannot be null.");
        else if (missionConfigurationGroupSortField !== undefined)
            url_ += "MissionConfigurationGroupSortField=" + encodeURIComponent("" + missionConfigurationGroupSortField) + "&";
        if (sortingDirection === null)
            throw new Error("The parameter 'sortingDirection' cannot be null.");
        else if (sortingDirection !== undefined)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MissionConfigurationGroupListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MissionConfigurationGroupListViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<MissionConfigurationGroupListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MissionConfigurationGroupListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MissionConfigurationGroupListViewModel>(null as any);
    }

    add(subscriptionServiceId: string, projectId: string, missionConfigurationGroupDto: CreateMissionConfigurationGroupDto): Observable<CreateMissionConfigurationGroupViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configuration-groups";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(missionConfigurationGroupDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMissionConfigurationGroupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMissionConfigurationGroupViewModel>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<CreateMissionConfigurationGroupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMissionConfigurationGroupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateMissionConfigurationGroupViewModel>(null as any);
    }

    get(subscriptionServiceId: string, projectId: string, missionConfigurationGroupId: string): Observable<MissionConfigurationGroupViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configuration-groups/{missionConfigurationGroupId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (missionConfigurationGroupId === undefined || missionConfigurationGroupId === null)
            throw new Error("The parameter 'missionConfigurationGroupId' must be defined.");
        url_ = url_.replace("{missionConfigurationGroupId}", encodeURIComponent("" + missionConfigurationGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MissionConfigurationGroupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MissionConfigurationGroupViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MissionConfigurationGroupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MissionConfigurationGroupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MissionConfigurationGroupViewModel>(null as any);
    }

    delete(subscriptionServiceId: string, projectId: string, missionConfigurationGroupId: string): Observable<DeleteMissionConfigurationGroupViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configuration-groups/{missionConfigurationGroupId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (missionConfigurationGroupId === undefined || missionConfigurationGroupId === null)
            throw new Error("The parameter 'missionConfigurationGroupId' must be defined.");
        url_ = url_.replace("{missionConfigurationGroupId}", encodeURIComponent("" + missionConfigurationGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteMissionConfigurationGroupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteMissionConfigurationGroupViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteMissionConfigurationGroupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteMissionConfigurationGroupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteMissionConfigurationGroupViewModel>(null as any);
    }

    update(subscriptionServiceId: string, projectId: string, missionConfigurationGroupId: string, missionConfigurationGroupDto: UpdateMissionConfigurationGroupDto): Observable<UpdateMissionConfigurationGroupViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configuration-groups/{missionConfigurationGroupId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (missionConfigurationGroupId === undefined || missionConfigurationGroupId === null)
            throw new Error("The parameter 'missionConfigurationGroupId' must be defined.");
        url_ = url_.replace("{missionConfigurationGroupId}", encodeURIComponent("" + missionConfigurationGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(missionConfigurationGroupDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateMissionConfigurationGroupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateMissionConfigurationGroupViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateMissionConfigurationGroupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMissionConfigurationGroupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateMissionConfigurationGroupViewModel>(null as any);
    }
}

export interface IMissionConfigurationsClient {
    getMissionConfigurations(subscriptionServiceId: string, projectId: string): Observable<GetMissionConfigurationListViewModel>;
    createMissionConfiguration(subscriptionServiceId: string, projectId: string, data: CreateMissionConfigurationDto): Observable<CreateMissionConfigurationViewModel>;
    deleteMissionConfiguration(subscriptionServiceId: string, projectId: string, missionConfigurationId: string): Observable<boolean>;
    getLatestMissionConfigurationVersion(subscriptionServiceId: string, projectId: string, missionConfigurationId: string): Observable<GetMissionConfigurationViewModel>;
    cloneLatestMissionConfigurationVersion(subscriptionServiceId: string, projectId: string, missionConfigurationId: string): Observable<CloneMissionConfigurationViewModel>;
    getMissionConfigurationVersion(subscriptionServiceId: string, projectId: string, missionConfigurationId: string, missionConfigurationVersionId: string): Observable<GetMissionConfigurationViewModel>;
    updateMissionConfigurationVersion(subscriptionServiceId: string, projectId: string, missionConfigurationId: string, missionConfigurationVersionId: string, data: UpdateMissionConfigurationRequest): Observable<UpdateMissionConfigurationViewModel>;
    cloneSpecificMissionConfigurationVersion(subscriptionServiceId: string, projectId: string, missionConfigurationId: string, missionConfigurationVersionId: string): Observable<CloneMissionConfigurationViewModel>;
}

@Injectable()
export class MissionConfigurationsClient extends ClientBase implements IMissionConfigurationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getMissionConfigurations(subscriptionServiceId: string, projectId: string): Observable<GetMissionConfigurationListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configurations";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionConfigurationListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionConfigurationListViewModel>;
        }));
    }

    protected processGetMissionConfigurations(response: HttpResponseBase): Observable<GetMissionConfigurationListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionConfigurationListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionConfigurationListViewModel>(null as any);
    }

    createMissionConfiguration(subscriptionServiceId: string, projectId: string, data: CreateMissionConfigurationDto): Observable<CreateMissionConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configurations";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateMissionConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMissionConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMissionConfigurationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMissionConfigurationViewModel>;
        }));
    }

    protected processCreateMissionConfiguration(response: HttpResponseBase): Observable<CreateMissionConfigurationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMissionConfigurationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateMissionConfigurationViewModel>(null as any);
    }

    deleteMissionConfiguration(subscriptionServiceId: string, projectId: string, missionConfigurationId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configurations/{missionConfigurationId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (missionConfigurationId === undefined || missionConfigurationId === null)
            throw new Error("The parameter 'missionConfigurationId' must be defined.");
        url_ = url_.replace("{missionConfigurationId}", encodeURIComponent("" + missionConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteMissionConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMissionConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteMissionConfiguration(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getLatestMissionConfigurationVersion(subscriptionServiceId: string, projectId: string, missionConfigurationId: string): Observable<GetMissionConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configurations/{missionConfigurationId}/versions/latest";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (missionConfigurationId === undefined || missionConfigurationId === null)
            throw new Error("The parameter 'missionConfigurationId' must be defined.");
        url_ = url_.replace("{missionConfigurationId}", encodeURIComponent("" + missionConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLatestMissionConfigurationVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestMissionConfigurationVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionConfigurationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionConfigurationViewModel>;
        }));
    }

    protected processGetLatestMissionConfigurationVersion(response: HttpResponseBase): Observable<GetMissionConfigurationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionConfigurationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionConfigurationViewModel>(null as any);
    }

    cloneLatestMissionConfigurationVersion(subscriptionServiceId: string, projectId: string, missionConfigurationId: string): Observable<CloneMissionConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configurations/{missionConfigurationId}/versions/latest";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (missionConfigurationId === undefined || missionConfigurationId === null)
            throw new Error("The parameter 'missionConfigurationId' must be defined.");
        url_ = url_.replace("{missionConfigurationId}", encodeURIComponent("" + missionConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCloneLatestMissionConfigurationVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneLatestMissionConfigurationVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CloneMissionConfigurationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CloneMissionConfigurationViewModel>;
        }));
    }

    protected processCloneLatestMissionConfigurationVersion(response: HttpResponseBase): Observable<CloneMissionConfigurationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CloneMissionConfigurationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CloneMissionConfigurationViewModel>(null as any);
    }

    getMissionConfigurationVersion(subscriptionServiceId: string, projectId: string, missionConfigurationId: string, missionConfigurationVersionId: string): Observable<GetMissionConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configurations/{missionConfigurationId}/versions/{missionConfigurationVersionId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (missionConfigurationId === undefined || missionConfigurationId === null)
            throw new Error("The parameter 'missionConfigurationId' must be defined.");
        url_ = url_.replace("{missionConfigurationId}", encodeURIComponent("" + missionConfigurationId));
        if (missionConfigurationVersionId === undefined || missionConfigurationVersionId === null)
            throw new Error("The parameter 'missionConfigurationVersionId' must be defined.");
        url_ = url_.replace("{missionConfigurationVersionId}", encodeURIComponent("" + missionConfigurationVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionConfigurationVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionConfigurationVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionConfigurationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionConfigurationViewModel>;
        }));
    }

    protected processGetMissionConfigurationVersion(response: HttpResponseBase): Observable<GetMissionConfigurationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionConfigurationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionConfigurationViewModel>(null as any);
    }

    updateMissionConfigurationVersion(subscriptionServiceId: string, projectId: string, missionConfigurationId: string, missionConfigurationVersionId: string, data: UpdateMissionConfigurationRequest): Observable<UpdateMissionConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configurations/{missionConfigurationId}/versions/{missionConfigurationVersionId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (missionConfigurationId === undefined || missionConfigurationId === null)
            throw new Error("The parameter 'missionConfigurationId' must be defined.");
        url_ = url_.replace("{missionConfigurationId}", encodeURIComponent("" + missionConfigurationId));
        if (missionConfigurationVersionId === undefined || missionConfigurationVersionId === null)
            throw new Error("The parameter 'missionConfigurationVersionId' must be defined.");
        url_ = url_.replace("{missionConfigurationVersionId}", encodeURIComponent("" + missionConfigurationVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateMissionConfigurationVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMissionConfigurationVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateMissionConfigurationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateMissionConfigurationViewModel>;
        }));
    }

    protected processUpdateMissionConfigurationVersion(response: HttpResponseBase): Observable<UpdateMissionConfigurationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMissionConfigurationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateMissionConfigurationViewModel>(null as any);
    }

    cloneSpecificMissionConfigurationVersion(subscriptionServiceId: string, projectId: string, missionConfigurationId: string, missionConfigurationVersionId: string): Observable<CloneMissionConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/mission-configurations/{missionConfigurationId}/versions/{missionConfigurationVersionId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (missionConfigurationId === undefined || missionConfigurationId === null)
            throw new Error("The parameter 'missionConfigurationId' must be defined.");
        url_ = url_.replace("{missionConfigurationId}", encodeURIComponent("" + missionConfigurationId));
        if (missionConfigurationVersionId === undefined || missionConfigurationVersionId === null)
            throw new Error("The parameter 'missionConfigurationVersionId' must be defined.");
        url_ = url_.replace("{missionConfigurationVersionId}", encodeURIComponent("" + missionConfigurationVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCloneSpecificMissionConfigurationVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneSpecificMissionConfigurationVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CloneMissionConfigurationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CloneMissionConfigurationViewModel>;
        }));
    }

    protected processCloneSpecificMissionConfigurationVersion(response: HttpResponseBase): Observable<CloneMissionConfigurationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CloneMissionConfigurationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CloneMissionConfigurationViewModel>(null as any);
    }
}

export interface IMissionClient {
    getList(pageNumber: number | undefined, pageSize: number | undefined, filters: GetMissionListFilter): Observable<GetMissionListViewModel>;
    getSummary(filters: GetMissionListFilter): Observable<GetMissionListSummaryViewModel>;
    getFilters(): Observable<GetMissionListFiltersViewModel>;
    getMap(bottomRightLocation: string | undefined, topLeftLocation: string | undefined, filters: GetMissionListFilter): Observable<GetMissionListMapViewModel>;
}

@Injectable()
export class MissionClient extends ClientBase implements IMissionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, filters: GetMissionListFilter): Observable<GetMissionListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/missions?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionListViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetMissionListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionListViewModel>(null as any);
    }

    getSummary(filters: GetMissionListFilter): Observable<GetMissionListSummaryViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/missions/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionListSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionListSummaryViewModel>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<GetMissionListSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionListSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionListSummaryViewModel>(null as any);
    }

    getFilters(): Observable<GetMissionListFiltersViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/missions/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionListFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionListFiltersViewModel>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<GetMissionListFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionListFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionListFiltersViewModel>(null as any);
    }

    getMap(bottomRightLocation: string | undefined, topLeftLocation: string | undefined, filters: GetMissionListFilter): Observable<GetMissionListMapViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/missions/map?";
        if (bottomRightLocation === null)
            throw new Error("The parameter 'bottomRightLocation' cannot be null.");
        else if (bottomRightLocation !== undefined)
            url_ += "bottomRightLocation=" + encodeURIComponent("" + bottomRightLocation) + "&";
        if (topLeftLocation === null)
            throw new Error("The parameter 'topLeftLocation' cannot be null.");
        else if (topLeftLocation !== undefined)
            url_ += "topLeftLocation=" + encodeURIComponent("" + topLeftLocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionListMapViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionListMapViewModel>;
        }));
    }

    protected processGetMap(response: HttpResponseBase): Observable<GetMissionListMapViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionListMapViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionListMapViewModel>(null as any);
    }
}

export interface IMysteryShoppersClient {
    getMysteryShoppers(pageNumber: number | undefined, pageSize: number | undefined, filters: MysteryShopperFilters): Observable<GetMysteryShopperListViewModel>;
    getMysteryShopperValidations(mysteryShopperId: string, pageNumber: number | undefined, pageSize: number | undefined): Observable<GetMysteryShopperValidationsViewModel>;
    getMysteryShopper(mysteryShopperId: string): Observable<GetMysteryShopperViewModel>;
    updateMysteryShopper(mysteryShopperId: string, mysteryShopper: UpdateMysteryShopperDto): Observable<UpdateMysteryShopperProfileViewModel>;
    deleteMysteryShopper(mysteryShopperId: string): Observable<boolean>;
    getMysteryShopperMissions(mysteryShopperId: string, pageNumber: number | undefined, pageSize: number | undefined): Observable<GetMysteryShopperMissionsViewModel>;
    assignMission(mysteryShopperId: string, branchId: string | undefined, periodMissionConfigurationId: string | undefined): Observable<void>;
    unassignedAllMissions(mysteryShopperId: string): Observable<void>;
    getMissionsStats(mysteryShopperId: string): Observable<GetMissionsStatsViewModel>;
    getSurveyAnswers(mysteryShopperId: string, missionAssignationId: string): Observable<GetSurveyAnswersViewModel>;
    getMysteryShopperFilters(): Observable<GetMysteryShopperFiltersViewModel>;
    archiveMysteryShopperInterest(mysteryShopperId: string, interestId: string): Observable<boolean>;
    getValidations(mysteryShopperId: string, missionAssignationId: string): Observable<GetValidationViewModel>;
    extendMission(mysteryShopperId: string, missionAssignation: string, requestedDay: number | undefined): Observable<Date>;
    renewExpiredMission(mysteryShopperId: string, missionAssignationId: string): Observable<void>;
    requeueMission(mysteryShopperId: string, missionAssignationId: string): Observable<boolean>;
    updateSurveyAnswerJson(mysteryShopperId: string, missionAssignationId: string, surveyAnswerId: string, surveyAnswer: string): Observable<boolean>;
    bypassValidation(mysteryShopperId: string, missionAssignationId: string): Observable<BypassValidationViewModel>;
    deactivateMission(mysteryShopperId: string, missionAssignationId: string): Observable<void>;
    unassignedMission(mysteryShopperId: string, missionAssignationId: string, model: UnassignMissionDto): Observable<void>;
    deleteMysteryShopperAddress(mysteryShopperId: string, addressId: string): Observable<DeleteMysteryShopperAddressViewModel>;
    exportMysteryShoppers(exportType: ExportTableType | undefined, filters: MysteryShopperFilters): Observable<FileResponse>;
    publishInterest(mysteryShopperId: string, interest: InterestDto): Observable<void>;
    getMysteryShopperInterests(mysteryShopperId: string): Observable<GetMysteryShopperInterestsViewModel>;
    publishComment(mysteryShopperId: string, comment: CommentDto): Observable<void>;
    getMysteryShopperComments(mysteryShopperId: string): Observable<GetMysteryShopperCommentsViewModel>;
    getMysteryShopperNotifications(mysteryShopperId: string, pageNumber: number | undefined, pageSize: number | undefined): Observable<GetMysteryShopperNotificationsViewModel>;
    disableMysteryShopper(mysteryShopperId: string): Observable<boolean>;
    enableMysteryShopper(mysteryShopperId: string): Observable<boolean>;
    addCallLog(mysteryShopperId: string, data: CallLogDto): Observable<CreateCallLogViewModel>;
    getCallLogList(mysteryShopperId: string): Observable<GetCallLogListViewModel>;
    updateCallLog(mysteryShopperId: string, callLogId: string, data: CallLogDto): Observable<boolean>;
    deleteCallLog(mysteryShopperId: string, callLogId: string): Observable<boolean>;
    getCallLog(mysteryShopperId: string, callLogId: string): Observable<GetCallLogViewModel>;
    getMoveMissionAssignation(mysteryShopperId: string, missionAssignationId: string): Observable<GetMoveMissionResponse>;
    moveMissionAssignation(mysteryShopperId: string, missionAssignationId: string, data: MoveMissionRequest): Observable<MoveMissionResponse>;
}

@Injectable()
export class MysteryShoppersClient extends ClientBase implements IMysteryShoppersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getMysteryShoppers(pageNumber: number | undefined, pageSize: number | undefined, filters: MysteryShopperFilters): Observable<GetMysteryShopperListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMysteryShoppers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMysteryShoppers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMysteryShopperListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMysteryShopperListViewModel>;
        }));
    }

    protected processGetMysteryShoppers(response: HttpResponseBase): Observable<GetMysteryShopperListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMysteryShopperListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMysteryShopperListViewModel>(null as any);
    }

    getMysteryShopperValidations(mysteryShopperId: string, pageNumber: number | undefined, pageSize: number | undefined): Observable<GetMysteryShopperValidationsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/validations?";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMysteryShopperValidations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMysteryShopperValidations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMysteryShopperValidationsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMysteryShopperValidationsViewModel>;
        }));
    }

    protected processGetMysteryShopperValidations(response: HttpResponseBase): Observable<GetMysteryShopperValidationsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMysteryShopperValidationsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMysteryShopperValidationsViewModel>(null as any);
    }

    getMysteryShopper(mysteryShopperId: string): Observable<GetMysteryShopperViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMysteryShopper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMysteryShopper(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMysteryShopperViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMysteryShopperViewModel>;
        }));
    }

    protected processGetMysteryShopper(response: HttpResponseBase): Observable<GetMysteryShopperViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMysteryShopperViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMysteryShopperViewModel>(null as any);
    }

    updateMysteryShopper(mysteryShopperId: string, mysteryShopper: UpdateMysteryShopperDto): Observable<UpdateMysteryShopperProfileViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mysteryShopper);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateMysteryShopper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMysteryShopper(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateMysteryShopperProfileViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateMysteryShopperProfileViewModel>;
        }));
    }

    protected processUpdateMysteryShopper(response: HttpResponseBase): Observable<UpdateMysteryShopperProfileViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateMysteryShopperProfileViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateMysteryShopperProfileViewModel>(null as any);
    }

    deleteMysteryShopper(mysteryShopperId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteMysteryShopper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMysteryShopper(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteMysteryShopper(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getMysteryShopperMissions(mysteryShopperId: string, pageNumber: number | undefined, pageSize: number | undefined): Observable<GetMysteryShopperMissionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations?";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMysteryShopperMissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMysteryShopperMissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMysteryShopperMissionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMysteryShopperMissionsViewModel>;
        }));
    }

    protected processGetMysteryShopperMissions(response: HttpResponseBase): Observable<GetMysteryShopperMissionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMysteryShopperMissionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMysteryShopperMissionsViewModel>(null as any);
    }

    assignMission(mysteryShopperId: string, branchId: string | undefined, periodMissionConfigurationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations?";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        if (periodMissionConfigurationId === null)
            throw new Error("The parameter 'periodMissionConfigurationId' cannot be null.");
        else if (periodMissionConfigurationId !== undefined)
            url_ += "periodMissionConfigurationId=" + encodeURIComponent("" + periodMissionConfigurationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAssignMission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignMission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    unassignedAllMissions(mysteryShopperId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUnassignedAllMissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignedAllMissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignedAllMissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getMissionsStats(mysteryShopperId: string): Observable<GetMissionsStatsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/stats";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionsStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionsStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionsStatsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionsStatsViewModel>;
        }));
    }

    protected processGetMissionsStats(response: HttpResponseBase): Observable<GetMissionsStatsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionsStatsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionsStatsViewModel>(null as any);
    }

    getSurveyAnswers(mysteryShopperId: string, missionAssignationId: string): Observable<GetSurveyAnswersViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignationId}/survey-answers";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyAnswersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyAnswersViewModel>;
        }));
    }

    protected processGetSurveyAnswers(response: HttpResponseBase): Observable<GetSurveyAnswersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyAnswersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyAnswersViewModel>(null as any);
    }

    getMysteryShopperFilters(): Observable<GetMysteryShopperFiltersViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMysteryShopperFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMysteryShopperFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMysteryShopperFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMysteryShopperFiltersViewModel>;
        }));
    }

    protected processGetMysteryShopperFilters(response: HttpResponseBase): Observable<GetMysteryShopperFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMysteryShopperFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMysteryShopperFiltersViewModel>(null as any);
    }

    archiveMysteryShopperInterest(mysteryShopperId: string, interestId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/interests/{interestId}/archive";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (interestId === undefined || interestId === null)
            throw new Error("The parameter 'interestId' must be defined.");
        url_ = url_.replace("{interestId}", encodeURIComponent("" + interestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processArchiveMysteryShopperInterest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveMysteryShopperInterest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processArchiveMysteryShopperInterest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getValidations(mysteryShopperId: string, missionAssignationId: string): Observable<GetValidationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignationId}/validations";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetValidations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetValidationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetValidationViewModel>;
        }));
    }

    protected processGetValidations(response: HttpResponseBase): Observable<GetValidationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetValidationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetValidationViewModel>(null as any);
    }

    extendMission(mysteryShopperId: string, missionAssignation: string, requestedDay: number | undefined): Observable<Date> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignation}/extend?";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignation === undefined || missionAssignation === null)
            throw new Error("The parameter 'missionAssignation' must be defined.");
        url_ = url_.replace("{missionAssignation}", encodeURIComponent("" + missionAssignation));
        if (requestedDay === null)
            throw new Error("The parameter 'requestedDay' cannot be null.");
        else if (requestedDay !== undefined)
            url_ += "requestedDay=" + encodeURIComponent("" + requestedDay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExtendMission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendMission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date>;
        }));
    }

    protected processExtendMission(response: HttpResponseBase): Observable<Date> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Date>(null as any);
    }

    renewExpiredMission(mysteryShopperId: string, missionAssignationId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignationId}/renew-expired";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRenewExpiredMission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewExpiredMission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenewExpiredMission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    requeueMission(mysteryShopperId: string, missionAssignationId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignationId}/requeue";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequeueMission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequeueMission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRequeueMission(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    updateSurveyAnswerJson(mysteryShopperId: string, missionAssignationId: string, surveyAnswerId: string, surveyAnswer: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignationId}/survey-answers/{surveyAnswerId}";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        if (surveyAnswerId === undefined || surveyAnswerId === null)
            throw new Error("The parameter 'surveyAnswerId' must be defined.");
        url_ = url_.replace("{surveyAnswerId}", encodeURIComponent("" + surveyAnswerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyAnswer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSurveyAnswerJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSurveyAnswerJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateSurveyAnswerJson(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    bypassValidation(mysteryShopperId: string, missionAssignationId: string): Observable<BypassValidationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignationId}/bypass-validation";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBypassValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBypassValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BypassValidationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BypassValidationViewModel>;
        }));
    }

    protected processBypassValidation(response: HttpResponseBase): Observable<BypassValidationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BypassValidationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BypassValidationViewModel>(null as any);
    }

    deactivateMission(mysteryShopperId: string, missionAssignationId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignationId}/deactivate";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeactivateMission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateMission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateMission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    unassignedMission(mysteryShopperId: string, missionAssignationId: string, model: UnassignMissionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignationId}";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUnassignedMission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignedMission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignedMission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteMysteryShopperAddress(mysteryShopperId: string, addressId: string): Observable<DeleteMysteryShopperAddressViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/addresses/{addressId}";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteMysteryShopperAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMysteryShopperAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteMysteryShopperAddressViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteMysteryShopperAddressViewModel>;
        }));
    }

    protected processDeleteMysteryShopperAddress(response: HttpResponseBase): Observable<DeleteMysteryShopperAddressViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteMysteryShopperAddressViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteMysteryShopperAddressViewModel>(null as any);
    }

    exportMysteryShoppers(exportType: ExportTableType | undefined, filters: MysteryShopperFilters): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/export?";
        if (exportType === null)
            throw new Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExportMysteryShoppers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMysteryShoppers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportMysteryShoppers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    publishInterest(mysteryShopperId: string, interest: InterestDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/interests";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(interest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPublishInterest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishInterest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublishInterest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getMysteryShopperInterests(mysteryShopperId: string): Observable<GetMysteryShopperInterestsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/interests";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMysteryShopperInterests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMysteryShopperInterests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMysteryShopperInterestsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMysteryShopperInterestsViewModel>;
        }));
    }

    protected processGetMysteryShopperInterests(response: HttpResponseBase): Observable<GetMysteryShopperInterestsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMysteryShopperInterestsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMysteryShopperInterestsViewModel>(null as any);
    }

    publishComment(mysteryShopperId: string, comment: CommentDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/comments";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPublishComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublishComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getMysteryShopperComments(mysteryShopperId: string): Observable<GetMysteryShopperCommentsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/comments";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMysteryShopperComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMysteryShopperComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMysteryShopperCommentsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMysteryShopperCommentsViewModel>;
        }));
    }

    protected processGetMysteryShopperComments(response: HttpResponseBase): Observable<GetMysteryShopperCommentsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMysteryShopperCommentsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMysteryShopperCommentsViewModel>(null as any);
    }

    getMysteryShopperNotifications(mysteryShopperId: string, pageNumber: number | undefined, pageSize: number | undefined): Observable<GetMysteryShopperNotificationsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/notifications?";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMysteryShopperNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMysteryShopperNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMysteryShopperNotificationsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMysteryShopperNotificationsViewModel>;
        }));
    }

    protected processGetMysteryShopperNotifications(response: HttpResponseBase): Observable<GetMysteryShopperNotificationsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMysteryShopperNotificationsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMysteryShopperNotificationsViewModel>(null as any);
    }

    disableMysteryShopper(mysteryShopperId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/disable";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDisableMysteryShopper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableMysteryShopper(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDisableMysteryShopper(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    enableMysteryShopper(mysteryShopperId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/enable";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEnableMysteryShopper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableMysteryShopper(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEnableMysteryShopper(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    addCallLog(mysteryShopperId: string, data: CallLogDto): Observable<CreateCallLogViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/call-logs";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddCallLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCallLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCallLogViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCallLogViewModel>;
        }));
    }

    protected processAddCallLog(response: HttpResponseBase): Observable<CreateCallLogViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCallLogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateCallLogViewModel>(null as any);
    }

    getCallLogList(mysteryShopperId: string): Observable<GetCallLogListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/call-logs";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCallLogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCallLogList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCallLogListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCallLogListViewModel>;
        }));
    }

    protected processGetCallLogList(response: HttpResponseBase): Observable<GetCallLogListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCallLogListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCallLogListViewModel>(null as any);
    }

    updateCallLog(mysteryShopperId: string, callLogId: string, data: CallLogDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/call-logs/{callLogId}";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (callLogId === undefined || callLogId === null)
            throw new Error("The parameter 'callLogId' must be defined.");
        url_ = url_.replace("{callLogId}", encodeURIComponent("" + callLogId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCallLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCallLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateCallLog(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    deleteCallLog(mysteryShopperId: string, callLogId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/call-logs/{callLogId}";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (callLogId === undefined || callLogId === null)
            throw new Error("The parameter 'callLogId' must be defined.");
        url_ = url_.replace("{callLogId}", encodeURIComponent("" + callLogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCallLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCallLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCallLog(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getCallLog(mysteryShopperId: string, callLogId: string): Observable<GetCallLogViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/call-logs/{callLogId}";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (callLogId === undefined || callLogId === null)
            throw new Error("The parameter 'callLogId' must be defined.");
        url_ = url_.replace("{callLogId}", encodeURIComponent("" + callLogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCallLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCallLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCallLogViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCallLogViewModel>;
        }));
    }

    protected processGetCallLog(response: HttpResponseBase): Observable<GetCallLogViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCallLogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCallLogViewModel>(null as any);
    }

    getMoveMissionAssignation(mysteryShopperId: string, missionAssignationId: string): Observable<GetMoveMissionResponse> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignationId}/move";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMoveMissionAssignation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMoveMissionAssignation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMoveMissionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMoveMissionResponse>;
        }));
    }

    protected processGetMoveMissionAssignation(response: HttpResponseBase): Observable<GetMoveMissionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoveMissionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMoveMissionResponse>(null as any);
    }

    moveMissionAssignation(mysteryShopperId: string, missionAssignationId: string, data: MoveMissionRequest): Observable<MoveMissionResponse> {
        let url_ = this.baseUrl + "/api/ms/superadmin/mysteryshoppers/{mysteryShopperId}/assignations/{missionAssignationId}/move";
        if (mysteryShopperId === undefined || mysteryShopperId === null)
            throw new Error("The parameter 'mysteryShopperId' must be defined.");
        url_ = url_.replace("{mysteryShopperId}", encodeURIComponent("" + mysteryShopperId));
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMoveMissionAssignation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveMissionAssignation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveMissionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveMissionResponse>;
        }));
    }

    protected processMoveMissionAssignation(response: HttpResponseBase): Observable<MoveMissionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveMissionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoveMissionResponse>(null as any);
    }
}

export interface IPeriodClient {
    getPeriods(subscriptionServiceId: string, projectId: string, pageNumber: number | undefined, pageSize: number | undefined): Observable<GetPeriodListViewModel>;
    createPeriod(subscriptionServiceId: string, projectId: string, period: CreatePeriodDto): Observable<CreatePeriodViewModel>;
    getPeriod(subscriptionServiceId: string, projectId: string, periodId: string): Observable<GetPeriodViewModel>;
    updatePeriod(subscriptionServiceId: string, projectId: string, periodId: string, period: UpdatePeriodRequest): Observable<UpdatePeriodViewModel>;
    deletePeriod(subscriptionServiceId: string, projectId: string, periodId: string): Observable<boolean>;
}

@Injectable()
export class PeriodClient extends ClientBase implements IPeriodClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getPeriods(subscriptionServiceId: string, projectId: string, pageNumber: number | undefined, pageSize: number | undefined): Observable<GetPeriodListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/periods?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPeriodListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPeriodListViewModel>;
        }));
    }

    protected processGetPeriods(response: HttpResponseBase): Observable<GetPeriodListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPeriodListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPeriodListViewModel>(null as any);
    }

    createPeriod(subscriptionServiceId: string, projectId: string, period: CreatePeriodDto): Observable<CreatePeriodViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/periods";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(period);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePeriodViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePeriodViewModel>;
        }));
    }

    protected processCreatePeriod(response: HttpResponseBase): Observable<CreatePeriodViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePeriodViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePeriodViewModel>(null as any);
    }

    getPeriod(subscriptionServiceId: string, projectId: string, periodId: string): Observable<GetPeriodViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/periods/{periodId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined.");
        url_ = url_.replace("{periodId}", encodeURIComponent("" + periodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPeriodViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPeriodViewModel>;
        }));
    }

    protected processGetPeriod(response: HttpResponseBase): Observable<GetPeriodViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPeriodViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPeriodViewModel>(null as any);
    }

    updatePeriod(subscriptionServiceId: string, projectId: string, periodId: string, period: UpdatePeriodRequest): Observable<UpdatePeriodViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/periods/{periodId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined.");
        url_ = url_.replace("{periodId}", encodeURIComponent("" + periodId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(period);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePeriodViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePeriodViewModel>;
        }));
    }

    protected processUpdatePeriod(response: HttpResponseBase): Observable<UpdatePeriodViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePeriodViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePeriodViewModel>(null as any);
    }

    deletePeriod(subscriptionServiceId: string, projectId: string, periodId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/periods/{periodId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (periodId === undefined || periodId === null)
            throw new Error("The parameter 'periodId' must be defined.");
        url_ = url_.replace("{periodId}", encodeURIComponent("" + periodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeletePeriod(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IPeriodXMissionConfigurationClient {
    getBranches(periodMissionConfigId: string): Observable<GetPublishInterestViewModel>;
}

@Injectable()
export class PeriodXMissionConfigurationClient extends ClientBase implements IPeriodXMissionConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getBranches(periodMissionConfigId: string): Observable<GetPublishInterestViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/periodXMissionConfigurations/{periodMissionConfigId}/branches";
        if (periodMissionConfigId === undefined || periodMissionConfigId === null)
            throw new Error("The parameter 'periodMissionConfigId' must be defined.");
        url_ = url_.replace("{periodMissionConfigId}", encodeURIComponent("" + periodMissionConfigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPublishInterestViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPublishInterestViewModel>;
        }));
    }

    protected processGetBranches(response: HttpResponseBase): Observable<GetPublishInterestViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublishInterestViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPublishInterestViewModel>(null as any);
    }
}

export interface IProjectsClient {
    getProjects(organizationId: string | null | undefined, subscriptionId: string | null | undefined, adminTagIds: string[] | null | undefined, sortDirection: SortDirection | undefined, sortField: GetProjectListSortField | undefined, paginationFilter_PageNumber: number | undefined, paginationFilter_PageSize: number | undefined, withActivePeriods: boolean | null | undefined): Observable<GetProjectListViewModel>;
    getProjectFilters(): Observable<GetProjectListFiltersViewModel>;
    getCreateProject(subscriptionServiceId: string): Observable<GetCreateProjectViewModel>;
    createProject(subscriptionServiceId: string, data: CreateProjectDto): Observable<string>;
    getProject(subscriptionServiceId: string, projectId: string): Observable<GetProjectViewModel>;
    updateProject(subscriptionServiceId: string, projectId: string, project: UpdateProjectRequest): Observable<boolean>;
    getDatePickerSequences(subscriptionServiceId: string, projectId: string): Observable<GetDatePickerSequenceListViewModel>;
    updateDatePickerSequences(subscriptionServiceId: string, projectId: string, data: UpdateDatePickerSequenceListRequest): Observable<boolean>;
}

@Injectable()
export class ProjectsClient extends ClientBase implements IProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getProjects(organizationId: string | null | undefined, subscriptionId: string | null | undefined, adminTagIds: string[] | null | undefined, sortDirection: SortDirection | undefined, sortField: GetProjectListSortField | undefined, paginationFilter_PageNumber: number | undefined, paginationFilter_PageSize: number | undefined, withActivePeriods: boolean | null | undefined): Observable<GetProjectListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/projects?";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (subscriptionId !== undefined && subscriptionId !== null)
            url_ += "SubscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (adminTagIds !== undefined && adminTagIds !== null)
            adminTagIds && adminTagIds.forEach(item => { url_ += "AdminTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (paginationFilter_PageNumber === null)
            throw new Error("The parameter 'paginationFilter_PageNumber' cannot be null.");
        else if (paginationFilter_PageNumber !== undefined)
            url_ += "PaginationFilter.PageNumber=" + encodeURIComponent("" + paginationFilter_PageNumber) + "&";
        if (paginationFilter_PageSize === null)
            throw new Error("The parameter 'paginationFilter_PageSize' cannot be null.");
        else if (paginationFilter_PageSize !== undefined)
            url_ += "PaginationFilter.PageSize=" + encodeURIComponent("" + paginationFilter_PageSize) + "&";
        if (withActivePeriods !== undefined && withActivePeriods !== null)
            url_ += "WithActivePeriods=" + encodeURIComponent("" + withActivePeriods) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectListViewModel>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<GetProjectListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectListViewModel>(null as any);
    }

    getProjectFilters(): Observable<GetProjectListFiltersViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/projects/filter-parameters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectListFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectListFiltersViewModel>;
        }));
    }

    protected processGetProjectFilters(response: HttpResponseBase): Observable<GetProjectListFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectListFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectListFiltersViewModel>(null as any);
    }

    getCreateProject(subscriptionServiceId: string): Observable<GetCreateProjectViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/create-parameters";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCreateProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCreateProjectViewModel>;
        }));
    }

    protected processGetCreateProject(response: HttpResponseBase): Observable<GetCreateProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCreateProjectViewModel>(null as any);
    }

    createProject(subscriptionServiceId: string, data: CreateProjectDto): Observable<string> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateProject(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getProject(subscriptionServiceId: string, projectId: string): Observable<GetProjectViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectViewModel>;
        }));
    }

    protected processGetProject(response: HttpResponseBase): Observable<GetProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectViewModel>(null as any);
    }

    updateProject(subscriptionServiceId: string, projectId: string, project: UpdateProjectRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateProject(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getDatePickerSequences(subscriptionServiceId: string, projectId: string): Observable<GetDatePickerSequenceListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/datepicker-sequence";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDatePickerSequences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatePickerSequences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDatePickerSequenceListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDatePickerSequenceListViewModel>;
        }));
    }

    protected processGetDatePickerSequences(response: HttpResponseBase): Observable<GetDatePickerSequenceListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDatePickerSequenceListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDatePickerSequenceListViewModel>(null as any);
    }

    updateDatePickerSequences(subscriptionServiceId: string, projectId: string, data: UpdateDatePickerSequenceListRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/datepicker-sequence";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDatePickerSequences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDatePickerSequences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateDatePickerSequences(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IReportsClient {
    powerPoint(fakeStreamingData: string | undefined, powerPointTemplate: FileParameter | null | undefined, options_PeriodIds: string[] | null | undefined, options_CurrentLabel: string | null | undefined, options_PreviousPeriodIds: string[] | null | undefined, options_PreviousLabel: string | null | undefined, options_DisplayBranchCode: boolean | undefined): Observable<FileResponse>;
    powerPointDebug(fakeStreamingData: string | undefined, options: PowerPointReportQueryRequest): Observable<FileResponse>;
}

@Injectable()
export class ReportsClient extends ClientBase implements IReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    powerPoint(fakeStreamingData: string | undefined, powerPointTemplate: FileParameter | null | undefined, options_PeriodIds: string[] | null | undefined, options_CurrentLabel: string | null | undefined, options_PreviousPeriodIds: string[] | null | undefined, options_PreviousLabel: string | null | undefined, options_DisplayBranchCode: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/Reports?";
        if (fakeStreamingData === null)
            throw new Error("The parameter 'fakeStreamingData' cannot be null.");
        else if (fakeStreamingData !== undefined)
            url_ += "fakeStreamingData=" + encodeURIComponent("" + fakeStreamingData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (powerPointTemplate !== null && powerPointTemplate !== undefined)
            content_.append("PowerPointTemplate", powerPointTemplate.data, powerPointTemplate.fileName ? powerPointTemplate.fileName : "PowerPointTemplate");
        if (options_PeriodIds !== null && options_PeriodIds !== undefined)
            options_PeriodIds.forEach(item_ => content_.append("Options.PeriodIds", item_.toString()));
        if (options_CurrentLabel !== null && options_CurrentLabel !== undefined)
            content_.append("Options.CurrentLabel", options_CurrentLabel.toString());
        if (options_PreviousPeriodIds !== null && options_PreviousPeriodIds !== undefined)
            options_PreviousPeriodIds.forEach(item_ => content_.append("Options.PreviousPeriodIds", item_.toString()));
        if (options_PreviousLabel !== null && options_PreviousLabel !== undefined)
            content_.append("Options.PreviousLabel", options_PreviousLabel.toString());
        if (options_DisplayBranchCode === null || options_DisplayBranchCode === undefined)
            throw new Error("The parameter 'options_DisplayBranchCode' cannot be null.");
        else
            content_.append("Options.DisplayBranchCode", options_DisplayBranchCode.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPowerPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPowerPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPowerPoint(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    powerPointDebug(fakeStreamingData: string | undefined, options: PowerPointReportQueryRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/Reports/debug?";
        if (fakeStreamingData === null)
            throw new Error("The parameter 'fakeStreamingData' cannot be null.");
        else if (fakeStreamingData !== undefined)
            url_ += "fakeStreamingData=" + encodeURIComponent("" + fakeStreamingData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPowerPointDebug(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPowerPointDebug(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPowerPointDebug(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ISectionsClient {
    getSections(subscriptionServiceId: string, projectId: string): Observable<GetSectionListViewModel>;
    createSection(subscriptionServiceId: string, projectId: string, section: CreateSectionDto): Observable<CreateSectionViewModel>;
    getSection(subscriptionServiceId: string, projectId: string, sectionId: string): Observable<GetSectionViewModel>;
    updateSection(subscriptionServiceId: string, projectId: string, sectionId: string, section: UpdateSectionRequest): Observable<boolean>;
    deleteSection(subscriptionServiceId: string, projectId: string, sectionId: string): Observable<boolean>;
}

@Injectable()
export class SectionsClient extends ClientBase implements ISectionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getSections(subscriptionServiceId: string, projectId: string): Observable<GetSectionListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/sections";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSectionListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSectionListViewModel>;
        }));
    }

    protected processGetSections(response: HttpResponseBase): Observable<GetSectionListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSectionListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSectionListViewModel>(null as any);
    }

    createSection(subscriptionServiceId: string, projectId: string, section: CreateSectionDto): Observable<CreateSectionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/sections";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(section);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSectionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSectionViewModel>;
        }));
    }

    protected processCreateSection(response: HttpResponseBase): Observable<CreateSectionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSectionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSectionViewModel>(null as any);
    }

    getSection(subscriptionServiceId: string, projectId: string, sectionId: string): Observable<GetSectionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/sections/{sectionId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSectionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSectionViewModel>;
        }));
    }

    protected processGetSection(response: HttpResponseBase): Observable<GetSectionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSectionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSectionViewModel>(null as any);
    }

    updateSection(subscriptionServiceId: string, projectId: string, sectionId: string, section: UpdateSectionRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/sections/{sectionId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(section);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateSection(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    deleteSection(subscriptionServiceId: string, projectId: string, sectionId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/{subscriptionServiceId}/projects/{projectId}/sections/{sectionId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteSection(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IStatisticsClient {
    getGenreAndAgeStatistic(): Observable<GenreAndAgeProportionViewModel>;
    getGenreByAgeStatistic(): Observable<GenreByAgeViewModel>;
    getEducationStatistic(): Observable<EducationalLevelViewModel>;
    getCarStatistics(): Observable<AccessToCarViewModel>;
    getProvinceOfResidenceStatistics(): Observable<ProvinceOfResidenceViewModel>;
    getContactsLanguages(): Observable<ContactLanguageViewModel>;
    getActiveMembersPerRegion(filter: GetMissionRealizationFilter): Observable<ActiveMembersPerRegionViewModel>;
    getMedian(filter: GetMissionRealizationFilter): Observable<CompletedMissionsPerRegionViewModel>;
    getMembersByStatus(filter: GetMissionRealizationFilter): Observable<MembersByStatusViewModel>;
    getActiveMembersPerYear(): Observable<ActiveMembersPerYearViewModel>;
    getMissionRealization(filter: GetMissionRealizationFilter): Observable<MissionRealizationViewModel>;
    getGetLoginAndCompleteMissionQuery(): Observable<LoginAndCompleteMissionViewModel>;
    getSlackers(): Observable<SubscribersThatDontDoneMissionsViewModel>;
    getCummulativeMembersCount(): Observable<CummulativeMembersCountViewModel>;
    getMedianNumberOfCompleteMissions(): Observable<MedianNumberOfCompleteMissionsViewModel>;
    getMembersByCompleteMissions(): Observable<MembersByNumberOfCompleteMissionsViewModel>;
    getMembersWithCompleteMissions(): Observable<MembersWithCompleteMissionsViewModel>;
}

@Injectable()
export class StatisticsClient extends ClientBase implements IStatisticsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getGenreAndAgeStatistic(): Observable<GenreAndAgeProportionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/gender-and-age";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGenreAndAgeStatistic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenreAndAgeStatistic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenreAndAgeProportionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenreAndAgeProportionViewModel>;
        }));
    }

    protected processGetGenreAndAgeStatistic(response: HttpResponseBase): Observable<GenreAndAgeProportionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenreAndAgeProportionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenreAndAgeProportionViewModel>(null as any);
    }

    getGenreByAgeStatistic(): Observable<GenreByAgeViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/gender-by-age";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGenreByAgeStatistic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenreByAgeStatistic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenreByAgeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenreByAgeViewModel>;
        }));
    }

    protected processGetGenreByAgeStatistic(response: HttpResponseBase): Observable<GenreByAgeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenreByAgeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenreByAgeViewModel>(null as any);
    }

    getEducationStatistic(): Observable<EducationalLevelViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/education";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEducationStatistic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationStatistic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalLevelViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalLevelViewModel>;
        }));
    }

    protected processGetEducationStatistic(response: HttpResponseBase): Observable<EducationalLevelViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalLevelViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EducationalLevelViewModel>(null as any);
    }

    getCarStatistics(): Observable<AccessToCarViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/car-access";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCarStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessToCarViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessToCarViewModel>;
        }));
    }

    protected processGetCarStatistics(response: HttpResponseBase): Observable<AccessToCarViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessToCarViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccessToCarViewModel>(null as any);
    }

    getProvinceOfResidenceStatistics(): Observable<ProvinceOfResidenceViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/province-of-residence";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProvinceOfResidenceStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProvinceOfResidenceStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvinceOfResidenceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvinceOfResidenceViewModel>;
        }));
    }

    protected processGetProvinceOfResidenceStatistics(response: HttpResponseBase): Observable<ProvinceOfResidenceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProvinceOfResidenceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProvinceOfResidenceViewModel>(null as any);
    }

    getContactsLanguages(): Observable<ContactLanguageViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetContactsLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactsLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactLanguageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactLanguageViewModel>;
        }));
    }

    protected processGetContactsLanguages(response: HttpResponseBase): Observable<ContactLanguageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactLanguageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactLanguageViewModel>(null as any);
    }

    getActiveMembersPerRegion(filter: GetMissionRealizationFilter): Observable<ActiveMembersPerRegionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/active-members-per-region";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetActiveMembersPerRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveMembersPerRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveMembersPerRegionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveMembersPerRegionViewModel>;
        }));
    }

    protected processGetActiveMembersPerRegion(response: HttpResponseBase): Observable<ActiveMembersPerRegionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveMembersPerRegionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveMembersPerRegionViewModel>(null as any);
    }

    getMedian(filter: GetMissionRealizationFilter): Observable<CompletedMissionsPerRegionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/median-members-per-region";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMedian(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedian(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompletedMissionsPerRegionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompletedMissionsPerRegionViewModel>;
        }));
    }

    protected processGetMedian(response: HttpResponseBase): Observable<CompletedMissionsPerRegionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompletedMissionsPerRegionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompletedMissionsPerRegionViewModel>(null as any);
    }

    getMembersByStatus(filter: GetMissionRealizationFilter): Observable<MembersByStatusViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/members-by-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMembersByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembersByStatusViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembersByStatusViewModel>;
        }));
    }

    protected processGetMembersByStatus(response: HttpResponseBase): Observable<MembersByStatusViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembersByStatusViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MembersByStatusViewModel>(null as any);
    }

    getActiveMembersPerYear(): Observable<ActiveMembersPerYearViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/active-members-per-year";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetActiveMembersPerYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveMembersPerYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveMembersPerYearViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveMembersPerYearViewModel>;
        }));
    }

    protected processGetActiveMembersPerYear(response: HttpResponseBase): Observable<ActiveMembersPerYearViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveMembersPerYearViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveMembersPerYearViewModel>(null as any);
    }

    getMissionRealization(filter: GetMissionRealizationFilter): Observable<MissionRealizationViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/mission-realization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionRealization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionRealization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MissionRealizationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MissionRealizationViewModel>;
        }));
    }

    protected processGetMissionRealization(response: HttpResponseBase): Observable<MissionRealizationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MissionRealizationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MissionRealizationViewModel>(null as any);
    }

    getGetLoginAndCompleteMissionQuery(): Observable<LoginAndCompleteMissionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/logged-vs-done";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGetLoginAndCompleteMissionQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGetLoginAndCompleteMissionQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginAndCompleteMissionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginAndCompleteMissionViewModel>;
        }));
    }

    protected processGetGetLoginAndCompleteMissionQuery(response: HttpResponseBase): Observable<LoginAndCompleteMissionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginAndCompleteMissionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginAndCompleteMissionViewModel>(null as any);
    }

    getSlackers(): Observable<SubscribersThatDontDoneMissionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/subscribed-not-done";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSlackers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlackers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribersThatDontDoneMissionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribersThatDontDoneMissionsViewModel>;
        }));
    }

    protected processGetSlackers(response: HttpResponseBase): Observable<SubscribersThatDontDoneMissionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscribersThatDontDoneMissionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribersThatDontDoneMissionsViewModel>(null as any);
    }

    getCummulativeMembersCount(): Observable<CummulativeMembersCountViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/cumulative-subscribers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCummulativeMembersCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCummulativeMembersCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CummulativeMembersCountViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CummulativeMembersCountViewModel>;
        }));
    }

    protected processGetCummulativeMembersCount(response: HttpResponseBase): Observable<CummulativeMembersCountViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CummulativeMembersCountViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CummulativeMembersCountViewModel>(null as any);
    }

    getMedianNumberOfCompleteMissions(): Observable<MedianNumberOfCompleteMissionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/median-complete-missions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMedianNumberOfCompleteMissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedianNumberOfCompleteMissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedianNumberOfCompleteMissionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedianNumberOfCompleteMissionsViewModel>;
        }));
    }

    protected processGetMedianNumberOfCompleteMissions(response: HttpResponseBase): Observable<MedianNumberOfCompleteMissionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedianNumberOfCompleteMissionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MedianNumberOfCompleteMissionsViewModel>(null as any);
    }

    getMembersByCompleteMissions(): Observable<MembersByNumberOfCompleteMissionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/members-by-complete-missions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMembersByCompleteMissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersByCompleteMissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembersByNumberOfCompleteMissionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembersByNumberOfCompleteMissionsViewModel>;
        }));
    }

    protected processGetMembersByCompleteMissions(response: HttpResponseBase): Observable<MembersByNumberOfCompleteMissionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembersByNumberOfCompleteMissionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MembersByNumberOfCompleteMissionsViewModel>(null as any);
    }

    getMembersWithCompleteMissions(): Observable<MembersWithCompleteMissionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superadmin/statistics/members-with-missions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMembersWithCompleteMissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersWithCompleteMissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MembersWithCompleteMissionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MembersWithCompleteMissionsViewModel>;
        }));
    }

    protected processGetMembersWithCompleteMissions(response: HttpResponseBase): Observable<MembersWithCompleteMissionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembersWithCompleteMissionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MembersWithCompleteMissionsViewModel>(null as any);
    }
}

export interface ITagsClient {
    getTags(search: string | null | undefined, tagOrderType: TagOrderType | null | undefined): Observable<GetTagsViewModel>;
    createTag(tagDto: TagDto): Observable<string>;
    getCreateTag(): Observable<GetCreateTagViewModel>;
    getTag(tagId: string): Observable<GetTagViewModel>;
    updateTag(tagId: string, tagDto: TagDto): Observable<boolean>;
    deleteTag(tagId: string): Observable<boolean>;
    getTags2(): Observable<GetTagsViewModel2>;
}

@Injectable()
export class TagsClient extends ClientBase implements ITagsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getTags(search: string | null | undefined, tagOrderType: TagOrderType | null | undefined): Observable<GetTagsViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/tags?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tagOrderType !== undefined && tagOrderType !== null)
            url_ += "tagOrderType=" + encodeURIComponent("" + tagOrderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTagsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTagsViewModel>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<GetTagsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTagsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTagsViewModel>(null as any);
    }

    createTag(tagDto: TagDto): Observable<string> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateTag(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getCreateTag(): Observable<GetCreateTagViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/tags/create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreateTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCreateTagViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCreateTagViewModel>;
        }));
    }

    protected processGetCreateTag(response: HttpResponseBase): Observable<GetCreateTagViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateTagViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCreateTagViewModel>(null as any);
    }

    getTag(tagId: string): Observable<GetTagViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/tags/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTagViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTagViewModel>;
        }));
    }

    protected processGetTag(response: HttpResponseBase): Observable<GetTagViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTagViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTagViewModel>(null as any);
    }

    updateTag(tagId: string, tagDto: TagDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/tags/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTag(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    deleteTag(tagId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/tags/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteTag(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getTags2(): Observable<GetTagsViewModel2> {
        let url_ = this.baseUrl + "/api/ms/client/Tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTags2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTagsViewModel2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTagsViewModel2>;
        }));
    }

    protected processGetTags2(response: HttpResponseBase): Observable<GetTagsViewModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTagsViewModel2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTagsViewModel2>(null as any);
    }
}

export interface ITaxonomiesClient {
    getTaxonomies(): Observable<TaxonomyViewModel>;
}

@Injectable()
export class TaxonomiesClient extends ClientBase implements ITaxonomiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getTaxonomies(): Observable<TaxonomyViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/mandates/taxonomies/taxonomies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaxonomies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxonomies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxonomyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxonomyViewModel>;
        }));
    }

    protected processGetTaxonomies(response: HttpResponseBase): Observable<TaxonomyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxonomyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaxonomyViewModel>(null as any);
    }
}

export interface ITestClient {
    importGroupeMaurice(options: ManageCompetitorDataRequest): Observable<boolean>;
}

@Injectable()
export class TestClient extends ClientBase implements ITestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    importGroupeMaurice(options: ManageCompetitorDataRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/test/groupe-maurice-import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processImportGroupeMaurice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportGroupeMaurice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processImportGroupeMaurice(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface ITransactionClient {
    getFilters(): Observable<GetTransactionListFiltersViewModel>;
    getSummary(filter: GetTransactionListFilter): Observable<GetTransactionListSummaryViewModel>;
    getList(pageNumber: number | undefined, pageSize: number | undefined, filter: GetTransactionListFilter): Observable<GetTransactionListViewModel>;
    cancelTransaction(transactionId: string): Observable<CancelTransactionViewModel>;
    refreshTransaction(transactionId: string): Observable<RefreshTransactionViewModel>;
    confirmTransaction(transactionId: string): Observable<ConfirmTransactionViewModel>;
    exportList(exportType: ExportTableType | undefined, filter: GetTransactionListFilter): Observable<FileResponse>;
}

@Injectable()
export class TransactionClient extends ClientBase implements ITransactionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getFilters(): Observable<GetTransactionListFiltersViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/transactions/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTransactionListFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTransactionListFiltersViewModel>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<GetTransactionListFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionListFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionListFiltersViewModel>(null as any);
    }

    getSummary(filter: GetTransactionListFilter): Observable<GetTransactionListSummaryViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/transactions/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTransactionListSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTransactionListSummaryViewModel>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<GetTransactionListSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionListSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionListSummaryViewModel>(null as any);
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, filter: GetTransactionListFilter): Observable<GetTransactionListViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/transactions?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTransactionListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTransactionListViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetTransactionListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionListViewModel>(null as any);
    }

    cancelTransaction(transactionId: string): Observable<CancelTransactionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/transactions/{transactionId}/cancel";
        if (transactionId === undefined || transactionId === null)
            throw new Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelTransactionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelTransactionViewModel>;
        }));
    }

    protected processCancelTransaction(response: HttpResponseBase): Observable<CancelTransactionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelTransactionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CancelTransactionViewModel>(null as any);
    }

    refreshTransaction(transactionId: string): Observable<RefreshTransactionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/transactions/{transactionId}/refresh";
        if (transactionId === undefined || transactionId === null)
            throw new Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRefreshTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTransactionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTransactionViewModel>;
        }));
    }

    protected processRefreshTransaction(response: HttpResponseBase): Observable<RefreshTransactionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTransactionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefreshTransactionViewModel>(null as any);
    }

    confirmTransaction(transactionId: string): Observable<ConfirmTransactionViewModel> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/transactions/{transactionId}/confirm";
        if (transactionId === undefined || transactionId === null)
            throw new Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfirmTransactionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfirmTransactionViewModel>;
        }));
    }

    protected processConfirmTransaction(response: HttpResponseBase): Observable<ConfirmTransactionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmTransactionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfirmTransactionViewModel>(null as any);
    }

    exportList(exportType: ExportTableType | undefined, filter: GetTransactionListFilter): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/superAdmin/transactions/export?";
        if (exportType === null)
            throw new Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExportList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportList(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IValidationsClient {
    createOrUpdateValidations(projectId: string, validations: CreateOrUpdateValidationCommandViewModel): Observable<string[]>;
    deleteValidation(projectId: string, validationId: string | undefined): Observable<boolean>;
}

@Injectable()
export class ValidationsClient extends ClientBase implements IValidationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    createOrUpdateValidations(projectId: string, validations: CreateOrUpdateValidationCommandViewModel): Observable<string[]> {
        let url_ = this.baseUrl + "/api/ms/superadmin/projects/{projectId}/validations";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(validations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateValidations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateValidations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processCreateOrUpdateValidations(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    deleteValidation(projectId: string, validationId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/superadmin/projects/{projectId}/validations?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (validationId === null)
            throw new Error("The parameter 'validationId' cannot be null.");
        else if (validationId !== undefined)
            url_ += "validationId=" + encodeURIComponent("" + validationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteValidation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IMigrationClient {
    getMigrationViewModel(): Observable<MigrationViewModel>;
    getMigrationCandidatesViewModel(corporateClientId: number): Observable<MigrationCandidatesViewModel>;
    getProjectMap(projectId: string, mandateIds: number[] | undefined): Observable<ProjectMapViewModel>;
    migrateMissions(projectId: string, dto: MigrateMissionsDto): Observable<string>;
    syncUserEmails(allNow: boolean | undefined): Observable<string>;
    importMandate(organizationId: string | null | undefined, subscriptionId: string | null | undefined, subscriptionServiceId: string | null | undefined, options: MigrationOptions): Observable<string>;
    importTaskStatus(taskId: string): Observable<TaskStatus>;
}

@Injectable()
export class MigrationClient extends ClientBase implements IMigrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getMigrationViewModel(): Observable<MigrationViewModel> {
        let url_ = this.baseUrl + "/api/ms/migration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMigrationViewModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMigrationViewModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MigrationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MigrationViewModel>;
        }));
    }

    protected processGetMigrationViewModel(response: HttpResponseBase): Observable<MigrationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MigrationViewModel>(null as any);
    }

    getMigrationCandidatesViewModel(corporateClientId: number): Observable<MigrationCandidatesViewModel> {
        let url_ = this.baseUrl + "/api/ms/migration/{corporateClientId}";
        if (corporateClientId === undefined || corporateClientId === null)
            throw new Error("The parameter 'corporateClientId' must be defined.");
        url_ = url_.replace("{corporateClientId}", encodeURIComponent("" + corporateClientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMigrationCandidatesViewModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMigrationCandidatesViewModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MigrationCandidatesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MigrationCandidatesViewModel>;
        }));
    }

    protected processGetMigrationCandidatesViewModel(response: HttpResponseBase): Observable<MigrationCandidatesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationCandidatesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MigrationCandidatesViewModel>(null as any);
    }

    getProjectMap(projectId: string, mandateIds: number[] | undefined): Observable<ProjectMapViewModel> {
        let url_ = this.baseUrl + "/api/ms/migration/project/{projectId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (mandateIds === null)
            throw new Error("The parameter 'mandateIds' cannot be null.");
        else if (mandateIds !== undefined)
            mandateIds && mandateIds.forEach(item => { url_ += "mandateIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectMapViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectMapViewModel>;
        }));
    }

    protected processGetProjectMap(response: HttpResponseBase): Observable<ProjectMapViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectMapViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectMapViewModel>(null as any);
    }

    migrateMissions(projectId: string, dto: MigrateMissionsDto): Observable<string> {
        let url_ = this.baseUrl + "/api/ms/migration/project/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMigrateMissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateMissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMigrateMissions(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    syncUserEmails(allNow: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/ms/migration/sync-user-emails?";
        if (allNow === null)
            throw new Error("The parameter 'allNow' cannot be null.");
        else if (allNow !== undefined)
            url_ += "allNow=" + encodeURIComponent("" + allNow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSyncUserEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncUserEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSyncUserEmails(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    importMandate(organizationId: string | null | undefined, subscriptionId: string | null | undefined, subscriptionServiceId: string | null | undefined, options: MigrationOptions): Observable<string> {
        let url_ = this.baseUrl + "/api/ms/migration/import?";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (subscriptionId !== undefined && subscriptionId !== null)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (subscriptionServiceId !== undefined && subscriptionServiceId !== null)
            url_ += "subscriptionServiceId=" + encodeURIComponent("" + subscriptionServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processImportMandate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMandate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processImportMandate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    importTaskStatus(taskId: string): Observable<TaskStatus> {
        let url_ = this.baseUrl + "/api/ms/migration/import/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processImportTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportTaskStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskStatus>;
        }));
    }

    protected processImportTaskStatus(response: HttpResponseBase): Observable<TaskStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskStatus>(null as any);
    }
}

export interface IAuthenticateClient {
    getMysteryShopperExists(): Observable<MysteryShopperExistsViewModel>;
    registration(registration: RegistrationDto): Observable<void>;
    login(): Observable<void>;
    externalLogin(data: ExternalLoginRequest): Observable<boolean>;
    externalExists(data: ExternalExistsRequest): Observable<boolean>;
}

@Injectable()
export class AuthenticateClient extends ClientBase implements IAuthenticateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getMysteryShopperExists(): Observable<MysteryShopperExistsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Authenticate/exists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMysteryShopperExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMysteryShopperExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MysteryShopperExistsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MysteryShopperExistsViewModel>;
        }));
    }

    protected processGetMysteryShopperExists(response: HttpResponseBase): Observable<MysteryShopperExistsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MysteryShopperExistsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MysteryShopperExistsViewModel>(null as any);
    }

    registration(registration: RegistrationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/Authenticate/registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    login(): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/Authenticate/login";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    externalLogin(data: ExternalLoginRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/Authenticate/external-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExternalLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExternalLogin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    externalExists(data: ExternalExistsRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/Authenticate/external-exists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExternalExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExternalExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IMissionsClient {
    getMissionSurveyTemp(periodMissionConfigurationId: string): Observable<GetSurveyFromTempViewModel>;
    getMissionDetails(branchId: string | undefined, location: string | null | undefined, onlyAcceptableMissions: boolean | undefined): Observable<GetMissionDetailsViewModel>;
    getRemoteMissions(tagIds: string[] | null | undefined): Observable<GetRemoteMissionsViewModel>;
    getMissionsFromMap(tagIds: string[] | null | undefined, location: string, bottomRightLocation: string | undefined, topLeftLocation: string | undefined, onlyAcceptableMissions: boolean | undefined): Observable<GetMissionsViewModel>;
    getMissionsFromMapv2(tagIds: string[] | null | undefined, location: string, bottomRightLocation: string | undefined, topLeftLocation: string | undefined, onlyAcceptableMissions: boolean | undefined, showUpcomingMissions: boolean | undefined): Observable<GetMissionsViewModel>;
    getAcceptMissionsFromMap(brandIds: string[]): Observable<GetAcceptMissionsFromMapViewModel>;
    getAcceptMission(periodMissionConfigurationId: string | undefined, branchId: string | undefined): Observable<GetAcceptMissionViewModel>;
    acceptMission(periodMissionConfigurationId: string | undefined, branchId: string | undefined): Observable<AcceptMissionViewModel>;
    getAcceptMissions(branchId: string | undefined): Observable<GetAcceptMissionByBranchViewModel>;
}

@Injectable()
export class MissionsClient extends ClientBase implements IMissionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getMissionSurveyTemp(periodMissionConfigurationId: string): Observable<GetSurveyFromTempViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/{periodMissionConfigurationId}/surveyTemp";
        if (periodMissionConfigurationId === undefined || periodMissionConfigurationId === null)
            throw new Error("The parameter 'periodMissionConfigurationId' must be defined.");
        url_ = url_.replace("{periodMissionConfigurationId}", encodeURIComponent("" + periodMissionConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionSurveyTemp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionSurveyTemp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyFromTempViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyFromTempViewModel>;
        }));
    }

    protected processGetMissionSurveyTemp(response: HttpResponseBase): Observable<GetSurveyFromTempViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyFromTempViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyFromTempViewModel>(null as any);
    }

    getMissionDetails(branchId: string | undefined, location: string | null | undefined, onlyAcceptableMissions: boolean | undefined): Observable<GetMissionDetailsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/details?";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        if (location !== undefined && location !== null)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (onlyAcceptableMissions === null)
            throw new Error("The parameter 'onlyAcceptableMissions' cannot be null.");
        else if (onlyAcceptableMissions !== undefined)
            url_ += "onlyAcceptableMissions=" + encodeURIComponent("" + onlyAcceptableMissions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionDetailsViewModel>;
        }));
    }

    protected processGetMissionDetails(response: HttpResponseBase): Observable<GetMissionDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionDetailsViewModel>(null as any);
    }

    getRemoteMissions(tagIds: string[] | null | undefined): Observable<GetRemoteMissionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/remote?";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRemoteMissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemoteMissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRemoteMissionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRemoteMissionsViewModel>;
        }));
    }

    protected processGetRemoteMissions(response: HttpResponseBase): Observable<GetRemoteMissionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRemoteMissionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRemoteMissionsViewModel>(null as any);
    }

    getMissionsFromMap(tagIds: string[] | null | undefined, location: string, bottomRightLocation: string | undefined, topLeftLocation: string | undefined, onlyAcceptableMissions: boolean | undefined): Observable<GetMissionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/map/{location}?";
        if (location === undefined || location === null)
            throw new Error("The parameter 'location' must be defined.");
        url_ = url_.replace("{location}", encodeURIComponent("" + location));
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        if (bottomRightLocation === null)
            throw new Error("The parameter 'bottomRightLocation' cannot be null.");
        else if (bottomRightLocation !== undefined)
            url_ += "bottomRightLocation=" + encodeURIComponent("" + bottomRightLocation) + "&";
        if (topLeftLocation === null)
            throw new Error("The parameter 'topLeftLocation' cannot be null.");
        else if (topLeftLocation !== undefined)
            url_ += "topLeftLocation=" + encodeURIComponent("" + topLeftLocation) + "&";
        if (onlyAcceptableMissions === null)
            throw new Error("The parameter 'onlyAcceptableMissions' cannot be null.");
        else if (onlyAcceptableMissions !== undefined)
            url_ += "onlyAcceptableMissions=" + encodeURIComponent("" + onlyAcceptableMissions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionsFromMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionsFromMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionsViewModel>;
        }));
    }

    protected processGetMissionsFromMap(response: HttpResponseBase): Observable<GetMissionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionsViewModel>(null as any);
    }

    getMissionsFromMapv2(tagIds: string[] | null | undefined, location: string, bottomRightLocation: string | undefined, topLeftLocation: string | undefined, onlyAcceptableMissions: boolean | undefined, showUpcomingMissions: boolean | undefined): Observable<GetMissionsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/map/{location}/v2?";
        if (location === undefined || location === null)
            throw new Error("The parameter 'location' must be defined.");
        url_ = url_.replace("{location}", encodeURIComponent("" + location));
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        if (bottomRightLocation === null)
            throw new Error("The parameter 'bottomRightLocation' cannot be null.");
        else if (bottomRightLocation !== undefined)
            url_ += "bottomRightLocation=" + encodeURIComponent("" + bottomRightLocation) + "&";
        if (topLeftLocation === null)
            throw new Error("The parameter 'topLeftLocation' cannot be null.");
        else if (topLeftLocation !== undefined)
            url_ += "topLeftLocation=" + encodeURIComponent("" + topLeftLocation) + "&";
        if (onlyAcceptableMissions === null)
            throw new Error("The parameter 'onlyAcceptableMissions' cannot be null.");
        else if (onlyAcceptableMissions !== undefined)
            url_ += "onlyAcceptableMissions=" + encodeURIComponent("" + onlyAcceptableMissions) + "&";
        if (showUpcomingMissions === null)
            throw new Error("The parameter 'showUpcomingMissions' cannot be null.");
        else if (showUpcomingMissions !== undefined)
            url_ += "showUpcomingMissions=" + encodeURIComponent("" + showUpcomingMissions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionsFromMapv2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionsFromMapv2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMissionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMissionsViewModel>;
        }));
    }

    protected processGetMissionsFromMapv2(response: HttpResponseBase): Observable<GetMissionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMissionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionsViewModel>(null as any);
    }

    getAcceptMissionsFromMap(brandIds: string[]): Observable<GetAcceptMissionsFromMapViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/map/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(brandIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAcceptMissionsFromMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcceptMissionsFromMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAcceptMissionsFromMapViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAcceptMissionsFromMapViewModel>;
        }));
    }

    protected processGetAcceptMissionsFromMap(response: HttpResponseBase): Observable<GetAcceptMissionsFromMapViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAcceptMissionsFromMapViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAcceptMissionsFromMapViewModel>(null as any);
    }

    getAcceptMission(periodMissionConfigurationId: string | undefined, branchId: string | undefined): Observable<GetAcceptMissionViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/accept?";
        if (periodMissionConfigurationId === null)
            throw new Error("The parameter 'periodMissionConfigurationId' cannot be null.");
        else if (periodMissionConfigurationId !== undefined)
            url_ += "periodMissionConfigurationId=" + encodeURIComponent("" + periodMissionConfigurationId) + "&";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAcceptMission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcceptMission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAcceptMissionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAcceptMissionViewModel>;
        }));
    }

    protected processGetAcceptMission(response: HttpResponseBase): Observable<GetAcceptMissionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAcceptMissionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAcceptMissionViewModel>(null as any);
    }

    acceptMission(periodMissionConfigurationId: string | undefined, branchId: string | undefined): Observable<AcceptMissionViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/accept?";
        if (periodMissionConfigurationId === null)
            throw new Error("The parameter 'periodMissionConfigurationId' cannot be null.");
        else if (periodMissionConfigurationId !== undefined)
            url_ += "periodMissionConfigurationId=" + encodeURIComponent("" + periodMissionConfigurationId) + "&";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAcceptMission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptMission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcceptMissionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcceptMissionViewModel>;
        }));
    }

    protected processAcceptMission(response: HttpResponseBase): Observable<AcceptMissionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcceptMissionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AcceptMissionViewModel>(null as any);
    }

    getAcceptMissions(branchId: string | undefined): Observable<GetAcceptMissionByBranchViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Missions/accept-by-branch?";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAcceptMissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcceptMissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAcceptMissionByBranchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAcceptMissionByBranchViewModel>;
        }));
    }

    protected processGetAcceptMissions(response: HttpResponseBase): Observable<GetAcceptMissionByBranchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAcceptMissionByBranchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAcceptMissionByBranchViewModel>(null as any);
    }
}

export interface IMyMissionClient {
    saveAndComplete(missionAssignationId: string, timeZoneOffset: number | null | undefined, data: SaveMissionAnswerDto[]): Observable<void>;
    save(missionAssignationId: string, timeZoneOffset: number | null | undefined, data: PartialSaveMissionAnswerRequest[]): Observable<boolean>;
    getMissionSurvey(missionAssignationId: string): Observable<GetSurveyFromMissionAssignationViewModel>;
    cancelMyMission(missionAssignationId: string): Observable<void>;
    submitForCorrection(missionAssignationId: string): Observable<void>;
    extendMyMission(missionAssignationId: string, requestDay: number | undefined): Observable<Date>;
    getMyMissionExtendibleDays(missionAssignationId: string): Observable<GetMyMissionExtendibleDaysViewModel>;
    getMissionsList(): Observable<GetMyMissionListViewModel>;
    getMissionDetails(missionAssignationId: string): Observable<GetMyMissionDetailsViewModel>;
    getPreValidation(missionAssignationId: string): Observable<GetPreValidationViewModel>;
    getFailedValidationNotification(): Observable<GetFailedValidationNotificationViewModel>;
}

@Injectable()
export class MyMissionClient extends ClientBase implements IMyMissionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    saveAndComplete(missionAssignationId: string, timeZoneOffset: number | null | undefined, data: SaveMissionAnswerDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}?";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        if (timeZoneOffset !== undefined && timeZoneOffset !== null)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveAndComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAndComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAndComplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    save(missionAssignationId: string, timeZoneOffset: number | null | undefined, data: PartialSaveMissionAnswerRequest[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}?";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        if (timeZoneOffset !== undefined && timeZoneOffset !== null)
            url_ += "timeZoneOffset=" + encodeURIComponent("" + timeZoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getMissionSurvey(missionAssignationId: string): Observable<GetSurveyFromMissionAssignationViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/survey";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyFromMissionAssignationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyFromMissionAssignationViewModel>;
        }));
    }

    protected processGetMissionSurvey(response: HttpResponseBase): Observable<GetSurveyFromMissionAssignationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyFromMissionAssignationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyFromMissionAssignationViewModel>(null as any);
    }

    cancelMyMission(missionAssignationId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/cancel";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelMyMission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelMyMission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelMyMission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    submitForCorrection(missionAssignationId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/submit";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitForCorrection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitForCorrection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitForCorrection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    extendMyMission(missionAssignationId: string, requestDay: number | undefined): Observable<Date> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/extend?";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        if (requestDay === null)
            throw new Error("The parameter 'requestDay' cannot be null.");
        else if (requestDay !== undefined)
            url_ += "requestDay=" + encodeURIComponent("" + requestDay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExtendMyMission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendMyMission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date>;
        }));
    }

    protected processExtendMyMission(response: HttpResponseBase): Observable<Date> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Date>(null as any);
    }

    getMyMissionExtendibleDays(missionAssignationId: string): Observable<GetMyMissionExtendibleDaysViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/{missionAssignationId}/extendible-days";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMyMissionExtendibleDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyMissionExtendibleDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMyMissionExtendibleDaysViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMyMissionExtendibleDaysViewModel>;
        }));
    }

    protected processGetMyMissionExtendibleDays(response: HttpResponseBase): Observable<GetMyMissionExtendibleDaysViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyMissionExtendibleDaysViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyMissionExtendibleDaysViewModel>(null as any);
    }

    getMissionsList(): Observable<GetMyMissionListViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/missions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMyMissionListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMyMissionListViewModel>;
        }));
    }

    protected processGetMissionsList(response: HttpResponseBase): Observable<GetMyMissionListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyMissionListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyMissionListViewModel>(null as any);
    }

    getMissionDetails(missionAssignationId: string): Observable<GetMyMissionDetailsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/missions/{missionAssignationId}/details";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMyMissionDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMyMissionDetailsViewModel>;
        }));
    }

    protected processGetMissionDetails(response: HttpResponseBase): Observable<GetMyMissionDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyMissionDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyMissionDetailsViewModel>(null as any);
    }

    getPreValidation(missionAssignationId: string): Observable<GetPreValidationViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/missions/{missionAssignationId}/pre-validation";
        if (missionAssignationId === undefined || missionAssignationId === null)
            throw new Error("The parameter 'missionAssignationId' must be defined.");
        url_ = url_.replace("{missionAssignationId}", encodeURIComponent("" + missionAssignationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPreValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPreValidationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPreValidationViewModel>;
        }));
    }

    protected processGetPreValidation(response: HttpResponseBase): Observable<GetPreValidationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPreValidationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPreValidationViewModel>(null as any);
    }

    getFailedValidationNotification(): Observable<GetFailedValidationNotificationViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyMission/missions/failed-validation-notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFailedValidationNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFailedValidationNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFailedValidationNotificationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFailedValidationNotificationViewModel>;
        }));
    }

    protected processGetFailedValidationNotification(response: HttpResponseBase): Observable<GetFailedValidationNotificationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFailedValidationNotificationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFailedValidationNotificationViewModel>(null as any);
    }
}

export interface IMyRewardsClient {
    getMyRewards(): Observable<GetMyRewardsViewModel>;
}

@Injectable()
export class MyRewardsClient extends ClientBase implements IMyRewardsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getMyRewards(): Observable<GetMyRewardsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MyRewards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMyRewards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRewards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMyRewardsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMyRewardsViewModel>;
        }));
    }

    protected processGetMyRewards(response: HttpResponseBase): Observable<GetMyRewardsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyRewardsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyRewardsViewModel>(null as any);
    }
}

export interface IMysteryShopperClient {
    getProfile(): Observable<GetMysteryShopperProfileViewModel>;
    verifyAccount(): Observable<void>;
    saveProfile(model: SaveProfileValueDto): Observable<void>;
    saveBasicInformation(model: SaveBasicInformationDto): Observable<void>;
    addAddress(model: MysteryShopperAddressDto2): Observable<void>;
    updateAddress(addressId: string, model: MysteryShopperAddressDto2): Observable<void>;
    deleteAddress(addressId: string): Observable<void>;
    updateCurrentAddress(model: MysteryShopperAddressDto2): Observable<void>;
    registerDevice(device: RegisterDeviceDto): Observable<void>;
    getAlertBanner(): Observable<GetAlertBannerViewModel>;
    getAdvertisementTracking(): Observable<GetAdvertisementTrackingListViewModel>;
    resetAdvertisementTracking(): Observable<void>;
    getAdvertisementTrackingByCode(code: string): Observable<GetAdvertisementTrackingByCodeViewModel>;
    updateAdvertisementTracking(code: string, data: UpdateAdvertisementTrackingByCodeDto): Observable<void>;
    resetAdvertisementTrackingByCode(code: string): Observable<void>;
    getNotificationSettings(): Observable<GetNotificationSettingsViewModel>;
    saveNotificationSettings(data: SaveNotificationSettingsRequest): Observable<void>;
    deleteMysteryShopper(): Observable<boolean>;
    unsubscribeMysteryShopper(mysteryShopperEmail: string | undefined): Observable<FileResponse>;
    verifyPhoneNumber(phoneNumber: string | undefined): Observable<boolean>;
}

@Injectable()
export class MysteryShopperClient extends ClientBase implements IMysteryShopperClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getProfile(): Observable<GetMysteryShopperProfileViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMysteryShopperProfileViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMysteryShopperProfileViewModel>;
        }));
    }

    protected processGetProfile(response: HttpResponseBase): Observable<GetMysteryShopperProfileViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMysteryShopperProfileViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMysteryShopperProfileViewModel>(null as any);
    }

    verifyAccount(): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/verify";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifyAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    saveProfile(model: SaveProfileValueDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    saveBasicInformation(model: SaveBasicInformationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/basicInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveBasicInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBasicInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveBasicInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    addAddress(model: MysteryShopperAddressDto2): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    updateAddress(addressId: string, model: MysteryShopperAddressDto2): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/addresses/{addressId}";
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteAddress(addressId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/addresses/{addressId}";
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    updateCurrentAddress(model: MysteryShopperAddressDto2): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/profile/addresses/current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCurrentAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    registerDevice(device: RegisterDeviceDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRegisterDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegisterDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAlertBanner(): Observable<GetAlertBannerViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/alert";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAlertBanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlertBanner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAlertBannerViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAlertBannerViewModel>;
        }));
    }

    protected processGetAlertBanner(response: HttpResponseBase): Observable<GetAlertBannerViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAlertBannerViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAlertBannerViewModel>(null as any);
    }

    getAdvertisementTracking(): Observable<GetAdvertisementTrackingListViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/advertisement-tracking";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdvertisementTracking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertisementTracking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdvertisementTrackingListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdvertisementTrackingListViewModel>;
        }));
    }

    protected processGetAdvertisementTracking(response: HttpResponseBase): Observable<GetAdvertisementTrackingListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdvertisementTrackingListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvertisementTrackingListViewModel>(null as any);
    }

    resetAdvertisementTracking(): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/advertisement-tracking";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResetAdvertisementTracking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetAdvertisementTracking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetAdvertisementTracking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAdvertisementTrackingByCode(code: string): Observable<GetAdvertisementTrackingByCodeViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/advertisement-tracking/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdvertisementTrackingByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvertisementTrackingByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdvertisementTrackingByCodeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdvertisementTrackingByCodeViewModel>;
        }));
    }

    protected processGetAdvertisementTrackingByCode(response: HttpResponseBase): Observable<GetAdvertisementTrackingByCodeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdvertisementTrackingByCodeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdvertisementTrackingByCodeViewModel>(null as any);
    }

    updateAdvertisementTracking(code: string, data: UpdateAdvertisementTrackingByCodeDto): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/advertisement-tracking/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAdvertisementTracking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAdvertisementTracking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAdvertisementTracking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    resetAdvertisementTrackingByCode(code: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/advertisement-tracking/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResetAdvertisementTrackingByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetAdvertisementTrackingByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetAdvertisementTrackingByCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getNotificationSettings(): Observable<GetNotificationSettingsViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/notification-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationSettingsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationSettingsViewModel>;
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationSettingsViewModel>(null as any);
    }

    saveNotificationSettings(data: SaveNotificationSettingsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/notification-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteMysteryShopper(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteMysteryShopper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMysteryShopper(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteMysteryShopper(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    unsubscribeMysteryShopper(mysteryShopperEmail: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/unsubscribe?";
        if (mysteryShopperEmail === null)
            throw new Error("The parameter 'mysteryShopperEmail' cannot be null.");
        else if (mysteryShopperEmail !== undefined)
            url_ += "mysteryShopperEmail=" + encodeURIComponent("" + mysteryShopperEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUnsubscribeMysteryShopper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribeMysteryShopper(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUnsubscribeMysteryShopper(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    verifyPhoneNumber(phoneNumber: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/client/MysteryShopper/verify/phonenumber?";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyPhoneNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface ISimulateErrorsClient {
    get401(): Observable<number>;
    get403(): Observable<number>;
    get404(): Observable<number>;
    get409(): Observable<number>;
    get4012(): Observable<number>;
    get4032(): Observable<number>;
    get4042(): Observable<number>;
    get4092(): Observable<number>;
}

@Injectable()
export class SimulateErrorsClient extends ClientBase implements ISimulateErrorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get401(): Observable<number> {
        let url_ = this.baseUrl + "/api/ms/client/simulate-errors/401";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet401(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet401(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGet401(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    get403(): Observable<number> {
        let url_ = this.baseUrl + "/api/ms/client/simulate-errors/403";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet403(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet403(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGet403(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    get404(): Observable<number> {
        let url_ = this.baseUrl + "/api/ms/client/simulate-errors/404";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet404(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet404(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGet404(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    get409(): Observable<number> {
        let url_ = this.baseUrl + "/api/ms/client/simulate-errors/409";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet409(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet409(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGet409(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    get4012(): Observable<number> {
        let url_ = this.baseUrl + "/api/portal/simulate-errors/401";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet4012(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet4012(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGet4012(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    get4032(): Observable<number> {
        let url_ = this.baseUrl + "/api/portal/simulate-errors/403";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet4032(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet4032(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGet4032(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    get4042(): Observable<number> {
        let url_ = this.baseUrl + "/api/portal/simulate-errors/404";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet4042(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet4042(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGet4042(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    get4092(): Observable<number> {
        let url_ = this.baseUrl + "/api/portal/simulate-errors/409";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet4092(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet4092(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGet4092(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

export interface ITransactionsClient {
    getTransactions(continuationToken: string | null | undefined, pageSize: number | undefined, filters: GetTransactionListFilter2 | undefined): Observable<GetTransactionListViewModel2>;
    canProceedToCashOut(): Observable<CanProceedToCashOutViewModel>;
    proceedToCashOut(): Observable<ProceedToCashOutViewModel>;
    cancelCashOut(cashoutTransactionId: string): Observable<CancelCashOutViewModel>;
}

@Injectable()
export class TransactionsClient extends ClientBase implements ITransactionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getTransactions(continuationToken: string | null | undefined, pageSize: number | undefined, filters: GetTransactionListFilter2 | undefined): Observable<GetTransactionListViewModel2> {
        let url_ = this.baseUrl + "/api/ms/client/Transactions?";
        if (continuationToken !== undefined && continuationToken !== null)
            url_ += "ContinuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTransactionListViewModel2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTransactionListViewModel2>;
        }));
    }

    protected processGetTransactions(response: HttpResponseBase): Observable<GetTransactionListViewModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionListViewModel2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionListViewModel2>(null as any);
    }

    canProceedToCashOut(): Observable<CanProceedToCashOutViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Transactions/cashout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCanProceedToCashOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanProceedToCashOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanProceedToCashOutViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanProceedToCashOutViewModel>;
        }));
    }

    protected processCanProceedToCashOut(response: HttpResponseBase): Observable<CanProceedToCashOutViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanProceedToCashOutViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CanProceedToCashOutViewModel>(null as any);
    }

    proceedToCashOut(): Observable<ProceedToCashOutViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Transactions/cashout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProceedToCashOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProceedToCashOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProceedToCashOutViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProceedToCashOutViewModel>;
        }));
    }

    protected processProceedToCashOut(response: HttpResponseBase): Observable<ProceedToCashOutViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProceedToCashOutViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProceedToCashOutViewModel>(null as any);
    }

    cancelCashOut(cashoutTransactionId: string): Observable<CancelCashOutViewModel> {
        let url_ = this.baseUrl + "/api/ms/client/Transactions/cashout/{cashoutTransactionId}/cancel";
        if (cashoutTransactionId === undefined || cashoutTransactionId === null)
            throw new Error("The parameter 'cashoutTransactionId' must be defined.");
        url_ = url_.replace("{cashoutTransactionId}", encodeURIComponent("" + cashoutTransactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelCashOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelCashOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelCashOutViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelCashOutViewModel>;
        }));
    }

    protected processCancelCashOut(response: HttpResponseBase): Observable<CancelCashOutViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelCashOutViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CancelCashOutViewModel>(null as any);
    }
}

export interface IFirebaseClient {
    getToken(username: string | null | undefined, password: string | null | undefined): Observable<FileResponse>;
}

@Injectable()
export class FirebaseClient extends ClientBase implements IFirebaseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getToken(username: string | null | undefined, password: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ms/client/Firebase/auth/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (username !== null && username !== undefined)
            content_.append("Username", username.toString());
        if (password !== null && password !== undefined)
            content_.append("Password", password.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IMysteryShoppingAutomationProcessClient {
    getAutomationProcesses(): Observable<ProfileAutomationProcessListItemDto[]>;
    getAutomationProcess(id: string): Observable<ProfileAutomationProcessViewModel>;
    getAutomationProcessHistory(id: string): Observable<AutomationProcessHistoryViewModel>;
    getAutomationProcessCheckup(id: string): Observable<CheckupAutomationProcessDto>;
    changeNextStep(id: string, nextStep: ProcessStep): Observable<boolean>;
    getCallingListByAutomationProcess(id: string): Observable<CallListViewModel>;
    forceExecution(id: string, nextStep: ProcessStep): Observable<boolean>;
    getLast100ActivityLogs(): Observable<ActivityLogDto[]>;
    getLast100ActivityLogsByBranchRuleId(id: string): Observable<ActivityLogDto[]>;
}

@Injectable()
export class MysteryShoppingAutomationProcessClient extends ClientBase implements IMysteryShoppingAutomationProcessClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getAutomationProcesses(): Observable<ProfileAutomationProcessListItemDto[]> {
        let url_ = this.baseUrl + "/api/ms/automation/MysteryShoppingAutomationProcess/processes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAutomationProcesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomationProcesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileAutomationProcessListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileAutomationProcessListItemDto[]>;
        }));
    }

    protected processGetAutomationProcesses(response: HttpResponseBase): Observable<ProfileAutomationProcessListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfileAutomationProcessListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfileAutomationProcessListItemDto[]>(null as any);
    }

    getAutomationProcess(id: string): Observable<ProfileAutomationProcessViewModel> {
        let url_ = this.baseUrl + "/api/ms/automation/MysteryShoppingAutomationProcess/process/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAutomationProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomationProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileAutomationProcessViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileAutomationProcessViewModel>;
        }));
    }

    protected processGetAutomationProcess(response: HttpResponseBase): Observable<ProfileAutomationProcessViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileAutomationProcessViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfileAutomationProcessViewModel>(null as any);
    }

    getAutomationProcessHistory(id: string): Observable<AutomationProcessHistoryViewModel> {
        let url_ = this.baseUrl + "/api/ms/automation/MysteryShoppingAutomationProcess/process/{id}/history";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAutomationProcessHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomationProcessHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutomationProcessHistoryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutomationProcessHistoryViewModel>;
        }));
    }

    protected processGetAutomationProcessHistory(response: HttpResponseBase): Observable<AutomationProcessHistoryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutomationProcessHistoryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AutomationProcessHistoryViewModel>(null as any);
    }

    getAutomationProcessCheckup(id: string): Observable<CheckupAutomationProcessDto> {
        let url_ = this.baseUrl + "/api/ms/automation/MysteryShoppingAutomationProcess/process/{id}/check";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAutomationProcessCheckup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomationProcessCheckup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckupAutomationProcessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckupAutomationProcessDto>;
        }));
    }

    protected processGetAutomationProcessCheckup(response: HttpResponseBase): Observable<CheckupAutomationProcessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckupAutomationProcessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckupAutomationProcessDto>(null as any);
    }

    changeNextStep(id: string, nextStep: ProcessStep): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/automation/MysteryShoppingAutomationProcess/process/{id}/nextstep/{nextStep}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (nextStep === undefined || nextStep === null)
            throw new Error("The parameter 'nextStep' must be defined.");
        url_ = url_.replace("{nextStep}", encodeURIComponent("" + nextStep));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeNextStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeNextStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeNextStep(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getCallingListByAutomationProcess(id: string): Observable<CallListViewModel> {
        let url_ = this.baseUrl + "/api/ms/automation/MysteryShoppingAutomationProcess/process/{id}/callingList";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCallingListByAutomationProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCallingListByAutomationProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallListViewModel>;
        }));
    }

    protected processGetCallingListByAutomationProcess(response: HttpResponseBase): Observable<CallListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CallListViewModel>(null as any);
    }

    forceExecution(id: string, nextStep: ProcessStep): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ms/automation/MysteryShoppingAutomationProcess/process/{id}/execute/{nextStep}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (nextStep === undefined || nextStep === null)
            throw new Error("The parameter 'nextStep' must be defined.");
        url_ = url_.replace("{nextStep}", encodeURIComponent("" + nextStep));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processForceExecution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceExecution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForceExecution(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getLast100ActivityLogs(): Observable<ActivityLogDto[]> {
        let url_ = this.baseUrl + "/api/ms/automation/MysteryShoppingAutomationProcess/activityLogs/last100";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLast100ActivityLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLast100ActivityLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityLogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityLogDto[]>;
        }));
    }

    protected processGetLast100ActivityLogs(response: HttpResponseBase): Observable<ActivityLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityLogDto[]>(null as any);
    }

    getLast100ActivityLogsByBranchRuleId(id: string): Observable<ActivityLogDto[]> {
        let url_ = this.baseUrl + "/api/ms/automation/MysteryShoppingAutomationProcess/activityLogs/last100/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLast100ActivityLogsByBranchRuleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLast100ActivityLogsByBranchRuleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityLogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityLogDto[]>;
        }));
    }

    protected processGetLast100ActivityLogsByBranchRuleId(response: HttpResponseBase): Observable<ActivityLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityLogDto[]>(null as any);
    }
}

export interface IActionLogsClient {
    logView(logDto: ActionLogDto): Observable<void>;
}

@Injectable()
export class ActionLogsClient extends ClientBase implements IActionLogsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    logView(logDto: ActionLogDto): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/action-logs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IAddressTypeClient {
    get(organizationId: string, subscriptionId: string, branchId: string, addressId: string): Observable<GetAddressTypeByIdViewModel>;
    delete(organizationId: string, subscriptionId: string, branchId: string, addressId: string): Observable<DeleteAddressTypeViewModel>;
    create(organizationId: string, subscriptionId: string, branchId: string, createAddressTypeCommandRequest: CreateAddressTypeCommandDto): Observable<CreateAddressTypeViewModel>;
    update(organizationId: string, subscriptionId: string, branchId: string, updateAddressTypeCommandRequest: UpdateAddressTypeCommandDto): Observable<UpdateAddressTypeViewModel>;
}

@Injectable()
export class AddressTypeClient extends ClientBase implements IAddressTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(organizationId: string, subscriptionId: string, branchId: string, addressId: string): Observable<GetAddressTypeByIdViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}/addresses/{addressId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAddressTypeByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAddressTypeByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAddressTypeByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAddressTypeByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAddressTypeByIdViewModel>(null as any);
    }

    delete(organizationId: string, subscriptionId: string, branchId: string, addressId: string): Observable<DeleteAddressTypeViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}/addresses/{addressId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteAddressTypeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteAddressTypeViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteAddressTypeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteAddressTypeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteAddressTypeViewModel>(null as any);
    }

    create(organizationId: string, subscriptionId: string, branchId: string, createAddressTypeCommandRequest: CreateAddressTypeCommandDto): Observable<CreateAddressTypeViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}/addresses";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createAddressTypeCommandRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAddressTypeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAddressTypeViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateAddressTypeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAddressTypeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateAddressTypeViewModel>(null as any);
    }

    update(organizationId: string, subscriptionId: string, branchId: string, updateAddressTypeCommandRequest: UpdateAddressTypeCommandDto): Observable<UpdateAddressTypeViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}/addresses";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateAddressTypeCommandRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAddressTypeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAddressTypeViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateAddressTypeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAddressTypeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateAddressTypeViewModel>(null as any);
    }
}

export interface IBasicBranchClient {
    get(branchId: string, organizationId: string, subscriptionId: string): Observable<GetBranchViewModel>;
    create(organizationId: string, subscriptionId: string, createBranchCommandDto: CreateBranchCommandDto): Observable<CreateBranchViewModel>;
    update(organizationId: string, subscriptionId: string, updateBranchCommandDto: UpdateBranchCommandDto): Observable<UpdateBranchViewModel>;
    delete(branchId: string, organizationId: string, subscriptionId: string): Observable<DeleteBranchViewModel>;
}

@Injectable()
export class BasicBranchClient extends ClientBase implements IBasicBranchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(branchId: string, organizationId: string, subscriptionId: string): Observable<GetBranchViewModel> {
        let url_ = this.baseUrl + "/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBranchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBranchViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetBranchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchViewModel>(null as any);
    }

    create(organizationId: string, subscriptionId: string, createBranchCommandDto: CreateBranchCommandDto): Observable<CreateBranchViewModel> {
        let url_ = this.baseUrl + "/api/admin/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createBranchCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateBranchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateBranchViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateBranchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateBranchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateBranchViewModel>(null as any);
    }

    update(organizationId: string, subscriptionId: string, updateBranchCommandDto: UpdateBranchCommandDto): Observable<UpdateBranchViewModel> {
        let url_ = this.baseUrl + "/api/admin/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateBranchCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateBranchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateBranchViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateBranchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateBranchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateBranchViewModel>(null as any);
    }

    delete(branchId: string, organizationId: string, subscriptionId: string): Observable<DeleteBranchViewModel> {
        let url_ = this.baseUrl + "/api/admin/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteBranchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteBranchViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteBranchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteBranchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteBranchViewModel>(null as any);
    }
}

export interface IBellNotificationsClient {
    getUserNotifications(): Observable<NotificationViewModel>;
    markAsAllRead(): Observable<boolean>;
    markNotificationAsRead(notificationId: string, provider: string | null | undefined): Observable<boolean>;
}

@Injectable()
export class BellNotificationsClient extends ClientBase implements IBellNotificationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getUserNotifications(): Observable<NotificationViewModel> {
        let url_ = this.baseUrl + "/api/portal/bell-notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationViewModel>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<NotificationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationViewModel>(null as any);
    }

    markAsAllRead(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/bell-notifications/mark-as-read";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAsAllRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsAllRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkAsAllRead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    markNotificationAsRead(notificationId: string, provider: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/bell-notifications/mark-as-read/{notificationId}?";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        if (provider !== undefined && provider !== null)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkNotificationAsRead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IBranchClient {
    getFilters(organizationId: string, subscriptionId: string, subscriptionServiceId: string | null | undefined, projectId: string | null | undefined): Observable<GetAvailableBranchFiltersViewModel>;
    get(subscriptionId: string, demoMode: boolean | undefined, organizationId: string): Observable<BranchTreeViewModel>;
    getLogo(organizationId: string, subscriptionId: string, branchId: string): Observable<FileResponse>;
    getLogoCulture(organizationId: string, subscriptionId: string, branchId: string, culture: string): Observable<FileResponse>;
    getListPaginated(organizationId: string, subscriptionId: string, excludeGroup: boolean | undefined, sortingField: BranchSortingField | undefined, sortingDirection: SortingDirection | undefined, searchText: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<BranchPageViewModel>;
    get2(organizationId: string, subscriptionId: string, branchId: string): Observable<BranchViewModel>;
    update(organizationId: string, subscriptionId: string, branchId: string, subscriptionServiceId: string | null | undefined, branchDto: EditableBranchDto): Observable<void>;
    verifyCodeUnicity(organizationId: string, subscriptionId: string, dto: VerifyCodeUnicityDto): Observable<boolean>;
    insert(organizationId: string, subscriptionId: string, branchDto: UpsertBranchDto): Observable<BranchViewModel>;
    import(organizationId: string, subscriptionId: string, options: ImportBranchOptions): Observable<void>;
    getTemplate(organizationId: string, subscriptionId: string): Observable<FileResponse>;
    upload(organizationId: string, subscriptionId: string, branchId: string, subscriptionServiceId: string | null | undefined, files: FileParameter[] | null | undefined, cultures: string[] | null | undefined): Observable<void>;
    export(organizationId: string, subscriptionId: string, excludeGroup: boolean | undefined, exportType: ExportTableType | undefined, searchText: string | null | undefined): Observable<FileResponse>;
    setState(organizationId: string, subscriptionId: string, branchId: string, state: State | undefined): Observable<void>;
    deleteLogo(organizationId: string, subscriptionId: string, branchId: string, subscriptionServiceId: string | null | undefined): Observable<void>;
    deleteCultureLogo(organizationId: string, subscriptionId: string, branchId: string, subscriptionServiceId: string | null | undefined, cultureInfo: string): Observable<void>;
    getSummary(organizationId: string, subscriptionId: string): Observable<GetSummaryViewModel>;
    getBranches(refererUri: string | null | undefined, onlyEnabled: boolean | undefined): Observable<BranchDto2[]>;
    getBranchesLocalities(referrerUri: string | null | undefined, onlyEnabled: boolean | null | undefined): Observable<LocalityDto[]>;
    getBranchesByLocality(refererUri: string | null | undefined, locality: string, onlyEnabled: boolean | undefined): Observable<BranchDto2[]>;
    getListPaginated2(subscriptionServiceId: string, projectId: string, sortingField: BranchSortingField2 | undefined, sortingDirection: SortingDirection | undefined, searchText: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<BranchPageViewModel2>;
    setEnabled(subscriptionServiceId: string, projectId: string, branchId: string, enabled: boolean | undefined): Observable<boolean>;
    setIncluded(subscriptionServiceId: string, projectId: string, branchId: string, included: boolean | undefined): Observable<boolean>;
}

@Injectable()
export class BranchClient extends ClientBase implements IBranchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getFilters(organizationId: string, subscriptionId: string, subscriptionServiceId: string | null | undefined, projectId: string | null | undefined): Observable<GetAvailableBranchFiltersViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches/filters?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId !== undefined && subscriptionServiceId !== null)
            url_ += "subscriptionServiceId=" + encodeURIComponent("" + subscriptionServiceId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAvailableBranchFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAvailableBranchFiltersViewModel>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<GetAvailableBranchFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAvailableBranchFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAvailableBranchFiltersViewModel>(null as any);
    }

    get(subscriptionId: string, demoMode: boolean | undefined, organizationId: string): Observable<BranchTreeViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (demoMode === null)
            throw new Error("The parameter 'demoMode' cannot be null.");
        else if (demoMode !== undefined)
            url_ += "demoMode=" + encodeURIComponent("" + demoMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTreeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTreeViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BranchTreeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchTreeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchTreeViewModel>(null as any);
    }

    getLogo(organizationId: string, subscriptionId: string, branchId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}/logo";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLogo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLogoCulture(organizationId: string, subscriptionId: string, branchId: string, culture: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}/logo/{culture}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (culture === undefined || culture === null)
            throw new Error("The parameter 'culture' must be defined.");
        url_ = url_.replace("{culture}", encodeURIComponent("" + culture));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLogoCulture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogoCulture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLogoCulture(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getListPaginated(organizationId: string, subscriptionId: string, excludeGroup: boolean | undefined, sortingField: BranchSortingField | undefined, sortingDirection: SortingDirection | undefined, searchText: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<BranchPageViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/paginated?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (excludeGroup === null)
            throw new Error("The parameter 'excludeGroup' cannot be null.");
        else if (excludeGroup !== undefined)
            url_ += "excludeGroup=" + encodeURIComponent("" + excludeGroup) + "&";
        if (sortingField === null)
            throw new Error("The parameter 'sortingField' cannot be null.");
        else if (sortingField !== undefined)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (sortingDirection === null)
            throw new Error("The parameter 'sortingDirection' cannot be null.");
        else if (sortingDirection !== undefined)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchPageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchPageViewModel>;
        }));
    }

    protected processGetListPaginated(response: HttpResponseBase): Observable<BranchPageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchPageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchPageViewModel>(null as any);
    }

    get2(organizationId: string, subscriptionId: string, branchId: string): Observable<BranchViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchViewModel>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<BranchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchViewModel>(null as any);
    }

    update(organizationId: string, subscriptionId: string, branchId: string, subscriptionServiceId: string | null | undefined, branchDto: EditableBranchDto): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (subscriptionServiceId !== undefined && subscriptionServiceId !== null)
            url_ += "subscriptionServiceId=" + encodeURIComponent("" + subscriptionServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(branchDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    verifyCodeUnicity(organizationId: string, subscriptionId: string, dto: VerifyCodeUnicityDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/unique-code";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyCodeUnicity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyCodeUnicity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyCodeUnicity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    insert(organizationId: string, subscriptionId: string, branchDto: UpsertBranchDto): Observable<BranchViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(branchDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchViewModel>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<BranchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchViewModel>(null as any);
    }

    import(organizationId: string, subscriptionId: string, options: ImportBranchOptions): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/import";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getTemplate(organizationId: string, subscriptionId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/template";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    upload(organizationId: string, subscriptionId: string, branchId: string, subscriptionServiceId: string | null | undefined, files: FileParameter[] | null | undefined, cultures: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}/logos?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (subscriptionServiceId !== undefined && subscriptionServiceId !== null)
            url_ += "subscriptionServiceId=" + encodeURIComponent("" + subscriptionServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (cultures !== null && cultures !== undefined)
            cultures.forEach(item_ => content_.append("cultures", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    export(organizationId: string, subscriptionId: string, excludeGroup: boolean | undefined, exportType: ExportTableType | undefined, searchText: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/export?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (excludeGroup === null)
            throw new Error("The parameter 'excludeGroup' cannot be null.");
        else if (excludeGroup !== undefined)
            url_ += "excludeGroup=" + encodeURIComponent("" + excludeGroup) + "&";
        if (exportType === null)
            throw new Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    setState(organizationId: string, subscriptionId: string, branchId: string, state: State | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}/state?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteLogo(organizationId: string, subscriptionId: string, branchId: string, subscriptionServiceId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}/logo?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (subscriptionServiceId !== undefined && subscriptionServiceId !== null)
            url_ += "subscriptionServiceId=" + encodeURIComponent("" + subscriptionServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteCultureLogo(organizationId: string, subscriptionId: string, branchId: string, subscriptionServiceId: string | null | undefined, cultureInfo: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/{branchId}/logo/{cultureInfo}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (cultureInfo === undefined || cultureInfo === null)
            throw new Error("The parameter 'cultureInfo' must be defined.");
        url_ = url_.replace("{cultureInfo}", encodeURIComponent("" + cultureInfo));
        if (subscriptionServiceId !== undefined && subscriptionServiceId !== null)
            url_ += "subscriptionServiceId=" + encodeURIComponent("" + subscriptionServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCultureLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCultureLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCultureLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getSummary(organizationId: string, subscriptionId: string): Observable<GetSummaryViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branches/summary";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSummaryViewModel>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<GetSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSummaryViewModel>(null as any);
    }

    getBranches(refererUri: string | null | undefined, onlyEnabled: boolean | undefined): Observable<BranchDto2[]> {
        let url_ = this.baseUrl + "/api/voc/client/branches?";
        if (refererUri !== undefined && refererUri !== null)
            url_ += "X-Hexa-Referer=" + encodeURIComponent("" + refererUri) + "&";
        if (onlyEnabled === null)
            throw new Error("The parameter 'onlyEnabled' cannot be null.");
        else if (onlyEnabled !== undefined)
            url_ += "active=" + encodeURIComponent("" + onlyEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchDto2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchDto2[]>;
        }));
    }

    protected processGetBranches(response: HttpResponseBase): Observable<BranchDto2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchDto2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDto2[]>(null as any);
    }

    getBranchesLocalities(referrerUri: string | null | undefined, onlyEnabled: boolean | null | undefined): Observable<LocalityDto[]> {
        let url_ = this.baseUrl + "/api/voc/client/branches/localities?";
        if (referrerUri !== undefined && referrerUri !== null)
            url_ += "X-Hexa-Referer=" + encodeURIComponent("" + referrerUri) + "&";
        if (onlyEnabled !== undefined && onlyEnabled !== null)
            url_ += "active=" + encodeURIComponent("" + onlyEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBranchesLocalities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchesLocalities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocalityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocalityDto[]>;
        }));
    }

    protected processGetBranchesLocalities(response: HttpResponseBase): Observable<LocalityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocalityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocalityDto[]>(null as any);
    }

    getBranchesByLocality(refererUri: string | null | undefined, locality: string, onlyEnabled: boolean | undefined): Observable<BranchDto2[]> {
        let url_ = this.baseUrl + "/api/voc/client/branches/bylocality/{locality}?";
        if (locality === undefined || locality === null)
            throw new Error("The parameter 'locality' must be defined.");
        url_ = url_.replace("{locality}", encodeURIComponent("" + locality));
        if (refererUri !== undefined && refererUri !== null)
            url_ += "X-Hexa-Referer=" + encodeURIComponent("" + refererUri) + "&";
        if (onlyEnabled === null)
            throw new Error("The parameter 'onlyEnabled' cannot be null.");
        else if (onlyEnabled !== undefined)
            url_ += "active=" + encodeURIComponent("" + onlyEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBranchesByLocality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchesByLocality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchDto2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchDto2[]>;
        }));
    }

    protected processGetBranchesByLocality(response: HttpResponseBase): Observable<BranchDto2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchDto2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDto2[]>(null as any);
    }

    getListPaginated2(subscriptionServiceId: string, projectId: string, sortingField: BranchSortingField2 | undefined, sortingDirection: SortingDirection | undefined, searchText: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<BranchPageViewModel2> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/branches/paginated?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (sortingField === null)
            throw new Error("The parameter 'sortingField' cannot be null.");
        else if (sortingField !== undefined)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (sortingDirection === null)
            throw new Error("The parameter 'sortingDirection' cannot be null.");
        else if (sortingDirection !== undefined)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListPaginated2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListPaginated2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchPageViewModel2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchPageViewModel2>;
        }));
    }

    protected processGetListPaginated2(response: HttpResponseBase): Observable<BranchPageViewModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchPageViewModel2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchPageViewModel2>(null as any);
    }

    setEnabled(subscriptionServiceId: string, projectId: string, branchId: string, enabled: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/branches/{branchId}/set-enabled?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (enabled === null)
            throw new Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    setIncluded(subscriptionServiceId: string, projectId: string, branchId: string, included: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/branches/{branchId}/set-included?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (included === null)
            throw new Error("The parameter 'included' cannot be null.");
        else if (included !== undefined)
            url_ += "included=" + encodeURIComponent("" + included) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetIncluded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIncluded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetIncluded(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IBrandGroupsClient {
    getFilters(organizationId: string, subscriptionId: string, subscriptionServiceId: string | null | undefined, projectId: string | null | undefined): Observable<GetBrandGroupFiltersViewModel>;
}

@Injectable()
export class BrandGroupsClient extends ClientBase implements IBrandGroupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getFilters(organizationId: string, subscriptionId: string, subscriptionServiceId: string | null | undefined, projectId: string | null | undefined): Observable<GetBrandGroupFiltersViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/brand-groups/filters?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId !== undefined && subscriptionServiceId !== null)
            url_ += "subscriptionServiceId=" + encodeURIComponent("" + subscriptionServiceId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBrandGroupFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBrandGroupFiltersViewModel>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<GetBrandGroupFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBrandGroupFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBrandGroupFiltersViewModel>(null as any);
    }
}

export interface ICompetitorGroupsClient {
    getFilters(organizationId: string, subscriptionId: string, subscriptionServiceId: string | null | undefined, projectId: string | null | undefined): Observable<GetCompetitorBranchGroupFiltersViewModel>;
}

@Injectable()
export class CompetitorGroupsClient extends ClientBase implements ICompetitorGroupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getFilters(organizationId: string, subscriptionId: string, subscriptionServiceId: string | null | undefined, projectId: string | null | undefined): Observable<GetCompetitorBranchGroupFiltersViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/competitor-groups/filters?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId !== undefined && subscriptionServiceId !== null)
            url_ += "subscriptionServiceId=" + encodeURIComponent("" + subscriptionServiceId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCompetitorBranchGroupFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCompetitorBranchGroupFiltersViewModel>;
        }));
    }

    protected processGetFilters(response: HttpResponseBase): Observable<GetCompetitorBranchGroupFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompetitorBranchGroupFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCompetitorBranchGroupFiltersViewModel>(null as any);
    }
}

export interface IGlobalNotificationsClient {
    getList(): Observable<GetGlobalNotificationsViewModel>;
    markAllAsRead(): Observable<boolean>;
    markAsRead(notificationId: string): Observable<boolean>;
    getListPaginated(sortingField: GlobalNotificationSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, searchText: string | null | undefined): Observable<GlobalNotificationPageViewModel>;
    insert(dto: GlobalNotificationDto2): Observable<string>;
    get(notificationId: string): Observable<GetGlobalNotificationByIdViewModel>;
    update(notificationId: string, dto: GlobalNotificationDto2): Observable<string>;
    delete(notificationId: string): Observable<boolean>;
}

@Injectable()
export class GlobalNotificationsClient extends ClientBase implements IGlobalNotificationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(): Observable<GetGlobalNotificationsViewModel> {
        let url_ = this.baseUrl + "/api/portal/global-notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGlobalNotificationsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGlobalNotificationsViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetGlobalNotificationsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGlobalNotificationsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGlobalNotificationsViewModel>(null as any);
    }

    markAllAsRead(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/global-notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAllAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkAllAsRead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    markAsRead(notificationId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/global-notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkAsRead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getListPaginated(sortingField: GlobalNotificationSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, searchText: string | null | undefined): Observable<GlobalNotificationPageViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/global-notifications?";
        if (sortingField !== undefined && sortingField !== null)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (sortingDirection !== undefined && sortingDirection !== null)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GlobalNotificationPageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GlobalNotificationPageViewModel>;
        }));
    }

    protected processGetListPaginated(response: HttpResponseBase): Observable<GlobalNotificationPageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalNotificationPageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlobalNotificationPageViewModel>(null as any);
    }

    insert(dto: GlobalNotificationDto2): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/global-notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    get(notificationId: string): Observable<GetGlobalNotificationByIdViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/global-notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGlobalNotificationByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGlobalNotificationByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetGlobalNotificationByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGlobalNotificationByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGlobalNotificationByIdViewModel>(null as any);
    }

    update(notificationId: string, dto: GlobalNotificationDto2): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/global-notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    delete(notificationId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/global-notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IIndustryClient {
    get(): Observable<IndustriesViewModel>;
    getIndustry(id: string): Observable<IndustryViewModel>;
    getLogo(id: string): Observable<FileResponse>;
    getInformation(id: string): Observable<IndustryInformationViewModel>;
    getServices(id: string): Observable<IndustryServiceViewModel>;
}

@Injectable()
export class IndustryClient extends ClientBase implements IIndustryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(): Observable<IndustriesViewModel> {
        let url_ = this.baseUrl + "/api/portal/industries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndustriesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndustriesViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IndustriesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndustriesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IndustriesViewModel>(null as any);
    }

    getIndustry(id: string): Observable<IndustryViewModel> {
        let url_ = this.baseUrl + "/api/portal/industries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetIndustry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIndustry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndustryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndustryViewModel>;
        }));
    }

    protected processGetIndustry(response: HttpResponseBase): Observable<IndustryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndustryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IndustryViewModel>(null as any);
    }

    getLogo(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/industries/{id}/logo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLogo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getInformation(id: string): Observable<IndustryInformationViewModel> {
        let url_ = this.baseUrl + "/api/portal/industries/{id}/information";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndustryInformationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndustryInformationViewModel>;
        }));
    }

    protected processGetInformation(response: HttpResponseBase): Observable<IndustryInformationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndustryInformationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IndustryInformationViewModel>(null as any);
    }

    getServices(id: string): Observable<IndustryServiceViewModel> {
        let url_ = this.baseUrl + "/api/portal/industries/{id}/services";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndustryServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndustryServiceViewModel>;
        }));
    }

    protected processGetServices(response: HttpResponseBase): Observable<IndustryServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndustryServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IndustryServiceViewModel>(null as any);
    }
}

export interface IMenuClient {
    getOrganizationAndSubscription(): Observable<GetOrganizationAndSubscriptionViewModel>;
    getOrganizationTree(organizationId: string): Observable<GetPermissionMenuTreeByOrganisationViewModel>;
    getSubscriptionTree(subscriptionId: string): Observable<GetPermissionMenuTreeBySubscriptionViewModel>;
    getSubscriptionServices(organizationId: string, subscriptionId: string): Observable<GetSubscriptionServicesViewModel>;
}

@Injectable()
export class MenuClient extends ClientBase implements IMenuClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getOrganizationAndSubscription(): Observable<GetOrganizationAndSubscriptionViewModel> {
        let url_ = this.baseUrl + "/api/portal/menu/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationAndSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationAndSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationAndSubscriptionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationAndSubscriptionViewModel>;
        }));
    }

    protected processGetOrganizationAndSubscription(response: HttpResponseBase): Observable<GetOrganizationAndSubscriptionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationAndSubscriptionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrganizationAndSubscriptionViewModel>(null as any);
    }

    getOrganizationTree(organizationId: string): Observable<GetPermissionMenuTreeByOrganisationViewModel> {
        let url_ = this.baseUrl + "/api/portal/menu/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPermissionMenuTreeByOrganisationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPermissionMenuTreeByOrganisationViewModel>;
        }));
    }

    protected processGetOrganizationTree(response: HttpResponseBase): Observable<GetPermissionMenuTreeByOrganisationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPermissionMenuTreeByOrganisationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPermissionMenuTreeByOrganisationViewModel>(null as any);
    }

    getSubscriptionTree(subscriptionId: string): Observable<GetPermissionMenuTreeBySubscriptionViewModel> {
        let url_ = this.baseUrl + "/api/portal/menu/subscriptions/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubscriptionTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPermissionMenuTreeBySubscriptionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPermissionMenuTreeBySubscriptionViewModel>;
        }));
    }

    protected processGetSubscriptionTree(response: HttpResponseBase): Observable<GetPermissionMenuTreeBySubscriptionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPermissionMenuTreeBySubscriptionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPermissionMenuTreeBySubscriptionViewModel>(null as any);
    }

    getSubscriptionServices(organizationId: string, subscriptionId: string): Observable<GetSubscriptionServicesViewModel> {
        let url_ = this.baseUrl + "/api/portal/menu/{organizationId}/subscriptions/{subscriptionId}/subscriptionServices";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubscriptionServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionServicesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionServicesViewModel>;
        }));
    }

    protected processGetSubscriptionServices(response: HttpResponseBase): Observable<GetSubscriptionServicesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionServicesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionServicesViewModel>(null as any);
    }
}

export interface IMenuSettingsClient {
    get(subjectId: string): Observable<GetMenuSettingsBySubjectIdViewmodel>;
    upsert(dto: MenuSettingsDto2): Observable<string>;
    getList(): Observable<GetMenuSettingsListViewModel>;
}

@Injectable()
export class MenuSettingsClient extends ClientBase implements IMenuSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(subjectId: string): Observable<GetMenuSettingsBySubjectIdViewmodel> {
        let url_ = this.baseUrl + "/api/portal/menu-settings/subject/{subjectId}";
        if (subjectId === undefined || subjectId === null)
            throw new Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMenuSettingsBySubjectIdViewmodel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMenuSettingsBySubjectIdViewmodel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetMenuSettingsBySubjectIdViewmodel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMenuSettingsBySubjectIdViewmodel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMenuSettingsBySubjectIdViewmodel>(null as any);
    }

    upsert(dto: MenuSettingsDto2): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/menu-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getList(): Observable<GetMenuSettingsListViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/menu-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMenuSettingsListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMenuSettingsListViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetMenuSettingsListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMenuSettingsListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMenuSettingsListViewModel>(null as any);
    }
}

export interface IOrganizationClient {
    get(): Observable<OrganizationsViewModel>;
    create(createOrganizationCommandRequest: CreateOrganizationCommandDto): Observable<CreateOrganizationViewModel>;
    update(updateOrganizationCommandRequest: UpdateOrganizationCommandDto): Observable<UpdateOrganizationViewModel>;
    delete(deleteOrganizationCommandrequest: DeleteOrganizationCommandDto): Observable<DeleteOrganizationViewModel>;
    getById(organizationId: string, includeSubscriptions: boolean | undefined): Observable<OrganizationViewModel>;
    getDomains(organizationId: string): Observable<OrganizationDomainsViewModel>;
    updateDomains(organizationId: string, organizationDomains: UpdateOrganizationDomainsDto): Observable<UpdateOrganizationDomainsDto>;
    getList(): Observable<GetOrganizationsViewModel>;
    create2(dto: OrganizationDto2): Observable<string>;
    get2(organizationId: string): Observable<GetOrganizationViewModel>;
    update2(organizationId: string, dto: OrganizationDto2): Observable<string>;
}

@Injectable()
export class OrganizationClient extends ClientBase implements IOrganizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(): Observable<OrganizationsViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationsViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrganizationsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationsViewModel>(null as any);
    }

    create(createOrganizationCommandRequest: CreateOrganizationCommandDto): Observable<CreateOrganizationViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createOrganizationCommandRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrganizationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrganizationViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateOrganizationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrganizationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrganizationViewModel>(null as any);
    }

    update(updateOrganizationCommandRequest: UpdateOrganizationCommandDto): Observable<UpdateOrganizationViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateOrganizationCommandRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateOrganizationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateOrganizationViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateOrganizationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateOrganizationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateOrganizationViewModel>(null as any);
    }

    delete(deleteOrganizationCommandrequest: DeleteOrganizationCommandDto): Observable<DeleteOrganizationViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteOrganizationCommandrequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteOrganizationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteOrganizationViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteOrganizationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteOrganizationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteOrganizationViewModel>(null as any);
    }

    getById(organizationId: string, includeSubscriptions: boolean | undefined): Observable<OrganizationViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (includeSubscriptions === null)
            throw new Error("The parameter 'includeSubscriptions' cannot be null.");
        else if (includeSubscriptions !== undefined)
            url_ += "includeSubscriptions=" + encodeURIComponent("" + includeSubscriptions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<OrganizationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationViewModel>(null as any);
    }

    getDomains(organizationId: string): Observable<OrganizationDomainsViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/domains";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationDomainsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationDomainsViewModel>;
        }));
    }

    protected processGetDomains(response: HttpResponseBase): Observable<OrganizationDomainsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDomainsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationDomainsViewModel>(null as any);
    }

    updateDomains(organizationId: string, organizationDomains: UpdateOrganizationDomainsDto): Observable<UpdateOrganizationDomainsDto> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/domains";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organizationDomains);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateOrganizationDomainsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateOrganizationDomainsDto>;
        }));
    }

    protected processUpdateDomains(response: HttpResponseBase): Observable<UpdateOrganizationDomainsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateOrganizationDomainsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateOrganizationDomainsDto>(null as any);
    }

    getList(): Observable<GetOrganizationsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationsViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetOrganizationsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrganizationsViewModel>(null as any);
    }

    create2(dto: OrganizationDto2): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    get2(organizationId: string): Observable<GetOrganizationViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrganizationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrganizationViewModel>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<GetOrganizationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrganizationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrganizationViewModel>(null as any);
    }

    update2(organizationId: string, dto: OrganizationDto2): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdate2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IServiceClient {
    get(id: string): Observable<GetServiceViewModel>;
    delete(id: string): Observable<DeleteServiceViewModel>;
    get2(): Observable<GetServicesViewModel>;
    create(createServiceCommandRequest: CreateServiceCommandDto): Observable<CreateServiceViewModel>;
    update(updateServiceCommandRequest: UpdateServiceCommandDto): Observable<UpdateServiceViewModel>;
}

@Injectable()
export class ServiceClient extends ClientBase implements IServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(id: string): Observable<GetServiceViewModel> {
        let url_ = this.baseUrl + "/api/portal/services/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServiceViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetServiceViewModel>(null as any);
    }

    delete(id: string): Observable<DeleteServiceViewModel> {
        let url_ = this.baseUrl + "/api/portal/services/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteServiceViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteServiceViewModel>(null as any);
    }

    get2(): Observable<GetServicesViewModel> {
        let url_ = this.baseUrl + "/api/portal/services";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetServicesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetServicesViewModel>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<GetServicesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetServicesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetServicesViewModel>(null as any);
    }

    create(createServiceCommandRequest: CreateServiceCommandDto): Observable<CreateServiceViewModel> {
        let url_ = this.baseUrl + "/api/portal/services";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createServiceCommandRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateServiceViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateServiceViewModel>(null as any);
    }

    update(updateServiceCommandRequest: UpdateServiceCommandDto): Observable<UpdateServiceViewModel> {
        let url_ = this.baseUrl + "/api/portal/services";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateServiceCommandRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateServiceViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateServiceViewModel>(null as any);
    }
}

export interface ISubscriptionClient {
    create(organizationId: string, createSubscriptionCommandRequest: CreateSubscriptionCommandDto): Observable<CreateSubscriptionViewModel>;
    update(organizationId: string, updateSubscriptionCommandRequest: UpdateSubscriptionCommandDto): Observable<UpdateSubscriptionViewModel>;
    convertContactTracingSubscriptionToOrganization(organizationId: string): Observable<ConvertContactTracingSubscriptionToOrganizationViewModel>;
    delete(subscriptionId: string, organizationId: string): Observable<DeleteSubscriptionViewModel>;
    getById(organizationId: string, subscriptionId: string): Observable<GetSubscriptionByIdViewModel>;
    getInformation(id: string, organizationId: string): Observable<SubscriptionInformationViewModel>;
    getLogo(organizationId: string, subscriptionId: string): Observable<FileResponse>;
    deleteLogo(organizationId: string, subscriptionId: string): Observable<void>;
    uploadLogo(organizationId: string, subscriptionId: string, file: FileParameter | null | undefined): Observable<string>;
    deleteLogo2(organizationId: string, subscriptionId: string, cultureCode: string): Observable<void>;
    uploadLogoCulture(organizationId: string, subscriptionId: string, cultureCode: string, file: FileParameter | null | undefined): Observable<string>;
    getDomains(subscriptionId: string, organizationId: string): Observable<SubscriptionDomainsViewModel>;
    updateDomains(organizationId: string, subscriptionId: string, subscriptionDomains: UpdateSubscriptionDomainsDto): Observable<UpdateSubscriptionDomainsDto>;
    searchBranches(subscriptionId: string, searchTerm: string, organizationId: string): Observable<SubscriptionBranchesViewModel>;
    getLogos(organizationId: string, subscriptionId: string): Observable<SubscriptionLogosViewModel>;
    upload(organizationId: string, subscriptionId: string, files: FileParameter[] | null | undefined, cultures: string[] | null | undefined): Observable<void>;
    getAvailableCultures(organizationId: string, subscriptionId: string): Observable<AvailableCultureViewModel>;
    searchBranchKeywords(organizationId: string, subscriptionId: string, searchTerm: string | null | undefined): Observable<BranchKeywordViewModel>;
    getList(organizationId: string): Observable<GetSubscriptionsViewModel>;
    create2(organizationId: string, dto: SubscriptionDto2): Observable<string>;
    get(organizationId: string, subscriptionId: string): Observable<GetSubscriptionViewModel>;
    update2(organizationId: string, subscriptionId: string, dto: SubscriptionDto2): Observable<string>;
    getMove(organizationId: string, subscriptionId: string): Observable<GetMoveSubscriptionViewModel>;
    move(organizationId: string, subscriptionId: string, targetOrganizationId: string | undefined, movePermissions: boolean | undefined): Observable<MoveSubscriptionViewModel>;
    deleteLogo22(organizationId: string, subscriptionId: string): Observable<void>;
    deleteCultureLogo(organizationId: string, subscriptionId: string, culture: string): Observable<void>;
}

@Injectable()
export class SubscriptionClient extends ClientBase implements ISubscriptionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    create(organizationId: string, createSubscriptionCommandRequest: CreateSubscriptionCommandDto): Observable<CreateSubscriptionViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createSubscriptionCommandRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSubscriptionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSubscriptionViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateSubscriptionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSubscriptionViewModel>(null as any);
    }

    update(organizationId: string, updateSubscriptionCommandRequest: UpdateSubscriptionCommandDto): Observable<UpdateSubscriptionViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateSubscriptionCommandRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSubscriptionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSubscriptionViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateSubscriptionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSubscriptionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateSubscriptionViewModel>(null as any);
    }

    convertContactTracingSubscriptionToOrganization(organizationId: string): Observable<ConvertContactTracingSubscriptionToOrganizationViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processConvertContactTracingSubscriptionToOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertContactTracingSubscriptionToOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConvertContactTracingSubscriptionToOrganizationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConvertContactTracingSubscriptionToOrganizationViewModel>;
        }));
    }

    protected processConvertContactTracingSubscriptionToOrganization(response: HttpResponseBase): Observable<ConvertContactTracingSubscriptionToOrganizationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConvertContactTracingSubscriptionToOrganizationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConvertContactTracingSubscriptionToOrganizationViewModel>(null as any);
    }

    delete(subscriptionId: string, organizationId: string): Observable<DeleteSubscriptionViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteSubscriptionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteSubscriptionViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteSubscriptionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteSubscriptionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteSubscriptionViewModel>(null as any);
    }

    getById(organizationId: string, subscriptionId: string): Observable<GetSubscriptionByIdViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionByIdViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetSubscriptionByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionByIdViewModel>(null as any);
    }

    getInformation(id: string, organizationId: string): Observable<SubscriptionInformationViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{id}/information";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionInformationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionInformationViewModel>;
        }));
    }

    protected processGetInformation(response: HttpResponseBase): Observable<SubscriptionInformationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionInformationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionInformationViewModel>(null as any);
    }

    getLogo(organizationId: string, subscriptionId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/logo";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLogo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    deleteLogo(organizationId: string, subscriptionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/logo";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    uploadLogo(organizationId: string, subscriptionId: string, file: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/logo";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    deleteLogo2(organizationId: string, subscriptionId: string, cultureCode: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/logo/{cultureCode}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (cultureCode === undefined || cultureCode === null)
            throw new Error("The parameter 'cultureCode' must be defined.");
        url_ = url_.replace("{cultureCode}", encodeURIComponent("" + cultureCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLogo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLogo2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLogo2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    uploadLogoCulture(organizationId: string, subscriptionId: string, cultureCode: string, file: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/logo/{cultureCode}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (cultureCode === undefined || cultureCode === null)
            throw new Error("The parameter 'cultureCode' must be defined.");
        url_ = url_.replace("{cultureCode}", encodeURIComponent("" + cultureCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadLogoCulture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogoCulture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadLogoCulture(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getDomains(subscriptionId: string, organizationId: string): Observable<SubscriptionDomainsViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/domains";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionDomainsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionDomainsViewModel>;
        }));
    }

    protected processGetDomains(response: HttpResponseBase): Observable<SubscriptionDomainsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionDomainsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionDomainsViewModel>(null as any);
    }

    updateDomains(organizationId: string, subscriptionId: string, subscriptionDomains: UpdateSubscriptionDomainsDto): Observable<UpdateSubscriptionDomainsDto> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/domains";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionDomains);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSubscriptionDomainsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSubscriptionDomainsDto>;
        }));
    }

    protected processUpdateDomains(response: HttpResponseBase): Observable<UpdateSubscriptionDomainsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSubscriptionDomainsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateSubscriptionDomainsDto>(null as any);
    }

    searchBranches(subscriptionId: string, searchTerm: string, organizationId: string): Observable<SubscriptionBranchesViewModel> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/branches/{searchTerm}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined.");
        url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBranches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionBranchesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionBranchesViewModel>;
        }));
    }

    protected processSearchBranches(response: HttpResponseBase): Observable<SubscriptionBranchesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionBranchesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionBranchesViewModel>(null as any);
    }

    getLogos(organizationId: string, subscriptionId: string): Observable<SubscriptionLogosViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/logos";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLogos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionLogosViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionLogosViewModel>;
        }));
    }

    protected processGetLogos(response: HttpResponseBase): Observable<SubscriptionLogosViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionLogosViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionLogosViewModel>(null as any);
    }

    upload(organizationId: string, subscriptionId: string, files: FileParameter[] | null | undefined, cultures: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/logos";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (cultures !== null && cultures !== undefined)
            cultures.forEach(item_ => content_.append("cultures", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAvailableCultures(organizationId: string, subscriptionId: string): Observable<AvailableCultureViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/available-cultures";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAvailableCultures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableCultures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableCultureViewModel>;
        }));
    }

    protected processGetAvailableCultures(response: HttpResponseBase): Observable<AvailableCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailableCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailableCultureViewModel>(null as any);
    }

    searchBranchKeywords(organizationId: string, subscriptionId: string, searchTerm: string | null | undefined): Observable<BranchKeywordViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/keywords?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchBranchKeywords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBranchKeywords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchKeywordViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchKeywordViewModel>;
        }));
    }

    protected processSearchBranchKeywords(response: HttpResponseBase): Observable<BranchKeywordViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchKeywordViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchKeywordViewModel>(null as any);
    }

    getList(organizationId: string): Observable<GetSubscriptionsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionsViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetSubscriptionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionsViewModel>(null as any);
    }

    create2(organizationId: string, dto: SubscriptionDto2): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    get(organizationId: string, subscriptionId: string): Observable<GetSubscriptionViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetSubscriptionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionViewModel>(null as any);
    }

    update2(organizationId: string, subscriptionId: string, dto: SubscriptionDto2): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdate2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getMove(organizationId: string, subscriptionId: string): Observable<GetMoveSubscriptionViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/move";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMoveSubscriptionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMoveSubscriptionViewModel>;
        }));
    }

    protected processGetMove(response: HttpResponseBase): Observable<GetMoveSubscriptionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoveSubscriptionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMoveSubscriptionViewModel>(null as any);
    }

    move(organizationId: string, subscriptionId: string, targetOrganizationId: string | undefined, movePermissions: boolean | undefined): Observable<MoveSubscriptionViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/move?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (targetOrganizationId === null)
            throw new Error("The parameter 'targetOrganizationId' cannot be null.");
        else if (targetOrganizationId !== undefined)
            url_ += "targetOrganizationId=" + encodeURIComponent("" + targetOrganizationId) + "&";
        if (movePermissions === null)
            throw new Error("The parameter 'movePermissions' cannot be null.");
        else if (movePermissions !== undefined)
            url_ += "movePermissions=" + encodeURIComponent("" + movePermissions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveSubscriptionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveSubscriptionViewModel>;
        }));
    }

    protected processMove(response: HttpResponseBase): Observable<MoveSubscriptionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveSubscriptionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoveSubscriptionViewModel>(null as any);
    }

    deleteLogo22(organizationId: string, subscriptionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/logo";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLogo22(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLogo22(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLogo22(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteCultureLogo(organizationId: string, subscriptionId: string, culture: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/logo/{culture}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (culture === undefined || culture === null)
            throw new Error("The parameter 'culture' must be defined.");
        url_ = url_.replace("{culture}", encodeURIComponent("" + culture));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCultureLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCultureLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCultureLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ISubscriptionServiceClient {
    getLogo(organizationId: string, subscriptionId: string, subscriptionServiceId: string): Observable<FileResponse>;
    getLogo2(organizationId: string, subscriptionId: string, subscriptionServiceId: string, cultureCode: string): Observable<FileResponse>;
    create(organizationId: string, subscriptionId: string, subscriptionServiceDto: SubscriptionServiceDto2): Observable<string>;
    getList(organizationId: string, subscriptionId: string): Observable<GetSubscriptionServicesViewModel2>;
    update(organizationId: string, subscriptionId: string, subscriptionServiceId: string, subscriptionServiceDto: SubscriptionServiceDto2): Observable<string>;
    delete(organizationId: string, subscriptionId: string, subscriptionServiceId: string): Observable<DeleteSubscriptionServiceViewModel>;
    get(organizationId: string, subscriptionId: string, subscriptionServiceId: string): Observable<GetSubscriptionServiceViewModel>;
    upload(organizationId: string, subscriptionId: string, subscriptionServiceId: string, files: FileParameter[] | null | undefined, cultures: string[] | null | undefined): Observable<void>;
    deleteLogo(organizationId: string, subscriptionId: string, subscriptionServiceId: string): Observable<void>;
    deleteCultureLogo(organizationId: string, subscriptionId: string, subscriptionServiceId: string, culture: string): Observable<void>;
}

@Injectable()
export class SubscriptionServiceClient extends ClientBase implements ISubscriptionServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getLogo(organizationId: string, subscriptionId: string, subscriptionServiceId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/services/{subscriptionServiceId}/logo";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLogo(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getLogo2(organizationId: string, subscriptionId: string, subscriptionServiceId: string, cultureCode: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/organizations/{organizationId}/subscriptions/{subscriptionId}/services/{subscriptionServiceId}/logo/{cultureCode}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (cultureCode === undefined || cultureCode === null)
            throw new Error("The parameter 'cultureCode' must be defined.");
        url_ = url_.replace("{cultureCode}", encodeURIComponent("" + cultureCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLogo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogo2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLogo2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    create(organizationId: string, subscriptionId: string, subscriptionServiceDto: SubscriptionServiceDto2): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations/{organizationId}/subscriptions/{subscriptionId}/services";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionServiceDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getList(organizationId: string, subscriptionId: string): Observable<GetSubscriptionServicesViewModel2> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations/{organizationId}/subscriptions/{subscriptionId}/services";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionServicesViewModel2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionServicesViewModel2>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetSubscriptionServicesViewModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionServicesViewModel2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionServicesViewModel2>(null as any);
    }

    update(organizationId: string, subscriptionId: string, subscriptionServiceId: string, subscriptionServiceDto: SubscriptionServiceDto2): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations/{organizationId}/subscriptions/{subscriptionId}/services/{subscriptionServiceId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionServiceDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    delete(organizationId: string, subscriptionId: string, subscriptionServiceId: string): Observable<DeleteSubscriptionServiceViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations/{organizationId}/subscriptions/{subscriptionId}/services/{subscriptionServiceId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteSubscriptionServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteSubscriptionServiceViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteSubscriptionServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteSubscriptionServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteSubscriptionServiceViewModel>(null as any);
    }

    get(organizationId: string, subscriptionId: string, subscriptionServiceId: string): Observable<GetSubscriptionServiceViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations/{organizationId}/subscriptions/{subscriptionId}/services/{subscriptionServiceId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionServiceViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetSubscriptionServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionServiceViewModel>(null as any);
    }

    upload(organizationId: string, subscriptionId: string, subscriptionServiceId: string, files: FileParameter[] | null | undefined, cultures: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations/{organizationId}/subscriptions/{subscriptionId}/services/{subscriptionServiceId}/logos";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );
        if (cultures !== null && cultures !== undefined)
            cultures.forEach(item_ => content_.append("cultures", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteLogo(organizationId: string, subscriptionId: string, subscriptionServiceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations/{organizationId}/subscriptions/{subscriptionId}/services/{subscriptionServiceId}/logo";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteCultureLogo(organizationId: string, subscriptionId: string, subscriptionServiceId: string, culture: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/organizations/{organizationId}/subscriptions/{subscriptionId}/services/{subscriptionServiceId}/logo/{culture}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (culture === undefined || culture === null)
            throw new Error("The parameter 'culture' must be defined.");
        url_ = url_.replace("{culture}", encodeURIComponent("" + culture));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCultureLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCultureLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCultureLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ISubscriptionServiceMappingClient {
    getSubscriptionServiceHierarchy(subscriptionServiceId: string): Observable<GetSubscriptionServiceHierarchyViewModel>;
}

@Injectable()
export class SubscriptionServiceMappingClient extends ClientBase implements ISubscriptionServiceMappingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getSubscriptionServiceHierarchy(subscriptionServiceId: string): Observable<GetSubscriptionServiceHierarchyViewModel> {
        let url_ = this.baseUrl + "/api/portal/subscriptionServiceMapping/{subscriptionServiceId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubscriptionServiceHierarchy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionServiceHierarchy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionServiceHierarchyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionServiceHierarchyViewModel>;
        }));
    }

    protected processGetSubscriptionServiceHierarchy(response: HttpResponseBase): Observable<GetSubscriptionServiceHierarchyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionServiceHierarchyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionServiceHierarchyViewModel>(null as any);
    }
}

export interface ISuperDashboardClient {
    getSuperDashboardMenu(subjectId: string | undefined, subjectPath: any[] | null | undefined, subjectType: SubjectType | undefined): Observable<GetDashboardMenuViewModel>;
    createSuperDashboard(superDashboardDto: CreateSuperDashboardDto): Observable<string>;
    getSuperdashboard(superdashboardId: string): Observable<GetSuperDashboardConfigViewModel>;
    getWidgetData(superdashboardId: string, widgetid: string): Observable<GetWidgetDataViewModel>;
    getWidgetFilters(superDashboardId: string, widgetId: string, subscriptionServiceId: string | undefined): Observable<GetWidgetFiltersViewModel>;
    getEditSuperDashboard(superDashboardId: string): Observable<GetEditSuperDashboardViewModel>;
    getEditWidget(superDashboardId: string, widgetId: string): Observable<GetEditWidgetViewModel>;
    updateSuperDashboard(superDashboardId: string, updateRequest: UpdateSuperDashboardRequest): Observable<string>;
    deleteSuperDashboard(superDashboardId: string): Observable<Unit>;
    createSuperDashboardWidget(superDashboardId: string, createRequest: UpsertWidgetRequest): Observable<string>;
    updateSuperDashboardWidget(superDashboardId: string, widgetId: string, updateRequest: UpsertWidgetRequest): Observable<string>;
    deleteSuperDashboardWidget(superDashboardId: string, widgetId: string): Observable<Unit>;
    deleteSuperDashboardShare(superDashboardId: string, shareId: string): Observable<Unit>;
}

@Injectable()
export class SuperDashboardClient extends ClientBase implements ISuperDashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getSuperDashboardMenu(subjectId: string | undefined, subjectPath: any[] | null | undefined, subjectType: SubjectType | undefined): Observable<GetDashboardMenuViewModel> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards?";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (subjectPath !== undefined && subjectPath !== null)
            subjectPath && subjectPath.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "subjectPath[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (subjectType === null)
            throw new Error("The parameter 'subjectType' cannot be null.");
        else if (subjectType !== undefined)
            url_ += "subjectType=" + encodeURIComponent("" + subjectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSuperDashboardMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuperDashboardMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardMenuViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardMenuViewModel>;
        }));
    }

    protected processGetSuperDashboardMenu(response: HttpResponseBase): Observable<GetDashboardMenuViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardMenuViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDashboardMenuViewModel>(null as any);
    }

    createSuperDashboard(superDashboardDto: CreateSuperDashboardDto): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(superDashboardDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateSuperDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSuperDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateSuperDashboard(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getSuperdashboard(superdashboardId: string): Observable<GetSuperDashboardConfigViewModel> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superdashboardId}";
        if (superdashboardId === undefined || superdashboardId === null)
            throw new Error("The parameter 'superdashboardId' must be defined.");
        url_ = url_.replace("{superdashboardId}", encodeURIComponent("" + superdashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSuperdashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuperdashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSuperDashboardConfigViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSuperDashboardConfigViewModel>;
        }));
    }

    protected processGetSuperdashboard(response: HttpResponseBase): Observable<GetSuperDashboardConfigViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSuperDashboardConfigViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSuperDashboardConfigViewModel>(null as any);
    }

    getWidgetData(superdashboardId: string, widgetid: string): Observable<GetWidgetDataViewModel> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superdashboardId}/widgets/{widgetId}";
        if (superdashboardId === undefined || superdashboardId === null)
            throw new Error("The parameter 'superdashboardId' must be defined.");
        url_ = url_.replace("{superdashboardId}", encodeURIComponent("" + superdashboardId));
        if (widgetid === undefined || widgetid === null)
            throw new Error("The parameter 'widgetid' must be defined.");
        url_ = url_.replace("{widgetid}", encodeURIComponent("" + widgetid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWidgetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWidgetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWidgetDataViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWidgetDataViewModel>;
        }));
    }

    protected processGetWidgetData(response: HttpResponseBase): Observable<GetWidgetDataViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWidgetDataViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWidgetDataViewModel>(null as any);
    }

    getWidgetFilters(superDashboardId: string, widgetId: string, subscriptionServiceId: string | undefined): Observable<GetWidgetFiltersViewModel> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superDashboardId}/widgets/{widgetId}/filters?";
        if (superDashboardId === undefined || superDashboardId === null)
            throw new Error("The parameter 'superDashboardId' must be defined.");
        url_ = url_.replace("{superDashboardId}", encodeURIComponent("" + superDashboardId));
        if (widgetId === undefined || widgetId === null)
            throw new Error("The parameter 'widgetId' must be defined.");
        url_ = url_.replace("{widgetId}", encodeURIComponent("" + widgetId));
        if (subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' cannot be null.");
        else if (subscriptionServiceId !== undefined)
            url_ += "subscriptionServiceId=" + encodeURIComponent("" + subscriptionServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWidgetFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWidgetFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWidgetFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWidgetFiltersViewModel>;
        }));
    }

    protected processGetWidgetFilters(response: HttpResponseBase): Observable<GetWidgetFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWidgetFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWidgetFiltersViewModel>(null as any);
    }

    getEditSuperDashboard(superDashboardId: string): Observable<GetEditSuperDashboardViewModel> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superDashboardId}/edit";
        if (superDashboardId === undefined || superDashboardId === null)
            throw new Error("The parameter 'superDashboardId' must be defined.");
        url_ = url_.replace("{superDashboardId}", encodeURIComponent("" + superDashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditSuperDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditSuperDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditSuperDashboardViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditSuperDashboardViewModel>;
        }));
    }

    protected processGetEditSuperDashboard(response: HttpResponseBase): Observable<GetEditSuperDashboardViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditSuperDashboardViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditSuperDashboardViewModel>(null as any);
    }

    getEditWidget(superDashboardId: string, widgetId: string): Observable<GetEditWidgetViewModel> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superDashboardId}/widgets/{widgetId}/edit";
        if (superDashboardId === undefined || superDashboardId === null)
            throw new Error("The parameter 'superDashboardId' must be defined.");
        url_ = url_.replace("{superDashboardId}", encodeURIComponent("" + superDashboardId));
        if (widgetId === undefined || widgetId === null)
            throw new Error("The parameter 'widgetId' must be defined.");
        url_ = url_.replace("{widgetId}", encodeURIComponent("" + widgetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditWidgetViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditWidgetViewModel>;
        }));
    }

    protected processGetEditWidget(response: HttpResponseBase): Observable<GetEditWidgetViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditWidgetViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditWidgetViewModel>(null as any);
    }

    updateSuperDashboard(superDashboardId: string, updateRequest: UpdateSuperDashboardRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superDashboardId}";
        if (superDashboardId === undefined || superDashboardId === null)
            throw new Error("The parameter 'superDashboardId' must be defined.");
        url_ = url_.replace("{superDashboardId}", encodeURIComponent("" + superDashboardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSuperDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSuperDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateSuperDashboard(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    deleteSuperDashboard(superDashboardId: string): Observable<Unit> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superDashboardId}";
        if (superDashboardId === undefined || superDashboardId === null)
            throw new Error("The parameter 'superDashboardId' must be defined.");
        url_ = url_.replace("{superDashboardId}", encodeURIComponent("" + superDashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteSuperDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSuperDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processDeleteSuperDashboard(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Unit>(null as any);
    }

    createSuperDashboardWidget(superDashboardId: string, createRequest: UpsertWidgetRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superDashboardId}/widgets";
        if (superDashboardId === undefined || superDashboardId === null)
            throw new Error("The parameter 'superDashboardId' must be defined.");
        url_ = url_.replace("{superDashboardId}", encodeURIComponent("" + superDashboardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateSuperDashboardWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSuperDashboardWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateSuperDashboardWidget(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    updateSuperDashboardWidget(superDashboardId: string, widgetId: string, updateRequest: UpsertWidgetRequest): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superDashboardId}/widgets/{widgetId}";
        if (superDashboardId === undefined || superDashboardId === null)
            throw new Error("The parameter 'superDashboardId' must be defined.");
        url_ = url_.replace("{superDashboardId}", encodeURIComponent("" + superDashboardId));
        if (widgetId === undefined || widgetId === null)
            throw new Error("The parameter 'widgetId' must be defined.");
        url_ = url_.replace("{widgetId}", encodeURIComponent("" + widgetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSuperDashboardWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSuperDashboardWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateSuperDashboardWidget(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    deleteSuperDashboardWidget(superDashboardId: string, widgetId: string): Observable<Unit> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superDashboardId}/widgets/{widgetId}";
        if (superDashboardId === undefined || superDashboardId === null)
            throw new Error("The parameter 'superDashboardId' must be defined.");
        url_ = url_.replace("{superDashboardId}", encodeURIComponent("" + superDashboardId));
        if (widgetId === undefined || widgetId === null)
            throw new Error("The parameter 'widgetId' must be defined.");
        url_ = url_.replace("{widgetId}", encodeURIComponent("" + widgetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteSuperDashboardWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSuperDashboardWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processDeleteSuperDashboardWidget(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Unit>(null as any);
    }

    deleteSuperDashboardShare(superDashboardId: string, shareId: string): Observable<Unit> {
        let url_ = this.baseUrl + "/api/portal/super-dashboards/{superDashboardId}/shares/{shareId}";
        if (superDashboardId === undefined || superDashboardId === null)
            throw new Error("The parameter 'superDashboardId' must be defined.");
        url_ = url_.replace("{superDashboardId}", encodeURIComponent("" + superDashboardId));
        if (shareId === undefined || shareId === null)
            throw new Error("The parameter 'shareId' must be defined.");
        url_ = url_.replace("{shareId}", encodeURIComponent("" + shareId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteSuperDashboardShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSuperDashboardShare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processDeleteSuperDashboardShare(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Unit>(null as any);
    }
}

export interface ITutorialClient {
    post(dto: CreateTutorialDto): Observable<CreateTutorialViewModel>;
    get(key: string | null | undefined): Observable<TutorialViewModel>;
}

@Injectable()
export class TutorialClient extends ClientBase implements ITutorialClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    post(dto: CreateTutorialDto): Observable<CreateTutorialViewModel> {
        let url_ = this.baseUrl + "/api/portal/tutorial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTutorialViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTutorialViewModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<CreateTutorialViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTutorialViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTutorialViewModel>(null as any);
    }

    get(key: string | null | undefined): Observable<TutorialViewModel> {
        let url_ = this.baseUrl + "/api/portal/tutorial?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TutorialViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TutorialViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TutorialViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TutorialViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TutorialViewModel>(null as any);
    }
}

export interface IUserClient {
    getUserSubscriptionServiceType(): Observable<GetUserSubscriptionServiceTypeViewModel>;
    getUserMenu(): Observable<GetUserMenuViewModel>;
    saveUserId(): Observable<void>;
    saveDeviceId(deviceId: string): Observable<void>;
    removeDeviceId(deviceId: string): Observable<void>;
    setDevView(isDevView: boolean | undefined): Observable<void>;
}

@Injectable()
export class UserClient extends ClientBase implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getUserSubscriptionServiceType(): Observable<GetUserSubscriptionServiceTypeViewModel> {
        let url_ = this.baseUrl + "/api/portal/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserSubscriptionServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSubscriptionServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserSubscriptionServiceTypeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserSubscriptionServiceTypeViewModel>;
        }));
    }

    protected processGetUserSubscriptionServiceType(response: HttpResponseBase): Observable<GetUserSubscriptionServiceTypeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserSubscriptionServiceTypeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserSubscriptionServiceTypeViewModel>(null as any);
    }

    getUserMenu(): Observable<GetUserMenuViewModel> {
        let url_ = this.baseUrl + "/api/portal/user/menu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserMenuViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserMenuViewModel>;
        }));
    }

    protected processGetUserMenu(response: HttpResponseBase): Observable<GetUserMenuViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserMenuViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserMenuViewModel>(null as any);
    }

    saveUserId(): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/user/id";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveUserId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    saveDeviceId(deviceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/user/devices/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveDeviceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDeviceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveDeviceId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    removeDeviceId(deviceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/user/devices/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRemoveDeviceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDeviceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveDeviceId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    setDevView(isDevView: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/user/isDevView?";
        if (isDevView === null)
            throw new Error("The parameter 'isDevView' cannot be null.");
        else if (isDevView !== undefined)
            url_ += "isDevView=" + encodeURIComponent("" + isDevView) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetDevView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDevView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDevView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IUserProfileClient {
    get(userId: string): Observable<ApplicationUser>;
    getTimeZones(): Observable<{ [key: string]: string; }>;
    postClaims(body: string | null | undefined): Observable<boolean>;
    put(newSettings: UserAlertNotificationSettings): Observable<boolean>;
    postUpdatePassword(accountPassword: AccountPassword): Observable<boolean>;
    postAlertNotificationSettings(newSettings: UserAlertNotificationSettings): Observable<boolean>;
    getUserAlertNotificationSettings(id: string): Observable<UserAlertNotificationSettings[]>;
    getUserAlerts(): Observable<GetUserAlertsViewModel>;
    toggleUserAlert(dto: SaveUserAlertDto): Observable<boolean>;
    toggleAllUserAlert(dto: SaveAllUserAlertDto): Observable<Unit>;
    getUserBranchAlerts(subjectId: string | undefined, subjectPath: string | null | undefined, subjectType: SubjectType | undefined): Observable<GetUserBranchAlertsViewModel>;
    toggleAllUserBranchAlert(dto: SaveUserAlertDto): Observable<boolean>;
    toggleUserBranchAlert(branchId: string, dto: SaveUserAlertDto): Observable<boolean>;
}

@Injectable()
export class UserProfileClient extends ClientBase implements IUserProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(userId: string): Observable<ApplicationUser> {
        let url_ = this.baseUrl + "/api/portal/userprofile/applicationUser/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationUser>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApplicationUser>(null as any);
    }

    getTimeZones(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/portal/userprofile/timeZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTimeZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processGetTimeZones(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: string; }>(null as any);
    }

    postClaims(body: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/userprofile/claims?";
        if (body !== undefined && body !== null)
            url_ += "body=" + encodeURIComponent("" + body) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPostClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPostClaims(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    put(newSettings: UserAlertNotificationSettings): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/userprofile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newSettings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    postUpdatePassword(accountPassword: AccountPassword): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/userprofile/updatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountPassword);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPostUpdatePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostUpdatePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPostUpdatePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    postAlertNotificationSettings(newSettings: UserAlertNotificationSettings): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/userprofile/userAlertNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newSettings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPostAlertNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAlertNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPostAlertNotificationSettings(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getUserAlertNotificationSettings(id: string): Observable<UserAlertNotificationSettings[]> {
        let url_ = this.baseUrl + "/api/portal/userprofile/userAlertNotificationSettings/userid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserAlertNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAlertNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAlertNotificationSettings[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAlertNotificationSettings[]>;
        }));
    }

    protected processGetUserAlertNotificationSettings(response: HttpResponseBase): Observable<UserAlertNotificationSettings[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAlertNotificationSettings.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAlertNotificationSettings[]>(null as any);
    }

    getUserAlerts(): Observable<GetUserAlertsViewModel> {
        let url_ = this.baseUrl + "/api/portal/userprofile/alerts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserAlertsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserAlertsViewModel>;
        }));
    }

    protected processGetUserAlerts(response: HttpResponseBase): Observable<GetUserAlertsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserAlertsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserAlertsViewModel>(null as any);
    }

    toggleUserAlert(dto: SaveUserAlertDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/userprofile/alerts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processToggleUserAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleUserAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processToggleUserAlert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    toggleAllUserAlert(dto: SaveAllUserAlertDto): Observable<Unit> {
        let url_ = this.baseUrl + "/api/portal/userprofile/alerts/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processToggleAllUserAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleAllUserAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processToggleAllUserAlert(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Unit>(null as any);
    }

    getUserBranchAlerts(subjectId: string | undefined, subjectPath: string | null | undefined, subjectType: SubjectType | undefined): Observable<GetUserBranchAlertsViewModel> {
        let url_ = this.baseUrl + "/api/portal/userprofile/alerts/branch-alerts?";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (subjectPath !== undefined && subjectPath !== null)
            url_ += "subjectPath=" + encodeURIComponent("" + subjectPath) + "&";
        if (subjectType === null)
            throw new Error("The parameter 'subjectType' cannot be null.");
        else if (subjectType !== undefined)
            url_ += "subjectType=" + encodeURIComponent("" + subjectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserBranchAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserBranchAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserBranchAlertsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserBranchAlertsViewModel>;
        }));
    }

    protected processGetUserBranchAlerts(response: HttpResponseBase): Observable<GetUserBranchAlertsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserBranchAlertsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserBranchAlertsViewModel>(null as any);
    }

    toggleAllUserBranchAlert(dto: SaveUserAlertDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/userprofile/alerts/branch-alerts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processToggleAllUserBranchAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleAllUserBranchAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processToggleAllUserBranchAlert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    toggleUserBranchAlert(branchId: string, dto: SaveUserAlertDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/userprofile/alerts/branch-alerts/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processToggleUserBranchAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleUserBranchAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processToggleUserBranchAlert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IAdminBranchClient {
    getList(organizationId: string, subscriptionIds: string[]): Observable<BranchListBulkViewModel>;
}

@Injectable()
export class AdminBranchClient extends ClientBase implements IAdminBranchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(organizationId: string, subscriptionIds: string[]): Observable<BranchListBulkViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/branches";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchListBulkViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchListBulkViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<BranchListBulkViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchListBulkViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchListBulkViewModel>(null as any);
    }
}

export interface IAnalystReportsClient {
    getViewModel(): Observable<GetAnalystReportsViewModel>;
    getProjects(subscriptionServiceId: string): Observable<AnalystReportProjectsViewModel>;
    getMandates(subscriptionServiceId: string): Observable<AnalystReportMandatesViewModel>;
    getReport(subscriptionServiceId: string, options: AnalystReportOptions): Observable<FileResponse>;
}

@Injectable()
export class AnalystReportsClient extends ClientBase implements IAnalystReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getViewModel(): Observable<GetAnalystReportsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/analyst-reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetViewModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViewModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAnalystReportsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAnalystReportsViewModel>;
        }));
    }

    protected processGetViewModel(response: HttpResponseBase): Observable<GetAnalystReportsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnalystReportsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnalystReportsViewModel>(null as any);
    }

    getProjects(subscriptionServiceId: string): Observable<AnalystReportProjectsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/analyst-reports/subscription-services/{subscriptionServiceId}/projects";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnalystReportProjectsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnalystReportProjectsViewModel>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<AnalystReportProjectsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalystReportProjectsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnalystReportProjectsViewModel>(null as any);
    }

    getMandates(subscriptionServiceId: string): Observable<AnalystReportMandatesViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/analyst-reports/subscription-services/{subscriptionServiceId}/mandates";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMandates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMandates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnalystReportMandatesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnalystReportMandatesViewModel>;
        }));
    }

    protected processGetMandates(response: HttpResponseBase): Observable<AnalystReportMandatesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalystReportMandatesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnalystReportMandatesViewModel>(null as any);
    }

    getReport(subscriptionServiceId: string, options: AnalystReportOptions): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/admin/analyst-reports/subscription-services/{subscriptionServiceId}/reports";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IBounceListClient {
    updateBounceList(formFile: FileParameter | null | undefined): Observable<number>;
}

@Injectable()
export class BounceListClient extends ClientBase implements IBounceListClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    updateBounceList(formFile: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/portal/admin/bounce-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateBounceList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBounceList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateBounceList(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

export interface IBranchGroupClient {
    getGroups(organizationId: string, subscriptionId: string, branchGroupSortField: BranchGroupSortingField | undefined, sortingDirection: SortingDirection | undefined, searchText: string | null | undefined, demoMode: boolean | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<BranchGroupListViewModel>;
    add(organizationId: string, subscriptionId: string, branchGroupDto: CommandsBranchGroupDto): Observable<CreateBranchGroupViewModel>;
    get(organizationId: string, subscriptionId: string, branchGroupId: string): Observable<BranchGroupViewModel>;
    delete(organizationId: string, subscriptionId: string, branchGroupId: string): Observable<DeleteBranchGroupViewModel>;
    update(organizationId: string, subscriptionId: string, branchGroupId: string, branchGroupDto: CommandsBranchGroupDto): Observable<UpdateBranchGroupViewModel>;
    getChildren(organizationId: string, subscriptionId: string, branchGroupId: string): Observable<GetBranchGroupChildrenViewModel>;
}

@Injectable()
export class BranchGroupClient extends ClientBase implements IBranchGroupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getGroups(organizationId: string, subscriptionId: string, branchGroupSortField: BranchGroupSortingField | undefined, sortingDirection: SortingDirection | undefined, searchText: string | null | undefined, demoMode: boolean | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<BranchGroupListViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branchGroups?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchGroupSortField === null)
            throw new Error("The parameter 'branchGroupSortField' cannot be null.");
        else if (branchGroupSortField !== undefined)
            url_ += "branchGroupSortField=" + encodeURIComponent("" + branchGroupSortField) + "&";
        if (sortingDirection === null)
            throw new Error("The parameter 'sortingDirection' cannot be null.");
        else if (sortingDirection !== undefined)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (demoMode === null)
            throw new Error("The parameter 'demoMode' cannot be null.");
        else if (demoMode !== undefined)
            url_ += "demoMode=" + encodeURIComponent("" + demoMode) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchGroupListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchGroupListViewModel>;
        }));
    }

    protected processGetGroups(response: HttpResponseBase): Observable<BranchGroupListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchGroupListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchGroupListViewModel>(null as any);
    }

    add(organizationId: string, subscriptionId: string, branchGroupDto: CommandsBranchGroupDto): Observable<CreateBranchGroupViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branchGroups";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(branchGroupDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateBranchGroupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateBranchGroupViewModel>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<CreateBranchGroupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateBranchGroupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateBranchGroupViewModel>(null as any);
    }

    get(organizationId: string, subscriptionId: string, branchGroupId: string): Observable<BranchGroupViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branchGroups/{branchGroupId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchGroupId === undefined || branchGroupId === null)
            throw new Error("The parameter 'branchGroupId' must be defined.");
        url_ = url_.replace("{branchGroupId}", encodeURIComponent("" + branchGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchGroupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchGroupViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BranchGroupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchGroupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchGroupViewModel>(null as any);
    }

    delete(organizationId: string, subscriptionId: string, branchGroupId: string): Observable<DeleteBranchGroupViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branchGroups/{branchGroupId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchGroupId === undefined || branchGroupId === null)
            throw new Error("The parameter 'branchGroupId' must be defined.");
        url_ = url_.replace("{branchGroupId}", encodeURIComponent("" + branchGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteBranchGroupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteBranchGroupViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteBranchGroupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteBranchGroupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteBranchGroupViewModel>(null as any);
    }

    update(organizationId: string, subscriptionId: string, branchGroupId: string, branchGroupDto: CommandsBranchGroupDto): Observable<UpdateBranchGroupViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branchGroups/{branchGroupId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchGroupId === undefined || branchGroupId === null)
            throw new Error("The parameter 'branchGroupId' must be defined.");
        url_ = url_.replace("{branchGroupId}", encodeURIComponent("" + branchGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(branchGroupDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateBranchGroupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateBranchGroupViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateBranchGroupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateBranchGroupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateBranchGroupViewModel>(null as any);
    }

    getChildren(organizationId: string, subscriptionId: string, branchGroupId: string): Observable<GetBranchGroupChildrenViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/branchGroups/{branchGroupId}/children";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (branchGroupId === undefined || branchGroupId === null)
            throw new Error("The parameter 'branchGroupId' must be defined.");
        url_ = url_.replace("{branchGroupId}", encodeURIComponent("" + branchGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChildren(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChildren(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBranchGroupChildrenViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBranchGroupChildrenViewModel>;
        }));
    }

    protected processGetChildren(response: HttpResponseBase): Observable<GetBranchGroupChildrenViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchGroupChildrenViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchGroupChildrenViewModel>(null as any);
    }
}

export interface IOrganizationUserAssignmentClient {
    getList(organizationId: string, excludeUserWithPermission: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortingField: UsersSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, searchText: string | null | undefined): Observable<GetUserAssignmentsViewModel>;
    create(organizationId: string, dto: ManageUserAssignmentByEmailRequest): Observable<void>;
    deleteByEmail(organizationId: string, email: string | null | undefined): Observable<void>;
    export(organizationId: string, excludeUserWithPermission: boolean | undefined, exportType: ExportTableType | undefined, sortingField: UsersSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, searchText: string | null | undefined): Observable<FileResponse>;
    getByEmail(organizationId: string, email: string | null | undefined): Observable<GetUserAssignmentByEmailViewModel>;
    update(organizationId: string, email: string | null | undefined, dto: ManageUserAssignmentByEmailRequest): Observable<void>;
    getUserInformationByEmail(organizationId: string, email: string | null | undefined): Observable<GetUserInformationByUserAssignmentEmailViewModel>;
    getDuplicate(organizationId: string, email: string | null | undefined): Observable<GetUserAssignmentByEmailViewModel>;
    getNew(organizationId: string): Observable<GetUserAssignmentByEmailViewModel>;
    resetPassword(organizationId: string, email: string | null | undefined): Observable<boolean>;
    confirmEmail(organizationId: string, email: string | null | undefined): Observable<boolean>;
    sendInvitationEmail(organizationId: string, email: string | null | undefined): Observable<void>;
    batchImport(organizationId: string, notify: boolean | undefined, options: ManageMultipleUserAssignmentsByEmailRequest): Observable<void>;
    getTemplate(organizationId: string): Observable<FileResponse>;
    partialUpdate(organizationId: string, email: string | null | undefined, dto: PartialUpdateUserPermissionsDto): Observable<void>;
}

@Injectable()
export class OrganizationUserAssignmentClient extends ClientBase implements IOrganizationUserAssignmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(organizationId: string, excludeUserWithPermission: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortingField: UsersSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, searchText: string | null | undefined): Observable<GetUserAssignmentsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (excludeUserWithPermission === null)
            throw new Error("The parameter 'excludeUserWithPermission' cannot be null.");
        else if (excludeUserWithPermission !== undefined)
            url_ += "excludeUserWithPermission=" + encodeURIComponent("" + excludeUserWithPermission) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortingField !== undefined && sortingField !== null)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (sortingDirection !== undefined && sortingDirection !== null)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserAssignmentsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserAssignmentsViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetUserAssignmentsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserAssignmentsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserAssignmentsViewModel>(null as any);
    }

    create(organizationId: string, dto: ManageUserAssignmentByEmailRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    deleteByEmail(organizationId: string, email: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteByEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    export(organizationId: string, excludeUserWithPermission: boolean | undefined, exportType: ExportTableType | undefined, sortingField: UsersSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, searchText: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/export?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (excludeUserWithPermission === null)
            throw new Error("The parameter 'excludeUserWithPermission' cannot be null.");
        else if (excludeUserWithPermission !== undefined)
            url_ += "excludeUserWithPermission=" + encodeURIComponent("" + excludeUserWithPermission) + "&";
        if (exportType === null)
            throw new Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        if (sortingField !== undefined && sortingField !== null)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (sortingDirection !== undefined && sortingDirection !== null)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getByEmail(organizationId: string, email: string | null | undefined): Observable<GetUserAssignmentByEmailViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/by-email?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserAssignmentByEmailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserAssignmentByEmailViewModel>;
        }));
    }

    protected processGetByEmail(response: HttpResponseBase): Observable<GetUserAssignmentByEmailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserAssignmentByEmailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserAssignmentByEmailViewModel>(null as any);
    }

    update(organizationId: string, email: string | null | undefined, dto: ManageUserAssignmentByEmailRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/by-email?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getUserInformationByEmail(organizationId: string, email: string | null | undefined): Observable<GetUserInformationByUserAssignmentEmailViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/by-email/user-information?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserInformationByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInformationByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserInformationByUserAssignmentEmailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserInformationByUserAssignmentEmailViewModel>;
        }));
    }

    protected processGetUserInformationByEmail(response: HttpResponseBase): Observable<GetUserInformationByUserAssignmentEmailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserInformationByUserAssignmentEmailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserInformationByUserAssignmentEmailViewModel>(null as any);
    }

    getDuplicate(organizationId: string, email: string | null | undefined): Observable<GetUserAssignmentByEmailViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/by-email/duplicate?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserAssignmentByEmailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserAssignmentByEmailViewModel>;
        }));
    }

    protected processGetDuplicate(response: HttpResponseBase): Observable<GetUserAssignmentByEmailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserAssignmentByEmailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserAssignmentByEmailViewModel>(null as any);
    }

    getNew(organizationId: string): Observable<GetUserAssignmentByEmailViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/new";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserAssignmentByEmailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserAssignmentByEmailViewModel>;
        }));
    }

    protected processGetNew(response: HttpResponseBase): Observable<GetUserAssignmentByEmailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserAssignmentByEmailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserAssignmentByEmailViewModel>(null as any);
    }

    resetPassword(organizationId: string, email: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/by-email/reset-password?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    confirmEmail(organizationId: string, email: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/by-email/confirm?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    sendInvitationEmail(organizationId: string, email: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/by-email/invitation?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendInvitationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInvitationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendInvitationEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    batchImport(organizationId: string, notify: boolean | undefined, options: ManageMultipleUserAssignmentsByEmailRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/import?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (notify === null)
            throw new Error("The parameter 'notify' cannot be null.");
        else if (notify !== undefined)
            url_ += "notify=" + encodeURIComponent("" + notify) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatchImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getTemplate(organizationId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/template";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    partialUpdate(organizationId: string, email: string | null | undefined, dto: PartialUpdateUserPermissionsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-assignments/fromEmail?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPartialUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartialUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPartialUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IOrganizationUserGroupClient {
    getList(organizationId: string, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined): Observable<GetUserGroupsViewModel>;
    create(organizationId: string, dto: ManageUserGroupByIdRequest): Observable<void>;
    getById(organizationId: string, userGroupId: string): Observable<GetUserGroupByIdViewModel>;
    update(organizationId: string, userGroupId: string, dto: ManageUserGroupByIdRequest): Observable<void>;
    delete(organizationId: string, userGroupId: string): Observable<void>;
    getDuplicate(organizationId: string, userGroupId: string): Observable<GetUserGroupByIdViewModel>;
    getNew(organizationId: string): Observable<GetUserGroupByIdViewModel>;
}

@Injectable()
export class OrganizationUserGroupClient extends ClientBase implements IOrganizationUserGroupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(organizationId: string, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined): Observable<GetUserGroupsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-groups?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserGroupsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserGroupsViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetUserGroupsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserGroupsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserGroupsViewModel>(null as any);
    }

    create(organizationId: string, dto: ManageUserGroupByIdRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-groups";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getById(organizationId: string, userGroupId: string): Observable<GetUserGroupByIdViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-groups/{userGroupId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserGroupByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserGroupByIdViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetUserGroupByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserGroupByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserGroupByIdViewModel>(null as any);
    }

    update(organizationId: string, userGroupId: string, dto: ManageUserGroupByIdRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-groups/{userGroupId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    delete(organizationId: string, userGroupId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-groups/{userGroupId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getDuplicate(organizationId: string, userGroupId: string): Observable<GetUserGroupByIdViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-groups/{userGroupId}/duplicate";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserGroupByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserGroupByIdViewModel>;
        }));
    }

    protected processGetDuplicate(response: HttpResponseBase): Observable<GetUserGroupByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserGroupByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserGroupByIdViewModel>(null as any);
    }

    getNew(organizationId: string): Observable<GetUserGroupByIdViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/user-groups/new";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserGroupByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserGroupByIdViewModel>;
        }));
    }

    protected processGetNew(response: HttpResponseBase): Observable<GetUserGroupByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserGroupByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserGroupByIdViewModel>(null as any);
    }
}

export interface IParticipatingBranchesClient {
    getListPaginated(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined, sortingField: ParticipatingBranchSortingField | undefined, sortingDirection: SortingDirection | undefined, searchText: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<GetParticipatingBranchesViewModel>;
    setEnabled(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined, branchId: string, enabled: boolean | undefined): Observable<boolean>;
    setIncluded(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined, branchId: string, included: boolean | undefined): Observable<boolean>;
    setAllEnabled(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined, enabled: boolean | undefined): Observable<boolean>;
    setAllIncluded(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined, included: boolean | undefined): Observable<boolean>;
    getSummary(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined): Observable<GetParticipatingBranchesSummaryViewModel>;
}

@Injectable()
export class ParticipatingBranchesClient extends ClientBase implements IParticipatingBranchesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getListPaginated(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined, sortingField: ParticipatingBranchSortingField | undefined, sortingDirection: SortingDirection | undefined, searchText: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Observable<GetParticipatingBranchesViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/participating-branches?";
        if (subjectPath === null)
            throw new Error("The parameter 'subjectPath' cannot be null.");
        else if (subjectPath !== undefined)
            url_ += "subjectPath=" + encodeURIComponent("" + subjectPath) + "&";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (subjectType === null)
            throw new Error("The parameter 'subjectType' cannot be null.");
        else if (subjectType !== undefined)
            url_ += "subjectType=" + encodeURIComponent("" + subjectType) + "&";
        if (sortingField === null)
            throw new Error("The parameter 'sortingField' cannot be null.");
        else if (sortingField !== undefined)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (sortingDirection === null)
            throw new Error("The parameter 'sortingDirection' cannot be null.");
        else if (sortingDirection !== undefined)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetParticipatingBranchesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetParticipatingBranchesViewModel>;
        }));
    }

    protected processGetListPaginated(response: HttpResponseBase): Observable<GetParticipatingBranchesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetParticipatingBranchesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetParticipatingBranchesViewModel>(null as any);
    }

    setEnabled(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined, branchId: string, enabled: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/participating-branches/{branchId}/set-enabled?";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (subjectPath === null)
            throw new Error("The parameter 'subjectPath' cannot be null.");
        else if (subjectPath !== undefined)
            url_ += "subjectPath=" + encodeURIComponent("" + subjectPath) + "&";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (subjectType === null)
            throw new Error("The parameter 'subjectType' cannot be null.");
        else if (subjectType !== undefined)
            url_ += "subjectType=" + encodeURIComponent("" + subjectType) + "&";
        if (enabled === null)
            throw new Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    setIncluded(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined, branchId: string, included: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/participating-branches/{branchId}/set-included?";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        if (subjectPath === null)
            throw new Error("The parameter 'subjectPath' cannot be null.");
        else if (subjectPath !== undefined)
            url_ += "subjectPath=" + encodeURIComponent("" + subjectPath) + "&";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (subjectType === null)
            throw new Error("The parameter 'subjectType' cannot be null.");
        else if (subjectType !== undefined)
            url_ += "subjectType=" + encodeURIComponent("" + subjectType) + "&";
        if (included === null)
            throw new Error("The parameter 'included' cannot be null.");
        else if (included !== undefined)
            url_ += "included=" + encodeURIComponent("" + included) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetIncluded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIncluded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetIncluded(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    setAllEnabled(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined, enabled: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/participating-branches/set-all-enabled?";
        if (subjectPath === null)
            throw new Error("The parameter 'subjectPath' cannot be null.");
        else if (subjectPath !== undefined)
            url_ += "subjectPath=" + encodeURIComponent("" + subjectPath) + "&";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (subjectType === null)
            throw new Error("The parameter 'subjectType' cannot be null.");
        else if (subjectType !== undefined)
            url_ += "subjectType=" + encodeURIComponent("" + subjectType) + "&";
        if (enabled === null)
            throw new Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetAllEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetAllEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    setAllIncluded(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined, included: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/participating-branches/set-all-included?";
        if (subjectPath === null)
            throw new Error("The parameter 'subjectPath' cannot be null.");
        else if (subjectPath !== undefined)
            url_ += "subjectPath=" + encodeURIComponent("" + subjectPath) + "&";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (subjectType === null)
            throw new Error("The parameter 'subjectType' cannot be null.");
        else if (subjectType !== undefined)
            url_ += "subjectType=" + encodeURIComponent("" + subjectType) + "&";
        if (included === null)
            throw new Error("The parameter 'included' cannot be null.");
        else if (included !== undefined)
            url_ += "included=" + encodeURIComponent("" + included) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetAllIncluded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllIncluded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetAllIncluded(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getSummary(subjectPath: string | undefined, subjectId: string | undefined, subjectType: SubjectType | undefined): Observable<GetParticipatingBranchesSummaryViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/participating-branches/summary?";
        if (subjectPath === null)
            throw new Error("The parameter 'subjectPath' cannot be null.");
        else if (subjectPath !== undefined)
            url_ += "subjectPath=" + encodeURIComponent("" + subjectPath) + "&";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (subjectType === null)
            throw new Error("The parameter 'subjectType' cannot be null.");
        else if (subjectType !== undefined)
            url_ += "subjectType=" + encodeURIComponent("" + subjectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetParticipatingBranchesSummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetParticipatingBranchesSummaryViewModel>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<GetParticipatingBranchesSummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetParticipatingBranchesSummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetParticipatingBranchesSummaryViewModel>(null as any);
    }
}

export interface IPermissionClient {
    getList(organizationId: string): Observable<HierarchyRoleType>;
    getListForBranches(organizationId: string): Observable<BranchRoleType>;
    getPermissionOptions(organizationId: string): Observable<PermissionTreeOptionsViewModel>;
    getPermissionOptionsBySubscription(subscriptionId: string, organizationId: string): Observable<PermissionTreeOptionsBySubscriptionViewModel>;
}

@Injectable()
export class PermissionClient extends ClientBase implements IPermissionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(organizationId: string): Observable<HierarchyRoleType> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/roletypes";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HierarchyRoleType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HierarchyRoleType>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<HierarchyRoleType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HierarchyRoleType>(null as any);
    }

    getListForBranches(organizationId: string): Observable<BranchRoleType> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/branchroletypes";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListForBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForBranches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchRoleType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchRoleType>;
        }));
    }

    protected processGetListForBranches(response: HttpResponseBase): Observable<BranchRoleType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchRoleType>(null as any);
    }

    getPermissionOptions(organizationId: string): Observable<PermissionTreeOptionsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/options";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPermissionOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionTreeOptionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionTreeOptionsViewModel>;
        }));
    }

    protected processGetPermissionOptions(response: HttpResponseBase): Observable<PermissionTreeOptionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionTreeOptionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionTreeOptionsViewModel>(null as any);
    }

    getPermissionOptionsBySubscription(subscriptionId: string, organizationId: string): Observable<PermissionTreeOptionsBySubscriptionViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/options";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPermissionOptionsBySubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissionOptionsBySubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionTreeOptionsBySubscriptionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionTreeOptionsBySubscriptionViewModel>;
        }));
    }

    protected processGetPermissionOptionsBySubscription(response: HttpResponseBase): Observable<PermissionTreeOptionsBySubscriptionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionTreeOptionsBySubscriptionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionTreeOptionsBySubscriptionViewModel>(null as any);
    }
}

export interface ISubscriptionManagerClient {
    getViewModel(): Observable<GetSubscriptionManagerViewModel>;
    getCorporateClients(): Observable<GetCorporateClientsViewModel>;
    getSubscriptionLogo(subscriptionId: string): Observable<SubscriptionLogosViewModel>;
    updateSubscriptionLogo(subscriptionId: string, formFile: FileParameter | null | undefined): Observable<string>;
    addSubscription(organizationId: string | undefined, name: string | null | undefined): Observable<boolean>;
    addMysteryShopperSubscriptionService(subscriptionId: string, corporateClientId: number | undefined): Observable<boolean>;
}

@Injectable()
export class SubscriptionManagerClient extends ClientBase implements ISubscriptionManagerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getViewModel(): Observable<GetSubscriptionManagerViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/subscription-manager";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetViewModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetViewModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionManagerViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionManagerViewModel>;
        }));
    }

    protected processGetViewModel(response: HttpResponseBase): Observable<GetSubscriptionManagerViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionManagerViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionManagerViewModel>(null as any);
    }

    getCorporateClients(): Observable<GetCorporateClientsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/subscription-manager/corporate-clients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCorporateClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorporateClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCorporateClientsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCorporateClientsViewModel>;
        }));
    }

    protected processGetCorporateClients(response: HttpResponseBase): Observable<GetCorporateClientsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCorporateClientsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCorporateClientsViewModel>(null as any);
    }

    getSubscriptionLogo(subscriptionId: string): Observable<SubscriptionLogosViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/subscription-manager/subscription/{subscriptionId}/logo";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubscriptionLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionLogosViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionLogosViewModel>;
        }));
    }

    protected processGetSubscriptionLogo(response: HttpResponseBase): Observable<SubscriptionLogosViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionLogosViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionLogosViewModel>(null as any);
    }

    updateSubscriptionLogo(subscriptionId: string, formFile: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/subscription-manager/subscription/{subscriptionId}/logo";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSubscriptionLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscriptionLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateSubscriptionLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    addSubscription(organizationId: string | undefined, name: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/subscription-manager/subscription?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddSubscription(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    addMysteryShopperSubscriptionService(subscriptionId: string, corporateClientId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/subscription-manager/subscription/{subscriptionId}/subscription-service?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (corporateClientId === null)
            throw new Error("The parameter 'corporateClientId' cannot be null.");
        else if (corporateClientId !== undefined)
            url_ += "corporateClientId=" + encodeURIComponent("" + corporateClientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddMysteryShopperSubscriptionService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMysteryShopperSubscriptionService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddMysteryShopperSubscriptionService(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface ISubscriptionUserAssignmentClient {
    getList(organizationId: string, subscriptionId: string, excludeUserWithPermission: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortingField: UsersSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, searchText: string | null | undefined): Observable<GetUserAssignmentsViewModel>;
    deleteByEmail(organizationId: string, subscriptionId: string, email: string | undefined): Observable<void>;
    export(organizationId: string, subscriptionId: string, excludeUserWithPermission: boolean | undefined, exportType: ExportTableType | undefined, sortingField: UsersSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, searchText: string | null | undefined): Observable<FileResponse>;
    sendInvitationEmail(organizationId: string, subscriptionId: string, email: string | undefined): Observable<void>;
    getByEmail(organizationId: string, subscriptionId: string, email: string | undefined): Observable<GetUserAssignmentByEmailViewModel>;
    update(organizationId: string, subscriptionId: string, email: string | undefined, dto: ManageUserAssignmentByEmailRequest): Observable<void>;
    partialUpdate(organizationId: string, subscriptionId: string, email: string | undefined, dto: PartialUpdateUserPermissionsDto): Observable<void>;
    getUserInformationByEmail(organizationId: string, subscriptionId: string, email: string | undefined): Observable<GetUserInformationByUserAssignmentEmailViewModel>;
    getDuplicate(organizationId: string, subscriptionId: string, email: string | undefined): Observable<GetUserAssignmentByEmailViewModel>;
    getNew(organizationId: string, subscriptionId: string): Observable<GetUserAssignmentByEmailViewModel>;
    create(organizationId: string, subscriptionId: string, dto: ManageUserAssignmentByEmailRequest): Observable<void>;
    resetPassword(organizationId: string, subscriptionId: string, email: string | undefined): Observable<boolean>;
    confirmEmail(organizationId: string, subscriptionId: string, email: string | undefined): Observable<boolean>;
    batchImport(organizationId: string, subscriptionId: string, notify: boolean | undefined, options: ManageMultipleUserAssignmentsByEmailRequest): Observable<void>;
    getTemplate(organizationId: string, subscriptionId: string): Observable<FileResponse>;
}

@Injectable()
export class SubscriptionUserAssignmentClient extends ClientBase implements ISubscriptionUserAssignmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(organizationId: string, subscriptionId: string, excludeUserWithPermission: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined, sortingField: UsersSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, searchText: string | null | undefined): Observable<GetUserAssignmentsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (excludeUserWithPermission === null)
            throw new Error("The parameter 'excludeUserWithPermission' cannot be null.");
        else if (excludeUserWithPermission !== undefined)
            url_ += "excludeUserWithPermission=" + encodeURIComponent("" + excludeUserWithPermission) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortingField !== undefined && sortingField !== null)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (sortingDirection !== undefined && sortingDirection !== null)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserAssignmentsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserAssignmentsViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetUserAssignmentsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserAssignmentsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserAssignmentsViewModel>(null as any);
    }

    deleteByEmail(organizationId: string, subscriptionId: string, email: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteByEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    export(organizationId: string, subscriptionId: string, excludeUserWithPermission: boolean | undefined, exportType: ExportTableType | undefined, sortingField: UsersSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, searchText: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/export?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (excludeUserWithPermission === null)
            throw new Error("The parameter 'excludeUserWithPermission' cannot be null.");
        else if (excludeUserWithPermission !== undefined)
            url_ += "excludeUserWithPermission=" + encodeURIComponent("" + excludeUserWithPermission) + "&";
        if (exportType === null)
            throw new Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        if (sortingField !== undefined && sortingField !== null)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (sortingDirection !== undefined && sortingDirection !== null)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    sendInvitationEmail(organizationId: string, subscriptionId: string, email: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/by-email/invitation?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendInvitationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInvitationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendInvitationEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getByEmail(organizationId: string, subscriptionId: string, email: string | undefined): Observable<GetUserAssignmentByEmailViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/by-email?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserAssignmentByEmailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserAssignmentByEmailViewModel>;
        }));
    }

    protected processGetByEmail(response: HttpResponseBase): Observable<GetUserAssignmentByEmailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserAssignmentByEmailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserAssignmentByEmailViewModel>(null as any);
    }

    update(organizationId: string, subscriptionId: string, email: string | undefined, dto: ManageUserAssignmentByEmailRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/by-email?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    partialUpdate(organizationId: string, subscriptionId: string, email: string | undefined, dto: PartialUpdateUserPermissionsDto): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/by-email?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPartialUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartialUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPartialUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getUserInformationByEmail(organizationId: string, subscriptionId: string, email: string | undefined): Observable<GetUserInformationByUserAssignmentEmailViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/by-email/user-information?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserInformationByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInformationByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserInformationByUserAssignmentEmailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserInformationByUserAssignmentEmailViewModel>;
        }));
    }

    protected processGetUserInformationByEmail(response: HttpResponseBase): Observable<GetUserInformationByUserAssignmentEmailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserInformationByUserAssignmentEmailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserInformationByUserAssignmentEmailViewModel>(null as any);
    }

    getDuplicate(organizationId: string, subscriptionId: string, email: string | undefined): Observable<GetUserAssignmentByEmailViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/by-email/duplicate?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserAssignmentByEmailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserAssignmentByEmailViewModel>;
        }));
    }

    protected processGetDuplicate(response: HttpResponseBase): Observable<GetUserAssignmentByEmailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserAssignmentByEmailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserAssignmentByEmailViewModel>(null as any);
    }

    getNew(organizationId: string, subscriptionId: string): Observable<GetUserAssignmentByEmailViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/new";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserAssignmentByEmailViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserAssignmentByEmailViewModel>;
        }));
    }

    protected processGetNew(response: HttpResponseBase): Observable<GetUserAssignmentByEmailViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserAssignmentByEmailViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserAssignmentByEmailViewModel>(null as any);
    }

    create(organizationId: string, subscriptionId: string, dto: ManageUserAssignmentByEmailRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/new";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    resetPassword(organizationId: string, subscriptionId: string, email: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/by-email/reset-password?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    confirmEmail(organizationId: string, subscriptionId: string, email: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/by-email/confirm?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    batchImport(organizationId: string, subscriptionId: string, notify: boolean | undefined, options: ManageMultipleUserAssignmentsByEmailRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/import?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (notify === null)
            throw new Error("The parameter 'notify' cannot be null.");
        else if (notify !== undefined)
            url_ += "notify=" + encodeURIComponent("" + notify) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatchImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getTemplate(organizationId: string, subscriptionId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-assignments/template";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ISubscriptionUserGroupClient {
    getList(organizationId: string, subscriptionId: string, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined): Observable<GetUserGroupsViewModel>;
    create(organizationId: string, subscriptionId: string, dto: ManageUserGroupByIdRequest): Observable<void>;
    getById(organizationId: string, subscriptionId: string, userGroupId: string): Observable<GetUserGroupByIdViewModel>;
    update(organizationId: string, subscriptionId: string, userGroupId: string, dto: ManageUserGroupByIdRequest): Observable<void>;
    delete(organizationId: string, subscriptionId: string, userGroupId: string): Observable<void>;
    getDuplicate(organizationId: string, subscriptionId: string, userGroupId: string): Observable<GetUserGroupByIdViewModel>;
    getNew(organizationId: string, subscriptionId: string): Observable<GetUserGroupByIdViewModel>;
}

@Injectable()
export class SubscriptionUserGroupClient extends ClientBase implements ISubscriptionUserGroupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(organizationId: string, subscriptionId: string, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined): Observable<GetUserGroupsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-groups?";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserGroupsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserGroupsViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetUserGroupsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserGroupsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserGroupsViewModel>(null as any);
    }

    create(organizationId: string, subscriptionId: string, dto: ManageUserGroupByIdRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-groups";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getById(organizationId: string, subscriptionId: string, userGroupId: string): Observable<GetUserGroupByIdViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-groups/{userGroupId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserGroupByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserGroupByIdViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetUserGroupByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserGroupByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserGroupByIdViewModel>(null as any);
    }

    update(organizationId: string, subscriptionId: string, userGroupId: string, dto: ManageUserGroupByIdRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-groups/{userGroupId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    delete(organizationId: string, subscriptionId: string, userGroupId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-groups/{userGroupId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getDuplicate(organizationId: string, subscriptionId: string, userGroupId: string): Observable<GetUserGroupByIdViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-groups/{userGroupId}/duplicate";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserGroupByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserGroupByIdViewModel>;
        }));
    }

    protected processGetDuplicate(response: HttpResponseBase): Observable<GetUserGroupByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserGroupByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserGroupByIdViewModel>(null as any);
    }

    getNew(organizationId: string, subscriptionId: string): Observable<GetUserGroupByIdViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/{organizationId}/subscriptions/{subscriptionId}/user-groups/new";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserGroupByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserGroupByIdViewModel>;
        }));
    }

    protected processGetNew(response: HttpResponseBase): Observable<GetUserGroupByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserGroupByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserGroupByIdViewModel>(null as any);
    }
}

export interface ISurveyQuestionClient {
    getSurveyQuestions(pageNumber: number | undefined, pageSize: number | undefined): Observable<GetSurveyQuestionsViewModel>;
    upsertSurveyQuestion(dto: UpsertSurveyQuestionDto): Observable<string>;
    getSurveyQuestion(surveyQuestionId: string): Observable<GetSurveyQuestionViewModel>;
    searchForSurveyQuestions(searchString: string | null | undefined): Observable<SearchForSurveyQuestionsViewModel>;
    upsertSurveyQuestionTag(surveyQuestionId: string, dto: SurveyQuestionTagDto): Observable<SurveyQuestionTagDto>;
    removeTag(surveyQuestionId: string, surveyQuestionTagId: string): Observable<boolean>;
}

@Injectable()
export class SurveyQuestionClient extends ClientBase implements ISurveyQuestionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getSurveyQuestions(pageNumber: number | undefined, pageSize: number | undefined): Observable<GetSurveyQuestionsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/survey-questions?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyQuestionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyQuestionsViewModel>;
        }));
    }

    protected processGetSurveyQuestions(response: HttpResponseBase): Observable<GetSurveyQuestionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyQuestionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyQuestionsViewModel>(null as any);
    }

    upsertSurveyQuestion(dto: UpsertSurveyQuestionDto): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/survey-questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpsertSurveyQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertSurveyQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpsertSurveyQuestion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getSurveyQuestion(surveyQuestionId: string): Observable<GetSurveyQuestionViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/survey-questions/{surveyQuestionId}";
        if (surveyQuestionId === undefined || surveyQuestionId === null)
            throw new Error("The parameter 'surveyQuestionId' must be defined.");
        url_ = url_.replace("{surveyQuestionId}", encodeURIComponent("" + surveyQuestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyQuestionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyQuestionViewModel>;
        }));
    }

    protected processGetSurveyQuestion(response: HttpResponseBase): Observable<GetSurveyQuestionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyQuestionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyQuestionViewModel>(null as any);
    }

    searchForSurveyQuestions(searchString: string | null | undefined): Observable<SearchForSurveyQuestionsViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/survey-questions/search?";
        if (searchString !== undefined && searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchForSurveyQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchForSurveyQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchForSurveyQuestionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchForSurveyQuestionsViewModel>;
        }));
    }

    protected processSearchForSurveyQuestions(response: HttpResponseBase): Observable<SearchForSurveyQuestionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchForSurveyQuestionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchForSurveyQuestionsViewModel>(null as any);
    }

    upsertSurveyQuestionTag(surveyQuestionId: string, dto: SurveyQuestionTagDto): Observable<SurveyQuestionTagDto> {
        let url_ = this.baseUrl + "/api/portal/admin/survey-questions/{surveyQuestionId}/tags";
        if (surveyQuestionId === undefined || surveyQuestionId === null)
            throw new Error("The parameter 'surveyQuestionId' must be defined.");
        url_ = url_.replace("{surveyQuestionId}", encodeURIComponent("" + surveyQuestionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpsertSurveyQuestionTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertSurveyQuestionTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestionTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestionTagDto>;
        }));
    }

    protected processUpsertSurveyQuestionTag(response: HttpResponseBase): Observable<SurveyQuestionTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestionTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SurveyQuestionTagDto>(null as any);
    }

    removeTag(surveyQuestionId: string, surveyQuestionTagId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/survey-questions/{surveyQuestionId}/tags/{surveyQuestionTagId}";
        if (surveyQuestionId === undefined || surveyQuestionId === null)
            throw new Error("The parameter 'surveyQuestionId' must be defined.");
        url_ = url_.replace("{surveyQuestionId}", encodeURIComponent("" + surveyQuestionId));
        if (surveyQuestionTagId === undefined || surveyQuestionTagId === null)
            throw new Error("The parameter 'surveyQuestionTagId' must be defined.");
        url_ = url_.replace("{surveyQuestionTagId}", encodeURIComponent("" + surveyQuestionTagId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRemoveTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemoveTag(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface ISystemClient {
    getCountries(): Observable<CountriesViewModel>;
    getSocialMedias(): Observable<SocialMediasViewModel>;
}

@Injectable()
export class SystemClient extends ClientBase implements ISystemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getCountries(): Observable<CountriesViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/system/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountriesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountriesViewModel>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<CountriesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountriesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountriesViewModel>(null as any);
    }

    getSocialMedias(): Observable<SocialMediasViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/system/socials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSocialMedias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSocialMedias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialMediasViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialMediasViewModel>;
        }));
    }

    protected processGetSocialMedias(response: HttpResponseBase): Observable<SocialMediasViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialMediasViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialMediasViewModel>(null as any);
    }
}

export interface ISystemNotificationsClient {
    getListPaginated(sortingField: SystemNotificationSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, searchText: string | null | undefined): Observable<SystemNotificationPageViewModel>;
    insert(dto: SystemNotificationDto): Observable<string>;
    get(notificationId: string): Observable<GetSystemNotificationByIdViewModel>;
    update(notificationId: string, dto: SystemNotificationDto): Observable<string>;
    delete(notificationId: string): Observable<boolean>;
}

@Injectable()
export class SystemNotificationsClient extends ClientBase implements ISystemNotificationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getListPaginated(sortingField: SystemNotificationSortingField | null | undefined, sortingDirection: SortingDirection | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined, searchText: string | null | undefined): Observable<SystemNotificationPageViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/system-notifications?";
        if (sortingField !== undefined && sortingField !== null)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        if (sortingDirection !== undefined && sortingDirection !== null)
            url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemNotificationPageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemNotificationPageViewModel>;
        }));
    }

    protected processGetListPaginated(response: HttpResponseBase): Observable<SystemNotificationPageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemNotificationPageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemNotificationPageViewModel>(null as any);
    }

    insert(dto: SystemNotificationDto): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/system-notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    get(notificationId: string): Observable<GetSystemNotificationByIdViewModel> {
        let url_ = this.baseUrl + "/api/portal/admin/system-notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSystemNotificationByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSystemNotificationByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetSystemNotificationByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSystemNotificationByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSystemNotificationByIdViewModel>(null as any);
    }

    update(notificationId: string, dto: SystemNotificationDto): Observable<string> {
        let url_ = this.baseUrl + "/api/portal/admin/system-notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    delete(notificationId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/portal/admin/system-notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IAlertClient {
    post(subscriptionServiceId: string, projectId: string, alertStatusHistoryDto: AlertStatusHistoryDto): Observable<AlertStatusHistoryModel>;
    getAlert(subscriptionServiceId: string, projectId: string, surveyAnswerId: string, lang: string): Observable<AlertDetailModel>;
    forwardAlert(subscriptionServiceId: string, projectId: string, alertForward: AlertForward): Observable<AlertStatusHistoryModel>;
}

@Injectable()
export class AlertClient extends ClientBase implements IAlertClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    post(subscriptionServiceId: string, projectId: string, alertStatusHistoryDto: AlertStatusHistoryDto): Observable<AlertStatusHistoryModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/alerts";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alertStatusHistoryDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertStatusHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertStatusHistoryModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<AlertStatusHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertStatusHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlertStatusHistoryModel>(null as any);
    }

    getAlert(subscriptionServiceId: string, projectId: string, surveyAnswerId: string, lang: string): Observable<AlertDetailModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/alerts/{surveyAnswerId}/{lang}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (surveyAnswerId === undefined || surveyAnswerId === null)
            throw new Error("The parameter 'surveyAnswerId' must be defined.");
        url_ = url_.replace("{surveyAnswerId}", encodeURIComponent("" + surveyAnswerId));
        if (lang === undefined || lang === null)
            throw new Error("The parameter 'lang' must be defined.");
        url_ = url_.replace("{lang}", encodeURIComponent("" + lang));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDetailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDetailModel>;
        }));
    }

    protected processGetAlert(response: HttpResponseBase): Observable<AlertDetailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDetailModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlertDetailModel>(null as any);
    }

    forwardAlert(subscriptionServiceId: string, projectId: string, alertForward: AlertForward): Observable<AlertStatusHistoryModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/alerts/forward";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alertForward);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processForwardAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForwardAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertStatusHistoryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertStatusHistoryModel>;
        }));
    }

    protected processForwardAlert(response: HttpResponseBase): Observable<AlertStatusHistoryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertStatusHistoryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlertStatusHistoryModel>(null as any);
    }
}

export interface ICustomImportAdminClient {
    getCustomImportCount(startDate: Date | undefined, endDate: Date | undefined): Observable<CustomImportEntryCountViewModel>;
}

@Injectable()
export class CustomImportAdminClient extends ClientBase implements ICustomImportAdminClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getCustomImportCount(startDate: Date | undefined, endDate: Date | undefined): Observable<CustomImportEntryCountViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/customImport/count?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomImportCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomImportCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomImportEntryCountViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomImportEntryCountViewModel>;
        }));
    }

    protected processGetCustomImportCount(response: HttpResponseBase): Observable<CustomImportEntryCountViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomImportEntryCountViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomImportEntryCountViewModel>(null as any);
    }
}

export interface ICustomImportClient {
    getInputJsonForm(customImportConfigId: string | undefined, subscriptionServiceId: string): Observable<string>;
    resetCustomImportFunctions(customImportConfigId: string | undefined, subscriptionServiceId: string): Observable<ResetCustomImportFunctionsViewModel>;
    getFiles(customImportConfigurationId: string | undefined, subscriptionServiceId: string): Observable<CustomImportFilesViewModel>;
}

@Injectable()
export class CustomImportClient extends ClientBase implements ICustomImportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getInputJsonForm(customImportConfigId: string | undefined, subscriptionServiceId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/customImport/GetInputJsonForm?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (customImportConfigId === null)
            throw new Error("The parameter 'customImportConfigId' cannot be null.");
        else if (customImportConfigId !== undefined)
            url_ += "customImportConfigId=" + encodeURIComponent("" + customImportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInputJsonForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInputJsonForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetInputJsonForm(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    resetCustomImportFunctions(customImportConfigId: string | undefined, subscriptionServiceId: string): Observable<ResetCustomImportFunctionsViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/customImport/reset?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (customImportConfigId === null)
            throw new Error("The parameter 'customImportConfigId' cannot be null.");
        else if (customImportConfigId !== undefined)
            url_ += "customImportConfigId=" + encodeURIComponent("" + customImportConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResetCustomImportFunctions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetCustomImportFunctions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetCustomImportFunctionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetCustomImportFunctionsViewModel>;
        }));
    }

    protected processResetCustomImportFunctions(response: HttpResponseBase): Observable<ResetCustomImportFunctionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetCustomImportFunctionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetCustomImportFunctionsViewModel>(null as any);
    }

    getFiles(customImportConfigurationId: string | undefined, subscriptionServiceId: string): Observable<CustomImportFilesViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/customImport/Files?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (customImportConfigurationId === null)
            throw new Error("The parameter 'customImportConfigurationId' cannot be null.");
        else if (customImportConfigurationId !== undefined)
            url_ += "CustomImportConfigurationId=" + encodeURIComponent("" + customImportConfigurationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomImportFilesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomImportFilesViewModel>;
        }));
    }

    protected processGetFiles(response: HttpResponseBase): Observable<CustomImportFilesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomImportFilesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomImportFilesViewModel>(null as any);
    }
}

export interface ICustomImportProjectClient {
    getCustomImportCount(projectId: string, startDate: Date | undefined, endDate: Date | undefined, subscriptionServiceId: string): Observable<CustomImportEntryCountByProjectViewModel>;
    resendCustomImportEntriesInDateRange(projectId: string, startDate: Date | undefined, endDate: Date | undefined, subscriptionServiceId: string): Observable<ResendCustomImportEntryViewModel>;
}

@Injectable()
export class CustomImportProjectClient extends ClientBase implements ICustomImportProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getCustomImportCount(projectId: string, startDate: Date | undefined, endDate: Date | undefined, subscriptionServiceId: string): Observable<CustomImportEntryCountByProjectViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/customImport/count?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomImportCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomImportCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomImportEntryCountByProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomImportEntryCountByProjectViewModel>;
        }));
    }

    protected processGetCustomImportCount(response: HttpResponseBase): Observable<CustomImportEntryCountByProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomImportEntryCountByProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomImportEntryCountByProjectViewModel>(null as any);
    }

    resendCustomImportEntriesInDateRange(projectId: string, startDate: Date | undefined, endDate: Date | undefined, subscriptionServiceId: string): Observable<ResendCustomImportEntryViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/customImport/resend?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResendCustomImportEntriesInDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendCustomImportEntriesInDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResendCustomImportEntryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResendCustomImportEntryViewModel>;
        }));
    }

    protected processResendCustomImportEntriesInDateRange(response: HttpResponseBase): Observable<ResendCustomImportEntryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResendCustomImportEntryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResendCustomImportEntryViewModel>(null as any);
    }
}

export interface ICxRayClient {
    getOverview(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<GetOverviewResponse>;
    getSatisfactionRate(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<GetSatisfactionRateResponse>;
    getTrendsOverTime(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<GetSentimentTrendsResponse>;
    getTop5Comments(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<Top5CommentsResponse>;
    getStrengthsAndWeaknesses(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<StrengthsAndWeaknessesResponse>;
    getSentimentTrends(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<GetSentimentTrendsResponse>;
    getSentimentsByCategory(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<SentimentsByCategoryResponse>;
    getPromoterComments(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<RecommendationCommentsResponse>;
    getDetractorComments(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<RecommendationCommentsResponse>;
    getSummary(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<GetSummaryResponse>;
    getAnalysisTopics(subscriptionServiceId: string, projectId: string, showRaw: boolean | undefined, minimum: number | undefined, filterViewModel: FilterViewModel | undefined): Observable<AnalysisTopicsResponse>;
    getResults(subscriptionServiceId: string, projectId: string, showCommentsOnly: boolean | undefined, filterViewModel: FilterViewModel | undefined): Observable<GetResultsResponse>;
}

@Injectable()
export class CxRayClient extends ClientBase implements ICxRayClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getOverview(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<GetOverviewResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/overview";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOverviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOverviewResponse>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<GetOverviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOverviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOverviewResponse>(null as any);
    }

    getSatisfactionRate(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<GetSatisfactionRateResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/widgets/satisfaction-rate";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSatisfactionRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSatisfactionRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSatisfactionRateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSatisfactionRateResponse>;
        }));
    }

    protected processGetSatisfactionRate(response: HttpResponseBase): Observable<GetSatisfactionRateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSatisfactionRateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSatisfactionRateResponse>(null as any);
    }

    getTrendsOverTime(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<GetSentimentTrendsResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/widgets/trends-over-time";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTrendsOverTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrendsOverTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSentimentTrendsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSentimentTrendsResponse>;
        }));
    }

    protected processGetTrendsOverTime(response: HttpResponseBase): Observable<GetSentimentTrendsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSentimentTrendsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSentimentTrendsResponse>(null as any);
    }

    getTop5Comments(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<Top5CommentsResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/widgets/top5";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTop5Comments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTop5Comments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Top5CommentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Top5CommentsResponse>;
        }));
    }

    protected processGetTop5Comments(response: HttpResponseBase): Observable<Top5CommentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Top5CommentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Top5CommentsResponse>(null as any);
    }

    getStrengthsAndWeaknesses(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<StrengthsAndWeaknessesResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/widgets/strengths-weakness";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetStrengthsAndWeaknesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStrengthsAndWeaknesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StrengthsAndWeaknessesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StrengthsAndWeaknessesResponse>;
        }));
    }

    protected processGetStrengthsAndWeaknesses(response: HttpResponseBase): Observable<StrengthsAndWeaknessesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StrengthsAndWeaknessesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StrengthsAndWeaknessesResponse>(null as any);
    }

    getSentimentTrends(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<GetSentimentTrendsResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/widgets/sentiment-trends";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSentimentTrends(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSentimentTrends(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSentimentTrendsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSentimentTrendsResponse>;
        }));
    }

    protected processGetSentimentTrends(response: HttpResponseBase): Observable<GetSentimentTrendsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSentimentTrendsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSentimentTrendsResponse>(null as any);
    }

    getSentimentsByCategory(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<SentimentsByCategoryResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/widgets/sentiments-by-category";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSentimentsByCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSentimentsByCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SentimentsByCategoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SentimentsByCategoryResponse>;
        }));
    }

    protected processGetSentimentsByCategory(response: HttpResponseBase): Observable<SentimentsByCategoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SentimentsByCategoryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SentimentsByCategoryResponse>(null as any);
    }

    getPromoterComments(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<RecommendationCommentsResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/widgets/promoter-comments";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPromoterComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromoterComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecommendationCommentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecommendationCommentsResponse>;
        }));
    }

    protected processGetPromoterComments(response: HttpResponseBase): Observable<RecommendationCommentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecommendationCommentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecommendationCommentsResponse>(null as any);
    }

    getDetractorComments(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<RecommendationCommentsResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/widgets/detractor-comments";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetractorComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetractorComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecommendationCommentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecommendationCommentsResponse>;
        }));
    }

    protected processGetDetractorComments(response: HttpResponseBase): Observable<RecommendationCommentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecommendationCommentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecommendationCommentsResponse>(null as any);
    }

    getSummary(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel | undefined): Observable<GetSummaryResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/summary";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSummaryResponse>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<GetSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSummaryResponse>(null as any);
    }

    getAnalysisTopics(subscriptionServiceId: string, projectId: string, showRaw: boolean | undefined, minimum: number | undefined, filterViewModel: FilterViewModel | undefined): Observable<AnalysisTopicsResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/topics?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (showRaw === null)
            throw new Error("The parameter 'showRaw' cannot be null.");
        else if (showRaw !== undefined)
            url_ += "showRaw=" + encodeURIComponent("" + showRaw) + "&";
        if (minimum === null)
            throw new Error("The parameter 'minimum' cannot be null.");
        else if (minimum !== undefined)
            url_ += "minimum=" + encodeURIComponent("" + minimum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAnalysisTopics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnalysisTopics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnalysisTopicsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnalysisTopicsResponse>;
        }));
    }

    protected processGetAnalysisTopics(response: HttpResponseBase): Observable<AnalysisTopicsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalysisTopicsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnalysisTopicsResponse>(null as any);
    }

    getResults(subscriptionServiceId: string, projectId: string, showCommentsOnly: boolean | undefined, filterViewModel: FilterViewModel | undefined): Observable<GetResultsResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/cxray/results?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (showCommentsOnly === null)
            throw new Error("The parameter 'showCommentsOnly' cannot be null.");
        else if (showCommentsOnly !== undefined)
            url_ += "showCommentsOnly=" + encodeURIComponent("" + showCommentsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResultsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResultsResponse>;
        }));
    }

    protected processGetResults(response: HttpResponseBase): Observable<GetResultsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetResultsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetResultsResponse>(null as any);
    }
}

export interface IDashboardBranchClient {
    get(subscriptionId: string, projectId: string, demoMode: boolean | undefined): Observable<BranchTreeViewModel>;
}

@Injectable()
export class DashboardBranchClient extends ClientBase implements IDashboardBranchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(subscriptionId: string, projectId: string, demoMode: boolean | undefined): Observable<BranchTreeViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionId}/projects/{projectId}/Branches/Tree?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (demoMode === null)
            throw new Error("The parameter 'demoMode' cannot be null.");
        else if (demoMode !== undefined)
            url_ += "demoMode=" + encodeURIComponent("" + demoMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchTreeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchTreeViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BranchTreeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchTreeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchTreeViewModel>(null as any);
    }
}

export interface IDetailsClient {
    getSurveyAnswersDateRange(subscriptionServiceId: string, projectId: string, demoMode: boolean | undefined): Observable<SurveyAnswerDateRangeViewModel>;
    getSummary(subscriptionServiceId: string, projectId: string, filterModel: FilterViewModel): Observable<SummaryViewModel>;
    getSummaryAlerts(subscriptionServiceId: string, projectId: string, filterModel: FilterViewModel): Observable<SummaryAlertsViewModel>;
    getByCountries(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByCountryViewModel>;
    getByProvinces(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByProvinceViewModel>;
    getByLocality(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByLocalityViewModel>;
    getByBranchGroups(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByBranchGroupViewModel>;
    getByBranches(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByBranchViewModel>;
    getByBranchesV2(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByBranchViewModel>;
    getBySurveyAnswers(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<AllDetailedViewModel>;
}

@Injectable()
export class DetailsClient extends ClientBase implements IDetailsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getSurveyAnswersDateRange(subscriptionServiceId: string, projectId: string, demoMode: boolean | undefined): Observable<SurveyAnswerDateRangeViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/details/survey-answers-date-range?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (demoMode === null)
            throw new Error("The parameter 'demoMode' cannot be null.");
        else if (demoMode !== undefined)
            url_ += "demoMode=" + encodeURIComponent("" + demoMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyAnswersDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyAnswersDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyAnswerDateRangeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyAnswerDateRangeViewModel>;
        }));
    }

    protected processGetSurveyAnswersDateRange(response: HttpResponseBase): Observable<SurveyAnswerDateRangeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyAnswerDateRangeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SurveyAnswerDateRangeViewModel>(null as any);
    }

    getSummary(subscriptionServiceId: string, projectId: string, filterModel: FilterViewModel): Observable<SummaryViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/details/summary";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SummaryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SummaryViewModel>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<SummaryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummaryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SummaryViewModel>(null as any);
    }

    getSummaryAlerts(subscriptionServiceId: string, projectId: string, filterModel: FilterViewModel): Observable<SummaryAlertsViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/details/summary-alerts";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSummaryAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummaryAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SummaryAlertsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SummaryAlertsViewModel>;
        }));
    }

    protected processGetSummaryAlerts(response: HttpResponseBase): Observable<SummaryAlertsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummaryAlertsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SummaryAlertsViewModel>(null as any);
    }

    getByCountries(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByCountryViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/details/countries";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailsByCountryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailsByCountryViewModel>;
        }));
    }

    protected processGetByCountries(response: HttpResponseBase): Observable<DetailsByCountryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetailsByCountryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DetailsByCountryViewModel>(null as any);
    }

    getByProvinces(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByProvinceViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/details/provinces";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByProvinces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProvinces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailsByProvinceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailsByProvinceViewModel>;
        }));
    }

    protected processGetByProvinces(response: HttpResponseBase): Observable<DetailsByProvinceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetailsByProvinceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DetailsByProvinceViewModel>(null as any);
    }

    getByLocality(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByLocalityViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/details/localities";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByLocality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByLocality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailsByLocalityViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailsByLocalityViewModel>;
        }));
    }

    protected processGetByLocality(response: HttpResponseBase): Observable<DetailsByLocalityViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetailsByLocalityViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DetailsByLocalityViewModel>(null as any);
    }

    getByBranchGroups(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByBranchGroupViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/details/branch-groups";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByBranchGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByBranchGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailsByBranchGroupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailsByBranchGroupViewModel>;
        }));
    }

    protected processGetByBranchGroups(response: HttpResponseBase): Observable<DetailsByBranchGroupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetailsByBranchGroupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DetailsByBranchGroupViewModel>(null as any);
    }

    getByBranches(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByBranchViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/details/branches";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByBranches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailsByBranchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailsByBranchViewModel>;
        }));
    }

    protected processGetByBranches(response: HttpResponseBase): Observable<DetailsByBranchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetailsByBranchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DetailsByBranchViewModel>(null as any);
    }

    getByBranchesV2(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<DetailsByBranchViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/details/branchesV2";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByBranchesV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByBranchesV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DetailsByBranchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DetailsByBranchViewModel>;
        }));
    }

    protected processGetByBranchesV2(response: HttpResponseBase): Observable<DetailsByBranchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DetailsByBranchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DetailsByBranchViewModel>(null as any);
    }

    getBySurveyAnswers(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<AllDetailedViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/details/survey-answers";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBySurveyAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySurveyAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllDetailedViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllDetailedViewModel>;
        }));
    }

    protected processGetBySurveyAnswers(response: HttpResponseBase): Observable<AllDetailedViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllDetailedViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllDetailedViewModel>(null as any);
    }
}

export interface IExportClient {
    post(subscriptionServiceId: string, projectId: string, exportType: ExportTableType | undefined, filterViewModel: FilterViewModel): Observable<FileResponse>;
}

@Injectable()
export class ExportClient extends ClientBase implements IExportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    post(subscriptionServiceId: string, projectId: string, exportType: ExportTableType | undefined, filterViewModel: FilterViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/export?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (exportType === null)
            throw new Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IFiltersClient {
    getCategories(subscriptionServiceId: string, projectId: string, demoMode: boolean | undefined): Observable<CategoriesViewModel>;
    getCustomFilters(subscriptionServiceId: string, projectId: string, demoMode: boolean | undefined): Observable<CustomFiltersViewModel>;
    getQuestionFilters(subscriptionServiceId: string, projectId: string, demoMode: boolean | undefined): Observable<QuestionFiltersViewModel>;
}

@Injectable()
export class FiltersClient extends ClientBase implements IFiltersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getCategories(subscriptionServiceId: string, projectId: string, demoMode: boolean | undefined): Observable<CategoriesViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/filters/categories?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (demoMode === null)
            throw new Error("The parameter 'demoMode' cannot be null.");
        else if (demoMode !== undefined)
            url_ += "demoMode=" + encodeURIComponent("" + demoMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoriesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoriesViewModel>;
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<CategoriesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoriesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoriesViewModel>(null as any);
    }

    getCustomFilters(subscriptionServiceId: string, projectId: string, demoMode: boolean | undefined): Observable<CustomFiltersViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/filters/customfilters?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (demoMode === null)
            throw new Error("The parameter 'demoMode' cannot be null.");
        else if (demoMode !== undefined)
            url_ += "demoMode=" + encodeURIComponent("" + demoMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFiltersViewModel>;
        }));
    }

    protected processGetCustomFilters(response: HttpResponseBase): Observable<CustomFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomFiltersViewModel>(null as any);
    }

    getQuestionFilters(subscriptionServiceId: string, projectId: string, demoMode: boolean | undefined): Observable<QuestionFiltersViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/filters/questionfilters?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (demoMode === null)
            throw new Error("The parameter 'demoMode' cannot be null.");
        else if (demoMode !== undefined)
            url_ += "demoMode=" + encodeURIComponent("" + demoMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuestionFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionFiltersViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionFiltersViewModel>;
        }));
    }

    protected processGetQuestionFilters(response: HttpResponseBase): Observable<QuestionFiltersViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionFiltersViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuestionFiltersViewModel>(null as any);
    }
}

export interface IFlowClient {
    get(flowId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<GetFlowByIdModel>;
    delete(flowId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<DeleteFlowViewModel>;
    create(projectId: string, subscriptionServiceId: string, surveyId: string, createFlowDommandDto: CreateFlowCommandDto): Observable<CreateFlowViewModel>;
    update(projectId: string, subscriptionServiceId: string, surveyId: string, updateFlowCommandDto: UpdateFlowCommandDto): Observable<UpdateFlowViewModel>;
}

@Injectable()
export class FlowClient extends ClientBase implements IFlowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(flowId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<GetFlowByIdModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/flows/{flowId}";
        if (flowId === undefined || flowId === null)
            throw new Error("The parameter 'flowId' must be defined.");
        url_ = url_.replace("{flowId}", encodeURIComponent("" + flowId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFlowByIdModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFlowByIdModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetFlowByIdModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFlowByIdModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFlowByIdModel>(null as any);
    }

    delete(flowId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<DeleteFlowViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/flows/{flowId}";
        if (flowId === undefined || flowId === null)
            throw new Error("The parameter 'flowId' must be defined.");
        url_ = url_.replace("{flowId}", encodeURIComponent("" + flowId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteFlowViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteFlowViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteFlowViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFlowViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteFlowViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, surveyId: string, createFlowDommandDto: CreateFlowCommandDto): Observable<CreateFlowViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/flows";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createFlowDommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateFlowViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateFlowViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateFlowViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateFlowViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateFlowViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, surveyId: string, updateFlowCommandDto: UpdateFlowCommandDto): Observable<UpdateFlowViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/flows";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFlowCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateFlowViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateFlowViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateFlowViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateFlowViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateFlowViewModel>(null as any);
    }
}

export interface IFormVersionClient {
    get(formVersionId: string, projectId: string, subscriptionServiceId: string, formId: string): Observable<GetFormVersionByIdViewModel>;
    delete(formVersionId: string, projectId: string, subscriptionServiceId: string, formId: string): Observable<DeleteFormVersionViewModel>;
    create(projectId: string, subscriptionServiceId: string, formId: string, createFormVersionCommandDto: CreateFormVersionCommandDto): Observable<CreateFormVersionViewModel>;
    update(projectId: string, subscriptionServiceId: string, formId: string, updateFormVersionCommandDto: UpdateFormVersionCommandDto): Observable<UpdateFormVersionViewModel>;
}

@Injectable()
export class FormVersionClient extends ClientBase implements IFormVersionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(formVersionId: string, projectId: string, subscriptionServiceId: string, formId: string): Observable<GetFormVersionByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{formVersionId}";
        if (formVersionId === undefined || formVersionId === null)
            throw new Error("The parameter 'formVersionId' must be defined.");
        url_ = url_.replace("{formVersionId}", encodeURIComponent("" + formVersionId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFormVersionByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFormVersionByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetFormVersionByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFormVersionByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormVersionByIdViewModel>(null as any);
    }

    delete(formVersionId: string, projectId: string, subscriptionServiceId: string, formId: string): Observable<DeleteFormVersionViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{formVersionId}";
        if (formVersionId === undefined || formVersionId === null)
            throw new Error("The parameter 'formVersionId' must be defined.");
        url_ = url_.replace("{formVersionId}", encodeURIComponent("" + formVersionId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteFormVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteFormVersionViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteFormVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFormVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteFormVersionViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, formId: string, createFormVersionCommandDto: CreateFormVersionCommandDto): Observable<CreateFormVersionViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createFormVersionCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateFormVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateFormVersionViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateFormVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateFormVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateFormVersionViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, formId: string, updateFormVersionCommandDto: UpdateFormVersionCommandDto): Observable<UpdateFormVersionViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFormVersionCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateFormVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateFormVersionViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateFormVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateFormVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateFormVersionViewModel>(null as any);
    }
}

export interface ILayoutCulturesClient {
    get(cultureId: string, projectId: string, subscriptionServiceId: string, layoutId: string): Observable<GetLayoutCultureByIdViewModel>;
    delete(cultureId: string, projectId: string, subscriptionServiceId: string, layoutId: string): Observable<DeleteLayoutCultureViewModel>;
    create(projectId: string, subscriptionServiceId: string, layoutId: string, createLayoutCultureCommandDto: CreateLayoutCultureCommandDto): Observable<CreateLayoutCultureViewModel>;
    update(projectId: string, subscriptionServiceId: string, layoutId: string, updateLayoutCultureCommandDto: UpdateLayoutCultureCommandDto): Observable<UpdateLayoutCultureViewModel>;
}

@Injectable()
export class LayoutCulturesClient extends ClientBase implements ILayoutCulturesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(cultureId: string, projectId: string, subscriptionServiceId: string, layoutId: string): Observable<GetLayoutCultureByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/layouts/{layoutId}/cultures/{cultureId}";
        if (cultureId === undefined || cultureId === null)
            throw new Error("The parameter 'cultureId' must be defined.");
        url_ = url_.replace("{cultureId}", encodeURIComponent("" + cultureId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (layoutId === undefined || layoutId === null)
            throw new Error("The parameter 'layoutId' must be defined.");
        url_ = url_.replace("{layoutId}", encodeURIComponent("" + layoutId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLayoutCultureByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLayoutCultureByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetLayoutCultureByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLayoutCultureByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLayoutCultureByIdViewModel>(null as any);
    }

    delete(cultureId: string, projectId: string, subscriptionServiceId: string, layoutId: string): Observable<DeleteLayoutCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/layouts/{layoutId}/cultures/{cultureId}";
        if (cultureId === undefined || cultureId === null)
            throw new Error("The parameter 'cultureId' must be defined.");
        url_ = url_.replace("{cultureId}", encodeURIComponent("" + cultureId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (layoutId === undefined || layoutId === null)
            throw new Error("The parameter 'layoutId' must be defined.");
        url_ = url_.replace("{layoutId}", encodeURIComponent("" + layoutId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteLayoutCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteLayoutCultureViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteLayoutCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteLayoutCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteLayoutCultureViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, layoutId: string, createLayoutCultureCommandDto: CreateLayoutCultureCommandDto): Observable<CreateLayoutCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/layouts/{layoutId}/cultures";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (layoutId === undefined || layoutId === null)
            throw new Error("The parameter 'layoutId' must be defined.");
        url_ = url_.replace("{layoutId}", encodeURIComponent("" + layoutId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createLayoutCultureCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLayoutCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLayoutCultureViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateLayoutCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateLayoutCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateLayoutCultureViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, layoutId: string, updateLayoutCultureCommandDto: UpdateLayoutCultureCommandDto): Observable<UpdateLayoutCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/layouts/{layoutId}/cultures";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (layoutId === undefined || layoutId === null)
            throw new Error("The parameter 'layoutId' must be defined.");
        url_ = url_.replace("{layoutId}", encodeURIComponent("" + layoutId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateLayoutCultureCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateLayoutCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateLayoutCultureViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateLayoutCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateLayoutCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateLayoutCultureViewModel>(null as any);
    }
}

export interface ILayoutCultureValuesClient {
    get(cultureValueId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<GetLayoutCultureValueByIdViewModel>;
    delete(cultureValueId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<DeleteLayoutCultureValueViewModel>;
    create(projectId: string, subscriptionServiceId: string, surveyId: string, createLayoutCultureValueCommandDto: CreateLayoutCultureValueCommandDto): Observable<CreateLayoutCultureValueViewModel>;
    update(projectId: string, subscriptionServiceId: string, surveyId: string, updateCultureLayoutValueCommandDto: UpdateLayoutCultureValueCommandDto): Observable<UpdateLayoutCultureValueViewModel>;
}

@Injectable()
export class LayoutCultureValuesClient extends ClientBase implements ILayoutCultureValuesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(cultureValueId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<GetLayoutCultureValueByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/layoutCultureValues/{cultureValueId}";
        if (cultureValueId === undefined || cultureValueId === null)
            throw new Error("The parameter 'cultureValueId' must be defined.");
        url_ = url_.replace("{cultureValueId}", encodeURIComponent("" + cultureValueId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLayoutCultureValueByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLayoutCultureValueByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetLayoutCultureValueByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLayoutCultureValueByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLayoutCultureValueByIdViewModel>(null as any);
    }

    delete(cultureValueId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<DeleteLayoutCultureValueViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/layoutCultureValues/{cultureValueId}";
        if (cultureValueId === undefined || cultureValueId === null)
            throw new Error("The parameter 'cultureValueId' must be defined.");
        url_ = url_.replace("{cultureValueId}", encodeURIComponent("" + cultureValueId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteLayoutCultureValueViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteLayoutCultureValueViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteLayoutCultureValueViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteLayoutCultureValueViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteLayoutCultureValueViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, surveyId: string, createLayoutCultureValueCommandDto: CreateLayoutCultureValueCommandDto): Observable<CreateLayoutCultureValueViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/layoutCultureValues";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createLayoutCultureValueCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLayoutCultureValueViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLayoutCultureValueViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateLayoutCultureValueViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateLayoutCultureValueViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateLayoutCultureValueViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, surveyId: string, updateCultureLayoutValueCommandDto: UpdateLayoutCultureValueCommandDto): Observable<UpdateLayoutCultureValueViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/layoutCultureValues";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCultureLayoutValueCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateLayoutCultureValueViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateLayoutCultureValueViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateLayoutCultureValueViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateLayoutCultureValueViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateLayoutCultureValueViewModel>(null as any);
    }
}

export interface ILayoutsClient {
    get(layoutId: string, projectId: string, subscriptionServiceId: string): Observable<GetLayoutByIdViewModel>;
    delete(layoutId: string, projectId: string, subscriptionServiceId: string): Observable<DeleteLayoutViewModel>;
    create(projectId: string, subscriptionServiceId: string, createLayoutCommandDto: CreateLayoutCommandDto): Observable<CreateLayoutViewModel>;
    update(projectId: string, subscriptionServiceId: string, updateLayoutCommandDto: UpdateLayoutCommandDto): Observable<UpdateLayoutViewModel>;
}

@Injectable()
export class LayoutsClient extends ClientBase implements ILayoutsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(layoutId: string, projectId: string, subscriptionServiceId: string): Observable<GetLayoutByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/layouts/{layoutId}";
        if (layoutId === undefined || layoutId === null)
            throw new Error("The parameter 'layoutId' must be defined.");
        url_ = url_.replace("{layoutId}", encodeURIComponent("" + layoutId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLayoutByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLayoutByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetLayoutByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLayoutByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLayoutByIdViewModel>(null as any);
    }

    delete(layoutId: string, projectId: string, subscriptionServiceId: string): Observable<DeleteLayoutViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/layouts/{layoutId}";
        if (layoutId === undefined || layoutId === null)
            throw new Error("The parameter 'layoutId' must be defined.");
        url_ = url_.replace("{layoutId}", encodeURIComponent("" + layoutId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteLayoutViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteLayoutViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteLayoutViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteLayoutViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteLayoutViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, createLayoutCommandDto: CreateLayoutCommandDto): Observable<CreateLayoutViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/layouts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createLayoutCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLayoutViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLayoutViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateLayoutViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateLayoutViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateLayoutViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, updateLayoutCommandDto: UpdateLayoutCommandDto): Observable<UpdateLayoutViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/layouts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateLayoutCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateLayoutViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateLayoutViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateLayoutViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateLayoutViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateLayoutViewModel>(null as any);
    }
}

export interface IMySurveysClient {
    get(subscriptionServiceId: string, projectId: string): Observable<GetMySurveysViewModel>;
    generateQr(subscriptionId: string | undefined, projectId: string, subscriptionServiceId: string, dto: GenerateQrCodeDto): Observable<FileResponse>;
}

@Injectable()
export class MySurveysClient extends ClientBase implements IMySurveysClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(subscriptionServiceId: string, projectId: string): Observable<GetMySurveysViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/mysurveys";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMySurveysViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMySurveysViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetMySurveysViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMySurveysViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMySurveysViewModel>(null as any);
    }

    generateQr(subscriptionId: string | undefined, projectId: string, subscriptionServiceId: string, dto: GenerateQrCodeDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/mysurveys?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateQr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateQr(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IOverviewClient {
    getAlerts(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<AlertsWidgetViewModel>;
    getCes(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<CesWidgetViewModel>;
    getCompetitors(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<CompetitorsWidgetViewModel>;
    getGeneral(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<GeneralViewModel>;
    getGeneralByCategory(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<GeneralByCategoryViewModel>;
    getGeneralSatisfaction(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<GeneralSatisfactionViewModel>;
    getNps(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<NpsWidgetViewModel>;
    getTrends(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<TrendsViewModel>;
    postDashboardOverview(subscriptionServiceId: string, projectId: string, options: DashboardOptions): Observable<DashboardOverview>;
}

@Injectable()
export class OverviewClient extends ClientBase implements IOverviewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getAlerts(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<AlertsWidgetViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/overview/alerts";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertsWidgetViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertsWidgetViewModel>;
        }));
    }

    protected processGetAlerts(response: HttpResponseBase): Observable<AlertsWidgetViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertsWidgetViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlertsWidgetViewModel>(null as any);
    }

    getCes(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<CesWidgetViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/overview/ces";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CesWidgetViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CesWidgetViewModel>;
        }));
    }

    protected processGetCes(response: HttpResponseBase): Observable<CesWidgetViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CesWidgetViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CesWidgetViewModel>(null as any);
    }

    getCompetitors(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<CompetitorsWidgetViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/overview/competitors";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCompetitors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompetitors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompetitorsWidgetViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompetitorsWidgetViewModel>;
        }));
    }

    protected processGetCompetitors(response: HttpResponseBase): Observable<CompetitorsWidgetViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitorsWidgetViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompetitorsWidgetViewModel>(null as any);
    }

    getGeneral(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<GeneralViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/overview/general";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralViewModel>;
        }));
    }

    protected processGetGeneral(response: HttpResponseBase): Observable<GeneralViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralViewModel>(null as any);
    }

    getGeneralByCategory(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<GeneralByCategoryViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/overview/generalByCategory";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneralByCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralByCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralByCategoryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralByCategoryViewModel>;
        }));
    }

    protected processGetGeneralByCategory(response: HttpResponseBase): Observable<GeneralByCategoryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralByCategoryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralByCategoryViewModel>(null as any);
    }

    getGeneralSatisfaction(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<GeneralSatisfactionViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/overview/generalSatisfaction";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneralSatisfaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralSatisfaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralSatisfactionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralSatisfactionViewModel>;
        }));
    }

    protected processGetGeneralSatisfaction(response: HttpResponseBase): Observable<GeneralSatisfactionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralSatisfactionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralSatisfactionViewModel>(null as any);
    }

    getNps(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<NpsWidgetViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/overview/nps";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NpsWidgetViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NpsWidgetViewModel>;
        }));
    }

    protected processGetNps(response: HttpResponseBase): Observable<NpsWidgetViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NpsWidgetViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NpsWidgetViewModel>(null as any);
    }

    getTrends(subscriptionServiceId: string, projectId: string, filterViewModel: FilterViewModel): Observable<TrendsViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/overview/trends";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTrends(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrends(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendsViewModel>;
        }));
    }

    protected processGetTrends(response: HttpResponseBase): Observable<TrendsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrendsViewModel>(null as any);
    }

    postDashboardOverview(subscriptionServiceId: string, projectId: string, options: DashboardOptions): Observable<DashboardOverview> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/overview";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPostDashboardOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDashboardOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardOverview>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardOverview>;
        }));
    }

    protected processPostDashboardOverview(response: HttpResponseBase): Observable<DashboardOverview> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOverview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardOverview>(null as any);
    }
}

export interface IPredefinedFlowClient {
    get(id: string): Observable<GetPredefinedFlowViewModel>;
    delete(id: string): Observable<DeletePredefinedFlowViewModel>;
    create(createPredefinedFlowCommandDto: CreatePredefinedFlowCommandDto): Observable<CreatePredefinedFlowViewModel>;
    update(updatePredefinedFlowCommandDto: UpdatePredefinedFlowCommandDto): Observable<UpdatePredefinedFlowViewModel>;
}

@Injectable()
export class PredefinedFlowClient extends ClientBase implements IPredefinedFlowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(id: string): Observable<GetPredefinedFlowViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedFlows/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredefinedFlowViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredefinedFlowViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPredefinedFlowViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredefinedFlowViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredefinedFlowViewModel>(null as any);
    }

    delete(id: string): Observable<DeletePredefinedFlowViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedFlows/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePredefinedFlowViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePredefinedFlowViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeletePredefinedFlowViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePredefinedFlowViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeletePredefinedFlowViewModel>(null as any);
    }

    create(createPredefinedFlowCommandDto: CreatePredefinedFlowCommandDto): Observable<CreatePredefinedFlowViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedFlows";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPredefinedFlowCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePredefinedFlowViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePredefinedFlowViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatePredefinedFlowViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePredefinedFlowViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePredefinedFlowViewModel>(null as any);
    }

    update(updatePredefinedFlowCommandDto: UpdatePredefinedFlowCommandDto): Observable<UpdatePredefinedFlowViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedFlows";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePredefinedFlowCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePredefinedFlowViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePredefinedFlowViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdatePredefinedFlowViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePredefinedFlowViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePredefinedFlowViewModel>(null as any);
    }
}

export interface IPredefinedFormClient {
    get(id: string): Observable<GetPredefinedFormViewModel>;
    delete(id: string): Observable<DeletePredefinedFormViewModel>;
    create(createPredefinedFormCommandDto: CreatePredefinedFormCommandDto): Observable<CreatePredefinedFormViewModel>;
    update(updatePredefinedFormCommandDto: UpdatePredefinedFormCommandDto): Observable<UpdatePredefinedFormViewModel>;
}

@Injectable()
export class PredefinedFormClient extends ClientBase implements IPredefinedFormClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(id: string): Observable<GetPredefinedFormViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedForms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredefinedFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredefinedFormViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPredefinedFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredefinedFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredefinedFormViewModel>(null as any);
    }

    delete(id: string): Observable<DeletePredefinedFormViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedForms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePredefinedFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePredefinedFormViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeletePredefinedFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePredefinedFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeletePredefinedFormViewModel>(null as any);
    }

    create(createPredefinedFormCommandDto: CreatePredefinedFormCommandDto): Observable<CreatePredefinedFormViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPredefinedFormCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePredefinedFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePredefinedFormViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatePredefinedFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePredefinedFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePredefinedFormViewModel>(null as any);
    }

    update(updatePredefinedFormCommandDto: UpdatePredefinedFormCommandDto): Observable<UpdatePredefinedFormViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePredefinedFormCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePredefinedFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePredefinedFormViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdatePredefinedFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePredefinedFormViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePredefinedFormViewModel>(null as any);
    }
}

export interface IPredefinedFormVersionClient {
    get(id: string, predefinedFormId: string): Observable<GetPredefinedFormVersionViewModel>;
    delete(id: string, predefinedFormId: string): Observable<DeletePredefinedFormVersionViewModel>;
    create(predefinedFormId: string, createPredefinedFormVersionCommandDto: CreatePredefinedFormVersionCommandDto): Observable<CreatePredefinedFormVersionViewModel>;
    update(predefinedFormId: string, updatePredefinedFormVersionCommandDto: UpdatePredefinedFormVersionCommandDto): Observable<UpdatePredefinedFormVersionViewModel>;
}

@Injectable()
export class PredefinedFormVersionClient extends ClientBase implements IPredefinedFormVersionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(id: string, predefinedFormId: string): Observable<GetPredefinedFormVersionViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedForms/{predefinedFormId}/versions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (predefinedFormId === undefined || predefinedFormId === null)
            throw new Error("The parameter 'predefinedFormId' must be defined.");
        url_ = url_.replace("{predefinedFormId}", encodeURIComponent("" + predefinedFormId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredefinedFormVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredefinedFormVersionViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPredefinedFormVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredefinedFormVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredefinedFormVersionViewModel>(null as any);
    }

    delete(id: string, predefinedFormId: string): Observable<DeletePredefinedFormVersionViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedForms/{predefinedFormId}/versions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (predefinedFormId === undefined || predefinedFormId === null)
            throw new Error("The parameter 'predefinedFormId' must be defined.");
        url_ = url_.replace("{predefinedFormId}", encodeURIComponent("" + predefinedFormId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePredefinedFormVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePredefinedFormVersionViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeletePredefinedFormVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePredefinedFormVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeletePredefinedFormVersionViewModel>(null as any);
    }

    create(predefinedFormId: string, createPredefinedFormVersionCommandDto: CreatePredefinedFormVersionCommandDto): Observable<CreatePredefinedFormVersionViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedForms/{predefinedFormId}/versions";
        if (predefinedFormId === undefined || predefinedFormId === null)
            throw new Error("The parameter 'predefinedFormId' must be defined.");
        url_ = url_.replace("{predefinedFormId}", encodeURIComponent("" + predefinedFormId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPredefinedFormVersionCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePredefinedFormVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePredefinedFormVersionViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatePredefinedFormVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePredefinedFormVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePredefinedFormVersionViewModel>(null as any);
    }

    update(predefinedFormId: string, updatePredefinedFormVersionCommandDto: UpdatePredefinedFormVersionCommandDto): Observable<UpdatePredefinedFormVersionViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedForms/{predefinedFormId}/versions";
        if (predefinedFormId === undefined || predefinedFormId === null)
            throw new Error("The parameter 'predefinedFormId' must be defined.");
        url_ = url_.replace("{predefinedFormId}", encodeURIComponent("" + predefinedFormId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePredefinedFormVersionCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePredefinedFormVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePredefinedFormVersionViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdatePredefinedFormVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePredefinedFormVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePredefinedFormVersionViewModel>(null as any);
    }
}

export interface IPredefinedLayoutClient {
    get(id: string): Observable<GetPredefinedLayoutViewModel>;
    delete(id: string): Observable<DeletePredefinedLayoutViewModel>;
    create(createPredefinedLayoutCommandDto: CreatePredefinedLayoutCommandDto): Observable<CreatePredefinedLayoutViewModel>;
    update(updatePredefinedLayoutCommandDto: UpdatePredefinedLayoutCommandDto): Observable<UpdatePredefinedLayoutViewModel>;
}

@Injectable()
export class PredefinedLayoutClient extends ClientBase implements IPredefinedLayoutClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(id: string): Observable<GetPredefinedLayoutViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedLayout/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredefinedLayoutViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredefinedLayoutViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPredefinedLayoutViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredefinedLayoutViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredefinedLayoutViewModel>(null as any);
    }

    delete(id: string): Observable<DeletePredefinedLayoutViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedLayout/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePredefinedLayoutViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePredefinedLayoutViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeletePredefinedLayoutViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePredefinedLayoutViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeletePredefinedLayoutViewModel>(null as any);
    }

    create(createPredefinedLayoutCommandDto: CreatePredefinedLayoutCommandDto): Observable<CreatePredefinedLayoutViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedLayout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPredefinedLayoutCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePredefinedLayoutViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePredefinedLayoutViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatePredefinedLayoutViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePredefinedLayoutViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePredefinedLayoutViewModel>(null as any);
    }

    update(updatePredefinedLayoutCommandDto: UpdatePredefinedLayoutCommandDto): Observable<UpdatePredefinedLayoutViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedLayout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePredefinedLayoutCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePredefinedLayoutViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePredefinedLayoutViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdatePredefinedLayoutViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePredefinedLayoutViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePredefinedLayoutViewModel>(null as any);
    }
}

export interface IPredefinedLayoutCultureClient {
    get(id: string, predefinedLayoutId: string): Observable<GetPredefinedLayoutCultureViewModel>;
    delete(id: string, predefinedLayoutId: string): Observable<DeletePredefinedLayoutCultureViewModel>;
    create(predefinedLayoutId: string, createPredefinedLayoutLanguageCommandDto: CreatePredefinedLayoutCultureCommandDto): Observable<CreatePredefinedLayoutCultureViewModel>;
    update(predefinedLayoutId: string, updatePredefinedLayoutLanguageCommandDto: UpdatePredefinedLayoutCultureCommandDto): Observable<UpdatePredefinedLayoutCultureViewModel>;
}

@Injectable()
export class PredefinedLayoutCultureClient extends ClientBase implements IPredefinedLayoutCultureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(id: string, predefinedLayoutId: string): Observable<GetPredefinedLayoutCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedLayouts/{predefinedLayoutId}/cultures/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (predefinedLayoutId === undefined || predefinedLayoutId === null)
            throw new Error("The parameter 'predefinedLayoutId' must be defined.");
        url_ = url_.replace("{predefinedLayoutId}", encodeURIComponent("" + predefinedLayoutId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredefinedLayoutCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredefinedLayoutCultureViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPredefinedLayoutCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredefinedLayoutCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredefinedLayoutCultureViewModel>(null as any);
    }

    delete(id: string, predefinedLayoutId: string): Observable<DeletePredefinedLayoutCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedLayouts/{predefinedLayoutId}/cultures/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (predefinedLayoutId === undefined || predefinedLayoutId === null)
            throw new Error("The parameter 'predefinedLayoutId' must be defined.");
        url_ = url_.replace("{predefinedLayoutId}", encodeURIComponent("" + predefinedLayoutId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePredefinedLayoutCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePredefinedLayoutCultureViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeletePredefinedLayoutCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePredefinedLayoutCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeletePredefinedLayoutCultureViewModel>(null as any);
    }

    create(predefinedLayoutId: string, createPredefinedLayoutLanguageCommandDto: CreatePredefinedLayoutCultureCommandDto): Observable<CreatePredefinedLayoutCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedLayouts/{predefinedLayoutId}/cultures";
        if (predefinedLayoutId === undefined || predefinedLayoutId === null)
            throw new Error("The parameter 'predefinedLayoutId' must be defined.");
        url_ = url_.replace("{predefinedLayoutId}", encodeURIComponent("" + predefinedLayoutId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPredefinedLayoutLanguageCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePredefinedLayoutCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePredefinedLayoutCultureViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatePredefinedLayoutCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePredefinedLayoutCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePredefinedLayoutCultureViewModel>(null as any);
    }

    update(predefinedLayoutId: string, updatePredefinedLayoutLanguageCommandDto: UpdatePredefinedLayoutCultureCommandDto): Observable<UpdatePredefinedLayoutCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedLayouts/{predefinedLayoutId}/cultures";
        if (predefinedLayoutId === undefined || predefinedLayoutId === null)
            throw new Error("The parameter 'predefinedLayoutId' must be defined.");
        url_ = url_.replace("{predefinedLayoutId}", encodeURIComponent("" + predefinedLayoutId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePredefinedLayoutLanguageCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePredefinedLayoutCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePredefinedLayoutCultureViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdatePredefinedLayoutCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePredefinedLayoutCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePredefinedLayoutCultureViewModel>(null as any);
    }
}

export interface IPredefinedTemplateClient {
    get(id: string): Observable<GetPredefinedTemplateViewModel>;
    delete(id: string): Observable<DeletePredefinedTemplateViewModel>;
    create(createPredefinedTemplateCommandDto: CreatePredefinedTemplateCommandDto): Observable<CreatePredefinedTemplateViewModel>;
    update(updatePredefinedTemplateCommandDto: UpdatePredefinedTemplateCommandDto): Observable<UpdatePredefinedTemplateViewModel>;
}

@Injectable()
export class PredefinedTemplateClient extends ClientBase implements IPredefinedTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(id: string): Observable<GetPredefinedTemplateViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedtTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredefinedTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredefinedTemplateViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPredefinedTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredefinedTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredefinedTemplateViewModel>(null as any);
    }

    delete(id: string): Observable<DeletePredefinedTemplateViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedtTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePredefinedTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePredefinedTemplateViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeletePredefinedTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePredefinedTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeletePredefinedTemplateViewModel>(null as any);
    }

    create(createPredefinedTemplateCommandDto: CreatePredefinedTemplateCommandDto): Observable<CreatePredefinedTemplateViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedtTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPredefinedTemplateCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePredefinedTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePredefinedTemplateViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatePredefinedTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePredefinedTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePredefinedTemplateViewModel>(null as any);
    }

    update(updatePredefinedTemplateCommandDto: UpdatePredefinedTemplateCommandDto): Observable<UpdatePredefinedTemplateViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedtTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePredefinedTemplateCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePredefinedTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePredefinedTemplateViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdatePredefinedTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePredefinedTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePredefinedTemplateViewModel>(null as any);
    }
}

export interface IPredefinedTemplateCultureClient {
    get(id: string, predefinedTemplatesId: string): Observable<GetPredefinedTemplateCultureViewModel>;
    delete(id: string, predefinedTemplatesId: string): Observable<DeletePredefinedTemplateCultureViewModel>;
    create(predefinedTemplatesId: string, createPredefinedTemplateLanguageCommandDto: CreatePredefinedTemplateCultureCommandDto): Observable<CreatePredefinedTemplateCultureViewModel>;
    update(predefinedTemplatesId: string, updatePredefinedTemplateLanguageCommandDto: UpdatePredefinedTemplateCultureCommandDto): Observable<UpdatePredefinedTemplateCultureViewModel>;
}

@Injectable()
export class PredefinedTemplateCultureClient extends ClientBase implements IPredefinedTemplateCultureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(id: string, predefinedTemplatesId: string): Observable<GetPredefinedTemplateCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedTemplates/{predefinedTemplatesId}/cultures/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (predefinedTemplatesId === undefined || predefinedTemplatesId === null)
            throw new Error("The parameter 'predefinedTemplatesId' must be defined.");
        url_ = url_.replace("{predefinedTemplatesId}", encodeURIComponent("" + predefinedTemplatesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPredefinedTemplateCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPredefinedTemplateCultureViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPredefinedTemplateCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredefinedTemplateCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPredefinedTemplateCultureViewModel>(null as any);
    }

    delete(id: string, predefinedTemplatesId: string): Observable<DeletePredefinedTemplateCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedTemplates/{predefinedTemplatesId}/cultures/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (predefinedTemplatesId === undefined || predefinedTemplatesId === null)
            throw new Error("The parameter 'predefinedTemplatesId' must be defined.");
        url_ = url_.replace("{predefinedTemplatesId}", encodeURIComponent("" + predefinedTemplatesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePredefinedTemplateCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePredefinedTemplateCultureViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeletePredefinedTemplateCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePredefinedTemplateCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeletePredefinedTemplateCultureViewModel>(null as any);
    }

    create(predefinedTemplatesId: string, createPredefinedTemplateLanguageCommandDto: CreatePredefinedTemplateCultureCommandDto): Observable<CreatePredefinedTemplateCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedTemplates/{predefinedTemplatesId}/cultures";
        if (predefinedTemplatesId === undefined || predefinedTemplatesId === null)
            throw new Error("The parameter 'predefinedTemplatesId' must be defined.");
        url_ = url_.replace("{predefinedTemplatesId}", encodeURIComponent("" + predefinedTemplatesId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPredefinedTemplateLanguageCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePredefinedTemplateCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePredefinedTemplateCultureViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatePredefinedTemplateCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePredefinedTemplateCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePredefinedTemplateCultureViewModel>(null as any);
    }

    update(predefinedTemplatesId: string, updatePredefinedTemplateLanguageCommandDto: UpdatePredefinedTemplateCultureCommandDto): Observable<UpdatePredefinedTemplateCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/predefinedTemplates/{predefinedTemplatesId}/cultures";
        if (predefinedTemplatesId === undefined || predefinedTemplatesId === null)
            throw new Error("The parameter 'predefinedTemplatesId' must be defined.");
        url_ = url_.replace("{predefinedTemplatesId}", encodeURIComponent("" + predefinedTemplatesId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePredefinedTemplateLanguageCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePredefinedTemplateCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePredefinedTemplateCultureViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdatePredefinedTemplateCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePredefinedTemplateCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePredefinedTemplateCultureViewModel>(null as any);
    }
}

export interface IProjectUrlNavigatorClient {
    get(url: string | undefined): Observable<UrlViewModel>;
}

@Injectable()
export class ProjectUrlNavigatorClient extends ClientBase implements IProjectUrlNavigatorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(url: string | undefined): Observable<UrlViewModel> {
        let url_ = this.baseUrl + "/api/voc/projectUrlNavigator?";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UrlViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UrlViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UrlViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UrlViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UrlViewModel>(null as any);
    }
}

export interface IQrCodeClient {
    get(urlId: string, projectId: string, subscriptionServiceId: string, branchId: string | undefined): Observable<FileResponse>;
    getAll(urlId: string | undefined, projectId: string, subscriptionServiceId: string): Observable<FileResponse>;
}

@Injectable()
export class QrCodeClient extends ClientBase implements IQrCodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(urlId: string, projectId: string, subscriptionServiceId: string, branchId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/qrcode/{urlId}?";
        if (urlId === undefined || urlId === null)
            throw new Error("The parameter 'urlId' must be defined.");
        url_ = url_.replace("{urlId}", encodeURIComponent("" + urlId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getAll(urlId: string | undefined, projectId: string, subscriptionServiceId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/qrcode/all?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (urlId === null)
            throw new Error("The parameter 'urlId' cannot be null.");
        else if (urlId !== undefined)
            url_ += "urlId=" + encodeURIComponent("" + urlId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IReportClient {
    getAvailableReports(subscriptionServiceId: string, projectId: string): Observable<{ [key in keyof typeof ReportType]?: boolean; }>;
    postReport(subscriptionServiceId: string, projectId: string, culture: string, reportOptions: ReportsOption): Observable<FileResponse>;
}

@Injectable()
export class ReportClient extends ClientBase implements IReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getAvailableReports(subscriptionServiceId: string, projectId: string): Observable<{ [key in keyof typeof ReportType]?: boolean; }> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/reports";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAvailableReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key in keyof typeof ReportType]?: boolean; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key in keyof typeof ReportType]?: boolean; }>;
        }));
    }

    protected processGetAvailableReports(response: HttpResponseBase): Observable<{ [key in keyof typeof ReportType]?: boolean; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key in keyof typeof ReportType]?: boolean; }>(null as any);
    }

    postReport(subscriptionServiceId: string, projectId: string, culture: string, reportOptions: ReportsOption): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/reports/{culture}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (culture === undefined || culture === null)
            throw new Error("The parameter 'culture' must be defined.");
        url_ = url_.replace("{culture}", encodeURIComponent("" + culture));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPostReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPostReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ISignUpClient {
    canAccess(): Observable<CanAccessViewModel>;
    verifyAvailability(suggestionCount: number | undefined, dto: ProjectUrlAvailabilityDto): Observable<ProjectUrlAvailabilityViewModel>;
    getSurveyAddress(voiceOfCustomerServiceId: string): Observable<GetSurveyAddressViewModel>;
    register(voiceOfCustomerServiceId: string, requestedUrl: string): Observable<RegisterProjectUrlViewModel>;
    getUserOrganizationOwnerHasSurveys(): Observable<UserOrganizationOwnerHasSurveysViewModel>;
    getIfSendToDemoMode(projectId: string | undefined, organizationId: string | undefined): Observable<GetIfDemoModeViewModel>;
    getSignupDetails(): Observable<SignupDetailsViewModel>;
    postSignupDetails(viewModel: SetupSubscriptionViewModel): Observable<SignupDetailsViewModel2>;
    postPlaceholderSignup(): Observable<OrganizationPlaceholderViewModel>;
    postSignupBranchServices(id: string, industryServices: string[]): Observable<SetupBranchServicesViewModel>;
    getPredefinedFlows(): Observable<PredefinedFlowListViewModel>;
    build(voiceOfCustomerServiceId: string, dto: BuildSurveyDto): Observable<BuildSurveyViewModel>;
    report(startDate: Date | undefined, endDate: Date | undefined): Observable<ReportViewModel>;
    completedSurveysPerSaaSBusiness(serviceId: string): Observable<FileResponse>;
}

@Injectable()
export class SignUpClient extends ClientBase implements ISignUpClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    canAccess(): Observable<CanAccessViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/canAccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCanAccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanAccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanAccessViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanAccessViewModel>;
        }));
    }

    protected processCanAccess(response: HttpResponseBase): Observable<CanAccessViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanAccessViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CanAccessViewModel>(null as any);
    }

    verifyAvailability(suggestionCount: number | undefined, dto: ProjectUrlAvailabilityDto): Observable<ProjectUrlAvailabilityViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/urls/verify?";
        if (suggestionCount === null)
            throw new Error("The parameter 'suggestionCount' cannot be null.");
        else if (suggestionCount !== undefined)
            url_ += "suggestionCount=" + encodeURIComponent("" + suggestionCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectUrlAvailabilityViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectUrlAvailabilityViewModel>;
        }));
    }

    protected processVerifyAvailability(response: HttpResponseBase): Observable<ProjectUrlAvailabilityViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectUrlAvailabilityViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectUrlAvailabilityViewModel>(null as any);
    }

    getSurveyAddress(voiceOfCustomerServiceId: string): Observable<GetSurveyAddressViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/{voiceOfCustomerServiceId}/urls";
        if (voiceOfCustomerServiceId === undefined || voiceOfCustomerServiceId === null)
            throw new Error("The parameter 'voiceOfCustomerServiceId' must be defined.");
        url_ = url_.replace("{voiceOfCustomerServiceId}", encodeURIComponent("" + voiceOfCustomerServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyAddressViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyAddressViewModel>;
        }));
    }

    protected processGetSurveyAddress(response: HttpResponseBase): Observable<GetSurveyAddressViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyAddressViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyAddressViewModel>(null as any);
    }

    register(voiceOfCustomerServiceId: string, requestedUrl: string): Observable<RegisterProjectUrlViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/{voiceOfCustomerServiceId}/urls";
        if (voiceOfCustomerServiceId === undefined || voiceOfCustomerServiceId === null)
            throw new Error("The parameter 'voiceOfCustomerServiceId' must be defined.");
        url_ = url_.replace("{voiceOfCustomerServiceId}", encodeURIComponent("" + voiceOfCustomerServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestedUrl);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterProjectUrlViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterProjectUrlViewModel>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterProjectUrlViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterProjectUrlViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterProjectUrlViewModel>(null as any);
    }

    getUserOrganizationOwnerHasSurveys(): Observable<UserOrganizationOwnerHasSurveysViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/GetUserOrganizationOwnerHasSurveys";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserOrganizationOwnerHasSurveys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserOrganizationOwnerHasSurveys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrganizationOwnerHasSurveysViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrganizationOwnerHasSurveysViewModel>;
        }));
    }

    protected processGetUserOrganizationOwnerHasSurveys(response: HttpResponseBase): Observable<UserOrganizationOwnerHasSurveysViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserOrganizationOwnerHasSurveysViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserOrganizationOwnerHasSurveysViewModel>(null as any);
    }

    getIfSendToDemoMode(projectId: string | undefined, organizationId: string | undefined): Observable<GetIfDemoModeViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/GetIfSendToDemoMode?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetIfSendToDemoMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIfSendToDemoMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIfDemoModeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIfDemoModeViewModel>;
        }));
    }

    protected processGetIfSendToDemoMode(response: HttpResponseBase): Observable<GetIfDemoModeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIfDemoModeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIfDemoModeViewModel>(null as any);
    }

    getSignupDetails(): Observable<SignupDetailsViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSignupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignupDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignupDetailsViewModel>;
        }));
    }

    protected processGetSignupDetails(response: HttpResponseBase): Observable<SignupDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignupDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignupDetailsViewModel>(null as any);
    }

    postSignupDetails(viewModel: SetupSubscriptionViewModel): Observable<SignupDetailsViewModel2> {
        let url_ = this.baseUrl + "/api/voc/signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPostSignupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSignupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignupDetailsViewModel2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignupDetailsViewModel2>;
        }));
    }

    protected processPostSignupDetails(response: HttpResponseBase): Observable<SignupDetailsViewModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignupDetailsViewModel2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SignupDetailsViewModel2>(null as any);
    }

    postPlaceholderSignup(): Observable<OrganizationPlaceholderViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/placeholder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPostPlaceholderSignup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPlaceholderSignup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationPlaceholderViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationPlaceholderViewModel>;
        }));
    }

    protected processPostPlaceholderSignup(response: HttpResponseBase): Observable<OrganizationPlaceholderViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationPlaceholderViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationPlaceholderViewModel>(null as any);
    }

    postSignupBranchServices(id: string, industryServices: string[]): Observable<SetupBranchServicesViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/branches/{id}/branchServices";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(industryServices);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPostSignupBranchServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSignupBranchServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetupBranchServicesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetupBranchServicesViewModel>;
        }));
    }

    protected processPostSignupBranchServices(response: HttpResponseBase): Observable<SetupBranchServicesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetupBranchServicesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetupBranchServicesViewModel>(null as any);
    }

    getPredefinedFlows(): Observable<PredefinedFlowListViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/predefinedFlows";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPredefinedFlows(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPredefinedFlows(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PredefinedFlowListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PredefinedFlowListViewModel>;
        }));
    }

    protected processGetPredefinedFlows(response: HttpResponseBase): Observable<PredefinedFlowListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PredefinedFlowListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PredefinedFlowListViewModel>(null as any);
    }

    build(voiceOfCustomerServiceId: string, dto: BuildSurveyDto): Observable<BuildSurveyViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/{voiceOfCustomerServiceId}/survey/build";
        if (voiceOfCustomerServiceId === undefined || voiceOfCustomerServiceId === null)
            throw new Error("The parameter 'voiceOfCustomerServiceId' must be defined.");
        url_ = url_.replace("{voiceOfCustomerServiceId}", encodeURIComponent("" + voiceOfCustomerServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBuild(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuild(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildSurveyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildSurveyViewModel>;
        }));
    }

    protected processBuild(response: HttpResponseBase): Observable<BuildSurveyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BuildSurveyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BuildSurveyViewModel>(null as any);
    }

    report(startDate: Date | undefined, endDate: Date | undefined): Observable<ReportViewModel> {
        let url_ = this.baseUrl + "/api/voc/signup/report?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportViewModel>;
        }));
    }

    protected processReport(response: HttpResponseBase): Observable<ReportViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportViewModel>(null as any);
    }

    completedSurveysPerSaaSBusiness(serviceId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/voc/signup/{serviceId}/completedsurveys";
        if (serviceId === undefined || serviceId === null)
            throw new Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCompletedSurveysPerSaaSBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletedSurveysPerSaaSBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCompletedSurveysPerSaaSBusiness(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ISurveyAnswerClient {
    get(surveyAnswerId: string): Observable<GetSurveyAnswerViewModel>;
    updateState(surveyAnswerId: string, state: SurveyState | undefined): Observable<boolean>;
    getProject(id: string, loadDemoData: boolean | undefined): Observable<GetProjectByAnswerIdViewModel>;
    getSurveyAnswersByStatus(projectId: string, state: SurveyState, filter: GetSurveyAnswersByStateFilter): Observable<GetSurveyAnswersByStateViewModel>;
    getSurveyAnswerExtraDetails(surveyAnswerId: string): Observable<GetSurveyAnswerExtraDetailsViewModel>;
}

@Injectable()
export class SurveyAnswerClient extends ClientBase implements ISurveyAnswerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(surveyAnswerId: string): Observable<GetSurveyAnswerViewModel> {
        let url_ = this.baseUrl + "/api/voc/surveyanswers/{surveyAnswerId}";
        if (surveyAnswerId === undefined || surveyAnswerId === null)
            throw new Error("The parameter 'surveyAnswerId' must be defined.");
        url_ = url_.replace("{surveyAnswerId}", encodeURIComponent("" + surveyAnswerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyAnswerViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyAnswerViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetSurveyAnswerViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyAnswerViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyAnswerViewModel>(null as any);
    }

    updateState(surveyAnswerId: string, state: SurveyState | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/surveyanswers/{surveyAnswerId}/state?";
        if (surveyAnswerId === undefined || surveyAnswerId === null)
            throw new Error("The parameter 'surveyAnswerId' must be defined.");
        url_ = url_.replace("{surveyAnswerId}", encodeURIComponent("" + surveyAnswerId));
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateState(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getProject(id: string, loadDemoData: boolean | undefined): Observable<GetProjectByAnswerIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/surveyanswers/{id}/projects?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (loadDemoData === null)
            throw new Error("The parameter 'loadDemoData' cannot be null.");
        else if (loadDemoData !== undefined)
            url_ += "loadDemoData=" + encodeURIComponent("" + loadDemoData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectByAnswerIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectByAnswerIdViewModel>;
        }));
    }

    protected processGetProject(response: HttpResponseBase): Observable<GetProjectByAnswerIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectByAnswerIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectByAnswerIdViewModel>(null as any);
    }

    getSurveyAnswersByStatus(projectId: string, state: SurveyState, filter: GetSurveyAnswersByStateFilter): Observable<GetSurveyAnswersByStateViewModel> {
        let url_ = this.baseUrl + "/api/voc/surveyanswers/projects/{projectId}/state/{state}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined.");
        url_ = url_.replace("{state}", encodeURIComponent("" + state));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyAnswersByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyAnswersByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyAnswersByStateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyAnswersByStateViewModel>;
        }));
    }

    protected processGetSurveyAnswersByStatus(response: HttpResponseBase): Observable<GetSurveyAnswersByStateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyAnswersByStateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyAnswersByStateViewModel>(null as any);
    }

    getSurveyAnswerExtraDetails(surveyAnswerId: string): Observable<GetSurveyAnswerExtraDetailsViewModel> {
        let url_ = this.baseUrl + "/api/voc/surveyanswers/{surveyAnswerId}/extra";
        if (surveyAnswerId === undefined || surveyAnswerId === null)
            throw new Error("The parameter 'surveyAnswerId' must be defined.");
        url_ = url_.replace("{surveyAnswerId}", encodeURIComponent("" + surveyAnswerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyAnswerExtraDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyAnswerExtraDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyAnswerExtraDetailsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyAnswerExtraDetailsViewModel>;
        }));
    }

    protected processGetSurveyAnswerExtraDetails(response: HttpResponseBase): Observable<GetSurveyAnswerExtraDetailsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyAnswerExtraDetailsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyAnswerExtraDetailsViewModel>(null as any);
    }
}

export interface ISurveyAnswerCustomImportFieldJobClient {
    get(projectId: string, subscriptionServiceId: string): Observable<GetCustomImportJobsViewModel>;
    addCustomImportJob(projectId: string, subscriptionServiceId: string, options: SurveyAnswerCustomImportFieldJobOptions): Observable<FileResponse>;
}

@Injectable()
export class SurveyAnswerCustomImportFieldJobClient extends ClientBase implements ISurveyAnswerCustomImportFieldJobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(projectId: string, subscriptionServiceId: string): Observable<GetCustomImportJobsViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/customimport-jobs";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomImportJobsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomImportJobsViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetCustomImportJobsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomImportJobsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomImportJobsViewModel>(null as any);
    }

    addCustomImportJob(projectId: string, subscriptionServiceId: string, options: SurveyAnswerCustomImportFieldJobOptions): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/customimport-jobs";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddCustomImportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomImportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAddCustomImportJob(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ISurveyClient {
    get(surveyId: string, projectId: string, subscriptionServiceId: string): Observable<GetSurveyViewModel>;
    delete(surveyId: string, projectId: string, subscriptionServiceId: string): Observable<DeleteSurveyViewModel>;
    create(projectId: string, subscriptionServiceId: string, createSurveyCommandDto: CreateSurveyCommandDto): Observable<CreateSurveyViewModel>;
    update(projectId: string, subscriptionServiceId: string, updateSurveyCommandDto: UpdateSurveyCommandDto): Observable<UpdateSurveyViewModel>;
}

@Injectable()
export class SurveyClient extends ClientBase implements ISurveyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(surveyId: string, projectId: string, subscriptionServiceId: string): Observable<GetSurveyViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetSurveyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyViewModel>(null as any);
    }

    delete(surveyId: string, projectId: string, subscriptionServiceId: string): Observable<DeleteSurveyViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteSurveyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteSurveyViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteSurveyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteSurveyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteSurveyViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, createSurveyCommandDto: CreateSurveyCommandDto): Observable<CreateSurveyViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createSurveyCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSurveyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSurveyViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateSurveyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSurveyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSurveyViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, updateSurveyCommandDto: UpdateSurveyCommandDto): Observable<UpdateSurveyViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateSurveyCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSurveyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSurveyViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateSurveyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSurveyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateSurveyViewModel>(null as any);
    }
}

export interface ISurveyProjectClient {
    get(projectId: string, subscriptionServiceId: string): Observable<GetSurveyProjectByIdViewModel>;
    create(projectId: string, subscriptionServiceId: string, createSurveyProjectCommandDto: CreateSurveyProjectCommandDto): Observable<CreateSurveyProjectViewModel>;
    update(projectId: string, subscriptionServiceId: string, updateSurveyProjectCommandDto: UpdateSurveyProjectCommandDto): Observable<UpdateSurveyProjectViewModel>;
    delete(projectId: string, subscriptionServiceId: string): Observable<DeleteSurveyProjectViewModel>;
}

@Injectable()
export class SurveyProjectClient extends ClientBase implements ISurveyProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(projectId: string, subscriptionServiceId: string): Observable<GetSurveyProjectByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveyProjects";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSurveyProjectByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSurveyProjectByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetSurveyProjectByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSurveyProjectByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyProjectByIdViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, createSurveyProjectCommandDto: CreateSurveyProjectCommandDto): Observable<CreateSurveyProjectViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveyProjects";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createSurveyProjectCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSurveyProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSurveyProjectViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateSurveyProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSurveyProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSurveyProjectViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, updateSurveyProjectCommandDto: UpdateSurveyProjectCommandDto): Observable<UpdateSurveyProjectViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveyProjects";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateSurveyProjectCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSurveyProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSurveyProjectViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateSurveyProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSurveyProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateSurveyProjectViewModel>(null as any);
    }

    delete(projectId: string, subscriptionServiceId: string): Observable<DeleteSurveyProjectViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveyProjects";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteSurveyProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteSurveyProjectViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteSurveyProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteSurveyProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteSurveyProjectViewModel>(null as any);
    }
}

export interface ITemplateClient {
    get(templateId: string, projectId: string, subscriptionServiceId: string): Observable<GetTemplateByIdViewModel>;
    delete(templateId: string, projectId: string, subscriptionServiceId: string): Observable<DeleteTemplateViewModel>;
    create(projectId: string, subscriptionServiceId: string, createTemplateCommandDto: CreateTemplateCommandDto): Observable<CreateTemplateViewModel>;
    update(projectId: string, subscriptionServiceId: string, updateTemplateCommandDto: UpdateTemplateCommandDto): Observable<UpdateTemplateViewModel>;
}

@Injectable()
export class TemplateClient extends ClientBase implements ITemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(templateId: string, projectId: string, subscriptionServiceId: string): Observable<GetTemplateByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTemplateByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTemplateByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetTemplateByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTemplateByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTemplateByIdViewModel>(null as any);
    }

    delete(templateId: string, projectId: string, subscriptionServiceId: string): Observable<DeleteTemplateViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteTemplateViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteTemplateViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, createTemplateCommandDto: CreateTemplateCommandDto): Observable<CreateTemplateViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/templates";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createTemplateCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTemplateViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTemplateViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, updateTemplateCommandDto: UpdateTemplateCommandDto): Observable<UpdateTemplateViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/templates";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTemplateCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTemplateViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTemplateViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateTemplateViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTemplateViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateTemplateViewModel>(null as any);
    }
}

export interface ITemplateCulturesClient {
    get(cultureId: string, projectId: string, subscriptionServiceId: string, templateId: string): Observable<GetTemplateCultureByIdViewModel>;
    delete(cultureId: string, projectId: string, subscriptionServiceId: string, templateId: string): Observable<DeleteTemplateCultureViewModel>;
    create(projectId: string, subscriptionServiceId: string, templateId: string, createTemplateCultureCommandDto: CreateTemplateCultureCommandDto): Observable<CreateTemplateCultureViewModel>;
    update(projectId: string, subscriptionServiceId: string, templateId: string, updateTemplateCultureCommandDto: UpdateTemplateCultureCommandDto): Observable<UpdateTemplateCultureViewModel>;
}

@Injectable()
export class TemplateCulturesClient extends ClientBase implements ITemplateCulturesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(cultureId: string, projectId: string, subscriptionServiceId: string, templateId: string): Observable<GetTemplateCultureByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/templates/{templateId}/cultures/{cultureId}";
        if (cultureId === undefined || cultureId === null)
            throw new Error("The parameter 'cultureId' must be defined.");
        url_ = url_.replace("{cultureId}", encodeURIComponent("" + cultureId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTemplateCultureByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTemplateCultureByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetTemplateCultureByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTemplateCultureByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTemplateCultureByIdViewModel>(null as any);
    }

    delete(cultureId: string, projectId: string, subscriptionServiceId: string, templateId: string): Observable<DeleteTemplateCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/templates/{templateId}/cultures/{cultureId}";
        if (cultureId === undefined || cultureId === null)
            throw new Error("The parameter 'cultureId' must be defined.");
        url_ = url_.replace("{cultureId}", encodeURIComponent("" + cultureId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteTemplateCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteTemplateCultureViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteTemplateCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteTemplateCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteTemplateCultureViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, templateId: string, createTemplateCultureCommandDto: CreateTemplateCultureCommandDto): Observable<CreateTemplateCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/templates/{templateId}/cultures";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createTemplateCultureCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTemplateCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTemplateCultureViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateTemplateCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTemplateCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTemplateCultureViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, templateId: string, updateTemplateCultureCommandDto: UpdateTemplateCultureCommandDto): Observable<UpdateTemplateCultureViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/templates/{templateId}/cultures";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTemplateCultureCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTemplateCultureViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTemplateCultureViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateTemplateCultureViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTemplateCultureViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateTemplateCultureViewModel>(null as any);
    }
}

export interface ITemplateCultureValuesClient {
    get(cultureValueId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<GetTemplateCultureValueByIdViewModel>;
    delete(cultureValueId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<DeleteTemplateCultureValueViewModel>;
    create(projectId: string, subscriptionServiceId: string, surveyId: string, createTemplateLanguageValueCommandDto: CreateTemplateCultureValueCommandDto): Observable<CreateTemplateCultureValueViewModel>;
    update(projectId: string, subscriptionServiceId: string, surveyId: string, updateTemplateLanguageValueCommandDto: UpdateTemplateCultureValueCommandDto): Observable<UpdateTemplateCultureValueViewModel>;
}

@Injectable()
export class TemplateCultureValuesClient extends ClientBase implements ITemplateCultureValuesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(cultureValueId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<GetTemplateCultureValueByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/templateCultureValues/{cultureValueId}";
        if (cultureValueId === undefined || cultureValueId === null)
            throw new Error("The parameter 'cultureValueId' must be defined.");
        url_ = url_.replace("{cultureValueId}", encodeURIComponent("" + cultureValueId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTemplateCultureValueByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTemplateCultureValueByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetTemplateCultureValueByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTemplateCultureValueByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTemplateCultureValueByIdViewModel>(null as any);
    }

    delete(cultureValueId: string, projectId: string, subscriptionServiceId: string, surveyId: string): Observable<DeleteTemplateCultureValueViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/templateCultureValues/{cultureValueId}";
        if (cultureValueId === undefined || cultureValueId === null)
            throw new Error("The parameter 'cultureValueId' must be defined.");
        url_ = url_.replace("{cultureValueId}", encodeURIComponent("" + cultureValueId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteTemplateCultureValueViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteTemplateCultureValueViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteTemplateCultureValueViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteTemplateCultureValueViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteTemplateCultureValueViewModel>(null as any);
    }

    create(projectId: string, subscriptionServiceId: string, surveyId: string, createTemplateLanguageValueCommandDto: CreateTemplateCultureValueCommandDto): Observable<CreateTemplateCultureValueViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/templateCultureValues";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createTemplateLanguageValueCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTemplateCultureValueViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTemplateCultureValueViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateTemplateCultureValueViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTemplateCultureValueViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTemplateCultureValueViewModel>(null as any);
    }

    update(projectId: string, subscriptionServiceId: string, surveyId: string, updateTemplateLanguageValueCommandDto: UpdateTemplateCultureValueCommandDto): Observable<UpdateTemplateCultureValueViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveys/{surveyId}/templateCultureValues";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTemplateLanguageValueCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTemplateCultureValueViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTemplateCultureValueViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateTemplateCultureValueViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTemplateCultureValueViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateTemplateCultureValueViewModel>(null as any);
    }
}

export interface IUserBookmarkClient {
    create(subscriptionServiceId: string, projectId: string, dto: CreateUserBookmarkDto): Observable<CreateUserBookmarkViewModel>;
    get(subscriptionServiceId: string, projectId: string, userBookmarkSection: UserBookmarkSection): Observable<GetUserBookmarkByCurrentUserViewModel[]>;
    delete(subscriptionServiceId: string, projectId: string, bookmarkId: string): Observable<boolean>;
}

@Injectable()
export class UserBookmarkClient extends ClientBase implements IUserBookmarkClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    create(subscriptionServiceId: string, projectId: string, dto: CreateUserBookmarkDto): Observable<CreateUserBookmarkViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/bookmarks";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateUserBookmarkViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateUserBookmarkViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateUserBookmarkViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUserBookmarkViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateUserBookmarkViewModel>(null as any);
    }

    get(subscriptionServiceId: string, projectId: string, userBookmarkSection: UserBookmarkSection): Observable<GetUserBookmarkByCurrentUserViewModel[]> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/bookmarks/section/{userBookmarkSection}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (userBookmarkSection === undefined || userBookmarkSection === null)
            throw new Error("The parameter 'userBookmarkSection' must be defined.");
        url_ = url_.replace("{userBookmarkSection}", encodeURIComponent("" + userBookmarkSection));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserBookmarkByCurrentUserViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserBookmarkByCurrentUserViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetUserBookmarkByCurrentUserViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserBookmarkByCurrentUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserBookmarkByCurrentUserViewModel[]>(null as any);
    }

    delete(subscriptionServiceId: string, projectId: string, bookmarkId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/bookmarks/{bookmarkId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (bookmarkId === undefined || bookmarkId === null)
            throw new Error("The parameter 'bookmarkId' must be defined.");
        url_ = url_.replace("{bookmarkId}", encodeURIComponent("" + bookmarkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IVocClientClient {
    compareBranchInputsValidation(branchId: string | undefined, branchCode: string | null | undefined): Observable<CompareBranchInputsViewModel>;
}

@Injectable()
export class VocClientClient extends ClientBase implements IVocClientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    compareBranchInputsValidation(branchId: string | undefined, branchCode: string | null | undefined): Observable<CompareBranchInputsViewModel> {
        let url_ = this.baseUrl + "/api/voc/client/branchCodeInput/validate?";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        if (branchCode !== undefined && branchCode !== null)
            url_ += "branchCode=" + encodeURIComponent("" + branchCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCompareBranchInputsValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompareBranchInputsValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompareBranchInputsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompareBranchInputsViewModel>;
        }));
    }

    protected processCompareBranchInputsValidation(response: HttpResponseBase): Observable<CompareBranchInputsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompareBranchInputsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompareBranchInputsViewModel>(null as any);
    }
}

export interface IVocPdfClient {
    getWebSurvey(answerId: string, projectId: string, subscriptionServiceId: string): Observable<FileResponse>;
}

@Injectable()
export class VocPdfClient extends ClientBase implements IVocPdfClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getWebSurvey(answerId: string, projectId: string, subscriptionServiceId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/surveyanswers/{answerId}";
        if (answerId === undefined || answerId === null)
            throw new Error("The parameter 'answerId' must be defined.");
        url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWebSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetWebSurvey(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IVoCProjectsClient {
    getList(subscriptionServiceId: string, lang: string | null | undefined): Observable<ProjectLangDto[]>;
    create(subscriptionServiceId: string, createVocProjectCommandDto: CreateVocProjectCommandDto): Observable<CreateVocProjectViewModel>;
    update(subscriptionServiceId: string, updateVocProjectCommandDto: UpdateVocProjectCommandDto): Observable<UpdateVocProjectViewModel>;
    get(projectId: string, subscriptionServiceId: string): Observable<GetVocProjectByIdViewModel>;
    delete(projectId: string, subscriptionServiceId: string): Observable<DeleteVocProjectViewModel>;
    updateCurrentPredefined(projectId: string, subscriptionServiceId: string): Observable<void>;
    updateAllPredefined(subscriptionServiceId: string): Observable<void>;
    getProjectOptions(projectId: string, subscriptionServiceId: string): Observable<ProjectOptionsViewModel>;
    getProjectDashboard(projectId: string, pageType: VocDashboardPageType | undefined, subscriptionServiceId: string): Observable<ProjectDashboardViewModel>;
    getDashboardWidget(subscriptionServiceId: string, projectId: string, widgetType: DashboardWidgetType2, options: DashboardOptions): Observable<DashboardWidgetViewModel>;
    getTrendsOptions(subscriptionServiceId: string, projectId: string): Observable<DashboardFilterSet>;
    getTrends(subscriptionServiceId: string, projectId: string, options: DashboardOptions): Observable<TrendsPageViewModel>;
    getCompetitorDetailPage(subscriptionServiceId: string, projectId: string, options: DashboardOptions): Observable<CompetitorDetailPage>;
    getUrls(projectId: string, subscriptionServiceId: string): Observable<ProjectUrl[]>;
}

@Injectable()
export class VoCProjectsClient extends ClientBase implements IVoCProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(subscriptionServiceId: string, lang: string | null | undefined): Observable<ProjectLangDto[]> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectLangDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectLangDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ProjectLangDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectLangDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectLangDto[]>(null as any);
    }

    create(subscriptionServiceId: string, createVocProjectCommandDto: CreateVocProjectCommandDto): Observable<CreateVocProjectViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createVocProjectCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateVocProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateVocProjectViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateVocProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateVocProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateVocProjectViewModel>(null as any);
    }

    update(subscriptionServiceId: string, updateVocProjectCommandDto: UpdateVocProjectCommandDto): Observable<UpdateVocProjectViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateVocProjectCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateVocProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateVocProjectViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateVocProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateVocProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateVocProjectViewModel>(null as any);
    }

    get(projectId: string, subscriptionServiceId: string): Observable<GetVocProjectByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetVocProjectByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetVocProjectByIdViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetVocProjectByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVocProjectByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVocProjectByIdViewModel>(null as any);
    }

    delete(projectId: string, subscriptionServiceId: string): Observable<DeleteVocProjectViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteVocProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteVocProjectViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteVocProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteVocProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteVocProjectViewModel>(null as any);
    }

    updateCurrentPredefined(projectId: string, subscriptionServiceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/OverwriteFromPredefined";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCurrentPredefined(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentPredefined(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentPredefined(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    updateAllPredefined(subscriptionServiceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/OverwriteFromPredefined";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAllPredefined(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllPredefined(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllPredefined(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getProjectOptions(projectId: string, subscriptionServiceId: string): Observable<ProjectOptionsViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/options";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectOptionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectOptionsViewModel>;
        }));
    }

    protected processGetProjectOptions(response: HttpResponseBase): Observable<ProjectOptionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectOptionsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectOptionsViewModel>(null as any);
    }

    getProjectDashboard(projectId: string, pageType: VocDashboardPageType | undefined, subscriptionServiceId: string): Observable<ProjectDashboardViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/dashboard?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (pageType === null)
            throw new Error("The parameter 'pageType' cannot be null.");
        else if (pageType !== undefined)
            url_ += "pageType=" + encodeURIComponent("" + pageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDashboardViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDashboardViewModel>;
        }));
    }

    protected processGetProjectDashboard(response: HttpResponseBase): Observable<ProjectDashboardViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDashboardViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDashboardViewModel>(null as any);
    }

    getDashboardWidget(subscriptionServiceId: string, projectId: string, widgetType: DashboardWidgetType2, options: DashboardOptions): Observable<DashboardWidgetViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/dashboard/overview/{widgetType}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (widgetType === undefined || widgetType === null)
            throw new Error("The parameter 'widgetType' must be defined.");
        url_ = url_.replace("{widgetType}", encodeURIComponent("" + widgetType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDashboardWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardWidgetViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardWidgetViewModel>;
        }));
    }

    protected processGetDashboardWidget(response: HttpResponseBase): Observable<DashboardWidgetViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardWidgetViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardWidgetViewModel>(null as any);
    }

    getTrendsOptions(subscriptionServiceId: string, projectId: string): Observable<DashboardFilterSet> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/trends/options";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTrendsOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrendsOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardFilterSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardFilterSet>;
        }));
    }

    protected processGetTrendsOptions(response: HttpResponseBase): Observable<DashboardFilterSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardFilterSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardFilterSet>(null as any);
    }

    getTrends(subscriptionServiceId: string, projectId: string, options: DashboardOptions): Observable<TrendsPageViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/trends";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTrends(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrends(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrendsPageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrendsPageViewModel>;
        }));
    }

    protected processGetTrends(response: HttpResponseBase): Observable<TrendsPageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrendsPageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrendsPageViewModel>(null as any);
    }

    getCompetitorDetailPage(subscriptionServiceId: string, projectId: string, options: DashboardOptions): Observable<CompetitorDetailPage> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/Competitors";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCompetitorDetailPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompetitorDetailPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompetitorDetailPage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompetitorDetailPage>;
        }));
    }

    protected processGetCompetitorDetailPage(response: HttpResponseBase): Observable<CompetitorDetailPage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitorDetailPage.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompetitorDetailPage>(null as any);
    }

    getUrls(projectId: string, subscriptionServiceId: string): Observable<ProjectUrl[]> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}/projects/{projectId}/urls";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUrls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectUrl[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectUrl[]>;
        }));
    }

    protected processGetUrls(response: HttpResponseBase): Observable<ProjectUrl[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectUrl.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectUrl[]>(null as any);
    }
}

export interface IVoiceOfCustomerServiceClient {
    get(subscriptionServiceId: string): Observable<GetVoiceOfCustomerServiceViewModel>;
    delete(subscriptionServiceId: string): Observable<DeleteVoiceOfCustomerServiceViewModel>;
    create(createVoiceOfCustomerServiceCommandDto: CreateVoiceOfCustomerServiceCommandDto): Observable<CreateVoiceOfCustomerServiceViewModel>;
    update(updateVoiceOfCustomerServiceCommandDto: UpdateVoiceOfCustomerServiceCommandDto): Observable<UpdateVoiceOfCustomerViewModel>;
}

@Injectable()
export class VoiceOfCustomerServiceClient extends ClientBase implements IVoiceOfCustomerServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    get(subscriptionServiceId: string): Observable<GetVoiceOfCustomerServiceViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetVoiceOfCustomerServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetVoiceOfCustomerServiceViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetVoiceOfCustomerServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVoiceOfCustomerServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoiceOfCustomerServiceViewModel>(null as any);
    }

    delete(subscriptionServiceId: string): Observable<DeleteVoiceOfCustomerServiceViewModel> {
        let url_ = this.baseUrl + "/api/voc/{subscriptionServiceId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteVoiceOfCustomerServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteVoiceOfCustomerServiceViewModel>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteVoiceOfCustomerServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteVoiceOfCustomerServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteVoiceOfCustomerServiceViewModel>(null as any);
    }

    create(createVoiceOfCustomerServiceCommandDto: CreateVoiceOfCustomerServiceCommandDto): Observable<CreateVoiceOfCustomerServiceViewModel> {
        let url_ = this.baseUrl + "/api/voc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createVoiceOfCustomerServiceCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateVoiceOfCustomerServiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateVoiceOfCustomerServiceViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateVoiceOfCustomerServiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateVoiceOfCustomerServiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateVoiceOfCustomerServiceViewModel>(null as any);
    }

    update(updateVoiceOfCustomerServiceCommandDto: UpdateVoiceOfCustomerServiceCommandDto): Observable<UpdateVoiceOfCustomerViewModel> {
        let url_ = this.baseUrl + "/api/voc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateVoiceOfCustomerServiceCommandDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateVoiceOfCustomerViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateVoiceOfCustomerViewModel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateVoiceOfCustomerViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateVoiceOfCustomerViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateVoiceOfCustomerViewModel>(null as any);
    }
}

export interface ICategoryClient {
    getList(subscriptionServiceId: string, projectId: string): Observable<GetCategoriesViewModel>;
    add(subscriptionServiceId: string, projectId: string, category: CategoryDto2): Observable<string>;
    getById(subscriptionServiceId: string, projectId: string, categoryId: string): Observable<GetCategoryByIdViewModel>;
    update(subscriptionServiceId: string, projectId: string, categoryId: string, category: CategoryDto2): Observable<void>;
    delete(subscriptionServiceId: string, projectId: string, categoryId: string): Observable<void>;
}

@Injectable()
export class CategoryClient extends ClientBase implements ICategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(subscriptionServiceId: string, projectId: string): Observable<GetCategoriesViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/categories";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCategoriesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCategoriesViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetCategoriesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCategoriesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCategoriesViewModel>(null as any);
    }

    add(subscriptionServiceId: string, projectId: string, category: CategoryDto2): Observable<string> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/categories";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    getById(subscriptionServiceId: string, projectId: string, categoryId: string): Observable<GetCategoryByIdViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/categories/{categoryId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCategoryByIdViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCategoryByIdViewModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetCategoryByIdViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCategoryByIdViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCategoryByIdViewModel>(null as any);
    }

    update(subscriptionServiceId: string, projectId: string, categoryId: string, category: CategoryDto2): Observable<void> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/categories/{categoryId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    delete(subscriptionServiceId: string, projectId: string, categoryId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/categories/{categoryId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IChatGptClient {
    post(dto: PromptDto): Observable<PromptCommandViewModel>;
}

@Injectable()
export class ChatGptClient extends ClientBase implements IChatGptClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    post(dto: PromptDto): Observable<PromptCommandViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/gpt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromptCommandViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromptCommandViewModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<PromptCommandViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromptCommandViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PromptCommandViewModel>(null as any);
    }
}

export interface ICustomImportConfigurationClient {
    getList(subscriptionServiceId: string): Observable<GetCustomImportConfigurationsViewModel>;
    insert(subscriptionServiceId: string, name: string | null | undefined): Observable<string>;
    get(subscriptionServiceId: string, customImportConfigurationId: string): Observable<GetCustomImportConfigurationViewModel>;
    update(subscriptionServiceId: string, customImportConfigurationId: string, dto: UpdateCustomImportConfigurationDto): Observable<boolean>;
    delete(subscriptionServiceId: string, customImportConfigurationId: string): Observable<boolean>;
}

@Injectable()
export class CustomImportConfigurationClient extends ClientBase implements ICustomImportConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(subscriptionServiceId: string): Observable<GetCustomImportConfigurationsViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/custom-import-configurations";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomImportConfigurationsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomImportConfigurationsViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetCustomImportConfigurationsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomImportConfigurationsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomImportConfigurationsViewModel>(null as any);
    }

    insert(subscriptionServiceId: string, name: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/custom-import-configurations?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    get(subscriptionServiceId: string, customImportConfigurationId: string): Observable<GetCustomImportConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/custom-import-configurations/{customImportConfigurationId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (customImportConfigurationId === undefined || customImportConfigurationId === null)
            throw new Error("The parameter 'customImportConfigurationId' must be defined.");
        url_ = url_.replace("{customImportConfigurationId}", encodeURIComponent("" + customImportConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomImportConfigurationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomImportConfigurationViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetCustomImportConfigurationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomImportConfigurationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomImportConfigurationViewModel>(null as any);
    }

    update(subscriptionServiceId: string, customImportConfigurationId: string, dto: UpdateCustomImportConfigurationDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/custom-import-configurations/{customImportConfigurationId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (customImportConfigurationId === undefined || customImportConfigurationId === null)
            throw new Error("The parameter 'customImportConfigurationId' must be defined.");
        url_ = url_.replace("{customImportConfigurationId}", encodeURIComponent("" + customImportConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    delete(subscriptionServiceId: string, customImportConfigurationId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/custom-import-configurations/{customImportConfigurationId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (customImportConfigurationId === undefined || customImportConfigurationId === null)
            throw new Error("The parameter 'customImportConfigurationId' must be defined.");
        url_ = url_.replace("{customImportConfigurationId}", encodeURIComponent("" + customImportConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface ICustomImportProjectConfigurationClient {
    getList(subscriptionServiceId: string, projectId: string): Observable<GetCustomImportProjectConfigurationsViewModel>;
    insert(subscriptionServiceId: string, projectId: string, dto: EditCustomImportProjectConfigurationDto): Observable<string>;
    get(subscriptionServiceId: string, projectId: string, customImportProjectConfigurationId: string): Observable<GetCustomImportProjectConfigurationViewModel>;
    update(subscriptionServiceId: string, projectId: string, customImportProjectConfigurationId: string, dto: EditCustomImportProjectConfigurationDto): Observable<boolean>;
    delete(subscriptionServiceId: string, projectId: string, customImportProjectConfigurationId: string): Observable<boolean>;
    getExport(subscriptionServiceId: string, projectId: string, customImportProjectConfigurationId: string): Observable<GetExportCustomImportLinksViewModel>;
    export(subscriptionServiceId: string, projectId: string, customImportProjectConfigurationId: string, exportType: ExportTableType | undefined, filterOptions: ExportCustomImportFilterOptions): Observable<FileResponse>;
}

@Injectable()
export class CustomImportProjectConfigurationClient extends ClientBase implements ICustomImportProjectConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getList(subscriptionServiceId: string, projectId: string): Observable<GetCustomImportProjectConfigurationsViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/custom-import-project-configurations";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomImportProjectConfigurationsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomImportProjectConfigurationsViewModel>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<GetCustomImportProjectConfigurationsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomImportProjectConfigurationsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomImportProjectConfigurationsViewModel>(null as any);
    }

    insert(subscriptionServiceId: string, projectId: string, dto: EditCustomImportProjectConfigurationDto): Observable<string> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/custom-import-project-configurations";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    get(subscriptionServiceId: string, projectId: string, customImportProjectConfigurationId: string): Observable<GetCustomImportProjectConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/custom-import-project-configurations/{customImportProjectConfigurationId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (customImportProjectConfigurationId === undefined || customImportProjectConfigurationId === null)
            throw new Error("The parameter 'customImportProjectConfigurationId' must be defined.");
        url_ = url_.replace("{customImportProjectConfigurationId}", encodeURIComponent("" + customImportProjectConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomImportProjectConfigurationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomImportProjectConfigurationViewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetCustomImportProjectConfigurationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomImportProjectConfigurationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomImportProjectConfigurationViewModel>(null as any);
    }

    update(subscriptionServiceId: string, projectId: string, customImportProjectConfigurationId: string, dto: EditCustomImportProjectConfigurationDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/custom-import-project-configurations/{customImportProjectConfigurationId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (customImportProjectConfigurationId === undefined || customImportProjectConfigurationId === null)
            throw new Error("The parameter 'customImportProjectConfigurationId' must be defined.");
        url_ = url_.replace("{customImportProjectConfigurationId}", encodeURIComponent("" + customImportProjectConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    delete(subscriptionServiceId: string, projectId: string, customImportProjectConfigurationId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/custom-import-project-configurations/{customImportProjectConfigurationId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (customImportProjectConfigurationId === undefined || customImportProjectConfigurationId === null)
            throw new Error("The parameter 'customImportProjectConfigurationId' must be defined.");
        url_ = url_.replace("{customImportProjectConfigurationId}", encodeURIComponent("" + customImportProjectConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getExport(subscriptionServiceId: string, projectId: string, customImportProjectConfigurationId: string): Observable<GetExportCustomImportLinksViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/custom-import-project-configurations/{customImportProjectConfigurationId}/export";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (customImportProjectConfigurationId === undefined || customImportProjectConfigurationId === null)
            throw new Error("The parameter 'customImportProjectConfigurationId' must be defined.");
        url_ = url_.replace("{customImportProjectConfigurationId}", encodeURIComponent("" + customImportProjectConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExportCustomImportLinksViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExportCustomImportLinksViewModel>;
        }));
    }

    protected processGetExport(response: HttpResponseBase): Observable<GetExportCustomImportLinksViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExportCustomImportLinksViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExportCustomImportLinksViewModel>(null as any);
    }

    export(subscriptionServiceId: string, projectId: string, customImportProjectConfigurationId: string, exportType: ExportTableType | undefined, filterOptions: ExportCustomImportFilterOptions): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/custom-import-project-configurations/{customImportProjectConfigurationId}/export?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (customImportProjectConfigurationId === undefined || customImportProjectConfigurationId === null)
            throw new Error("The parameter 'customImportProjectConfigurationId' must be defined.");
        url_ = url_.replace("{customImportProjectConfigurationId}", encodeURIComponent("" + customImportProjectConfigurationId));
        if (exportType === null)
            throw new Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IFormClient {
    getWizard(subscriptionServiceId: string, projectId: string): Observable<GetCreateFormWizardViewModel2>;
    createFromWizard(subscriptionServiceId: string, projectId: string, formVersionId: string | null | undefined): Observable<string>;
    transferFormVersion(subscriptionServiceId: string, projectId: string, formVersionId: string, dto: FormVersionTransferDto2): Observable<boolean>;
    exportFormVersionToWord(id: string, major: number, minor: number, subscriptionServiceId: string, projectId: string, intro: WordExportModel): Observable<FileResponse>;
}

@Injectable()
export class FormClient extends ClientBase implements IFormClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getWizard(subscriptionServiceId: string, projectId: string): Observable<GetCreateFormWizardViewModel2> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/forms/wizard";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWizard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWizard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCreateFormWizardViewModel2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCreateFormWizardViewModel2>;
        }));
    }

    protected processGetWizard(response: HttpResponseBase): Observable<GetCreateFormWizardViewModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateFormWizardViewModel2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCreateFormWizardViewModel2>(null as any);
    }

    createFromWizard(subscriptionServiceId: string, projectId: string, formVersionId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/forms/wizard?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formVersionId !== undefined && formVersionId !== null)
            url_ += "formVersionId=" + encodeURIComponent("" + formVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateFromWizard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFromWizard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateFromWizard(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    transferFormVersion(subscriptionServiceId: string, projectId: string, formVersionId: string, dto: FormVersionTransferDto2): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/forms/{formVersionId}/transfer";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formVersionId === undefined || formVersionId === null)
            throw new Error("The parameter 'formVersionId' must be defined.");
        url_ = url_.replace("{formVersionId}", encodeURIComponent("" + formVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTransferFormVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferFormVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTransferFormVersion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    exportFormVersionToWord(id: string, major: number, minor: number, subscriptionServiceId: string, projectId: string, intro: WordExportModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/forms/{id}/versions/{major}/{minor}/export";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (major === undefined || major === null)
            throw new Error("The parameter 'major' must be defined.");
        url_ = url_.replace("{major}", encodeURIComponent("" + major));
        if (minor === undefined || minor === null)
            throw new Error("The parameter 'minor' must be defined.");
        url_ = url_.replace("{minor}", encodeURIComponent("" + minor));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(intro);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFormVersionToWord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFormVersionToWord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportFormVersionToWord(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IProjectClient {
    getMove(subscriptionServiceId: string, projectId: string): Observable<GetMoveProjectViewModel>;
    move(subscriptionServiceId: string, projectId: string, targetSubscriptionServiceId: string | undefined): Observable<MoveProjectViewModel>;
    create(subscriptionServiceId: string, project: VocProjectDto): Observable<void>;
    getCreate(subscriptionServiceId: string): Observable<GetCreateProjectViewModel2>;
    get(subscriptionServiceId: string, projectId: string): Observable<GetProjectViewModel2>;
    update(subscriptionServiceId: string, projectId: string, project: VocProjectDto): Observable<void>;
    getCategories(subscriptionServiceId: string, projectId: string): Observable<SurveyJsBuilderViewModel>;
    getUrls(subscriptionServiceId: string, projectId: string): Observable<GetProjectUrlsViewModel>;
    createUrl(subscriptionServiceId: string, projectId: string, dto: EditProjectUrlDto): Observable<ProjectUrlSaveResult>;
    updateUrl(subscriptionServiceId: string, projectId: string, projectUrlId: string, dto: EditProjectUrlDto): Observable<ProjectUrlSaveResult>;
    deleteUrl(subscriptionServiceId: string, projectId: string, projectUrlId: string): Observable<boolean>;
    getForms(subscriptionServiceId: string, projectId: string): Observable<GetFormsViewModel>;
    getForm(subscriptionServiceId: string, projectId: string, formId: string): Observable<GetFormViewModel2>;
    publishForm(subscriptionServiceId: string, projectId: string, formId: string): Observable<boolean>;
    getVersion(subscriptionServiceId: string, projectId: string, formId: string, formVersionId: string): Observable<GetVersionViewModel>;
    updateVersion(subscriptionServiceId: string, projectId: string, formId: string, formVersionId: string, version: FormVersionPatchDto): Observable<boolean>;
    incrementVersion(subscriptionServiceId: string, projectId: string, formId: string, version: FormVersionPatchDto): Observable<boolean>;
    getDatePickerSequences(subscriptionServiceId: string, projectId: string): Observable<GetDatePickerSequenceListViewModel2>;
    updateDatePickerSequences(subscriptionServiceId: string, projectId: string, data: UpdateDatePickerSequenceListRequest2): Observable<boolean>;
}

@Injectable()
export class ProjectClient extends ClientBase implements IProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getMove(subscriptionServiceId: string, projectId: string): Observable<GetMoveProjectViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/move";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMoveProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMoveProjectViewModel>;
        }));
    }

    protected processGetMove(response: HttpResponseBase): Observable<GetMoveProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoveProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMoveProjectViewModel>(null as any);
    }

    move(subscriptionServiceId: string, projectId: string, targetSubscriptionServiceId: string | undefined): Observable<MoveProjectViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/move?";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (targetSubscriptionServiceId === null)
            throw new Error("The parameter 'targetSubscriptionServiceId' cannot be null.");
        else if (targetSubscriptionServiceId !== undefined)
            url_ += "targetSubscriptionServiceId=" + encodeURIComponent("" + targetSubscriptionServiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveProjectViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveProjectViewModel>;
        }));
    }

    protected processMove(response: HttpResponseBase): Observable<MoveProjectViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveProjectViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoveProjectViewModel>(null as any);
    }

    create(subscriptionServiceId: string, project: VocProjectDto): Observable<void> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getCreate(subscriptionServiceId: string): Observable<GetCreateProjectViewModel2> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/create";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCreateProjectViewModel2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCreateProjectViewModel2>;
        }));
    }

    protected processGetCreate(response: HttpResponseBase): Observable<GetCreateProjectViewModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreateProjectViewModel2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCreateProjectViewModel2>(null as any);
    }

    get(subscriptionServiceId: string, projectId: string): Observable<GetProjectViewModel2> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectViewModel2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectViewModel2>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetProjectViewModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectViewModel2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectViewModel2>(null as any);
    }

    update(subscriptionServiceId: string, projectId: string, project: VocProjectDto): Observable<void> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getCategories(subscriptionServiceId: string, projectId: string): Observable<SurveyJsBuilderViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/builder";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyJsBuilderViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyJsBuilderViewModel>;
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<SurveyJsBuilderViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyJsBuilderViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SurveyJsBuilderViewModel>(null as any);
    }

    getUrls(subscriptionServiceId: string, projectId: string): Observable<GetProjectUrlsViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/urls";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUrls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProjectUrlsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProjectUrlsViewModel>;
        }));
    }

    protected processGetUrls(response: HttpResponseBase): Observable<GetProjectUrlsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProjectUrlsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProjectUrlsViewModel>(null as any);
    }

    createUrl(subscriptionServiceId: string, projectId: string, dto: EditProjectUrlDto): Observable<ProjectUrlSaveResult> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/urls";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectUrlSaveResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectUrlSaveResult>;
        }));
    }

    protected processCreateUrl(response: HttpResponseBase): Observable<ProjectUrlSaveResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectUrlSaveResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectUrlSaveResult>(null as any);
    }

    updateUrl(subscriptionServiceId: string, projectId: string, projectUrlId: string, dto: EditProjectUrlDto): Observable<ProjectUrlSaveResult> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/urls/{projectUrlId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (projectUrlId === undefined || projectUrlId === null)
            throw new Error("The parameter 'projectUrlId' must be defined.");
        url_ = url_.replace("{projectUrlId}", encodeURIComponent("" + projectUrlId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectUrlSaveResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectUrlSaveResult>;
        }));
    }

    protected processUpdateUrl(response: HttpResponseBase): Observable<ProjectUrlSaveResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectUrlSaveResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectUrlSaveResult>(null as any);
    }

    deleteUrl(subscriptionServiceId: string, projectId: string, projectUrlId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/urls/{projectUrlId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (projectUrlId === undefined || projectUrlId === null)
            throw new Error("The parameter 'projectUrlId' must be defined.");
        url_ = url_.replace("{projectUrlId}", encodeURIComponent("" + projectUrlId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteUrl(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getForms(subscriptionServiceId: string, projectId: string): Observable<GetFormsViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/forms";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFormsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFormsViewModel>;
        }));
    }

    protected processGetForms(response: HttpResponseBase): Observable<GetFormsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFormsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormsViewModel>(null as any);
    }

    getForm(subscriptionServiceId: string, projectId: string, formId: string): Observable<GetFormViewModel2> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFormViewModel2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFormViewModel2>;
        }));
    }

    protected processGetForm(response: HttpResponseBase): Observable<GetFormViewModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFormViewModel2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormViewModel2>(null as any);
    }

    publishForm(subscriptionServiceId: string, projectId: string, formId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/publish";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPublishForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPublishForm(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getVersion(subscriptionServiceId: string, projectId: string, formId: string, formVersionId: string): Observable<GetVersionViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{formVersionId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (formVersionId === undefined || formVersionId === null)
            throw new Error("The parameter 'formVersionId' must be defined.");
        url_ = url_.replace("{formVersionId}", encodeURIComponent("" + formVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetVersionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetVersionViewModel>;
        }));
    }

    protected processGetVersion(response: HttpResponseBase): Observable<GetVersionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVersionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVersionViewModel>(null as any);
    }

    updateVersion(subscriptionServiceId: string, projectId: string, formId: string, formVersionId: string, version: FormVersionPatchDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions/{formVersionId}";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (formVersionId === undefined || formVersionId === null)
            throw new Error("The parameter 'formVersionId' must be defined.");
        url_ = url_.replace("{formVersionId}", encodeURIComponent("" + formVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(version);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateVersion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    incrementVersion(subscriptionServiceId: string, projectId: string, formId: string, version: FormVersionPatchDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/forms/{formId}/versions";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(version);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processIncrementVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIncrementVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIncrementVersion(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    getDatePickerSequences(subscriptionServiceId: string, projectId: string): Observable<GetDatePickerSequenceListViewModel2> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/datepicker-sequence";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDatePickerSequences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatePickerSequences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDatePickerSequenceListViewModel2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDatePickerSequenceListViewModel2>;
        }));
    }

    protected processGetDatePickerSequences(response: HttpResponseBase): Observable<GetDatePickerSequenceListViewModel2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDatePickerSequenceListViewModel2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDatePickerSequenceListViewModel2>(null as any);
    }

    updateDatePickerSequences(subscriptionServiceId: string, projectId: string, data: UpdateDatePickerSequenceListRequest2): Observable<boolean> {
        let url_ = this.baseUrl + "/api/voc/admin/{subscriptionServiceId}/projects/{projectId}/datepicker-sequence";
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDatePickerSequences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDatePickerSequences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateDatePickerSequences(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IProjectSearchClient {
    getByOrganization(organizationId: string): Observable<ProjectsListViewModel>;
    getBySubscription(organizationId: string, subscriptionId: string): Observable<ProjectsListViewModel>;
    getBySubscriptionService(organizationId: string, subscriptionId: string, subscriptionServiceId: string): Observable<ProjectsListViewModel>;
}

@Injectable()
export class ProjectSearchClient extends ClientBase implements IProjectSearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ConfigService) configuration: ConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    getByOrganization(organizationId: string): Observable<ProjectsListViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/project/search/organizations/{organizationId}/projects";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectsListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectsListViewModel>;
        }));
    }

    protected processGetByOrganization(response: HttpResponseBase): Observable<ProjectsListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectsListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectsListViewModel>(null as any);
    }

    getBySubscription(organizationId: string, subscriptionId: string): Observable<ProjectsListViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/project/search/organizations/{organizationId}/subscriptions/{subscriptionId}/projects";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBySubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectsListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectsListViewModel>;
        }));
    }

    protected processGetBySubscription(response: HttpResponseBase): Observable<ProjectsListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectsListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectsListViewModel>(null as any);
    }

    getBySubscriptionService(organizationId: string, subscriptionId: string, subscriptionServiceId: string): Observable<ProjectsListViewModel> {
        let url_ = this.baseUrl + "/api/voc/admin/project/search/organizations/{organizationId}/subscriptions/{subscriptionId}/subscriptionServices/{subscriptionServiceId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subscriptionServiceId === undefined || subscriptionServiceId === null)
            throw new Error("The parameter 'subscriptionServiceId' must be defined.");
        url_ = url_.replace("{subscriptionServiceId}", encodeURIComponent("" + subscriptionServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBySubscriptionService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySubscriptionService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectsListViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectsListViewModel>;
        }));
    }

    protected processGetBySubscriptionService(response: HttpResponseBase): Observable<ProjectsListViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectsListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectsListViewModel>(null as any);
    }
}

export enum ProcessStep {
    Unknown = 0,
    Notification = 1,
    FirstRaise = 2,
    SecondRaise = 3,
    ShareMission = 4,
    CallingList = 5,
    Done = 6,
}

export class GetAvailableMissionListFiltersViewModel implements IGetAvailableMissionListFiltersViewModel {
    organizations?: OrganizationFilter[];
    subscriptions?: SubscriptionFilter[];
    subscriptionServices?: SubscriptionServiceFilter[];
    projects?: ProjectFilter[];
    missionConfigurations?: MissionConfigurationFilter[];
    periods?: PeriodFilter[];

    constructor(data?: IGetAvailableMissionListFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationFilter.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(SubscriptionFilter.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(SubscriptionServiceFilter.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectFilter.fromJS(item));
            }
            if (Array.isArray(_data["missionConfigurations"])) {
                this.missionConfigurations = [] as any;
                for (let item of _data["missionConfigurations"])
                    this.missionConfigurations!.push(MissionConfigurationFilter.fromJS(item));
            }
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(PeriodFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableMissionListFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableMissionListFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.missionConfigurations)) {
            data["missionConfigurations"] = [];
            for (let item of this.missionConfigurations)
                data["missionConfigurations"].push(item.toJSON());
        }
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAvailableMissionListFiltersViewModel {
    organizations?: OrganizationFilter[];
    subscriptions?: SubscriptionFilter[];
    subscriptionServices?: SubscriptionServiceFilter[];
    projects?: ProjectFilter[];
    missionConfigurations?: MissionConfigurationFilter[];
    periods?: PeriodFilter[];
}

export class OrganizationFilter implements IOrganizationFilter {
    id?: string;
    name?: string;

    constructor(data?: IOrganizationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrganizationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IOrganizationFilter {
    id?: string;
    name?: string;
}

export class SubscriptionFilter implements ISubscriptionFilter {
    id?: string;
    name?: string;
    organizationId?: string;

    constructor(data?: ISubscriptionFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): SubscriptionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ISubscriptionFilter {
    id?: string;
    name?: string;
    organizationId?: string;
}

export class SubscriptionServiceFilter implements ISubscriptionServiceFilter {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;

    constructor(data?: ISubscriptionServiceFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): SubscriptionServiceFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionServiceFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface ISubscriptionServiceFilter {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
}

export class ProjectFilter implements IProjectFilter {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;

    constructor(data?: IProjectFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
        }
    }

    static fromJS(data: any): ProjectFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        return data;
    }
}

export interface IProjectFilter {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
}

export class MissionConfigurationFilter implements IMissionConfigurationFilter {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;

    constructor(data?: IMissionConfigurationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): MissionConfigurationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IMissionConfigurationFilter {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;
}

export class PeriodFilter implements IPeriodFilter {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;

    constructor(data?: IPeriodFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): PeriodFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IPeriodFilter {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;
}

export class GetAvailableMissionListViewModel implements IGetAvailableMissionListViewModel {
    missions?: PaginatedResponseOfGetAvailableMissionListMissionDto;

    constructor(data?: IGetAvailableMissionListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missions = _data["missions"] ? PaginatedResponseOfGetAvailableMissionListMissionDto.fromJS(_data["missions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAvailableMissionListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableMissionListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missions"] = this.missions ? this.missions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAvailableMissionListViewModel {
    missions?: PaginatedResponseOfGetAvailableMissionListMissionDto;
}

export class PaginatedResponseOfGetAvailableMissionListMissionDto implements IPaginatedResponseOfGetAvailableMissionListMissionDto {
    items?: GetAvailableMissionListMissionDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfGetAvailableMissionListMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAvailableMissionListMissionDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetAvailableMissionListMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetAvailableMissionListMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfGetAvailableMissionListMissionDto {
    items?: GetAvailableMissionListMissionDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class GetAvailableMissionListMissionDto implements IGetAvailableMissionListMissionDto {
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionName?: string | undefined;
    subscriptionServiceId?: string | undefined;
    subscriptionServiceName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    missionConfigurationId?: string | undefined;
    missionConfigurationName?: string | undefined;
    periodId?: string | undefined;
    periodName?: string | undefined;
    periodStartDate?: Date | undefined;
    periodEndDate?: Date | undefined;
    periodMissionConfigurationId?: string | undefined;
    missionsToComplete?: number | undefined;
    missionsTaken?: number;
    missionsLeft?: number | undefined;
    branchId?: string;
    branchCode?: string;
    branchName?: string;

    constructor(data?: IGetAvailableMissionListMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionName = _data["subscriptionName"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.subscriptionServiceName = _data["subscriptionServiceName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.periodId = _data["periodId"];
            this.periodName = _data["periodName"];
            this.periodStartDate = _data["periodStartDate"] ? new Date(_data["periodStartDate"].toString()) : <any>undefined;
            this.periodEndDate = _data["periodEndDate"] ? new Date(_data["periodEndDate"].toString()) : <any>undefined;
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.missionsToComplete = _data["missionsToComplete"];
            this.missionsTaken = _data["missionsTaken"];
            this.missionsLeft = _data["missionsLeft"];
            this.branchId = _data["branchId"];
            this.branchCode = _data["branchCode"];
            this.branchName = _data["branchName"];
        }
    }

    static fromJS(data: any): GetAvailableMissionListMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableMissionListMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionName"] = this.subscriptionName;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["subscriptionServiceName"] = this.subscriptionServiceName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["periodId"] = this.periodId;
        data["periodName"] = this.periodName;
        data["periodStartDate"] = this.periodStartDate ? this.periodStartDate.toISOString() : <any>undefined;
        data["periodEndDate"] = this.periodEndDate ? this.periodEndDate.toISOString() : <any>undefined;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["missionsToComplete"] = this.missionsToComplete;
        data["missionsTaken"] = this.missionsTaken;
        data["missionsLeft"] = this.missionsLeft;
        data["branchId"] = this.branchId;
        data["branchCode"] = this.branchCode;
        data["branchName"] = this.branchName;
        return data;
    }
}

export interface IGetAvailableMissionListMissionDto {
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionName?: string | undefined;
    subscriptionServiceId?: string | undefined;
    subscriptionServiceName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    missionConfigurationId?: string | undefined;
    missionConfigurationName?: string | undefined;
    periodId?: string | undefined;
    periodName?: string | undefined;
    periodStartDate?: Date | undefined;
    periodEndDate?: Date | undefined;
    periodMissionConfigurationId?: string | undefined;
    missionsToComplete?: number | undefined;
    missionsTaken?: number;
    missionsLeft?: number | undefined;
    branchId?: string;
    branchCode?: string;
    branchName?: string;
}

export class GetAvailableMissionListFilter implements IGetAvailableMissionListFilter {
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodId?: string | undefined;
    periodMissionConfigurationId?: string | undefined;
    branchIds?: string[] | undefined;
    branchSearch?: string | undefined;
    includeBranchesWithNoMissionsLeft?: boolean;

    constructor(data?: IGetAvailableMissionListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.periodId = _data["periodId"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            this.branchSearch = _data["branchSearch"];
            this.includeBranchesWithNoMissionsLeft = _data["includeBranchesWithNoMissionsLeft"];
        }
    }

    static fromJS(data: any): GetAvailableMissionListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableMissionListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["periodId"] = this.periodId;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        data["branchSearch"] = this.branchSearch;
        data["includeBranchesWithNoMissionsLeft"] = this.includeBranchesWithNoMissionsLeft;
        return data;
    }
}

export interface IGetAvailableMissionListFilter {
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodId?: string | undefined;
    periodMissionConfigurationId?: string | undefined;
    branchIds?: string[] | undefined;
    branchSearch?: string | undefined;
    includeBranchesWithNoMissionsLeft?: boolean;
}

export class GetCorporateWidgetOptionsListViewModel implements IGetCorporateWidgetOptionsListViewModel {
    corporateWidgetOptions?: CorporateWidgetOptionsDto[];

    constructor(data?: IGetCorporateWidgetOptionsListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["corporateWidgetOptions"])) {
                this.corporateWidgetOptions = [] as any;
                for (let item of _data["corporateWidgetOptions"])
                    this.corporateWidgetOptions!.push(CorporateWidgetOptionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCorporateWidgetOptionsListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCorporateWidgetOptionsListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.corporateWidgetOptions)) {
            data["corporateWidgetOptions"] = [];
            for (let item of this.corporateWidgetOptions)
                data["corporateWidgetOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCorporateWidgetOptionsListViewModel {
    corporateWidgetOptions?: CorporateWidgetOptionsDto[];
}

export class CorporateWidgetOptionsDto implements ICorporateWidgetOptionsDto {
    widgetType?: GetWidgetOptionsWidgetType;
    enabled?: boolean;
    order?: number;
    page?: number;

    constructor(data?: ICorporateWidgetOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetType = _data["widgetType"];
            this.enabled = _data["enabled"];
            this.order = _data["order"];
            this.page = _data["page"];
        }
    }

    static fromJS(data: any): CorporateWidgetOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateWidgetOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetType"] = this.widgetType;
        data["enabled"] = this.enabled;
        data["order"] = this.order;
        data["page"] = this.page;
        return data;
    }
}

export interface ICorporateWidgetOptionsDto {
    widgetType?: GetWidgetOptionsWidgetType;
    enabled?: boolean;
    order?: number;
    page?: number;
}

export enum GetWidgetOptionsWidgetType {
    GeneralSatisfaction = 0,
    Nps = 1,
    Trend = 2,
    Ces = 3,
    ConsistencyIndex = 4,
    BestWorstPerformance = 5,
}

export class UpsertCorporateWidgetOptionsViewModel implements IUpsertCorporateWidgetOptionsViewModel {
    success?: boolean;

    constructor(data?: IUpsertCorporateWidgetOptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UpsertCorporateWidgetOptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCorporateWidgetOptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IUpsertCorporateWidgetOptionsViewModel {
    success?: boolean;
}

export class UpsertCorporateWidgetOptionsDto implements IUpsertCorporateWidgetOptionsDto {
    page?: number | undefined;
    order?: number | undefined;
    enabled?: boolean | undefined;

    constructor(data?: IUpsertCorporateWidgetOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.order = _data["order"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): UpsertCorporateWidgetOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCorporateWidgetOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["order"] = this.order;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IUpsertCorporateWidgetOptionsDto {
    page?: number | undefined;
    order?: number | undefined;
    enabled?: boolean | undefined;
}

export class GetDashboardListViewModel implements IGetDashboardListViewModel {
    tableResponse?: TableResponse;

    constructor(data?: IGetDashboardListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableResponse = _data["tableResponse"] ? TableResponse.fromJS(_data["tableResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDashboardListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableResponse"] = this.tableResponse ? this.tableResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDashboardListViewModel {
    tableResponse?: TableResponse;
}

export class TableResponseOfTableHeaderRowResponseAndTableBodyRowResponseAndTableFooterRowResponse implements ITableResponseOfTableHeaderRowResponseAndTableBodyRowResponseAndTableFooterRowResponse {
    numberOfFixedColumns?: number | undefined;
    header?: TableHeaderRowResponse | undefined;
    body?: TableBodyRowResponse[];
    footer?: TableFooterRowResponse | undefined;

    constructor(data?: ITableResponseOfTableHeaderRowResponseAndTableBodyRowResponseAndTableFooterRowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfFixedColumns = _data["numberOfFixedColumns"];
            this.header = _data["header"] ? TableHeaderRowResponse.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["body"])) {
                this.body = [] as any;
                for (let item of _data["body"])
                    this.body!.push(TableBodyRowResponse.fromJS(item));
            }
            this.footer = _data["footer"] ? TableFooterRowResponse.fromJS(_data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TableResponseOfTableHeaderRowResponseAndTableBodyRowResponseAndTableFooterRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableResponseOfTableHeaderRowResponseAndTableBodyRowResponseAndTableFooterRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfFixedColumns"] = this.numberOfFixedColumns;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.body)) {
            data["body"] = [];
            for (let item of this.body)
                data["body"].push(item.toJSON());
        }
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITableResponseOfTableHeaderRowResponseAndTableBodyRowResponseAndTableFooterRowResponse {
    numberOfFixedColumns?: number | undefined;
    header?: TableHeaderRowResponse | undefined;
    body?: TableBodyRowResponse[];
    footer?: TableFooterRowResponse | undefined;
}

export class TableResponse extends TableResponseOfTableHeaderRowResponseAndTableBodyRowResponseAndTableFooterRowResponse implements ITableResponse {

    constructor(data?: ITableResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITableResponse extends ITableResponseOfTableHeaderRowResponseAndTableBodyRowResponseAndTableFooterRowResponse {
}

export abstract class TableRowResponseOfTableHeaderCellResponse implements ITableRowResponseOfTableHeaderCellResponse {
    cells?: TableHeaderCellResponse[];

    constructor(data?: ITableRowResponseOfTableHeaderCellResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(TableHeaderCellResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TableRowResponseOfTableHeaderCellResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TableRowResponseOfTableHeaderCellResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITableRowResponseOfTableHeaderCellResponse {
    cells?: TableHeaderCellResponse[];
}

export class TableHeaderRowResponseOfTableHeaderCellResponse extends TableRowResponseOfTableHeaderCellResponse implements ITableHeaderRowResponseOfTableHeaderCellResponse {

    constructor(data?: ITableHeaderRowResponseOfTableHeaderCellResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TableHeaderRowResponseOfTableHeaderCellResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableHeaderRowResponseOfTableHeaderCellResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITableHeaderRowResponseOfTableHeaderCellResponse extends ITableRowResponseOfTableHeaderCellResponse {
}

export class TableHeaderRowResponse extends TableHeaderRowResponseOfTableHeaderCellResponse implements ITableHeaderRowResponse {

    constructor(data?: ITableHeaderRowResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TableHeaderRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableHeaderRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITableHeaderRowResponse extends ITableHeaderRowResponseOfTableHeaderCellResponse {
}

export abstract class TableCellResponse implements ITableCellResponse {
    overrideColumnType?: TableColumnType | undefined;
    value?: any | undefined;

    constructor(data?: ITableCellResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overrideColumnType = _data["overrideColumnType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TableCellResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TableCellResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overrideColumnType"] = this.overrideColumnType;
        data["value"] = this.value;
        return data;
    }
}

export interface ITableCellResponse {
    overrideColumnType?: TableColumnType | undefined;
    value?: any | undefined;
}

export class TableHeaderCellResponse extends TableCellResponse implements ITableHeaderCellResponse {
    key?: string;
    canBeSorted?: boolean;
    isSortedByDefault?: boolean | undefined;
    defaultSortDirection?: SortDirection | undefined;
    columnType?: TableColumnType;
    visibilityBreakpoint?: TableHeaderCellVisibilityBreakpoint | undefined;
    toolTip?: string | undefined;
    skipExport?: boolean;

    constructor(data?: ITableHeaderCellResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"];
            this.canBeSorted = _data["canBeSorted"];
            this.isSortedByDefault = _data["isSortedByDefault"];
            this.defaultSortDirection = _data["defaultSortDirection"];
            this.columnType = _data["columnType"];
            this.visibilityBreakpoint = _data["visibilityBreakpoint"];
            this.toolTip = _data["toolTip"];
            this.skipExport = _data["skipExport"];
        }
    }

    static fromJS(data: any): TableHeaderCellResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableHeaderCellResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["canBeSorted"] = this.canBeSorted;
        data["isSortedByDefault"] = this.isSortedByDefault;
        data["defaultSortDirection"] = this.defaultSortDirection;
        data["columnType"] = this.columnType;
        data["visibilityBreakpoint"] = this.visibilityBreakpoint;
        data["toolTip"] = this.toolTip;
        data["skipExport"] = this.skipExport;
        super.toJSON(data);
        return data;
    }
}

export interface ITableHeaderCellResponse extends ITableCellResponse {
    key?: string;
    canBeSorted?: boolean;
    isSortedByDefault?: boolean | undefined;
    defaultSortDirection?: SortDirection | undefined;
    columnType?: TableColumnType;
    visibilityBreakpoint?: TableHeaderCellVisibilityBreakpoint | undefined;
    toolTip?: string | undefined;
    skipExport?: boolean;
}

export enum SortDirection {
    Ascending = 0,
    Descending = 1,
}

export enum TableColumnType {
    Text = 0,
    Number = 1,
    Percentage = 2,
    Dot = 3,
    Image = 4,
    Custom = 5,
    Html = 6,
}

export enum TableHeaderCellVisibilityBreakpoint {
    AlwaysVisible = 0,
    MobileS = 1,
    MobileM = 2,
    MobileL = 3,
    Tablet = 4,
    DesktopXS = 5,
    DesktopS = 6,
    DesktopM = 7,
    DesktopL = 8,
    DesktopXL = 9,
    Never = 9999999,
}

export abstract class TableRowResponseOfTableBodyCellResponse implements ITableRowResponseOfTableBodyCellResponse {
    cells?: TableBodyCellResponse[];

    constructor(data?: ITableRowResponseOfTableBodyCellResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(TableBodyCellResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TableRowResponseOfTableBodyCellResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TableRowResponseOfTableBodyCellResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITableRowResponseOfTableBodyCellResponse {
    cells?: TableBodyCellResponse[];
}

export class TableBodyRowResponseOfTableBodyCellResponse extends TableRowResponseOfTableBodyCellResponse implements ITableBodyRowResponseOfTableBodyCellResponse {
    isHighlighted?: boolean;
    level?: number;

    constructor(data?: ITableBodyRowResponseOfTableBodyCellResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isHighlighted = _data["isHighlighted"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): TableBodyRowResponseOfTableBodyCellResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableBodyRowResponseOfTableBodyCellResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHighlighted"] = this.isHighlighted;
        data["level"] = this.level;
        super.toJSON(data);
        return data;
    }
}

export interface ITableBodyRowResponseOfTableBodyCellResponse extends ITableRowResponseOfTableBodyCellResponse {
    isHighlighted?: boolean;
    level?: number;
}

export class TableBodyRowResponse extends TableBodyRowResponseOfTableBodyCellResponse implements ITableBodyRowResponse {

    constructor(data?: ITableBodyRowResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TableBodyRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableBodyRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITableBodyRowResponse extends ITableBodyRowResponseOfTableBodyCellResponse {
}

export class TableBodyCellResponse extends TableCellResponse implements ITableBodyCellResponse {

    constructor(data?: ITableBodyCellResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TableBodyCellResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableBodyCellResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITableBodyCellResponse extends ITableCellResponse {
}

export abstract class TableRowResponseOfTableFooterCellResponse implements ITableRowResponseOfTableFooterCellResponse {
    cells?: TableFooterCellResponse[];

    constructor(data?: ITableRowResponseOfTableFooterCellResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(TableFooterCellResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TableRowResponseOfTableFooterCellResponse {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TableRowResponseOfTableFooterCellResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITableRowResponseOfTableFooterCellResponse {
    cells?: TableFooterCellResponse[];
}

export class TableFooterRowResponseOfTableFooterCellResponse extends TableRowResponseOfTableFooterCellResponse implements ITableFooterRowResponseOfTableFooterCellResponse {

    constructor(data?: ITableFooterRowResponseOfTableFooterCellResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TableFooterRowResponseOfTableFooterCellResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableFooterRowResponseOfTableFooterCellResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITableFooterRowResponseOfTableFooterCellResponse extends ITableRowResponseOfTableFooterCellResponse {
}

export class TableFooterRowResponse extends TableFooterRowResponseOfTableFooterCellResponse implements ITableFooterRowResponse {

    constructor(data?: ITableFooterRowResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TableFooterRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableFooterRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITableFooterRowResponse extends ITableFooterRowResponseOfTableFooterCellResponse {
}

export class TableFooterCellResponse extends TableCellResponse implements ITableFooterCellResponse {

    constructor(data?: ITableFooterCellResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TableFooterCellResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableFooterCellResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITableFooterCellResponse extends ITableCellResponse {
}

export class GetRealTimeDashboardFilterSet implements IGetRealTimeDashboardFilterSet {
    paginatedRequest?: PaginatedRequest;
    riskType?: RiskType[] | undefined;
    projectId?: string[] | undefined;
    subscriptionId?: string[] | undefined;
    tagId?: string[] | undefined;
    orderBy?: GetRealTimeDashboardOrderByColumn | undefined;
    periodStatus?: PeriodStatus[] | undefined;

    constructor(data?: IGetRealTimeDashboardFilterSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paginatedRequest = _data["paginatedRequest"] ? PaginatedRequest.fromJS(_data["paginatedRequest"]) : <any>undefined;
            if (Array.isArray(_data["riskType"])) {
                this.riskType = [] as any;
                for (let item of _data["riskType"])
                    this.riskType!.push(item);
            }
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            if (Array.isArray(_data["subscriptionId"])) {
                this.subscriptionId = [] as any;
                for (let item of _data["subscriptionId"])
                    this.subscriptionId!.push(item);
            }
            if (Array.isArray(_data["tagId"])) {
                this.tagId = [] as any;
                for (let item of _data["tagId"])
                    this.tagId!.push(item);
            }
            this.orderBy = _data["orderBy"];
            if (Array.isArray(_data["periodStatus"])) {
                this.periodStatus = [] as any;
                for (let item of _data["periodStatus"])
                    this.periodStatus!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRealTimeDashboardFilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new GetRealTimeDashboardFilterSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paginatedRequest"] = this.paginatedRequest ? this.paginatedRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.riskType)) {
            data["riskType"] = [];
            for (let item of this.riskType)
                data["riskType"].push(item);
        }
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        if (Array.isArray(this.subscriptionId)) {
            data["subscriptionId"] = [];
            for (let item of this.subscriptionId)
                data["subscriptionId"].push(item);
        }
        if (Array.isArray(this.tagId)) {
            data["tagId"] = [];
            for (let item of this.tagId)
                data["tagId"].push(item);
        }
        data["orderBy"] = this.orderBy;
        if (Array.isArray(this.periodStatus)) {
            data["periodStatus"] = [];
            for (let item of this.periodStatus)
                data["periodStatus"].push(item);
        }
        return data;
    }
}

export interface IGetRealTimeDashboardFilterSet {
    paginatedRequest?: PaginatedRequest;
    riskType?: RiskType[] | undefined;
    projectId?: string[] | undefined;
    subscriptionId?: string[] | undefined;
    tagId?: string[] | undefined;
    orderBy?: GetRealTimeDashboardOrderByColumn | undefined;
    periodStatus?: PeriodStatus[] | undefined;
}

export class PaginatedRequest implements IPaginatedRequest {
    pageNumber?: number;
    pageSize?: number;

    constructor(data?: IPaginatedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PaginatedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPaginatedRequest {
    pageNumber?: number;
    pageSize?: number;
}

export enum RiskType {
    Unknown = 0,
    Low = 1,
    Moderate = 2,
    High = 3,
}

export enum GetRealTimeDashboardOrderByColumn {
    Risk = 0,
    MissionsToComplete = 1,
    DaysLeft = 2,
}

export enum PeriodStatus {
    Inactive = 0,
    Ready = 1,
    Active = 2,
    Completed = 3,
}

export class GetDashboardListFiltersViewModel implements IGetDashboardListFiltersViewModel {
    subscriptions?: GetDashboardListFiltersSubscriptionDto[];
    projects?: GetDashboardListFiltersProjectDto[];
    adminTags?: GetDashboardListFiltersAdminTagDto[];

    constructor(data?: IGetDashboardListFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(GetDashboardListFiltersSubscriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(GetDashboardListFiltersProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["adminTags"])) {
                this.adminTags = [] as any;
                for (let item of _data["adminTags"])
                    this.adminTags!.push(GetDashboardListFiltersAdminTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDashboardListFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardListFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.adminTags)) {
            data["adminTags"] = [];
            for (let item of this.adminTags)
                data["adminTags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDashboardListFiltersViewModel {
    subscriptions?: GetDashboardListFiltersSubscriptionDto[];
    projects?: GetDashboardListFiltersProjectDto[];
    adminTags?: GetDashboardListFiltersAdminTagDto[];
}

export class GetDashboardListFiltersSubscriptionDto implements IGetDashboardListFiltersSubscriptionDto {
    id?: string;
    name?: string;
    inactive?: boolean;

    constructor(data?: IGetDashboardListFiltersSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.inactive = _data["inactive"];
        }
    }

    static fromJS(data: any): GetDashboardListFiltersSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardListFiltersSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["inactive"] = this.inactive;
        return data;
    }
}

export interface IGetDashboardListFiltersSubscriptionDto {
    id?: string;
    name?: string;
    inactive?: boolean;
}

export class GetDashboardListFiltersProjectDto implements IGetDashboardListFiltersProjectDto {
    id?: string;
    name?: string;
    subscriptionId?: string;

    constructor(data?: IGetDashboardListFiltersProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): GetDashboardListFiltersProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardListFiltersProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface IGetDashboardListFiltersProjectDto {
    id?: string;
    name?: string;
    subscriptionId?: string;
}

export class GetDashboardListFiltersAdminTagDto implements IGetDashboardListFiltersAdminTagDto {
    id?: string;
    name?: string;

    constructor(data?: IGetDashboardListFiltersAdminTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDashboardListFiltersAdminTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardListFiltersAdminTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDashboardListFiltersAdminTagDto {
    id?: string;
    name?: string;
}

export class GetSummaryDashboardsViewModel implements IGetSummaryDashboardsViewModel {
    summary?: GetSummaryDashboardsDto;

    constructor(data?: IGetSummaryDashboardsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? GetSummaryDashboardsDto.fromJS(_data["summary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSummaryDashboardsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryDashboardsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSummaryDashboardsViewModel {
    summary?: GetSummaryDashboardsDto;
}

export class GetSummaryDashboardsDto implements IGetSummaryDashboardsDto {
    totalPeriodMissionConfigurations?: number;
    stats?: StatsDto;
    progression?: GetSummaryDashboardsProgressionDto;

    constructor(data?: IGetSummaryDashboardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPeriodMissionConfigurations = _data["totalPeriodMissionConfigurations"];
            this.stats = _data["stats"] ? StatsDto.fromJS(_data["stats"]) : <any>undefined;
            this.progression = _data["progression"] ? GetSummaryDashboardsProgressionDto.fromJS(_data["progression"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSummaryDashboardsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryDashboardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPeriodMissionConfigurations"] = this.totalPeriodMissionConfigurations;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        data["progression"] = this.progression ? this.progression.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSummaryDashboardsDto {
    totalPeriodMissionConfigurations?: number;
    stats?: StatsDto;
    progression?: GetSummaryDashboardsProgressionDto;
}

export class StatsDto implements IStatsDto {
    toCorrectAndResend?: string;
    toCorrectAndResendPercent?: string;
    naturalAssign?: number;
    bookingAssign?: number;

    constructor(data?: IStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toCorrectAndResend = _data["toCorrectAndResend"];
            this.toCorrectAndResendPercent = _data["toCorrectAndResendPercent"];
            this.naturalAssign = _data["naturalAssign"];
            this.bookingAssign = _data["bookingAssign"];
        }
    }

    static fromJS(data: any): StatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toCorrectAndResend"] = this.toCorrectAndResend;
        data["toCorrectAndResendPercent"] = this.toCorrectAndResendPercent;
        data["naturalAssign"] = this.naturalAssign;
        data["bookingAssign"] = this.bookingAssign;
        return data;
    }
}

export interface IStatsDto {
    toCorrectAndResend?: string;
    toCorrectAndResendPercent?: string;
    naturalAssign?: number;
    bookingAssign?: number;
}

export class GetSummaryDashboardsProgressionDto implements IGetSummaryDashboardsProgressionDto {
    total?: number;
    inProgress?: number;
    available?: number;
    assigned?: number;
    validating?: number;
    validationRejected?: number;
    approved?: number;
    approvedDisabled?: number;

    constructor(data?: IGetSummaryDashboardsProgressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.inProgress = _data["inProgress"];
            this.available = _data["available"];
            this.assigned = _data["assigned"];
            this.validating = _data["validating"];
            this.validationRejected = _data["validationRejected"];
            this.approved = _data["approved"];
            this.approvedDisabled = _data["approvedDisabled"];
        }
    }

    static fromJS(data: any): GetSummaryDashboardsProgressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryDashboardsProgressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["inProgress"] = this.inProgress;
        data["available"] = this.available;
        data["assigned"] = this.assigned;
        data["validating"] = this.validating;
        data["validationRejected"] = this.validationRejected;
        data["approved"] = this.approved;
        data["approvedDisabled"] = this.approvedDisabled;
        return data;
    }
}

export interface IGetSummaryDashboardsProgressionDto {
    total?: number;
    inProgress?: number;
    available?: number;
    assigned?: number;
    validating?: number;
    validationRejected?: number;
    approved?: number;
    approvedDisabled?: number;
}

export class GetSummaryDashboardsFilterSet implements IGetSummaryDashboardsFilterSet {
    riskType?: RiskType[] | undefined;
    projectId?: string[] | undefined;
    subscriptionId?: string[] | undefined;
    adminTagId?: string[] | undefined;
    periodStatus?: PeriodStatus[] | undefined;

    constructor(data?: IGetSummaryDashboardsFilterSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["riskType"])) {
                this.riskType = [] as any;
                for (let item of _data["riskType"])
                    this.riskType!.push(item);
            }
            if (Array.isArray(_data["projectId"])) {
                this.projectId = [] as any;
                for (let item of _data["projectId"])
                    this.projectId!.push(item);
            }
            if (Array.isArray(_data["subscriptionId"])) {
                this.subscriptionId = [] as any;
                for (let item of _data["subscriptionId"])
                    this.subscriptionId!.push(item);
            }
            if (Array.isArray(_data["adminTagId"])) {
                this.adminTagId = [] as any;
                for (let item of _data["adminTagId"])
                    this.adminTagId!.push(item);
            }
            if (Array.isArray(_data["periodStatus"])) {
                this.periodStatus = [] as any;
                for (let item of _data["periodStatus"])
                    this.periodStatus!.push(item);
            }
        }
    }

    static fromJS(data: any): GetSummaryDashboardsFilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryDashboardsFilterSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.riskType)) {
            data["riskType"] = [];
            for (let item of this.riskType)
                data["riskType"].push(item);
        }
        if (Array.isArray(this.projectId)) {
            data["projectId"] = [];
            for (let item of this.projectId)
                data["projectId"].push(item);
        }
        if (Array.isArray(this.subscriptionId)) {
            data["subscriptionId"] = [];
            for (let item of this.subscriptionId)
                data["subscriptionId"].push(item);
        }
        if (Array.isArray(this.adminTagId)) {
            data["adminTagId"] = [];
            for (let item of this.adminTagId)
                data["adminTagId"].push(item);
        }
        if (Array.isArray(this.periodStatus)) {
            data["periodStatus"] = [];
            for (let item of this.periodStatus)
                data["periodStatus"].push(item);
        }
        return data;
    }
}

export interface IGetSummaryDashboardsFilterSet {
    riskType?: RiskType[] | undefined;
    projectId?: string[] | undefined;
    subscriptionId?: string[] | undefined;
    adminTagId?: string[] | undefined;
    periodStatus?: PeriodStatus[] | undefined;
}

export class GetProgressionViewModel implements IGetProgressionViewModel {
    overallProgression?: OverallProgressionDto;
    dailyProgressions?: ProgressionDay[];
    weeklyProgressions?: ProgressionRange[];
    monthlyProgressions?: ProgressionRange[];
    latestProgressions?: ProgressionDay;

    constructor(data?: IGetProgressionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overallProgression = _data["overallProgression"] ? OverallProgressionDto.fromJS(_data["overallProgression"]) : <any>undefined;
            if (Array.isArray(_data["dailyProgressions"])) {
                this.dailyProgressions = [] as any;
                for (let item of _data["dailyProgressions"])
                    this.dailyProgressions!.push(ProgressionDay.fromJS(item));
            }
            if (Array.isArray(_data["weeklyProgressions"])) {
                this.weeklyProgressions = [] as any;
                for (let item of _data["weeklyProgressions"])
                    this.weeklyProgressions!.push(ProgressionRange.fromJS(item));
            }
            if (Array.isArray(_data["monthlyProgressions"])) {
                this.monthlyProgressions = [] as any;
                for (let item of _data["monthlyProgressions"])
                    this.monthlyProgressions!.push(ProgressionRange.fromJS(item));
            }
            this.latestProgressions = _data["latestProgressions"] ? ProgressionDay.fromJS(_data["latestProgressions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProgressionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgressionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overallProgression"] = this.overallProgression ? this.overallProgression.toJSON() : <any>undefined;
        if (Array.isArray(this.dailyProgressions)) {
            data["dailyProgressions"] = [];
            for (let item of this.dailyProgressions)
                data["dailyProgressions"].push(item.toJSON());
        }
        if (Array.isArray(this.weeklyProgressions)) {
            data["weeklyProgressions"] = [];
            for (let item of this.weeklyProgressions)
                data["weeklyProgressions"].push(item.toJSON());
        }
        if (Array.isArray(this.monthlyProgressions)) {
            data["monthlyProgressions"] = [];
            for (let item of this.monthlyProgressions)
                data["monthlyProgressions"].push(item.toJSON());
        }
        data["latestProgressions"] = this.latestProgressions ? this.latestProgressions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProgressionViewModel {
    overallProgression?: OverallProgressionDto;
    dailyProgressions?: ProgressionDay[];
    weeklyProgressions?: ProgressionRange[];
    monthlyProgressions?: ProgressionRange[];
    latestProgressions?: ProgressionDay;
}

export class OverallProgressionDto implements IOverallProgressionDto {
    total?: number;
    assigned?: number;
    available?: number;
    validated?: number;
    preValidated?: number;
    approved?: number;
    fraudDetected?: number;

    constructor(data?: IOverallProgressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.assigned = _data["assigned"];
            this.available = _data["available"];
            this.validated = _data["validated"];
            this.preValidated = _data["preValidated"];
            this.approved = _data["approved"];
            this.fraudDetected = _data["fraudDetected"];
        }
    }

    static fromJS(data: any): OverallProgressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverallProgressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["assigned"] = this.assigned;
        data["available"] = this.available;
        data["validated"] = this.validated;
        data["preValidated"] = this.preValidated;
        data["approved"] = this.approved;
        data["fraudDetected"] = this.fraudDetected;
        return data;
    }
}

export interface IOverallProgressionDto {
    total?: number;
    assigned?: number;
    available?: number;
    validated?: number;
    preValidated?: number;
    approved?: number;
    fraudDetected?: number;
}

export class ProgressionDay implements IProgressionDay {
    day?: Date;
    statusMissionCounts?: StatusMissionCount[];

    constructor(data?: IProgressionDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"] ? new Date(_data["day"].toString()) : <any>undefined;
            if (Array.isArray(_data["statusMissionCounts"])) {
                this.statusMissionCounts = [] as any;
                for (let item of _data["statusMissionCounts"])
                    this.statusMissionCounts!.push(StatusMissionCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProgressionDay {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressionDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day ? this.day.toISOString() : <any>undefined;
        if (Array.isArray(this.statusMissionCounts)) {
            data["statusMissionCounts"] = [];
            for (let item of this.statusMissionCounts)
                data["statusMissionCounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProgressionDay {
    day?: Date;
    statusMissionCounts?: StatusMissionCount[];
}

export class StatusMissionCount implements IStatusMissionCount {
    status?: MissionAssignationStatus;
    value?: number;

    constructor(data?: IStatusMissionCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatusMissionCount {
        data = typeof data === 'object' ? data : {};
        let result = new StatusMissionCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["value"] = this.value;
        return data;
    }
}

export interface IStatusMissionCount {
    status?: MissionAssignationStatus;
    value?: number;
}

export enum MissionAssignationStatus {
    Available = 0,
    Assigned = 1,
    Prevalidation = 2,
    Validating = 3,
    ValidationRejected = 4,
    Approved = 5,
    Cancelled = 6,
    FraudDetected = 7,
    InappropriateLanguage = 8,
    ApproveDeactivated = 9,
    Imported = 10,
    ExpiredTimeout = 11,
    ExpiredCorrection = 12,
    PrevalidationFailed = 13,
}

export class ProgressionRange implements IProgressionRange {
    start?: Date;
    end?: Date;
    statusMissionCounts?: StatusMissionCount[];

    constructor(data?: IProgressionRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            if (Array.isArray(_data["statusMissionCounts"])) {
                this.statusMissionCounts = [] as any;
                for (let item of _data["statusMissionCounts"])
                    this.statusMissionCounts!.push(StatusMissionCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProgressionRange {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressionRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        if (Array.isArray(this.statusMissionCounts)) {
            data["statusMissionCounts"] = [];
            for (let item of this.statusMissionCounts)
                data["statusMissionCounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProgressionRange {
    start?: Date;
    end?: Date;
    statusMissionCounts?: StatusMissionCount[];
}

export class GetStatisticsViewModel implements IGetStatisticsViewModel {
    stats?: DashboardStatsDto[];

    constructor(data?: IGetStatisticsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(DashboardStatsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStatisticsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatisticsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetStatisticsViewModel {
    stats?: DashboardStatsDto[];
}

export class DashboardStatsDto implements IDashboardStatsDto {
    statisticsType?: StatisticsType;
    value?: string;
    denominatorValue?: string | undefined;

    constructor(data?: IDashboardStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statisticsType = _data["statisticsType"];
            this.value = _data["value"];
            this.denominatorValue = _data["denominatorValue"];
        }
    }

    static fromJS(data: any): DashboardStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statisticsType"] = this.statisticsType;
        data["value"] = this.value;
        data["denominatorValue"] = this.denominatorValue;
        return data;
    }
}

export interface IDashboardStatsDto {
    statisticsType?: StatisticsType;
    value?: string;
    denominatorValue?: string | undefined;
}

export enum StatisticsType {
    ClientsToCall = 0,
    QuestionairesToResendAndCorrectByShopper = 1,
    NaturalAssignPercent = 2,
    BookingAssignPercent = 3,
    WeeklyCallsPerBooking = 4,
    TotalCallsPerBooking = 5,
    WeeklyNaturalAssignAvg = 6,
    WeeklyBookingAssignAvg = 7,
    ValidationTimeAvg = 8,
    QuestionairesSentToTheMysteryShopper = 9,
    ResentToShopperPercent = 10,
    CorrectionTimeAvg = 11,
    CorrectionCount = 12,
    MissionsToAssignPerDayNumber = 13,
}

export class GetAutomatisationListViewModel implements IGetAutomatisationListViewModel {
    automationProcesses?: PaginatedResponseOfAutomationProcessDto;

    constructor(data?: IGetAutomatisationListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.automationProcesses = _data["automationProcesses"] ? PaginatedResponseOfAutomationProcessDto.fromJS(_data["automationProcesses"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAutomatisationListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAutomatisationListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["automationProcesses"] = this.automationProcesses ? this.automationProcesses.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAutomatisationListViewModel {
    automationProcesses?: PaginatedResponseOfAutomationProcessDto;
}

export class PaginatedResponseOfAutomationProcessDto implements IPaginatedResponseOfAutomationProcessDto {
    items?: AutomationProcessDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfAutomationProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AutomationProcessDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfAutomationProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfAutomationProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfAutomationProcessDto {
    items?: AutomationProcessDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class AutomationProcessDto implements IAutomationProcessDto {
    automationProcessId?: string;
    branchCode?: string;
    branchName?: string;
    nextStep?: ProcessStep;
    processSteps?: { [key in keyof typeof ProcessStep]?: StepInformationDto; };
    branchTotalMissionCount?: number;

    constructor(data?: IAutomationProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.automationProcessId = _data["automationProcessId"];
            this.branchCode = _data["branchCode"];
            this.branchName = _data["branchName"];
            this.nextStep = _data["nextStep"];
            if (_data["processSteps"]) {
                this.processSteps = {} as any;
                for (let key in _data["processSteps"]) {
                    if (_data["processSteps"].hasOwnProperty(key))
                        (<any>this.processSteps)![key] = _data["processSteps"][key] ? StepInformationDto.fromJS(_data["processSteps"][key]) : new StepInformationDto();
                }
            }
            this.branchTotalMissionCount = _data["branchTotalMissionCount"];
        }
    }

    static fromJS(data: any): AutomationProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new AutomationProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["automationProcessId"] = this.automationProcessId;
        data["branchCode"] = this.branchCode;
        data["branchName"] = this.branchName;
        data["nextStep"] = this.nextStep;
        if (this.processSteps) {
            data["processSteps"] = {};
            for (let key in this.processSteps) {
                if (this.processSteps.hasOwnProperty(key))
                    (<any>data["processSteps"])[key] = this.processSteps[key] ? this.processSteps[key].toJSON() : <any>undefined;
            }
        }
        data["branchTotalMissionCount"] = this.branchTotalMissionCount;
        return data;
    }
}

export interface IAutomationProcessDto {
    automationProcessId?: string;
    branchCode?: string;
    branchName?: string;
    nextStep?: ProcessStep;
    processSteps?: { [key in keyof typeof ProcessStep]?: StepInformationDto; };
    branchTotalMissionCount?: number;
}

export class StepInformationDto implements IStepInformationDto {
    assignedMissions?: number | undefined;
    assignedProcessStartDate?: Date | undefined;

    constructor(data?: IStepInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedMissions = _data["assignedMissions"];
            this.assignedProcessStartDate = _data["assignedProcessStartDate"] ? new Date(_data["assignedProcessStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StepInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StepInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedMissions"] = this.assignedMissions;
        data["assignedProcessStartDate"] = this.assignedProcessStartDate ? this.assignedProcessStartDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStepInformationDto {
    assignedMissions?: number | undefined;
    assignedProcessStartDate?: Date | undefined;
}

export class GetBasicDashboardInfoViewModel implements IGetBasicDashboardInfoViewModel {
    periodMissionConfig?: GetBasicDashboardInfoPeriodMissionConfigDto;
    branches?: GetDashboardBranchDto[];
    tags?: GetBasicDashboardInfoTagDto[];
    subscriptions?: GetBasicDashboardInfoHierachyLevelDto[];
    organizations?: GetBasicDashboardInfoHierachyLevelDto[];

    constructor(data?: IGetBasicDashboardInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodMissionConfig = _data["periodMissionConfig"] ? GetBasicDashboardInfoPeriodMissionConfigDto.fromJS(_data["periodMissionConfig"]) : <any>undefined;
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetDashboardBranchDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetBasicDashboardInfoTagDto.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(GetBasicDashboardInfoHierachyLevelDto.fromJS(item));
            }
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(GetBasicDashboardInfoHierachyLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBasicDashboardInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetBasicDashboardInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodMissionConfig"] = this.periodMissionConfig ? this.periodMissionConfig.toJSON() : <any>undefined;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBasicDashboardInfoViewModel {
    periodMissionConfig?: GetBasicDashboardInfoPeriodMissionConfigDto;
    branches?: GetDashboardBranchDto[];
    tags?: GetBasicDashboardInfoTagDto[];
    subscriptions?: GetBasicDashboardInfoHierachyLevelDto[];
    organizations?: GetBasicDashboardInfoHierachyLevelDto[];
}

export class GetBasicDashboardInfoPeriodMissionConfigDto implements IGetBasicDashboardInfoPeriodMissionConfigDto {
    periodName?: string;
    periodMissionConfigName?: string;
    missionConfigName?: string;
    endDate?: Date | undefined;
    daysLeft?: number;

    constructor(data?: IGetBasicDashboardInfoPeriodMissionConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodName = _data["periodName"];
            this.periodMissionConfigName = _data["periodMissionConfigName"];
            this.missionConfigName = _data["missionConfigName"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.daysLeft = _data["daysLeft"];
        }
    }

    static fromJS(data: any): GetBasicDashboardInfoPeriodMissionConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBasicDashboardInfoPeriodMissionConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodName"] = this.periodName;
        data["periodMissionConfigName"] = this.periodMissionConfigName;
        data["missionConfigName"] = this.missionConfigName;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["daysLeft"] = this.daysLeft;
        return data;
    }
}

export interface IGetBasicDashboardInfoPeriodMissionConfigDto {
    periodName?: string;
    periodMissionConfigName?: string;
    missionConfigName?: string;
    endDate?: Date | undefined;
    daysLeft?: number;
}

export class GetDashboardBranchDto implements IGetDashboardBranchDto {
    id?: string;
    name?: string;
    address?: string;

    constructor(data?: IGetDashboardBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): GetDashboardBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        return data;
    }
}

export interface IGetDashboardBranchDto {
    id?: string;
    name?: string;
    address?: string;
}

export class GetBasicDashboardInfoTagDto implements IGetBasicDashboardInfoTagDto {
    id?: string;
    name?: string[];

    constructor(data?: IGetBasicDashboardInfoTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name!.push(item);
            }
        }
    }

    static fromJS(data: any): GetBasicDashboardInfoTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBasicDashboardInfoTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item);
        }
        return data;
    }
}

export interface IGetBasicDashboardInfoTagDto {
    id?: string;
    name?: string[];
}

export class GetBasicDashboardInfoHierachyLevelDto implements IGetBasicDashboardInfoHierachyLevelDto {
    id?: string;
    name?: string;
    parentId?: string | undefined;

    constructor(data?: IGetBasicDashboardInfoHierachyLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): GetBasicDashboardInfoHierachyLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBasicDashboardInfoHierachyLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IGetBasicDashboardInfoHierachyLevelDto {
    id?: string;
    name?: string;
    parentId?: string | undefined;
}

export class AvailableMissionsViewModel implements IAvailableMissionsViewModel {
    results?: PaginatedResponseOfAvailableMissionsRowDto | undefined;

    constructor(data?: IAvailableMissionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.results = _data["results"] ? PaginatedResponseOfAvailableMissionsRowDto.fromJS(_data["results"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailableMissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableMissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["results"] = this.results ? this.results.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailableMissionsViewModel {
    results?: PaginatedResponseOfAvailableMissionsRowDto | undefined;
}

export class PaginatedResponseOfAvailableMissionsRowDto implements IPaginatedResponseOfAvailableMissionsRowDto {
    items?: AvailableMissionsRowDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfAvailableMissionsRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AvailableMissionsRowDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfAvailableMissionsRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfAvailableMissionsRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfAvailableMissionsRowDto {
    items?: AvailableMissionsRowDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class AvailableMissionsRowDto implements IAvailableMissionsRowDto {
    branchId?: string;
    branchName?: string | undefined;
    missionsDone?: number;
    missionsLeft?: number;
    isAssignable?: boolean;

    constructor(data?: IAvailableMissionsRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.branchName = _data["branchName"];
            this.missionsDone = _data["missionsDone"];
            this.missionsLeft = _data["missionsLeft"];
            this.isAssignable = _data["isAssignable"];
        }
    }

    static fromJS(data: any): AvailableMissionsRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableMissionsRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["branchName"] = this.branchName;
        data["missionsDone"] = this.missionsDone;
        data["missionsLeft"] = this.missionsLeft;
        data["isAssignable"] = this.isAssignable;
        return data;
    }
}

export interface IAvailableMissionsRowDto {
    branchId?: string;
    branchName?: string | undefined;
    missionsDone?: number;
    missionsLeft?: number;
    isAssignable?: boolean;
}

export class MissionsAssignationsViewModel implements IMissionsAssignationsViewModel {
    results?: PaginatedResponseOfMissionsAssignationsDto | undefined;

    constructor(data?: IMissionsAssignationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.results = _data["results"] ? PaginatedResponseOfMissionsAssignationsDto.fromJS(_data["results"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MissionsAssignationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissionsAssignationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["results"] = this.results ? this.results.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMissionsAssignationsViewModel {
    results?: PaginatedResponseOfMissionsAssignationsDto | undefined;
}

export class PaginatedResponseOfMissionsAssignationsDto implements IPaginatedResponseOfMissionsAssignationsDto {
    items?: MissionsAssignationsDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfMissionsAssignationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MissionsAssignationsDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfMissionsAssignationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfMissionsAssignationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfMissionsAssignationsDto {
    items?: MissionsAssignationsDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class MissionsAssignationsDto implements IMissionsAssignationsDto {
    firstName?: string;
    lastName?: string;
    email?: string;
    status?: MissionAssignationStatus;
    misteryShopperId?: string;
    missionAssignationId?: string;

    constructor(data?: IMissionsAssignationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.misteryShopperId = _data["misteryShopperId"];
            this.missionAssignationId = _data["missionAssignationId"];
        }
    }

    static fromJS(data: any): MissionsAssignationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionsAssignationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["status"] = this.status;
        data["misteryShopperId"] = this.misteryShopperId;
        data["missionAssignationId"] = this.missionAssignationId;
        return data;
    }
}

export interface IMissionsAssignationsDto {
    firstName?: string;
    lastName?: string;
    email?: string;
    status?: MissionAssignationStatus;
    misteryShopperId?: string;
    missionAssignationId?: string;
}

export class GetMissionOverviewViewModel implements IGetMissionOverviewViewModel {
    overview?: GetDashboardListDto;

    constructor(data?: IGetMissionOverviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overview = _data["overview"] ? GetDashboardListDto.fromJS(_data["overview"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMissionOverviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionOverviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overview"] = this.overview ? this.overview.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMissionOverviewViewModel {
    overview?: GetDashboardListDto;
}

export class GetDashboardListDto implements IGetDashboardListDto {
    id?: string;
    periodId?: string;
    missionConfigurationId?: string;
    projectId?: string;
    periodName?: string;
    projectName?: string;
    missionConfigurationName?: string;
    subscriptionName?: string;
    organizationName?: string;
    subscriptionServiceName?: string;
    riskType?: RiskType;
    daysLeft?: number;
    status?: PeriodStatus;
    stats?: StatsDto;
    progression?: MissionProgressionDto;

    constructor(data?: IGetDashboardListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.periodId = _data["periodId"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.projectId = _data["projectId"];
            this.periodName = _data["periodName"];
            this.projectName = _data["projectName"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.subscriptionName = _data["subscriptionName"];
            this.organizationName = _data["organizationName"];
            this.subscriptionServiceName = _data["subscriptionServiceName"];
            this.riskType = _data["riskType"];
            this.daysLeft = _data["daysLeft"];
            this.status = _data["status"];
            this.stats = _data["stats"] ? StatsDto.fromJS(_data["stats"]) : <any>undefined;
            this.progression = _data["progression"] ? MissionProgressionDto.fromJS(_data["progression"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDashboardListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["periodId"] = this.periodId;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["projectId"] = this.projectId;
        data["periodName"] = this.periodName;
        data["projectName"] = this.projectName;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["subscriptionName"] = this.subscriptionName;
        data["organizationName"] = this.organizationName;
        data["subscriptionServiceName"] = this.subscriptionServiceName;
        data["riskType"] = this.riskType;
        data["daysLeft"] = this.daysLeft;
        data["status"] = this.status;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        data["progression"] = this.progression ? this.progression.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDashboardListDto {
    id?: string;
    periodId?: string;
    missionConfigurationId?: string;
    projectId?: string;
    periodName?: string;
    projectName?: string;
    missionConfigurationName?: string;
    subscriptionName?: string;
    organizationName?: string;
    subscriptionServiceName?: string;
    riskType?: RiskType;
    daysLeft?: number;
    status?: PeriodStatus;
    stats?: StatsDto;
    progression?: MissionProgressionDto;
}

export class MissionProgressionDto implements IMissionProgressionDto {
    total?: number;
    available?: number;
    assigned?: number;
    validating?: number;
    validationRejected?: number;
    approved?: number;

    constructor(data?: IMissionProgressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.available = _data["available"];
            this.assigned = _data["assigned"];
            this.validating = _data["validating"];
            this.validationRejected = _data["validationRejected"];
            this.approved = _data["approved"];
        }
    }

    static fromJS(data: any): MissionProgressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionProgressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["available"] = this.available;
        data["assigned"] = this.assigned;
        data["validating"] = this.validating;
        data["validationRejected"] = this.validationRejected;
        data["approved"] = this.approved;
        return data;
    }
}

export interface IMissionProgressionDto {
    total?: number;
    available?: number;
    assigned?: number;
    validating?: number;
    validationRejected?: number;
    approved?: number;
}

export class GetCallListEntriesViewModel implements IGetCallListEntriesViewModel {
    manualCallListEntries?: PaginatedResponseOfGetManualCallListEntriesDto;

    constructor(data?: IGetCallListEntriesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manualCallListEntries = _data["manualCallListEntries"] ? PaginatedResponseOfGetManualCallListEntriesDto.fromJS(_data["manualCallListEntries"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCallListEntriesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallListEntriesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manualCallListEntries"] = this.manualCallListEntries ? this.manualCallListEntries.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCallListEntriesViewModel {
    manualCallListEntries?: PaginatedResponseOfGetManualCallListEntriesDto;
}

export class PaginatedResponseOfGetManualCallListEntriesDto implements IPaginatedResponseOfGetManualCallListEntriesDto {
    items?: GetManualCallListEntriesDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfGetManualCallListEntriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetManualCallListEntriesDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetManualCallListEntriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetManualCallListEntriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfGetManualCallListEntriesDto {
    items?: GetManualCallListEntriesDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class GetManualCallListEntriesDto implements IGetManualCallListEntriesDto {
    mysteryShopperId?: string;
    email?: string;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    status?: ManualCallListEntryStatus;
    closestBranches?: GetManualCallListEntriesBranchDto[];

    constructor(data?: IGetManualCallListEntriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mysteryShopperId = _data["mysteryShopperId"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
            if (Array.isArray(_data["closestBranches"])) {
                this.closestBranches = [] as any;
                for (let item of _data["closestBranches"])
                    this.closestBranches!.push(GetManualCallListEntriesBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManualCallListEntriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetManualCallListEntriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mysteryShopperId"] = this.mysteryShopperId;
        data["email"] = this.email;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        if (Array.isArray(this.closestBranches)) {
            data["closestBranches"] = [];
            for (let item of this.closestBranches)
                data["closestBranches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetManualCallListEntriesDto {
    mysteryShopperId?: string;
    email?: string;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    status?: ManualCallListEntryStatus;
    closestBranches?: GetManualCallListEntriesBranchDto[];
}

export enum ManualCallListEntryStatus {
    ToCall = 0,
    Called = 1,
    Refused = 2,
    Accepted = 3,
}

export class GetManualCallListEntriesBranchDto implements IGetManualCallListEntriesBranchDto {
    name?: string;
    code?: string | undefined;
    distance?: string | undefined;

    constructor(data?: IGetManualCallListEntriesBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.distance = _data["distance"];
        }
    }

    static fromJS(data: any): GetManualCallListEntriesBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetManualCallListEntriesBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["distance"] = this.distance;
        return data;
    }
}

export interface IGetManualCallListEntriesBranchDto {
    name?: string;
    code?: string | undefined;
    distance?: string | undefined;
}

export class GetCallListEntriesFilter implements IGetCallListEntriesFilter {
    paginatedRequest?: PaginatedRequest;
    search?: string | undefined;
    status?: ManualCallListEntryStatus | undefined;
    branchIds?: string[] | undefined;

    constructor(data?: IGetCallListEntriesFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paginatedRequest = _data["paginatedRequest"] ? PaginatedRequest.fromJS(_data["paginatedRequest"]) : <any>undefined;
            this.search = _data["search"];
            this.status = _data["status"];
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCallListEntriesFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallListEntriesFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paginatedRequest"] = this.paginatedRequest ? this.paginatedRequest.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["status"] = this.status;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        return data;
    }
}

export interface IGetCallListEntriesFilter {
    paginatedRequest?: PaginatedRequest;
    search?: string | undefined;
    status?: ManualCallListEntryStatus | undefined;
    branchIds?: string[] | undefined;
}

export class GetCallListEntriesFilterViewModel implements IGetCallListEntriesFilterViewModel {
    branches?: GetManualCallListEntriesFilterBranchDto[];

    constructor(data?: IGetCallListEntriesFilterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetManualCallListEntriesFilterBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCallListEntriesFilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallListEntriesFilterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCallListEntriesFilterViewModel {
    branches?: GetManualCallListEntriesFilterBranchDto[];
}

export class GetManualCallListEntriesFilterBranchDto implements IGetManualCallListEntriesFilterBranchDto {
    id?: string;
    code?: string | undefined;
    name?: string;

    constructor(data?: IGetManualCallListEntriesFilterBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetManualCallListEntriesFilterBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetManualCallListEntriesFilterBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetManualCallListEntriesFilterBranchDto {
    id?: string;
    code?: string | undefined;
    name?: string;
}

export class GetCallListEntriesDetailsViewModel implements IGetCallListEntriesDetailsViewModel {
    branches?: GetCallListEntriesDetailsBranchDto[];

    constructor(data?: IGetCallListEntriesDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetCallListEntriesDetailsBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCallListEntriesDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallListEntriesDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCallListEntriesDetailsViewModel {
    branches?: GetCallListEntriesDetailsBranchDto[];
}

export class GetCallListEntriesDetailsBranchDto implements IGetCallListEntriesDetailsBranchDto {
    id?: string;
    code?: string | undefined;
    name?: string;
    location?: GeoLocation | undefined;
    distance?: string | undefined;

    constructor(data?: IGetCallListEntriesDetailsBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.location = _data["location"] ? GeoLocation.fromJS(_data["location"]) : <any>undefined;
            this.distance = _data["distance"];
        }
    }

    static fromJS(data: any): GetCallListEntriesDetailsBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallListEntriesDetailsBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["distance"] = this.distance;
        return data;
    }
}

export interface IGetCallListEntriesDetailsBranchDto {
    id?: string;
    code?: string | undefined;
    name?: string;
    location?: GeoLocation | undefined;
    distance?: string | undefined;
}

export class GeoLocation implements IGeoLocation {
    x?: number;
    y?: number;

    constructor(data?: IGeoLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): GeoLocation {
        data = typeof data === 'object' ? data : {};
        let result = new GeoLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        return data;
    }
}

export interface IGeoLocation {
    x?: number;
    y?: number;
}

export class GetFakeValidationViewModel implements IGetFakeValidationViewModel {
    fakeValidations?: FakeValidationDto[];
    fakeValidationTypes?: { [key in keyof typeof ValidationType]?: FakeValidationTypePayload; };

    constructor(data?: IGetFakeValidationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fakeValidations"])) {
                this.fakeValidations = [] as any;
                for (let item of _data["fakeValidations"])
                    this.fakeValidations!.push(FakeValidationDto.fromJS(item));
            }
            if (_data["fakeValidationTypes"]) {
                this.fakeValidationTypes = {} as any;
                for (let key in _data["fakeValidationTypes"]) {
                    if (_data["fakeValidationTypes"].hasOwnProperty(key))
                        (<any>this.fakeValidationTypes)![key] = _data["fakeValidationTypes"][key] ? FakeValidationTypePayload.fromJS(_data["fakeValidationTypes"][key]) : new FakeValidationTypePayload();
                }
            }
        }
    }

    static fromJS(data: any): GetFakeValidationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFakeValidationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fakeValidations)) {
            data["fakeValidations"] = [];
            for (let item of this.fakeValidations)
                data["fakeValidations"].push(item.toJSON());
        }
        if (this.fakeValidationTypes) {
            data["fakeValidationTypes"] = {};
            for (let key in this.fakeValidationTypes) {
                if (this.fakeValidationTypes.hasOwnProperty(key))
                    (<any>data["fakeValidationTypes"])[key] = this.fakeValidationTypes[key] ? this.fakeValidationTypes[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IGetFakeValidationViewModel {
    fakeValidations?: FakeValidationDto[];
    fakeValidationTypes?: { [key in keyof typeof ValidationType]?: FakeValidationTypePayload; };
}

export class FakeValidationDto implements IFakeValidationDto {
    id?: string | undefined;
    type?: ValidationType;
    mainQuestion?: string;
    secondQuestion?: string | undefined;
    fakeQuestion?: string | undefined;
    text?: string | undefined;
    formVersionId?: string;
    order?: number;
    enabled?: boolean;

    constructor(data?: IFakeValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.mainQuestion = _data["mainQuestion"];
            this.secondQuestion = _data["secondQuestion"];
            this.fakeQuestion = _data["fakeQuestion"];
            this.text = _data["text"];
            this.formVersionId = _data["formVersionId"];
            this.order = _data["order"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): FakeValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FakeValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["mainQuestion"] = this.mainQuestion;
        data["secondQuestion"] = this.secondQuestion;
        data["fakeQuestion"] = this.fakeQuestion;
        data["text"] = this.text;
        data["formVersionId"] = this.formVersionId;
        data["order"] = this.order;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IFakeValidationDto {
    id?: string | undefined;
    type?: ValidationType;
    mainQuestion?: string;
    secondQuestion?: string | undefined;
    fakeQuestion?: string | undefined;
    text?: string | undefined;
    formVersionId?: string;
    order?: number;
    enabled?: boolean;
}

export enum ValidationType {
    QuestionAnswered = 0,
    ScaleSentiment = 1,
    ImageAnswered = 2,
    AnswerCorrelation = 3,
    Custom = 4,
    DateTime = 5,
    ProductService = 6,
}

export class FakeValidationTypePayload implements IFakeValidationTypePayload {
    text?: string;
    mainQuestions?: QuestionDto[] | undefined;
    hasSecondQuestion?: boolean;
    secondQuestions?: QuestionDto[] | undefined;

    constructor(data?: IFakeValidationTypePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["mainQuestions"])) {
                this.mainQuestions = [] as any;
                for (let item of _data["mainQuestions"])
                    this.mainQuestions!.push(QuestionDto.fromJS(item));
            }
            this.hasSecondQuestion = _data["hasSecondQuestion"];
            if (Array.isArray(_data["secondQuestions"])) {
                this.secondQuestions = [] as any;
                for (let item of _data["secondQuestions"])
                    this.secondQuestions!.push(QuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FakeValidationTypePayload {
        data = typeof data === 'object' ? data : {};
        let result = new FakeValidationTypePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.mainQuestions)) {
            data["mainQuestions"] = [];
            for (let item of this.mainQuestions)
                data["mainQuestions"].push(item.toJSON());
        }
        data["hasSecondQuestion"] = this.hasSecondQuestion;
        if (Array.isArray(this.secondQuestions)) {
            data["secondQuestions"] = [];
            for (let item of this.secondQuestions)
                data["secondQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFakeValidationTypePayload {
    text?: string;
    mainQuestions?: QuestionDto[] | undefined;
    hasSecondQuestion?: boolean;
    secondQuestions?: QuestionDto[] | undefined;
}

export class QuestionDto implements IQuestionDto {
    questionName?: string;
    text?: string | undefined;

    constructor(data?: IQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionName = _data["questionName"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionName"] = this.questionName;
        data["text"] = this.text;
        return data;
    }
}

export interface IQuestionDto {
    questionName?: string;
    text?: string | undefined;
}

export class CreateOrUpdateFakeValidationCommandViewModel implements ICreateOrUpdateFakeValidationCommandViewModel {
    validations?: FakeValidationDto[];

    constructor(data?: ICreateOrUpdateFakeValidationCommandViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validations"])) {
                this.validations = [] as any;
                for (let item of _data["validations"])
                    this.validations!.push(FakeValidationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateFakeValidationCommandViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateFakeValidationCommandViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validations)) {
            data["validations"] = [];
            for (let item of this.validations)
                data["validations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateFakeValidationCommandViewModel {
    validations?: FakeValidationDto[];
}

export class GetCreateFormWizardViewModel implements IGetCreateFormWizardViewModel {
    parents?: GetCreateFormWizardProjectDto[];

    constructor(data?: IGetCreateFormWizardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(GetCreateFormWizardProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreateFormWizardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateFormWizardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreateFormWizardViewModel {
    parents?: GetCreateFormWizardProjectDto[];
}

export class GetCreateFormWizardProjectDto implements IGetCreateFormWizardProjectDto {
    id?: string;
    name?: string;
    forms?: GetCreateFormWizardFormDto[];

    constructor(data?: IGetCreateFormWizardProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(GetCreateFormWizardFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreateFormWizardProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateFormWizardProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreateFormWizardProjectDto {
    id?: string;
    name?: string;
    forms?: GetCreateFormWizardFormDto[];
}

export class GetCreateFormWizardFormDto implements IGetCreateFormWizardFormDto {
    id?: string;
    name?: string;

    constructor(data?: IGetCreateFormWizardFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateFormWizardFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateFormWizardFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateFormWizardFormDto {
    id?: string;
    name?: string;
}

export class GetFormListViewModel implements IGetFormListViewModel {
    forms?: GetFormListFormDto[];

    constructor(data?: IGetFormListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(GetFormListFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFormListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFormListViewModel {
    forms?: GetFormListFormDto[];
}

export class GetFormListFormDto implements IGetFormListFormDto {
    id?: string;
    name?: string;
    versionId?: string;
    majorVersion?: number;
    minorVersion?: number;

    constructor(data?: IGetFormListFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.versionId = _data["versionId"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
        }
    }

    static fromJS(data: any): GetFormListFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormListFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["versionId"] = this.versionId;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        return data;
    }
}

export interface IGetFormListFormDto {
    id?: string;
    name?: string;
    versionId?: string;
    majorVersion?: number;
    minorVersion?: number;
}

export class GetMetadataViewModel implements IGetMetadataViewModel {
    sections?: KeyValuePairOfStringAndString[];
    indicators?: KeyValuePairOfStringAndString[];
    taxonomies?: KeyValuePairOfStringAndString[];
    confidentialityLevels?: KeyValuePairOfStringAndString[];
    userRoles?: KeyValuePairOfStringAndString[];

    constructor(data?: IGetMetadataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
            if (Array.isArray(_data["indicators"])) {
                this.indicators = [] as any;
                for (let item of _data["indicators"])
                    this.indicators!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
            if (Array.isArray(_data["taxonomies"])) {
                this.taxonomies = [] as any;
                for (let item of _data["taxonomies"])
                    this.taxonomies!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
            if (Array.isArray(_data["confidentialityLevels"])) {
                this.confidentialityLevels = [] as any;
                for (let item of _data["confidentialityLevels"])
                    this.confidentialityLevels!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMetadataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMetadataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        if (Array.isArray(this.indicators)) {
            data["indicators"] = [];
            for (let item of this.indicators)
                data["indicators"].push(item.toJSON());
        }
        if (Array.isArray(this.taxonomies)) {
            data["taxonomies"] = [];
            for (let item of this.taxonomies)
                data["taxonomies"].push(item.toJSON());
        }
        if (Array.isArray(this.confidentialityLevels)) {
            data["confidentialityLevels"] = [];
            for (let item of this.confidentialityLevels)
                data["confidentialityLevels"].push(item.toJSON());
        }
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMetadataViewModel {
    sections?: KeyValuePairOfStringAndString[];
    indicators?: KeyValuePairOfStringAndString[];
    taxonomies?: KeyValuePairOfStringAndString[];
    confidentialityLevels?: KeyValuePairOfStringAndString[];
    userRoles?: KeyValuePairOfStringAndString[];
}

export class KeyValuePairOfStringAndString implements IKeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IKeyValuePairOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;
}

export class GetFormViewModel implements IGetFormViewModel {
    id?: string;
    cultures?: GetFormCultureDto[];
    hierarchyRoleTypes?: GetFormHierarchyRoleTypeDto[];
    versions?: GetFormVersionDto[];
    latestVersion?: GetLatestFormVersionDto;

    constructor(data?: IGetFormViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(GetFormCultureDto.fromJS(item));
            }
            if (Array.isArray(_data["hierarchyRoleTypes"])) {
                this.hierarchyRoleTypes = [] as any;
                for (let item of _data["hierarchyRoleTypes"])
                    this.hierarchyRoleTypes!.push(GetFormHierarchyRoleTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(GetFormVersionDto.fromJS(item));
            }
            this.latestVersion = _data["latestVersion"] ? GetLatestFormVersionDto.fromJS(_data["latestVersion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFormViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.hierarchyRoleTypes)) {
            data["hierarchyRoleTypes"] = [];
            for (let item of this.hierarchyRoleTypes)
                data["hierarchyRoleTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        data["latestVersion"] = this.latestVersion ? this.latestVersion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFormViewModel {
    id?: string;
    cultures?: GetFormCultureDto[];
    hierarchyRoleTypes?: GetFormHierarchyRoleTypeDto[];
    versions?: GetFormVersionDto[];
    latestVersion?: GetLatestFormVersionDto;
}

export class GetFormCultureDto implements IGetFormCultureDto {
    isPrimary?: boolean;
    name?: string;
    cultureCode?: string;

    constructor(data?: IGetFormCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPrimary = _data["isPrimary"];
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): GetFormCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPrimary"] = this.isPrimary;
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IGetFormCultureDto {
    isPrimary?: boolean;
    name?: string;
    cultureCode?: string;
}

export class GetFormHierarchyRoleTypeDto implements IGetFormHierarchyRoleTypeDto {
    key?: HierarchyRoleType;
    value?: string;

    constructor(data?: IGetFormHierarchyRoleTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetFormHierarchyRoleTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormHierarchyRoleTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IGetFormHierarchyRoleTypeDto {
    key?: HierarchyRoleType;
    value?: string;
}

export enum HierarchyRoleType {
    NotSet = 0,
    NoAccess = 1,
    Inherited = 3,
    Access = 7,
    Reader = 15,
    Contributor = 31,
    Administrator = 63,
    Owner = 127,
}

export class GetFormVersionDto implements IGetFormVersionDto {
    id?: string;
    state?: FormVersionState;
    majorVersion?: number;
    minorVersion?: number;

    constructor(data?: IGetFormVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
        }
    }

    static fromJS(data: any): GetFormVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        return data;
    }
}

export interface IGetFormVersionDto {
    id?: string;
    state?: FormVersionState;
    majorVersion?: number;
    minorVersion?: number;
}

export enum FormVersionState {
    Preview = 0,
    Published = 1,
}

export class GetLatestFormVersionDto implements IGetLatestFormVersionDto {
    id?: string;
    formJson?: string;

    constructor(data?: IGetLatestFormVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): GetLatestFormVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestFormVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IGetLatestFormVersionDto {
    id?: string;
    formJson?: string;
}

export class CreateFormDto implements ICreateFormDto {
    name?: string;

    constructor(data?: ICreateFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateFormDto {
    name?: string;
}

export class UpdateFormCultureDto implements IUpdateFormCultureDto {
    isPrimary?: boolean;
    name?: string;
    cultureCode?: string;

    constructor(data?: IUpdateFormCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPrimary = _data["isPrimary"];
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): UpdateFormCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPrimary"] = this.isPrimary;
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IUpdateFormCultureDto {
    isPrimary?: boolean;
    name?: string;
    cultureCode?: string;
}

export class DuplicateFormVersionResponseViewModel implements IDuplicateFormVersionResponseViewModel {
    id?: string;
    formId?: string;
    majorVersion?: number;
    minorVersion?: number;

    constructor(data?: IDuplicateFormVersionResponseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formId = _data["formId"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
        }
    }

    static fromJS(data: any): DuplicateFormVersionResponseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateFormVersionResponseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formId"] = this.formId;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        return data;
    }
}

export interface IDuplicateFormVersionResponseViewModel {
    id?: string;
    formId?: string;
    majorVersion?: number;
    minorVersion?: number;
}

export class WordExportDto implements IWordExportDto {
    header?: string;
    conditionMessage?: string;
    welcomeMessage?: string;
    languages?: string[];

    constructor(data?: IWordExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.conditionMessage = _data["conditionMessage"];
            this.welcomeMessage = _data["welcomeMessage"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
        }
    }

    static fromJS(data: any): WordExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new WordExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["conditionMessage"] = this.conditionMessage;
        data["welcomeMessage"] = this.welcomeMessage;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        return data;
    }
}

export interface IWordExportDto {
    header?: string;
    conditionMessage?: string;
    welcomeMessage?: string;
    languages?: string[];
}

export class MysteryShoppingFormVersionViewModel implements IMysteryShoppingFormVersionViewModel {
    id?: string;
    majorVersion?: number;
    minorVersion?: number;

    constructor(data?: IMysteryShoppingFormVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
        }
    }

    static fromJS(data: any): MysteryShoppingFormVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShoppingFormVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        return data;
    }
}

export interface IMysteryShoppingFormVersionViewModel {
    id?: string;
    majorVersion?: number;
    minorVersion?: number;
}

export class MysteryShoppingFormVersionDto implements IMysteryShoppingFormVersionDto {
    id?: string;
    formJson?: string;

    constructor(data?: IMysteryShoppingFormVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): MysteryShoppingFormVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShoppingFormVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IMysteryShoppingFormVersionDto {
    id?: string;
    formJson?: string;
}

export class GetValidationViewModel implements IGetValidationViewModel {
    validations?: ValidationDto[];
    validationTypes?: { [key in keyof typeof ValidationType]?: ValidationTypePayload[]; };
    supportedCultures?: ValidationSupportedCulture[];

    constructor(data?: IGetValidationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validations"])) {
                this.validations = [] as any;
                for (let item of _data["validations"])
                    this.validations!.push(ValidationDto.fromJS(item));
            }
            if (_data["validationTypes"]) {
                this.validationTypes = {} as any;
                for (let key in _data["validationTypes"]) {
                    if (_data["validationTypes"].hasOwnProperty(key))
                        (<any>this.validationTypes)![key] = _data["validationTypes"][key] ? _data["validationTypes"][key].map((i: any) => ValidationTypePayload.fromJS(i)) : [];
                }
            }
            if (Array.isArray(_data["supportedCultures"])) {
                this.supportedCultures = [] as any;
                for (let item of _data["supportedCultures"])
                    this.supportedCultures!.push(ValidationSupportedCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetValidationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetValidationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validations)) {
            data["validations"] = [];
            for (let item of this.validations)
                data["validations"].push(item.toJSON());
        }
        if (this.validationTypes) {
            data["validationTypes"] = {};
            for (let key in this.validationTypes) {
                if (this.validationTypes.hasOwnProperty(key))
                    (<any>data["validationTypes"])[key] = (<any>this.validationTypes)[key];
            }
        }
        if (Array.isArray(this.supportedCultures)) {
            data["supportedCultures"] = [];
            for (let item of this.supportedCultures)
                data["supportedCultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetValidationViewModel {
    validations?: ValidationDto[];
    validationTypes?: { [key in keyof typeof ValidationType]?: ValidationTypePayload[]; };
    supportedCultures?: ValidationSupportedCulture[];
}

export class ValidationDto implements IValidationDto {
    id?: string | undefined;
    type?: ValidationType;
    mainQuestion?: string;
    secondQuestion?: string | undefined;
    formVersionId?: string;
    order?: number;
    enabled?: boolean;
    cultures?: ValidationCultureDto[] | undefined;

    constructor(data?: IValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.mainQuestion = _data["mainQuestion"];
            this.secondQuestion = _data["secondQuestion"];
            this.formVersionId = _data["formVersionId"];
            this.order = _data["order"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(ValidationCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["mainQuestion"] = this.mainQuestion;
        data["secondQuestion"] = this.secondQuestion;
        data["formVersionId"] = this.formVersionId;
        data["order"] = this.order;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationDto {
    id?: string | undefined;
    type?: ValidationType;
    mainQuestion?: string;
    secondQuestion?: string | undefined;
    formVersionId?: string;
    order?: number;
    enabled?: boolean;
    cultures?: ValidationCultureDto[] | undefined;
}

export class ValidationCultureDto implements IValidationCultureDto {
    text?: string;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: IValidationCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): ValidationCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IValidationCultureDto {
    text?: string;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class ValidationTypePayload implements IValidationTypePayload {
    formVersionId?: string;
    text?: string;
    mainQuestions?: QuestionDto[] | undefined;
    hasSecondQuestion?: boolean;
    secondQuestions?: QuestionDto[] | undefined;

    constructor(data?: IValidationTypePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formVersionId = _data["formVersionId"];
            this.text = _data["text"];
            if (Array.isArray(_data["mainQuestions"])) {
                this.mainQuestions = [] as any;
                for (let item of _data["mainQuestions"])
                    this.mainQuestions!.push(QuestionDto.fromJS(item));
            }
            this.hasSecondQuestion = _data["hasSecondQuestion"];
            if (Array.isArray(_data["secondQuestions"])) {
                this.secondQuestions = [] as any;
                for (let item of _data["secondQuestions"])
                    this.secondQuestions!.push(QuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationTypePayload {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationTypePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formVersionId"] = this.formVersionId;
        data["text"] = this.text;
        if (Array.isArray(this.mainQuestions)) {
            data["mainQuestions"] = [];
            for (let item of this.mainQuestions)
                data["mainQuestions"].push(item.toJSON());
        }
        data["hasSecondQuestion"] = this.hasSecondQuestion;
        if (Array.isArray(this.secondQuestions)) {
            data["secondQuestions"] = [];
            for (let item of this.secondQuestions)
                data["secondQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationTypePayload {
    formVersionId?: string;
    text?: string;
    mainQuestions?: QuestionDto[] | undefined;
    hasSecondQuestion?: boolean;
    secondQuestions?: QuestionDto[] | undefined;
}

export class ValidationSupportedCulture implements IValidationSupportedCulture {
    text?: string;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: IValidationSupportedCulture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): ValidationSupportedCulture {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationSupportedCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IValidationSupportedCulture {
    text?: string;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class FormVersionTransferDto implements IFormVersionTransferDto {
    questionTransfers?: QuestionTransfer[];

    constructor(data?: IFormVersionTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questionTransfers"])) {
                this.questionTransfers = [] as any;
                for (let item of _data["questionTransfers"])
                    this.questionTransfers!.push(QuestionTransfer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormVersionTransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormVersionTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questionTransfers)) {
            data["questionTransfers"] = [];
            for (let item of this.questionTransfers)
                data["questionTransfers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormVersionTransferDto {
    questionTransfers?: QuestionTransfer[];
}

export class QuestionTransfer implements IQuestionTransfer {
    source?: string;
    target?: string;
    rows?: ChoiceTransfer[] | undefined;
    choices?: ChoiceTransfer[];

    constructor(data?: IQuestionTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.target = _data["target"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ChoiceTransfer.fromJS(item));
            }
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(ChoiceTransfer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["target"] = this.target;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionTransfer {
    source?: string;
    target?: string;
    rows?: ChoiceTransfer[] | undefined;
    choices?: ChoiceTransfer[];
}

export class ChoiceTransfer implements IChoiceTransfer {
    source?: string;
    target?: string;

    constructor(data?: IChoiceTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): ChoiceTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["target"] = this.target;
        return data;
    }
}

export interface IChoiceTransfer {
    source?: string;
    target?: string;
}

export class GptValidationResultViewModel implements IGptValidationResultViewModel {
    validations?: TableResponse;
    mysteryShoppers?: MysteryShopperFilter[];
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    totalCount?: number;

    constructor(data?: IGptValidationResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validations = _data["validations"] ? TableResponse.fromJS(_data["validations"]) : <any>undefined;
            if (Array.isArray(_data["mysteryShoppers"])) {
                this.mysteryShoppers = [] as any;
                for (let item of _data["mysteryShoppers"])
                    this.mysteryShoppers!.push(MysteryShopperFilter.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GptValidationResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GptValidationResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validations"] = this.validations ? this.validations.toJSON() : <any>undefined;
        if (Array.isArray(this.mysteryShoppers)) {
            data["mysteryShoppers"] = [];
            for (let item of this.mysteryShoppers)
                data["mysteryShoppers"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGptValidationResultViewModel {
    validations?: TableResponse;
    mysteryShoppers?: MysteryShopperFilter[];
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    totalCount?: number;
}

export class MysteryShopperFilter implements IMysteryShopperFilter {
    id?: string;
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IMysteryShopperFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): MysteryShopperFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IMysteryShopperFilter {
    id?: string;
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class GptValidationFilter implements IGptValidationFilter {
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodId?: string | undefined;
    periodMissionConfigurationId?: string | undefined;
    branchIds?: string[] | undefined;
    branchSearch?: string | undefined;
    missionAssignationIdSearch?: string | undefined;
    missionAnswerIdSearch?: string | undefined;
    mysteryShopperSearch?: string | undefined;
    mysteryShopperId?: string | undefined;
    missionAssignationStatuses?: MissionAssignationStatus[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    validationTypes?: string[] | undefined;
    fraudDetected?: boolean;

    constructor(data?: IGptValidationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.periodId = _data["periodId"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            this.branchSearch = _data["branchSearch"];
            this.missionAssignationIdSearch = _data["missionAssignationIdSearch"];
            this.missionAnswerIdSearch = _data["missionAnswerIdSearch"];
            this.mysteryShopperSearch = _data["mysteryShopperSearch"];
            this.mysteryShopperId = _data["mysteryShopperId"];
            if (Array.isArray(_data["missionAssignationStatuses"])) {
                this.missionAssignationStatuses = [] as any;
                for (let item of _data["missionAssignationStatuses"])
                    this.missionAssignationStatuses!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["validationTypes"])) {
                this.validationTypes = [] as any;
                for (let item of _data["validationTypes"])
                    this.validationTypes!.push(item);
            }
            this.fraudDetected = _data["fraudDetected"];
        }
    }

    static fromJS(data: any): GptValidationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GptValidationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["periodId"] = this.periodId;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        data["branchSearch"] = this.branchSearch;
        data["missionAssignationIdSearch"] = this.missionAssignationIdSearch;
        data["missionAnswerIdSearch"] = this.missionAnswerIdSearch;
        data["mysteryShopperSearch"] = this.mysteryShopperSearch;
        data["mysteryShopperId"] = this.mysteryShopperId;
        if (Array.isArray(this.missionAssignationStatuses)) {
            data["missionAssignationStatuses"] = [];
            for (let item of this.missionAssignationStatuses)
                data["missionAssignationStatuses"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.validationTypes)) {
            data["validationTypes"] = [];
            for (let item of this.validationTypes)
                data["validationTypes"].push(item);
        }
        data["fraudDetected"] = this.fraudDetected;
        return data;
    }
}

export interface IGptValidationFilter {
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodId?: string | undefined;
    periodMissionConfigurationId?: string | undefined;
    branchIds?: string[] | undefined;
    branchSearch?: string | undefined;
    missionAssignationIdSearch?: string | undefined;
    missionAnswerIdSearch?: string | undefined;
    mysteryShopperSearch?: string | undefined;
    mysteryShopperId?: string | undefined;
    missionAssignationStatuses?: MissionAssignationStatus[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    validationTypes?: string[] | undefined;
    fraudDetected?: boolean;
}

export class GetGptValidationFiltersViewModel implements IGetGptValidationFiltersViewModel {
    organizations?: OrganizationFilter[];
    subscriptions?: SubscriptionFilter[];
    subscriptionServices?: SubscriptionServiceFilter[];
    projects?: ProjectFilter[];
    missionConfigurations?: MissionConfigurationFilter[];
    periods?: PeriodFilter[];

    constructor(data?: IGetGptValidationFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationFilter.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(SubscriptionFilter.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(SubscriptionServiceFilter.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectFilter.fromJS(item));
            }
            if (Array.isArray(_data["missionConfigurations"])) {
                this.missionConfigurations = [] as any;
                for (let item of _data["missionConfigurations"])
                    this.missionConfigurations!.push(MissionConfigurationFilter.fromJS(item));
            }
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(PeriodFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGptValidationFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetGptValidationFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.missionConfigurations)) {
            data["missionConfigurations"] = [];
            for (let item of this.missionConfigurations)
                data["missionConfigurations"].push(item.toJSON());
        }
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGptValidationFiltersViewModel {
    organizations?: OrganizationFilter[];
    subscriptions?: SubscriptionFilter[];
    subscriptionServices?: SubscriptionServiceFilter[];
    projects?: ProjectFilter[];
    missionConfigurations?: MissionConfigurationFilter[];
    periods?: PeriodFilter[];
}

export class PropagateAiValidationStatusViewModel implements IPropagateAiValidationStatusViewModel {
    success?: boolean;

    constructor(data?: IPropagateAiValidationStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PropagateAiValidationStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropagateAiValidationStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IPropagateAiValidationStatusViewModel {
    success?: boolean;
}

export class GetImageDataViewModel implements IGetImageDataViewModel {
    image?: { [key: string]: string; } | undefined;

    constructor(data?: IGetImageDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["image"]) {
                this.image = {} as any;
                for (let key in _data["image"]) {
                    if (_data["image"].hasOwnProperty(key))
                        (<any>this.image)![key] = _data["image"][key];
                }
            }
        }
    }

    static fromJS(data: any): GetImageDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetImageDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.image) {
            data["image"] = {};
            for (let key in this.image) {
                if (this.image.hasOwnProperty(key))
                    (<any>data["image"])[key] = (<any>this.image)[key];
            }
        }
        return data;
    }
}

export interface IGetImageDataViewModel {
    image?: { [key: string]: string; } | undefined;
}

export class GetIndicatorListViewModel implements IGetIndicatorListViewModel {
    indicators?: GetIndicatorListIndicatorDto[];

    constructor(data?: IGetIndicatorListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["indicators"])) {
                this.indicators = [] as any;
                for (let item of _data["indicators"])
                    this.indicators!.push(GetIndicatorListIndicatorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIndicatorListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetIndicatorListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.indicators)) {
            data["indicators"] = [];
            for (let item of this.indicators)
                data["indicators"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIndicatorListViewModel {
    indicators?: GetIndicatorListIndicatorDto[];
}

export class GetIndicatorListIndicatorDto implements IGetIndicatorListIndicatorDto {
    id?: string;
    name?: string;
    shortName?: string | undefined;
    code?: string;
    order?: number;
    target?: number | undefined;

    constructor(data?: IGetIndicatorListIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
            this.order = _data["order"];
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): GetIndicatorListIndicatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIndicatorListIndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        data["order"] = this.order;
        data["target"] = this.target;
        return data;
    }
}

export interface IGetIndicatorListIndicatorDto {
    id?: string;
    name?: string;
    shortName?: string | undefined;
    code?: string;
    order?: number;
    target?: number | undefined;
}

export class GetIndicatorViewModel implements IGetIndicatorViewModel {
    id?: string;
    indicator?: GetIndicatorDto;

    constructor(data?: IGetIndicatorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.indicator = _data["indicator"] ? GetIndicatorDto.fromJS(_data["indicator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIndicatorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetIndicatorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["indicator"] = this.indicator ? this.indicator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetIndicatorViewModel {
    id?: string;
    indicator?: GetIndicatorDto;
}

export class GetIndicatorDto implements IGetIndicatorDto {
    cultures?: IndicatorCultureDto[];
    code?: string;
    order?: number;
    target?: number | undefined;

    constructor(data?: IGetIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(IndicatorCultureDto.fromJS(item));
            }
            this.code = _data["code"];
            this.order = _data["order"];
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): GetIndicatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["order"] = this.order;
        data["target"] = this.target;
        return data;
    }
}

export interface IGetIndicatorDto {
    cultures?: IndicatorCultureDto[];
    code?: string;
    order?: number;
    target?: number | undefined;
}

export class IndicatorCultureDto implements IIndicatorCultureDto {
    name?: string;
    shortName?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: IIndicatorCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): IndicatorCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndicatorCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IIndicatorCultureDto {
    name?: string;
    shortName?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class CreateIndicatorViewModel implements ICreateIndicatorViewModel {
    indicatorId?: string;

    constructor(data?: ICreateIndicatorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indicatorId = _data["indicatorId"];
        }
    }

    static fromJS(data: any): CreateIndicatorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIndicatorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicatorId"] = this.indicatorId;
        return data;
    }
}

export interface ICreateIndicatorViewModel {
    indicatorId?: string;
}

export class CreateIndicatorDto implements ICreateIndicatorDto {
    code?: string;
    name?: string;
    shortName?: string | undefined;
    order?: number | undefined;
    target?: number | undefined;

    constructor(data?: ICreateIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.order = _data["order"];
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): CreateIndicatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["order"] = this.order;
        data["target"] = this.target;
        return data;
    }
}

export interface ICreateIndicatorDto {
    code?: string;
    name?: string;
    shortName?: string | undefined;
    order?: number | undefined;
    target?: number | undefined;
}

export class UpdateIndicatorRequest implements IUpdateIndicatorRequest {
    cultures?: IndicatorCultureDto[];
    code?: string;
    order?: number;
    target?: number | undefined;

    constructor(data?: IUpdateIndicatorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(IndicatorCultureDto.fromJS(item));
            }
            this.code = _data["code"];
            this.order = _data["order"];
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): UpdateIndicatorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIndicatorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["order"] = this.order;
        data["target"] = this.target;
        return data;
    }
}

export interface IUpdateIndicatorRequest {
    cultures?: IndicatorCultureDto[];
    code?: string;
    order?: number;
    target?: number | undefined;
}

export class GetMissionAssignationListFiltersViewModel implements IGetMissionAssignationListFiltersViewModel {
    earliestMissionAssignationDate?: Date | undefined;
    latestMissionAssignationDate?: Date | undefined;
    organizations?: OrganizationFilter[];
    subscriptions?: SubscriptionFilter[];
    subscriptionServices?: SubscriptionServiceFilter[];
    projects?: ProjectFilter[];
    missionConfigurations?: MissionConfigurationFilter[];
    periods?: PeriodFilter[];

    constructor(data?: IGetMissionAssignationListFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.earliestMissionAssignationDate = _data["earliestMissionAssignationDate"] ? new Date(_data["earliestMissionAssignationDate"].toString()) : <any>undefined;
            this.latestMissionAssignationDate = _data["latestMissionAssignationDate"] ? new Date(_data["latestMissionAssignationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationFilter.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(SubscriptionFilter.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(SubscriptionServiceFilter.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectFilter.fromJS(item));
            }
            if (Array.isArray(_data["missionConfigurations"])) {
                this.missionConfigurations = [] as any;
                for (let item of _data["missionConfigurations"])
                    this.missionConfigurations!.push(MissionConfigurationFilter.fromJS(item));
            }
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(PeriodFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionAssignationListFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionAssignationListFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["earliestMissionAssignationDate"] = this.earliestMissionAssignationDate ? this.earliestMissionAssignationDate.toISOString() : <any>undefined;
        data["latestMissionAssignationDate"] = this.latestMissionAssignationDate ? this.latestMissionAssignationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.missionConfigurations)) {
            data["missionConfigurations"] = [];
            for (let item of this.missionConfigurations)
                data["missionConfigurations"].push(item.toJSON());
        }
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMissionAssignationListFiltersViewModel {
    earliestMissionAssignationDate?: Date | undefined;
    latestMissionAssignationDate?: Date | undefined;
    organizations?: OrganizationFilter[];
    subscriptions?: SubscriptionFilter[];
    subscriptionServices?: SubscriptionServiceFilter[];
    projects?: ProjectFilter[];
    missionConfigurations?: MissionConfigurationFilter[];
    periods?: PeriodFilter[];
}

export class GetMissionAssignationListSummaryViewModel implements IGetMissionAssignationListSummaryViewModel {
    missionAssignationCount?: number;
    assignedCount?: number;
    validatingCount?: number;
    validationRejectedCount?: number;
    approvedCount?: number;
    cancelledCount?: number;
    expiredCount?: number;
    expiredCorrectionCount?: number;

    constructor(data?: IGetMissionAssignationListSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionAssignationCount = _data["missionAssignationCount"];
            this.assignedCount = _data["assignedCount"];
            this.validatingCount = _data["validatingCount"];
            this.validationRejectedCount = _data["validationRejectedCount"];
            this.approvedCount = _data["approvedCount"];
            this.cancelledCount = _data["cancelledCount"];
            this.expiredCount = _data["expiredCount"];
            this.expiredCorrectionCount = _data["expiredCorrectionCount"];
        }
    }

    static fromJS(data: any): GetMissionAssignationListSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionAssignationListSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationCount"] = this.missionAssignationCount;
        data["assignedCount"] = this.assignedCount;
        data["validatingCount"] = this.validatingCount;
        data["validationRejectedCount"] = this.validationRejectedCount;
        data["approvedCount"] = this.approvedCount;
        data["cancelledCount"] = this.cancelledCount;
        data["expiredCount"] = this.expiredCount;
        data["expiredCorrectionCount"] = this.expiredCorrectionCount;
        return data;
    }
}

export interface IGetMissionAssignationListSummaryViewModel {
    missionAssignationCount?: number;
    assignedCount?: number;
    validatingCount?: number;
    validationRejectedCount?: number;
    approvedCount?: number;
    cancelledCount?: number;
    expiredCount?: number;
    expiredCorrectionCount?: number;
}

export class GetMissionAssignationListFilter implements IGetMissionAssignationListFilter {
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodId?: string | undefined;
    periodMissionConfigurationId?: string | undefined;
    branchIds?: string[] | undefined;
    branchSearch?: string | undefined;
    mysteryShopperId?: string | undefined;
    missionAssignationStatuses?: MissionAssignationStatus[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IGetMissionAssignationListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.periodId = _data["periodId"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            this.branchSearch = _data["branchSearch"];
            this.mysteryShopperId = _data["mysteryShopperId"];
            if (Array.isArray(_data["missionAssignationStatuses"])) {
                this.missionAssignationStatuses = [] as any;
                for (let item of _data["missionAssignationStatuses"])
                    this.missionAssignationStatuses!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMissionAssignationListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionAssignationListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["periodId"] = this.periodId;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        data["branchSearch"] = this.branchSearch;
        data["mysteryShopperId"] = this.mysteryShopperId;
        if (Array.isArray(this.missionAssignationStatuses)) {
            data["missionAssignationStatuses"] = [];
            for (let item of this.missionAssignationStatuses)
                data["missionAssignationStatuses"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMissionAssignationListFilter {
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodId?: string | undefined;
    periodMissionConfigurationId?: string | undefined;
    branchIds?: string[] | undefined;
    branchSearch?: string | undefined;
    mysteryShopperId?: string | undefined;
    missionAssignationStatuses?: MissionAssignationStatus[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class GetMissionAssignationListViewModel implements IGetMissionAssignationListViewModel {
    missions?: PaginatedResponseOfGetMissionAssignationListMissionDto;

    constructor(data?: IGetMissionAssignationListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missions = _data["missions"] ? PaginatedResponseOfGetMissionAssignationListMissionDto.fromJS(_data["missions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMissionAssignationListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionAssignationListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missions"] = this.missions ? this.missions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMissionAssignationListViewModel {
    missions?: PaginatedResponseOfGetMissionAssignationListMissionDto;
}

export class PaginatedResponseOfGetMissionAssignationListMissionDto implements IPaginatedResponseOfGetMissionAssignationListMissionDto {
    items?: GetMissionAssignationListMissionDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfGetMissionAssignationListMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMissionAssignationListMissionDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetMissionAssignationListMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetMissionAssignationListMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfGetMissionAssignationListMissionDto {
    items?: GetMissionAssignationListMissionDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class GetMissionAssignationListMissionDto implements IGetMissionAssignationListMissionDto {
    missionAssignationId?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    endDate?: Date | undefined;
    missionAssignationStatus?: MissionAssignationStatus;
    mysteryShopperId?: string;
    mysteryShopperFirstName?: string | undefined;
    mysteryShopperLastName?: string | undefined;
    mysteryShopperEmail?: string;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionName?: string | undefined;
    subscriptionServiceId?: string | undefined;
    subscriptionServiceName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    missionConfigurationId?: string | undefined;
    missionConfigurationName?: string | undefined;
    periodId?: string | undefined;
    periodName?: string | undefined;
    branchId?: string;
    branchCode?: string;
    branchName?: string;
    canBeCancelled?: boolean;
    canBypassValidation?: boolean;
    canBeDeactivated?: boolean;
    canBeExtended?: boolean;
    canBeEdited?: boolean;

    constructor(data?: IGetMissionAssignationListMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionAssignationId = _data["missionAssignationId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.missionAssignationStatus = _data["missionAssignationStatus"];
            this.mysteryShopperId = _data["mysteryShopperId"];
            this.mysteryShopperFirstName = _data["mysteryShopperFirstName"];
            this.mysteryShopperLastName = _data["mysteryShopperLastName"];
            this.mysteryShopperEmail = _data["mysteryShopperEmail"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionName = _data["subscriptionName"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.subscriptionServiceName = _data["subscriptionServiceName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.periodId = _data["periodId"];
            this.periodName = _data["periodName"];
            this.branchId = _data["branchId"];
            this.branchCode = _data["branchCode"];
            this.branchName = _data["branchName"];
            this.canBeCancelled = _data["canBeCancelled"];
            this.canBypassValidation = _data["canBypassValidation"];
            this.canBeDeactivated = _data["canBeDeactivated"];
            this.canBeExtended = _data["canBeExtended"];
            this.canBeEdited = _data["canBeEdited"];
        }
    }

    static fromJS(data: any): GetMissionAssignationListMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionAssignationListMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationId"] = this.missionAssignationId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["missionAssignationStatus"] = this.missionAssignationStatus;
        data["mysteryShopperId"] = this.mysteryShopperId;
        data["mysteryShopperFirstName"] = this.mysteryShopperFirstName;
        data["mysteryShopperLastName"] = this.mysteryShopperLastName;
        data["mysteryShopperEmail"] = this.mysteryShopperEmail;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionName"] = this.subscriptionName;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["subscriptionServiceName"] = this.subscriptionServiceName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["periodId"] = this.periodId;
        data["periodName"] = this.periodName;
        data["branchId"] = this.branchId;
        data["branchCode"] = this.branchCode;
        data["branchName"] = this.branchName;
        data["canBeCancelled"] = this.canBeCancelled;
        data["canBypassValidation"] = this.canBypassValidation;
        data["canBeDeactivated"] = this.canBeDeactivated;
        data["canBeExtended"] = this.canBeExtended;
        data["canBeEdited"] = this.canBeEdited;
        return data;
    }
}

export interface IGetMissionAssignationListMissionDto {
    missionAssignationId?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    endDate?: Date | undefined;
    missionAssignationStatus?: MissionAssignationStatus;
    mysteryShopperId?: string;
    mysteryShopperFirstName?: string | undefined;
    mysteryShopperLastName?: string | undefined;
    mysteryShopperEmail?: string;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionName?: string | undefined;
    subscriptionServiceId?: string | undefined;
    subscriptionServiceName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    missionConfigurationId?: string | undefined;
    missionConfigurationName?: string | undefined;
    periodId?: string | undefined;
    periodName?: string | undefined;
    branchId?: string;
    branchCode?: string;
    branchName?: string;
    canBeCancelled?: boolean;
    canBypassValidation?: boolean;
    canBeDeactivated?: boolean;
    canBeExtended?: boolean;
    canBeEdited?: boolean;
}

export class SetPeerReviewValidationViewModel implements ISetPeerReviewValidationViewModel {
    status?: PeerReviewValidationStatus;
    comment?: string | undefined;

    constructor(data?: ISetPeerReviewValidationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SetPeerReviewValidationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetPeerReviewValidationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ISetPeerReviewValidationViewModel {
    status?: PeerReviewValidationStatus;
    comment?: string | undefined;
}

export enum PeerReviewValidationStatus {
    InProgress = 0,
    Succeeded = 1,
    Failed = 2,
    Inconclusive = 3,
}

export class MissionConfigurationGroupListViewModel implements IMissionConfigurationGroupListViewModel {
    missionConfigurationGroups?: PaginatedResponseOfMissionConfigurationGroupItem;

    constructor(data?: IMissionConfigurationGroupListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionConfigurationGroups = _data["missionConfigurationGroups"] ? PaginatedResponseOfMissionConfigurationGroupItem.fromJS(_data["missionConfigurationGroups"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MissionConfigurationGroupListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationGroupListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionConfigurationGroups"] = this.missionConfigurationGroups ? this.missionConfigurationGroups.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMissionConfigurationGroupListViewModel {
    missionConfigurationGroups?: PaginatedResponseOfMissionConfigurationGroupItem;
}

export class PaginatedResponseOfMissionConfigurationGroupItem implements IPaginatedResponseOfMissionConfigurationGroupItem {
    items?: MissionConfigurationGroupItem[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfMissionConfigurationGroupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MissionConfigurationGroupItem.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfMissionConfigurationGroupItem {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfMissionConfigurationGroupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfMissionConfigurationGroupItem {
    items?: MissionConfigurationGroupItem[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class MissionConfigurationGroupItem implements IMissionConfigurationGroupItem {
    id?: string;
    name?: string;
    members?: MissionConfigurationItem[] | undefined;
    memberCount?: number;

    constructor(data?: IMissionConfigurationGroupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(MissionConfigurationItem.fromJS(item));
            }
            this.memberCount = _data["memberCount"];
        }
    }

    static fromJS(data: any): MissionConfigurationGroupItem {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationGroupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        data["memberCount"] = this.memberCount;
        return data;
    }
}

export interface IMissionConfigurationGroupItem {
    id?: string;
    name?: string;
    members?: MissionConfigurationItem[] | undefined;
    memberCount?: number;
}

export class MissionConfigurationItem implements IMissionConfigurationItem {
    id?: string;
    name?: string;

    constructor(data?: IMissionConfigurationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MissionConfigurationItem {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMissionConfigurationItem {
    id?: string;
    name?: string;
}

export enum MissionConfigurationGroupSortingField {
    Name = 0,
    Members = 1,
}

export enum SortingDirection {
    Ascending = 0,
    Descending = 1,
}

export class MissionConfigurationGroupViewModel implements IMissionConfigurationGroupViewModel {
    missionConfigurationGroupDto?: UpdateMissionConfigurationGroupDto;

    constructor(data?: IMissionConfigurationGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionConfigurationGroupDto = _data["missionConfigurationGroupDto"] ? UpdateMissionConfigurationGroupDto.fromJS(_data["missionConfigurationGroupDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MissionConfigurationGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionConfigurationGroupDto"] = this.missionConfigurationGroupDto ? this.missionConfigurationGroupDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMissionConfigurationGroupViewModel {
    missionConfigurationGroupDto?: UpdateMissionConfigurationGroupDto;
}

export class UpdateMissionConfigurationGroupDto implements IUpdateMissionConfigurationGroupDto {
    id?: string;
    cultures?: MissionConfigurationGroupCultureDto[];
    members?: MissionConfigurationGroupMemberDto[] | undefined;

    constructor(data?: IUpdateMissionConfigurationGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(MissionConfigurationGroupCultureDto.fromJS(item));
            }
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(MissionConfigurationGroupMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMissionConfigurationGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMissionConfigurationGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateMissionConfigurationGroupDto {
    id?: string;
    cultures?: MissionConfigurationGroupCultureDto[];
    members?: MissionConfigurationGroupMemberDto[] | undefined;
}

export class MissionConfigurationGroupCultureDto implements IMissionConfigurationGroupCultureDto {
    cultureCode?: string;
    name?: string;
    isPrimary?: boolean;

    constructor(data?: IMissionConfigurationGroupCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): MissionConfigurationGroupCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationGroupCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IMissionConfigurationGroupCultureDto {
    cultureCode?: string;
    name?: string;
    isPrimary?: boolean;
}

export class MissionConfigurationGroupMemberDto implements IMissionConfigurationGroupMemberDto {
    id?: string;
    name?: string;

    constructor(data?: IMissionConfigurationGroupMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MissionConfigurationGroupMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationGroupMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMissionConfigurationGroupMemberDto {
    id?: string;
    name?: string;
}

export class DeleteMissionConfigurationGroupViewModel implements IDeleteMissionConfigurationGroupViewModel {
    success?: boolean;

    constructor(data?: IDeleteMissionConfigurationGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeleteMissionConfigurationGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMissionConfigurationGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeleteMissionConfigurationGroupViewModel {
    success?: boolean;
}

export class CreateMissionConfigurationGroupViewModel implements ICreateMissionConfigurationGroupViewModel {
    missionConfigurationGroupId?: string;

    constructor(data?: ICreateMissionConfigurationGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionConfigurationGroupId = _data["missionConfigurationGroupId"];
        }
    }

    static fromJS(data: any): CreateMissionConfigurationGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMissionConfigurationGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionConfigurationGroupId"] = this.missionConfigurationGroupId;
        return data;
    }
}

export interface ICreateMissionConfigurationGroupViewModel {
    missionConfigurationGroupId?: string;
}

export class CreateMissionConfigurationGroupDto implements ICreateMissionConfigurationGroupDto {
    name?: string;
    members?: CreateMissionConfigurationGroupMemberDto[] | undefined;

    constructor(data?: ICreateMissionConfigurationGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(CreateMissionConfigurationGroupMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMissionConfigurationGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMissionConfigurationGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateMissionConfigurationGroupDto {
    name?: string;
    members?: CreateMissionConfigurationGroupMemberDto[] | undefined;
}

export class CreateMissionConfigurationGroupMemberDto implements ICreateMissionConfigurationGroupMemberDto {
    id?: string;
    name?: string;

    constructor(data?: ICreateMissionConfigurationGroupMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateMissionConfigurationGroupMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMissionConfigurationGroupMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateMissionConfigurationGroupMemberDto {
    id?: string;
    name?: string;
}

export class UpdateMissionConfigurationGroupViewModel implements IUpdateMissionConfigurationGroupViewModel {
    success?: boolean;

    constructor(data?: IUpdateMissionConfigurationGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UpdateMissionConfigurationGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMissionConfigurationGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IUpdateMissionConfigurationGroupViewModel {
    success?: boolean;
}

export class GetMissionConfigurationListViewModel implements IGetMissionConfigurationListViewModel {
    missionConfigurations?: GetMissionConfigurationListDto[];

    constructor(data?: IGetMissionConfigurationListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missionConfigurations"])) {
                this.missionConfigurations = [] as any;
                for (let item of _data["missionConfigurations"])
                    this.missionConfigurations!.push(GetMissionConfigurationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionConfigurationListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionConfigurationListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missionConfigurations)) {
            data["missionConfigurations"] = [];
            for (let item of this.missionConfigurations)
                data["missionConfigurations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMissionConfigurationListViewModel {
    missionConfigurations?: GetMissionConfigurationListDto[];
}

export class GetMissionConfigurationListDto implements IGetMissionConfigurationListDto {
    id?: string;
    name?: string;
    versionId?: string;
    majorVersion?: number;
    state?: MissionConfigurationVersionState;
    locationType?: LocationSettingsType | undefined;

    constructor(data?: IGetMissionConfigurationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.versionId = _data["versionId"];
            this.majorVersion = _data["majorVersion"];
            this.state = _data["state"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): GetMissionConfigurationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionConfigurationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["versionId"] = this.versionId;
        data["majorVersion"] = this.majorVersion;
        data["state"] = this.state;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface IGetMissionConfigurationListDto {
    id?: string;
    name?: string;
    versionId?: string;
    majorVersion?: number;
    state?: MissionConfigurationVersionState;
    locationType?: LocationSettingsType | undefined;
}

export enum MissionConfigurationVersionState {
    Initializing = 0,
    Initialized = 1,
}

export enum LocationSettingsType {
    OnSite = 0,
    Phone = 1,
    Website = 2,
}

export class CreateMissionConfigurationViewModel implements ICreateMissionConfigurationViewModel {
    id?: string;

    constructor(data?: ICreateMissionConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateMissionConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMissionConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateMissionConfigurationViewModel {
    id?: string;
}

export class CreateMissionConfigurationDto implements ICreateMissionConfigurationDto {
    name?: string;

    constructor(data?: ICreateMissionConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateMissionConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMissionConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateMissionConfigurationDto {
    name?: string;
}

export class GetMissionConfigurationViewModel implements IGetMissionConfigurationViewModel {
    id?: string;
    versionId?: string;
    missionConfiguration?: GetMissionConfigurationDto;
    enabledSettings?: { [key: string]: boolean; };
    tags?: GetMissionConfigurationTagDto[];
    forms?: GetMissionConfigurationFormDto[];
    availableProfileMembers?: ProfileMemberDto[];
    availableVersions?: GetMissionConfigurationVersionDto[];
    missionConfigurationLinks?: { [key: string]: string; };

    constructor(data?: IGetMissionConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionId = _data["versionId"];
            this.missionConfiguration = _data["missionConfiguration"] ? GetMissionConfigurationDto.fromJS(_data["missionConfiguration"]) : <any>undefined;
            if (_data["enabledSettings"]) {
                this.enabledSettings = {} as any;
                for (let key in _data["enabledSettings"]) {
                    if (_data["enabledSettings"].hasOwnProperty(key))
                        (<any>this.enabledSettings)![key] = _data["enabledSettings"][key];
                }
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetMissionConfigurationTagDto.fromJS(item));
            }
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(GetMissionConfigurationFormDto.fromJS(item));
            }
            if (Array.isArray(_data["availableProfileMembers"])) {
                this.availableProfileMembers = [] as any;
                for (let item of _data["availableProfileMembers"])
                    this.availableProfileMembers!.push(ProfileMemberDto.fromJS(item));
            }
            if (Array.isArray(_data["availableVersions"])) {
                this.availableVersions = [] as any;
                for (let item of _data["availableVersions"])
                    this.availableVersions!.push(GetMissionConfigurationVersionDto.fromJS(item));
            }
            if (_data["missionConfigurationLinks"]) {
                this.missionConfigurationLinks = {} as any;
                for (let key in _data["missionConfigurationLinks"]) {
                    if (_data["missionConfigurationLinks"].hasOwnProperty(key))
                        (<any>this.missionConfigurationLinks)![key] = _data["missionConfigurationLinks"][key];
                }
            }
        }
    }

    static fromJS(data: any): GetMissionConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionId"] = this.versionId;
        data["missionConfiguration"] = this.missionConfiguration ? this.missionConfiguration.toJSON() : <any>undefined;
        if (this.enabledSettings) {
            data["enabledSettings"] = {};
            for (let key in this.enabledSettings) {
                if (this.enabledSettings.hasOwnProperty(key))
                    (<any>data["enabledSettings"])[key] = (<any>this.enabledSettings)[key];
            }
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        if (Array.isArray(this.availableProfileMembers)) {
            data["availableProfileMembers"] = [];
            for (let item of this.availableProfileMembers)
                data["availableProfileMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.availableVersions)) {
            data["availableVersions"] = [];
            for (let item of this.availableVersions)
                data["availableVersions"].push(item.toJSON());
        }
        if (this.missionConfigurationLinks) {
            data["missionConfigurationLinks"] = {};
            for (let key in this.missionConfigurationLinks) {
                if (this.missionConfigurationLinks.hasOwnProperty(key))
                    (<any>data["missionConfigurationLinks"])[key] = (<any>this.missionConfigurationLinks)[key];
            }
        }
        return data;
    }
}

export interface IGetMissionConfigurationViewModel {
    id?: string;
    versionId?: string;
    missionConfiguration?: GetMissionConfigurationDto;
    enabledSettings?: { [key: string]: boolean; };
    tags?: GetMissionConfigurationTagDto[];
    forms?: GetMissionConfigurationFormDto[];
    availableProfileMembers?: ProfileMemberDto[];
    availableVersions?: GetMissionConfigurationVersionDto[];
    missionConfigurationLinks?: { [key: string]: string; };
}

export class GetMissionConfigurationDto implements IGetMissionConfigurationDto {
    cultures?: MissionConfigurationCultureDto[];
    missionConfigurationVersionId?: string | undefined;
    state?: MissionConfigurationVersionState;
    estimatedCompletionTime?: string | undefined;
    storeLocatorLink?: string | undefined;
    tagIds?: string[];
    details?: MissionConfigurationDetailDto[];
    missionConfigurationSettings?: MissionConfigurationSettingsDto;

    constructor(data?: IGetMissionConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(MissionConfigurationCultureDto.fromJS(item));
            }
            this.missionConfigurationVersionId = _data["missionConfigurationVersionId"];
            this.state = _data["state"];
            this.estimatedCompletionTime = _data["estimatedCompletionTime"];
            this.storeLocatorLink = _data["storeLocatorLink"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(MissionConfigurationDetailDto.fromJS(item));
            }
            this.missionConfigurationSettings = _data["missionConfigurationSettings"] ? MissionConfigurationSettingsDto.fromJS(_data["missionConfigurationSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMissionConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        data["missionConfigurationVersionId"] = this.missionConfigurationVersionId;
        data["state"] = this.state;
        data["estimatedCompletionTime"] = this.estimatedCompletionTime;
        data["storeLocatorLink"] = this.storeLocatorLink;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["missionConfigurationSettings"] = this.missionConfigurationSettings ? this.missionConfigurationSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMissionConfigurationDto {
    cultures?: MissionConfigurationCultureDto[];
    missionConfigurationVersionId?: string | undefined;
    state?: MissionConfigurationVersionState;
    estimatedCompletionTime?: string | undefined;
    storeLocatorLink?: string | undefined;
    tagIds?: string[];
    details?: MissionConfigurationDetailDto[];
    missionConfigurationSettings?: MissionConfigurationSettingsDto;
}

export class MissionConfigurationCultureDto implements IMissionConfigurationCultureDto {
    name?: string;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: IMissionConfigurationCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): MissionConfigurationCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IMissionConfigurationCultureDto {
    name?: string;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class MissionConfigurationDetailDto implements IMissionConfigurationDetailDto {
    type?: MissionConfigurationDetailType;
    cultures?: MissionConfigurationDetailCultureDto[];

    constructor(data?: IMissionConfigurationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(MissionConfigurationDetailCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MissionConfigurationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMissionConfigurationDetailDto {
    type?: MissionConfigurationDetailType;
    cultures?: MissionConfigurationDetailCultureDto[];
}

export enum MissionConfigurationDetailType {
    Objective = 0,
    Eligibility = 1,
    TermsAndConditions = 2,
    ToNote = 3,
    Scenario = 4,
    NiceToKnow = 5,
}

export class MissionConfigurationDetailCultureDto implements IMissionConfigurationDetailCultureDto {
    text?: string;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: IMissionConfigurationDetailCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): MissionConfigurationDetailCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationDetailCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IMissionConfigurationDetailCultureDto {
    text?: string;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class MissionConfigurationSettingsDto implements IMissionConfigurationSettingsDto {
    formSettings?: FormSettingsDto | undefined;
    missionDisplayNameSettings?: MissionDisplayNameSettingsDto | undefined;
    missionExtensionSettings?: MissionExtensionSettingsDto | undefined;
    missionVisibilitySettings?: MissionVisibilitySettingsDto | undefined;
    mysteryShopperProfileSettings?: MysteryShopperProfileSettingsDto | undefined;
    purchaseSettings?: PurchaseSettingsDto | undefined;
    remunerationSettings?: RemunerationSettingsDto | undefined;
    rotationSettings?: RotationSettingsDto | undefined;
    timeTableSettings?: TimeTableSettingsDto | undefined;
    locationSettings?: LocationSettingsDto | undefined;
    languageRestrictionSettings?: LanguageRestrictionSettingsDto | undefined;

    constructor(data?: IMissionConfigurationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formSettings = _data["formSettings"] ? FormSettingsDto.fromJS(_data["formSettings"]) : <any>undefined;
            this.missionDisplayNameSettings = _data["missionDisplayNameSettings"] ? MissionDisplayNameSettingsDto.fromJS(_data["missionDisplayNameSettings"]) : <any>undefined;
            this.missionExtensionSettings = _data["missionExtensionSettings"] ? MissionExtensionSettingsDto.fromJS(_data["missionExtensionSettings"]) : <any>undefined;
            this.missionVisibilitySettings = _data["missionVisibilitySettings"] ? MissionVisibilitySettingsDto.fromJS(_data["missionVisibilitySettings"]) : <any>undefined;
            this.mysteryShopperProfileSettings = _data["mysteryShopperProfileSettings"] ? MysteryShopperProfileSettingsDto.fromJS(_data["mysteryShopperProfileSettings"]) : <any>undefined;
            this.purchaseSettings = _data["purchaseSettings"] ? PurchaseSettingsDto.fromJS(_data["purchaseSettings"]) : <any>undefined;
            this.remunerationSettings = _data["remunerationSettings"] ? RemunerationSettingsDto.fromJS(_data["remunerationSettings"]) : <any>undefined;
            this.rotationSettings = _data["rotationSettings"] ? RotationSettingsDto.fromJS(_data["rotationSettings"]) : <any>undefined;
            this.timeTableSettings = _data["timeTableSettings"] ? TimeTableSettingsDto.fromJS(_data["timeTableSettings"]) : <any>undefined;
            this.locationSettings = _data["locationSettings"] ? LocationSettingsDto.fromJS(_data["locationSettings"]) : <any>undefined;
            this.languageRestrictionSettings = _data["languageRestrictionSettings"] ? LanguageRestrictionSettingsDto.fromJS(_data["languageRestrictionSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MissionConfigurationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formSettings"] = this.formSettings ? this.formSettings.toJSON() : <any>undefined;
        data["missionDisplayNameSettings"] = this.missionDisplayNameSettings ? this.missionDisplayNameSettings.toJSON() : <any>undefined;
        data["missionExtensionSettings"] = this.missionExtensionSettings ? this.missionExtensionSettings.toJSON() : <any>undefined;
        data["missionVisibilitySettings"] = this.missionVisibilitySettings ? this.missionVisibilitySettings.toJSON() : <any>undefined;
        data["mysteryShopperProfileSettings"] = this.mysteryShopperProfileSettings ? this.mysteryShopperProfileSettings.toJSON() : <any>undefined;
        data["purchaseSettings"] = this.purchaseSettings ? this.purchaseSettings.toJSON() : <any>undefined;
        data["remunerationSettings"] = this.remunerationSettings ? this.remunerationSettings.toJSON() : <any>undefined;
        data["rotationSettings"] = this.rotationSettings ? this.rotationSettings.toJSON() : <any>undefined;
        data["timeTableSettings"] = this.timeTableSettings ? this.timeTableSettings.toJSON() : <any>undefined;
        data["locationSettings"] = this.locationSettings ? this.locationSettings.toJSON() : <any>undefined;
        data["languageRestrictionSettings"] = this.languageRestrictionSettings ? this.languageRestrictionSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMissionConfigurationSettingsDto {
    formSettings?: FormSettingsDto | undefined;
    missionDisplayNameSettings?: MissionDisplayNameSettingsDto | undefined;
    missionExtensionSettings?: MissionExtensionSettingsDto | undefined;
    missionVisibilitySettings?: MissionVisibilitySettingsDto | undefined;
    mysteryShopperProfileSettings?: MysteryShopperProfileSettingsDto | undefined;
    purchaseSettings?: PurchaseSettingsDto | undefined;
    remunerationSettings?: RemunerationSettingsDto | undefined;
    rotationSettings?: RotationSettingsDto | undefined;
    timeTableSettings?: TimeTableSettingsDto | undefined;
    locationSettings?: LocationSettingsDto | undefined;
    languageRestrictionSettings?: LanguageRestrictionSettingsDto | undefined;
}

export class FormSettingsDto implements IFormSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    formId?: string | undefined;

    constructor(data?: IFormSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.settingsKey = _data["settingsKey"];
            this.formId = _data["formId"];
        }
    }

    static fromJS(data: any): FormSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["settingsKey"] = this.settingsKey;
        data["formId"] = this.formId;
        return data;
    }
}

export interface IFormSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    formId?: string | undefined;
}

export class MissionDisplayNameSettingsDto implements IMissionDisplayNameSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    displayNameType?: MissionDisplayNameType;
    cultures?: MissionDisplayNameSettingsCultureDto[] | undefined;

    constructor(data?: IMissionDisplayNameSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.settingsKey = _data["settingsKey"];
            this.displayNameType = _data["displayNameType"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(MissionDisplayNameSettingsCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MissionDisplayNameSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionDisplayNameSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["settingsKey"] = this.settingsKey;
        data["displayNameType"] = this.displayNameType;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMissionDisplayNameSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    displayNameType?: MissionDisplayNameType;
    cultures?: MissionDisplayNameSettingsCultureDto[] | undefined;
}

export enum MissionDisplayNameType {
    SubscriptionName = 0,
    BranchName = 1,
    BranchGroupName = 2,
    Custom = 3,
}

export class MissionDisplayNameSettingsCultureDto implements IMissionDisplayNameSettingsCultureDto {
    displayNameCustom?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: IMissionDisplayNameSettingsCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayNameCustom = _data["displayNameCustom"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): MissionDisplayNameSettingsCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionDisplayNameSettingsCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayNameCustom"] = this.displayNameCustom;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IMissionDisplayNameSettingsCultureDto {
    displayNameCustom?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class MissionExtensionSettingsDto implements IMissionExtensionSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    initialDays?: number | undefined;
    maxExtendableDays?: number | undefined;
    canExtendBeyondPeriodEndDate?: boolean | undefined;

    constructor(data?: IMissionExtensionSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.settingsKey = _data["settingsKey"];
            this.initialDays = _data["initialDays"];
            this.maxExtendableDays = _data["maxExtendableDays"];
            this.canExtendBeyondPeriodEndDate = _data["canExtendBeyondPeriodEndDate"];
        }
    }

    static fromJS(data: any): MissionExtensionSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionExtensionSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["settingsKey"] = this.settingsKey;
        data["initialDays"] = this.initialDays;
        data["maxExtendableDays"] = this.maxExtendableDays;
        data["canExtendBeyondPeriodEndDate"] = this.canExtendBeyondPeriodEndDate;
        return data;
    }
}

export interface IMissionExtensionSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    initialDays?: number | undefined;
    maxExtendableDays?: number | undefined;
    canExtendBeyondPeriodEndDate?: boolean | undefined;
}

export class MissionVisibilitySettingsDto implements IMissionVisibilitySettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    missionVisibility?: MissionVisibilityType;
    alwaysShow?: boolean;
    missionOrder?: MissionOrderType | undefined;

    constructor(data?: IMissionVisibilitySettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.settingsKey = _data["settingsKey"];
            this.missionVisibility = _data["missionVisibility"];
            this.alwaysShow = _data["alwaysShow"];
            this.missionOrder = _data["missionOrder"];
        }
    }

    static fromJS(data: any): MissionVisibilitySettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionVisibilitySettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["settingsKey"] = this.settingsKey;
        data["missionVisibility"] = this.missionVisibility;
        data["alwaysShow"] = this.alwaysShow;
        data["missionOrder"] = this.missionOrder;
        return data;
    }
}

export interface IMissionVisibilitySettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    missionVisibility?: MissionVisibilityType;
    alwaysShow?: boolean;
    missionOrder?: MissionOrderType | undefined;
}

export enum MissionVisibilityType {
    Everyone = 0,
    Hidden = 1,
}

export enum MissionOrderType {
    Top = 0,
    Bottom = 1,
}

export class MysteryShopperProfileSettingsDto implements IMysteryShopperProfileSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    conditions?: ConditionsDto | undefined;

    constructor(data?: IMysteryShopperProfileSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.settingsKey = _data["settingsKey"];
            this.conditions = _data["conditions"] ? ConditionsDto.fromJS(_data["conditions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MysteryShopperProfileSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperProfileSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["settingsKey"] = this.settingsKey;
        data["conditions"] = this.conditions ? this.conditions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMysteryShopperProfileSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    conditions?: ConditionsDto | undefined;
}

export class ConditionsDto implements IConditionsDto {
    conditions?: ConditionDto[];

    constructor(data?: IConditionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(ConditionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConditionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConditionsDto {
    conditions?: ConditionDto[];
}

export class ConditionDto implements IConditionDto {
    previous?: LogicalComparisonType | undefined;
    rules?: RuleDto[];

    constructor(data?: IConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previous = _data["previous"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previous"] = this.previous;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConditionDto {
    previous?: LogicalComparisonType | undefined;
    rules?: RuleDto[];
}

export enum LogicalComparisonType {
    AndAlso = 0,
    OrElse = 1,
}

export class RuleDto implements IRuleDto {
    previous?: LogicalComparisonType | undefined;
    memberName?: string;
    operator?: EqualityComparisonType;
    value?: string;

    constructor(data?: IRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previous = _data["previous"];
            this.memberName = _data["memberName"];
            this.operator = _data["operator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previous"] = this.previous;
        data["memberName"] = this.memberName;
        data["operator"] = this.operator;
        data["value"] = this.value;
        return data;
    }
}

export interface IRuleDto {
    previous?: LogicalComparisonType | undefined;
    memberName?: string;
    operator?: EqualityComparisonType;
    value?: string;
}

export enum EqualityComparisonType {
    Contains = 0,
    NotContains = 1,
    Equal = 2,
    NotEqual = 3,
    GreaterThanOrEqual = 4,
    GreaterThan = 5,
    LessThan = 6,
    LessThanOrEqual = 7,
    Unknown = -1,
}

export class PurchaseSettingsDto implements IPurchaseSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    requiredPurchase?: boolean | undefined;
    cultures?: PurchaseSettingsCultureDto[] | undefined;

    constructor(data?: IPurchaseSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.settingsKey = _data["settingsKey"];
            this.requiredPurchase = _data["requiredPurchase"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(PurchaseSettingsCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["settingsKey"] = this.settingsKey;
        data["requiredPurchase"] = this.requiredPurchase;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPurchaseSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    requiredPurchase?: boolean | undefined;
    cultures?: PurchaseSettingsCultureDto[] | undefined;
}

export class PurchaseSettingsCultureDto implements IPurchaseSettingsCultureDto {
    requiredPurchaseText?: string | undefined;
    exclusionsText?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: IPurchaseSettingsCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requiredPurchaseText = _data["requiredPurchaseText"];
            this.exclusionsText = _data["exclusionsText"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): PurchaseSettingsCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseSettingsCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiredPurchaseText"] = this.requiredPurchaseText;
        data["exclusionsText"] = this.exclusionsText;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IPurchaseSettingsCultureDto {
    requiredPurchaseText?: string | undefined;
    exclusionsText?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class RemunerationSettingsDto implements IRemunerationSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    salary?: number | undefined;
    reimbursementUnitType?: RemunerationReimbursementUnitType | undefined;
    reimbursementValue?: number | undefined;
    maximumPurchaseAmount?: number | undefined;
    maximumAmount?: number | undefined;

    constructor(data?: IRemunerationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.settingsKey = _data["settingsKey"];
            this.salary = _data["salary"];
            this.reimbursementUnitType = _data["reimbursementUnitType"];
            this.reimbursementValue = _data["reimbursementValue"];
            this.maximumPurchaseAmount = _data["maximumPurchaseAmount"];
            this.maximumAmount = _data["maximumAmount"];
        }
    }

    static fromJS(data: any): RemunerationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemunerationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["settingsKey"] = this.settingsKey;
        data["salary"] = this.salary;
        data["reimbursementUnitType"] = this.reimbursementUnitType;
        data["reimbursementValue"] = this.reimbursementValue;
        data["maximumPurchaseAmount"] = this.maximumPurchaseAmount;
        data["maximumAmount"] = this.maximumAmount;
        return data;
    }
}

export interface IRemunerationSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    salary?: number | undefined;
    reimbursementUnitType?: RemunerationReimbursementUnitType | undefined;
    reimbursementValue?: number | undefined;
    maximumPurchaseAmount?: number | undefined;
    maximumAmount?: number | undefined;
}

export enum RemunerationReimbursementUnitType {
    Percentage = 0,
    Dollar = 1,
}

export class RotationSettingsDto implements IRotationSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    type?: RotationType;
    rotationDays?: number | undefined;
    rotationValue?: number | undefined;
    enablePerBranch?: boolean;
    valuePerBranch?: number | undefined;

    constructor(data?: IRotationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.settingsKey = _data["settingsKey"];
            this.type = _data["type"];
            this.rotationDays = _data["rotationDays"];
            this.rotationValue = _data["rotationValue"];
            this.enablePerBranch = _data["enablePerBranch"];
            this.valuePerBranch = _data["valuePerBranch"];
        }
    }

    static fromJS(data: any): RotationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RotationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["settingsKey"] = this.settingsKey;
        data["type"] = this.type;
        data["rotationDays"] = this.rotationDays;
        data["rotationValue"] = this.rotationValue;
        data["enablePerBranch"] = this.enablePerBranch;
        data["valuePerBranch"] = this.valuePerBranch;
        return data;
    }
}

export interface IRotationSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    type?: RotationType;
    rotationDays?: number | undefined;
    rotationValue?: number | undefined;
    enablePerBranch?: boolean;
    valuePerBranch?: number | undefined;
}

export enum RotationType {
    Unlimited = 0,
    PeriodMissionConfiguration = 1,
    Period = 2,
    MissionConfiguration = 3,
    Project = 4,
    Subscription = 5,
    Days = 6,
}

export class TimeTableSettingsDto implements ITimeTableSettingsDto {
    enabled?: boolean;
    specific?: boolean;
    settingsKey?: string;
    availableDays?: DayOfWeek[];
    hourType?: TimeTableHourType;
    periodType?: TimeTablePeriodType | undefined;
    customStartTime?: string | undefined;
    customEndTime?: string | undefined;
    specificSettings?: TimeTableSpecificSettingsDto[];

    constructor(data?: ITimeTableSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.specific = _data["specific"];
            this.settingsKey = _data["settingsKey"];
            if (Array.isArray(_data["availableDays"])) {
                this.availableDays = [] as any;
                for (let item of _data["availableDays"])
                    this.availableDays!.push(item);
            }
            this.hourType = _data["hourType"];
            this.periodType = _data["periodType"];
            this.customStartTime = _data["customStartTime"];
            this.customEndTime = _data["customEndTime"];
            if (Array.isArray(_data["specificSettings"])) {
                this.specificSettings = [] as any;
                for (let item of _data["specificSettings"])
                    this.specificSettings!.push(TimeTableSpecificSettingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeTableSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeTableSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["specific"] = this.specific;
        data["settingsKey"] = this.settingsKey;
        if (Array.isArray(this.availableDays)) {
            data["availableDays"] = [];
            for (let item of this.availableDays)
                data["availableDays"].push(item);
        }
        data["hourType"] = this.hourType;
        data["periodType"] = this.periodType;
        data["customStartTime"] = this.customStartTime;
        data["customEndTime"] = this.customEndTime;
        if (Array.isArray(this.specificSettings)) {
            data["specificSettings"] = [];
            for (let item of this.specificSettings)
                data["specificSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeTableSettingsDto {
    enabled?: boolean;
    specific?: boolean;
    settingsKey?: string;
    availableDays?: DayOfWeek[];
    hourType?: TimeTableHourType;
    periodType?: TimeTablePeriodType | undefined;
    customStartTime?: string | undefined;
    customEndTime?: string | undefined;
    specificSettings?: TimeTableSpecificSettingsDto[];
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export enum TimeTableHourType {
    Regular = 0,
    Period = 1,
    Custom = 2,
}

export enum TimeTablePeriodType {
    Morning = 0,
    Noon = 1,
    Evening = 2,
}

export class TimeTableSpecificSettingsDto implements ITimeTableSpecificSettingsDto {
    exists?: boolean;
    day?: DayOfWeek;
    hourType?: TimeTableHourType;
    periodType?: TimeTablePeriodType | undefined;
    customStartTime?: string | undefined;
    customEndTime?: string | undefined;

    constructor(data?: ITimeTableSpecificSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
            this.day = _data["day"];
            this.hourType = _data["hourType"];
            this.periodType = _data["periodType"];
            this.customStartTime = _data["customStartTime"];
            this.customEndTime = _data["customEndTime"];
        }
    }

    static fromJS(data: any): TimeTableSpecificSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeTableSpecificSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        data["day"] = this.day;
        data["hourType"] = this.hourType;
        data["periodType"] = this.periodType;
        data["customStartTime"] = this.customStartTime;
        data["customEndTime"] = this.customEndTime;
        return data;
    }
}

export interface ITimeTableSpecificSettingsDto {
    exists?: boolean;
    day?: DayOfWeek;
    hourType?: TimeTableHourType;
    periodType?: TimeTablePeriodType | undefined;
    customStartTime?: string | undefined;
    customEndTime?: string | undefined;
}

export class LocationSettingsDto implements ILocationSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    type?: LocationSettingsType;
    phoneType?: LocationSettingsPhoneType | undefined;
    phoneNumber?: string | undefined;
    websiteType?: LocationSettingsWebsiteType | undefined;
    website?: string | undefined;

    constructor(data?: ILocationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.settingsKey = _data["settingsKey"];
            this.type = _data["type"];
            this.phoneType = _data["phoneType"];
            this.phoneNumber = _data["phoneNumber"];
            this.websiteType = _data["websiteType"];
            this.website = _data["website"];
        }
    }

    static fromJS(data: any): LocationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["settingsKey"] = this.settingsKey;
        data["type"] = this.type;
        data["phoneType"] = this.phoneType;
        data["phoneNumber"] = this.phoneNumber;
        data["websiteType"] = this.websiteType;
        data["website"] = this.website;
        return data;
    }
}

export interface ILocationSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    type?: LocationSettingsType;
    phoneType?: LocationSettingsPhoneType | undefined;
    phoneNumber?: string | undefined;
    websiteType?: LocationSettingsWebsiteType | undefined;
    website?: string | undefined;
}

export enum LocationSettingsPhoneType {
    Global = 0,
    Branch = 1,
}

export enum LocationSettingsWebsiteType {
    Global = 0,
    Branch = 1,
}

export class LanguageRestrictionSettingsDto implements ILanguageRestrictionSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    supportedCultureCodes?: string[];

    constructor(data?: ILanguageRestrictionSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.settingsKey = _data["settingsKey"];
            if (Array.isArray(_data["supportedCultureCodes"])) {
                this.supportedCultureCodes = [] as any;
                for (let item of _data["supportedCultureCodes"])
                    this.supportedCultureCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): LanguageRestrictionSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageRestrictionSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["settingsKey"] = this.settingsKey;
        if (Array.isArray(this.supportedCultureCodes)) {
            data["supportedCultureCodes"] = [];
            for (let item of this.supportedCultureCodes)
                data["supportedCultureCodes"].push(item);
        }
        return data;
    }
}

export interface ILanguageRestrictionSettingsDto {
    enabled?: boolean;
    settingsKey?: string;
    supportedCultureCodes?: string[];
}

export class GetMissionConfigurationTagDto implements IGetMissionConfigurationTagDto {
    id?: string;
    text?: string;

    constructor(data?: IGetMissionConfigurationTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): GetMissionConfigurationTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionConfigurationTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IGetMissionConfigurationTagDto {
    id?: string;
    text?: string;
}

export class GetMissionConfigurationFormDto implements IGetMissionConfigurationFormDto {
    id?: string;
    name?: string;

    constructor(data?: IGetMissionConfigurationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetMissionConfigurationFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionConfigurationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetMissionConfigurationFormDto {
    id?: string;
    name?: string;
}

export class ProfileMemberDto implements IProfileMemberDto {
    key?: string;
    label?: string;
    question?: string;
    enabled?: boolean;
    minValue?: string | undefined;
    maxValue?: string | undefined;
    valueType?: MysteryShopperProfileMemberType;
    comparisons?: EqualityComparisonType[];
    choices?: ProfileMemberChoiceDto[] | undefined;

    constructor(data?: IProfileMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.question = _data["question"];
            this.enabled = _data["enabled"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.valueType = _data["valueType"];
            if (Array.isArray(_data["comparisons"])) {
                this.comparisons = [] as any;
                for (let item of _data["comparisons"])
                    this.comparisons!.push(item);
            }
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(ProfileMemberChoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["question"] = this.question;
        data["enabled"] = this.enabled;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["valueType"] = this.valueType;
        if (Array.isArray(this.comparisons)) {
            data["comparisons"] = [];
            for (let item of this.comparisons)
                data["comparisons"].push(item);
        }
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProfileMemberDto {
    key?: string;
    label?: string;
    question?: string;
    enabled?: boolean;
    minValue?: string | undefined;
    maxValue?: string | undefined;
    valueType?: MysteryShopperProfileMemberType;
    comparisons?: EqualityComparisonType[];
    choices?: ProfileMemberChoiceDto[] | undefined;
}

export enum MysteryShopperProfileMemberType {
    SingleChoice = 0,
    MultipleChoices = 1,
    Int32 = 2,
    String = 3,
    Date = 4,
}

export class ProfileMemberChoiceDto implements IProfileMemberChoiceDto {
    key?: number;
    label?: string;
    enabled?: boolean;

    constructor(data?: IProfileMemberChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): ProfileMemberChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileMemberChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IProfileMemberChoiceDto {
    key?: number;
    label?: string;
    enabled?: boolean;
}

export class GetMissionConfigurationVersionDto implements IGetMissionConfigurationVersionDto {
    versionId?: string;
    majorVersion?: number;
    current?: boolean;

    constructor(data?: IGetMissionConfigurationVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionId = _data["versionId"];
            this.majorVersion = _data["majorVersion"];
            this.current = _data["current"];
        }
    }

    static fromJS(data: any): GetMissionConfigurationVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionConfigurationVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionId"] = this.versionId;
        data["majorVersion"] = this.majorVersion;
        data["current"] = this.current;
        return data;
    }
}

export interface IGetMissionConfigurationVersionDto {
    versionId?: string;
    majorVersion?: number;
    current?: boolean;
}

export class UpdateMissionConfigurationViewModel implements IUpdateMissionConfigurationViewModel {
    state?: MissionConfigurationVersionState;
    missingRequiredSettings?: string[] | undefined;
    validationResult?: { [key: string]: string[]; } | undefined;

    constructor(data?: IUpdateMissionConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            if (Array.isArray(_data["missingRequiredSettings"])) {
                this.missingRequiredSettings = [] as any;
                for (let item of _data["missingRequiredSettings"])
                    this.missingRequiredSettings!.push(item);
            }
            if (_data["validationResult"]) {
                this.validationResult = {} as any;
                for (let key in _data["validationResult"]) {
                    if (_data["validationResult"].hasOwnProperty(key))
                        (<any>this.validationResult)![key] = _data["validationResult"][key] !== undefined ? _data["validationResult"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): UpdateMissionConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMissionConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        if (Array.isArray(this.missingRequiredSettings)) {
            data["missingRequiredSettings"] = [];
            for (let item of this.missingRequiredSettings)
                data["missingRequiredSettings"].push(item);
        }
        if (this.validationResult) {
            data["validationResult"] = {};
            for (let key in this.validationResult) {
                if (this.validationResult.hasOwnProperty(key))
                    (<any>data["validationResult"])[key] = (<any>this.validationResult)[key];
            }
        }
        return data;
    }
}

export interface IUpdateMissionConfigurationViewModel {
    state?: MissionConfigurationVersionState;
    missingRequiredSettings?: string[] | undefined;
    validationResult?: { [key: string]: string[]; } | undefined;
}

export class UpdateMissionConfigurationRequest implements IUpdateMissionConfigurationRequest {
    generalInformation?: UpdateGeneralMissionConfigurationDto | undefined;
    cultures?: MissionConfigurationCultureDto[] | undefined;
    details?: MissionConfigurationDetailDto[] | undefined;
    missionConfigurationSettings?: MissionConfigurationSettingsDto | undefined;
    enabledSettings?: { [key: string]: boolean; } | undefined;

    constructor(data?: IUpdateMissionConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalInformation = _data["generalInformation"] ? UpdateGeneralMissionConfigurationDto.fromJS(_data["generalInformation"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(MissionConfigurationCultureDto.fromJS(item));
            }
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(MissionConfigurationDetailDto.fromJS(item));
            }
            this.missionConfigurationSettings = _data["missionConfigurationSettings"] ? MissionConfigurationSettingsDto.fromJS(_data["missionConfigurationSettings"]) : <any>undefined;
            if (_data["enabledSettings"]) {
                this.enabledSettings = {} as any;
                for (let key in _data["enabledSettings"]) {
                    if (_data["enabledSettings"].hasOwnProperty(key))
                        (<any>this.enabledSettings)![key] = _data["enabledSettings"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdateMissionConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMissionConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalInformation"] = this.generalInformation ? this.generalInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["missionConfigurationSettings"] = this.missionConfigurationSettings ? this.missionConfigurationSettings.toJSON() : <any>undefined;
        if (this.enabledSettings) {
            data["enabledSettings"] = {};
            for (let key in this.enabledSettings) {
                if (this.enabledSettings.hasOwnProperty(key))
                    (<any>data["enabledSettings"])[key] = (<any>this.enabledSettings)[key];
            }
        }
        return data;
    }
}

export interface IUpdateMissionConfigurationRequest {
    generalInformation?: UpdateGeneralMissionConfigurationDto | undefined;
    cultures?: MissionConfigurationCultureDto[] | undefined;
    details?: MissionConfigurationDetailDto[] | undefined;
    missionConfigurationSettings?: MissionConfigurationSettingsDto | undefined;
    enabledSettings?: { [key: string]: boolean; } | undefined;
}

export class UpdateGeneralMissionConfigurationDto implements IUpdateGeneralMissionConfigurationDto {
    tagIds?: string[] | undefined;
    estimatedCompletionTime?: string | undefined;
    storeLocatorLink?: string | undefined;
    missionConfigurationVersionId?: string | undefined;

    constructor(data?: IUpdateGeneralMissionConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.estimatedCompletionTime = _data["estimatedCompletionTime"];
            this.storeLocatorLink = _data["storeLocatorLink"];
            this.missionConfigurationVersionId = _data["missionConfigurationVersionId"];
        }
    }

    static fromJS(data: any): UpdateGeneralMissionConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeneralMissionConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["estimatedCompletionTime"] = this.estimatedCompletionTime;
        data["storeLocatorLink"] = this.storeLocatorLink;
        data["missionConfigurationVersionId"] = this.missionConfigurationVersionId;
        return data;
    }
}

export interface IUpdateGeneralMissionConfigurationDto {
    tagIds?: string[] | undefined;
    estimatedCompletionTime?: string | undefined;
    storeLocatorLink?: string | undefined;
    missionConfigurationVersionId?: string | undefined;
}

export class CloneMissionConfigurationViewModel implements ICloneMissionConfigurationViewModel {
    versionId?: string;
    majorVersion?: number;

    constructor(data?: ICloneMissionConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionId = _data["versionId"];
            this.majorVersion = _data["majorVersion"];
        }
    }

    static fromJS(data: any): CloneMissionConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneMissionConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionId"] = this.versionId;
        data["majorVersion"] = this.majorVersion;
        return data;
    }
}

export interface ICloneMissionConfigurationViewModel {
    versionId?: string;
    majorVersion?: number;
}

export class GetMissionListViewModel implements IGetMissionListViewModel {
    missions?: PaginatedResponseOfGetMissionListMissionDto;

    constructor(data?: IGetMissionListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missions = _data["missions"] ? PaginatedResponseOfGetMissionListMissionDto.fromJS(_data["missions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMissionListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missions"] = this.missions ? this.missions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMissionListViewModel {
    missions?: PaginatedResponseOfGetMissionListMissionDto;
}

export class PaginatedResponseOfGetMissionListMissionDto implements IPaginatedResponseOfGetMissionListMissionDto {
    items?: GetMissionListMissionDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfGetMissionListMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMissionListMissionDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetMissionListMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetMissionListMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfGetMissionListMissionDto {
    items?: GetMissionListMissionDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class GetMissionListMissionDto implements IGetMissionListMissionDto {
    missionAssignationId?: string | undefined;
    missionAssignationCreatedDate?: Date | undefined;
    missionAssignationLastModifiedDate?: Date | undefined;
    missionAssignationEndDate?: Date | undefined;
    missionAssignationStatus?: MissionAssignationStatus;
    mysteryShopperId?: string | undefined;
    mysteryShopperFirstName?: string | undefined;
    mysteryShopperLastName?: string | undefined;
    mysteryShopperEmail?: string | undefined;
    mysteryShopperPhoneNumber?: string | undefined;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionName?: string | undefined;
    subscriptionServiceId?: string | undefined;
    subscriptionServiceName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodMissionConfigurationId?: string | undefined;
    missionConfigurationName?: string | undefined;
    periodId?: string | undefined;
    periodName?: string | undefined;
    branchId?: string;
    branchCode?: string;
    branchName?: string;
    numberOfMissionsLast30Days?: number | undefined;
    numberOfApprovedMissionsLast30Days?: number | undefined;
    canBeAssigned?: boolean;
    canBeCancelled?: boolean;
    canBypassValidation?: boolean;
    canBeDeactivated?: boolean;
    canBeExtended?: boolean;
    canBeMoved?: boolean;
    canBeEdited?: boolean;

    constructor(data?: IGetMissionListMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionAssignationId = _data["missionAssignationId"];
            this.missionAssignationCreatedDate = _data["missionAssignationCreatedDate"] ? new Date(_data["missionAssignationCreatedDate"].toString()) : <any>undefined;
            this.missionAssignationLastModifiedDate = _data["missionAssignationLastModifiedDate"] ? new Date(_data["missionAssignationLastModifiedDate"].toString()) : <any>undefined;
            this.missionAssignationEndDate = _data["missionAssignationEndDate"] ? new Date(_data["missionAssignationEndDate"].toString()) : <any>undefined;
            this.missionAssignationStatus = _data["missionAssignationStatus"];
            this.mysteryShopperId = _data["mysteryShopperId"];
            this.mysteryShopperFirstName = _data["mysteryShopperFirstName"];
            this.mysteryShopperLastName = _data["mysteryShopperLastName"];
            this.mysteryShopperEmail = _data["mysteryShopperEmail"];
            this.mysteryShopperPhoneNumber = _data["mysteryShopperPhoneNumber"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionName = _data["subscriptionName"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.subscriptionServiceName = _data["subscriptionServiceName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.periodId = _data["periodId"];
            this.periodName = _data["periodName"];
            this.branchId = _data["branchId"];
            this.branchCode = _data["branchCode"];
            this.branchName = _data["branchName"];
            this.numberOfMissionsLast30Days = _data["numberOfMissionsLast30Days"];
            this.numberOfApprovedMissionsLast30Days = _data["numberOfApprovedMissionsLast30Days"];
            this.canBeAssigned = _data["canBeAssigned"];
            this.canBeCancelled = _data["canBeCancelled"];
            this.canBypassValidation = _data["canBypassValidation"];
            this.canBeDeactivated = _data["canBeDeactivated"];
            this.canBeExtended = _data["canBeExtended"];
            this.canBeMoved = _data["canBeMoved"];
            this.canBeEdited = _data["canBeEdited"];
        }
    }

    static fromJS(data: any): GetMissionListMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionListMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationId"] = this.missionAssignationId;
        data["missionAssignationCreatedDate"] = this.missionAssignationCreatedDate ? this.missionAssignationCreatedDate.toISOString() : <any>undefined;
        data["missionAssignationLastModifiedDate"] = this.missionAssignationLastModifiedDate ? this.missionAssignationLastModifiedDate.toISOString() : <any>undefined;
        data["missionAssignationEndDate"] = this.missionAssignationEndDate ? this.missionAssignationEndDate.toISOString() : <any>undefined;
        data["missionAssignationStatus"] = this.missionAssignationStatus;
        data["mysteryShopperId"] = this.mysteryShopperId;
        data["mysteryShopperFirstName"] = this.mysteryShopperFirstName;
        data["mysteryShopperLastName"] = this.mysteryShopperLastName;
        data["mysteryShopperEmail"] = this.mysteryShopperEmail;
        data["mysteryShopperPhoneNumber"] = this.mysteryShopperPhoneNumber;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionName"] = this.subscriptionName;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["subscriptionServiceName"] = this.subscriptionServiceName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["periodId"] = this.periodId;
        data["periodName"] = this.periodName;
        data["branchId"] = this.branchId;
        data["branchCode"] = this.branchCode;
        data["branchName"] = this.branchName;
        data["numberOfMissionsLast30Days"] = this.numberOfMissionsLast30Days;
        data["numberOfApprovedMissionsLast30Days"] = this.numberOfApprovedMissionsLast30Days;
        data["canBeAssigned"] = this.canBeAssigned;
        data["canBeCancelled"] = this.canBeCancelled;
        data["canBypassValidation"] = this.canBypassValidation;
        data["canBeDeactivated"] = this.canBeDeactivated;
        data["canBeExtended"] = this.canBeExtended;
        data["canBeMoved"] = this.canBeMoved;
        data["canBeEdited"] = this.canBeEdited;
        return data;
    }
}

export interface IGetMissionListMissionDto {
    missionAssignationId?: string | undefined;
    missionAssignationCreatedDate?: Date | undefined;
    missionAssignationLastModifiedDate?: Date | undefined;
    missionAssignationEndDate?: Date | undefined;
    missionAssignationStatus?: MissionAssignationStatus;
    mysteryShopperId?: string | undefined;
    mysteryShopperFirstName?: string | undefined;
    mysteryShopperLastName?: string | undefined;
    mysteryShopperEmail?: string | undefined;
    mysteryShopperPhoneNumber?: string | undefined;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionName?: string | undefined;
    subscriptionServiceId?: string | undefined;
    subscriptionServiceName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodMissionConfigurationId?: string | undefined;
    missionConfigurationName?: string | undefined;
    periodId?: string | undefined;
    periodName?: string | undefined;
    branchId?: string;
    branchCode?: string;
    branchName?: string;
    numberOfMissionsLast30Days?: number | undefined;
    numberOfApprovedMissionsLast30Days?: number | undefined;
    canBeAssigned?: boolean;
    canBeCancelled?: boolean;
    canBypassValidation?: boolean;
    canBeDeactivated?: boolean;
    canBeExtended?: boolean;
    canBeMoved?: boolean;
    canBeEdited?: boolean;
}

export class GetMissionListFilter implements IGetMissionListFilter {
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodId?: string | undefined;
    periodMissionConfigurationId?: string | undefined;
    branchIds?: string[] | undefined;
    branchSearch?: string | undefined;
    missionAssignationIdSearch?: string | undefined;
    missionAnswerIdSearch?: string | undefined;
    mysteryShopperSearch?: string | undefined;
    approvedBy?: string | undefined;
    mysteryShopperId?: string | undefined;
    missionAssignationStatuses?: MissionAssignationStatus[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: GetMissionListFilterSorting | undefined;

    constructor(data?: IGetMissionListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.periodId = _data["periodId"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            this.branchSearch = _data["branchSearch"];
            this.missionAssignationIdSearch = _data["missionAssignationIdSearch"];
            this.missionAnswerIdSearch = _data["missionAnswerIdSearch"];
            this.mysteryShopperSearch = _data["mysteryShopperSearch"];
            this.approvedBy = _data["approvedBy"];
            this.mysteryShopperId = _data["mysteryShopperId"];
            if (Array.isArray(_data["missionAssignationStatuses"])) {
                this.missionAssignationStatuses = [] as any;
                for (let item of _data["missionAssignationStatuses"])
                    this.missionAssignationStatuses!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): GetMissionListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["periodId"] = this.periodId;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        data["branchSearch"] = this.branchSearch;
        data["missionAssignationIdSearch"] = this.missionAssignationIdSearch;
        data["missionAnswerIdSearch"] = this.missionAnswerIdSearch;
        data["mysteryShopperSearch"] = this.mysteryShopperSearch;
        data["approvedBy"] = this.approvedBy;
        data["mysteryShopperId"] = this.mysteryShopperId;
        if (Array.isArray(this.missionAssignationStatuses)) {
            data["missionAssignationStatuses"] = [];
            for (let item of this.missionAssignationStatuses)
                data["missionAssignationStatuses"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IGetMissionListFilter {
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodId?: string | undefined;
    periodMissionConfigurationId?: string | undefined;
    branchIds?: string[] | undefined;
    branchSearch?: string | undefined;
    missionAssignationIdSearch?: string | undefined;
    missionAnswerIdSearch?: string | undefined;
    mysteryShopperSearch?: string | undefined;
    approvedBy?: string | undefined;
    mysteryShopperId?: string | undefined;
    missionAssignationStatuses?: MissionAssignationStatus[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    sorting?: GetMissionListFilterSorting | undefined;
}

export enum GetMissionListFilterSorting {
    Email = 1,
}

export class GetMissionListSummaryViewModel implements IGetMissionListSummaryViewModel {
    missionAssignationCount?: number;
    naturalAssignmentCount?: number;
    bookingAssignmentCount?: number;
    resentForCorrectionCount?: number;
    availableCount?: number;
    missionsToComplete?: number;
    missionsTaken?: number;
    progression?: GetMissionListSummaryProgressionDto;
    statuses?: GetMissionListSummaryMissionAssignationStatusDto[];

    constructor(data?: IGetMissionListSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionAssignationCount = _data["missionAssignationCount"];
            this.naturalAssignmentCount = _data["naturalAssignmentCount"];
            this.bookingAssignmentCount = _data["bookingAssignmentCount"];
            this.resentForCorrectionCount = _data["resentForCorrectionCount"];
            this.availableCount = _data["availableCount"];
            this.missionsToComplete = _data["missionsToComplete"];
            this.missionsTaken = _data["missionsTaken"];
            this.progression = _data["progression"] ? GetMissionListSummaryProgressionDto.fromJS(_data["progression"]) : <any>undefined;
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(GetMissionListSummaryMissionAssignationStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionListSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionListSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationCount"] = this.missionAssignationCount;
        data["naturalAssignmentCount"] = this.naturalAssignmentCount;
        data["bookingAssignmentCount"] = this.bookingAssignmentCount;
        data["resentForCorrectionCount"] = this.resentForCorrectionCount;
        data["availableCount"] = this.availableCount;
        data["missionsToComplete"] = this.missionsToComplete;
        data["missionsTaken"] = this.missionsTaken;
        data["progression"] = this.progression ? this.progression.toJSON() : <any>undefined;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMissionListSummaryViewModel {
    missionAssignationCount?: number;
    naturalAssignmentCount?: number;
    bookingAssignmentCount?: number;
    resentForCorrectionCount?: number;
    availableCount?: number;
    missionsToComplete?: number;
    missionsTaken?: number;
    progression?: GetMissionListSummaryProgressionDto;
    statuses?: GetMissionListSummaryMissionAssignationStatusDto[];
}

export class GetMissionListSummaryProgressionDto implements IGetMissionListSummaryProgressionDto {
    total?: number;
    available?: number;
    assigned?: number;
    validating?: number;
    validationRejected?: number;
    approved?: number;

    constructor(data?: IGetMissionListSummaryProgressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.available = _data["available"];
            this.assigned = _data["assigned"];
            this.validating = _data["validating"];
            this.validationRejected = _data["validationRejected"];
            this.approved = _data["approved"];
        }
    }

    static fromJS(data: any): GetMissionListSummaryProgressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionListSummaryProgressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["available"] = this.available;
        data["assigned"] = this.assigned;
        data["validating"] = this.validating;
        data["validationRejected"] = this.validationRejected;
        data["approved"] = this.approved;
        return data;
    }
}

export interface IGetMissionListSummaryProgressionDto {
    total?: number;
    available?: number;
    assigned?: number;
    validating?: number;
    validationRejected?: number;
    approved?: number;
}

export class GetMissionListSummaryMissionAssignationStatusDto implements IGetMissionListSummaryMissionAssignationStatusDto {
    status?: MissionAssignationStatus;
    count?: number;

    constructor(data?: IGetMissionListSummaryMissionAssignationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetMissionListSummaryMissionAssignationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionListSummaryMissionAssignationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["count"] = this.count;
        return data;
    }
}

export interface IGetMissionListSummaryMissionAssignationStatusDto {
    status?: MissionAssignationStatus;
    count?: number;
}

export class GetMissionListFiltersViewModel implements IGetMissionListFiltersViewModel {
    organizations?: OrganizationFilter[];
    subscriptions?: SubscriptionFilter[];
    subscriptionServices?: SubscriptionServiceFilter[];
    projects?: ProjectFilter[];
    missionConfigurations?: MissionConfigurationFilter[];
    periods?: PeriodFilter[];
    employees?: string[];

    constructor(data?: IGetMissionListFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationFilter.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(SubscriptionFilter.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(SubscriptionServiceFilter.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectFilter.fromJS(item));
            }
            if (Array.isArray(_data["missionConfigurations"])) {
                this.missionConfigurations = [] as any;
                for (let item of _data["missionConfigurations"])
                    this.missionConfigurations!.push(MissionConfigurationFilter.fromJS(item));
            }
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(PeriodFilter.fromJS(item));
            }
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMissionListFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionListFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.missionConfigurations)) {
            data["missionConfigurations"] = [];
            for (let item of this.missionConfigurations)
                data["missionConfigurations"].push(item.toJSON());
        }
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item);
        }
        return data;
    }
}

export interface IGetMissionListFiltersViewModel {
    organizations?: OrganizationFilter[];
    subscriptions?: SubscriptionFilter[];
    subscriptionServices?: SubscriptionServiceFilter[];
    projects?: ProjectFilter[];
    missionConfigurations?: MissionConfigurationFilter[];
    periods?: PeriodFilter[];
    employees?: string[];
}

export class GetMissionListMapViewModel implements IGetMissionListMapViewModel {
    branches?: GetMissionListMapBranchDto[];

    constructor(data?: IGetMissionListMapViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetMissionListMapBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionListMapViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionListMapViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMissionListMapViewModel {
    branches?: GetMissionListMapBranchDto[];
}

export class GetMissionListMapBranchDto implements IGetMissionListMapBranchDto {
    branchId?: string;
    name?: string;
    address?: string;
    geocoordinate?: GeoLocation;
    missionsToComplete?: number;
    missionsTaken?: number;
    availableCount?: number;

    constructor(data?: IGetMissionListMapBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.geocoordinate = _data["geocoordinate"] ? GeoLocation.fromJS(_data["geocoordinate"]) : <any>undefined;
            this.missionsToComplete = _data["missionsToComplete"];
            this.missionsTaken = _data["missionsTaken"];
            this.availableCount = _data["availableCount"];
        }
    }

    static fromJS(data: any): GetMissionListMapBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionListMapBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : <any>undefined;
        data["missionsToComplete"] = this.missionsToComplete;
        data["missionsTaken"] = this.missionsTaken;
        data["availableCount"] = this.availableCount;
        return data;
    }
}

export interface IGetMissionListMapBranchDto {
    branchId?: string;
    name?: string;
    address?: string;
    geocoordinate?: GeoLocation;
    missionsToComplete?: number;
    missionsTaken?: number;
    availableCount?: number;
}

export class GetMysteryShopperListViewModel implements IGetMysteryShopperListViewModel {
    mysteryShoppers?: PaginatedResponseOfGetMysteryShopperListDto;

    constructor(data?: IGetMysteryShopperListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mysteryShoppers = _data["mysteryShoppers"] ? PaginatedResponseOfGetMysteryShopperListDto.fromJS(_data["mysteryShoppers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMysteryShopperListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mysteryShoppers"] = this.mysteryShoppers ? this.mysteryShoppers.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMysteryShopperListViewModel {
    mysteryShoppers?: PaginatedResponseOfGetMysteryShopperListDto;
}

export class PaginatedResponseOfGetMysteryShopperListDto implements IPaginatedResponseOfGetMysteryShopperListDto {
    items?: GetMysteryShopperListDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfGetMysteryShopperListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMysteryShopperListDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetMysteryShopperListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetMysteryShopperListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfGetMysteryShopperListDto {
    items?: GetMysteryShopperListDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class GetMysteryShopperListDto implements IGetMysteryShopperListDto {
    id?: string;
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    balance?: number | undefined;
    lastActiveDate?: Date;
    numberOfApprovedMissions?: number;
    signUpSource?: string | undefined;
    riskType?: MysteryShopperRiskType;
    address?: string;

    constructor(data?: IGetMysteryShopperListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.balance = _data["balance"];
            this.lastActiveDate = _data["lastActiveDate"] ? new Date(_data["lastActiveDate"].toString()) : <any>undefined;
            this.numberOfApprovedMissions = _data["numberOfApprovedMissions"];
            this.signUpSource = _data["signUpSource"];
            this.riskType = _data["riskType"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): GetMysteryShopperListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["balance"] = this.balance;
        data["lastActiveDate"] = this.lastActiveDate ? this.lastActiveDate.toISOString() : <any>undefined;
        data["numberOfApprovedMissions"] = this.numberOfApprovedMissions;
        data["signUpSource"] = this.signUpSource;
        data["riskType"] = this.riskType;
        data["address"] = this.address;
        return data;
    }
}

export interface IGetMysteryShopperListDto {
    id?: string;
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    balance?: number | undefined;
    lastActiveDate?: Date;
    numberOfApprovedMissions?: number;
    signUpSource?: string | undefined;
    riskType?: MysteryShopperRiskType;
    address?: string;
}

export enum MysteryShopperRiskType {
    Unknown = 0,
    Low = 1,
    Medium = 2,
    High = 3,
}

export class MysteryShopperFilters implements IMysteryShopperFilters {
    conditions?: ConditionsDto | undefined;
    search?: string | undefined;
    cityPostalCodeSearch?: string | undefined;
    signUpSourceSearch?: string | undefined;
    radiusInKilometer?: number | undefined;
    minBalance?: number | undefined;
    maxBalance?: number | undefined;
    order?: SortOrder | undefined;
    orderField?: GetMysteryShopperListOrderField | undefined;
    isUnsubscribedFromMarketingEmail?: boolean | undefined;
    unsubscribedFromMarketingEmailStartDate?: Date | undefined;
    unsubscribedFromMarketingEmailEndDate?: Date | undefined;
    includeSignUpSource?: boolean | undefined;
    onlySus?: boolean | undefined;

    constructor(data?: IMysteryShopperFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditions = _data["conditions"] ? ConditionsDto.fromJS(_data["conditions"]) : <any>undefined;
            this.search = _data["search"];
            this.cityPostalCodeSearch = _data["cityPostalCodeSearch"];
            this.signUpSourceSearch = _data["signUpSourceSearch"];
            this.radiusInKilometer = _data["radiusInKilometer"];
            this.minBalance = _data["minBalance"];
            this.maxBalance = _data["maxBalance"];
            this.order = _data["order"];
            this.orderField = _data["orderField"];
            this.isUnsubscribedFromMarketingEmail = _data["isUnsubscribedFromMarketingEmail"];
            this.unsubscribedFromMarketingEmailStartDate = _data["unsubscribedFromMarketingEmailStartDate"] ? new Date(_data["unsubscribedFromMarketingEmailStartDate"].toString()) : <any>undefined;
            this.unsubscribedFromMarketingEmailEndDate = _data["unsubscribedFromMarketingEmailEndDate"] ? new Date(_data["unsubscribedFromMarketingEmailEndDate"].toString()) : <any>undefined;
            this.includeSignUpSource = _data["includeSignUpSource"];
            this.onlySus = _data["onlySus"];
        }
    }

    static fromJS(data: any): MysteryShopperFilters {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditions"] = this.conditions ? this.conditions.toJSON() : <any>undefined;
        data["search"] = this.search;
        data["cityPostalCodeSearch"] = this.cityPostalCodeSearch;
        data["signUpSourceSearch"] = this.signUpSourceSearch;
        data["radiusInKilometer"] = this.radiusInKilometer;
        data["minBalance"] = this.minBalance;
        data["maxBalance"] = this.maxBalance;
        data["order"] = this.order;
        data["orderField"] = this.orderField;
        data["isUnsubscribedFromMarketingEmail"] = this.isUnsubscribedFromMarketingEmail;
        data["unsubscribedFromMarketingEmailStartDate"] = this.unsubscribedFromMarketingEmailStartDate ? this.unsubscribedFromMarketingEmailStartDate.toISOString() : <any>undefined;
        data["unsubscribedFromMarketingEmailEndDate"] = this.unsubscribedFromMarketingEmailEndDate ? this.unsubscribedFromMarketingEmailEndDate.toISOString() : <any>undefined;
        data["includeSignUpSource"] = this.includeSignUpSource;
        data["onlySus"] = this.onlySus;
        return data;
    }
}

export interface IMysteryShopperFilters {
    conditions?: ConditionsDto | undefined;
    search?: string | undefined;
    cityPostalCodeSearch?: string | undefined;
    signUpSourceSearch?: string | undefined;
    radiusInKilometer?: number | undefined;
    minBalance?: number | undefined;
    maxBalance?: number | undefined;
    order?: SortOrder | undefined;
    orderField?: GetMysteryShopperListOrderField | undefined;
    isUnsubscribedFromMarketingEmail?: boolean | undefined;
    unsubscribedFromMarketingEmailStartDate?: Date | undefined;
    unsubscribedFromMarketingEmailEndDate?: Date | undefined;
    includeSignUpSource?: boolean | undefined;
    onlySus?: boolean | undefined;
}

export enum SortOrder {
    Ascending = 0,
    Descending = 1,
}

export enum GetMysteryShopperListOrderField {
    FirstName = 0,
    LastName = 1,
    Email = 2,
    Balance = 3,
    NumberOfApprovedMissions = 4,
    LastActiveDate = 5,
    SignUpSource = 6,
}

export class GetMysteryShopperValidationsViewModel implements IGetMysteryShopperValidationsViewModel {

    constructor(data?: IGetMysteryShopperValidationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetMysteryShopperValidationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperValidationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetMysteryShopperValidationsViewModel {
}

export class GetMysteryShopperViewModel implements IGetMysteryShopperViewModel {
    mysteryShopper?: GetMysteryShopperDto;
    tags?: GetMysteryShopperTagDto[];
    subscriptions?: GetInterestClientSubscriptionDto[];
    organizations?: GetInterestClientOrganizationDto[];
    availableProfileMembers?: ProfileMemberDto[];

    constructor(data?: IGetMysteryShopperViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mysteryShopper = _data["mysteryShopper"] ? GetMysteryShopperDto.fromJS(_data["mysteryShopper"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetMysteryShopperTagDto.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(GetInterestClientSubscriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(GetInterestClientOrganizationDto.fromJS(item));
            }
            if (Array.isArray(_data["availableProfileMembers"])) {
                this.availableProfileMembers = [] as any;
                for (let item of _data["availableProfileMembers"])
                    this.availableProfileMembers!.push(ProfileMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mysteryShopper"] = this.mysteryShopper ? this.mysteryShopper.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.availableProfileMembers)) {
            data["availableProfileMembers"] = [];
            for (let item of this.availableProfileMembers)
                data["availableProfileMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMysteryShopperViewModel {
    mysteryShopper?: GetMysteryShopperDto;
    tags?: GetMysteryShopperTagDto[];
    subscriptions?: GetInterestClientSubscriptionDto[];
    organizations?: GetInterestClientOrganizationDto[];
    availableProfileMembers?: ProfileMemberDto[];
}

export class GetMysteryShopperDto implements IGetMysteryShopperDto {
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    id?: string;
    createdDate?: Date;
    lastActiveDate?: Date;
    languages?: string[] | undefined;
    isDeleted?: boolean;
    isDisabled?: boolean;
    invalidPhoneNumber?: boolean;
    fraud?: boolean;
    doNotCall?: boolean;
    last90DaysMissionApprovedCount?: number;
    age?: number | undefined;
    profiles?: MysteryShopperProfileDto[];
    addresses?: MysteryShopperAddressDto[];
    comments?: MysteryShopperCommentDto[];
    interests?: MysteryShopperInterestDto[];
    notificationEntries?: MysteryShopperNotificationEntryDto[];

    constructor(data?: IGetMysteryShopperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastActiveDate = _data["lastActiveDate"] ? new Date(_data["lastActiveDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.isDeleted = _data["isDeleted"];
            this.isDisabled = _data["isDisabled"];
            this.invalidPhoneNumber = _data["invalidPhoneNumber"];
            this.fraud = _data["fraud"];
            this.doNotCall = _data["doNotCall"];
            this.last90DaysMissionApprovedCount = _data["last90DaysMissionApprovedCount"];
            this.age = _data["age"];
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(MysteryShopperProfileDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(MysteryShopperAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(MysteryShopperCommentDto.fromJS(item));
            }
            if (Array.isArray(_data["interests"])) {
                this.interests = [] as any;
                for (let item of _data["interests"])
                    this.interests!.push(MysteryShopperInterestDto.fromJS(item));
            }
            if (Array.isArray(_data["notificationEntries"])) {
                this.notificationEntries = [] as any;
                for (let item of _data["notificationEntries"])
                    this.notificationEntries!.push(MysteryShopperNotificationEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastActiveDate"] = this.lastActiveDate ? this.lastActiveDate.toISOString() : <any>undefined;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["isDisabled"] = this.isDisabled;
        data["invalidPhoneNumber"] = this.invalidPhoneNumber;
        data["fraud"] = this.fraud;
        data["doNotCall"] = this.doNotCall;
        data["last90DaysMissionApprovedCount"] = this.last90DaysMissionApprovedCount;
        data["age"] = this.age;
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.interests)) {
            data["interests"] = [];
            for (let item of this.interests)
                data["interests"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationEntries)) {
            data["notificationEntries"] = [];
            for (let item of this.notificationEntries)
                data["notificationEntries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMysteryShopperDto {
    email?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    id?: string;
    createdDate?: Date;
    lastActiveDate?: Date;
    languages?: string[] | undefined;
    isDeleted?: boolean;
    isDisabled?: boolean;
    invalidPhoneNumber?: boolean;
    fraud?: boolean;
    doNotCall?: boolean;
    last90DaysMissionApprovedCount?: number;
    age?: number | undefined;
    profiles?: MysteryShopperProfileDto[];
    addresses?: MysteryShopperAddressDto[];
    comments?: MysteryShopperCommentDto[];
    interests?: MysteryShopperInterestDto[];
    notificationEntries?: MysteryShopperNotificationEntryDto[];
}

export class MysteryShopperProfileDto implements IMysteryShopperProfileDto {
    label?: string;
    valueText?: string | undefined;

    constructor(data?: IMysteryShopperProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.valueText = _data["valueText"];
        }
    }

    static fromJS(data: any): MysteryShopperProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["valueText"] = this.valueText;
        return data;
    }
}

export interface IMysteryShopperProfileDto {
    label?: string;
    valueText?: string | undefined;
}

export class MysteryShopperAddressDto implements IMysteryShopperAddressDto {
    id?: string;
    type?: MysteryShopperAddressType;
    city?: string;
    postalCode?: string;
    address?: string;
    department?: string;
    country?: string;
    geoLocation?: GeoLocation | undefined;
    mysteryShopperId?: string;

    constructor(data?: IMysteryShopperAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.department = _data["department"];
            this.country = _data["country"];
            this.geoLocation = _data["geoLocation"] ? GeoLocation.fromJS(_data["geoLocation"]) : <any>undefined;
            this.mysteryShopperId = _data["mysteryShopperId"];
        }
    }

    static fromJS(data: any): MysteryShopperAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["department"] = this.department;
        data["country"] = this.country;
        data["geoLocation"] = this.geoLocation ? this.geoLocation.toJSON() : <any>undefined;
        data["mysteryShopperId"] = this.mysteryShopperId;
        return data;
    }
}

export interface IMysteryShopperAddressDto {
    id?: string;
    type?: MysteryShopperAddressType;
    city?: string;
    postalCode?: string;
    address?: string;
    department?: string;
    country?: string;
    geoLocation?: GeoLocation | undefined;
    mysteryShopperId?: string;
}

export enum MysteryShopperAddressType {
    Home = 0,
    Work = 1,
    School = 2,
    SecondaryHome = 3,
    Other = 4,
    Current = 5,
}

export class MysteryShopperCommentDto implements IMysteryShopperCommentDto {
    commentText?: string | undefined;
    satisfaction?: SatisfactionType;
    mysteryShopperId?: string;
    createdDate?: Date;
    createdBy?: string;

    constructor(data?: IMysteryShopperCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentText = _data["commentText"];
            this.satisfaction = _data["satisfaction"];
            this.mysteryShopperId = _data["mysteryShopperId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): MysteryShopperCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentText"] = this.commentText;
        data["satisfaction"] = this.satisfaction;
        data["mysteryShopperId"] = this.mysteryShopperId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IMysteryShopperCommentDto {
    commentText?: string | undefined;
    satisfaction?: SatisfactionType;
    mysteryShopperId?: string;
    createdDate?: Date;
    createdBy?: string;
}

export enum SatisfactionType {
    VeryPositive = 0,
    Positive = 1,
    Neutral = 2,
    Negative = 3,
    VeryNegative = 4,
}

export class MysteryShopperInterestDto implements IMysteryShopperInterestDto {
    id?: string;
    interestText?: string | undefined;
    approximatedTime?: Date | undefined;
    isArchived?: boolean;
    createdDate?: Date;
    createdBy?: string;
    mysteryShopperId?: string;
    tagId?: string;
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;

    constructor(data?: IMysteryShopperInterestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestText = _data["interestText"];
            this.approximatedTime = _data["approximatedTime"] ? new Date(_data["approximatedTime"].toString()) : <any>undefined;
            this.isArchived = _data["isArchived"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.mysteryShopperId = _data["mysteryShopperId"];
            this.tagId = _data["tagId"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): MysteryShopperInterestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperInterestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestText"] = this.interestText;
        data["approximatedTime"] = this.approximatedTime ? this.approximatedTime.toISOString() : <any>undefined;
        data["isArchived"] = this.isArchived;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["mysteryShopperId"] = this.mysteryShopperId;
        data["tagId"] = this.tagId;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface IMysteryShopperInterestDto {
    id?: string;
    interestText?: string | undefined;
    approximatedTime?: Date | undefined;
    isArchived?: boolean;
    createdDate?: Date;
    createdBy?: string;
    mysteryShopperId?: string;
    tagId?: string;
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
}

export class MysteryShopperNotificationEntryDto implements IMysteryShopperNotificationEntryDto {
    type?: NotificationRule;
    mysteryShopperId?: string;
    profileBranchRuleId?: string;
    profileAutomationProcessId?: string;
    title?: string;
    content?: string;
    sendDate?: Date | undefined;
    status?: NotificationEntryStatus;
    periodName?: string;
    mandateName?: string;

    constructor(data?: IMysteryShopperNotificationEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.mysteryShopperId = _data["mysteryShopperId"];
            this.profileBranchRuleId = _data["profileBranchRuleId"];
            this.profileAutomationProcessId = _data["profileAutomationProcessId"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.sendDate = _data["sendDate"] ? new Date(_data["sendDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.periodName = _data["periodName"];
            this.mandateName = _data["mandateName"];
        }
    }

    static fromJS(data: any): MysteryShopperNotificationEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperNotificationEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["mysteryShopperId"] = this.mysteryShopperId;
        data["profileBranchRuleId"] = this.profileBranchRuleId;
        data["profileAutomationProcessId"] = this.profileAutomationProcessId;
        data["title"] = this.title;
        data["content"] = this.content;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["periodName"] = this.periodName;
        data["mandateName"] = this.mandateName;
        return data;
    }
}

export interface IMysteryShopperNotificationEntryDto {
    type?: NotificationRule;
    mysteryShopperId?: string;
    profileBranchRuleId?: string;
    profileAutomationProcessId?: string;
    title?: string;
    content?: string;
    sendDate?: Date | undefined;
    status?: NotificationEntryStatus;
    periodName?: string;
    mandateName?: string;
}

export enum NotificationRule {
    UserRule = 0,
    Bypass = 1,
}

export enum NotificationEntryStatus {
    Created = 0,
    Sent = 1,
    Error = 2,
}

export class GetMysteryShopperTagDto implements IGetMysteryShopperTagDto {
    id?: string;
    name?: string[];

    constructor(data?: IGetMysteryShopperTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["name"])) {
                this.name = [] as any;
                for (let item of _data["name"])
                    this.name!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.name)) {
            data["name"] = [];
            for (let item of this.name)
                data["name"].push(item);
        }
        return data;
    }
}

export interface IGetMysteryShopperTagDto {
    id?: string;
    name?: string[];
}

export class GetInterestClientSubscriptionDto implements IGetInterestClientSubscriptionDto {
    id?: string;
    name?: string;
    organizationId?: string;

    constructor(data?: IGetInterestClientSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): GetInterestClientSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterestClientSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IGetInterestClientSubscriptionDto {
    id?: string;
    name?: string;
    organizationId?: string;
}

export class GetInterestClientOrganizationDto implements IGetInterestClientOrganizationDto {
    name?: string;
    id?: string;
    organizationId?: string;

    constructor(data?: IGetInterestClientOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): GetInterestClientOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterestClientOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IGetInterestClientOrganizationDto {
    name?: string;
    id?: string;
    organizationId?: string;
}

export class GetMysteryShopperMissionsViewModel implements IGetMysteryShopperMissionsViewModel {
    missions?: PaginatedResponseOfGetMysteryShopperMissionsDto;
    unfilteredMissions?: GetMysteryShopperMissionsCountDto[];

    constructor(data?: IGetMysteryShopperMissionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missions = _data["missions"] ? PaginatedResponseOfGetMysteryShopperMissionsDto.fromJS(_data["missions"]) : <any>undefined;
            if (Array.isArray(_data["unfilteredMissions"])) {
                this.unfilteredMissions = [] as any;
                for (let item of _data["unfilteredMissions"])
                    this.unfilteredMissions!.push(GetMysteryShopperMissionsCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperMissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperMissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missions"] = this.missions ? this.missions.toJSON() : <any>undefined;
        if (Array.isArray(this.unfilteredMissions)) {
            data["unfilteredMissions"] = [];
            for (let item of this.unfilteredMissions)
                data["unfilteredMissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMysteryShopperMissionsViewModel {
    missions?: PaginatedResponseOfGetMysteryShopperMissionsDto;
    unfilteredMissions?: GetMysteryShopperMissionsCountDto[];
}

export class PaginatedResponseOfGetMysteryShopperMissionsDto implements IPaginatedResponseOfGetMysteryShopperMissionsDto {
    items?: GetMysteryShopperMissionsDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfGetMysteryShopperMissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetMysteryShopperMissionsDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetMysteryShopperMissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetMysteryShopperMissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfGetMysteryShopperMissionsDto {
    items?: GetMysteryShopperMissionsDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class GetMysteryShopperMissionsDto implements IGetMysteryShopperMissionsDto {
    id?: string;
    projectName?: string;
    periodName?: string;
    subscriptionName?: string;
    branch?: GetMysteryShopperMissionsBranchDto;
    dateOfVisit?: Date | undefined;
    remuneration?: GetMysteryShopperMissionsRemunerationDto;
    delay?: GetMysteryShopperMissionsDelayDto;
    missionAssignationStatus?: MissionAssignationStatus;
    isCancellable?: boolean;
    canBypassValidation?: boolean;
    canBeExtended?: boolean;
    canBeMoved?: boolean;
    createdAt?: Date;
    approvedDate?: Date | undefined;
    expirationDate?: Date | undefined;

    constructor(data?: IGetMysteryShopperMissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.periodName = _data["periodName"];
            this.subscriptionName = _data["subscriptionName"];
            this.branch = _data["branch"] ? GetMysteryShopperMissionsBranchDto.fromJS(_data["branch"]) : <any>undefined;
            this.dateOfVisit = _data["dateOfVisit"] ? new Date(_data["dateOfVisit"].toString()) : <any>undefined;
            this.remuneration = _data["remuneration"] ? GetMysteryShopperMissionsRemunerationDto.fromJS(_data["remuneration"]) : <any>undefined;
            this.delay = _data["delay"] ? GetMysteryShopperMissionsDelayDto.fromJS(_data["delay"]) : <any>undefined;
            this.missionAssignationStatus = _data["missionAssignationStatus"];
            this.isCancellable = _data["isCancellable"];
            this.canBypassValidation = _data["canBypassValidation"];
            this.canBeExtended = _data["canBeExtended"];
            this.canBeMoved = _data["canBeMoved"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMysteryShopperMissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperMissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["periodName"] = this.periodName;
        data["subscriptionName"] = this.subscriptionName;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["dateOfVisit"] = this.dateOfVisit ? this.dateOfVisit.toISOString() : <any>undefined;
        data["remuneration"] = this.remuneration ? this.remuneration.toJSON() : <any>undefined;
        data["delay"] = this.delay ? this.delay.toJSON() : <any>undefined;
        data["missionAssignationStatus"] = this.missionAssignationStatus;
        data["isCancellable"] = this.isCancellable;
        data["canBypassValidation"] = this.canBypassValidation;
        data["canBeExtended"] = this.canBeExtended;
        data["canBeMoved"] = this.canBeMoved;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMysteryShopperMissionsDto {
    id?: string;
    projectName?: string;
    periodName?: string;
    subscriptionName?: string;
    branch?: GetMysteryShopperMissionsBranchDto;
    dateOfVisit?: Date | undefined;
    remuneration?: GetMysteryShopperMissionsRemunerationDto;
    delay?: GetMysteryShopperMissionsDelayDto;
    missionAssignationStatus?: MissionAssignationStatus;
    isCancellable?: boolean;
    canBypassValidation?: boolean;
    canBeExtended?: boolean;
    canBeMoved?: boolean;
    createdAt?: Date;
    approvedDate?: Date | undefined;
    expirationDate?: Date | undefined;
}

export class GetMysteryShopperMissionsBranchDto implements IGetMysteryShopperMissionsBranchDto {
    name?: string;
    code?: string;
    address?: string;

    constructor(data?: IGetMysteryShopperMissionsBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): GetMysteryShopperMissionsBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperMissionsBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        return data;
    }
}

export interface IGetMysteryShopperMissionsBranchDto {
    name?: string;
    code?: string;
    address?: string;
}

export class GetMysteryShopperMissionsRemunerationDto implements IGetMysteryShopperMissionsRemunerationDto {
    invoiceAmount?: number | undefined;
    invoiceReimbursementAmount?: number | undefined;
    salary?: number;
    reimbursementUnitType?: RemunerationReimbursementUnitType | undefined;
    reimbursementValue?: number;
    perDiem?: number;

    constructor(data?: IGetMysteryShopperMissionsRemunerationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceAmount = _data["invoiceAmount"];
            this.invoiceReimbursementAmount = _data["invoiceReimbursementAmount"];
            this.salary = _data["salary"];
            this.reimbursementUnitType = _data["reimbursementUnitType"];
            this.reimbursementValue = _data["reimbursementValue"];
            this.perDiem = _data["perDiem"];
        }
    }

    static fromJS(data: any): GetMysteryShopperMissionsRemunerationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperMissionsRemunerationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceAmount"] = this.invoiceAmount;
        data["invoiceReimbursementAmount"] = this.invoiceReimbursementAmount;
        data["salary"] = this.salary;
        data["reimbursementUnitType"] = this.reimbursementUnitType;
        data["reimbursementValue"] = this.reimbursementValue;
        data["perDiem"] = this.perDiem;
        return data;
    }
}

export interface IGetMysteryShopperMissionsRemunerationDto {
    invoiceAmount?: number | undefined;
    invoiceReimbursementAmount?: number | undefined;
    salary?: number;
    reimbursementUnitType?: RemunerationReimbursementUnitType | undefined;
    reimbursementValue?: number;
    perDiem?: number;
}

export class GetMysteryShopperMissionsDelayDto implements IGetMysteryShopperMissionsDelayDto {
    timeLeft?: string;
    requiredAppointmentText?: string;

    constructor(data?: IGetMysteryShopperMissionsDelayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeLeft = _data["timeLeft"];
            this.requiredAppointmentText = _data["requiredAppointmentText"];
        }
    }

    static fromJS(data: any): GetMysteryShopperMissionsDelayDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperMissionsDelayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeLeft"] = this.timeLeft;
        data["requiredAppointmentText"] = this.requiredAppointmentText;
        return data;
    }
}

export interface IGetMysteryShopperMissionsDelayDto {
    timeLeft?: string;
    requiredAppointmentText?: string;
}

export class GetMysteryShopperMissionsCountDto implements IGetMysteryShopperMissionsCountDto {
    missionAssignationStatus?: MissionAssignationStatus;
    count?: number;

    constructor(data?: IGetMysteryShopperMissionsCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionAssignationStatus = _data["missionAssignationStatus"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetMysteryShopperMissionsCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperMissionsCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationStatus"] = this.missionAssignationStatus;
        data["count"] = this.count;
        return data;
    }
}

export interface IGetMysteryShopperMissionsCountDto {
    missionAssignationStatus?: MissionAssignationStatus;
    count?: number;
}

export class GetMissionsStatsViewModel implements IGetMissionsStatsViewModel {
    missionStats?: GetMissionStatsDto[] | undefined;

    constructor(data?: IGetMissionsStatsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missionStats"])) {
                this.missionStats = [] as any;
                for (let item of _data["missionStats"])
                    this.missionStats!.push(GetMissionStatsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionsStatsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionsStatsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missionStats)) {
            data["missionStats"] = [];
            for (let item of this.missionStats)
                data["missionStats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMissionsStatsViewModel {
    missionStats?: GetMissionStatsDto[] | undefined;
}

export class GetMissionStatsDto implements IGetMissionStatsDto {
    status?: MissionAssignationStatus;
    currentCount?: number;
    totalCount?: number;

    constructor(data?: IGetMissionStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.currentCount = _data["currentCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetMissionStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["currentCount"] = this.currentCount;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGetMissionStatsDto {
    status?: MissionAssignationStatus;
    currentCount?: number;
    totalCount?: number;
}

export class GetSurveyAnswersViewModel implements IGetSurveyAnswersViewModel {
    surveyAnswers?: GetSurveyAnswersPayload[];

    constructor(data?: IGetSurveyAnswersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyAnswers"])) {
                this.surveyAnswers = [] as any;
                for (let item of _data["surveyAnswers"])
                    this.surveyAnswers!.push(GetSurveyAnswersPayload.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSurveyAnswersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAnswersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyAnswers)) {
            data["surveyAnswers"] = [];
            for (let item of this.surveyAnswers)
                data["surveyAnswers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSurveyAnswersViewModel {
    surveyAnswers?: GetSurveyAnswersPayload[];
}

export class GetSurveyAnswersPayload implements IGetSurveyAnswersPayload {
    projectName?: string;
    periodName?: string;
    missionConfigurationName?: string;
    surveyAnswer?: GetSurveyAnswersDto;

    constructor(data?: IGetSurveyAnswersPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.periodName = _data["periodName"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.surveyAnswer = _data["surveyAnswer"] ? GetSurveyAnswersDto.fromJS(_data["surveyAnswer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyAnswersPayload {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAnswersPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["periodName"] = this.periodName;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["surveyAnswer"] = this.surveyAnswer ? this.surveyAnswer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyAnswersPayload {
    projectName?: string;
    periodName?: string;
    missionConfigurationName?: string;
    surveyAnswer?: GetSurveyAnswersDto;
}

export class GetSurveyAnswersDto implements IGetSurveyAnswersDto {
    id?: string;
    branchName?: string;
    formName?: string;
    formJson?: string;
    answerJson?: string | undefined;
    formVersionId?: string;
    formId?: string;
    projectId?: string;
    canDisplayPeerReviewValidations?: boolean;
    canEditPeerReviewValidations?: boolean;
    peerReviewValidations?: GetSurveyAnswersPeerReviewValidationDto[] | undefined;

    constructor(data?: IGetSurveyAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchName = _data["branchName"];
            this.formName = _data["formName"];
            this.formJson = _data["formJson"];
            this.answerJson = _data["answerJson"];
            this.formVersionId = _data["formVersionId"];
            this.formId = _data["formId"];
            this.projectId = _data["projectId"];
            this.canDisplayPeerReviewValidations = _data["canDisplayPeerReviewValidations"];
            this.canEditPeerReviewValidations = _data["canEditPeerReviewValidations"];
            if (Array.isArray(_data["peerReviewValidations"])) {
                this.peerReviewValidations = [] as any;
                for (let item of _data["peerReviewValidations"])
                    this.peerReviewValidations!.push(GetSurveyAnswersPeerReviewValidationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSurveyAnswersDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchName"] = this.branchName;
        data["formName"] = this.formName;
        data["formJson"] = this.formJson;
        data["answerJson"] = this.answerJson;
        data["formVersionId"] = this.formVersionId;
        data["formId"] = this.formId;
        data["projectId"] = this.projectId;
        data["canDisplayPeerReviewValidations"] = this.canDisplayPeerReviewValidations;
        data["canEditPeerReviewValidations"] = this.canEditPeerReviewValidations;
        if (Array.isArray(this.peerReviewValidations)) {
            data["peerReviewValidations"] = [];
            for (let item of this.peerReviewValidations)
                data["peerReviewValidations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSurveyAnswersDto {
    id?: string;
    branchName?: string;
    formName?: string;
    formJson?: string;
    answerJson?: string | undefined;
    formVersionId?: string;
    formId?: string;
    projectId?: string;
    canDisplayPeerReviewValidations?: boolean;
    canEditPeerReviewValidations?: boolean;
    peerReviewValidations?: GetSurveyAnswersPeerReviewValidationDto[] | undefined;
}

export class GetSurveyAnswersPeerReviewValidationDto implements IGetSurveyAnswersPeerReviewValidationDto {
    validationId?: string;
    status?: PeerReviewValidationStatus;
    date?: Date | undefined;
    comment?: string | undefined;
    history?: GetSurveyAnswersPeerReviewValidationDto[];

    constructor(data?: IGetSurveyAnswersPeerReviewValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationId = _data["validationId"];
            this.status = _data["status"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(GetSurveyAnswersPeerReviewValidationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSurveyAnswersPeerReviewValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAnswersPeerReviewValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationId"] = this.validationId;
        data["status"] = this.status;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSurveyAnswersPeerReviewValidationDto {
    validationId?: string;
    status?: PeerReviewValidationStatus;
    date?: Date | undefined;
    comment?: string | undefined;
    history?: GetSurveyAnswersPeerReviewValidationDto[];
}

export class GetMysteryShopperFiltersViewModel implements IGetMysteryShopperFiltersViewModel {
    availableProfileMembers?: ProfileMemberDto[];
    earliestUnsubscribedStartDate?: Date | undefined;
    latestUnsubscribedEndDate?: Date | undefined;

    constructor(data?: IGetMysteryShopperFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableProfileMembers"])) {
                this.availableProfileMembers = [] as any;
                for (let item of _data["availableProfileMembers"])
                    this.availableProfileMembers!.push(ProfileMemberDto.fromJS(item));
            }
            this.earliestUnsubscribedStartDate = _data["earliestUnsubscribedStartDate"] ? new Date(_data["earliestUnsubscribedStartDate"].toString()) : <any>undefined;
            this.latestUnsubscribedEndDate = _data["latestUnsubscribedEndDate"] ? new Date(_data["latestUnsubscribedEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMysteryShopperFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableProfileMembers)) {
            data["availableProfileMembers"] = [];
            for (let item of this.availableProfileMembers)
                data["availableProfileMembers"].push(item.toJSON());
        }
        data["earliestUnsubscribedStartDate"] = this.earliestUnsubscribedStartDate ? this.earliestUnsubscribedStartDate.toISOString() : <any>undefined;
        data["latestUnsubscribedEndDate"] = this.latestUnsubscribedEndDate ? this.latestUnsubscribedEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMysteryShopperFiltersViewModel {
    availableProfileMembers?: ProfileMemberDto[];
    earliestUnsubscribedStartDate?: Date | undefined;
    latestUnsubscribedEndDate?: Date | undefined;
}

export class UpdateMysteryShopperProfileViewModel implements IUpdateMysteryShopperProfileViewModel {
    mysteryShopperDto?: UpdateMysteryShopperDto;

    constructor(data?: IUpdateMysteryShopperProfileViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mysteryShopperDto = _data["mysteryShopperDto"] ? UpdateMysteryShopperDto.fromJS(_data["mysteryShopperDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateMysteryShopperProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMysteryShopperProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mysteryShopperDto"] = this.mysteryShopperDto ? this.mysteryShopperDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateMysteryShopperProfileViewModel {
    mysteryShopperDto?: UpdateMysteryShopperDto;
}

export class UpdateMysteryShopperDto implements IUpdateMysteryShopperDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    languages?: string[] | undefined;
    phoneNumber?: string | undefined;
    theme?: DeviceTheme | undefined;
    profiles?: UpdateMysteryShopperProfileDto[] | undefined;
    addresses?: UpdateMysteryShopperAddressDto[] | undefined;
    invalidPhoneNumber?: boolean;
    fraud?: boolean;
    doNotCall?: boolean;

    constructor(data?: IUpdateMysteryShopperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.phoneNumber = _data["phoneNumber"];
            this.theme = _data["theme"];
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(UpdateMysteryShopperProfileDto.fromJS(item));
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(UpdateMysteryShopperAddressDto.fromJS(item));
            }
            this.invalidPhoneNumber = _data["invalidPhoneNumber"];
            this.fraud = _data["fraud"];
            this.doNotCall = _data["doNotCall"];
        }
    }

    static fromJS(data: any): UpdateMysteryShopperDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMysteryShopperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["phoneNumber"] = this.phoneNumber;
        data["theme"] = this.theme;
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["invalidPhoneNumber"] = this.invalidPhoneNumber;
        data["fraud"] = this.fraud;
        data["doNotCall"] = this.doNotCall;
        return data;
    }
}

export interface IUpdateMysteryShopperDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    languages?: string[] | undefined;
    phoneNumber?: string | undefined;
    theme?: DeviceTheme | undefined;
    profiles?: UpdateMysteryShopperProfileDto[] | undefined;
    addresses?: UpdateMysteryShopperAddressDto[] | undefined;
    invalidPhoneNumber?: boolean;
    fraud?: boolean;
    doNotCall?: boolean;
}

export enum DeviceTheme {
    Light = 0,
    Dark = 1,
}

export class UpdateMysteryShopperProfileDto implements IUpdateMysteryShopperProfileDto {
    key?: string;
    value?: string | undefined;

    constructor(data?: IUpdateMysteryShopperProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateMysteryShopperProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMysteryShopperProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateMysteryShopperProfileDto {
    key?: string;
    value?: string | undefined;
}

export class UpdateMysteryShopperAddressDto implements IUpdateMysteryShopperAddressDto {
    id?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    department?: string | undefined;
    country?: string | undefined;
    type?: MysteryShopperAddressType;

    constructor(data?: IUpdateMysteryShopperAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.department = _data["department"];
            this.country = _data["country"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UpdateMysteryShopperAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMysteryShopperAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["department"] = this.department;
        data["country"] = this.country;
        data["type"] = this.type;
        return data;
    }
}

export interface IUpdateMysteryShopperAddressDto {
    id?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    department?: string | undefined;
    country?: string | undefined;
    type?: MysteryShopperAddressType;
}

export class BypassValidationViewModel implements IBypassValidationViewModel {
    isSuccess?: boolean;

    constructor(data?: IBypassValidationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): BypassValidationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BypassValidationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IBypassValidationViewModel {
    isSuccess?: boolean;
}

export class UnassignMissionDto implements IUnassignMissionDto {
    comment?: string | undefined;

    constructor(data?: IUnassignMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UnassignMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnassignMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUnassignMissionDto {
    comment?: string | undefined;
}

export class DeleteMysteryShopperAddressViewModel implements IDeleteMysteryShopperAddressViewModel {
    success?: boolean;

    constructor(data?: IDeleteMysteryShopperAddressViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeleteMysteryShopperAddressViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMysteryShopperAddressViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeleteMysteryShopperAddressViewModel {
    success?: boolean;
}

export enum ExportTableType {
    Xlsx = 0,
    Csv = 1,
    Pdf = 2,
}

export class InterestDto implements IInterestDto {
    interestText?: string | undefined;
    months?: number | undefined;
    subscriptionId?: string | undefined;
    tagId?: string | undefined;
    isArchived?: boolean;

    constructor(data?: IInterestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interestText = _data["interestText"];
            this.months = _data["months"];
            this.subscriptionId = _data["subscriptionId"];
            this.tagId = _data["tagId"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): InterestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interestText"] = this.interestText;
        data["months"] = this.months;
        data["subscriptionId"] = this.subscriptionId;
        data["tagId"] = this.tagId;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IInterestDto {
    interestText?: string | undefined;
    months?: number | undefined;
    subscriptionId?: string | undefined;
    tagId?: string | undefined;
    isArchived?: boolean;
}

export class CommentDto implements ICommentDto {
    commentText?: string | undefined;
    satisfaction?: SatisfactionType;
    noContact?: boolean | undefined;

    constructor(data?: ICommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentText = _data["commentText"];
            this.satisfaction = _data["satisfaction"];
            this.noContact = _data["noContact"];
        }
    }

    static fromJS(data: any): CommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentText"] = this.commentText;
        data["satisfaction"] = this.satisfaction;
        data["noContact"] = this.noContact;
        return data;
    }
}

export interface ICommentDto {
    commentText?: string | undefined;
    satisfaction?: SatisfactionType;
    noContact?: boolean | undefined;
}

export class GetMysteryShopperInterestsViewModel implements IGetMysteryShopperInterestsViewModel {
    interests?: MysteryShopperInterestDto2[];

    constructor(data?: IGetMysteryShopperInterestsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["interests"])) {
                this.interests = [] as any;
                for (let item of _data["interests"])
                    this.interests!.push(MysteryShopperInterestDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperInterestsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperInterestsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.interests)) {
            data["interests"] = [];
            for (let item of this.interests)
                data["interests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMysteryShopperInterestsViewModel {
    interests?: MysteryShopperInterestDto2[];
}

export class MysteryShopperInterestDto2 implements IMysteryShopperInterestDto2 {
    interestText?: string | undefined;
    tag?: string;
    timeLeftInMonths?: number | undefined;
    createdBy?: string;
    createdAt?: Date;
    isArchived?: boolean;
    organizationName?: string;
    subscriptionName?: string;

    constructor(data?: IMysteryShopperInterestDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interestText = _data["interestText"];
            this.tag = _data["tag"];
            this.timeLeftInMonths = _data["timeLeftInMonths"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isArchived = _data["isArchived"];
            this.organizationName = _data["organizationName"];
            this.subscriptionName = _data["subscriptionName"];
        }
    }

    static fromJS(data: any): MysteryShopperInterestDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperInterestDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interestText"] = this.interestText;
        data["tag"] = this.tag;
        data["timeLeftInMonths"] = this.timeLeftInMonths;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isArchived"] = this.isArchived;
        data["organizationName"] = this.organizationName;
        data["subscriptionName"] = this.subscriptionName;
        return data;
    }
}

export interface IMysteryShopperInterestDto2 {
    interestText?: string | undefined;
    tag?: string;
    timeLeftInMonths?: number | undefined;
    createdBy?: string;
    createdAt?: Date;
    isArchived?: boolean;
    organizationName?: string;
    subscriptionName?: string;
}

export class GetMysteryShopperCommentsViewModel implements IGetMysteryShopperCommentsViewModel {
    comments?: MysteryShopperCommentsDto[];

    constructor(data?: IGetMysteryShopperCommentsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(MysteryShopperCommentsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperCommentsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperCommentsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMysteryShopperCommentsViewModel {
    comments?: MysteryShopperCommentsDto[];
}

export class MysteryShopperCommentsDto implements IMysteryShopperCommentsDto {
    commentText?: string | undefined;
    createdBy?: string;
    createdAt?: Date;

    constructor(data?: IMysteryShopperCommentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentText = _data["commentText"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MysteryShopperCommentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperCommentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentText"] = this.commentText;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMysteryShopperCommentsDto {
    commentText?: string | undefined;
    createdBy?: string;
    createdAt?: Date;
}

export class GetMysteryShopperNotificationsViewModel implements IGetMysteryShopperNotificationsViewModel {
    notifications?: GetMysteryShopperNotificationsDto[];

    constructor(data?: IGetMysteryShopperNotificationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(GetMysteryShopperNotificationsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperNotificationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperNotificationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMysteryShopperNotificationsViewModel {
    notifications?: GetMysteryShopperNotificationsDto[];
}

export class GetMysteryShopperNotificationsDto implements IGetMysteryShopperNotificationsDto {
    status?: NotificationStatus;
    createdDate?: Date;
    emailContent?: string | undefined;
    sentToEmail?: boolean;
    sentToPushNotification?: number;
    pushNotificationContent?: string | undefined;
    title?: string;

    constructor(data?: IGetMysteryShopperNotificationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.emailContent = _data["emailContent"];
            this.sentToEmail = _data["sentToEmail"];
            this.sentToPushNotification = _data["sentToPushNotification"];
            this.pushNotificationContent = _data["pushNotificationContent"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): GetMysteryShopperNotificationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperNotificationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["emailContent"] = this.emailContent;
        data["sentToEmail"] = this.sentToEmail;
        data["sentToPushNotification"] = this.sentToPushNotification;
        data["pushNotificationContent"] = this.pushNotificationContent;
        data["title"] = this.title;
        return data;
    }
}

export interface IGetMysteryShopperNotificationsDto {
    status?: NotificationStatus;
    createdDate?: Date;
    emailContent?: string | undefined;
    sentToEmail?: boolean;
    sentToPushNotification?: number;
    pushNotificationContent?: string | undefined;
    title?: string;
}

export enum NotificationStatus {
    Created = 0,
    Notified = 1,
}

export class CreateCallLogViewModel implements ICreateCallLogViewModel {
    id?: string;

    constructor(data?: ICreateCallLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCallLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCallLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateCallLogViewModel {
    id?: string;
}

export class CallLogDto implements ICallLogDto {
    comment?: string | undefined;
    callLength?: string | undefined;
    status?: MysteryShopperCallLogStatus;
    satisfaction?: SatisfactionType | undefined;
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    periodId?: string | undefined;
    missionConfigurationId?: string | undefined;
    missionAssignationId?: string | undefined;

    constructor(data?: ICallLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.callLength = _data["callLength"];
            this.status = _data["status"];
            this.satisfaction = _data["satisfaction"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
            this.periodId = _data["periodId"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.missionAssignationId = _data["missionAssignationId"];
        }
    }

    static fromJS(data: any): CallLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["callLength"] = this.callLength;
        data["status"] = this.status;
        data["satisfaction"] = this.satisfaction;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        data["periodId"] = this.periodId;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["missionAssignationId"] = this.missionAssignationId;
        return data;
    }
}

export interface ICallLogDto {
    comment?: string | undefined;
    callLength?: string | undefined;
    status?: MysteryShopperCallLogStatus;
    satisfaction?: SatisfactionType | undefined;
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    periodId?: string | undefined;
    missionConfigurationId?: string | undefined;
    missionAssignationId?: string | undefined;
}

export enum MysteryShopperCallLogStatus {
    ToContact = 0,
    Refused = 1,
    Accepted = 2,
    Voicemail = 3,
    NoAnswer = 4,
}

export class GetCallLogViewModel implements IGetCallLogViewModel {
    callLog?: CallLogDto;

    constructor(data?: IGetCallLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callLog = _data["callLog"] ? CallLogDto.fromJS(_data["callLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCallLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callLog"] = this.callLog ? this.callLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCallLogViewModel {
    callLog?: CallLogDto;
}

export class GetCallLogListViewModel implements IGetCallLogListViewModel {
    callLogs?: GetCallLogListQueryDto[];

    constructor(data?: IGetCallLogListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callLogs"])) {
                this.callLogs = [] as any;
                for (let item of _data["callLogs"])
                    this.callLogs!.push(GetCallLogListQueryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCallLogListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallLogListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callLogs)) {
            data["callLogs"] = [];
            for (let item of this.callLogs)
                data["callLogs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCallLogListViewModel {
    callLogs?: GetCallLogListQueryDto[];
}

export class GetCallLogListQueryDto implements IGetCallLogListQueryDto {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    comment?: string | undefined;
    callLength?: string | undefined;
    subjectName?: string;
    status?: MysteryShopperCallLogStatus;
    satisfaction?: SatisfactionType | undefined;
    createdBy?: string;
    lastModifiedBy?: string | undefined;

    constructor(data?: IGetCallLogListQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.callLength = _data["callLength"];
            this.subjectName = _data["subjectName"];
            this.status = _data["status"];
            this.satisfaction = _data["satisfaction"];
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): GetCallLogListQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallLogListQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["callLength"] = this.callLength;
        data["subjectName"] = this.subjectName;
        data["status"] = this.status;
        data["satisfaction"] = this.satisfaction;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IGetCallLogListQueryDto {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    comment?: string | undefined;
    callLength?: string | undefined;
    subjectName?: string;
    status?: MysteryShopperCallLogStatus;
    satisfaction?: SatisfactionType | undefined;
    createdBy?: string;
    lastModifiedBy?: string | undefined;
}

export class GetMoveMissionResponse implements IGetMoveMissionResponse {
    periods?: GetMoveMissionPeriodDto[];
    branches?: GetMoveMissionBranchDto[];

    constructor(data?: IGetMoveMissionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(GetMoveMissionPeriodDto.fromJS(item));
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetMoveMissionBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMoveMissionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoveMissionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMoveMissionResponse {
    periods?: GetMoveMissionPeriodDto[];
    branches?: GetMoveMissionBranchDto[];
}

export class GetMoveMissionPeriodDto implements IGetMoveMissionPeriodDto {
    id?: string;
    name?: string;
    selected?: boolean;
    missionConfigurations?: GetMoveMissionMissionConfigurationDto[];

    constructor(data?: IGetMoveMissionPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.selected = _data["selected"];
            if (Array.isArray(_data["missionConfigurations"])) {
                this.missionConfigurations = [] as any;
                for (let item of _data["missionConfigurations"])
                    this.missionConfigurations!.push(GetMoveMissionMissionConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMoveMissionPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoveMissionPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["selected"] = this.selected;
        if (Array.isArray(this.missionConfigurations)) {
            data["missionConfigurations"] = [];
            for (let item of this.missionConfigurations)
                data["missionConfigurations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMoveMissionPeriodDto {
    id?: string;
    name?: string;
    selected?: boolean;
    missionConfigurations?: GetMoveMissionMissionConfigurationDto[];
}

export class GetMoveMissionMissionConfigurationDto implements IGetMoveMissionMissionConfigurationDto {
    id?: string;
    name?: string;
    selected?: boolean;

    constructor(data?: IGetMoveMissionMissionConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): GetMoveMissionMissionConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoveMissionMissionConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["selected"] = this.selected;
        return data;
    }
}

export interface IGetMoveMissionMissionConfigurationDto {
    id?: string;
    name?: string;
    selected?: boolean;
}

export class GetMoveMissionBranchDto implements IGetMoveMissionBranchDto {
    id?: string;
    name?: string;
    selected?: boolean;

    constructor(data?: IGetMoveMissionBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): GetMoveMissionBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoveMissionBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["selected"] = this.selected;
        return data;
    }
}

export interface IGetMoveMissionBranchDto {
    id?: string;
    name?: string;
    selected?: boolean;
}

export class MoveMissionResponse implements IMoveMissionResponse {
    success?: boolean;

    constructor(data?: IMoveMissionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): MoveMissionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MoveMissionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IMoveMissionResponse {
    success?: boolean;
}

export class MoveMissionRequest implements IMoveMissionRequest {
    newPeriodId?: string;
    newMissionConfigurationVersionId?: string;
    newBranchId?: string;

    constructor(data?: IMoveMissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPeriodId = _data["newPeriodId"];
            this.newMissionConfigurationVersionId = _data["newMissionConfigurationVersionId"];
            this.newBranchId = _data["newBranchId"];
        }
    }

    static fromJS(data: any): MoveMissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveMissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPeriodId"] = this.newPeriodId;
        data["newMissionConfigurationVersionId"] = this.newMissionConfigurationVersionId;
        data["newBranchId"] = this.newBranchId;
        return data;
    }
}

export interface IMoveMissionRequest {
    newPeriodId?: string;
    newMissionConfigurationVersionId?: string;
    newBranchId?: string;
}

export class GetPeriodListViewModel implements IGetPeriodListViewModel {
    periods?: PaginatedResponseOfGetPeriodListPeriodDto;

    constructor(data?: IGetPeriodListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periods = _data["periods"] ? PaginatedResponseOfGetPeriodListPeriodDto.fromJS(_data["periods"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPeriodListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periods"] = this.periods ? this.periods.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPeriodListViewModel {
    periods?: PaginatedResponseOfGetPeriodListPeriodDto;
}

export class PaginatedResponseOfGetPeriodListPeriodDto implements IPaginatedResponseOfGetPeriodListPeriodDto {
    items?: GetPeriodListPeriodDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfGetPeriodListPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPeriodListPeriodDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetPeriodListPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetPeriodListPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfGetPeriodListPeriodDto {
    items?: GetPeriodListPeriodDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class GetPeriodListPeriodDto implements IGetPeriodListPeriodDto {
    id?: string;
    order?: number;
    name?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    state?: PeriodState;
    status?: PeriodStatus;

    constructor(data?: IGetPeriodListPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetPeriodListPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodListPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetPeriodListPeriodDto {
    id?: string;
    order?: number;
    name?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    state?: PeriodState;
    status?: PeriodStatus;
}

export enum PeriodState {
    Initializing = 0,
    Initialized = 1,
}

export class GetPeriodViewModel implements IGetPeriodViewModel {
    period?: GetPeriodDto;

    constructor(data?: IGetPeriodViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"] ? GetPeriodDto.fromJS(_data["period"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPeriodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPeriodViewModel {
    period?: GetPeriodDto;
}

export class GetPeriodDto implements IGetPeriodDto {
    cultures?: PeriodCultureDto[];
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: PeriodStatus;
    order?: number;
    periodMissionConfigurations?: GetPeriodXMissionConfigurationDto[];

    constructor(data?: IGetPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(PeriodCultureDto.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.order = _data["order"];
            if (Array.isArray(_data["periodMissionConfigurations"])) {
                this.periodMissionConfigurations = [] as any;
                for (let item of _data["periodMissionConfigurations"])
                    this.periodMissionConfigurations!.push(GetPeriodXMissionConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["order"] = this.order;
        if (Array.isArray(this.periodMissionConfigurations)) {
            data["periodMissionConfigurations"] = [];
            for (let item of this.periodMissionConfigurations)
                data["periodMissionConfigurations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPeriodDto {
    cultures?: PeriodCultureDto[];
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: PeriodStatus;
    order?: number;
    periodMissionConfigurations?: GetPeriodXMissionConfigurationDto[];
}

export class PeriodCultureDto implements IPeriodCultureDto {
    name?: string;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: IPeriodCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): PeriodCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IPeriodCultureDto {
    name?: string;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class GetPeriodXMissionConfigurationDto implements IGetPeriodXMissionConfigurationDto {
    missionConfigurationId?: string;
    name?: string;
    latestMajorVersion?: number;
    availableVersions?: number[];
    enabled?: boolean;
    majorVersion?: number | undefined;
    state?: PeriodXMissionConfigurationState | undefined;
    hasBranchSettings?: boolean | undefined;
    branchSettings?: GetPeriodXMissionConfigurationBranchSettingsDto | undefined;
    hasFormSettings?: boolean | undefined;
    formSettings?: GetPeriodXMissionConfigurationFormSettingsDto | undefined;

    constructor(data?: IGetPeriodXMissionConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.name = _data["name"];
            this.latestMajorVersion = _data["latestMajorVersion"];
            if (Array.isArray(_data["availableVersions"])) {
                this.availableVersions = [] as any;
                for (let item of _data["availableVersions"])
                    this.availableVersions!.push(item);
            }
            this.enabled = _data["enabled"];
            this.majorVersion = _data["majorVersion"];
            this.state = _data["state"];
            this.hasBranchSettings = _data["hasBranchSettings"];
            this.branchSettings = _data["branchSettings"] ? GetPeriodXMissionConfigurationBranchSettingsDto.fromJS(_data["branchSettings"]) : <any>undefined;
            this.hasFormSettings = _data["hasFormSettings"];
            this.formSettings = _data["formSettings"] ? GetPeriodXMissionConfigurationFormSettingsDto.fromJS(_data["formSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPeriodXMissionConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodXMissionConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["name"] = this.name;
        data["latestMajorVersion"] = this.latestMajorVersion;
        if (Array.isArray(this.availableVersions)) {
            data["availableVersions"] = [];
            for (let item of this.availableVersions)
                data["availableVersions"].push(item);
        }
        data["enabled"] = this.enabled;
        data["majorVersion"] = this.majorVersion;
        data["state"] = this.state;
        data["hasBranchSettings"] = this.hasBranchSettings;
        data["branchSettings"] = this.branchSettings ? this.branchSettings.toJSON() : <any>undefined;
        data["hasFormSettings"] = this.hasFormSettings;
        data["formSettings"] = this.formSettings ? this.formSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPeriodXMissionConfigurationDto {
    missionConfigurationId?: string;
    name?: string;
    latestMajorVersion?: number;
    availableVersions?: number[];
    enabled?: boolean;
    majorVersion?: number | undefined;
    state?: PeriodXMissionConfigurationState | undefined;
    hasBranchSettings?: boolean | undefined;
    branchSettings?: GetPeriodXMissionConfigurationBranchSettingsDto | undefined;
    hasFormSettings?: boolean | undefined;
    formSettings?: GetPeriodXMissionConfigurationFormSettingsDto | undefined;
}

export enum PeriodXMissionConfigurationState {
    Initializing = 0,
    Initialized = 1,
}

export class GetPeriodXMissionConfigurationBranchSettingsDto implements IGetPeriodXMissionConfigurationBranchSettingsDto {
    missions?: GetPeriodXMissionConfigurationBranchMissionDto[];

    constructor(data?: IGetPeriodXMissionConfigurationBranchSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missions"])) {
                this.missions = [] as any;
                for (let item of _data["missions"])
                    this.missions!.push(GetPeriodXMissionConfigurationBranchMissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPeriodXMissionConfigurationBranchSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodXMissionConfigurationBranchSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missions)) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPeriodXMissionConfigurationBranchSettingsDto {
    missions?: GetPeriodXMissionConfigurationBranchMissionDto[];
}

export class GetPeriodXMissionConfigurationBranchMissionDto implements IGetPeriodXMissionConfigurationBranchMissionDto {
    missionsToComplete?: number | undefined;
    missionsTaken?: number | undefined;
    branchId?: string;
    branchName?: string;

    constructor(data?: IGetPeriodXMissionConfigurationBranchMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionsToComplete = _data["missionsToComplete"];
            this.missionsTaken = _data["missionsTaken"];
            this.branchId = _data["branchId"];
            this.branchName = _data["branchName"];
        }
    }

    static fromJS(data: any): GetPeriodXMissionConfigurationBranchMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodXMissionConfigurationBranchMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionsToComplete"] = this.missionsToComplete;
        data["missionsTaken"] = this.missionsTaken;
        data["branchId"] = this.branchId;
        data["branchName"] = this.branchName;
        return data;
    }
}

export interface IGetPeriodXMissionConfigurationBranchMissionDto {
    missionsToComplete?: number | undefined;
    missionsTaken?: number | undefined;
    branchId?: string;
    branchName?: string;
}

export class GetPeriodXMissionConfigurationFormSettingsDto implements IGetPeriodXMissionConfigurationFormSettingsDto {
    formVersionId?: string | undefined;
    formName?: string;
    versions?: GetPeriodXMissionConfigurationFormVersionDto[];

    constructor(data?: IGetPeriodXMissionConfigurationFormSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formVersionId = _data["formVersionId"];
            this.formName = _data["formName"];
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(GetPeriodXMissionConfigurationFormVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPeriodXMissionConfigurationFormSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodXMissionConfigurationFormSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formVersionId"] = this.formVersionId;
        data["formName"] = this.formName;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPeriodXMissionConfigurationFormSettingsDto {
    formVersionId?: string | undefined;
    formName?: string;
    versions?: GetPeriodXMissionConfigurationFormVersionDto[];
}

export class GetPeriodXMissionConfigurationFormVersionDto implements IGetPeriodXMissionConfigurationFormVersionDto {
    formVersionId?: string;
    majorVersion?: number;
    minorVersion?: number;

    constructor(data?: IGetPeriodXMissionConfigurationFormVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formVersionId = _data["formVersionId"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
        }
    }

    static fromJS(data: any): GetPeriodXMissionConfigurationFormVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodXMissionConfigurationFormVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formVersionId"] = this.formVersionId;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        return data;
    }
}

export interface IGetPeriodXMissionConfigurationFormVersionDto {
    formVersionId?: string;
    majorVersion?: number;
    minorVersion?: number;
}

export class CreatePeriodViewModel implements ICreatePeriodViewModel {
    id?: string;

    constructor(data?: ICreatePeriodViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePeriodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePeriodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreatePeriodViewModel {
    id?: string;
}

export class CreatePeriodDto implements ICreatePeriodDto {
    name?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    participatingMissionConfigurationIds?: string[];

    constructor(data?: ICreatePeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["participatingMissionConfigurationIds"])) {
                this.participatingMissionConfigurationIds = [] as any;
                for (let item of _data["participatingMissionConfigurationIds"])
                    this.participatingMissionConfigurationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.participatingMissionConfigurationIds)) {
            data["participatingMissionConfigurationIds"] = [];
            for (let item of this.participatingMissionConfigurationIds)
                data["participatingMissionConfigurationIds"].push(item);
        }
        return data;
    }
}

export interface ICreatePeriodDto {
    name?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    participatingMissionConfigurationIds?: string[];
}

export class UpdatePeriodViewModel implements IUpdatePeriodViewModel {
    state?: PeriodState;
    missingRequiredSettings?: (string[] | undefined)[] | undefined;
    validationResult?: { [key: string]: string[]; } | undefined;

    constructor(data?: IUpdatePeriodViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            if (Array.isArray(_data["missingRequiredSettings"])) {
                this.missingRequiredSettings = [] as any;
                for (let item of _data["missingRequiredSettings"])
                    this.missingRequiredSettings!.push(item);
            }
            if (_data["validationResult"]) {
                this.validationResult = {} as any;
                for (let key in _data["validationResult"]) {
                    if (_data["validationResult"].hasOwnProperty(key))
                        (<any>this.validationResult)![key] = _data["validationResult"][key] !== undefined ? _data["validationResult"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): UpdatePeriodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePeriodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        if (Array.isArray(this.missingRequiredSettings)) {
            data["missingRequiredSettings"] = [];
            for (let item of this.missingRequiredSettings)
                data["missingRequiredSettings"].push(item);
        }
        if (this.validationResult) {
            data["validationResult"] = {};
            for (let key in this.validationResult) {
                if (this.validationResult.hasOwnProperty(key))
                    (<any>data["validationResult"])[key] = (<any>this.validationResult)[key];
            }
        }
        return data;
    }
}

export interface IUpdatePeriodViewModel {
    state?: PeriodState;
    missingRequiredSettings?: (string[] | undefined)[] | undefined;
    validationResult?: { [key: string]: string[]; } | undefined;
}

export class UpdatePeriodRequest implements IUpdatePeriodRequest {
    info?: UpdatePeriodInfoDto | undefined;
    participatingMissionConfigurations?: UpdatePeriodXMissionConfigurationDto[] | undefined;
    enabledParticipatingMissionConfigurations?: { [key: string]: boolean; } | undefined;

    constructor(data?: IUpdatePeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.info = _data["info"] ? UpdatePeriodInfoDto.fromJS(_data["info"]) : <any>undefined;
            if (Array.isArray(_data["participatingMissionConfigurations"])) {
                this.participatingMissionConfigurations = [] as any;
                for (let item of _data["participatingMissionConfigurations"])
                    this.participatingMissionConfigurations!.push(UpdatePeriodXMissionConfigurationDto.fromJS(item));
            }
            if (_data["enabledParticipatingMissionConfigurations"]) {
                this.enabledParticipatingMissionConfigurations = {} as any;
                for (let key in _data["enabledParticipatingMissionConfigurations"]) {
                    if (_data["enabledParticipatingMissionConfigurations"].hasOwnProperty(key))
                        (<any>this.enabledParticipatingMissionConfigurations)![key] = _data["enabledParticipatingMissionConfigurations"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdatePeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["info"] = this.info ? this.info.toJSON() : <any>undefined;
        if (Array.isArray(this.participatingMissionConfigurations)) {
            data["participatingMissionConfigurations"] = [];
            for (let item of this.participatingMissionConfigurations)
                data["participatingMissionConfigurations"].push(item.toJSON());
        }
        if (this.enabledParticipatingMissionConfigurations) {
            data["enabledParticipatingMissionConfigurations"] = {};
            for (let key in this.enabledParticipatingMissionConfigurations) {
                if (this.enabledParticipatingMissionConfigurations.hasOwnProperty(key))
                    (<any>data["enabledParticipatingMissionConfigurations"])[key] = (<any>this.enabledParticipatingMissionConfigurations)[key];
            }
        }
        return data;
    }
}

export interface IUpdatePeriodRequest {
    info?: UpdatePeriodInfoDto | undefined;
    participatingMissionConfigurations?: UpdatePeriodXMissionConfigurationDto[] | undefined;
    enabledParticipatingMissionConfigurations?: { [key: string]: boolean; } | undefined;
}

export class UpdatePeriodInfoDto implements IUpdatePeriodInfoDto {
    cultures?: PeriodCultureDto[] | undefined;
    startDate?: Date;
    endDate?: Date;
    periodStatus?: PeriodStatus | undefined;
    order?: number;

    constructor(data?: IUpdatePeriodInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(PeriodCultureDto.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.periodStatus = _data["periodStatus"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdatePeriodInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePeriodInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["periodStatus"] = this.periodStatus;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdatePeriodInfoDto {
    cultures?: PeriodCultureDto[] | undefined;
    startDate?: Date;
    endDate?: Date;
    periodStatus?: PeriodStatus | undefined;
    order?: number;
}

export class UpdatePeriodXMissionConfigurationDto implements IUpdatePeriodXMissionConfigurationDto {
    missionConfigurationId?: string;
    enabled?: boolean | undefined;
    majorVersion?: number | undefined;
    branchSettings?: UpdatePeriodXMissionConfigurationBranchSettingsDto | undefined;
    formSettings?: UpdatePeriodXMissionConfigurationFormSettingsDto | undefined;

    constructor(data?: IUpdatePeriodXMissionConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.enabled = _data["enabled"];
            this.majorVersion = _data["majorVersion"];
            this.branchSettings = _data["branchSettings"] ? UpdatePeriodXMissionConfigurationBranchSettingsDto.fromJS(_data["branchSettings"]) : <any>undefined;
            this.formSettings = _data["formSettings"] ? UpdatePeriodXMissionConfigurationFormSettingsDto.fromJS(_data["formSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePeriodXMissionConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePeriodXMissionConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["enabled"] = this.enabled;
        data["majorVersion"] = this.majorVersion;
        data["branchSettings"] = this.branchSettings ? this.branchSettings.toJSON() : <any>undefined;
        data["formSettings"] = this.formSettings ? this.formSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdatePeriodXMissionConfigurationDto {
    missionConfigurationId?: string;
    enabled?: boolean | undefined;
    majorVersion?: number | undefined;
    branchSettings?: UpdatePeriodXMissionConfigurationBranchSettingsDto | undefined;
    formSettings?: UpdatePeriodXMissionConfigurationFormSettingsDto | undefined;
}

export class UpdatePeriodXMissionConfigurationBranchSettingsDto implements IUpdatePeriodXMissionConfigurationBranchSettingsDto {
    missions?: UpdatePeriodXMissionConfigurationBranchMissionDto[];

    constructor(data?: IUpdatePeriodXMissionConfigurationBranchSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missions"])) {
                this.missions = [] as any;
                for (let item of _data["missions"])
                    this.missions!.push(UpdatePeriodXMissionConfigurationBranchMissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePeriodXMissionConfigurationBranchSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePeriodXMissionConfigurationBranchSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missions)) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdatePeriodXMissionConfigurationBranchSettingsDto {
    missions?: UpdatePeriodXMissionConfigurationBranchMissionDto[];
}

export class UpdatePeriodXMissionConfigurationBranchMissionDto implements IUpdatePeriodXMissionConfigurationBranchMissionDto {
    missionsToComplete?: number | undefined;
    branchId?: string;

    constructor(data?: IUpdatePeriodXMissionConfigurationBranchMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionsToComplete = _data["missionsToComplete"];
            this.branchId = _data["branchId"];
        }
    }

    static fromJS(data: any): UpdatePeriodXMissionConfigurationBranchMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePeriodXMissionConfigurationBranchMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionsToComplete"] = this.missionsToComplete;
        data["branchId"] = this.branchId;
        return data;
    }
}

export interface IUpdatePeriodXMissionConfigurationBranchMissionDto {
    missionsToComplete?: number | undefined;
    branchId?: string;
}

export class UpdatePeriodXMissionConfigurationFormSettingsDto implements IUpdatePeriodXMissionConfigurationFormSettingsDto {
    formVersionId?: string;

    constructor(data?: IUpdatePeriodXMissionConfigurationFormSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formVersionId = _data["formVersionId"];
        }
    }

    static fromJS(data: any): UpdatePeriodXMissionConfigurationFormSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePeriodXMissionConfigurationFormSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formVersionId"] = this.formVersionId;
        return data;
    }
}

export interface IUpdatePeriodXMissionConfigurationFormSettingsDto {
    formVersionId?: string;
}

export class GetPublishInterestViewModel implements IGetPublishInterestViewModel {
    branches?: GetPublishInterestBranchDto[];

    constructor(data?: IGetPublishInterestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetPublishInterestBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPublishInterestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublishInterestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPublishInterestViewModel {
    branches?: GetPublishInterestBranchDto[];
}

export class GetPublishInterestBranchDto implements IGetPublishInterestBranchDto {
    id?: string;
    code?: string;
    name?: string;
    nameWithCode?: string;

    constructor(data?: IGetPublishInterestBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.nameWithCode = _data["nameWithCode"];
        }
    }

    static fromJS(data: any): GetPublishInterestBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublishInterestBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["nameWithCode"] = this.nameWithCode;
        return data;
    }
}

export interface IGetPublishInterestBranchDto {
    id?: string;
    code?: string;
    name?: string;
    nameWithCode?: string;
}

export class GetProjectListViewModel implements IGetProjectListViewModel {
    projects?: PaginatedResponseOfGetProjectListProjectDto;

    constructor(data?: IGetProjectListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projects = _data["projects"] ? PaginatedResponseOfGetProjectListProjectDto.fromJS(_data["projects"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjectListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projects"] = this.projects ? this.projects.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProjectListViewModel {
    projects?: PaginatedResponseOfGetProjectListProjectDto;
}

export class PaginatedResponseOfGetProjectListProjectDto implements IPaginatedResponseOfGetProjectListProjectDto {
    items?: GetProjectListProjectDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfGetProjectListProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetProjectListProjectDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetProjectListProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetProjectListProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfGetProjectListProjectDto {
    items?: GetProjectListProjectDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class GetProjectListProjectDto implements IGetProjectListProjectDto {
    organizationId?: string;
    organizationName?: string;
    subscriptionId?: string;
    subscriptionName?: string;
    subscriptionServiceId?: string;
    subscriptionServiceName?: string;
    projectId?: string;
    projectName?: string;
    adminTags?: string[];
    hasActivePeriods?: boolean;

    constructor(data?: IGetProjectListProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionName = _data["subscriptionName"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.subscriptionServiceName = _data["subscriptionServiceName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            if (Array.isArray(_data["adminTags"])) {
                this.adminTags = [] as any;
                for (let item of _data["adminTags"])
                    this.adminTags!.push(item);
            }
            this.hasActivePeriods = _data["hasActivePeriods"];
        }
    }

    static fromJS(data: any): GetProjectListProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectListProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionName"] = this.subscriptionName;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["subscriptionServiceName"] = this.subscriptionServiceName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        if (Array.isArray(this.adminTags)) {
            data["adminTags"] = [];
            for (let item of this.adminTags)
                data["adminTags"].push(item);
        }
        data["hasActivePeriods"] = this.hasActivePeriods;
        return data;
    }
}

export interface IGetProjectListProjectDto {
    organizationId?: string;
    organizationName?: string;
    subscriptionId?: string;
    subscriptionName?: string;
    subscriptionServiceId?: string;
    subscriptionServiceName?: string;
    projectId?: string;
    projectName?: string;
    adminTags?: string[];
    hasActivePeriods?: boolean;
}

export enum GetProjectListSortField {
    Organization = 0,
    Subscription = 1,
    SubscriptionService = 2,
    Project = 3,
}

export class GetProjectListFiltersViewModel implements IGetProjectListFiltersViewModel {
    organizations?: GetProjectListFiltersOrganizationDto[];
    subscriptions?: GetProjectListFiltersSubscriptionDto[];
    subscriptionServices?: GetProjectListFiltersSubscriptionServiceDto[];
    adminTags?: GetProjectListFiltersAdminTagDto[];

    constructor(data?: IGetProjectListFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(GetProjectListFiltersOrganizationDto.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(GetProjectListFiltersSubscriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(GetProjectListFiltersSubscriptionServiceDto.fromJS(item));
            }
            if (Array.isArray(_data["adminTags"])) {
                this.adminTags = [] as any;
                for (let item of _data["adminTags"])
                    this.adminTags!.push(GetProjectListFiltersAdminTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectListFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectListFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        if (Array.isArray(this.adminTags)) {
            data["adminTags"] = [];
            for (let item of this.adminTags)
                data["adminTags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectListFiltersViewModel {
    organizations?: GetProjectListFiltersOrganizationDto[];
    subscriptions?: GetProjectListFiltersSubscriptionDto[];
    subscriptionServices?: GetProjectListFiltersSubscriptionServiceDto[];
    adminTags?: GetProjectListFiltersAdminTagDto[];
}

export class GetProjectListFiltersOrganizationDto implements IGetProjectListFiltersOrganizationDto {
    name?: string;
    organizationId?: string;

    constructor(data?: IGetProjectListFiltersOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): GetProjectListFiltersOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectListFiltersOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IGetProjectListFiltersOrganizationDto {
    name?: string;
    organizationId?: string;
}

export class GetProjectListFiltersSubscriptionDto implements IGetProjectListFiltersSubscriptionDto {
    organizationId?: string;
    subscriptionId?: string;
    name?: string;

    constructor(data?: IGetProjectListFiltersSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetProjectListFiltersSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectListFiltersSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetProjectListFiltersSubscriptionDto {
    organizationId?: string;
    subscriptionId?: string;
    name?: string;
}

export class GetProjectListFiltersSubscriptionServiceDto implements IGetProjectListFiltersSubscriptionServiceDto {
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    name?: string;

    constructor(data?: IGetProjectListFiltersSubscriptionServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetProjectListFiltersSubscriptionServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectListFiltersSubscriptionServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetProjectListFiltersSubscriptionServiceDto {
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    name?: string;
}

export class GetProjectListFiltersAdminTagDto implements IGetProjectListFiltersAdminTagDto {
    id?: string;
    text?: string;

    constructor(data?: IGetProjectListFiltersAdminTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): GetProjectListFiltersAdminTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectListFiltersAdminTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IGetProjectListFiltersAdminTagDto {
    id?: string;
    text?: string;
}

export class GetCreateProjectViewModel implements IGetCreateProjectViewModel {
    projectTypeSettings?: GetCreateProjectTypeDto[];
    availableSettings?: string[];

    constructor(data?: IGetCreateProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectTypeSettings"])) {
                this.projectTypeSettings = [] as any;
                for (let item of _data["projectTypeSettings"])
                    this.projectTypeSettings!.push(GetCreateProjectTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["availableSettings"])) {
                this.availableSettings = [] as any;
                for (let item of _data["availableSettings"])
                    this.availableSettings!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCreateProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectTypeSettings)) {
            data["projectTypeSettings"] = [];
            for (let item of this.projectTypeSettings)
                data["projectTypeSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.availableSettings)) {
            data["availableSettings"] = [];
            for (let item of this.availableSettings)
                data["availableSettings"].push(item);
        }
        return data;
    }
}

export interface IGetCreateProjectViewModel {
    projectTypeSettings?: GetCreateProjectTypeDto[];
    availableSettings?: string[];
}

export class GetCreateProjectTypeDto implements IGetCreateProjectTypeDto {
    projectType?: ProjectType;
    defaultProjectSettings?: CreateProjectSettings[];

    constructor(data?: IGetCreateProjectTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectType = _data["projectType"];
            if (Array.isArray(_data["defaultProjectSettings"])) {
                this.defaultProjectSettings = [] as any;
                for (let item of _data["defaultProjectSettings"])
                    this.defaultProjectSettings!.push(CreateProjectSettings.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreateProjectTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateProjectTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectType"] = this.projectType;
        if (Array.isArray(this.defaultProjectSettings)) {
            data["defaultProjectSettings"] = [];
            for (let item of this.defaultProjectSettings)
                data["defaultProjectSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreateProjectTypeDto {
    projectType?: ProjectType;
    defaultProjectSettings?: CreateProjectSettings[];
}

export enum ProjectType {
    Custom = 0,
    Airport = 1,
}

export class CreateProjectSettings implements ICreateProjectSettings {
    settingName?: string;
    checked?: boolean;

    constructor(data?: ICreateProjectSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingName = _data["settingName"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): CreateProjectSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingName"] = this.settingName;
        data["checked"] = this.checked;
        return data;
    }
}

export interface ICreateProjectSettings {
    settingName?: string;
    checked?: boolean;
}

export class CreateProjectDto implements ICreateProjectDto {
    name?: string;
    projectType?: ProjectType;
    settings?: CreateProjectSettings[];

    constructor(data?: ICreateProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectType = _data["projectType"];
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(CreateProjectSettings.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectType"] = this.projectType;
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateProjectDto {
    name?: string;
    projectType?: ProjectType;
    settings?: CreateProjectSettings[];
}

export class GetProjectViewModel implements IGetProjectViewModel {
    id?: string;
    project?: GetProjectDto;
    tags?: ProjectTagDto[];

    constructor(data?: IGetProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.project = _data["project"] ? GetProjectDto.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ProjectTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectViewModel {
    id?: string;
    project?: GetProjectDto;
    tags?: ProjectTagDto[];
}

export class GetProjectDto implements IGetProjectDto {
    cultures?: ProjectCultureDto[];
    projectType?: ProjectType;
    selectedTags?: ProjectTagDto[];
    target?: number | undefined;
    strictSuccessRateEnabled?: boolean;
    regularSuccessRateEnabled?: boolean;
    computedDataPeriodTypes?: PeriodStatus[];
    viewMissionConfigurationGroupsOnly?: boolean;

    constructor(data?: IGetProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(ProjectCultureDto.fromJS(item));
            }
            this.projectType = _data["projectType"];
            if (Array.isArray(_data["selectedTags"])) {
                this.selectedTags = [] as any;
                for (let item of _data["selectedTags"])
                    this.selectedTags!.push(ProjectTagDto.fromJS(item));
            }
            this.target = _data["target"];
            this.strictSuccessRateEnabled = _data["strictSuccessRateEnabled"];
            this.regularSuccessRateEnabled = _data["regularSuccessRateEnabled"];
            if (Array.isArray(_data["computedDataPeriodTypes"])) {
                this.computedDataPeriodTypes = [] as any;
                for (let item of _data["computedDataPeriodTypes"])
                    this.computedDataPeriodTypes!.push(item);
            }
            this.viewMissionConfigurationGroupsOnly = _data["viewMissionConfigurationGroupsOnly"];
        }
    }

    static fromJS(data: any): GetProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        data["projectType"] = this.projectType;
        if (Array.isArray(this.selectedTags)) {
            data["selectedTags"] = [];
            for (let item of this.selectedTags)
                data["selectedTags"].push(item.toJSON());
        }
        data["target"] = this.target;
        data["strictSuccessRateEnabled"] = this.strictSuccessRateEnabled;
        data["regularSuccessRateEnabled"] = this.regularSuccessRateEnabled;
        if (Array.isArray(this.computedDataPeriodTypes)) {
            data["computedDataPeriodTypes"] = [];
            for (let item of this.computedDataPeriodTypes)
                data["computedDataPeriodTypes"].push(item);
        }
        data["viewMissionConfigurationGroupsOnly"] = this.viewMissionConfigurationGroupsOnly;
        return data;
    }
}

export interface IGetProjectDto {
    cultures?: ProjectCultureDto[];
    projectType?: ProjectType;
    selectedTags?: ProjectTagDto[];
    target?: number | undefined;
    strictSuccessRateEnabled?: boolean;
    regularSuccessRateEnabled?: boolean;
    computedDataPeriodTypes?: PeriodStatus[];
    viewMissionConfigurationGroupsOnly?: boolean;
}

export class ProjectCultureDto implements IProjectCultureDto {
    name?: string;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: IProjectCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): ProjectCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IProjectCultureDto {
    name?: string;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class ProjectTagDto implements IProjectTagDto {
    tagId?: string | undefined;
    text?: string;

    constructor(data?: IProjectTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ProjectTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["text"] = this.text;
        return data;
    }
}

export interface IProjectTagDto {
    tagId?: string | undefined;
    text?: string;
}

export class UpdateProjectRequest implements IUpdateProjectRequest {
    cultures?: ProjectCultureDto[] | undefined;
    projectType?: ProjectType | undefined;
    selectedTags?: ProjectTagDto[] | undefined;
    target?: number | undefined;
    strictSuccessRateEnabled?: boolean | undefined;
    regularSuccessRateEnabled?: boolean | undefined;
    computedDataPeriodTypes?: PeriodStatus[] | undefined;
    viewMissionConfigurationGroupsOnly?: boolean | undefined;

    constructor(data?: IUpdateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(ProjectCultureDto.fromJS(item));
            }
            this.projectType = _data["projectType"];
            if (Array.isArray(_data["selectedTags"])) {
                this.selectedTags = [] as any;
                for (let item of _data["selectedTags"])
                    this.selectedTags!.push(ProjectTagDto.fromJS(item));
            }
            this.target = _data["target"];
            this.strictSuccessRateEnabled = _data["strictSuccessRateEnabled"];
            this.regularSuccessRateEnabled = _data["regularSuccessRateEnabled"];
            if (Array.isArray(_data["computedDataPeriodTypes"])) {
                this.computedDataPeriodTypes = [] as any;
                for (let item of _data["computedDataPeriodTypes"])
                    this.computedDataPeriodTypes!.push(item);
            }
            this.viewMissionConfigurationGroupsOnly = _data["viewMissionConfigurationGroupsOnly"];
        }
    }

    static fromJS(data: any): UpdateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        data["projectType"] = this.projectType;
        if (Array.isArray(this.selectedTags)) {
            data["selectedTags"] = [];
            for (let item of this.selectedTags)
                data["selectedTags"].push(item.toJSON());
        }
        data["target"] = this.target;
        data["strictSuccessRateEnabled"] = this.strictSuccessRateEnabled;
        data["regularSuccessRateEnabled"] = this.regularSuccessRateEnabled;
        if (Array.isArray(this.computedDataPeriodTypes)) {
            data["computedDataPeriodTypes"] = [];
            for (let item of this.computedDataPeriodTypes)
                data["computedDataPeriodTypes"].push(item);
        }
        data["viewMissionConfigurationGroupsOnly"] = this.viewMissionConfigurationGroupsOnly;
        return data;
    }
}

export interface IUpdateProjectRequest {
    cultures?: ProjectCultureDto[] | undefined;
    projectType?: ProjectType | undefined;
    selectedTags?: ProjectTagDto[] | undefined;
    target?: number | undefined;
    strictSuccessRateEnabled?: boolean | undefined;
    regularSuccessRateEnabled?: boolean | undefined;
    computedDataPeriodTypes?: PeriodStatus[] | undefined;
    viewMissionConfigurationGroupsOnly?: boolean | undefined;
}

export class GetDatePickerSequenceListViewModel implements IGetDatePickerSequenceListViewModel {
    datePickerSequences?: GetDatePickerSequenceListDto[];

    constructor(data?: IGetDatePickerSequenceListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datePickerSequences"])) {
                this.datePickerSequences = [] as any;
                for (let item of _data["datePickerSequences"])
                    this.datePickerSequences!.push(GetDatePickerSequenceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDatePickerSequenceListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatePickerSequenceListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datePickerSequences)) {
            data["datePickerSequences"] = [];
            for (let item of this.datePickerSequences)
                data["datePickerSequences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDatePickerSequenceListViewModel {
    datePickerSequences?: GetDatePickerSequenceListDto[];
}

export class GetDatePickerSequenceListDto implements IGetDatePickerSequenceListDto {
    id?: string;
    dateType?: DatePickerSequenceType;
    order?: number;
    enabled?: boolean;
    cultures?: GetDatePickerSequenceListCultureDto[];

    constructor(data?: IGetDatePickerSequenceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateType = _data["dateType"];
            this.order = _data["order"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(GetDatePickerSequenceListCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDatePickerSequenceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatePickerSequenceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateType"] = this.dateType;
        data["order"] = this.order;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDatePickerSequenceListDto {
    id?: string;
    dateType?: DatePickerSequenceType;
    order?: number;
    enabled?: boolean;
    cultures?: GetDatePickerSequenceListCultureDto[];
}

export enum DatePickerSequenceType {
    Period = 0,
    SubmittedDate = 1,
    EventDate = 2,
}

export class GetDatePickerSequenceListCultureDto implements IGetDatePickerSequenceListCultureDto {
    cultureCode?: string;
    text?: string;
    isDefault?: boolean;

    constructor(data?: IGetDatePickerSequenceListCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.text = _data["text"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): GetDatePickerSequenceListCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatePickerSequenceListCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["text"] = this.text;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IGetDatePickerSequenceListCultureDto {
    cultureCode?: string;
    text?: string;
    isDefault?: boolean;
}

export class UpdateDatePickerSequenceListRequest implements IUpdateDatePickerSequenceListRequest {
    datePickerSequences?: UpdateDatePickerSequenceListDto[];

    constructor(data?: IUpdateDatePickerSequenceListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datePickerSequences"])) {
                this.datePickerSequences = [] as any;
                for (let item of _data["datePickerSequences"])
                    this.datePickerSequences!.push(UpdateDatePickerSequenceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDatePickerSequenceListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDatePickerSequenceListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datePickerSequences)) {
            data["datePickerSequences"] = [];
            for (let item of this.datePickerSequences)
                data["datePickerSequences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateDatePickerSequenceListRequest {
    datePickerSequences?: UpdateDatePickerSequenceListDto[];
}

export class UpdateDatePickerSequenceListDto implements IUpdateDatePickerSequenceListDto {
    dateType?: DatePickerSequenceType;
    order?: number | undefined;
    enabled?: boolean | undefined;
    cultures?: UpdateDatePickerSequenceListCultureDto[];

    constructor(data?: IUpdateDatePickerSequenceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateType = _data["dateType"];
            this.order = _data["order"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(UpdateDatePickerSequenceListCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDatePickerSequenceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDatePickerSequenceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateType"] = this.dateType;
        data["order"] = this.order;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateDatePickerSequenceListDto {
    dateType?: DatePickerSequenceType;
    order?: number | undefined;
    enabled?: boolean | undefined;
    cultures?: UpdateDatePickerSequenceListCultureDto[];
}

export class UpdateDatePickerSequenceListCultureDto implements IUpdateDatePickerSequenceListCultureDto {
    cultureCode?: string;
    text?: string;
    isDefault?: boolean;

    constructor(data?: IUpdateDatePickerSequenceListCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.text = _data["text"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UpdateDatePickerSequenceListCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDatePickerSequenceListCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["text"] = this.text;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IUpdateDatePickerSequenceListCultureDto {
    cultureCode?: string;
    text?: string;
    isDefault?: boolean;
}

export class PowerPointReportQueryRequest implements IPowerPointReportQueryRequest {
    periodIds?: string[];
    currentLabel?: string;
    previousPeriodIds?: string[];
    previousLabel?: string;
    displayBranchCode?: boolean;

    constructor(data?: IPowerPointReportQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["periodIds"])) {
                this.periodIds = [] as any;
                for (let item of _data["periodIds"])
                    this.periodIds!.push(item);
            }
            this.currentLabel = _data["currentLabel"];
            if (Array.isArray(_data["previousPeriodIds"])) {
                this.previousPeriodIds = [] as any;
                for (let item of _data["previousPeriodIds"])
                    this.previousPeriodIds!.push(item);
            }
            this.previousLabel = _data["previousLabel"];
            this.displayBranchCode = _data["displayBranchCode"];
        }
    }

    static fromJS(data: any): PowerPointReportQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PowerPointReportQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.periodIds)) {
            data["periodIds"] = [];
            for (let item of this.periodIds)
                data["periodIds"].push(item);
        }
        data["currentLabel"] = this.currentLabel;
        if (Array.isArray(this.previousPeriodIds)) {
            data["previousPeriodIds"] = [];
            for (let item of this.previousPeriodIds)
                data["previousPeriodIds"].push(item);
        }
        data["previousLabel"] = this.previousLabel;
        data["displayBranchCode"] = this.displayBranchCode;
        return data;
    }
}

export interface IPowerPointReportQueryRequest {
    periodIds?: string[];
    currentLabel?: string;
    previousPeriodIds?: string[];
    previousLabel?: string;
    displayBranchCode?: boolean;
}

export class GetSectionListViewModel implements IGetSectionListViewModel {
    sections?: GetSectionListSectionDto[];

    constructor(data?: IGetSectionListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(GetSectionListSectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSectionListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSectionListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSectionListViewModel {
    sections?: GetSectionListSectionDto[];
}

export class GetSectionListSectionDto implements IGetSectionListSectionDto {
    id?: string;
    name?: string;
    shortName?: string | undefined;
    code?: string;
    order?: number;

    constructor(data?: IGetSectionListSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): GetSectionListSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSectionListSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        data["order"] = this.order;
        return data;
    }
}

export interface IGetSectionListSectionDto {
    id?: string;
    name?: string;
    shortName?: string | undefined;
    code?: string;
    order?: number;
}

export class GetSectionViewModel implements IGetSectionViewModel {
    id?: string;
    section?: GetSectionDto;

    constructor(data?: IGetSectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.section = _data["section"] ? GetSectionDto.fromJS(_data["section"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["section"] = this.section ? this.section.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSectionViewModel {
    id?: string;
    section?: GetSectionDto;
}

export class GetSectionDto implements IGetSectionDto {
    cultures?: SectionCultureDto[];
    code?: string;
    order?: number;

    constructor(data?: IGetSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SectionCultureDto.fromJS(item));
            }
            this.code = _data["code"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): GetSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["order"] = this.order;
        return data;
    }
}

export interface IGetSectionDto {
    cultures?: SectionCultureDto[];
    code?: string;
    order?: number;
}

export class SectionCultureDto implements ISectionCultureDto {
    name?: string;
    shortName?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: ISectionCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): SectionCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface ISectionCultureDto {
    name?: string;
    shortName?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class CreateSectionViewModel implements ICreateSectionViewModel {
    sectionId?: string;

    constructor(data?: ICreateSectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
        }
    }

    static fromJS(data: any): CreateSectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        return data;
    }
}

export interface ICreateSectionViewModel {
    sectionId?: string;
}

export class CreateSectionDto implements ICreateSectionDto {
    code?: string;
    name?: string;
    shortName?: string | undefined;
    order?: number | undefined;

    constructor(data?: ICreateSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): CreateSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["order"] = this.order;
        return data;
    }
}

export interface ICreateSectionDto {
    code?: string;
    name?: string;
    shortName?: string | undefined;
    order?: number | undefined;
}

export class UpdateSectionRequest implements IUpdateSectionRequest {
    cultures?: SectionCultureDto[];
    code?: string;
    order?: number;

    constructor(data?: IUpdateSectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SectionCultureDto.fromJS(item));
            }
            this.code = _data["code"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateSectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateSectionRequest {
    cultures?: SectionCultureDto[];
    code?: string;
    order?: number;
}

export class GenreAndAgeProportionViewModel implements IGenreAndAgeProportionViewModel {
    ageData?: AgeProportionDto;
    genderData?: GenreProportionDto;

    constructor(data?: IGenreAndAgeProportionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ageData = _data["ageData"] ? AgeProportionDto.fromJS(_data["ageData"]) : <any>undefined;
            this.genderData = _data["genderData"] ? GenreProportionDto.fromJS(_data["genderData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GenreAndAgeProportionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenreAndAgeProportionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ageData"] = this.ageData ? this.ageData.toJSON() : <any>undefined;
        data["genderData"] = this.genderData ? this.genderData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGenreAndAgeProportionViewModel {
    ageData?: AgeProportionDto;
    genderData?: GenreProportionDto;
}

export class AgeProportionDto implements IAgeProportionDto {
    ageGroups?: AgeGroupDto[];

    constructor(data?: IAgeProportionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ageGroups"])) {
                this.ageGroups = [] as any;
                for (let item of _data["ageGroups"])
                    this.ageGroups!.push(AgeGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgeProportionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgeProportionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ageGroups)) {
            data["ageGroups"] = [];
            for (let item of this.ageGroups)
                data["ageGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgeProportionDto {
    ageGroups?: AgeGroupDto[];
}

export class AgeGroupDto implements IAgeGroupDto {
    label?: string;
    value?: number;

    constructor(data?: IAgeGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AgeGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgeGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IAgeGroupDto {
    label?: string;
    value?: number;
}

export class GenreProportionDto implements IGenreProportionDto {
    middleValue?: string;
    series?: SeriesDto[];

    constructor(data?: IGenreProportionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.middleValue = _data["middleValue"];
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(SeriesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenreProportionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenreProportionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["middleValue"] = this.middleValue;
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGenreProportionDto {
    middleValue?: string;
    series?: SeriesDto[];
}

export class SeriesDto implements ISeriesDto {
    key?: string;
    value?: number;
    label?: string;

    constructor(data?: ISeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): SeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface ISeriesDto {
    key?: string;
    value?: number;
    label?: string;
}

export class GenreByAgeViewModel implements IGenreByAgeViewModel {
    genreByAgeData?: GenreByAgeDataDto | undefined;

    constructor(data?: IGenreByAgeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.genreByAgeData = _data["genreByAgeData"] ? GenreByAgeDataDto.fromJS(_data["genreByAgeData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GenreByAgeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenreByAgeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["genreByAgeData"] = this.genreByAgeData ? this.genreByAgeData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGenreByAgeViewModel {
    genreByAgeData?: GenreByAgeDataDto | undefined;
}

export class GenreByAgeDataDto implements IGenreByAgeDataDto {
    entries?: EntryDto[] | undefined;
    seriesColors?: SeriesColorsDto | undefined;
    valueProperties?: string[] | undefined;

    constructor(data?: IGenreByAgeDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(EntryDto.fromJS(item));
            }
            this.seriesColors = _data["seriesColors"] ? SeriesColorsDto.fromJS(_data["seriesColors"]) : <any>undefined;
            if (Array.isArray(_data["valueProperties"])) {
                this.valueProperties = [] as any;
                for (let item of _data["valueProperties"])
                    this.valueProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): GenreByAgeDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenreByAgeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        data["seriesColors"] = this.seriesColors ? this.seriesColors.toJSON() : <any>undefined;
        if (Array.isArray(this.valueProperties)) {
            data["valueProperties"] = [];
            for (let item of this.valueProperties)
                data["valueProperties"].push(item);
        }
        return data;
    }
}

export interface IGenreByAgeDataDto {
    entries?: EntryDto[] | undefined;
    seriesColors?: SeriesColorsDto | undefined;
    valueProperties?: string[] | undefined;
}

export class EntryDto implements IEntryDto {
    name?: string | undefined;
    label?: string | undefined;
    female?: number;
    male?: number;
    unknown?: number;

    constructor(data?: IEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"];
            this.female = _data["female"];
            this.male = _data["male"];
            this.unknown = _data["unknown"];
        }
    }

    static fromJS(data: any): EntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label;
        data["female"] = this.female;
        data["male"] = this.male;
        data["unknown"] = this.unknown;
        return data;
    }
}

export interface IEntryDto {
    name?: string | undefined;
    label?: string | undefined;
    female?: number;
    male?: number;
    unknown?: number;
}

export class SeriesColorsDto implements ISeriesColorsDto {
    female?: string | undefined;
    male?: string | undefined;
    unknown?: string | undefined;

    constructor(data?: ISeriesColorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.female = _data["female"];
            this.male = _data["male"];
            this.unknown = _data["unknown"];
        }
    }

    static fromJS(data: any): SeriesColorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesColorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["female"] = this.female;
        data["male"] = this.male;
        data["unknown"] = this.unknown;
        return data;
    }
}

export interface ISeriesColorsDto {
    female?: string | undefined;
    male?: string | undefined;
    unknown?: string | undefined;
}

export class EducationalLevelViewModel implements IEducationalLevelViewModel {
    widgetName?: string;
    educationData?: EducationalLevelDto | undefined;

    constructor(data?: IEducationalLevelViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetName = _data["widgetName"];
            this.educationData = _data["educationData"] ? EducationalLevelDto.fromJS(_data["educationData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EducationalLevelViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalLevelViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetName"] = this.widgetName;
        data["educationData"] = this.educationData ? this.educationData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEducationalLevelViewModel {
    widgetName?: string;
    educationData?: EducationalLevelDto | undefined;
}

export class EducationalLevelDto implements IEducationalLevelDto {
    educationGroups?: EducationalCategoryInfoDto[];

    constructor(data?: IEducationalLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["educationGroups"])) {
                this.educationGroups = [] as any;
                for (let item of _data["educationGroups"])
                    this.educationGroups!.push(EducationalCategoryInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EducationalLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.educationGroups)) {
            data["educationGroups"] = [];
            for (let item of this.educationGroups)
                data["educationGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEducationalLevelDto {
    educationGroups?: EducationalCategoryInfoDto[];
}

export class EducationalCategoryInfoDto implements IEducationalCategoryInfoDto {
    label?: string;
    value?: number;

    constructor(data?: IEducationalCategoryInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EducationalCategoryInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalCategoryInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IEducationalCategoryInfoDto {
    label?: string;
    value?: number;
}

export class AccessToCarViewModel implements IAccessToCarViewModel {
    widgetName?: string;
    data?: AccessToCarDto | undefined;

    constructor(data?: IAccessToCarViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetName = _data["widgetName"];
            this.data = _data["data"] ? AccessToCarDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccessToCarViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessToCarViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetName"] = this.widgetName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccessToCarViewModel {
    widgetName?: string;
    data?: AccessToCarDto | undefined;
}

export class AccessToCarDto implements IAccessToCarDto {
    middleValue?: string;
    series?: SeriesDto2[];

    constructor(data?: IAccessToCarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.middleValue = _data["middleValue"];
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(SeriesDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccessToCarDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessToCarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["middleValue"] = this.middleValue;
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccessToCarDto {
    middleValue?: string;
    series?: SeriesDto2[];
}

export class SeriesDto2 implements ISeriesDto2 {
    key?: string;
    value?: number;

    constructor(data?: ISeriesDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SeriesDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ISeriesDto2 {
    key?: string;
    value?: number;
}

export class ProvinceOfResidenceViewModel implements IProvinceOfResidenceViewModel {
    widgetName?: string;
    provinceOfResidence?: ProvinceOfResidenceDto | undefined;

    constructor(data?: IProvinceOfResidenceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetName = _data["widgetName"];
            this.provinceOfResidence = _data["provinceOfResidence"] ? ProvinceOfResidenceDto.fromJS(_data["provinceOfResidence"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProvinceOfResidenceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceOfResidenceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetName"] = this.widgetName;
        data["provinceOfResidence"] = this.provinceOfResidence ? this.provinceOfResidence.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProvinceOfResidenceViewModel {
    widgetName?: string;
    provinceOfResidence?: ProvinceOfResidenceDto | undefined;
}

export class ProvinceOfResidenceDto implements IProvinceOfResidenceDto {
    contactsPerProvince?: PerProvinceInfoDto[];

    constructor(data?: IProvinceOfResidenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contactsPerProvince"])) {
                this.contactsPerProvince = [] as any;
                for (let item of _data["contactsPerProvince"])
                    this.contactsPerProvince!.push(PerProvinceInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProvinceOfResidenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceOfResidenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contactsPerProvince)) {
            data["contactsPerProvince"] = [];
            for (let item of this.contactsPerProvince)
                data["contactsPerProvince"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProvinceOfResidenceDto {
    contactsPerProvince?: PerProvinceInfoDto[];
}

export class PerProvinceInfoDto implements IPerProvinceInfoDto {
    label?: string;
    value?: number;

    constructor(data?: IPerProvinceInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PerProvinceInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerProvinceInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IPerProvinceInfoDto {
    label?: string;
    value?: number;
}

export class ContactLanguageViewModel implements IContactLanguageViewModel {
    widgetName?: string;
    data?: ContactLanguageDto;

    constructor(data?: IContactLanguageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetName = _data["widgetName"];
            this.data = _data["data"] ? ContactLanguageDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactLanguageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactLanguageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetName"] = this.widgetName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactLanguageViewModel {
    widgetName?: string;
    data?: ContactLanguageDto;
}

export class ContactLanguageDto implements IContactLanguageDto {
    middleValue?: string;
    series?: SeriesDto3[];

    constructor(data?: IContactLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.middleValue = _data["middleValue"];
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(SeriesDto3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContactLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["middleValue"] = this.middleValue;
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContactLanguageDto {
    middleValue?: string;
    series?: SeriesDto3[];
}

export class SeriesDto3 implements ISeriesDto3 {
    key?: string;
    value?: number;

    constructor(data?: ISeriesDto3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SeriesDto3 {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesDto3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ISeriesDto3 {
    key?: string;
    value?: number;
}

export class ActiveMembersPerRegionViewModel implements IActiveMembersPerRegionViewModel {
    data?: ActiveMembersPerRegionDto[] | undefined;

    constructor(data?: IActiveMembersPerRegionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ActiveMembersPerRegionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveMembersPerRegionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveMembersPerRegionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActiveMembersPerRegionViewModel {
    data?: ActiveMembersPerRegionDto[] | undefined;
}

export class ActiveMembersPerRegionDto implements IActiveMembersPerRegionDto {
    label?: string;
    name?: string;
    value?: number;

    constructor(data?: IActiveMembersPerRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ActiveMembersPerRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveMembersPerRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IActiveMembersPerRegionDto {
    label?: string;
    name?: string;
    value?: number;
}

export class GetMissionRealizationFilter implements IGetMissionRealizationFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IGetMissionRealizationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMissionRealizationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionRealizationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetMissionRealizationFilter {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class CompletedMissionsPerRegionViewModel implements ICompletedMissionsPerRegionViewModel {
    completedMissionsGenreAndRegion?: CompletedMissionsGenreAndRegionDto | undefined;

    constructor(data?: ICompletedMissionsPerRegionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedMissionsGenreAndRegion = _data["completedMissionsGenreAndRegion"] ? CompletedMissionsGenreAndRegionDto.fromJS(_data["completedMissionsGenreAndRegion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompletedMissionsPerRegionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompletedMissionsPerRegionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedMissionsGenreAndRegion"] = this.completedMissionsGenreAndRegion ? this.completedMissionsGenreAndRegion.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompletedMissionsPerRegionViewModel {
    completedMissionsGenreAndRegion?: CompletedMissionsGenreAndRegionDto | undefined;
}

export class CompletedMissionsGenreAndRegionDto implements ICompletedMissionsGenreAndRegionDto {
    entries?: EntryDto2[] | undefined;
    seriesColors?: SeriesColorsDto2 | undefined;
    valueProperties?: string[] | undefined;
    total?: number;

    constructor(data?: ICompletedMissionsGenreAndRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(EntryDto2.fromJS(item));
            }
            this.seriesColors = _data["seriesColors"] ? SeriesColorsDto2.fromJS(_data["seriesColors"]) : <any>undefined;
            if (Array.isArray(_data["valueProperties"])) {
                this.valueProperties = [] as any;
                for (let item of _data["valueProperties"])
                    this.valueProperties!.push(item);
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): CompletedMissionsGenreAndRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompletedMissionsGenreAndRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        data["seriesColors"] = this.seriesColors ? this.seriesColors.toJSON() : <any>undefined;
        if (Array.isArray(this.valueProperties)) {
            data["valueProperties"] = [];
            for (let item of this.valueProperties)
                data["valueProperties"].push(item);
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ICompletedMissionsGenreAndRegionDto {
    entries?: EntryDto2[] | undefined;
    seriesColors?: SeriesColorsDto2 | undefined;
    valueProperties?: string[] | undefined;
    total?: number;
}

export class EntryDto2 implements IEntryDto2 {
    name?: string | undefined;
    label?: string | undefined;
    female?: number;
    male?: number;

    constructor(data?: IEntryDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"];
            this.female = _data["female"];
            this.male = _data["male"];
        }
    }

    static fromJS(data: any): EntryDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new EntryDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label;
        data["female"] = this.female;
        data["male"] = this.male;
        return data;
    }
}

export interface IEntryDto2 {
    name?: string | undefined;
    label?: string | undefined;
    female?: number;
    male?: number;
}

export class SeriesColorsDto2 implements ISeriesColorsDto2 {
    female?: string | undefined;
    male?: string | undefined;
    unknown?: string | undefined;

    constructor(data?: ISeriesColorsDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.female = _data["female"];
            this.male = _data["male"];
            this.unknown = _data["unknown"];
        }
    }

    static fromJS(data: any): SeriesColorsDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new SeriesColorsDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["female"] = this.female;
        data["male"] = this.male;
        data["unknown"] = this.unknown;
        return data;
    }
}

export interface ISeriesColorsDto2 {
    female?: string | undefined;
    male?: string | undefined;
    unknown?: string | undefined;
}

export class MembersByStatusViewModel implements IMembersByStatusViewModel {
    widgetName?: string;
    data?: MembersByStatusDto | undefined;

    constructor(data?: IMembersByStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetName = _data["widgetName"];
            this.data = _data["data"] ? MembersByStatusDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MembersByStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MembersByStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetName"] = this.widgetName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMembersByStatusViewModel {
    widgetName?: string;
    data?: MembersByStatusDto | undefined;
}

export class MembersByStatusDto implements IMembersByStatusDto {
    membersByStatus?: MembersByStatusInfo[] | undefined;
    total?: number;

    constructor(data?: IMembersByStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["membersByStatus"])) {
                this.membersByStatus = [] as any;
                for (let item of _data["membersByStatus"])
                    this.membersByStatus!.push(MembersByStatusInfo.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): MembersByStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new MembersByStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.membersByStatus)) {
            data["membersByStatus"] = [];
            for (let item of this.membersByStatus)
                data["membersByStatus"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IMembersByStatusDto {
    membersByStatus?: MembersByStatusInfo[] | undefined;
    total?: number;
}

export class MembersByStatusInfo implements IMembersByStatusInfo {
    label?: string;
    value?: number;

    constructor(data?: IMembersByStatusInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MembersByStatusInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MembersByStatusInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IMembersByStatusInfo {
    label?: string;
    value?: number;
}

export class ActiveMembersPerYearViewModel implements IActiveMembersPerYearViewModel {
    name?: string | undefined;
    data?: ActiveMembersPerYearDto | undefined;

    constructor(data?: IActiveMembersPerYearViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.data = _data["data"] ? ActiveMembersPerYearDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActiveMembersPerYearViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveMembersPerYearViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActiveMembersPerYearViewModel {
    name?: string | undefined;
    data?: ActiveMembersPerYearDto | undefined;
}

export class ActiveMembersPerYearDto implements IActiveMembersPerYearDto {
    activeMembersPerYear?: ActiveMembersPerYearSeries[] | undefined;

    constructor(data?: IActiveMembersPerYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activeMembersPerYear"])) {
                this.activeMembersPerYear = [] as any;
                for (let item of _data["activeMembersPerYear"])
                    this.activeMembersPerYear!.push(ActiveMembersPerYearSeries.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveMembersPerYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveMembersPerYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeMembersPerYear)) {
            data["activeMembersPerYear"] = [];
            for (let item of this.activeMembersPerYear)
                data["activeMembersPerYear"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActiveMembersPerYearDto {
    activeMembersPerYear?: ActiveMembersPerYearSeries[] | undefined;
}

export class ActiveMembersPerYearSeries implements IActiveMembersPerYearSeries {
    values?: ActiveMembersPerYearInfo[] | undefined;

    constructor(data?: IActiveMembersPerYearSeries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ActiveMembersPerYearInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveMembersPerYearSeries {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveMembersPerYearSeries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActiveMembersPerYearSeries {
    values?: ActiveMembersPerYearInfo[] | undefined;
}

export class ActiveMembersPerYearInfo implements IActiveMembersPerYearInfo {
    label?: string;
    value?: number;

    constructor(data?: IActiveMembersPerYearInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ActiveMembersPerYearInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveMembersPerYearInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IActiveMembersPerYearInfo {
    label?: string;
    value?: number;
}

export class MissionRealizationViewModel implements IMissionRealizationViewModel {
    widgetName?: string;
    missionStatus?: MissionRealizationDto | undefined;

    constructor(data?: IMissionRealizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetName = _data["widgetName"];
            this.missionStatus = _data["missionStatus"] ? MissionRealizationDto.fromJS(_data["missionStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MissionRealizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissionRealizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetName"] = this.widgetName;
        data["missionStatus"] = this.missionStatus ? this.missionStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMissionRealizationViewModel {
    widgetName?: string;
    missionStatus?: MissionRealizationDto | undefined;
}

export class MissionRealizationDto implements IMissionRealizationDto {
    series?: MissionsByStatusInfo[] | undefined;
    middleValue?: string | undefined;

    constructor(data?: IMissionRealizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(MissionsByStatusInfo.fromJS(item));
            }
            this.middleValue = _data["middleValue"];
        }
    }

    static fromJS(data: any): MissionRealizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionRealizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        data["middleValue"] = this.middleValue;
        return data;
    }
}

export interface IMissionRealizationDto {
    series?: MissionsByStatusInfo[] | undefined;
    middleValue?: string | undefined;
}

export class MissionsByStatusInfo implements IMissionsByStatusInfo {
    key?: string;
    label?: string | undefined;
    value?: number | undefined;
    color?: string | undefined;

    constructor(data?: IMissionsByStatusInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.value = _data["value"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): MissionsByStatusInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MissionsByStatusInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["value"] = this.value;
        data["color"] = this.color;
        return data;
    }
}

export interface IMissionsByStatusInfo {
    key?: string;
    label?: string | undefined;
    value?: number | undefined;
    color?: string | undefined;
}

export class LoginAndCompleteMissionViewModel implements ILoginAndCompleteMissionViewModel {
    widgetName?: string;
    data?: LoginAndCompleteMissionDto | undefined;

    constructor(data?: ILoginAndCompleteMissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetName = _data["widgetName"];
            this.data = _data["data"] ? LoginAndCompleteMissionDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginAndCompleteMissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginAndCompleteMissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetName"] = this.widgetName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginAndCompleteMissionViewModel {
    widgetName?: string;
    data?: LoginAndCompleteMissionDto | undefined;
}

export class LoginAndCompleteMissionDto implements ILoginAndCompleteMissionDto {
    msDoneMissionsCountPerYear?: IdleAndActiveShoppersPerYear[] | undefined;

    constructor(data?: ILoginAndCompleteMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["msDoneMissionsCountPerYear"])) {
                this.msDoneMissionsCountPerYear = [] as any;
                for (let item of _data["msDoneMissionsCountPerYear"])
                    this.msDoneMissionsCountPerYear!.push(IdleAndActiveShoppersPerYear.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoginAndCompleteMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginAndCompleteMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.msDoneMissionsCountPerYear)) {
            data["msDoneMissionsCountPerYear"] = [];
            for (let item of this.msDoneMissionsCountPerYear)
                data["msDoneMissionsCountPerYear"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILoginAndCompleteMissionDto {
    msDoneMissionsCountPerYear?: IdleAndActiveShoppersPerYear[] | undefined;
}

export class IdleAndActiveShoppersPerYear implements IIdleAndActiveShoppersPerYear {
    label?: string;
    value?: number;

    constructor(data?: IIdleAndActiveShoppersPerYear) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): IdleAndActiveShoppersPerYear {
        data = typeof data === 'object' ? data : {};
        let result = new IdleAndActiveShoppersPerYear();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IIdleAndActiveShoppersPerYear {
    label?: string;
    value?: number;
}

export class SubscribersThatDontDoneMissionsViewModel implements ISubscribersThatDontDoneMissionsViewModel {
    name?: string | undefined;
    data?: SlackingSubscribersDto | undefined;

    constructor(data?: ISubscribersThatDontDoneMissionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.data = _data["data"] ? SlackingSubscribersDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscribersThatDontDoneMissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribersThatDontDoneMissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubscribersThatDontDoneMissionsViewModel {
    name?: string | undefined;
    data?: SlackingSubscribersDto | undefined;
}

export class SlackingSubscribersDto implements ISlackingSubscribersDto {
    slackingSubscribersPerYear?: SlackingSubscribersPerYearSeries[] | undefined;

    constructor(data?: ISlackingSubscribersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["slackingSubscribersPerYear"])) {
                this.slackingSubscribersPerYear = [] as any;
                for (let item of _data["slackingSubscribersPerYear"])
                    this.slackingSubscribersPerYear!.push(SlackingSubscribersPerYearSeries.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlackingSubscribersDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlackingSubscribersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slackingSubscribersPerYear)) {
            data["slackingSubscribersPerYear"] = [];
            for (let item of this.slackingSubscribersPerYear)
                data["slackingSubscribersPerYear"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISlackingSubscribersDto {
    slackingSubscribersPerYear?: SlackingSubscribersPerYearSeries[] | undefined;
}

export class SlackingSubscribersPerYearSeries implements ISlackingSubscribersPerYearSeries {
    values?: SlackingSubscribersPerYear[] | undefined;

    constructor(data?: ISlackingSubscribersPerYearSeries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(SlackingSubscribersPerYear.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlackingSubscribersPerYearSeries {
        data = typeof data === 'object' ? data : {};
        let result = new SlackingSubscribersPerYearSeries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISlackingSubscribersPerYearSeries {
    values?: SlackingSubscribersPerYear[] | undefined;
}

export class SlackingSubscribersPerYear implements ISlackingSubscribersPerYear {
    label?: string;
    value?: number;

    constructor(data?: ISlackingSubscribersPerYear) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SlackingSubscribersPerYear {
        data = typeof data === 'object' ? data : {};
        let result = new SlackingSubscribersPerYear();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ISlackingSubscribersPerYear {
    label?: string;
    value?: number;
}

export class CummulativeMembersCountViewModel implements ICummulativeMembersCountViewModel {
    data?: CummulativeMembersCountDto | undefined;
    widgetName?: string;

    constructor(data?: ICummulativeMembersCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CummulativeMembersCountDto.fromJS(_data["data"]) : <any>undefined;
            this.widgetName = _data["widgetName"];
        }
    }

    static fromJS(data: any): CummulativeMembersCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CummulativeMembersCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["widgetName"] = this.widgetName;
        return data;
    }
}

export interface ICummulativeMembersCountViewModel {
    data?: CummulativeMembersCountDto | undefined;
    widgetName?: string;
}

export class CummulativeMembersCountDto implements ICummulativeMembersCountDto {
    cumulativeMembersData?: CumulativeMembersPerYearInfo[] | undefined;

    constructor(data?: ICummulativeMembersCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cumulativeMembersData"])) {
                this.cumulativeMembersData = [] as any;
                for (let item of _data["cumulativeMembersData"])
                    this.cumulativeMembersData!.push(CumulativeMembersPerYearInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CummulativeMembersCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CummulativeMembersCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cumulativeMembersData)) {
            data["cumulativeMembersData"] = [];
            for (let item of this.cumulativeMembersData)
                data["cumulativeMembersData"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICummulativeMembersCountDto {
    cumulativeMembersData?: CumulativeMembersPerYearInfo[] | undefined;
}

export class CumulativeMembersPerYearInfo implements ICumulativeMembersPerYearInfo {
    year?: number;
    subscribersWithoutMissions?: number;
    subscribersWithoutMissionsPercentage?: number;
    subscribersWithMissionsCumulative?: number;
    subscribersWithMissionsCumulativePercentage?: number;

    constructor(data?: ICumulativeMembersPerYearInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.subscribersWithoutMissions = _data["subscribersWithoutMissions"];
            this.subscribersWithoutMissionsPercentage = _data["subscribersWithoutMissionsPercentage"];
            this.subscribersWithMissionsCumulative = _data["subscribersWithMissionsCumulative"];
            this.subscribersWithMissionsCumulativePercentage = _data["subscribersWithMissionsCumulativePercentage"];
        }
    }

    static fromJS(data: any): CumulativeMembersPerYearInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CumulativeMembersPerYearInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["subscribersWithoutMissions"] = this.subscribersWithoutMissions;
        data["subscribersWithoutMissionsPercentage"] = this.subscribersWithoutMissionsPercentage;
        data["subscribersWithMissionsCumulative"] = this.subscribersWithMissionsCumulative;
        data["subscribersWithMissionsCumulativePercentage"] = this.subscribersWithMissionsCumulativePercentage;
        return data;
    }
}

export interface ICumulativeMembersPerYearInfo {
    year?: number;
    subscribersWithoutMissions?: number;
    subscribersWithoutMissionsPercentage?: number;
    subscribersWithMissionsCumulative?: number;
    subscribersWithMissionsCumulativePercentage?: number;
}

export class MedianNumberOfCompleteMissionsViewModel implements IMedianNumberOfCompleteMissionsViewModel {
    widgetName?: string;
    data?: MedianNumberOfCompleteMissionsDto | undefined;

    constructor(data?: IMedianNumberOfCompleteMissionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetName = _data["widgetName"];
            this.data = _data["data"] ? MedianNumberOfCompleteMissionsDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MedianNumberOfCompleteMissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedianNumberOfCompleteMissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetName"] = this.widgetName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMedianNumberOfCompleteMissionsViewModel {
    widgetName?: string;
    data?: MedianNumberOfCompleteMissionsDto | undefined;
}

export class MedianNumberOfCompleteMissionsDto implements IMedianNumberOfCompleteMissionsDto {
    missions?: MedianAndAveragePerYear[] | undefined;

    constructor(data?: IMedianNumberOfCompleteMissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missions"])) {
                this.missions = [] as any;
                for (let item of _data["missions"])
                    this.missions!.push(MedianAndAveragePerYear.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedianNumberOfCompleteMissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedianNumberOfCompleteMissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missions)) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMedianNumberOfCompleteMissionsDto {
    missions?: MedianAndAveragePerYear[] | undefined;
}

export class MedianAndAveragePerYear implements IMedianAndAveragePerYear {
    year?: number;
    median?: number;
    average?: number;

    constructor(data?: IMedianAndAveragePerYear) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.median = _data["median"];
            this.average = _data["average"];
        }
    }

    static fromJS(data: any): MedianAndAveragePerYear {
        data = typeof data === 'object' ? data : {};
        let result = new MedianAndAveragePerYear();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["median"] = this.median;
        data["average"] = this.average;
        return data;
    }
}

export interface IMedianAndAveragePerYear {
    year?: number;
    median?: number;
    average?: number;
}

export class MembersByNumberOfCompleteMissionsViewModel implements IMembersByNumberOfCompleteMissionsViewModel {
    widgetName?: string;
    data?: MembersByNumberOfCompleteMissionsDto | undefined;

    constructor(data?: IMembersByNumberOfCompleteMissionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetName = _data["widgetName"];
            this.data = _data["data"] ? MembersByNumberOfCompleteMissionsDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MembersByNumberOfCompleteMissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MembersByNumberOfCompleteMissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetName"] = this.widgetName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMembersByNumberOfCompleteMissionsViewModel {
    widgetName?: string;
    data?: MembersByNumberOfCompleteMissionsDto | undefined;
}

export class MembersByNumberOfCompleteMissionsDto implements IMembersByNumberOfCompleteMissionsDto {
    totalMSCount?: number;
    membersByCompleteMissions?: MembersByCompleteMissions[] | undefined;

    constructor(data?: IMembersByNumberOfCompleteMissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalMSCount = _data["totalMSCount"];
            if (Array.isArray(_data["membersByCompleteMissions"])) {
                this.membersByCompleteMissions = [] as any;
                for (let item of _data["membersByCompleteMissions"])
                    this.membersByCompleteMissions!.push(MembersByCompleteMissions.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MembersByNumberOfCompleteMissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MembersByNumberOfCompleteMissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalMSCount"] = this.totalMSCount;
        if (Array.isArray(this.membersByCompleteMissions)) {
            data["membersByCompleteMissions"] = [];
            for (let item of this.membersByCompleteMissions)
                data["membersByCompleteMissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMembersByNumberOfCompleteMissionsDto {
    totalMSCount?: number;
    membersByCompleteMissions?: MembersByCompleteMissions[] | undefined;
}

export class MembersByCompleteMissions implements IMembersByCompleteMissions {
    completedMissionsCount?: number;
    numberOfMembers?: number;

    constructor(data?: IMembersByCompleteMissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedMissionsCount = _data["completedMissionsCount"];
            this.numberOfMembers = _data["numberOfMembers"];
        }
    }

    static fromJS(data: any): MembersByCompleteMissions {
        data = typeof data === 'object' ? data : {};
        let result = new MembersByCompleteMissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedMissionsCount"] = this.completedMissionsCount;
        data["numberOfMembers"] = this.numberOfMembers;
        return data;
    }
}

export interface IMembersByCompleteMissions {
    completedMissionsCount?: number;
    numberOfMembers?: number;
}

export class MembersWithCompleteMissionsViewModel implements IMembersWithCompleteMissionsViewModel {
    widgetName?: string;
    data?: MembersWithCompleteMissionsDto | undefined;

    constructor(data?: IMembersWithCompleteMissionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetName = _data["widgetName"];
            this.data = _data["data"] ? MembersWithCompleteMissionsDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MembersWithCompleteMissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MembersWithCompleteMissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetName"] = this.widgetName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMembersWithCompleteMissionsViewModel {
    widgetName?: string;
    data?: MembersWithCompleteMissionsDto | undefined;
}

export class MembersWithCompleteMissionsDto implements IMembersWithCompleteMissionsDto {
    totalMemberCount?: number;
    membersPerYear?: MembersWithCompleteMissionsPerYear[] | undefined;

    constructor(data?: IMembersWithCompleteMissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalMemberCount = _data["totalMemberCount"];
            if (Array.isArray(_data["membersPerYear"])) {
                this.membersPerYear = [] as any;
                for (let item of _data["membersPerYear"])
                    this.membersPerYear!.push(MembersWithCompleteMissionsPerYear.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MembersWithCompleteMissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MembersWithCompleteMissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalMemberCount"] = this.totalMemberCount;
        if (Array.isArray(this.membersPerYear)) {
            data["membersPerYear"] = [];
            for (let item of this.membersPerYear)
                data["membersPerYear"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMembersWithCompleteMissionsDto {
    totalMemberCount?: number;
    membersPerYear?: MembersWithCompleteMissionsPerYear[] | undefined;
}

export class MembersWithCompleteMissionsPerYear implements IMembersWithCompleteMissionsPerYear {
    year?: number;
    percentageOfTotalMembers?: number;

    constructor(data?: IMembersWithCompleteMissionsPerYear) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.percentageOfTotalMembers = _data["percentageOfTotalMembers"];
        }
    }

    static fromJS(data: any): MembersWithCompleteMissionsPerYear {
        data = typeof data === 'object' ? data : {};
        let result = new MembersWithCompleteMissionsPerYear();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["percentageOfTotalMembers"] = this.percentageOfTotalMembers;
        return data;
    }
}

export interface IMembersWithCompleteMissionsPerYear {
    year?: number;
    percentageOfTotalMembers?: number;
}

export class GetTagsViewModel implements IGetTagsViewModel {
    tags?: GetTagsTagDto[];

    constructor(data?: IGetTagsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetTagsTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTagsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTagsViewModel {
    tags?: GetTagsTagDto[];
}

export class GetTagsTagDto implements IGetTagsTagDto {
    id?: string;
    text?: string;

    constructor(data?: IGetTagsTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): GetTagsTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagsTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IGetTagsTagDto {
    id?: string;
    text?: string;
}

export enum TagOrderType {
    Order = 0,
    Ascending = 1,
    Descending = 2,
}

export class GetCreateTagViewModel implements IGetCreateTagViewModel {
    cultures?: GeneralCultureDto[];

    constructor(data?: IGetCreateTagViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(GeneralCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreateTagViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateTagViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreateTagViewModel {
    cultures?: GeneralCultureDto[];
}

export class GeneralCultureDto implements IGeneralCultureDto {
    name?: string;
    cultureCode?: string;

    constructor(data?: IGeneralCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): GeneralCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IGeneralCultureDto {
    name?: string;
    cultureCode?: string;
}

export class GetTagViewModel implements IGetTagViewModel {
    tag?: TagDto;
    generalCultures?: GeneralCultureDto[];

    constructor(data?: IGetTagViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"] ? TagDto.fromJS(_data["tag"]) : <any>undefined;
            if (Array.isArray(_data["generalCultures"])) {
                this.generalCultures = [] as any;
                for (let item of _data["generalCultures"])
                    this.generalCultures!.push(GeneralCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTagViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        if (Array.isArray(this.generalCultures)) {
            data["generalCultures"] = [];
            for (let item of this.generalCultures)
                data["generalCultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTagViewModel {
    tag?: TagDto;
    generalCultures?: GeneralCultureDto[];
}

export class TagDto implements ITagDto {
    text?: string;
    order?: number;
    svgIcon?: string | undefined;
    parentId?: string | undefined;
    cultures?: TagCultureDto[];

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.order = _data["order"];
            this.svgIcon = _data["svgIcon"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(TagCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["order"] = this.order;
        data["svgIcon"] = this.svgIcon;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITagDto {
    text?: string;
    order?: number;
    svgIcon?: string | undefined;
    parentId?: string | undefined;
    cultures?: TagCultureDto[];
}

export class TagCultureDto implements ITagCultureDto {
    id?: string;
    text?: string;
    cultureCode?: string;

    constructor(data?: ITagCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): TagCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface ITagCultureDto {
    id?: string;
    text?: string;
    cultureCode?: string;
}

export class TaxonomyViewModel implements ITaxonomyViewModel {
    taxonomies?: TaxonomyDto[];

    constructor(data?: ITaxonomyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taxonomies"])) {
                this.taxonomies = [] as any;
                for (let item of _data["taxonomies"])
                    this.taxonomies!.push(TaxonomyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxonomyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaxonomyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taxonomies)) {
            data["taxonomies"] = [];
            for (let item of this.taxonomies)
                data["taxonomies"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaxonomyViewModel {
    taxonomies?: TaxonomyDto[];
}

export class TaxonomyDto implements ITaxonomyDto {
    code?: string;
    name?: string;

    constructor(data?: ITaxonomyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaxonomyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxonomyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ITaxonomyDto {
    code?: string;
    name?: string;
}

export class ManageCompetitorDataRequest implements IManageCompetitorDataRequest {
    fileName?: string;
    fileContents?: string;

    constructor(data?: IManageCompetitorDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileContents = _data["fileContents"];
        }
    }

    static fromJS(data: any): ManageCompetitorDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ManageCompetitorDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileContents"] = this.fileContents;
        return data;
    }
}

export interface IManageCompetitorDataRequest {
    fileName?: string;
    fileContents?: string;
}

export class GetTransactionListFiltersViewModel implements IGetTransactionListFiltersViewModel {
    earliestTransactionDate?: Date | undefined;
    latestTransactionDate?: Date | undefined;
    transactionTypes?: string[];
    organizations?: GetTransactionListFilterOrganizationDto[];
    subscriptions?: GetTransactionListFilterSubscriptionDto[];
    subscriptionServices?: GetTransactionListFilterSubscriptionServiceDto[];
    projects?: GetTransactionListFilterProjectDto[];
    missionConfigurations?: GetTransactionListFilterMissionConfigurationDto[];
    periods?: GetTransactionListFilterPeriodDto[];

    constructor(data?: IGetTransactionListFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.earliestTransactionDate = _data["earliestTransactionDate"] ? new Date(_data["earliestTransactionDate"].toString()) : <any>undefined;
            this.latestTransactionDate = _data["latestTransactionDate"] ? new Date(_data["latestTransactionDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["transactionTypes"])) {
                this.transactionTypes = [] as any;
                for (let item of _data["transactionTypes"])
                    this.transactionTypes!.push(item);
            }
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(GetTransactionListFilterOrganizationDto.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(GetTransactionListFilterSubscriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(GetTransactionListFilterSubscriptionServiceDto.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(GetTransactionListFilterProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["missionConfigurations"])) {
                this.missionConfigurations = [] as any;
                for (let item of _data["missionConfigurations"])
                    this.missionConfigurations!.push(GetTransactionListFilterMissionConfigurationDto.fromJS(item));
            }
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(GetTransactionListFilterPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTransactionListFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["earliestTransactionDate"] = this.earliestTransactionDate ? this.earliestTransactionDate.toISOString() : <any>undefined;
        data["latestTransactionDate"] = this.latestTransactionDate ? this.latestTransactionDate.toISOString() : <any>undefined;
        if (Array.isArray(this.transactionTypes)) {
            data["transactionTypes"] = [];
            for (let item of this.transactionTypes)
                data["transactionTypes"].push(item);
        }
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.missionConfigurations)) {
            data["missionConfigurations"] = [];
            for (let item of this.missionConfigurations)
                data["missionConfigurations"].push(item.toJSON());
        }
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTransactionListFiltersViewModel {
    earliestTransactionDate?: Date | undefined;
    latestTransactionDate?: Date | undefined;
    transactionTypes?: string[];
    organizations?: GetTransactionListFilterOrganizationDto[];
    subscriptions?: GetTransactionListFilterSubscriptionDto[];
    subscriptionServices?: GetTransactionListFilterSubscriptionServiceDto[];
    projects?: GetTransactionListFilterProjectDto[];
    missionConfigurations?: GetTransactionListFilterMissionConfigurationDto[];
    periods?: GetTransactionListFilterPeriodDto[];
}

export class GetTransactionListFilterOrganizationDto implements IGetTransactionListFilterOrganizationDto {
    id?: string;
    name?: string;

    constructor(data?: IGetTransactionListFilterOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetTransactionListFilterOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListFilterOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetTransactionListFilterOrganizationDto {
    id?: string;
    name?: string;
}

export class GetTransactionListFilterSubscriptionDto implements IGetTransactionListFilterSubscriptionDto {
    id?: string;
    name?: string;
    organizationId?: string;

    constructor(data?: IGetTransactionListFilterSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): GetTransactionListFilterSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListFilterSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IGetTransactionListFilterSubscriptionDto {
    id?: string;
    name?: string;
    organizationId?: string;
}

export class GetTransactionListFilterSubscriptionServiceDto implements IGetTransactionListFilterSubscriptionServiceDto {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;

    constructor(data?: IGetTransactionListFilterSubscriptionServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): GetTransactionListFilterSubscriptionServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListFilterSubscriptionServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface IGetTransactionListFilterSubscriptionServiceDto {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
}

export class GetTransactionListFilterProjectDto implements IGetTransactionListFilterProjectDto {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;

    constructor(data?: IGetTransactionListFilterProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
        }
    }

    static fromJS(data: any): GetTransactionListFilterProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListFilterProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        return data;
    }
}

export interface IGetTransactionListFilterProjectDto {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
}

export class GetTransactionListFilterMissionConfigurationDto implements IGetTransactionListFilterMissionConfigurationDto {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;

    constructor(data?: IGetTransactionListFilterMissionConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetTransactionListFilterMissionConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListFilterMissionConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetTransactionListFilterMissionConfigurationDto {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;
}

export class GetTransactionListFilterPeriodDto implements IGetTransactionListFilterPeriodDto {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;

    constructor(data?: IGetTransactionListFilterPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetTransactionListFilterPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListFilterPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetTransactionListFilterPeriodDto {
    id?: string;
    name?: string;
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;
}

export class GetTransactionListSummaryViewModel implements IGetTransactionListSummaryViewModel {
    balance?: BalanceResult;
    summary?: SummaryResult | undefined;

    constructor(data?: IGetTransactionListSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"] ? BalanceResult.fromJS(_data["balance"]) : <any>undefined;
            this.summary = _data["summary"] ? SummaryResult.fromJS(_data["summary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionListSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance ? this.balance.toJSON() : <any>undefined;
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionListSummaryViewModel {
    balance?: BalanceResult;
    summary?: SummaryResult | undefined;
}

export class BalanceResult implements IBalanceResult {
    pendingFunds?: number;
    accountBalance?: number;
    availableFunds?: number;

    constructor(data?: IBalanceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingFunds = _data["pendingFunds"];
            this.accountBalance = _data["accountBalance"];
            this.availableFunds = _data["availableFunds"];
        }
    }

    static fromJS(data: any): BalanceResult {
        data = typeof data === 'object' ? data : {};
        let result = new BalanceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingFunds"] = this.pendingFunds;
        data["accountBalance"] = this.accountBalance;
        data["availableFunds"] = this.availableFunds;
        return data;
    }
}

export interface IBalanceResult {
    pendingFunds?: number;
    accountBalance?: number;
    availableFunds?: number;
}

export class SummaryResult implements ISummaryResult {
    transactionCount?: number;
    depositTransactionCount?: number;
    withdrawalTransactionCount?: number;
    adjustmentTransactionCount?: number;
    depositTotalAmount?: number | undefined;
    withdrawalTotalAmount?: number | undefined;
    totalUncashedPoints?: number;
    totalUncashedCurrency?: number;
    totalPotentialAvailablePoints?: number;
    totalPotentialAvailableCurrency?: number;
    totalPotentialAssignedPoints?: number;
    totalPotentialAssignedCurrency?: number;
    totalPotentialAndUncashedPoints?: number;
    totalPotentialAndUncashedCurrency?: number;
    totalPotentialFuturePeriodSalaryCurrency?: number;
    totalPotentialFuturePeriodReimbursementCurrency?: number;
    totalPotentialFuturePeriod?: number;

    constructor(data?: ISummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionCount = _data["transactionCount"];
            this.depositTransactionCount = _data["depositTransactionCount"];
            this.withdrawalTransactionCount = _data["withdrawalTransactionCount"];
            this.adjustmentTransactionCount = _data["adjustmentTransactionCount"];
            this.depositTotalAmount = _data["depositTotalAmount"];
            this.withdrawalTotalAmount = _data["withdrawalTotalAmount"];
            this.totalUncashedPoints = _data["totalUncashedPoints"];
            this.totalUncashedCurrency = _data["totalUncashedCurrency"];
            this.totalPotentialAvailablePoints = _data["totalPotentialAvailablePoints"];
            this.totalPotentialAvailableCurrency = _data["totalPotentialAvailableCurrency"];
            this.totalPotentialAssignedPoints = _data["totalPotentialAssignedPoints"];
            this.totalPotentialAssignedCurrency = _data["totalPotentialAssignedCurrency"];
            this.totalPotentialAndUncashedPoints = _data["totalPotentialAndUncashedPoints"];
            this.totalPotentialAndUncashedCurrency = _data["totalPotentialAndUncashedCurrency"];
            this.totalPotentialFuturePeriodSalaryCurrency = _data["totalPotentialFuturePeriodSalaryCurrency"];
            this.totalPotentialFuturePeriodReimbursementCurrency = _data["totalPotentialFuturePeriodReimbursementCurrency"];
            this.totalPotentialFuturePeriod = _data["totalPotentialFuturePeriod"];
        }
    }

    static fromJS(data: any): SummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionCount"] = this.transactionCount;
        data["depositTransactionCount"] = this.depositTransactionCount;
        data["withdrawalTransactionCount"] = this.withdrawalTransactionCount;
        data["adjustmentTransactionCount"] = this.adjustmentTransactionCount;
        data["depositTotalAmount"] = this.depositTotalAmount;
        data["withdrawalTotalAmount"] = this.withdrawalTotalAmount;
        data["totalUncashedPoints"] = this.totalUncashedPoints;
        data["totalUncashedCurrency"] = this.totalUncashedCurrency;
        data["totalPotentialAvailablePoints"] = this.totalPotentialAvailablePoints;
        data["totalPotentialAvailableCurrency"] = this.totalPotentialAvailableCurrency;
        data["totalPotentialAssignedPoints"] = this.totalPotentialAssignedPoints;
        data["totalPotentialAssignedCurrency"] = this.totalPotentialAssignedCurrency;
        data["totalPotentialAndUncashedPoints"] = this.totalPotentialAndUncashedPoints;
        data["totalPotentialAndUncashedCurrency"] = this.totalPotentialAndUncashedCurrency;
        data["totalPotentialFuturePeriodSalaryCurrency"] = this.totalPotentialFuturePeriodSalaryCurrency;
        data["totalPotentialFuturePeriodReimbursementCurrency"] = this.totalPotentialFuturePeriodReimbursementCurrency;
        data["totalPotentialFuturePeriod"] = this.totalPotentialFuturePeriod;
        return data;
    }
}

export interface ISummaryResult {
    transactionCount?: number;
    depositTransactionCount?: number;
    withdrawalTransactionCount?: number;
    adjustmentTransactionCount?: number;
    depositTotalAmount?: number | undefined;
    withdrawalTotalAmount?: number | undefined;
    totalUncashedPoints?: number;
    totalUncashedCurrency?: number;
    totalPotentialAvailablePoints?: number;
    totalPotentialAvailableCurrency?: number;
    totalPotentialAssignedPoints?: number;
    totalPotentialAssignedCurrency?: number;
    totalPotentialAndUncashedPoints?: number;
    totalPotentialAndUncashedCurrency?: number;
    totalPotentialFuturePeriodSalaryCurrency?: number;
    totalPotentialFuturePeriodReimbursementCurrency?: number;
    totalPotentialFuturePeriod?: number;
}

export class GetTransactionListFilter implements IGetTransactionListFilter {
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodId?: string | undefined;
    mysteryShopperId?: string | undefined;
    transactionTypes?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    minAmount?: number | undefined;
    maxAmount?: number | undefined;

    constructor(data?: IGetTransactionListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.periodId = _data["periodId"];
            this.mysteryShopperId = _data["mysteryShopperId"];
            if (Array.isArray(_data["transactionTypes"])) {
                this.transactionTypes = [] as any;
                for (let item of _data["transactionTypes"])
                    this.transactionTypes!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.minAmount = _data["minAmount"];
            this.maxAmount = _data["maxAmount"];
        }
    }

    static fromJS(data: any): GetTransactionListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["periodId"] = this.periodId;
        data["mysteryShopperId"] = this.mysteryShopperId;
        if (Array.isArray(this.transactionTypes)) {
            data["transactionTypes"] = [];
            for (let item of this.transactionTypes)
                data["transactionTypes"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        return data;
    }
}

export interface IGetTransactionListFilter {
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    projectId?: string | undefined;
    missionConfigurationId?: string | undefined;
    periodId?: string | undefined;
    mysteryShopperId?: string | undefined;
    transactionTypes?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    minAmount?: number | undefined;
    maxAmount?: number | undefined;
}

export class GetTransactionListViewModel implements IGetTransactionListViewModel {
    transactions?: PaginatedResponseOfGetTransactionListTransactionDto;

    constructor(data?: IGetTransactionListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactions = _data["transactions"] ? PaginatedResponseOfGetTransactionListTransactionDto.fromJS(_data["transactions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactions"] = this.transactions ? this.transactions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionListViewModel {
    transactions?: PaginatedResponseOfGetTransactionListTransactionDto;
}

export class PaginatedResponseOfGetTransactionListTransactionDto implements IPaginatedResponseOfGetTransactionListTransactionDto {
    items?: GetTransactionListTransactionDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;

    constructor(data?: IPaginatedResponseOfGetTransactionListTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTransactionListTransactionDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetTransactionListTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetTransactionListTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IPaginatedResponseOfGetTransactionListTransactionDto {
    items?: GetTransactionListTransactionDto[];
    totalRecords?: number;
    totalPages?: number;
    pageSize?: number;
    currentPage?: number;
}

export class GetTransactionListTransactionDto implements IGetTransactionListTransactionDto {
    transactionId?: string;
    transactionType?: string;
    amountPoints?: number;
    amountCurrency?: number;
    balancePoints?: number;
    balanceCurrency?: number;
    salaryPoints?: number | undefined;
    salaryCurrency?: number | undefined;
    reimbursementPoints?: number | undefined;
    reimbursementCurrency?: number | undefined;
    createdDate?: Date;
    mysteryShopperId?: string;
    mysteryShopperFirstName?: string | undefined;
    mysteryShopperLastName?: string | undefined;
    mysteryShopperEmail?: string;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionName?: string | undefined;
    subscriptionServiceId?: string | undefined;
    subscriptionServiceName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    missionConfigurationId?: string | undefined;
    missionConfigurationName?: string | undefined;
    periodId?: string | undefined;
    periodName?: string | undefined;
    reason?: string | undefined;
    cashOutWithdrawTransactionId?: string | undefined;
    cashInDepositTransactionId?: string | undefined;
    latestStatus?: string | undefined;
    flagged?: string | undefined;
    canConfirm?: boolean;
    canRefreshStatus?: boolean;
    canCancel?: boolean;

    constructor(data?: IGetTransactionListTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.transactionType = _data["transactionType"];
            this.amountPoints = _data["amountPoints"];
            this.amountCurrency = _data["amountCurrency"];
            this.balancePoints = _data["balancePoints"];
            this.balanceCurrency = _data["balanceCurrency"];
            this.salaryPoints = _data["salaryPoints"];
            this.salaryCurrency = _data["salaryCurrency"];
            this.reimbursementPoints = _data["reimbursementPoints"];
            this.reimbursementCurrency = _data["reimbursementCurrency"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.mysteryShopperId = _data["mysteryShopperId"];
            this.mysteryShopperFirstName = _data["mysteryShopperFirstName"];
            this.mysteryShopperLastName = _data["mysteryShopperLastName"];
            this.mysteryShopperEmail = _data["mysteryShopperEmail"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionName = _data["subscriptionName"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.subscriptionServiceName = _data["subscriptionServiceName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.missionConfigurationId = _data["missionConfigurationId"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.periodId = _data["periodId"];
            this.periodName = _data["periodName"];
            this.reason = _data["reason"];
            this.cashOutWithdrawTransactionId = _data["cashOutWithdrawTransactionId"];
            this.cashInDepositTransactionId = _data["cashInDepositTransactionId"];
            this.latestStatus = _data["latestStatus"];
            this.flagged = _data["flagged"];
            this.canConfirm = _data["canConfirm"];
            this.canRefreshStatus = _data["canRefreshStatus"];
            this.canCancel = _data["canCancel"];
        }
    }

    static fromJS(data: any): GetTransactionListTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["transactionType"] = this.transactionType;
        data["amountPoints"] = this.amountPoints;
        data["amountCurrency"] = this.amountCurrency;
        data["balancePoints"] = this.balancePoints;
        data["balanceCurrency"] = this.balanceCurrency;
        data["salaryPoints"] = this.salaryPoints;
        data["salaryCurrency"] = this.salaryCurrency;
        data["reimbursementPoints"] = this.reimbursementPoints;
        data["reimbursementCurrency"] = this.reimbursementCurrency;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["mysteryShopperId"] = this.mysteryShopperId;
        data["mysteryShopperFirstName"] = this.mysteryShopperFirstName;
        data["mysteryShopperLastName"] = this.mysteryShopperLastName;
        data["mysteryShopperEmail"] = this.mysteryShopperEmail;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionName"] = this.subscriptionName;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["subscriptionServiceName"] = this.subscriptionServiceName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["missionConfigurationId"] = this.missionConfigurationId;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["periodId"] = this.periodId;
        data["periodName"] = this.periodName;
        data["reason"] = this.reason;
        data["cashOutWithdrawTransactionId"] = this.cashOutWithdrawTransactionId;
        data["cashInDepositTransactionId"] = this.cashInDepositTransactionId;
        data["latestStatus"] = this.latestStatus;
        data["flagged"] = this.flagged;
        data["canConfirm"] = this.canConfirm;
        data["canRefreshStatus"] = this.canRefreshStatus;
        data["canCancel"] = this.canCancel;
        return data;
    }
}

export interface IGetTransactionListTransactionDto {
    transactionId?: string;
    transactionType?: string;
    amountPoints?: number;
    amountCurrency?: number;
    balancePoints?: number;
    balanceCurrency?: number;
    salaryPoints?: number | undefined;
    salaryCurrency?: number | undefined;
    reimbursementPoints?: number | undefined;
    reimbursementCurrency?: number | undefined;
    createdDate?: Date;
    mysteryShopperId?: string;
    mysteryShopperFirstName?: string | undefined;
    mysteryShopperLastName?: string | undefined;
    mysteryShopperEmail?: string;
    organizationId?: string | undefined;
    organizationName?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionName?: string | undefined;
    subscriptionServiceId?: string | undefined;
    subscriptionServiceName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    missionConfigurationId?: string | undefined;
    missionConfigurationName?: string | undefined;
    periodId?: string | undefined;
    periodName?: string | undefined;
    reason?: string | undefined;
    cashOutWithdrawTransactionId?: string | undefined;
    cashInDepositTransactionId?: string | undefined;
    latestStatus?: string | undefined;
    flagged?: string | undefined;
    canConfirm?: boolean;
    canRefreshStatus?: boolean;
    canCancel?: boolean;
}

export class CancelTransactionViewModel implements ICancelTransactionViewModel {
    status?: CancelCashOutStatusType;

    constructor(data?: ICancelTransactionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CancelTransactionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CancelTransactionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface ICancelTransactionViewModel {
    status?: CancelCashOutStatusType;
}

export enum CancelCashOutStatusType {
    Succeeded = 0,
    AlreadyCancelled = 1,
    NoTransactionId = 2,
    PaymentCancelFailed = 3,
    CashInFailed = 4,
}

export class RefreshTransactionViewModel implements IRefreshTransactionViewModel {
    status?: CheckCashOutStatusType;
    errorDescription?: string | undefined;

    constructor(data?: IRefreshTransactionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.errorDescription = _data["errorDescription"];
        }
    }

    static fromJS(data: any): RefreshTransactionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTransactionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["errorDescription"] = this.errorDescription;
        return data;
    }
}

export interface IRefreshTransactionViewModel {
    status?: CheckCashOutStatusType;
    errorDescription?: string | undefined;
}

export enum CheckCashOutStatusType {
    Succeeded = 0,
    AlreadyProcessed = 1,
    StatusCheckFailed = 2,
    NoTransactionId = 3,
    CashInConcurrencyFailed = 4,
}

export class ConfirmTransactionViewModel implements IConfirmTransactionViewModel {
    status?: ConfirmTransactionStatusType;
    errorDescription?: string | undefined;

    constructor(data?: IConfirmTransactionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.errorDescription = _data["errorDescription"];
        }
    }

    static fromJS(data: any): ConfirmTransactionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmTransactionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["errorDescription"] = this.errorDescription;
        return data;
    }
}

export interface IConfirmTransactionViewModel {
    status?: ConfirmTransactionStatusType;
    errorDescription?: string | undefined;
}

export enum ConfirmTransactionStatusType {
    Succeeded = 0,
    NoTransactionId = 1,
    ConfirmFailed = 2,
}

export class CreateOrUpdateValidationCommandViewModel implements ICreateOrUpdateValidationCommandViewModel {
    validations?: ValidationDto[];

    constructor(data?: ICreateOrUpdateValidationCommandViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validations"])) {
                this.validations = [] as any;
                for (let item of _data["validations"])
                    this.validations!.push(ValidationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateValidationCommandViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateValidationCommandViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validations)) {
            data["validations"] = [];
            for (let item of this.validations)
                data["validations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateValidationCommandViewModel {
    validations?: ValidationDto[];
}

export class MigrationViewModel implements IMigrationViewModel {
    organizations?: HierarchySelectItem[];
    subscriptions?: HierarchySelectItem[];
    mysteryShoppingServices?: HierarchySelectItem[];
    projects?: HierarchySelectItem[];
    legacyCorporateClients?: HierarchySelectItem[];

    constructor(data?: IMigrationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["mysteryShoppingServices"])) {
                this.mysteryShoppingServices = [] as any;
                for (let item of _data["mysteryShoppingServices"])
                    this.mysteryShoppingServices!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["legacyCorporateClients"])) {
                this.legacyCorporateClients = [] as any;
                for (let item of _data["legacyCorporateClients"])
                    this.legacyCorporateClients!.push(HierarchySelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MigrationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.mysteryShoppingServices)) {
            data["mysteryShoppingServices"] = [];
            for (let item of this.mysteryShoppingServices)
                data["mysteryShoppingServices"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.legacyCorporateClients)) {
            data["legacyCorporateClients"] = [];
            for (let item of this.legacyCorporateClients)
                data["legacyCorporateClients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMigrationViewModel {
    organizations?: HierarchySelectItem[];
    subscriptions?: HierarchySelectItem[];
    mysteryShoppingServices?: HierarchySelectItem[];
    projects?: HierarchySelectItem[];
    legacyCorporateClients?: HierarchySelectItem[];
}

export class HierarchySelectItem implements IHierarchySelectItem {
    id?: string;
    parentId?: string | undefined;
    type?: HierarchyType;
    name?: string;

    constructor(data?: IHierarchySelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HierarchySelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchySelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IHierarchySelectItem {
    id?: string;
    parentId?: string | undefined;
    type?: HierarchyType;
    name?: string;
}

export enum HierarchyType {
    Organization = 0,
    Subscription = 1,
    VoiceOfCustomer = 2,
    MysteryShopping = 3,
    Project = 4,
    Mandate = 5,
    Period = 6,
    PidCorportateClient = 7,
    Unknown = 8,
}

export class MigrationCandidatesViewModel implements IMigrationCandidatesViewModel {
    mandates?: HierarchySelectItem[];
    periods?: HierarchySelectItem[];
    npsQuestions?: HierarchySelectItem[];
    cesQuestions?: HierarchySelectItem[];
    pqrQuestions?: HierarchySelectItem[];
    eventDateQuestions?: HierarchySelectItem[];
    eventTimeQuestions?: HierarchySelectItem[];

    constructor(data?: IMigrationCandidatesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mandates"])) {
                this.mandates = [] as any;
                for (let item of _data["mandates"])
                    this.mandates!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["npsQuestions"])) {
                this.npsQuestions = [] as any;
                for (let item of _data["npsQuestions"])
                    this.npsQuestions!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["cesQuestions"])) {
                this.cesQuestions = [] as any;
                for (let item of _data["cesQuestions"])
                    this.cesQuestions!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["pqrQuestions"])) {
                this.pqrQuestions = [] as any;
                for (let item of _data["pqrQuestions"])
                    this.pqrQuestions!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["eventDateQuestions"])) {
                this.eventDateQuestions = [] as any;
                for (let item of _data["eventDateQuestions"])
                    this.eventDateQuestions!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["eventTimeQuestions"])) {
                this.eventTimeQuestions = [] as any;
                for (let item of _data["eventTimeQuestions"])
                    this.eventTimeQuestions!.push(HierarchySelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MigrationCandidatesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationCandidatesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mandates)) {
            data["mandates"] = [];
            for (let item of this.mandates)
                data["mandates"].push(item.toJSON());
        }
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        if (Array.isArray(this.npsQuestions)) {
            data["npsQuestions"] = [];
            for (let item of this.npsQuestions)
                data["npsQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.cesQuestions)) {
            data["cesQuestions"] = [];
            for (let item of this.cesQuestions)
                data["cesQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.pqrQuestions)) {
            data["pqrQuestions"] = [];
            for (let item of this.pqrQuestions)
                data["pqrQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.eventDateQuestions)) {
            data["eventDateQuestions"] = [];
            for (let item of this.eventDateQuestions)
                data["eventDateQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.eventTimeQuestions)) {
            data["eventTimeQuestions"] = [];
            for (let item of this.eventTimeQuestions)
                data["eventTimeQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMigrationCandidatesViewModel {
    mandates?: HierarchySelectItem[];
    periods?: HierarchySelectItem[];
    npsQuestions?: HierarchySelectItem[];
    cesQuestions?: HierarchySelectItem[];
    pqrQuestions?: HierarchySelectItem[];
    eventDateQuestions?: HierarchySelectItem[];
    eventTimeQuestions?: HierarchySelectItem[];
}

export class ProjectMapViewModel implements IProjectMapViewModel {
    profiles?: HierarchySelectItem[];
    missionConfigurations?: HierarchySelectItem[];
    periods?: HierarchySelectItem[];

    constructor(data?: IProjectMapViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["missionConfigurations"])) {
                this.missionConfigurations = [] as any;
                for (let item of _data["missionConfigurations"])
                    this.missionConfigurations!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(HierarchySelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectMapViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMapViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item.toJSON());
        }
        if (Array.isArray(this.missionConfigurations)) {
            data["missionConfigurations"] = [];
            for (let item of this.missionConfigurations)
                data["missionConfigurations"].push(item.toJSON());
        }
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectMapViewModel {
    profiles?: HierarchySelectItem[];
    missionConfigurations?: HierarchySelectItem[];
    periods?: HierarchySelectItem[];
}

export class MigrateMissionsDto implements IMigrateMissionsDto {
    mapping?: MandatePeriodProfileMap[];

    constructor(data?: IMigrateMissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapping"])) {
                this.mapping = [] as any;
                for (let item of _data["mapping"])
                    this.mapping!.push(MandatePeriodProfileMap.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MigrateMissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MigrateMissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapping)) {
            data["mapping"] = [];
            for (let item of this.mapping)
                data["mapping"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMigrateMissionsDto {
    mapping?: MandatePeriodProfileMap[];
}

export class MandatePeriodProfileMap implements IMandatePeriodProfileMap {
    mandatePeriodProfileId?: number;
    periodId?: string;
    missionConfigurationVersionId?: string;

    constructor(data?: IMandatePeriodProfileMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mandatePeriodProfileId = _data["mandatePeriodProfileId"];
            this.periodId = _data["periodId"];
            this.missionConfigurationVersionId = _data["missionConfigurationVersionId"];
        }
    }

    static fromJS(data: any): MandatePeriodProfileMap {
        data = typeof data === 'object' ? data : {};
        let result = new MandatePeriodProfileMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandatePeriodProfileId"] = this.mandatePeriodProfileId;
        data["periodId"] = this.periodId;
        data["missionConfigurationVersionId"] = this.missionConfigurationVersionId;
        return data;
    }
}

export interface IMandatePeriodProfileMap {
    mandatePeriodProfileId?: number;
    periodId?: string;
    missionConfigurationVersionId?: string;
}

export class MigrationOptions implements IMigrationOptions {
    useSeparateForms?: boolean;
    mandates?: MandateOptions[];
    missionConfigurationGroups?: MissionConfigurationGroup[];

    constructor(data?: IMigrationOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useSeparateForms = _data["useSeparateForms"];
            if (Array.isArray(_data["mandates"])) {
                this.mandates = [] as any;
                for (let item of _data["mandates"])
                    this.mandates!.push(MandateOptions.fromJS(item));
            }
            if (Array.isArray(_data["missionConfigurationGroups"])) {
                this.missionConfigurationGroups = [] as any;
                for (let item of _data["missionConfigurationGroups"])
                    this.missionConfigurationGroups!.push(MissionConfigurationGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MigrationOptions {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useSeparateForms"] = this.useSeparateForms;
        if (Array.isArray(this.mandates)) {
            data["mandates"] = [];
            for (let item of this.mandates)
                data["mandates"].push(item.toJSON());
        }
        if (Array.isArray(this.missionConfigurationGroups)) {
            data["missionConfigurationGroups"] = [];
            for (let item of this.missionConfigurationGroups)
                data["missionConfigurationGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMigrationOptions {
    useSeparateForms?: boolean;
    mandates?: MandateOptions[];
    missionConfigurationGroups?: MissionConfigurationGroup[];
}

export class MandateOptions implements IMandateOptions {
    mandateId?: number;
    npsQuestionId?: number | undefined;
    cesQuestionId?: number | undefined;
    pqrQuestionId?: number | undefined;
    eventDateId?: number | undefined;
    eventTimeId?: number | undefined;

    constructor(data?: IMandateOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mandateId = _data["mandateId"];
            this.npsQuestionId = _data["npsQuestionId"];
            this.cesQuestionId = _data["cesQuestionId"];
            this.pqrQuestionId = _data["pqrQuestionId"];
            this.eventDateId = _data["eventDateId"];
            this.eventTimeId = _data["eventTimeId"];
        }
    }

    static fromJS(data: any): MandateOptions {
        data = typeof data === 'object' ? data : {};
        let result = new MandateOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandateId"] = this.mandateId;
        data["npsQuestionId"] = this.npsQuestionId;
        data["cesQuestionId"] = this.cesQuestionId;
        data["pqrQuestionId"] = this.pqrQuestionId;
        data["eventDateId"] = this.eventDateId;
        data["eventTimeId"] = this.eventTimeId;
        return data;
    }
}

export interface IMandateOptions {
    mandateId?: number;
    npsQuestionId?: number | undefined;
    cesQuestionId?: number | undefined;
    pqrQuestionId?: number | undefined;
    eventDateId?: number | undefined;
    eventTimeId?: number | undefined;
}

export class MissionConfigurationGroup implements IMissionConfigurationGroup {
    name?: string;
    periods?: number[];

    constructor(data?: IMissionConfigurationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(item);
            }
        }
    }

    static fromJS(data: any): MissionConfigurationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new MissionConfigurationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item);
        }
        return data;
    }
}

export interface IMissionConfigurationGroup {
    name?: string;
    periods?: number[];
}

export enum TaskStatus {
    Created = 0,
    WaitingForActivation = 1,
    WaitingToRun = 2,
    Running = 3,
    WaitingForChildrenToComplete = 4,
    RanToCompletion = 5,
    Canceled = 6,
    Faulted = 7,
}

export class MysteryShopperExistsViewModel implements IMysteryShopperExistsViewModel {
    exists?: boolean;

    constructor(data?: IMysteryShopperExistsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
        }
    }

    static fromJS(data: any): MysteryShopperExistsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperExistsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        return data;
    }
}

export interface IMysteryShopperExistsViewModel {
    exists?: boolean;
}

export class RegistrationDto implements IRegistrationDto {
    deviceTheme?: DeviceTheme;
    signUpSource?: string | undefined;
    language?: string | undefined;
    firebaseId?: string | undefined;

    constructor(data?: IRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceTheme = _data["deviceTheme"];
            this.signUpSource = _data["signUpSource"];
            this.language = _data["language"];
            this.firebaseId = _data["firebaseId"];
        }
    }

    static fromJS(data: any): RegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceTheme"] = this.deviceTheme;
        data["signUpSource"] = this.signUpSource;
        data["language"] = this.language;
        data["firebaseId"] = this.firebaseId;
        return data;
    }
}

export interface IRegistrationDto {
    deviceTheme?: DeviceTheme;
    signUpSource?: string | undefined;
    language?: string | undefined;
    firebaseId?: string | undefined;
}

export class ExternalLoginRequest implements IExternalLoginRequest {
    email?: string;
    password?: string;

    constructor(data?: IExternalLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ExternalLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IExternalLoginRequest {
    email?: string;
    password?: string;
}

export class ExternalExistsRequest implements IExternalExistsRequest {
    email?: string;

    constructor(data?: IExternalExistsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ExternalExistsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalExistsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IExternalExistsRequest {
    email?: string;
}

export class GetSurveyFromTempViewModel implements IGetSurveyFromTempViewModel {
    formJson?: GetSurveyFromTempQueryDto;

    constructor(data?: IGetSurveyFromTempViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formJson = _data["formJson"] ? GetSurveyFromTempQueryDto.fromJS(_data["formJson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyFromTempViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyFromTempViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formJson"] = this.formJson ? this.formJson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyFromTempViewModel {
    formJson?: GetSurveyFromTempQueryDto;
}

export class GetSurveyFromTempQueryDto implements IGetSurveyFromTempQueryDto {
    formJson?: string;

    constructor(data?: IGetSurveyFromTempQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): GetSurveyFromTempQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyFromTempQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IGetSurveyFromTempQueryDto {
    formJson?: string;
}

export class GetMissionDetailsViewModel implements IGetMissionDetailsViewModel {
    missionDetails?: GetMissionDetailsDto[];

    constructor(data?: IGetMissionDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missionDetails"])) {
                this.missionDetails = [] as any;
                for (let item of _data["missionDetails"])
                    this.missionDetails!.push(GetMissionDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missionDetails)) {
            data["missionDetails"] = [];
            for (let item of this.missionDetails)
                data["missionDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMissionDetailsViewModel {
    missionDetails?: GetMissionDetailsDto[];
}

export class GetMissionDetailsDto implements IGetMissionDetailsDto {
    periodMissionConfigurationId?: string;
    name?: string;
    missionConfigurationName?: string;
    time?: string;
    phone?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    address?: string;
    distance?: number | undefined;
    tags?: string;
    reimbursementValue?: string | undefined;
    reimbursementMaxAmount?: number | undefined;
    reimbursementMaxPoints?: number | undefined;
    salaryAmount?: number | undefined;
    salaryPoints?: number | undefined;
    requiredPurchase?: boolean;
    isTaken?: boolean;
    takenMissionAssignationId?: string | undefined;
    requiredPurchaseText?: string | undefined;
    requiredPurchaseExclusionText?: string | undefined;
    supportedCultureCodes?: string[] | undefined;
    acceptMissionStatus?: AcceptMissionStatus;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;
    storeLocatorLink?: string | undefined;
    geocoordinate?: GeoLocation | undefined;
    referenceLocation?: GeoLocation | undefined;
    details?: MissionDetailsDto[];

    constructor(data?: IGetMissionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.name = _data["name"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.time = _data["time"];
            this.phone = _data["phone"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.address = _data["address"];
            this.distance = _data["distance"];
            this.tags = _data["tags"];
            this.reimbursementValue = _data["reimbursementValue"];
            this.reimbursementMaxAmount = _data["reimbursementMaxAmount"];
            this.reimbursementMaxPoints = _data["reimbursementMaxPoints"];
            this.salaryAmount = _data["salaryAmount"];
            this.salaryPoints = _data["salaryPoints"];
            this.requiredPurchase = _data["requiredPurchase"];
            this.isTaken = _data["isTaken"];
            this.takenMissionAssignationId = _data["takenMissionAssignationId"];
            this.requiredPurchaseText = _data["requiredPurchaseText"];
            this.requiredPurchaseExclusionText = _data["requiredPurchaseExclusionText"];
            if (Array.isArray(_data["supportedCultureCodes"])) {
                this.supportedCultureCodes = [] as any;
                for (let item of _data["supportedCultureCodes"])
                    this.supportedCultureCodes!.push(item);
            }
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : <any>undefined;
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
            this.storeLocatorLink = _data["storeLocatorLink"];
            this.geocoordinate = _data["geocoordinate"] ? GeoLocation.fromJS(_data["geocoordinate"]) : <any>undefined;
            this.referenceLocation = _data["referenceLocation"] ? GeoLocation.fromJS(_data["referenceLocation"]) : <any>undefined;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(MissionDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["name"] = this.name;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["time"] = this.time;
        data["phone"] = this.phone;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["address"] = this.address;
        data["distance"] = this.distance;
        data["tags"] = this.tags;
        data["reimbursementValue"] = this.reimbursementValue;
        data["reimbursementMaxAmount"] = this.reimbursementMaxAmount;
        data["reimbursementMaxPoints"] = this.reimbursementMaxPoints;
        data["salaryAmount"] = this.salaryAmount;
        data["salaryPoints"] = this.salaryPoints;
        data["requiredPurchase"] = this.requiredPurchase;
        data["isTaken"] = this.isTaken;
        data["takenMissionAssignationId"] = this.takenMissionAssignationId;
        data["requiredPurchaseText"] = this.requiredPurchaseText;
        data["requiredPurchaseExclusionText"] = this.requiredPurchaseExclusionText;
        if (Array.isArray(this.supportedCultureCodes)) {
            data["supportedCultureCodes"] = [];
            for (let item of this.supportedCultureCodes)
                data["supportedCultureCodes"].push(item);
        }
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["missionAssignationId"] = this.missionAssignationId;
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item.toJSON());
        }
        data["storeLocatorLink"] = this.storeLocatorLink;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : <any>undefined;
        data["referenceLocation"] = this.referenceLocation ? this.referenceLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMissionDetailsDto {
    periodMissionConfigurationId?: string;
    name?: string;
    missionConfigurationName?: string;
    time?: string;
    phone?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    address?: string;
    distance?: number | undefined;
    tags?: string;
    reimbursementValue?: string | undefined;
    reimbursementMaxAmount?: number | undefined;
    reimbursementMaxPoints?: number | undefined;
    salaryAmount?: number | undefined;
    salaryPoints?: number | undefined;
    requiredPurchase?: boolean;
    isTaken?: boolean;
    takenMissionAssignationId?: string | undefined;
    requiredPurchaseText?: string | undefined;
    requiredPurchaseExclusionText?: string | undefined;
    supportedCultureCodes?: string[] | undefined;
    acceptMissionStatus?: AcceptMissionStatus;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;
    storeLocatorLink?: string | undefined;
    geocoordinate?: GeoLocation | undefined;
    referenceLocation?: GeoLocation | undefined;
    details?: MissionDetailsDto[];
}

export enum AcceptMissionStatus {
    UserNotAuthenticated = 0,
    MissionUnavailable = 1,
    MissionAlreadyInProgress = 2,
    IncompleteProfileRequirements = 3,
    UserIneligibleForMission = 4,
    MissionLimitReached = 5,
    MissionLimitRotationReach = 6,
    MissionEligible = 7,
    Retry = 8,
}

export class AcceptMissionRotationInfoDto implements IAcceptMissionRotationInfoDto {
    isRotationValid?: boolean;
    rotationType?: RotationType;
    nextAvailableDate?: Date | undefined;

    constructor(data?: IAcceptMissionRotationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRotationValid = _data["isRotationValid"];
            this.rotationType = _data["rotationType"];
            this.nextAvailableDate = _data["nextAvailableDate"] ? new Date(_data["nextAvailableDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AcceptMissionRotationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptMissionRotationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRotationValid"] = this.isRotationValid;
        data["rotationType"] = this.rotationType;
        data["nextAvailableDate"] = this.nextAvailableDate ? this.nextAvailableDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAcceptMissionRotationInfoDto {
    isRotationValid?: boolean;
    rotationType?: RotationType;
    nextAvailableDate?: Date | undefined;
}

export class GetMysteryShopperProfileMemberDto implements IGetMysteryShopperProfileMemberDto {
    key?: string;
    label?: string;
    question?: string;
    valueType?: MysteryShopperProfileMemberType;
    minValue?: string | undefined;
    maxValue?: string | undefined;
    choices?: GetMysteryShopperProfileMemberChoiceDto[] | undefined;

    constructor(data?: IGetMysteryShopperProfileMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.question = _data["question"];
            this.valueType = _data["valueType"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(GetMysteryShopperProfileMemberChoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperProfileMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperProfileMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["question"] = this.question;
        data["valueType"] = this.valueType;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMysteryShopperProfileMemberDto {
    key?: string;
    label?: string;
    question?: string;
    valueType?: MysteryShopperProfileMemberType;
    minValue?: string | undefined;
    maxValue?: string | undefined;
    choices?: GetMysteryShopperProfileMemberChoiceDto[] | undefined;
}

export class GetMysteryShopperProfileMemberChoiceDto implements IGetMysteryShopperProfileMemberChoiceDto {
    key?: number;
    label?: string;

    constructor(data?: IGetMysteryShopperProfileMemberChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): GetMysteryShopperProfileMemberChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperProfileMemberChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        return data;
    }
}

export interface IGetMysteryShopperProfileMemberChoiceDto {
    key?: number;
    label?: string;
}

export class MissionDetailsDto implements IMissionDetailsDto {
    type?: MissionConfigurationDetailType;
    text?: string;

    constructor(data?: IMissionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): MissionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["text"] = this.text;
        return data;
    }
}

export interface IMissionDetailsDto {
    type?: MissionConfigurationDetailType;
    text?: string;
}

export class GetRemoteMissionsViewModel implements IGetRemoteMissionsViewModel {
    missions?: GetRemoteMissionsDto[];
    tags?: GetMissionsTagDto[];

    constructor(data?: IGetRemoteMissionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missions"])) {
                this.missions = [] as any;
                for (let item of _data["missions"])
                    this.missions!.push(GetRemoteMissionsDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetMissionsTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRemoteMissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetRemoteMissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missions)) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRemoteMissionsViewModel {
    missions?: GetRemoteMissionsDto[];
    tags?: GetMissionsTagDto[];
}

export class GetRemoteMissionsDto implements IGetRemoteMissionsDto {
    periodMissionConfigurationId?: string;
    branchId?: string;
    name?: string;
    branch?: GetRemoteMissionsBranchDto;
    tags?: string[];

    constructor(data?: IGetRemoteMissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.branch = _data["branch"] ? GetRemoteMissionsBranchDto.fromJS(_data["branch"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRemoteMissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRemoteMissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IGetRemoteMissionsDto {
    periodMissionConfigurationId?: string;
    branchId?: string;
    name?: string;
    branch?: GetRemoteMissionsBranchDto;
    tags?: string[];
}

export class GetRemoteMissionsBranchDto implements IGetRemoteMissionsBranchDto {
    id?: string;
    name?: string;
    address?: string;
    logoUrl?: string | undefined;
    hasBlob?: boolean;

    constructor(data?: IGetRemoteMissionsBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.logoUrl = _data["logoUrl"];
            this.hasBlob = _data["hasBlob"];
        }
    }

    static fromJS(data: any): GetRemoteMissionsBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRemoteMissionsBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["logoUrl"] = this.logoUrl;
        data["hasBlob"] = this.hasBlob;
        return data;
    }
}

export interface IGetRemoteMissionsBranchDto {
    id?: string;
    name?: string;
    address?: string;
    logoUrl?: string | undefined;
    hasBlob?: boolean;
}

export class GetMissionsTagDto implements IGetMissionsTagDto {
    id?: string;
    name?: string;
    svgIcon?: string | undefined;

    constructor(data?: IGetMissionsTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.svgIcon = _data["svgIcon"];
        }
    }

    static fromJS(data: any): GetMissionsTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionsTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["svgIcon"] = this.svgIcon;
        return data;
    }
}

export interface IGetMissionsTagDto {
    id?: string;
    name?: string;
    svgIcon?: string | undefined;
}

export class GetMissionsViewModel implements IGetMissionsViewModel {
    highOrderMissions?: GetMissionsFromMapDto[];
    missions?: GetMissionsFromMapDto[];
    lowOrderMissions?: GetMissionsFromMapDto[];
    tags?: GetMissionsTagDto[];

    constructor(data?: IGetMissionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["highOrderMissions"])) {
                this.highOrderMissions = [] as any;
                for (let item of _data["highOrderMissions"])
                    this.highOrderMissions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["missions"])) {
                this.missions = [] as any;
                for (let item of _data["missions"])
                    this.missions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["lowOrderMissions"])) {
                this.lowOrderMissions = [] as any;
                for (let item of _data["lowOrderMissions"])
                    this.lowOrderMissions!.push(GetMissionsFromMapDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetMissionsTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMissionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.highOrderMissions)) {
            data["highOrderMissions"] = [];
            for (let item of this.highOrderMissions)
                data["highOrderMissions"].push(item.toJSON());
        }
        if (Array.isArray(this.missions)) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item.toJSON());
        }
        if (Array.isArray(this.lowOrderMissions)) {
            data["lowOrderMissions"] = [];
            for (let item of this.lowOrderMissions)
                data["lowOrderMissions"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMissionsViewModel {
    highOrderMissions?: GetMissionsFromMapDto[];
    missions?: GetMissionsFromMapDto[];
    lowOrderMissions?: GetMissionsFromMapDto[];
    tags?: GetMissionsTagDto[];
}

export class GetMissionsFromMapDto implements IGetMissionsFromMapDto {
    missionOrder?: MissionOrderType | undefined;
    branchId?: string;
    name?: string;
    phone?: string;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    svgIcon?: string | undefined;
    address?: string;
    distance?: number;
    tags?: string;
    tagCount?: number;
    canAccept?: boolean;
    isHidden?: boolean;
    upcomingPeriod?: boolean;
    upcomingPeriodStartDate?: Date | undefined;
    geocoordinate?: GeoLocation;
    referenceLocation?: GeoLocation | undefined;
    missionConfigurationNames?: string[];

    constructor(data?: IGetMissionsFromMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionOrder = _data["missionOrder"];
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.svgIcon = _data["svgIcon"];
            this.address = _data["address"];
            this.distance = _data["distance"];
            this.tags = _data["tags"];
            this.tagCount = _data["tagCount"];
            this.canAccept = _data["canAccept"];
            this.isHidden = _data["isHidden"];
            this.upcomingPeriod = _data["upcomingPeriod"];
            this.upcomingPeriodStartDate = _data["upcomingPeriodStartDate"] ? new Date(_data["upcomingPeriodStartDate"].toString()) : <any>undefined;
            this.geocoordinate = _data["geocoordinate"] ? GeoLocation.fromJS(_data["geocoordinate"]) : <any>undefined;
            this.referenceLocation = _data["referenceLocation"] ? GeoLocation.fromJS(_data["referenceLocation"]) : <any>undefined;
            if (Array.isArray(_data["missionConfigurationNames"])) {
                this.missionConfigurationNames = [] as any;
                for (let item of _data["missionConfigurationNames"])
                    this.missionConfigurationNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMissionsFromMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionsFromMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionOrder"] = this.missionOrder;
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["svgIcon"] = this.svgIcon;
        data["address"] = this.address;
        data["distance"] = this.distance;
        data["tags"] = this.tags;
        data["tagCount"] = this.tagCount;
        data["canAccept"] = this.canAccept;
        data["isHidden"] = this.isHidden;
        data["upcomingPeriod"] = this.upcomingPeriod;
        data["upcomingPeriodStartDate"] = this.upcomingPeriodStartDate ? this.upcomingPeriodStartDate.toISOString() : <any>undefined;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : <any>undefined;
        data["referenceLocation"] = this.referenceLocation ? this.referenceLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.missionConfigurationNames)) {
            data["missionConfigurationNames"] = [];
            for (let item of this.missionConfigurationNames)
                data["missionConfigurationNames"].push(item);
        }
        return data;
    }
}

export interface IGetMissionsFromMapDto {
    missionOrder?: MissionOrderType | undefined;
    branchId?: string;
    name?: string;
    phone?: string;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    svgIcon?: string | undefined;
    address?: string;
    distance?: number;
    tags?: string;
    tagCount?: number;
    canAccept?: boolean;
    isHidden?: boolean;
    upcomingPeriod?: boolean;
    upcomingPeriodStartDate?: Date | undefined;
    geocoordinate?: GeoLocation;
    referenceLocation?: GeoLocation | undefined;
    missionConfigurationNames?: string[];
}

export class GetAcceptMissionsFromMapViewModel implements IGetAcceptMissionsFromMapViewModel {
    items?: GetAcceptMissionsFromMapDto[];

    constructor(data?: IGetAcceptMissionsFromMapViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAcceptMissionsFromMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcceptMissionsFromMapViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptMissionsFromMapViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAcceptMissionsFromMapViewModel {
    items?: GetAcceptMissionsFromMapDto[];
}

export class GetAcceptMissionsFromMapDto implements IGetAcceptMissionsFromMapDto {
    branchId?: string;
    canAccept?: boolean;

    constructor(data?: IGetAcceptMissionsFromMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.canAccept = _data["canAccept"];
        }
    }

    static fromJS(data: any): GetAcceptMissionsFromMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptMissionsFromMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["canAccept"] = this.canAccept;
        return data;
    }
}

export interface IGetAcceptMissionsFromMapDto {
    branchId?: string;
    canAccept?: boolean;
}

export class GetAcceptMissionViewModel implements IGetAcceptMissionViewModel {
    acceptMissionStatus?: AcceptMissionStatus;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;

    constructor(data?: IGetAcceptMissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : <any>undefined;
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcceptMissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptMissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["missionAssignationId"] = this.missionAssignationId;
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAcceptMissionViewModel {
    acceptMissionStatus?: AcceptMissionStatus;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;
}

export class GetAcceptMissionByBranchViewModel implements IGetAcceptMissionByBranchViewModel {
    items?: GetAcceptMissionByBranchDto[];

    constructor(data?: IGetAcceptMissionByBranchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAcceptMissionByBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcceptMissionByBranchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptMissionByBranchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAcceptMissionByBranchViewModel {
    items?: GetAcceptMissionByBranchDto[];
}

export class GetAcceptMissionByBranchDto implements IGetAcceptMissionByBranchDto {
    periodMissionConfigurationId?: string;
    acceptMissionStatus?: AcceptMissionStatus;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;

    constructor(data?: IGetAcceptMissionByBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : <any>undefined;
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcceptMissionByBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcceptMissionByBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["missionAssignationId"] = this.missionAssignationId;
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAcceptMissionByBranchDto {
    periodMissionConfigurationId?: string;
    acceptMissionStatus?: AcceptMissionStatus;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;
}

export class AcceptMissionViewModel implements IAcceptMissionViewModel {
    success?: boolean;
    missionEndDate?: Date | undefined;
    acceptMissionStatus?: AcceptMissionStatus;
    hardLimitReached?: boolean;
    verifyUserPhoneNumber?: boolean | undefined;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;

    constructor(data?: IAcceptMissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.missionEndDate = _data["missionEndDate"] ? new Date(_data["missionEndDate"].toString()) : <any>undefined;
            this.acceptMissionStatus = _data["acceptMissionStatus"];
            this.hardLimitReached = _data["hardLimitReached"];
            this.verifyUserPhoneNumber = _data["verifyUserPhoneNumber"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.rotationInfo = _data["rotationInfo"] ? AcceptMissionRotationInfoDto.fromJS(_data["rotationInfo"]) : <any>undefined;
            if (Array.isArray(_data["missingProfileMembers"])) {
                this.missingProfileMembers = [] as any;
                for (let item of _data["missingProfileMembers"])
                    this.missingProfileMembers!.push(GetMysteryShopperProfileMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AcceptMissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptMissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["missionEndDate"] = this.missionEndDate ? this.missionEndDate.toISOString() : <any>undefined;
        data["acceptMissionStatus"] = this.acceptMissionStatus;
        data["hardLimitReached"] = this.hardLimitReached;
        data["verifyUserPhoneNumber"] = this.verifyUserPhoneNumber;
        data["missionAssignationId"] = this.missionAssignationId;
        data["rotationInfo"] = this.rotationInfo ? this.rotationInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.missingProfileMembers)) {
            data["missingProfileMembers"] = [];
            for (let item of this.missingProfileMembers)
                data["missingProfileMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAcceptMissionViewModel {
    success?: boolean;
    missionEndDate?: Date | undefined;
    acceptMissionStatus?: AcceptMissionStatus;
    hardLimitReached?: boolean;
    verifyUserPhoneNumber?: boolean | undefined;
    missionAssignationId?: string | undefined;
    rotationInfo?: AcceptMissionRotationInfoDto | undefined;
    missingProfileMembers?: GetMysteryShopperProfileMemberDto[] | undefined;
}

export class SaveMissionAnswerDto implements ISaveMissionAnswerDto {
    missionAssignationId?: string | undefined;
    answerJson?: string;
    periodMissionConfigurationId?: string;
    rootMissionAssignationId?: string | undefined;

    constructor(data?: ISaveMissionAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionAssignationId = _data["missionAssignationId"];
            this.answerJson = _data["answerJson"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.rootMissionAssignationId = _data["rootMissionAssignationId"];
        }
    }

    static fromJS(data: any): SaveMissionAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMissionAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationId"] = this.missionAssignationId;
        data["answerJson"] = this.answerJson;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["rootMissionAssignationId"] = this.rootMissionAssignationId;
        return data;
    }
}

export interface ISaveMissionAnswerDto {
    missionAssignationId?: string | undefined;
    answerJson?: string;
    periodMissionConfigurationId?: string;
    rootMissionAssignationId?: string | undefined;
}

export class PartialSaveMissionAnswerRequest implements IPartialSaveMissionAnswerRequest {
    answer?: SaveMissionAnswerDto;
    formVersionId?: string;
    metadataJson?: string | undefined;

    constructor(data?: IPartialSaveMissionAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"] ? SaveMissionAnswerDto.fromJS(_data["answer"]) : <any>undefined;
            this.formVersionId = _data["formVersionId"];
            this.metadataJson = _data["metadataJson"];
        }
    }

    static fromJS(data: any): PartialSaveMissionAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PartialSaveMissionAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["formVersionId"] = this.formVersionId;
        data["metadataJson"] = this.metadataJson;
        return data;
    }
}

export interface IPartialSaveMissionAnswerRequest {
    answer?: SaveMissionAnswerDto;
    formVersionId?: string;
    metadataJson?: string | undefined;
}

export class GetSurveyFromMissionAssignationViewModel implements IGetSurveyFromMissionAssignationViewModel {
    survey?: SurveyFormModel;
    subscriptionInfo?: GetSurveyFromMissionAssignationSubscriptionInformationDto;
    branchInfo?: GetSurveyFromMissionAssignationBranchInformationDto;
    restrictedLanguage?: string | undefined;

    constructor(data?: IGetSurveyFromMissionAssignationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.survey = _data["survey"] ? SurveyFormModel.fromJS(_data["survey"]) : <any>undefined;
            this.subscriptionInfo = _data["subscriptionInfo"] ? GetSurveyFromMissionAssignationSubscriptionInformationDto.fromJS(_data["subscriptionInfo"]) : <any>undefined;
            this.branchInfo = _data["branchInfo"] ? GetSurveyFromMissionAssignationBranchInformationDto.fromJS(_data["branchInfo"]) : <any>undefined;
            this.restrictedLanguage = _data["restrictedLanguage"];
        }
    }

    static fromJS(data: any): GetSurveyFromMissionAssignationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyFromMissionAssignationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        data["subscriptionInfo"] = this.subscriptionInfo ? this.subscriptionInfo.toJSON() : <any>undefined;
        data["branchInfo"] = this.branchInfo ? this.branchInfo.toJSON() : <any>undefined;
        data["restrictedLanguage"] = this.restrictedLanguage;
        return data;
    }
}

export interface IGetSurveyFromMissionAssignationViewModel {
    survey?: SurveyFormModel;
    subscriptionInfo?: GetSurveyFromMissionAssignationSubscriptionInformationDto;
    branchInfo?: GetSurveyFromMissionAssignationBranchInformationDto;
    restrictedLanguage?: string | undefined;
}

export class SurveyFormModel implements ISurveyFormModel {
    missionAssignationId?: string | undefined;
    formJson?: string;
    formAnswerJson?: string | undefined;
    metadataJson?: string | undefined;
    periodMissionConfigurationId?: string;
    formVersionId?: string;
    nextForm?: SurveyFormModel | undefined;

    constructor(data?: ISurveyFormModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionAssignationId = _data["missionAssignationId"];
            this.formJson = _data["formJson"];
            this.formAnswerJson = _data["formAnswerJson"];
            this.metadataJson = _data["metadataJson"];
            this.periodMissionConfigurationId = _data["periodMissionConfigurationId"];
            this.formVersionId = _data["formVersionId"];
            this.nextForm = _data["nextForm"] ? SurveyFormModel.fromJS(_data["nextForm"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyFormModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyFormModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationId"] = this.missionAssignationId;
        data["formJson"] = this.formJson;
        data["formAnswerJson"] = this.formAnswerJson;
        data["metadataJson"] = this.metadataJson;
        data["periodMissionConfigurationId"] = this.periodMissionConfigurationId;
        data["formVersionId"] = this.formVersionId;
        data["nextForm"] = this.nextForm ? this.nextForm.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISurveyFormModel {
    missionAssignationId?: string | undefined;
    formJson?: string;
    formAnswerJson?: string | undefined;
    metadataJson?: string | undefined;
    periodMissionConfigurationId?: string;
    formVersionId?: string;
    nextForm?: SurveyFormModel | undefined;
}

export class GetSurveyFromMissionAssignationSubscriptionInformationDto implements IGetSurveyFromMissionAssignationSubscriptionInformationDto {
    id?: string;
    name?: string;

    constructor(data?: IGetSurveyFromMissionAssignationSubscriptionInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetSurveyFromMissionAssignationSubscriptionInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyFromMissionAssignationSubscriptionInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetSurveyFromMissionAssignationSubscriptionInformationDto {
    id?: string;
    name?: string;
}

export class GetSurveyFromMissionAssignationBranchInformationDto implements IGetSurveyFromMissionAssignationBranchInformationDto {
    id?: string;
    name?: string;
    code?: string;
    address?: string;
    logoUrl?: string;

    constructor(data?: IGetSurveyFromMissionAssignationBranchInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): GetSurveyFromMissionAssignationBranchInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyFromMissionAssignationBranchInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}

export interface IGetSurveyFromMissionAssignationBranchInformationDto {
    id?: string;
    name?: string;
    code?: string;
    address?: string;
    logoUrl?: string;
}

export class GetMyMissionExtendibleDaysViewModel implements IGetMyMissionExtendibleDaysViewModel {
    days?: number[];

    constructor(data?: IGetMyMissionExtendibleDaysViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMyMissionExtendibleDaysViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionExtendibleDaysViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        return data;
    }
}

export interface IGetMyMissionExtendibleDaysViewModel {
    days?: number[];
}

export class GetMyMissionListViewModel implements IGetMyMissionListViewModel {
    missions?: GetMyMissionsListStatusDto[];

    constructor(data?: IGetMyMissionListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missions"])) {
                this.missions = [] as any;
                for (let item of _data["missions"])
                    this.missions!.push(GetMyMissionsListStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyMissionListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missions)) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMyMissionListViewModel {
    missions?: GetMyMissionsListStatusDto[];
}

export class GetMyMissionsListStatusDto implements IGetMyMissionsListStatusDto {
    status?: MissionAssignationStatus;
    missionsList?: GetMyMissionListDto[];

    constructor(data?: IGetMyMissionsListStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["missionsList"])) {
                this.missionsList = [] as any;
                for (let item of _data["missionsList"])
                    this.missionsList!.push(GetMyMissionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyMissionsListStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionsListStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.missionsList)) {
            data["missionsList"] = [];
            for (let item of this.missionsList)
                data["missionsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMyMissionsListStatusDto {
    status?: MissionAssignationStatus;
    missionsList?: GetMyMissionListDto[];
}

export class GetMyMissionListDto implements IGetMyMissionListDto {
    id?: string;
    branchId?: string;
    name?: string;
    phone?: string;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    address?: string;
    missionConfigurationName?: string;
    geoLocation?: GeoLocation;

    constructor(data?: IGetMyMissionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.address = _data["address"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.geoLocation = _data["geoLocation"] ? GeoLocation.fromJS(_data["geoLocation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMyMissionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["address"] = this.address;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["geoLocation"] = this.geoLocation ? this.geoLocation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMyMissionListDto {
    id?: string;
    branchId?: string;
    name?: string;
    phone?: string;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    address?: string;
    missionConfigurationName?: string;
    geoLocation?: GeoLocation;
}

export class GetMyMissionDetailsViewModel implements IGetMyMissionDetailsViewModel {
    missionDetails?: GetMyMissionDetailsDto;

    constructor(data?: IGetMyMissionDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionDetails = _data["missionDetails"] ? GetMyMissionDetailsDto.fromJS(_data["missionDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMyMissionDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionDetails"] = this.missionDetails ? this.missionDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMyMissionDetailsViewModel {
    missionDetails?: GetMyMissionDetailsDto;
}

export class GetMyMissionDetailsDto implements IGetMyMissionDetailsDto {
    createdDate?: Date;
    dateOfVisit?: Date | undefined;
    submittedDate?: Date | undefined;
    validatedDate?: Date | undefined;
    isCancellable?: boolean;
    status?: MissionAssignationStatus;
    inProgress?: boolean;
    svgIcon?: string | undefined;
    time?: string | undefined;
    tagCount?: number;
    tags?: string | undefined;
    reimbursementValue?: string | undefined;
    reimbursementMaxAmount?: number | undefined;
    reimbursementMaxPoints?: number | undefined;
    salaryAmount?: number | undefined;
    salaryPoints?: number | undefined;
    totalAmount?: number | undefined;
    requiredPurchase?: boolean;
    requiredPurchaseText?: string | undefined;
    requiredPurchaseExclusionText?: string | undefined;
    locationValue?: string | undefined;
    supportedCultureCodes?: string[] | undefined;
    isExtendable?: boolean;
    maxExtendableDays?: number | undefined;
    daysLeft?: number | undefined;
    endDate?: Date | undefined;
    missionDetails?: MissionDetailsDto[];
    missionConfigurationName?: string;

    constructor(data?: IGetMyMissionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.dateOfVisit = _data["dateOfVisit"] ? new Date(_data["dateOfVisit"].toString()) : <any>undefined;
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.validatedDate = _data["validatedDate"] ? new Date(_data["validatedDate"].toString()) : <any>undefined;
            this.isCancellable = _data["isCancellable"];
            this.status = _data["status"];
            this.inProgress = _data["inProgress"];
            this.svgIcon = _data["svgIcon"];
            this.time = _data["time"];
            this.tagCount = _data["tagCount"];
            this.tags = _data["tags"];
            this.reimbursementValue = _data["reimbursementValue"];
            this.reimbursementMaxAmount = _data["reimbursementMaxAmount"];
            this.reimbursementMaxPoints = _data["reimbursementMaxPoints"];
            this.salaryAmount = _data["salaryAmount"];
            this.salaryPoints = _data["salaryPoints"];
            this.totalAmount = _data["totalAmount"];
            this.requiredPurchase = _data["requiredPurchase"];
            this.requiredPurchaseText = _data["requiredPurchaseText"];
            this.requiredPurchaseExclusionText = _data["requiredPurchaseExclusionText"];
            this.locationValue = _data["locationValue"];
            if (Array.isArray(_data["supportedCultureCodes"])) {
                this.supportedCultureCodes = [] as any;
                for (let item of _data["supportedCultureCodes"])
                    this.supportedCultureCodes!.push(item);
            }
            this.isExtendable = _data["isExtendable"];
            this.maxExtendableDays = _data["maxExtendableDays"];
            this.daysLeft = _data["daysLeft"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["missionDetails"])) {
                this.missionDetails = [] as any;
                for (let item of _data["missionDetails"])
                    this.missionDetails!.push(MissionDetailsDto.fromJS(item));
            }
            this.missionConfigurationName = _data["missionConfigurationName"];
        }
    }

    static fromJS(data: any): GetMyMissionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyMissionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["dateOfVisit"] = this.dateOfVisit ? this.dateOfVisit.toISOString() : <any>undefined;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["validatedDate"] = this.validatedDate ? this.validatedDate.toISOString() : <any>undefined;
        data["isCancellable"] = this.isCancellable;
        data["status"] = this.status;
        data["inProgress"] = this.inProgress;
        data["svgIcon"] = this.svgIcon;
        data["time"] = this.time;
        data["tagCount"] = this.tagCount;
        data["tags"] = this.tags;
        data["reimbursementValue"] = this.reimbursementValue;
        data["reimbursementMaxAmount"] = this.reimbursementMaxAmount;
        data["reimbursementMaxPoints"] = this.reimbursementMaxPoints;
        data["salaryAmount"] = this.salaryAmount;
        data["salaryPoints"] = this.salaryPoints;
        data["totalAmount"] = this.totalAmount;
        data["requiredPurchase"] = this.requiredPurchase;
        data["requiredPurchaseText"] = this.requiredPurchaseText;
        data["requiredPurchaseExclusionText"] = this.requiredPurchaseExclusionText;
        data["locationValue"] = this.locationValue;
        if (Array.isArray(this.supportedCultureCodes)) {
            data["supportedCultureCodes"] = [];
            for (let item of this.supportedCultureCodes)
                data["supportedCultureCodes"].push(item);
        }
        data["isExtendable"] = this.isExtendable;
        data["maxExtendableDays"] = this.maxExtendableDays;
        data["daysLeft"] = this.daysLeft;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.missionDetails)) {
            data["missionDetails"] = [];
            for (let item of this.missionDetails)
                data["missionDetails"].push(item.toJSON());
        }
        data["missionConfigurationName"] = this.missionConfigurationName;
        return data;
    }
}

export interface IGetMyMissionDetailsDto {
    createdDate?: Date;
    dateOfVisit?: Date | undefined;
    submittedDate?: Date | undefined;
    validatedDate?: Date | undefined;
    isCancellable?: boolean;
    status?: MissionAssignationStatus;
    inProgress?: boolean;
    svgIcon?: string | undefined;
    time?: string | undefined;
    tagCount?: number;
    tags?: string | undefined;
    reimbursementValue?: string | undefined;
    reimbursementMaxAmount?: number | undefined;
    reimbursementMaxPoints?: number | undefined;
    salaryAmount?: number | undefined;
    salaryPoints?: number | undefined;
    totalAmount?: number | undefined;
    requiredPurchase?: boolean;
    requiredPurchaseText?: string | undefined;
    requiredPurchaseExclusionText?: string | undefined;
    locationValue?: string | undefined;
    supportedCultureCodes?: string[] | undefined;
    isExtendable?: boolean;
    maxExtendableDays?: number | undefined;
    daysLeft?: number | undefined;
    endDate?: Date | undefined;
    missionDetails?: MissionDetailsDto[];
    missionConfigurationName?: string;
}

export class GetPreValidationViewModel implements IGetPreValidationViewModel {
    preValidation?: PreValidationDto;

    constructor(data?: IGetPreValidationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preValidation = _data["preValidation"] ? PreValidationDto.fromJS(_data["preValidation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPreValidationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreValidationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preValidation"] = this.preValidation ? this.preValidation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPreValidationViewModel {
    preValidation?: PreValidationDto;
}

export class PreValidationDto implements IPreValidationDto {
    missionAssignationId?: string;
    branchId?: string;
    name?: string;
    address?: string;
    time?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    branchGeoLocation?: GeoLocation;
    purchaseRequired?: boolean | undefined;
    purchaseRequiredText?: string | undefined;
    supportedCultureCodes?: string[] | undefined;
    purchaseExclusionText?: string | undefined;

    constructor(data?: IPreValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missionAssignationId = _data["missionAssignationId"];
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.time = _data["time"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.branchGeoLocation = _data["branchGeoLocation"] ? GeoLocation.fromJS(_data["branchGeoLocation"]) : <any>undefined;
            this.purchaseRequired = _data["purchaseRequired"];
            this.purchaseRequiredText = _data["purchaseRequiredText"];
            if (Array.isArray(_data["supportedCultureCodes"])) {
                this.supportedCultureCodes = [] as any;
                for (let item of _data["supportedCultureCodes"])
                    this.supportedCultureCodes!.push(item);
            }
            this.purchaseExclusionText = _data["purchaseExclusionText"];
        }
    }

    static fromJS(data: any): PreValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missionAssignationId"] = this.missionAssignationId;
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["address"] = this.address;
        data["time"] = this.time;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["branchGeoLocation"] = this.branchGeoLocation ? this.branchGeoLocation.toJSON() : <any>undefined;
        data["purchaseRequired"] = this.purchaseRequired;
        data["purchaseRequiredText"] = this.purchaseRequiredText;
        if (Array.isArray(this.supportedCultureCodes)) {
            data["supportedCultureCodes"] = [];
            for (let item of this.supportedCultureCodes)
                data["supportedCultureCodes"].push(item);
        }
        data["purchaseExclusionText"] = this.purchaseExclusionText;
        return data;
    }
}

export interface IPreValidationDto {
    missionAssignationId?: string;
    branchId?: string;
    name?: string;
    address?: string;
    time?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    branchGeoLocation?: GeoLocation;
    purchaseRequired?: boolean | undefined;
    purchaseRequiredText?: string | undefined;
    supportedCultureCodes?: string[] | undefined;
    purchaseExclusionText?: string | undefined;
}

export class GetFailedValidationNotificationViewModel implements IGetFailedValidationNotificationViewModel {
    hasFailedValidationMission?: boolean;
    failedValidationMissionAssignationIds?: string[] | undefined;

    constructor(data?: IGetFailedValidationNotificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasFailedValidationMission = _data["hasFailedValidationMission"];
            if (Array.isArray(_data["failedValidationMissionAssignationIds"])) {
                this.failedValidationMissionAssignationIds = [] as any;
                for (let item of _data["failedValidationMissionAssignationIds"])
                    this.failedValidationMissionAssignationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetFailedValidationNotificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFailedValidationNotificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasFailedValidationMission"] = this.hasFailedValidationMission;
        if (Array.isArray(this.failedValidationMissionAssignationIds)) {
            data["failedValidationMissionAssignationIds"] = [];
            for (let item of this.failedValidationMissionAssignationIds)
                data["failedValidationMissionAssignationIds"].push(item);
        }
        return data;
    }
}

export interface IGetFailedValidationNotificationViewModel {
    hasFailedValidationMission?: boolean;
    failedValidationMissionAssignationIds?: string[] | undefined;
}

export class GetMyRewardsViewModel implements IGetMyRewardsViewModel {
    amountPts?: number;
    amountCurrency?: number;
    pointsPerCurrency?: number;
    progression?: GetMyRewardsProgressionDto;

    constructor(data?: IGetMyRewardsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountPts = _data["amountPts"];
            this.amountCurrency = _data["amountCurrency"];
            this.pointsPerCurrency = _data["pointsPerCurrency"];
            this.progression = _data["progression"] ? GetMyRewardsProgressionDto.fromJS(_data["progression"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMyRewardsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyRewardsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountPts"] = this.amountPts;
        data["amountCurrency"] = this.amountCurrency;
        data["pointsPerCurrency"] = this.pointsPerCurrency;
        data["progression"] = this.progression ? this.progression.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMyRewardsViewModel {
    amountPts?: number;
    amountCurrency?: number;
    pointsPerCurrency?: number;
    progression?: GetMyRewardsProgressionDto;
}

export class GetMyRewardsProgressionDto implements IGetMyRewardsProgressionDto {
    values?: number[];
    percentageValue?: number;

    constructor(data?: IGetMyRewardsProgressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.percentageValue = _data["percentageValue"];
        }
    }

    static fromJS(data: any): GetMyRewardsProgressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyRewardsProgressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["percentageValue"] = this.percentageValue;
        return data;
    }
}

export interface IGetMyRewardsProgressionDto {
    values?: number[];
    percentageValue?: number;
}

export class GetMysteryShopperProfileViewModel implements IGetMysteryShopperProfileViewModel {
    mysteryShopper?: GetMysteryShopperDto2;
    availableProfileMembers?: ProfileMemberDto[];

    constructor(data?: IGetMysteryShopperProfileViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mysteryShopper = _data["mysteryShopper"] ? GetMysteryShopperDto2.fromJS(_data["mysteryShopper"]) : <any>undefined;
            if (Array.isArray(_data["availableProfileMembers"])) {
                this.availableProfileMembers = [] as any;
                for (let item of _data["availableProfileMembers"])
                    this.availableProfileMembers!.push(ProfileMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mysteryShopper"] = this.mysteryShopper ? this.mysteryShopper.toJSON() : <any>undefined;
        if (Array.isArray(this.availableProfileMembers)) {
            data["availableProfileMembers"] = [];
            for (let item of this.availableProfileMembers)
                data["availableProfileMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMysteryShopperProfileViewModel {
    mysteryShopper?: GetMysteryShopperDto2;
    availableProfileMembers?: ProfileMemberDto[];
}

export class GetMysteryShopperDto2 implements IGetMysteryShopperDto2 {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string;
    phoneNumber?: string | undefined;
    theme?: DeviceTheme;
    languages?: string[] | undefined;
    addresses?: GetMysteryShopperAddressDto[];
    profiles?: GetMysteryShopperProfileDto[];

    constructor(data?: IGetMysteryShopperDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.theme = _data["theme"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(GetMysteryShopperAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(GetMysteryShopperProfileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMysteryShopperDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["theme"] = this.theme;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMysteryShopperDto2 {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string;
    phoneNumber?: string | undefined;
    theme?: DeviceTheme;
    languages?: string[] | undefined;
    addresses?: GetMysteryShopperAddressDto[];
    profiles?: GetMysteryShopperProfileDto[];
}

export class GetMysteryShopperAddressDto implements IGetMysteryShopperAddressDto {
    id?: string;
    type?: MysteryShopperAddressType;
    city?: string;
    postalCode?: string;
    address?: string;
    department?: string;
    country?: string;
    geocoordinate?: GeoLocation;

    constructor(data?: IGetMysteryShopperAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.department = _data["department"];
            this.country = _data["country"];
            this.geocoordinate = _data["geocoordinate"] ? GeoLocation.fromJS(_data["geocoordinate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMysteryShopperAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["department"] = this.department;
        data["country"] = this.country;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMysteryShopperAddressDto {
    id?: string;
    type?: MysteryShopperAddressType;
    city?: string;
    postalCode?: string;
    address?: string;
    department?: string;
    country?: string;
    geocoordinate?: GeoLocation;
}

export class GetMysteryShopperProfileDto implements IGetMysteryShopperProfileDto {
    key?: string;
    value?: string | undefined;
    valueText?: string | undefined;

    constructor(data?: IGetMysteryShopperProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.valueText = _data["valueText"];
        }
    }

    static fromJS(data: any): GetMysteryShopperProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMysteryShopperProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["valueText"] = this.valueText;
        return data;
    }
}

export interface IGetMysteryShopperProfileDto {
    key?: string;
    value?: string | undefined;
    valueText?: string | undefined;
}

export class SaveProfileValueDto implements ISaveProfileValueDto {
    key?: string;
    value?: string | undefined;

    constructor(data?: ISaveProfileValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SaveProfileValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProfileValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ISaveProfileValueDto {
    key?: string;
    value?: string | undefined;
}

export class SaveBasicInformationDto implements ISaveBasicInformationDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    languages?: string[] | undefined;
    theme?: DeviceTheme | undefined;

    constructor(data?: ISaveBasicInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): SaveBasicInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBasicInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["theme"] = this.theme;
        return data;
    }
}

export interface ISaveBasicInformationDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    languages?: string[] | undefined;
    theme?: DeviceTheme | undefined;
}

export class MysteryShopperAddressDto2 implements IMysteryShopperAddressDto2 {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    department?: string | undefined;
    country?: string | undefined;
    type?: MysteryShopperAddressType;
    latitude?: number | undefined;
    longitude?: number | undefined;

    constructor(data?: IMysteryShopperAddressDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.department = _data["department"];
            this.country = _data["country"];
            this.type = _data["type"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): MysteryShopperAddressDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new MysteryShopperAddressDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["department"] = this.department;
        data["country"] = this.country;
        data["type"] = this.type;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IMysteryShopperAddressDto2 {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    department?: string | undefined;
    country?: string | undefined;
    type?: MysteryShopperAddressType;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export class RegisterDeviceDto implements IRegisterDeviceDto {
    deviceType?: MysteryShopperDeviceType;
    operatingSystem?: string;
    version?: string | undefined;
    userAgent?: string | undefined;
    token?: string;

    constructor(data?: IRegisterDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceType = _data["deviceType"];
            this.operatingSystem = _data["operatingSystem"];
            this.version = _data["version"];
            this.userAgent = _data["userAgent"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RegisterDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceType"] = this.deviceType;
        data["operatingSystem"] = this.operatingSystem;
        data["version"] = this.version;
        data["userAgent"] = this.userAgent;
        data["token"] = this.token;
        return data;
    }
}

export interface IRegisterDeviceDto {
    deviceType?: MysteryShopperDeviceType;
    operatingSystem?: string;
    version?: string | undefined;
    userAgent?: string | undefined;
    token?: string;
}

export enum MysteryShopperDeviceType {
    Unknown = 0,
    Desktop = 1,
    Mobile = 2,
    Tablet = 3,
}

export class GetAlertBannerViewModel implements IGetAlertBannerViewModel {
    latestRejectedMissionAssignation?: MissionAssignationDto | undefined;
    totalRejectedMissionAssignations?: number;

    constructor(data?: IGetAlertBannerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latestRejectedMissionAssignation = _data["latestRejectedMissionAssignation"] ? MissionAssignationDto.fromJS(_data["latestRejectedMissionAssignation"]) : <any>undefined;
            this.totalRejectedMissionAssignations = _data["totalRejectedMissionAssignations"];
        }
    }

    static fromJS(data: any): GetAlertBannerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlertBannerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latestRejectedMissionAssignation"] = this.latestRejectedMissionAssignation ? this.latestRejectedMissionAssignation.toJSON() : <any>undefined;
        data["totalRejectedMissionAssignations"] = this.totalRejectedMissionAssignations;
        return data;
    }
}

export interface IGetAlertBannerViewModel {
    latestRejectedMissionAssignation?: MissionAssignationDto | undefined;
    totalRejectedMissionAssignations?: number;
}

export class MissionAssignationDto implements IMissionAssignationDto {

    constructor(data?: IMissionAssignationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MissionAssignationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionAssignationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMissionAssignationDto {
}

export class GetAdvertisementTrackingListViewModel implements IGetAdvertisementTrackingListViewModel {
    items?: GetAdvertisementTrackingListAdvertisementDto[];

    constructor(data?: IGetAdvertisementTrackingListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAdvertisementTrackingListAdvertisementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAdvertisementTrackingListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvertisementTrackingListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAdvertisementTrackingListViewModel {
    items?: GetAdvertisementTrackingListAdvertisementDto[];
}

export class GetAdvertisementTrackingListAdvertisementDto implements IGetAdvertisementTrackingListAdvertisementDto {
    code?: string;
    doNotShowAgain?: boolean;

    constructor(data?: IGetAdvertisementTrackingListAdvertisementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.doNotShowAgain = _data["doNotShowAgain"];
        }
    }

    static fromJS(data: any): GetAdvertisementTrackingListAdvertisementDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvertisementTrackingListAdvertisementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["doNotShowAgain"] = this.doNotShowAgain;
        return data;
    }
}

export interface IGetAdvertisementTrackingListAdvertisementDto {
    code?: string;
    doNotShowAgain?: boolean;
}

export class GetAdvertisementTrackingByCodeViewModel implements IGetAdvertisementTrackingByCodeViewModel {
    doNotShowAgain?: boolean;

    constructor(data?: IGetAdvertisementTrackingByCodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doNotShowAgain = _data["doNotShowAgain"];
        }
    }

    static fromJS(data: any): GetAdvertisementTrackingByCodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdvertisementTrackingByCodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doNotShowAgain"] = this.doNotShowAgain;
        return data;
    }
}

export interface IGetAdvertisementTrackingByCodeViewModel {
    doNotShowAgain?: boolean;
}

export class UpdateAdvertisementTrackingByCodeDto implements IUpdateAdvertisementTrackingByCodeDto {
    doNotShowAgain?: boolean;

    constructor(data?: IUpdateAdvertisementTrackingByCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doNotShowAgain = _data["doNotShowAgain"];
        }
    }

    static fromJS(data: any): UpdateAdvertisementTrackingByCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdvertisementTrackingByCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doNotShowAgain"] = this.doNotShowAgain;
        return data;
    }
}

export interface IUpdateAdvertisementTrackingByCodeDto {
    doNotShowAgain?: boolean;
}

export class GetNotificationSettingsViewModel implements IGetNotificationSettingsViewModel {
    notificationSettings?: GetNotificationSettingsDto[];

    constructor(data?: IGetNotificationSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationSettings"])) {
                this.notificationSettings = [] as any;
                for (let item of _data["notificationSettings"])
                    this.notificationSettings!.push(GetNotificationSettingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationSettings)) {
            data["notificationSettings"] = [];
            for (let item of this.notificationSettings)
                data["notificationSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationSettingsViewModel {
    notificationSettings?: GetNotificationSettingsDto[];
}

export class GetNotificationSettingsDto implements IGetNotificationSettingsDto {
    subject?: MysteryShopperNotificationSubject;
    subjectTitle?: string;
    emailEnabled?: boolean;
    pushNotificationEnabled?: boolean;

    constructor(data?: IGetNotificationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.subjectTitle = _data["subjectTitle"];
            this.emailEnabled = _data["emailEnabled"];
            this.pushNotificationEnabled = _data["pushNotificationEnabled"];
        }
    }

    static fromJS(data: any): GetNotificationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["subjectTitle"] = this.subjectTitle;
        data["emailEnabled"] = this.emailEnabled;
        data["pushNotificationEnabled"] = this.pushNotificationEnabled;
        return data;
    }
}

export interface IGetNotificationSettingsDto {
    subject?: MysteryShopperNotificationSubject;
    subjectTitle?: string;
    emailEnabled?: boolean;
    pushNotificationEnabled?: boolean;
}

export enum MysteryShopperNotificationSubject {
    ExclusiveMarketingEmail = 0,
    ShowSimilarMissionsAfterMissionSuccess = 1,
    WeeklyMissionDigest = 2,
    LocalMissionBriefings = 3,
}

export class SaveNotificationSettingsRequest implements ISaveNotificationSettingsRequest {
    subject?: MysteryShopperNotificationSubject;
    type?: MysteryShopperNotificationType;
    enabled?: boolean;

    constructor(data?: ISaveNotificationSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.type = _data["type"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): SaveNotificationSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveNotificationSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["type"] = this.type;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface ISaveNotificationSettingsRequest {
    subject?: MysteryShopperNotificationSubject;
    type?: MysteryShopperNotificationType;
    enabled?: boolean;
}

export enum MysteryShopperNotificationType {
    Email = 0,
    PushNotification = 1,
}

export class GetTagsViewModel2 implements IGetTagsViewModel2 {
    tags?: GetTagsDto[];

    constructor(data?: IGetTagsViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(GetTagsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTagsViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagsViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTagsViewModel2 {
    tags?: GetTagsDto[];
}

export class GetTagsDto implements IGetTagsDto {
    id?: string;
    text?: string;

    constructor(data?: IGetTagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): GetTagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IGetTagsDto {
    id?: string;
    text?: string;
}

export class GetTransactionListViewModel2 implements IGetTransactionListViewModel2 {
    transactions?: TokenPaginatedResponseOfGetTransactionListTransactionDto;

    constructor(data?: IGetTransactionListViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactions = _data["transactions"] ? TokenPaginatedResponseOfGetTransactionListTransactionDto.fromJS(_data["transactions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionListViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactions"] = this.transactions ? this.transactions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionListViewModel2 {
    transactions?: TokenPaginatedResponseOfGetTransactionListTransactionDto;
}

export class TokenPaginatedResponseOfGetTransactionListTransactionDto implements ITokenPaginatedResponseOfGetTransactionListTransactionDto {
    items?: GetTransactionListTransactionDto2[];
    pageSize?: number;
    continuationToken?: string | undefined;

    constructor(data?: ITokenPaginatedResponseOfGetTransactionListTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTransactionListTransactionDto2.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.continuationToken = _data["continuationToken"];
        }
    }

    static fromJS(data: any): TokenPaginatedResponseOfGetTransactionListTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenPaginatedResponseOfGetTransactionListTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["continuationToken"] = this.continuationToken;
        return data;
    }
}

export interface ITokenPaginatedResponseOfGetTransactionListTransactionDto {
    items?: GetTransactionListTransactionDto2[];
    pageSize?: number;
    continuationToken?: string | undefined;
}

export class GetTransactionListTransactionDto2 implements IGetTransactionListTransactionDto2 {
    id?: string;
    type?: GetTransactionListTransactionType;
    date?: Date;
    amountCurrency?: number;
    amountPoints?: number;
    balanceCurrency?: number;
    balancePoints?: number;
    reason?: string | undefined;
    missionAssignationId?: string | undefined;
    name?: string | undefined;
    missionConfigurationName?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    branchAddress?: string | undefined;
    branchCity?: string | undefined;
    branchPostalCode?: string | undefined;
    branchGeocoordinate?: GeoLocation | undefined;
    branchId?: string | undefined;
    branchName?: string | undefined;

    constructor(data?: IGetTransactionListTransactionDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.amountCurrency = _data["amountCurrency"];
            this.amountPoints = _data["amountPoints"];
            this.balanceCurrency = _data["balanceCurrency"];
            this.balancePoints = _data["balancePoints"];
            this.reason = _data["reason"];
            this.missionAssignationId = _data["missionAssignationId"];
            this.name = _data["name"];
            this.missionConfigurationName = _data["missionConfigurationName"];
            this.hasLogo = _data["hasLogo"];
            this.logoUrl = _data["logoUrl"];
            this.branchAddress = _data["branchAddress"];
            this.branchCity = _data["branchCity"];
            this.branchPostalCode = _data["branchPostalCode"];
            this.branchGeocoordinate = _data["branchGeocoordinate"] ? GeoLocation.fromJS(_data["branchGeocoordinate"]) : <any>undefined;
            this.branchId = _data["branchId"];
            this.branchName = _data["branchName"];
        }
    }

    static fromJS(data: any): GetTransactionListTransactionDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListTransactionDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["amountCurrency"] = this.amountCurrency;
        data["amountPoints"] = this.amountPoints;
        data["balanceCurrency"] = this.balanceCurrency;
        data["balancePoints"] = this.balancePoints;
        data["reason"] = this.reason;
        data["missionAssignationId"] = this.missionAssignationId;
        data["name"] = this.name;
        data["missionConfigurationName"] = this.missionConfigurationName;
        data["hasLogo"] = this.hasLogo;
        data["logoUrl"] = this.logoUrl;
        data["branchAddress"] = this.branchAddress;
        data["branchCity"] = this.branchCity;
        data["branchPostalCode"] = this.branchPostalCode;
        data["branchGeocoordinate"] = this.branchGeocoordinate ? this.branchGeocoordinate.toJSON() : <any>undefined;
        data["branchId"] = this.branchId;
        data["branchName"] = this.branchName;
        return data;
    }
}

export interface IGetTransactionListTransactionDto2 {
    id?: string;
    type?: GetTransactionListTransactionType;
    date?: Date;
    amountCurrency?: number;
    amountPoints?: number;
    balanceCurrency?: number;
    balancePoints?: number;
    reason?: string | undefined;
    missionAssignationId?: string | undefined;
    name?: string | undefined;
    missionConfigurationName?: string | undefined;
    hasLogo?: boolean;
    logoUrl?: string | undefined;
    branchAddress?: string | undefined;
    branchCity?: string | undefined;
    branchPostalCode?: string | undefined;
    branchGeocoordinate?: GeoLocation | undefined;
    branchId?: string | undefined;
    branchName?: string | undefined;
}

export enum GetTransactionListTransactionType {
    Unknown = 0,
    Adjustment = 1,
    Validation = 2,
    Mission = 3,
    CashOut = 4,
}

export class GetTransactionListFilter2 implements IGetTransactionListFilter2 {
    transactionTypes?: GetTransactionListTransactionType[] | undefined;

    constructor(data?: IGetTransactionListFilter2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactionTypes"])) {
                this.transactionTypes = [] as any;
                for (let item of _data["transactionTypes"])
                    this.transactionTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): GetTransactionListFilter2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionListFilter2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactionTypes)) {
            data["transactionTypes"] = [];
            for (let item of this.transactionTypes)
                data["transactionTypes"].push(item);
        }
        return data;
    }
}

export interface IGetTransactionListFilter2 {
    transactionTypes?: GetTransactionListTransactionType[] | undefined;
}

export class CanProceedToCashOutViewModel implements ICanProceedToCashOutViewModel {
    status?: CanCashOutStatusType;
    cashOutTransactionId?: string | undefined;

    constructor(data?: ICanProceedToCashOutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.cashOutTransactionId = _data["cashOutTransactionId"];
        }
    }

    static fromJS(data: any): CanProceedToCashOutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CanProceedToCashOutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["cashOutTransactionId"] = this.cashOutTransactionId;
        return data;
    }
}

export interface ICanProceedToCashOutViewModel {
    status?: CanCashOutStatusType;
    cashOutTransactionId?: string | undefined;
}

export enum CanCashOutStatusType {
    Succeeded = 0,
    Refresh = 1,
    NoPoints = 2,
    NotEnoughPoints = 3,
    InProgress = 4,
    Failed = 5,
}

export class ProceedToCashOutViewModel implements IProceedToCashOutViewModel {
    status?: CanCashOutStatusType;
    cashOutTransactionId?: string | undefined;

    constructor(data?: IProceedToCashOutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.cashOutTransactionId = _data["cashOutTransactionId"];
        }
    }

    static fromJS(data: any): ProceedToCashOutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProceedToCashOutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["cashOutTransactionId"] = this.cashOutTransactionId;
        return data;
    }
}

export interface IProceedToCashOutViewModel {
    status?: CanCashOutStatusType;
    cashOutTransactionId?: string | undefined;
}

export class CancelCashOutViewModel implements ICancelCashOutViewModel {
    status?: CancelCashOutStatusType;

    constructor(data?: ICancelCashOutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CancelCashOutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CancelCashOutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface ICancelCashOutViewModel {
    status?: CancelCashOutStatusType;
}

export class ProfileAutomationProcessListItemDto implements IProfileAutomationProcessListItemDto {
    id?: string;
    branchRuleId?: string;
    createdDate?: Date;
    lastModifiedDate?: Date;
    nextStep?: ProcessStep;
    hot?: boolean;

    constructor(data?: IProfileAutomationProcessListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchRuleId = _data["branchRuleId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.nextStep = _data["nextStep"];
            this.hot = _data["hot"];
        }
    }

    static fromJS(data: any): ProfileAutomationProcessListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileAutomationProcessListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchRuleId"] = this.branchRuleId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["nextStep"] = this.nextStep;
        data["hot"] = this.hot;
        return data;
    }
}

export interface IProfileAutomationProcessListItemDto {
    id?: string;
    branchRuleId?: string;
    createdDate?: Date;
    lastModifiedDate?: Date;
    nextStep?: ProcessStep;
    hot?: boolean;
}

export class ProfileAutomationProcessViewModel implements IProfileAutomationProcessViewModel {
    profileAutomationProcess?: ProfileAutomationProcessDto;
    lastStep?: ProcessStep;
    availableSteps?: { [key in keyof typeof ProcessStep]?: boolean; };
    totalNotifications?: number;
    distinctNotifiedCandidates?: number;

    constructor(data?: IProfileAutomationProcessViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileAutomationProcess = _data["profileAutomationProcess"] ? ProfileAutomationProcessDto.fromJS(_data["profileAutomationProcess"]) : <any>undefined;
            this.lastStep = _data["lastStep"];
            if (_data["availableSteps"]) {
                this.availableSteps = {} as any;
                for (let key in _data["availableSteps"]) {
                    if (_data["availableSteps"].hasOwnProperty(key))
                        (<any>this.availableSteps)![key] = _data["availableSteps"][key];
                }
            }
            this.totalNotifications = _data["totalNotifications"];
            this.distinctNotifiedCandidates = _data["distinctNotifiedCandidates"];
        }
    }

    static fromJS(data: any): ProfileAutomationProcessViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileAutomationProcessViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileAutomationProcess"] = this.profileAutomationProcess ? this.profileAutomationProcess.toJSON() : <any>undefined;
        data["lastStep"] = this.lastStep;
        if (this.availableSteps) {
            data["availableSteps"] = {};
            for (let key in this.availableSteps) {
                if (this.availableSteps.hasOwnProperty(key))
                    (<any>data["availableSteps"])[key] = (<any>this.availableSteps)[key];
            }
        }
        data["totalNotifications"] = this.totalNotifications;
        data["distinctNotifiedCandidates"] = this.distinctNotifiedCandidates;
        return data;
    }
}

export interface IProfileAutomationProcessViewModel {
    profileAutomationProcess?: ProfileAutomationProcessDto;
    lastStep?: ProcessStep;
    availableSteps?: { [key in keyof typeof ProcessStep]?: boolean; };
    totalNotifications?: number;
    distinctNotifiedCandidates?: number;
}

export class ProfileAutomationProcessDto implements IProfileAutomationProcessDto {
    id?: string;
    branchRuleId?: string;
    nextStep?: ProcessStep;
    notificationEntries?: NotificationEntryDto[];
    remunerationAdjustment?: RemunerationAdjustmentDto | undefined;
    remunerationAdjustmentHistories?: RemunerationAdjustmentHistoryDto[];

    constructor(data?: IProfileAutomationProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchRuleId = _data["branchRuleId"];
            this.nextStep = _data["nextStep"];
            if (Array.isArray(_data["notificationEntries"])) {
                this.notificationEntries = [] as any;
                for (let item of _data["notificationEntries"])
                    this.notificationEntries!.push(NotificationEntryDto.fromJS(item));
            }
            this.remunerationAdjustment = _data["remunerationAdjustment"] ? RemunerationAdjustmentDto.fromJS(_data["remunerationAdjustment"]) : <any>undefined;
            if (Array.isArray(_data["remunerationAdjustmentHistories"])) {
                this.remunerationAdjustmentHistories = [] as any;
                for (let item of _data["remunerationAdjustmentHistories"])
                    this.remunerationAdjustmentHistories!.push(RemunerationAdjustmentHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileAutomationProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileAutomationProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchRuleId"] = this.branchRuleId;
        data["nextStep"] = this.nextStep;
        if (Array.isArray(this.notificationEntries)) {
            data["notificationEntries"] = [];
            for (let item of this.notificationEntries)
                data["notificationEntries"].push(item.toJSON());
        }
        data["remunerationAdjustment"] = this.remunerationAdjustment ? this.remunerationAdjustment.toJSON() : <any>undefined;
        if (Array.isArray(this.remunerationAdjustmentHistories)) {
            data["remunerationAdjustmentHistories"] = [];
            for (let item of this.remunerationAdjustmentHistories)
                data["remunerationAdjustmentHistories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProfileAutomationProcessDto {
    id?: string;
    branchRuleId?: string;
    nextStep?: ProcessStep;
    notificationEntries?: NotificationEntryDto[];
    remunerationAdjustment?: RemunerationAdjustmentDto | undefined;
    remunerationAdjustmentHistories?: RemunerationAdjustmentHistoryDto[];
}

export class NotificationEntryDto implements INotificationEntryDto {
    id?: string;
    status?: NotificationEntryStatus;
    mysteryShopperId?: string;
    mysteryShopperName?: string;
    step?: ProcessStep;
    title?: string;
    content?: string;
    sendDate?: Date | undefined;
    sendGridMessageId?: string | undefined;
    sendGridStatus?: SendGridStatus | undefined;

    constructor(data?: INotificationEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.mysteryShopperId = _data["mysteryShopperId"];
            this.mysteryShopperName = _data["mysteryShopperName"];
            this.step = _data["step"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.sendDate = _data["sendDate"] ? new Date(_data["sendDate"].toString()) : <any>undefined;
            this.sendGridMessageId = _data["sendGridMessageId"];
            this.sendGridStatus = _data["sendGridStatus"];
        }
    }

    static fromJS(data: any): NotificationEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["mysteryShopperId"] = this.mysteryShopperId;
        data["mysteryShopperName"] = this.mysteryShopperName;
        data["step"] = this.step;
        data["title"] = this.title;
        data["content"] = this.content;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["sendGridMessageId"] = this.sendGridMessageId;
        data["sendGridStatus"] = this.sendGridStatus;
        return data;
    }
}

export interface INotificationEntryDto {
    id?: string;
    status?: NotificationEntryStatus;
    mysteryShopperId?: string;
    mysteryShopperName?: string;
    step?: ProcessStep;
    title?: string;
    content?: string;
    sendDate?: Date | undefined;
    sendGridMessageId?: string | undefined;
    sendGridStatus?: SendGridStatus | undefined;
}

export enum SendGridStatus {
    Processed = 0,
    Dropped = 1,
    Delivered = 2,
    Deferred = 3,
    Bounce = 4,
    Open = 5,
    Click = 6,
    SpamReport = 7,
    Unsubscribe = 8,
    GroupUnsubscribe = 9,
    GroupResubscribe = 10,
}

export class RemunerationAdjustmentDto implements IRemunerationAdjustmentDto {
    id?: string;
    salaryRaiseAmount?: number;
    expirationDate?: Date;

    constructor(data?: IRemunerationAdjustmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.salaryRaiseAmount = _data["salaryRaiseAmount"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RemunerationAdjustmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemunerationAdjustmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["salaryRaiseAmount"] = this.salaryRaiseAmount;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRemunerationAdjustmentDto {
    id?: string;
    salaryRaiseAmount?: number;
    expirationDate?: Date;
}

export class RemunerationAdjustmentHistoryDto implements IRemunerationAdjustmentHistoryDto {
    id?: string;
    createdDate?: Date;
    expirationDate?: Date;
    expirationPeriod?: number;
    raiseAmount?: number;
    totalSalaryAmount?: number;
    baseSalaryAmount?: number;

    constructor(data?: IRemunerationAdjustmentHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.expirationPeriod = _data["expirationPeriod"];
            this.raiseAmount = _data["raiseAmount"];
            this.totalSalaryAmount = _data["totalSalaryAmount"];
            this.baseSalaryAmount = _data["baseSalaryAmount"];
        }
    }

    static fromJS(data: any): RemunerationAdjustmentHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemunerationAdjustmentHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["expirationPeriod"] = this.expirationPeriod;
        data["raiseAmount"] = this.raiseAmount;
        data["totalSalaryAmount"] = this.totalSalaryAmount;
        data["baseSalaryAmount"] = this.baseSalaryAmount;
        return data;
    }
}

export interface IRemunerationAdjustmentHistoryDto {
    id?: string;
    createdDate?: Date;
    expirationDate?: Date;
    expirationPeriod?: number;
    raiseAmount?: number;
    totalSalaryAmount?: number;
    baseSalaryAmount?: number;
}

export class AutomationProcessHistoryViewModel implements IAutomationProcessHistoryViewModel {
    simplifiedHistory?: AutomationProcessHistoryDto[];

    constructor(data?: IAutomationProcessHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["simplifiedHistory"])) {
                this.simplifiedHistory = [] as any;
                for (let item of _data["simplifiedHistory"])
                    this.simplifiedHistory!.push(AutomationProcessHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutomationProcessHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AutomationProcessHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.simplifiedHistory)) {
            data["simplifiedHistory"] = [];
            for (let item of this.simplifiedHistory)
                data["simplifiedHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAutomationProcessHistoryViewModel {
    simplifiedHistory?: AutomationProcessHistoryDto[];
}

export class AutomationProcessHistoryDto implements IAutomationProcessHistoryDto {
    id?: string;
    createdDate?: Date;
    priorStep?: ProcessStep;
    nextStep?: ProcessStep;
    assignedMissionCount?: number;
    missionToBeAssignedCount?: number;

    constructor(data?: IAutomationProcessHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.priorStep = _data["priorStep"];
            this.nextStep = _data["nextStep"];
            this.assignedMissionCount = _data["assignedMissionCount"];
            this.missionToBeAssignedCount = _data["missionToBeAssignedCount"];
        }
    }

    static fromJS(data: any): AutomationProcessHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AutomationProcessHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["priorStep"] = this.priorStep;
        data["nextStep"] = this.nextStep;
        data["assignedMissionCount"] = this.assignedMissionCount;
        data["missionToBeAssignedCount"] = this.missionToBeAssignedCount;
        return data;
    }
}

export interface IAutomationProcessHistoryDto {
    id?: string;
    createdDate?: Date;
    priorStep?: ProcessStep;
    nextStep?: ProcessStep;
    assignedMissionCount?: number;
    missionToBeAssignedCount?: number;
}

export class CheckupAutomationProcessDto implements ICheckupAutomationProcessDto {
    branchName?: string;
    periodName?: string;
    profileName?: string;
    branchHasAddress?: boolean;
    hasMissionAssignationRateCache?: boolean;
    satisfactoryRate?: boolean;
    expectedRate?: number;
    stepIntervalAdoptedDays?: number;

    constructor(data?: ICheckupAutomationProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchName = _data["branchName"];
            this.periodName = _data["periodName"];
            this.profileName = _data["profileName"];
            this.branchHasAddress = _data["branchHasAddress"];
            this.hasMissionAssignationRateCache = _data["hasMissionAssignationRateCache"];
            this.satisfactoryRate = _data["satisfactoryRate"];
            this.expectedRate = _data["expectedRate"];
            this.stepIntervalAdoptedDays = _data["stepIntervalAdoptedDays"];
        }
    }

    static fromJS(data: any): CheckupAutomationProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckupAutomationProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchName"] = this.branchName;
        data["periodName"] = this.periodName;
        data["profileName"] = this.profileName;
        data["branchHasAddress"] = this.branchHasAddress;
        data["hasMissionAssignationRateCache"] = this.hasMissionAssignationRateCache;
        data["satisfactoryRate"] = this.satisfactoryRate;
        data["expectedRate"] = this.expectedRate;
        data["stepIntervalAdoptedDays"] = this.stepIntervalAdoptedDays;
        return data;
    }
}

export interface ICheckupAutomationProcessDto {
    branchName?: string;
    periodName?: string;
    profileName?: string;
    branchHasAddress?: boolean;
    hasMissionAssignationRateCache?: boolean;
    satisfactoryRate?: boolean;
    expectedRate?: number;
    stepIntervalAdoptedDays?: number;
}

export class CallListViewModel implements ICallListViewModel {
    list?: CallListEntryDto[];

    constructor(data?: ICallListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(CallListEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CallListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CallListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICallListViewModel {
    list?: CallListEntryDto[];
}

export class CallListEntryDto implements ICallListEntryDto {
    id?: string;
    createdDate?: Date;
    mysteryShopperId?: string;
    mysteryShopperName?: string;
    status?: CallListEntryStatus;

    constructor(data?: ICallListEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.mysteryShopperId = _data["mysteryShopperId"];
            this.mysteryShopperName = _data["mysteryShopperName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CallListEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallListEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["mysteryShopperId"] = this.mysteryShopperId;
        data["mysteryShopperName"] = this.mysteryShopperName;
        data["status"] = this.status;
        return data;
    }
}

export interface ICallListEntryDto {
    id?: string;
    createdDate?: Date;
    mysteryShopperId?: string;
    mysteryShopperName?: string;
    status?: CallListEntryStatus;
}

export enum CallListEntryStatus {
    ToCall = 0,
    Called = 1,
    Refused = 2,
    Accepted = 3,
}

export class ActivityLogDto implements IActivityLogDto {
    id?: string;
    createdDate?: Date;
    importance?: ImportanceType;
    type?: ActivityType;

    constructor(data?: IActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.importance = _data["importance"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["importance"] = this.importance;
        data["type"] = this.type;
        return data;
    }
}

export interface IActivityLogDto {
    id?: string;
    createdDate?: Date;
    importance?: ImportanceType;
    type?: ActivityType;
}

export enum ImportanceType {
    Trace = 0,
    Information = 1,
    Warning = 2,
    Error = 3,
}

export enum ActivityType {
    P001_StartCronTriggerToProcessPeriods = 0,
    P001_EndCronTriggerToProcessPeriods = 1,
    P001_ThereIsPeriodsToProcess = 2,
    P001_NoPeriodsToProcess = 3,
    P001_AddPeriodToProcessToQueue = 4,
    P002_TakePeriodFromQueue = 5,
    P003_NotificationStepStarted = 6,
    P003_FirstRaiseStepStarted = 7,
    P003_SecondRaiseStepStarted = 8,
    P003_ShareMissionStepStarted = 9,
    P003_NotificationStepEnded = 10,
    P003_FirstRaiseStepEnded = 11,
    P003_SecondRaiseStepEnded = 12,
    P003_ShareMissionStepEnded = 13,
    P003_CallListStepStarted = 14,
    P003_CallListStepEnded = 15,
    P004_NoProfileBranchToProcess = 16,
    P004_ThereIsProfileBranchToProcess = 17,
    P004_TryProcessProfile = 18,
    P004_IsCorrectStep = 19,
    P004_IsNotCorrectStep = 20,
    P004_IsTimeToProcess = 21,
    P004_IsNotTimeToProcess = 22,
    P005_NeedToNotifyCandidates = 23,
    P005_DoNotNeedToNotifyCandidates = 24,
    P006_FetchEligibleCandidates = 25,
    P006_NoEligibleCandidates = 26,
    P006_EligibleCandidatesFound = 27,
    P007_GenerateNotificationEntries = 28,
    P007_NotificationEntriesGenerated = 29,
    P008_NextStepChangeProfileBranch = 30,
    P009_ThereIsNotificationToSend = 31,
    P009_NoNotificationToSend = 32,
    P010_SalaryRaise = 33,
    P010_SalaryRaiseNotDone = 34,
    P011_CreatePMAlertNotificationEntry = 35,
    P012_SendCallingListNotification = 36,
}

export class ActionLogDto implements IActionLogDto {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    page?: string;
    action?: ActionEnum;

    constructor(data?: IActionLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
            this.page = _data["page"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): ActionLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        data["page"] = this.page;
        data["action"] = this.action;
        return data;
    }
}

export interface IActionLogDto {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    page?: string;
    action?: ActionEnum;
}

export enum SubjectType {
    Organization = 0,
    Subscription = 1,
    Service = 2,
    Branch = 3,
    Address = 4,
    SubscriptionService = 5,
    Project = 6,
    BranchGroup = 7,
    BranchCompetitor = 8,
    BranchCompetitorGroup = 9,
    BrandGroup = 10,
}

export enum ActionEnum {
    View = 1,
}

export class GetAddressTypeByIdViewModel implements IGetAddressTypeByIdViewModel {
    id?: string;
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;

    constructor(data?: IGetAddressTypeByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.department = _data["department"];
            this.locality = _data["locality"];
            this.city = _data["city"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): GetAddressTypeByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAddressTypeByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["department"] = this.department;
        data["locality"] = this.locality;
        data["city"] = this.city;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IGetAddressTypeByIdViewModel {
    id?: string;
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;
}

export class CreateAddressTypeViewModel implements ICreateAddressTypeViewModel {
    id?: string;

    constructor(data?: ICreateAddressTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateAddressTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateAddressTypeViewModel {
    id?: string;
}

export class CreateAddressTypeCommandDto implements ICreateAddressTypeCommandDto {
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;

    constructor(data?: ICreateAddressTypeCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.department = _data["department"];
            this.locality = _data["locality"];
            this.city = _data["city"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): CreateAddressTypeCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressTypeCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["department"] = this.department;
        data["locality"] = this.locality;
        data["city"] = this.city;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface ICreateAddressTypeCommandDto {
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;
}

export class UpdateAddressTypeViewModel implements IUpdateAddressTypeViewModel {
    id?: string;

    constructor(data?: IUpdateAddressTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateAddressTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddressTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateAddressTypeViewModel {
    id?: string;
}

export class UpdateAddressTypeCommandDto implements IUpdateAddressTypeCommandDto {
    id?: string;
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;

    constructor(data?: IUpdateAddressTypeCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.department = _data["department"];
            this.locality = _data["locality"];
            this.city = _data["city"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): UpdateAddressTypeCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddressTypeCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["department"] = this.department;
        data["locality"] = this.locality;
        data["city"] = this.city;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IUpdateAddressTypeCommandDto {
    id?: string;
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;
}

export class DeleteAddressTypeViewModel implements IDeleteAddressTypeViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteAddressTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteAddressTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAddressTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteAddressTypeViewModel {
    id?: string | undefined;
}

export class GetBranchViewModel implements IGetBranchViewModel {
    id?: string;
    name?: string;
    addressId?: string;
    subscriptionId?: string;
    enabled?: boolean;
    imageBlobStorageId?: string | undefined;
    code?: string;
    longitude?: number | undefined;
    latitude?: number | undefined;
    geocoordinate?: Point;
    address?: GetBranchAddressViewModel;

    constructor(data?: IGetBranchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.addressId = _data["addressId"];
            this.subscriptionId = _data["subscriptionId"];
            this.enabled = _data["enabled"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.code = _data["code"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.geocoordinate = _data["geocoordinate"] ? Point.fromJS(_data["geocoordinate"]) : <any>undefined;
            this.address = _data["address"] ? GetBranchAddressViewModel.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBranchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["addressId"] = this.addressId;
        data["subscriptionId"] = this.subscriptionId;
        data["enabled"] = this.enabled;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["code"] = this.code;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBranchViewModel {
    id?: string;
    name?: string;
    addressId?: string;
    subscriptionId?: string;
    enabled?: boolean;
    imageBlobStorageId?: string | undefined;
    code?: string;
    longitude?: number | undefined;
    latitude?: number | undefined;
    geocoordinate?: Point;
    address?: GetBranchAddressViewModel;
}

export abstract class Geometry implements IGeometry {
    factory?: GeometryFactory | undefined;
    userData?: any | undefined;
    srid?: number;
    geometryType?: string | undefined;
    ogcGeometryType?: OgcGeometryType;
    precisionModel?: PrecisionModel | undefined;
    coordinate?: Coordinate | undefined;
    coordinates?: Coordinate[] | undefined;
    numPoints?: number;
    numGeometries?: number;
    isSimple?: boolean;
    isValid?: boolean;
    isEmpty?: boolean;
    area?: number;
    length?: number;
    centroid?: Point | undefined;
    interiorPoint?: Point | undefined;
    pointOnSurface?: Point | undefined;
    dimension?: Dimension;
    boundary?: Geometry | undefined;
    boundaryDimension?: Dimension;
    envelope?: Geometry | undefined;
    envelopeInternal?: Envelope | undefined;
    isGeometryCollection?: boolean;
    sortIndex?: SortIndexValue;
    isRectangle?: boolean;

    constructor(data?: IGeometry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            this.geometryType = _data["geometryType"];
            this.ogcGeometryType = _data["ogcGeometryType"];
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(Coordinate.fromJS(item));
            }
            this.numPoints = _data["numPoints"];
            this.numGeometries = _data["numGeometries"];
            this.isSimple = _data["isSimple"];
            this.isValid = _data["isValid"];
            this.isEmpty = _data["isEmpty"];
            this.area = _data["area"];
            this.length = _data["length"];
            this.centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            this.interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            this.pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            this.dimension = _data["dimension"];
            this.boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            this.boundaryDimension = _data["boundaryDimension"];
            this.envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            this.envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            this.isGeometryCollection = _data["isGeometryCollection"];
            this.sortIndex = _data["sortIndex"];
            this.isRectangle = _data["isRectangle"];
        }
    }

    static fromJS(data: any): Geometry {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Geometry' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["isEmpty"] = this.isEmpty;
        data["area"] = this.area;
        data["length"] = this.length;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["dimension"] = this.dimension;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["boundaryDimension"] = this.boundaryDimension;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["isGeometryCollection"] = this.isGeometryCollection;
        data["sortIndex"] = this.sortIndex;
        data["isRectangle"] = this.isRectangle;
        return data;
    }
}

export interface IGeometry {
    factory?: GeometryFactory | undefined;
    userData?: any | undefined;
    srid?: number;
    geometryType?: string | undefined;
    ogcGeometryType?: OgcGeometryType;
    precisionModel?: PrecisionModel | undefined;
    coordinate?: Coordinate | undefined;
    coordinates?: Coordinate[] | undefined;
    numPoints?: number;
    numGeometries?: number;
    isSimple?: boolean;
    isValid?: boolean;
    isEmpty?: boolean;
    area?: number;
    length?: number;
    centroid?: Point | undefined;
    interiorPoint?: Point | undefined;
    pointOnSurface?: Point | undefined;
    dimension?: Dimension;
    boundary?: Geometry | undefined;
    boundaryDimension?: Dimension;
    envelope?: Geometry | undefined;
    envelopeInternal?: Envelope | undefined;
    isGeometryCollection?: boolean;
    sortIndex?: SortIndexValue;
    isRectangle?: boolean;
}

export class Point extends Geometry implements IPoint {
    sortIndex?: SortIndexValue;
    coordinateSequence?: CoordinateSequence | undefined;
    coordinates?: Coordinate[] | undefined;
    numPoints?: number;
    isEmpty?: boolean;
    dimension?: Dimension;
    boundaryDimension?: Dimension;
    x?: number;
    y?: number;
    coordinate?: Coordinate | undefined;
    geometryType?: string | undefined;
    ogcGeometryType?: OgcGeometryType;
    boundary?: Geometry | undefined;
    z?: number;
    m?: number;

    constructor(data?: IPoint) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sortIndex = _data["sortIndex"];
            this.coordinateSequence = _data["coordinateSequence"] ? CoordinateSequence.fromJS(_data["coordinateSequence"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(Coordinate.fromJS(item));
            }
            this.numPoints = _data["numPoints"];
            this.isEmpty = _data["isEmpty"];
            this.dimension = _data["dimension"];
            this.boundaryDimension = _data["boundaryDimension"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            this.geometryType = _data["geometryType"];
            this.ogcGeometryType = _data["ogcGeometryType"];
            this.boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            this.z = _data["z"];
            this.m = _data["m"];
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortIndex"] = this.sortIndex;
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["isEmpty"] = this.isEmpty;
        data["dimension"] = this.dimension;
        data["boundaryDimension"] = this.boundaryDimension;
        data["x"] = this.x;
        data["y"] = this.y;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["z"] = this.z;
        data["m"] = this.m;
        super.toJSON(data);
        return data;
    }
}

export interface IPoint extends IGeometry {
    sortIndex?: SortIndexValue;
    coordinateSequence?: CoordinateSequence | undefined;
    coordinates?: Coordinate[] | undefined;
    numPoints?: number;
    isEmpty?: boolean;
    dimension?: Dimension;
    boundaryDimension?: Dimension;
    x?: number;
    y?: number;
    coordinate?: Coordinate | undefined;
    geometryType?: string | undefined;
    ogcGeometryType?: OgcGeometryType;
    boundary?: Geometry | undefined;
    z?: number;
    m?: number;
}

export enum SortIndexValue {
    Point = 0,
    MultiPoint = 1,
    LineString = 2,
    LinearRing = 3,
    MultiLineString = 4,
    Polygon = 5,
    MultiPolygon = 6,
    GeometryCollection = 7,
}

export abstract class CoordinateSequence implements ICoordinateSequence {
    dimension?: number;
    measures?: number;
    spatial?: number;
    ordinates?: Ordinates;
    hasZ?: boolean;
    hasM?: boolean;
    zOrdinateIndex?: number;
    mOrdinateIndex?: number;
    first?: Coordinate | undefined;
    last?: Coordinate | undefined;
    count?: number;

    constructor(data?: ICoordinateSequence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dimension = _data["dimension"];
            this.measures = _data["measures"];
            this.spatial = _data["spatial"];
            this.ordinates = _data["ordinates"];
            this.hasZ = _data["hasZ"];
            this.hasM = _data["hasM"];
            this.zOrdinateIndex = _data["zOrdinateIndex"];
            this.mOrdinateIndex = _data["mOrdinateIndex"];
            this.first = _data["first"] ? Coordinate.fromJS(_data["first"]) : <any>undefined;
            this.last = _data["last"] ? Coordinate.fromJS(_data["last"]) : <any>undefined;
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CoordinateSequence {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CoordinateSequence' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension;
        data["measures"] = this.measures;
        data["spatial"] = this.spatial;
        data["ordinates"] = this.ordinates;
        data["hasZ"] = this.hasZ;
        data["hasM"] = this.hasM;
        data["zOrdinateIndex"] = this.zOrdinateIndex;
        data["mOrdinateIndex"] = this.mOrdinateIndex;
        data["first"] = this.first ? this.first.toJSON() : <any>undefined;
        data["last"] = this.last ? this.last.toJSON() : <any>undefined;
        data["count"] = this.count;
        return data;
    }
}

export interface ICoordinateSequence {
    dimension?: number;
    measures?: number;
    spatial?: number;
    ordinates?: Ordinates;
    hasZ?: boolean;
    hasM?: boolean;
    zOrdinateIndex?: number;
    mOrdinateIndex?: number;
    first?: Coordinate | undefined;
    last?: Coordinate | undefined;
    count?: number;
}

export enum Ordinates {
    None = 0,
    X = 1,
    Spatial1 = 1,
    Y = 2,
    Spatial2 = 2,
    XY = 3,
    Z = 4,
    Spatial3 = 4,
    XYZ = 7,
    Spatial4 = 8,
    Spatial5 = 16,
    Spatial6 = 32,
    Spatial7 = 64,
    Spatial8 = 128,
    Spatial9 = 256,
    Spatial10 = 512,
    Spatial11 = 1024,
    Spatial12 = 2048,
    Spatial13 = 4096,
    Spatial14 = 8192,
    Spatial15 = 16384,
    Spatial16 = 32768,
    AllSpatialOrdinates = 65535,
    M = 65536,
    Measure1 = 65536,
    XYM = 65539,
    XYZM = 65543,
    Measure2 = 131072,
    Measure3 = 262144,
    Measure4 = 524288,
    Measure5 = 1048576,
    Measure6 = 2097152,
    Measure7 = 4194304,
    Measure8 = 8388608,
    Measure9 = 16777216,
    Measure10 = 33554432,
    Measure11 = 67108864,
    Measure12 = 134217728,
    Measure13 = 268435456,
    Measure14 = 536870912,
    Measure15 = 1073741824,
    Measure16 = -2147483648,
    AllMeasureOrdinates = -65536,
    AllOrdinates = -1,
}

export class Coordinate implements ICoordinate {
    x?: number;
    y?: number;
    z?: number;
    m?: number;
    coordinateValue?: Coordinate | undefined;
    isValid?: boolean;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
            this.m = _data["m"];
            this.coordinateValue = _data["coordinateValue"] ? Coordinate.fromJS(_data["coordinateValue"]) : <any>undefined;
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        data["m"] = this.m;
        data["coordinateValue"] = this.coordinateValue ? this.coordinateValue.toJSON() : <any>undefined;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface ICoordinate {
    x?: number;
    y?: number;
    z?: number;
    m?: number;
    coordinateValue?: Coordinate | undefined;
    isValid?: boolean;
}

export enum Dimension {
    Point = 0,
    P = 0,
    Curve = 1,
    L = 1,
    Surface = 2,
    A = 2,
    Collapse = 3,
    Dontcare = -3,
    True = -2,
    False = -1,
    Unknown = -1,
}

export enum OgcGeometryType {
    Point = 1,
    LineString = 2,
    Polygon = 3,
    MultiPoint = 4,
    MultiLineString = 5,
    MultiPolygon = 6,
    GeometryCollection = 7,
    CircularString = 8,
    CompoundCurve = 9,
    CurvePolygon = 10,
    MultiCurve = 11,
    MultiSurface = 12,
    Curve = 13,
    Surface = 14,
    PolyhedralSurface = 15,
    TIN = 16,
}

export class GeometryFactory implements IGeometryFactory {
    precisionModel?: PrecisionModel | undefined;
    coordinateSequenceFactory?: CoordinateSequenceFactory | undefined;
    srid?: number;
    geometryOverlay?: GeometryOverlay | undefined;
    coordinateEqualityComparer?: CoordinateEqualityComparer | undefined;
    geometryServices?: NtsGeometryServices | undefined;

    constructor(data?: IGeometryFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            this.coordinateSequenceFactory = _data["coordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["coordinateSequenceFactory"]) : <any>undefined;
            this.srid = _data["srid"];
            this.geometryOverlay = _data["geometryOverlay"] ? GeometryOverlay.fromJS(_data["geometryOverlay"]) : <any>undefined;
            this.coordinateEqualityComparer = _data["coordinateEqualityComparer"] ? CoordinateEqualityComparer.fromJS(_data["coordinateEqualityComparer"]) : <any>undefined;
            this.geometryServices = _data["geometryServices"] ? NtsGeometryServices.fromJS(_data["geometryServices"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeometryFactory {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["coordinateSequenceFactory"] = this.coordinateSequenceFactory ? this.coordinateSequenceFactory.toJSON() : <any>undefined;
        data["srid"] = this.srid;
        data["geometryOverlay"] = this.geometryOverlay ? this.geometryOverlay.toJSON() : <any>undefined;
        data["coordinateEqualityComparer"] = this.coordinateEqualityComparer ? this.coordinateEqualityComparer.toJSON() : <any>undefined;
        data["geometryServices"] = this.geometryServices ? this.geometryServices.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeometryFactory {
    precisionModel?: PrecisionModel | undefined;
    coordinateSequenceFactory?: CoordinateSequenceFactory | undefined;
    srid?: number;
    geometryOverlay?: GeometryOverlay | undefined;
    coordinateEqualityComparer?: CoordinateEqualityComparer | undefined;
    geometryServices?: NtsGeometryServices | undefined;
}

export class PrecisionModel implements IPrecisionModel {
    isFloating?: boolean;
    maximumSignificantDigits?: number;
    scale?: number;
    gridSize?: number;
    precisionModelType?: PrecisionModels;

    constructor(data?: IPrecisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFloating = _data["isFloating"];
            this.maximumSignificantDigits = _data["maximumSignificantDigits"];
            this.scale = _data["scale"];
            this.gridSize = _data["gridSize"];
            this.precisionModelType = _data["precisionModelType"];
        }
    }

    static fromJS(data: any): PrecisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrecisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFloating"] = this.isFloating;
        data["maximumSignificantDigits"] = this.maximumSignificantDigits;
        data["scale"] = this.scale;
        data["gridSize"] = this.gridSize;
        data["precisionModelType"] = this.precisionModelType;
        return data;
    }
}

export interface IPrecisionModel {
    isFloating?: boolean;
    maximumSignificantDigits?: number;
    scale?: number;
    gridSize?: number;
    precisionModelType?: PrecisionModels;
}

export enum PrecisionModels {
    Floating = 0,
    FloatingSingle = 1,
    Fixed = 2,
}

export abstract class CoordinateSequenceFactory implements ICoordinateSequenceFactory {
    ordinates?: Ordinates;

    constructor(data?: ICoordinateSequenceFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinates = _data["ordinates"];
        }
    }

    static fromJS(data: any): CoordinateSequenceFactory {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CoordinateSequenceFactory' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinates"] = this.ordinates;
        return data;
    }
}

export interface ICoordinateSequenceFactory {
    ordinates?: Ordinates;
}

export abstract class GeometryOverlay implements IGeometryOverlay {

    constructor(data?: IGeometryOverlay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GeometryOverlay {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'GeometryOverlay' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGeometryOverlay {
}

export abstract class EqualityComparerOfCoordinate implements IEqualityComparerOfCoordinate {

    constructor(data?: IEqualityComparerOfCoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): EqualityComparerOfCoordinate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EqualityComparerOfCoordinate' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEqualityComparerOfCoordinate {
}

export class CoordinateEqualityComparer extends EqualityComparerOfCoordinate implements ICoordinateEqualityComparer {

    constructor(data?: ICoordinateEqualityComparer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CoordinateEqualityComparer {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateEqualityComparer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICoordinateEqualityComparer extends IEqualityComparerOfCoordinate {
}

export class NtsGeometryServices implements INtsGeometryServices {
    geometryOverlay?: GeometryOverlay | undefined;
    coordinateEqualityComparer?: CoordinateEqualityComparer | undefined;
    defaultSRID?: number;
    defaultCoordinateSequenceFactory?: CoordinateSequenceFactory | undefined;
    defaultPrecisionModel?: PrecisionModel | undefined;
    numFactories?: number;

    constructor(data?: INtsGeometryServices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geometryOverlay = _data["geometryOverlay"] ? GeometryOverlay.fromJS(_data["geometryOverlay"]) : <any>undefined;
            this.coordinateEqualityComparer = _data["coordinateEqualityComparer"] ? CoordinateEqualityComparer.fromJS(_data["coordinateEqualityComparer"]) : <any>undefined;
            this.defaultSRID = _data["defaultSRID"];
            this.defaultCoordinateSequenceFactory = _data["defaultCoordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["defaultCoordinateSequenceFactory"]) : <any>undefined;
            this.defaultPrecisionModel = _data["defaultPrecisionModel"] ? PrecisionModel.fromJS(_data["defaultPrecisionModel"]) : <any>undefined;
            this.numFactories = _data["numFactories"];
        }
    }

    static fromJS(data: any): NtsGeometryServices {
        data = typeof data === 'object' ? data : {};
        let result = new NtsGeometryServices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geometryOverlay"] = this.geometryOverlay ? this.geometryOverlay.toJSON() : <any>undefined;
        data["coordinateEqualityComparer"] = this.coordinateEqualityComparer ? this.coordinateEqualityComparer.toJSON() : <any>undefined;
        data["defaultSRID"] = this.defaultSRID;
        data["defaultCoordinateSequenceFactory"] = this.defaultCoordinateSequenceFactory ? this.defaultCoordinateSequenceFactory.toJSON() : <any>undefined;
        data["defaultPrecisionModel"] = this.defaultPrecisionModel ? this.defaultPrecisionModel.toJSON() : <any>undefined;
        data["numFactories"] = this.numFactories;
        return data;
    }
}

export interface INtsGeometryServices {
    geometryOverlay?: GeometryOverlay | undefined;
    coordinateEqualityComparer?: CoordinateEqualityComparer | undefined;
    defaultSRID?: number;
    defaultCoordinateSequenceFactory?: CoordinateSequenceFactory | undefined;
    defaultPrecisionModel?: PrecisionModel | undefined;
    numFactories?: number;
}

export class Envelope implements IEnvelope {
    isNull?: boolean;
    width?: number;
    height?: number;
    diameter?: number;
    minX?: number;
    maxX?: number;
    minY?: number;
    maxY?: number;
    area?: number;
    minExtent?: number;
    maxExtent?: number;
    centre?: Coordinate | undefined;

    constructor(data?: IEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isNull = _data["isNull"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.diameter = _data["diameter"];
            this.minX = _data["minX"];
            this.maxX = _data["maxX"];
            this.minY = _data["minY"];
            this.maxY = _data["maxY"];
            this.area = _data["area"];
            this.minExtent = _data["minExtent"];
            this.maxExtent = _data["maxExtent"];
            this.centre = _data["centre"] ? Coordinate.fromJS(_data["centre"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Envelope {
        data = typeof data === 'object' ? data : {};
        let result = new Envelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNull"] = this.isNull;
        data["width"] = this.width;
        data["height"] = this.height;
        data["diameter"] = this.diameter;
        data["minX"] = this.minX;
        data["maxX"] = this.maxX;
        data["minY"] = this.minY;
        data["maxY"] = this.maxY;
        data["area"] = this.area;
        data["minExtent"] = this.minExtent;
        data["maxExtent"] = this.maxExtent;
        data["centre"] = this.centre ? this.centre.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnvelope {
    isNull?: boolean;
    width?: number;
    height?: number;
    diameter?: number;
    minX?: number;
    maxX?: number;
    minY?: number;
    maxY?: number;
    area?: number;
    minExtent?: number;
    maxExtent?: number;
    centre?: Coordinate | undefined;
}

export class GetBranchAddressViewModel implements IGetBranchAddressViewModel {
    id?: string;
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;

    constructor(data?: IGetBranchAddressViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.department = _data["department"];
            this.locality = _data["locality"];
            this.city = _data["city"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): GetBranchAddressViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchAddressViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["department"] = this.department;
        data["locality"] = this.locality;
        data["city"] = this.city;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IGetBranchAddressViewModel {
    id?: string;
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;
}

export class CreateBranchViewModel implements ICreateBranchViewModel {
    branchId?: string;
    addressId?: string;

    constructor(data?: ICreateBranchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.addressId = _data["addressId"];
        }
    }

    static fromJS(data: any): CreateBranchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBranchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["addressId"] = this.addressId;
        return data;
    }
}

export interface ICreateBranchViewModel {
    branchId?: string;
    addressId?: string;
}

export class CreateBranchCommandDto implements ICreateBranchCommandDto {
    name?: string;
    addressId?: string;
    subscriptionId?: string;
    enabled?: boolean;
    imageBlobStorageId?: string | undefined;
    code?: string;
    longitude?: number | undefined;
    latitude?: number | undefined;
    geocoordinate?: Point;
    address?: CreateBranchAddressCommandDto;

    constructor(data?: ICreateBranchCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.addressId = _data["addressId"];
            this.subscriptionId = _data["subscriptionId"];
            this.enabled = _data["enabled"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.code = _data["code"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.geocoordinate = _data["geocoordinate"] ? Point.fromJS(_data["geocoordinate"]) : <any>undefined;
            this.address = _data["address"] ? CreateBranchAddressCommandDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateBranchCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBranchCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["addressId"] = this.addressId;
        data["subscriptionId"] = this.subscriptionId;
        data["enabled"] = this.enabled;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["code"] = this.code;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateBranchCommandDto {
    name?: string;
    addressId?: string;
    subscriptionId?: string;
    enabled?: boolean;
    imageBlobStorageId?: string | undefined;
    code?: string;
    longitude?: number | undefined;
    latitude?: number | undefined;
    geocoordinate?: Point;
    address?: CreateBranchAddressCommandDto;
}

export class CreateBranchAddressCommandDto implements ICreateBranchAddressCommandDto {
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;

    constructor(data?: ICreateBranchAddressCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.department = _data["department"];
            this.locality = _data["locality"];
            this.city = _data["city"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): CreateBranchAddressCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBranchAddressCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["department"] = this.department;
        data["locality"] = this.locality;
        data["city"] = this.city;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface ICreateBranchAddressCommandDto {
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;
}

export class UpdateBranchViewModel implements IUpdateBranchViewModel {
    id?: string;

    constructor(data?: IUpdateBranchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateBranchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBranchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateBranchViewModel {
    id?: string;
}

export class UpdateBranchCommandDto implements IUpdateBranchCommandDto {
    id?: string;
    lastModifiedDate?: Date | undefined;
    name?: string;
    addressId?: string;
    subscriptionId?: string;
    enabled?: boolean;
    imageBlobStorageId?: string | undefined;
    code?: string;
    longitude?: number | undefined;
    latitude?: number | undefined;
    geocoordinate?: Point;
    address?: UpdateBranchAddressCommandDto;

    constructor(data?: IUpdateBranchCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.addressId = _data["addressId"];
            this.subscriptionId = _data["subscriptionId"];
            this.enabled = _data["enabled"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.code = _data["code"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.geocoordinate = _data["geocoordinate"] ? Point.fromJS(_data["geocoordinate"]) : <any>undefined;
            this.address = _data["address"] ? UpdateBranchAddressCommandDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateBranchCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBranchCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["addressId"] = this.addressId;
        data["subscriptionId"] = this.subscriptionId;
        data["enabled"] = this.enabled;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["code"] = this.code;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateBranchCommandDto {
    id?: string;
    lastModifiedDate?: Date | undefined;
    name?: string;
    addressId?: string;
    subscriptionId?: string;
    enabled?: boolean;
    imageBlobStorageId?: string | undefined;
    code?: string;
    longitude?: number | undefined;
    latitude?: number | undefined;
    geocoordinate?: Point;
    address?: UpdateBranchAddressCommandDto;
}

export class UpdateBranchAddressCommandDto implements IUpdateBranchAddressCommandDto {
    id?: string;
    lastModifiedDate?: Date | undefined;
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;

    constructor(data?: IUpdateBranchAddressCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.department = _data["department"];
            this.locality = _data["locality"];
            this.city = _data["city"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): UpdateBranchAddressCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBranchAddressCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["department"] = this.department;
        data["locality"] = this.locality;
        data["city"] = this.city;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IUpdateBranchAddressCommandDto {
    id?: string;
    lastModifiedDate?: Date | undefined;
    organizationId?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;
}

export class DeleteBranchViewModel implements IDeleteBranchViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteBranchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteBranchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBranchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteBranchViewModel {
    id?: string | undefined;
}

export class NotificationViewModel implements INotificationViewModel {
    notifications?: GetNotificationByUserIdDto[];

    constructor(data?: INotificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(GetNotificationByUserIdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationViewModel {
    notifications?: GetNotificationByUserIdDto[];
}

export class GetNotificationByUserIdDto implements IGetNotificationByUserIdDto {
    providerId?: string;
    notificationId?: string;
    subjectPath?: any[] | undefined;
    subjectId?: string | undefined;
    subjectType?: number;
    title?: string;
    message?: string;
    iconType?: number;
    date?: Date;
    externalLink?: string | undefined;

    constructor(data?: IGetNotificationByUserIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data["providerId"];
            this.notificationId = _data["notificationId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectId = _data["subjectId"];
            this.subjectType = _data["subjectType"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.iconType = _data["iconType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.externalLink = _data["externalLink"];
        }
    }

    static fromJS(data: any): GetNotificationByUserIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationByUserIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerId"] = this.providerId;
        data["notificationId"] = this.notificationId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectId"] = this.subjectId;
        data["subjectType"] = this.subjectType;
        data["title"] = this.title;
        data["message"] = this.message;
        data["iconType"] = this.iconType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["externalLink"] = this.externalLink;
        return data;
    }
}

export interface IGetNotificationByUserIdDto {
    providerId?: string;
    notificationId?: string;
    subjectPath?: any[] | undefined;
    subjectId?: string | undefined;
    subjectType?: number;
    title?: string;
    message?: string;
    iconType?: number;
    date?: Date;
    externalLink?: string | undefined;
}

export class GetAvailableBranchFiltersViewModel implements IGetAvailableBranchFiltersViewModel {
    tabs?: GetAvailableBranchFiltersDto[];

    constructor(data?: IGetAvailableBranchFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tabs"])) {
                this.tabs = [] as any;
                for (let item of _data["tabs"])
                    this.tabs!.push(GetAvailableBranchFiltersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableBranchFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableBranchFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tabs)) {
            data["tabs"] = [];
            for (let item of this.tabs)
                data["tabs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAvailableBranchFiltersViewModel {
    tabs?: GetAvailableBranchFiltersDto[];
}

export class GetAvailableBranchFiltersDto implements IGetAvailableBranchFiltersDto {
    name?: string;
    children?: GetAvailableBranchFiltersChildrenDto[];

    constructor(data?: IGetAvailableBranchFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(GetAvailableBranchFiltersChildrenDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableBranchFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableBranchFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAvailableBranchFiltersDto {
    name?: string;
    children?: GetAvailableBranchFiltersChildrenDto[];
}

export class GetAvailableBranchFiltersChildrenDto implements IGetAvailableBranchFiltersChildrenDto {
    id?: string | undefined;
    name?: string;
    visibility?: BranchVisibility;
    type?: GetAvailableBranchFiltersChildrenType;
    children?: GetAvailableBranchFiltersChildrenDto[] | undefined;

    constructor(data?: IGetAvailableBranchFiltersChildrenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.visibility = _data["visibility"];
            this.type = _data["type"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(GetAvailableBranchFiltersChildrenDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAvailableBranchFiltersChildrenDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAvailableBranchFiltersChildrenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["visibility"] = this.visibility;
        data["type"] = this.type;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAvailableBranchFiltersChildrenDto {
    id?: string | undefined;
    name?: string;
    visibility?: BranchVisibility;
    type?: GetAvailableBranchFiltersChildrenType;
    children?: GetAvailableBranchFiltersChildrenDto[] | undefined;
}

export enum BranchVisibility {
    Active = 0,
    OnceActive = 1,
    Inactive = 2,
}

export enum GetAvailableBranchFiltersChildrenType {
    Unit = 0,
    Group = 1,
}

export class BranchTreeViewModel implements IBranchTreeViewModel {
    branchTrees?: BranchTreeDto[];
    branchCount?: number;
    branchTotalCount?: number;

    constructor(data?: IBranchTreeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branchTrees"])) {
                this.branchTrees = [] as any;
                for (let item of _data["branchTrees"])
                    this.branchTrees!.push(BranchTreeDto.fromJS(item));
            }
            this.branchCount = _data["branchCount"];
            this.branchTotalCount = _data["branchTotalCount"];
        }
    }

    static fromJS(data: any): BranchTreeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTreeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branchTrees)) {
            data["branchTrees"] = [];
            for (let item of this.branchTrees)
                data["branchTrees"].push(item.toJSON());
        }
        data["branchCount"] = this.branchCount;
        data["branchTotalCount"] = this.branchTotalCount;
        return data;
    }
}

export interface IBranchTreeViewModel {
    branchTrees?: BranchTreeDto[];
    branchCount?: number;
    branchTotalCount?: number;
}

export class BranchTreeDto implements IBranchTreeDto {
    id?: string;
    name?: string;
    code?: string;
    address?: AddressTypeDto;
    branchGroupChildrens?: BranchTreeDto[];
    children?: BranchTreeDto[];

    constructor(data?: IBranchTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"] ? AddressTypeDto.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["branchGroupChildrens"])) {
                this.branchGroupChildrens = [] as any;
                for (let item of _data["branchGroupChildrens"])
                    this.branchGroupChildrens!.push(BranchTreeDto.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BranchTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.branchGroupChildrens)) {
            data["branchGroupChildrens"] = [];
            for (let item of this.branchGroupChildrens)
                data["branchGroupChildrens"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchTreeDto {
    id?: string;
    name?: string;
    code?: string;
    address?: AddressTypeDto;
    branchGroupChildrens?: BranchTreeDto[];
    children?: BranchTreeDto[];
}

export class AddressTypeDto implements IAddressTypeDto {
    id?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;

    constructor(data?: IAddressTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.country = _data["country"];
            this.department = _data["department"];
            this.locality = _data["locality"];
            this.city = _data["city"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): AddressTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["country"] = this.country;
        data["department"] = this.department;
        data["locality"] = this.locality;
        data["city"] = this.city;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IAddressTypeDto {
    id?: string;
    country?: string;
    department?: string;
    locality?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;
}

export class GetBrandGroupFiltersViewModel implements IGetBrandGroupFiltersViewModel {
    brands?: GetBrandGroupFiltersBrandDto[];

    constructor(data?: IGetBrandGroupFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["brands"])) {
                this.brands = [] as any;
                for (let item of _data["brands"])
                    this.brands!.push(GetBrandGroupFiltersBrandDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBrandGroupFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandGroupFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBrandGroupFiltersViewModel {
    brands?: GetBrandGroupFiltersBrandDto[];
}

export class GetBrandGroupFiltersBrandDto implements IGetBrandGroupFiltersBrandDto {
    id?: string;
    name?: string;
    branches?: GetBrandGroupFiltersBrandBranchDto[];

    constructor(data?: IGetBrandGroupFiltersBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetBrandGroupFiltersBrandBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBrandGroupFiltersBrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandGroupFiltersBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBrandGroupFiltersBrandDto {
    id?: string;
    name?: string;
    branches?: GetBrandGroupFiltersBrandBranchDto[];
}

export class GetBrandGroupFiltersBrandBranchDto implements IGetBrandGroupFiltersBrandBranchDto {
    id?: string;
    name?: string;

    constructor(data?: IGetBrandGroupFiltersBrandBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetBrandGroupFiltersBrandBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandGroupFiltersBrandBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetBrandGroupFiltersBrandBranchDto {
    id?: string;
    name?: string;
}

export class GetCompetitorBranchGroupFiltersViewModel implements IGetCompetitorBranchGroupFiltersViewModel {
    competitorGroups?: GetCompetitorBranchGroupFiltersCompetitorBranchGroupDto[];

    constructor(data?: IGetCompetitorBranchGroupFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["competitorGroups"])) {
                this.competitorGroups = [] as any;
                for (let item of _data["competitorGroups"])
                    this.competitorGroups!.push(GetCompetitorBranchGroupFiltersCompetitorBranchGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompetitorBranchGroupFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompetitorBranchGroupFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.competitorGroups)) {
            data["competitorGroups"] = [];
            for (let item of this.competitorGroups)
                data["competitorGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompetitorBranchGroupFiltersViewModel {
    competitorGroups?: GetCompetitorBranchGroupFiltersCompetitorBranchGroupDto[];
}

export class GetCompetitorBranchGroupFiltersCompetitorBranchGroupDto implements IGetCompetitorBranchGroupFiltersCompetitorBranchGroupDto {
    id?: string;
    name?: string;
    branches?: GetCompetitorBranchGroupFiltersCompetitorBranchDto[];

    constructor(data?: IGetCompetitorBranchGroupFiltersCompetitorBranchGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetCompetitorBranchGroupFiltersCompetitorBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCompetitorBranchGroupFiltersCompetitorBranchGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompetitorBranchGroupFiltersCompetitorBranchGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCompetitorBranchGroupFiltersCompetitorBranchGroupDto {
    id?: string;
    name?: string;
    branches?: GetCompetitorBranchGroupFiltersCompetitorBranchDto[];
}

export class GetCompetitorBranchGroupFiltersCompetitorBranchDto implements IGetCompetitorBranchGroupFiltersCompetitorBranchDto {
    id?: string;
    name?: string;

    constructor(data?: IGetCompetitorBranchGroupFiltersCompetitorBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCompetitorBranchGroupFiltersCompetitorBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompetitorBranchGroupFiltersCompetitorBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCompetitorBranchGroupFiltersCompetitorBranchDto {
    id?: string;
    name?: string;
}

export class GetGlobalNotificationsViewModel implements IGetGlobalNotificationsViewModel {
    notifications?: GlobalNotificationDto[];

    constructor(data?: IGetGlobalNotificationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(GlobalNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGlobalNotificationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetGlobalNotificationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGlobalNotificationsViewModel {
    notifications?: GlobalNotificationDto[];
}

export class GlobalNotificationDto implements IGlobalNotificationDto {
    id?: string;
    title?: string;
    data?: string;

    constructor(data?: IGlobalNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GlobalNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["data"] = this.data;
        return data;
    }
}

export interface IGlobalNotificationDto {
    id?: string;
    title?: string;
    data?: string;
}

export class IndustriesViewModel implements IIndustriesViewModel {
    industries?: IndustryDto[];

    constructor(data?: IIndustriesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["industries"])) {
                this.industries = [] as any;
                for (let item of _data["industries"])
                    this.industries!.push(IndustryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndustriesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IndustriesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.industries)) {
            data["industries"] = [];
            for (let item of this.industries)
                data["industries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIndustriesViewModel {
    industries?: IndustryDto[];
}

export class IndustryDto implements IIndustryDto {
    id?: string;
    name?: string;
    text?: string;
    code?: string;
    order?: number;
    isEnabled?: boolean;

    constructor(data?: IIndustryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.code = _data["code"];
            this.order = _data["order"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): IndustryDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["text"] = this.text;
        data["code"] = this.code;
        data["order"] = this.order;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IIndustryDto {
    id?: string;
    name?: string;
    text?: string;
    code?: string;
    order?: number;
    isEnabled?: boolean;
}

export class IndustryViewModel implements IIndustryViewModel {
    industry?: IndustryDto2;

    constructor(data?: IIndustryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.industry = _data["industry"] ? IndustryDto2.fromJS(_data["industry"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IndustryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industry"] = this.industry ? this.industry.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIndustryViewModel {
    industry?: IndustryDto2;
}

export class IndustryDto2 implements IIndustryDto2 {
    id?: string;
    name?: string;
    text?: string;
    code?: string;
    order?: number;
    isEnabled?: boolean;

    constructor(data?: IIndustryDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.code = _data["code"];
            this.order = _data["order"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): IndustryDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["text"] = this.text;
        data["code"] = this.code;
        data["order"] = this.order;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IIndustryDto2 {
    id?: string;
    name?: string;
    text?: string;
    code?: string;
    order?: number;
    isEnabled?: boolean;
}

export class IndustryInformationViewModel implements IIndustryInformationViewModel {
    industryInformation?: IndustryInformationDto[];

    constructor(data?: IIndustryInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["industryInformation"])) {
                this.industryInformation = [] as any;
                for (let item of _data["industryInformation"])
                    this.industryInformation!.push(IndustryInformationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndustryInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.industryInformation)) {
            data["industryInformation"] = [];
            for (let item of this.industryInformation)
                data["industryInformation"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIndustryInformationViewModel {
    industryInformation?: IndustryInformationDto[];
}

export class IndustryInformationDto implements IIndustryInformationDto {
    id?: string;
    industryId?: string;
    questionType?: QuestionType;
    order?: number;

    constructor(data?: IIndustryInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryId = _data["industryId"];
            this.questionType = _data["questionType"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): IndustryInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryId"] = this.industryId;
        data["questionType"] = this.questionType;
        data["order"] = this.order;
        return data;
    }
}

export interface IIndustryInformationDto {
    id?: string;
    industryId?: string;
    questionType?: QuestionType;
    order?: number;
}

export enum QuestionType {
    Name = 0,
    NumberOfEmployees = 1,
    RestaurantType = 2,
    HasWebsite = 3,
}

export class IndustryServiceViewModel implements IIndustryServiceViewModel {
    industryServices?: IndustryServiceDto[];

    constructor(data?: IIndustryServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["industryServices"])) {
                this.industryServices = [] as any;
                for (let item of _data["industryServices"])
                    this.industryServices!.push(IndustryServiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndustryServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.industryServices)) {
            data["industryServices"] = [];
            for (let item of this.industryServices)
                data["industryServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIndustryServiceViewModel {
    industryServices?: IndustryServiceDto[];
}

export class IndustryServiceDto implements IIndustryServiceDto {
    id?: string;
    industryId?: string;
    name?: string;
    shortName?: string;
    code?: string;
    order?: number;

    constructor(data?: IIndustryServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryId = _data["industryId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): IndustryServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryId"] = this.industryId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        data["order"] = this.order;
        return data;
    }
}

export interface IIndustryServiceDto {
    id?: string;
    industryId?: string;
    name?: string;
    shortName?: string;
    code?: string;
    order?: number;
}

export class GetOrganizationAndSubscriptionViewModel implements IGetOrganizationAndSubscriptionViewModel {
    menuItems?: MenuItemDto[];

    constructor(data?: IGetOrganizationAndSubscriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["menuItems"])) {
                this.menuItems = [] as any;
                for (let item of _data["menuItems"])
                    this.menuItems!.push(MenuItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrganizationAndSubscriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationAndSubscriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuItems)) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrganizationAndSubscriptionViewModel {
    menuItems?: MenuItemDto[];
}

export class MenuItemDto implements IMenuItemDto {
    id?: string;
    text?: string;
    type?: MenuItemType;
    role?: HierarchyRoleType | undefined;
    subjectPath?: any[];
    subjectType?: SubjectType;
    children?: MenuItemDto[];

    constructor(data?: IMenuItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.type = _data["type"];
            this.role = _data["role"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(MenuItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["type"] = this.type;
        data["role"] = this.role;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMenuItemDto {
    id?: string;
    text?: string;
    type?: MenuItemType;
    role?: HierarchyRoleType | undefined;
    subjectPath?: any[];
    subjectType?: SubjectType;
    children?: MenuItemDto[];
}

export enum MenuItemType {
    Organization = 0,
    Subscription = 1,
    VoiceOfCustomer = 2,
    SocialListening = 3,
    Localtrac = 4,
    MysteryShopping = 5,
    MysteryShoppingLegacy = 6,
    ContractTracing = 7,
    Project = 8,
    MysteryShoppingProject = 9,
    Unknown = -1,
}

export class GetPermissionMenuTreeByOrganisationViewModel implements IGetPermissionMenuTreeByOrganisationViewModel {
    menu?: MenuItemDto;

    constructor(data?: IGetPermissionMenuTreeByOrganisationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menu = _data["menu"] ? MenuItemDto.fromJS(_data["menu"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPermissionMenuTreeByOrganisationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionMenuTreeByOrganisationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPermissionMenuTreeByOrganisationViewModel {
    menu?: MenuItemDto;
}

export class GetPermissionMenuTreeBySubscriptionViewModel implements IGetPermissionMenuTreeBySubscriptionViewModel {
    menu?: MenuItemDto;

    constructor(data?: IGetPermissionMenuTreeBySubscriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menu = _data["menu"] ? MenuItemDto.fromJS(_data["menu"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPermissionMenuTreeBySubscriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionMenuTreeBySubscriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPermissionMenuTreeBySubscriptionViewModel {
    menu?: MenuItemDto;
}

export class GetSubscriptionServicesViewModel implements IGetSubscriptionServicesViewModel {
    menuItems?: MenuItemDto[];

    constructor(data?: IGetSubscriptionServicesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["menuItems"])) {
                this.menuItems = [] as any;
                for (let item of _data["menuItems"])
                    this.menuItems!.push(MenuItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSubscriptionServicesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionServicesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuItems)) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSubscriptionServicesViewModel {
    menuItems?: MenuItemDto[];
}

export class GetMenuSettingsBySubjectIdViewmodel implements IGetMenuSettingsBySubjectIdViewmodel {
    menuSettingsDto?: MenuSettingsDto[];

    constructor(data?: IGetMenuSettingsBySubjectIdViewmodel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["menuSettingsDto"])) {
                this.menuSettingsDto = [] as any;
                for (let item of _data["menuSettingsDto"])
                    this.menuSettingsDto!.push(MenuSettingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMenuSettingsBySubjectIdViewmodel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMenuSettingsBySubjectIdViewmodel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuSettingsDto)) {
            data["menuSettingsDto"] = [];
            for (let item of this.menuSettingsDto)
                data["menuSettingsDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMenuSettingsBySubjectIdViewmodel {
    menuSettingsDto?: MenuSettingsDto[];
}

export class MenuSettingsDto implements IMenuSettingsDto {
    name?: string;
    type?: string;
    order?: number;
    enabled?: boolean;

    constructor(data?: IMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.order = _data["order"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): MenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["order"] = this.order;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IMenuSettingsDto {
    name?: string;
    type?: string;
    order?: number;
    enabled?: boolean;
}

export class OrganizationsViewModel implements IOrganizationsViewModel {
    organizations?: OrganizationDto[];

    constructor(data?: IOrganizationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationsViewModel {
    organizations?: OrganizationDto[];
}

export class OrganizationDto implements IOrganizationDto {
    id?: string;
    name?: string;
    displayName?: string;
    normalizedName?: string;
    isSaas?: boolean;
    subscriptions?: SubscriptionDto[];

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.isSaas = _data["isSaas"];
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(SubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["isSaas"] = this.isSaas;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationDto {
    id?: string;
    name?: string;
    displayName?: string;
    normalizedName?: string;
    isSaas?: boolean;
    subscriptions?: SubscriptionDto[];
}

export class SubscriptionDto implements ISubscriptionDto {
    id?: string;
    organizationId?: string;
    name?: string;
    email?: string;
    normalizedName?: string;
    subjectPath?: string;
    subscriptionServices?: SubscriptionServiceDto[];

    constructor(data?: ISubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.normalizedName = _data["normalizedName"];
            this.subjectPath = _data["subjectPath"];
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(SubscriptionServiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["normalizedName"] = this.normalizedName;
        data["subjectPath"] = this.subjectPath;
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscriptionDto {
    id?: string;
    organizationId?: string;
    name?: string;
    email?: string;
    normalizedName?: string;
    subjectPath?: string;
    subscriptionServices?: SubscriptionServiceDto[];
}

export class SubscriptionServiceDto implements ISubscriptionServiceDto {
    id?: string;
    displayName?: string;
    serviceId?: string;

    constructor(data?: ISubscriptionServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): SubscriptionServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["serviceId"] = this.serviceId;
        return data;
    }
}

export interface ISubscriptionServiceDto {
    id?: string;
    displayName?: string;
    serviceId?: string;
}

export class OrganizationViewModel implements IOrganizationViewModel {
    organization?: OrganizationDto;

    constructor(data?: IOrganizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organization = _data["organization"] ? OrganizationDto.fromJS(_data["organization"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrganizationViewModel {
    organization?: OrganizationDto;
}

export class CreateOrganizationViewModel implements ICreateOrganizationViewModel {
    id?: string;

    constructor(data?: ICreateOrganizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrganizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrganizationViewModel {
    id?: string;
}

export class CreateOrganizationCommandDto implements ICreateOrganizationCommandDto {
    name?: string;
    displayName?: string;
    email?: string;
    imageBlobStorageId?: string | undefined;

    constructor(data?: ICreateOrganizationCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
        }
    }

    static fromJS(data: any): CreateOrganizationCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        return data;
    }
}

export interface ICreateOrganizationCommandDto {
    name?: string;
    displayName?: string;
    email?: string;
    imageBlobStorageId?: string | undefined;
}

export class UpdateOrganizationViewModel implements IUpdateOrganizationViewModel {
    id?: string;

    constructor(data?: IUpdateOrganizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateOrganizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateOrganizationViewModel {
    id?: string;
}

export class UpdateOrganizationCommandDto implements IUpdateOrganizationCommandDto {
    id?: string;
    name?: string;
    displayName?: string;
    email?: string;
    imageBlobStorageId?: string | undefined;

    constructor(data?: IUpdateOrganizationCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
        }
    }

    static fromJS(data: any): UpdateOrganizationCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        return data;
    }
}

export interface IUpdateOrganizationCommandDto {
    id?: string;
    name?: string;
    displayName?: string;
    email?: string;
    imageBlobStorageId?: string | undefined;
}

export class DeleteOrganizationViewModel implements IDeleteOrganizationViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteOrganizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteOrganizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrganizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteOrganizationViewModel {
    id?: string | undefined;
}

export class DeleteOrganizationCommandDto implements IDeleteOrganizationCommandDto {
    id?: string;

    constructor(data?: IDeleteOrganizationCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteOrganizationCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrganizationCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteOrganizationCommandDto {
    id?: string;
}

export class OrganizationDomainsViewModel implements IOrganizationDomainsViewModel {
    organizationId?: string;
    domains?: OrganizationDomain[];
    textAreaDomains?: string;

    constructor(data?: IOrganizationDomainsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            if (Array.isArray(_data["domains"])) {
                this.domains = [] as any;
                for (let item of _data["domains"])
                    this.domains!.push(OrganizationDomain.fromJS(item));
            }
            this.textAreaDomains = _data["textAreaDomains"];
        }
    }

    static fromJS(data: any): OrganizationDomainsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDomainsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        if (Array.isArray(this.domains)) {
            data["domains"] = [];
            for (let item of this.domains)
                data["domains"].push(item.toJSON());
        }
        data["textAreaDomains"] = this.textAreaDomains;
        return data;
    }
}

export interface IOrganizationDomainsViewModel {
    organizationId?: string;
    domains?: OrganizationDomain[];
    textAreaDomains?: string;
}

export abstract class EntityBase implements IEntityBase {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;

    constructor(data?: IEntityBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEntityBase {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
}

export class OrganizationDomain extends EntityBase implements IOrganizationDomain {
    organizationId?: string;
    domain?: string | undefined;

    constructor(data?: IOrganizationDomain) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): OrganizationDomain {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDomain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["domain"] = this.domain;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationDomain extends IEntityBase {
    organizationId?: string;
    domain?: string | undefined;
}

export class UpdateOrganizationDomainsDto implements IUpdateOrganizationDomainsDto {
    organizationId?: string;
    domains?: string;

    constructor(data?: IUpdateOrganizationDomainsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.domains = _data["domains"];
        }
    }

    static fromJS(data: any): UpdateOrganizationDomainsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationDomainsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["domains"] = this.domains;
        return data;
    }
}

export interface IUpdateOrganizationDomainsDto {
    organizationId?: string;
    domains?: string;
}

export class GetServiceViewModel implements IGetServiceViewModel {
    id?: string;
    name?: string;
    imagePath?: string;
    displayName?: string;
    description?: string;

    constructor(data?: IGetServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imagePath = _data["imagePath"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imagePath"] = this.imagePath;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetServiceViewModel {
    id?: string;
    name?: string;
    imagePath?: string;
    displayName?: string;
    description?: string;
}

export class GetServicesViewModel implements IGetServicesViewModel {
    services?: Service[];

    constructor(data?: IGetServicesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(Service.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetServicesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetServicesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetServicesViewModel {
    services?: Service[];
}

export class Service extends EntityBase implements IService {
    name?: string | undefined;
    imagePath?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    isPrivate?: boolean | undefined;
    industryId?: string | undefined;

    constructor(data?: IService) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.imagePath = _data["imagePath"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isPrivate = _data["isPrivate"];
            this.industryId = _data["industryId"];
        }
    }

    static fromJS(data: any): Service {
        data = typeof data === 'object' ? data : {};
        let result = new Service();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["imagePath"] = this.imagePath;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isPrivate"] = this.isPrivate;
        data["industryId"] = this.industryId;
        super.toJSON(data);
        return data;
    }
}

export interface IService extends IEntityBase {
    name?: string | undefined;
    imagePath?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    isPrivate?: boolean | undefined;
    industryId?: string | undefined;
}

export class CreateServiceViewModel implements ICreateServiceViewModel {
    id?: string;

    constructor(data?: ICreateServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateServiceViewModel {
    id?: string;
}

export class CreateServiceCommandDto implements ICreateServiceCommandDto {
    name?: string;
    imagePath?: string;
    displayName?: string;
    description?: string;

    constructor(data?: ICreateServiceCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.imagePath = _data["imagePath"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateServiceCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["imagePath"] = this.imagePath;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateServiceCommandDto {
    name?: string;
    imagePath?: string;
    displayName?: string;
    description?: string;
}

export class UpdateServiceViewModel implements IUpdateServiceViewModel {
    id?: string;

    constructor(data?: IUpdateServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateServiceViewModel {
    id?: string;
}

export class UpdateServiceCommandDto implements IUpdateServiceCommandDto {
    id?: string;
    name?: string;
    imagePath?: string;
    displayName?: string;
    description?: string;

    constructor(data?: IUpdateServiceCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imagePath = _data["imagePath"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateServiceCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imagePath"] = this.imagePath;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateServiceCommandDto {
    id?: string;
    name?: string;
    imagePath?: string;
    displayName?: string;
    description?: string;
}

export class DeleteServiceViewModel implements IDeleteServiceViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteServiceViewModel {
    id?: string | undefined;
}

export class CreateSubscriptionViewModel implements ICreateSubscriptionViewModel {
    organizationId?: string;
    id?: string;

    constructor(data?: ICreateSubscriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateSubscriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateSubscriptionViewModel {
    organizationId?: string;
    id?: string;
}

export class CreateSubscriptionCommandDto implements ICreateSubscriptionCommandDto {
    organizationId?: string;
    name?: string;
    normalizedName?: string;
    email?: string;
    imageBlobStorageId?: string | undefined;
    industryId?: string | undefined;

    constructor(data?: ICreateSubscriptionCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.email = _data["email"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.industryId = _data["industryId"];
        }
    }

    static fromJS(data: any): CreateSubscriptionCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["email"] = this.email;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["industryId"] = this.industryId;
        return data;
    }
}

export interface ICreateSubscriptionCommandDto {
    organizationId?: string;
    name?: string;
    normalizedName?: string;
    email?: string;
    imageBlobStorageId?: string | undefined;
    industryId?: string | undefined;
}

export class UpdateSubscriptionViewModel implements IUpdateSubscriptionViewModel {
    subscriptionId?: string;

    constructor(data?: IUpdateSubscriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): UpdateSubscriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubscriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface IUpdateSubscriptionViewModel {
    subscriptionId?: string;
}

export class UpdateSubscriptionCommandDto implements IUpdateSubscriptionCommandDto {
    id?: string;
    organizationId?: string;
    name?: string;
    normalizedName?: string;
    email?: string;
    imageBlobStorageId?: string | undefined;
    industryId?: string | undefined;

    constructor(data?: IUpdateSubscriptionCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.email = _data["email"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.industryId = _data["industryId"];
        }
    }

    static fromJS(data: any): UpdateSubscriptionCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubscriptionCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["email"] = this.email;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["industryId"] = this.industryId;
        return data;
    }
}

export interface IUpdateSubscriptionCommandDto {
    id?: string;
    organizationId?: string;
    name?: string;
    normalizedName?: string;
    email?: string;
    imageBlobStorageId?: string | undefined;
    industryId?: string | undefined;
}

export class DeleteSubscriptionViewModel implements IDeleteSubscriptionViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteSubscriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteSubscriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSubscriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteSubscriptionViewModel {
    id?: string | undefined;
}

export class GetSubscriptionByIdViewModel implements IGetSubscriptionByIdViewModel {
    subscription?: SubscriptionDto;

    constructor(data?: IGetSubscriptionByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscription = _data["subscription"] ? SubscriptionDto.fromJS(_data["subscription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSubscriptionByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSubscriptionByIdViewModel {
    subscription?: SubscriptionDto;
}

export class SubscriptionInformationViewModel implements ISubscriptionInformationViewModel {
    subscriptionInformation?: SubscriptionInformationDto[];

    constructor(data?: ISubscriptionInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subscriptionInformation"])) {
                this.subscriptionInformation = [] as any;
                for (let item of _data["subscriptionInformation"])
                    this.subscriptionInformation!.push(SubscriptionInformationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscriptionInformation)) {
            data["subscriptionInformation"] = [];
            for (let item of this.subscriptionInformation)
                data["subscriptionInformation"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscriptionInformationViewModel {
    subscriptionInformation?: SubscriptionInformationDto[];
}

export class SubscriptionInformationDto implements ISubscriptionInformationDto {
    id?: string;
    subscriptionId?: string;
    key?: QuestionType;
    value?: string;

    constructor(data?: ISubscriptionInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriptionId = _data["subscriptionId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SubscriptionInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriptionId"] = this.subscriptionId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ISubscriptionInformationDto {
    id?: string;
    subscriptionId?: string;
    key?: QuestionType;
    value?: string;
}

export class SubscriptionDomainsViewModel implements ISubscriptionDomainsViewModel {
    subscriptionId?: string;
    domains?: SubscriptionDomain[];
    textAreaDomains?: string;

    constructor(data?: ISubscriptionDomainsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            if (Array.isArray(_data["domains"])) {
                this.domains = [] as any;
                for (let item of _data["domains"])
                    this.domains!.push(SubscriptionDomain.fromJS(item));
            }
            this.textAreaDomains = _data["textAreaDomains"];
        }
    }

    static fromJS(data: any): SubscriptionDomainsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionDomainsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        if (Array.isArray(this.domains)) {
            data["domains"] = [];
            for (let item of this.domains)
                data["domains"].push(item.toJSON());
        }
        data["textAreaDomains"] = this.textAreaDomains;
        return data;
    }
}

export interface ISubscriptionDomainsViewModel {
    subscriptionId?: string;
    domains?: SubscriptionDomain[];
    textAreaDomains?: string;
}

export class SubscriptionDomain extends EntityBase implements ISubscriptionDomain {
    subscriptionId?: string;
    domain?: string | undefined;

    constructor(data?: ISubscriptionDomain) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): SubscriptionDomain {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionDomain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["domain"] = this.domain;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionDomain extends IEntityBase {
    subscriptionId?: string;
    domain?: string | undefined;
}

export class SubscriptionBranchesViewModel implements ISubscriptionBranchesViewModel {
    branches?: BranchSearchResult[];

    constructor(data?: ISubscriptionBranchesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchSearchResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionBranchesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionBranchesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscriptionBranchesViewModel {
    branches?: BranchSearchResult[];
}

export class BranchSearchResult implements IBranchSearchResult {
    id?: string;
    name?: string;
    code?: string;

    constructor(data?: IBranchSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): BranchSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new BranchSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IBranchSearchResult {
    id?: string;
    name?: string;
    code?: string;
}

export class UpdateSubscriptionDomainsDto implements IUpdateSubscriptionDomainsDto {
    subscriptionId?: string;
    domains?: string;

    constructor(data?: IUpdateSubscriptionDomainsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.domains = _data["domains"];
        }
    }

    static fromJS(data: any): UpdateSubscriptionDomainsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubscriptionDomainsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["domains"] = this.domains;
        return data;
    }
}

export interface IUpdateSubscriptionDomainsDto {
    subscriptionId?: string;
    domains?: string;
}

export class ConvertContactTracingSubscriptionToOrganizationViewModel implements IConvertContactTracingSubscriptionToOrganizationViewModel {
    organizationId?: string;

    constructor(data?: IConvertContactTracingSubscriptionToOrganizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): ConvertContactTracingSubscriptionToOrganizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertContactTracingSubscriptionToOrganizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IConvertContactTracingSubscriptionToOrganizationViewModel {
    organizationId?: string;
}

export class GetSubscriptionServiceHierarchyViewModel implements IGetSubscriptionServiceHierarchyViewModel {
    subscriptionServiceId?: string;
    subscriptionId?: string;
    organizationId?: string;

    constructor(data?: IGetSubscriptionServiceHierarchyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.subscriptionId = _data["subscriptionId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): GetSubscriptionServiceHierarchyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionServiceHierarchyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["subscriptionId"] = this.subscriptionId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IGetSubscriptionServiceHierarchyViewModel {
    subscriptionServiceId?: string;
    subscriptionId?: string;
    organizationId?: string;
}

export class GetDashboardMenuViewModel implements IGetDashboardMenuViewModel {
    dashboards?: GetDashboardMenuDto[];
    projectHierarchies?: MenuItem[];

    constructor(data?: IGetDashboardMenuViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dashboards"])) {
                this.dashboards = [] as any;
                for (let item of _data["dashboards"])
                    this.dashboards!.push(GetDashboardMenuDto.fromJS(item));
            }
            if (Array.isArray(_data["projectHierarchies"])) {
                this.projectHierarchies = [] as any;
                for (let item of _data["projectHierarchies"])
                    this.projectHierarchies!.push(MenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDashboardMenuViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardMenuViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dashboards)) {
            data["dashboards"] = [];
            for (let item of this.dashboards)
                data["dashboards"].push(item.toJSON());
        }
        if (Array.isArray(this.projectHierarchies)) {
            data["projectHierarchies"] = [];
            for (let item of this.projectHierarchies)
                data["projectHierarchies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDashboardMenuViewModel {
    dashboards?: GetDashboardMenuDto[];
    projectHierarchies?: MenuItem[];
}

export class GetDashboardMenuDto implements IGetDashboardMenuDto {
    id?: string;
    name?: string;

    constructor(data?: IGetDashboardMenuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDashboardMenuDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardMenuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDashboardMenuDto {
    id?: string;
    name?: string;
}

export class MenuItem implements IMenuItem {
    id?: string;
    text?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    type?: MenuItemType;
    children?: MenuItem[] | undefined;

    constructor(data?: IMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
            this.type = _data["type"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(MenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        data["type"] = this.type;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMenuItem {
    id?: string;
    text?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    type?: MenuItemType;
    children?: MenuItem[] | undefined;
}

export class GetSuperDashboardConfigViewModel implements IGetSuperDashboardConfigViewModel {
    configuration?: GetSuperDashboardConfigDto | undefined;

    constructor(data?: IGetSuperDashboardConfigViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuration = _data["configuration"] ? GetSuperDashboardConfigDto.fromJS(_data["configuration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSuperDashboardConfigViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSuperDashboardConfigViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSuperDashboardConfigViewModel {
    configuration?: GetSuperDashboardConfigDto | undefined;
}

export class GetSuperDashboardConfigDto implements IGetSuperDashboardConfigDto {
    name?: string;
    widgets?: GetSDWidgetDto[] | undefined;

    constructor(data?: IGetSuperDashboardConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(GetSDWidgetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSuperDashboardConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSuperDashboardConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSuperDashboardConfigDto {
    name?: string;
    widgets?: GetSDWidgetDto[] | undefined;
}

export class GetSDWidgetDto implements IGetSDWidgetDto {
    id?: string;
    title?: string | undefined;
    subTitle?: string | undefined;
    widgetOptions?: JsonDocument | undefined;

    constructor(data?: IGetSDWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.widgetOptions = _data["widgetOptions"] ? JsonDocument.fromJS(_data["widgetOptions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSDWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSDWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["widgetOptions"] = this.widgetOptions ? this.widgetOptions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSDWidgetDto {
    id?: string;
    title?: string | undefined;
    subTitle?: string | undefined;
    widgetOptions?: JsonDocument | undefined;
}

export class JsonDocument implements IJsonDocument {
    isDisposable?: boolean;
    rootElement?: any;

    constructor(data?: IJsonDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDisposable = _data["isDisposable"];
            this.rootElement = _data["rootElement"];
        }
    }

    static fromJS(data: any): JsonDocument {
        data = typeof data === 'object' ? data : {};
        let result = new JsonDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDisposable"] = this.isDisposable;
        data["rootElement"] = this.rootElement;
        return data;
    }
}

export interface IJsonDocument {
    isDisposable?: boolean;
    rootElement?: any;
}

export class GetWidgetDataViewModel implements IGetWidgetDataViewModel {
    widgetData?: any | undefined;

    constructor(data?: IGetWidgetDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetData = _data["widgetData"];
        }
    }

    static fromJS(data: any): GetWidgetDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetWidgetDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetData"] = this.widgetData;
        return data;
    }
}

export interface IGetWidgetDataViewModel {
    widgetData?: any | undefined;
}

export class GetWidgetFiltersViewModel implements IGetWidgetFiltersViewModel {

    constructor(data?: IGetWidgetFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetWidgetFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetWidgetFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetWidgetFiltersViewModel {
}

export class GetEditSuperDashboardViewModel implements IGetEditSuperDashboardViewModel {
    superDashboardDto?: GetSuperDashboardDto;
    availableUsers?: string[];
    availableUserGroups?: GetEditSuperDashboardUsersGroup[];

    constructor(data?: IGetEditSuperDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.superDashboardDto = _data["superDashboardDto"] ? GetSuperDashboardDto.fromJS(_data["superDashboardDto"]) : <any>undefined;
            if (Array.isArray(_data["availableUsers"])) {
                this.availableUsers = [] as any;
                for (let item of _data["availableUsers"])
                    this.availableUsers!.push(item);
            }
            if (Array.isArray(_data["availableUserGroups"])) {
                this.availableUserGroups = [] as any;
                for (let item of _data["availableUserGroups"])
                    this.availableUserGroups!.push(GetEditSuperDashboardUsersGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditSuperDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditSuperDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["superDashboardDto"] = this.superDashboardDto ? this.superDashboardDto.toJSON() : <any>undefined;
        if (Array.isArray(this.availableUsers)) {
            data["availableUsers"] = [];
            for (let item of this.availableUsers)
                data["availableUsers"].push(item);
        }
        if (Array.isArray(this.availableUserGroups)) {
            data["availableUserGroups"] = [];
            for (let item of this.availableUserGroups)
                data["availableUserGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditSuperDashboardViewModel {
    superDashboardDto?: GetSuperDashboardDto;
    availableUsers?: string[];
    availableUserGroups?: GetEditSuperDashboardUsersGroup[];
}

export class GetSuperDashboardDto implements IGetSuperDashboardDto {
    isOwner?: boolean | undefined;
    cultures?: SuperDashboardCultureDto[];
    sharing?: GetSuperDashboardShareDto[];

    constructor(data?: IGetSuperDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOwner = _data["isOwner"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SuperDashboardCultureDto.fromJS(item));
            }
            if (Array.isArray(_data["sharing"])) {
                this.sharing = [] as any;
                for (let item of _data["sharing"])
                    this.sharing!.push(GetSuperDashboardShareDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSuperDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSuperDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOwner"] = this.isOwner;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.sharing)) {
            data["sharing"] = [];
            for (let item of this.sharing)
                data["sharing"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSuperDashboardDto {
    isOwner?: boolean | undefined;
    cultures?: SuperDashboardCultureDto[];
    sharing?: GetSuperDashboardShareDto[];
}

export class SuperDashboardCultureDto implements ISuperDashboardCultureDto {
    name?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: ISuperDashboardCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): SuperDashboardCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuperDashboardCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface ISuperDashboardCultureDto {
    name?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class GetSuperDashboardShareDto implements IGetSuperDashboardShareDto {
    id?: string;
    shareType?: ShareType;
    user?: string | undefined;
    userGroupId?: string | undefined;

    constructor(data?: IGetSuperDashboardShareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shareType = _data["shareType"];
            this.user = _data["user"];
            this.userGroupId = _data["userGroupId"];
        }
    }

    static fromJS(data: any): GetSuperDashboardShareDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSuperDashboardShareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shareType"] = this.shareType;
        data["user"] = this.user;
        data["userGroupId"] = this.userGroupId;
        return data;
    }
}

export interface IGetSuperDashboardShareDto {
    id?: string;
    shareType?: ShareType;
    user?: string | undefined;
    userGroupId?: string | undefined;
}

export enum ShareType {
    User = 0,
    UserGroup = 1,
}

export class GetEditSuperDashboardUsersGroup implements IGetEditSuperDashboardUsersGroup {
    id?: string;
    name?: string;

    constructor(data?: IGetEditSuperDashboardUsersGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetEditSuperDashboardUsersGroup {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditSuperDashboardUsersGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetEditSuperDashboardUsersGroup {
    id?: string;
    name?: string;
}

export class GetEditWidgetViewModel implements IGetEditWidgetViewModel {
    getEditWidgetDto?: GetEditWidgetDto;

    constructor(data?: IGetEditWidgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.getEditWidgetDto = _data["getEditWidgetDto"] ? GetEditWidgetDto.fromJS(_data["getEditWidgetDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEditWidgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditWidgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getEditWidgetDto"] = this.getEditWidgetDto ? this.getEditWidgetDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEditWidgetViewModel {
    getEditWidgetDto?: GetEditWidgetDto;
}

export class GetEditWidgetDto implements IGetEditWidgetDto {
    order?: number;
    scope?: HierarchyValueType | undefined;
    dataSource?: SuperDashboardWidgetDataSource;
    dataType?: SuperDashboardWidgetDataType;
    widgetOptions?: JsonDocument | undefined;
    filter?: GetEditWidgetFilterDto | undefined;
    cultures?: SuperDashboardWidgetCultureDto[];

    constructor(data?: IGetEditWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.scope = _data["scope"] ? HierarchyValueType.fromJS(_data["scope"]) : <any>undefined;
            this.dataSource = _data["dataSource"];
            this.dataType = _data["dataType"];
            this.widgetOptions = _data["widgetOptions"] ? JsonDocument.fromJS(_data["widgetOptions"]) : <any>undefined;
            this.filter = _data["filter"] ? GetEditWidgetFilterDto.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SuperDashboardWidgetCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["scope"] = this.scope ? this.scope.toJSON() : <any>undefined;
        data["dataSource"] = this.dataSource;
        data["dataType"] = this.dataType;
        data["widgetOptions"] = this.widgetOptions ? this.widgetOptions.toJSON() : <any>undefined;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditWidgetDto {
    order?: number;
    scope?: HierarchyValueType | undefined;
    dataSource?: SuperDashboardWidgetDataSource;
    dataType?: SuperDashboardWidgetDataType;
    widgetOptions?: JsonDocument | undefined;
    filter?: GetEditWidgetFilterDto | undefined;
    cultures?: SuperDashboardWidgetCultureDto[];
}

export class HierarchyValueType implements IHierarchyValueType {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;

    constructor(data?: IHierarchyValueType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
        }
    }

    static fromJS(data: any): HierarchyValueType {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyValueType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        return data;
    }
}

export interface IHierarchyValueType {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
}

export enum SuperDashboardWidgetDataSource {
    Unknown = 0,
    GeneralScore = 1,
    Indicators = 2,
    Nps = 3,
    Ces = 4,
    Consistency = 5,
    BestWorst = 6,
}

export enum SuperDashboardWidgetDataType {
    Unknown = 0,
    Result = 1,
    TrendResult = 2,
}

export class GetEditWidgetFilterDto implements IGetEditWidgetFilterDto {
    branchGroups?: string[] | undefined;
    branches?: string[] | undefined;
    dateFilter?: SuperDashboardWidgetDateFilterDto | undefined;
    periodFilter?: SuperDashboardWidgetPeriodFilterDto | undefined;

    constructor(data?: IGetEditWidgetFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branchGroups"])) {
                this.branchGroups = [] as any;
                for (let item of _data["branchGroups"])
                    this.branchGroups!.push(item);
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(item);
            }
            this.dateFilter = _data["dateFilter"] ? SuperDashboardWidgetDateFilterDto.fromJS(_data["dateFilter"]) : <any>undefined;
            this.periodFilter = _data["periodFilter"] ? SuperDashboardWidgetPeriodFilterDto.fromJS(_data["periodFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEditWidgetFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditWidgetFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branchGroups)) {
            data["branchGroups"] = [];
            for (let item of this.branchGroups)
                data["branchGroups"].push(item);
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item);
        }
        data["dateFilter"] = this.dateFilter ? this.dateFilter.toJSON() : <any>undefined;
        data["periodFilter"] = this.periodFilter ? this.periodFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEditWidgetFilterDto {
    branchGroups?: string[] | undefined;
    branches?: string[] | undefined;
    dateFilter?: SuperDashboardWidgetDateFilterDto | undefined;
    periodFilter?: SuperDashboardWidgetPeriodFilterDto | undefined;
}

export class SuperDashboardWidgetDateFilterDto implements ISuperDashboardWidgetDateFilterDto {
    dateType?: SuperDashboardWidgetFilterDateType;
    dateRange?: SuperDashboardWidgetFilterDateRange;
    lastNumberOfDays?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: ISuperDashboardWidgetDateFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateType = _data["dateType"];
            this.dateRange = _data["dateRange"];
            this.lastNumberOfDays = _data["lastNumberOfDays"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SuperDashboardWidgetDateFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuperDashboardWidgetDateFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateType"] = this.dateType;
        data["dateRange"] = this.dateRange;
        data["lastNumberOfDays"] = this.lastNumberOfDays;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISuperDashboardWidgetDateFilterDto {
    dateType?: SuperDashboardWidgetFilterDateType;
    dateRange?: SuperDashboardWidgetFilterDateRange;
    lastNumberOfDays?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export enum SuperDashboardWidgetFilterDateType {
    SubmittedDate = 0,
    EventDate = 1,
}

export enum SuperDashboardWidgetFilterDateRange {
    CurrentWeek = 100,
    LastWeek = 110,
    CurrentMonth = 200,
    LastMonth = 210,
    CurrentQuarter = 300,
    LastQuarter = 310,
    CurrentYear = 400,
    LastYear = 410,
    LastNumberOfDays = 100000,
    Custom = 1000000,
}

export class SuperDashboardWidgetPeriodFilterDto implements ISuperDashboardWidgetPeriodFilterDto {
    periodRange?: SuperDashboardWidgetPeriodRange;
    periodIds?: string[] | undefined;

    constructor(data?: ISuperDashboardWidgetPeriodFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodRange = _data["periodRange"];
            if (Array.isArray(_data["periodIds"])) {
                this.periodIds = [] as any;
                for (let item of _data["periodIds"])
                    this.periodIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SuperDashboardWidgetPeriodFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuperDashboardWidgetPeriodFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodRange"] = this.periodRange;
        if (Array.isArray(this.periodIds)) {
            data["periodIds"] = [];
            for (let item of this.periodIds)
                data["periodIds"].push(item);
        }
        return data;
    }
}

export interface ISuperDashboardWidgetPeriodFilterDto {
    periodRange?: SuperDashboardWidgetPeriodRange;
    periodIds?: string[] | undefined;
}

export enum SuperDashboardWidgetPeriodRange {
    CurrentPeriod = 100,
    LastPeriod = 110,
    Custom = 1000000,
}

export class SuperDashboardWidgetCultureDto implements ISuperDashboardWidgetCultureDto {
    cultureCode?: string;
    isPrimary?: boolean;
    title?: string | undefined;
    subTitle?: string | undefined;

    constructor(data?: ISuperDashboardWidgetCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.isPrimary = _data["isPrimary"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
        }
    }

    static fromJS(data: any): SuperDashboardWidgetCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuperDashboardWidgetCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["isPrimary"] = this.isPrimary;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        return data;
    }
}

export interface ISuperDashboardWidgetCultureDto {
    cultureCode?: string;
    isPrimary?: boolean;
    title?: string | undefined;
    subTitle?: string | undefined;
}

export class CreateSuperDashboardDto implements ICreateSuperDashboardDto {
    name?: string;
    scopeOwner?: HierachyValueTypeDto | undefined;
    isOwner?: boolean | undefined;

    constructor(data?: ICreateSuperDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.scopeOwner = _data["scopeOwner"] ? HierachyValueTypeDto.fromJS(_data["scopeOwner"]) : <any>undefined;
            this.isOwner = _data["isOwner"];
        }
    }

    static fromJS(data: any): CreateSuperDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSuperDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["scopeOwner"] = this.scopeOwner ? this.scopeOwner.toJSON() : <any>undefined;
        data["isOwner"] = this.isOwner;
        return data;
    }
}

export interface ICreateSuperDashboardDto {
    name?: string;
    scopeOwner?: HierachyValueTypeDto | undefined;
    isOwner?: boolean | undefined;
}

export class HierachyValueTypeDto implements IHierachyValueTypeDto {
    subjectId?: string;
    subjectPath?: any[] | undefined;
    subjectType?: SubjectType;

    constructor(data?: IHierachyValueTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
        }
    }

    static fromJS(data: any): HierachyValueTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new HierachyValueTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        return data;
    }
}

export interface IHierachyValueTypeDto {
    subjectId?: string;
    subjectPath?: any[] | undefined;
    subjectType?: SubjectType;
}

export class UpdateSuperDashboardRequest implements IUpdateSuperDashboardRequest {
    isOwner?: boolean | undefined;
    sharing?: UpdateSuperDashboardShareDto[] | undefined;
    cultures?: SuperDashboardCultureDto[] | undefined;

    constructor(data?: IUpdateSuperDashboardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOwner = _data["isOwner"];
            if (Array.isArray(_data["sharing"])) {
                this.sharing = [] as any;
                for (let item of _data["sharing"])
                    this.sharing!.push(UpdateSuperDashboardShareDto.fromJS(item));
            }
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SuperDashboardCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSuperDashboardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSuperDashboardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOwner"] = this.isOwner;
        if (Array.isArray(this.sharing)) {
            data["sharing"] = [];
            for (let item of this.sharing)
                data["sharing"].push(item.toJSON());
        }
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSuperDashboardRequest {
    isOwner?: boolean | undefined;
    sharing?: UpdateSuperDashboardShareDto[] | undefined;
    cultures?: SuperDashboardCultureDto[] | undefined;
}

export class UpdateSuperDashboardShareDto implements IUpdateSuperDashboardShareDto {
    shareType?: ShareType;
    user?: string | undefined;
    userGroupId?: string | undefined;

    constructor(data?: IUpdateSuperDashboardShareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shareType = _data["shareType"];
            this.user = _data["user"];
            this.userGroupId = _data["userGroupId"];
        }
    }

    static fromJS(data: any): UpdateSuperDashboardShareDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSuperDashboardShareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shareType"] = this.shareType;
        data["user"] = this.user;
        data["userGroupId"] = this.userGroupId;
        return data;
    }
}

export interface IUpdateSuperDashboardShareDto {
    shareType?: ShareType;
    user?: string | undefined;
    userGroupId?: string | undefined;
}

export class UpsertWidgetRequest implements IUpsertWidgetRequest {
    order?: number;
    scope?: HierachyValueTypeDto;
    dataSource?: SuperDashboardWidgetDataSource;
    dataType?: SuperDashboardWidgetDataType;
    widgetOptions?: JsonDocument | undefined;
    filter?: UpsertWidgetFilterDto | undefined;
    cultures?: SuperDashboardWidgetCultureDto[] | undefined;

    constructor(data?: IUpsertWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.scope = _data["scope"] ? HierachyValueTypeDto.fromJS(_data["scope"]) : <any>undefined;
            this.dataSource = _data["dataSource"];
            this.dataType = _data["dataType"];
            this.widgetOptions = _data["widgetOptions"] ? JsonDocument.fromJS(_data["widgetOptions"]) : <any>undefined;
            this.filter = _data["filter"] ? UpsertWidgetFilterDto.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SuperDashboardWidgetCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["scope"] = this.scope ? this.scope.toJSON() : <any>undefined;
        data["dataSource"] = this.dataSource;
        data["dataType"] = this.dataType;
        data["widgetOptions"] = this.widgetOptions ? this.widgetOptions.toJSON() : <any>undefined;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertWidgetRequest {
    order?: number;
    scope?: HierachyValueTypeDto;
    dataSource?: SuperDashboardWidgetDataSource;
    dataType?: SuperDashboardWidgetDataType;
    widgetOptions?: JsonDocument | undefined;
    filter?: UpsertWidgetFilterDto | undefined;
    cultures?: SuperDashboardWidgetCultureDto[] | undefined;
}

export class UpsertWidgetFilterDto implements IUpsertWidgetFilterDto {
    id?: string;
    dateFilter?: SuperDashboardWidgetDateFilterDto | undefined;
    periodFilter?: SuperDashboardWidgetPeriodFilterDto | undefined;
    branchGroups?: string[] | undefined;
    branches?: string[] | undefined;

    constructor(data?: IUpsertWidgetFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateFilter = _data["dateFilter"] ? SuperDashboardWidgetDateFilterDto.fromJS(_data["dateFilter"]) : <any>undefined;
            this.periodFilter = _data["periodFilter"] ? SuperDashboardWidgetPeriodFilterDto.fromJS(_data["periodFilter"]) : <any>undefined;
            if (Array.isArray(_data["branchGroups"])) {
                this.branchGroups = [] as any;
                for (let item of _data["branchGroups"])
                    this.branchGroups!.push(item);
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(item);
            }
        }
    }

    static fromJS(data: any): UpsertWidgetFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertWidgetFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateFilter"] = this.dateFilter ? this.dateFilter.toJSON() : <any>undefined;
        data["periodFilter"] = this.periodFilter ? this.periodFilter.toJSON() : <any>undefined;
        if (Array.isArray(this.branchGroups)) {
            data["branchGroups"] = [];
            for (let item of this.branchGroups)
                data["branchGroups"].push(item);
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item);
        }
        return data;
    }
}

export interface IUpsertWidgetFilterDto {
    id?: string;
    dateFilter?: SuperDashboardWidgetDateFilterDto | undefined;
    periodFilter?: SuperDashboardWidgetPeriodFilterDto | undefined;
    branchGroups?: string[] | undefined;
    branches?: string[] | undefined;
}

/** Represents a void type, since Void is not a valid return type in C#. */
export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Represents a void type, since Void is not a valid return type in C#. */
export interface IUnit {
}

export class CreateTutorialViewModel implements ICreateTutorialViewModel {
    id?: string;

    constructor(data?: ICreateTutorialViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateTutorialViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTutorialViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateTutorialViewModel {
    id?: string;
}

export class CreateTutorialDto implements ICreateTutorialDto {
    key?: string;
    userInformationId?: string;

    constructor(data?: ICreateTutorialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.userInformationId = _data["userInformationId"];
        }
    }

    static fromJS(data: any): CreateTutorialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTutorialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["userInformationId"] = this.userInformationId;
        return data;
    }
}

export interface ICreateTutorialDto {
    key?: string;
    userInformationId?: string;
}

export class TutorialViewModel implements ITutorialViewModel {
    hasSeen?: boolean;

    constructor(data?: ITutorialViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSeen = _data["hasSeen"];
        }
    }

    static fromJS(data: any): TutorialViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TutorialViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSeen"] = this.hasSeen;
        return data;
    }
}

export interface ITutorialViewModel {
    hasSeen?: boolean;
}

export class GetUserSubscriptionServiceTypeViewModel implements IGetUserSubscriptionServiceTypeViewModel {
    contactTracing?: boolean;
    saasFree?: boolean;
    saasPaid?: boolean;
    pro?: boolean;
    trialExpirationDate?: Date | undefined;

    constructor(data?: IGetUserSubscriptionServiceTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactTracing = _data["contactTracing"];
            this.saasFree = _data["saasFree"];
            this.saasPaid = _data["saasPaid"];
            this.pro = _data["pro"];
            this.trialExpirationDate = _data["trialExpirationDate"] ? new Date(_data["trialExpirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserSubscriptionServiceTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSubscriptionServiceTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactTracing"] = this.contactTracing;
        data["saasFree"] = this.saasFree;
        data["saasPaid"] = this.saasPaid;
        data["pro"] = this.pro;
        data["trialExpirationDate"] = this.trialExpirationDate ? this.trialExpirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetUserSubscriptionServiceTypeViewModel {
    contactTracing?: boolean;
    saasFree?: boolean;
    saasPaid?: boolean;
    pro?: boolean;
    trialExpirationDate?: Date | undefined;
}

export class GetUserMenuViewModel implements IGetUserMenuViewModel {
    organizations?: OrganizationDto[];

    constructor(data?: IGetUserMenuViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserMenuViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserMenuViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserMenuViewModel {
    organizations?: OrganizationDto[];
}

export class IdentityUserOfString implements IIdentityUserOfString {
    lockoutEnd?: Date | undefined;
    twoFactorEnabled?: boolean;
    phoneNumberConfirmed?: boolean;
    phoneNumber?: string | undefined;
    givenName?: string | undefined;
    familyName?: string | undefined;
    concurrencyStamp?: string | undefined;
    securityStamp?: string | undefined;
    passwordHash?: string | undefined;
    emailConfirmed?: boolean;
    normalizedEmail?: string | undefined;
    email?: string | undefined;
    normalizedUserName?: string | undefined;
    userName?: string | undefined;
    id?: string | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IIdentityUserOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.givenName = _data["givenName"];
            this.familyName = _data["familyName"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.securityStamp = _data["securityStamp"];
            this.passwordHash = _data["passwordHash"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.email = _data["email"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.userName = _data["userName"];
            this.id = _data["id"];
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUserOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["givenName"] = this.givenName;
        data["familyName"] = this.familyName;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["securityStamp"] = this.securityStamp;
        data["passwordHash"] = this.passwordHash;
        data["emailConfirmed"] = this.emailConfirmed;
        data["normalizedEmail"] = this.normalizedEmail;
        data["email"] = this.email;
        data["normalizedUserName"] = this.normalizedUserName;
        data["userName"] = this.userName;
        data["id"] = this.id;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }
}

export interface IIdentityUserOfString {
    lockoutEnd?: Date | undefined;
    twoFactorEnabled?: boolean;
    phoneNumberConfirmed?: boolean;
    phoneNumber?: string | undefined;
    givenName?: string | undefined;
    familyName?: string | undefined;
    concurrencyStamp?: string | undefined;
    securityStamp?: string | undefined;
    passwordHash?: string | undefined;
    emailConfirmed?: boolean;
    normalizedEmail?: string | undefined;
    email?: string | undefined;
    normalizedUserName?: string | undefined;
    userName?: string | undefined;
    id?: string | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export class ApplicationUser extends IdentityUserOfString implements IApplicationUser {
    deviceIds?: string | undefined;
    culture?: string | undefined;

    constructor(data?: IApplicationUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviceIds = _data["deviceIds"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceIds"] = this.deviceIds;
        data["culture"] = this.culture;
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationUser extends IIdentityUserOfString {
    deviceIds?: string | undefined;
    culture?: string | undefined;
}

export class UserAlertNotificationSettings extends EntityBase implements IUserAlertNotificationSettings {
    userId!: string;
    serviceId!: string;
    email?: boolean;
    sms?: boolean;

    constructor(data?: IUserAlertNotificationSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.serviceId = _data["serviceId"];
            this.email = _data["email"];
            this.sms = _data["sms"];
        }
    }

    static fromJS(data: any): UserAlertNotificationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new UserAlertNotificationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["serviceId"] = this.serviceId;
        data["email"] = this.email;
        data["sms"] = this.sms;
        super.toJSON(data);
        return data;
    }
}

export interface IUserAlertNotificationSettings extends IEntityBase {
    userId: string;
    serviceId: string;
    email?: boolean;
    sms?: boolean;
}

export class AccountPassword implements IAccountPassword {
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IAccountPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): AccountPassword {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IAccountPassword {
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;
}

export class GetUserAlertsViewModel implements IGetUserAlertsViewModel {
    menu?: AlertMenuItem[] | undefined;

    constructor(data?: IGetUserAlertsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["menu"])) {
                this.menu = [] as any;
                for (let item of _data["menu"])
                    this.menu!.push(AlertMenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserAlertsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserAlertsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menu)) {
            data["menu"] = [];
            for (let item of this.menu)
                data["menu"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserAlertsViewModel {
    menu?: AlertMenuItem[] | undefined;
}

export class AlertMenuItem implements IAlertMenuItem {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    menuItemType?: MenuItemType;
    name?: string;
    isActionable?: boolean | undefined;
    emailDisabled?: boolean | undefined;
    pushNotificationDisabled?: boolean | undefined;
    emailBranchStats?: AlertMenuBranchStats | undefined;
    pushNotificationsBranchStats?: AlertMenuBranchStats | undefined;
    children?: AlertMenuItem[] | undefined;

    constructor(data?: IAlertMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
            this.menuItemType = _data["menuItemType"];
            this.name = _data["name"];
            this.isActionable = _data["isActionable"];
            this.emailDisabled = _data["emailDisabled"];
            this.pushNotificationDisabled = _data["pushNotificationDisabled"];
            this.emailBranchStats = _data["emailBranchStats"] ? AlertMenuBranchStats.fromJS(_data["emailBranchStats"]) : <any>undefined;
            this.pushNotificationsBranchStats = _data["pushNotificationsBranchStats"] ? AlertMenuBranchStats.fromJS(_data["pushNotificationsBranchStats"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AlertMenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new AlertMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        data["menuItemType"] = this.menuItemType;
        data["name"] = this.name;
        data["isActionable"] = this.isActionable;
        data["emailDisabled"] = this.emailDisabled;
        data["pushNotificationDisabled"] = this.pushNotificationDisabled;
        data["emailBranchStats"] = this.emailBranchStats ? this.emailBranchStats.toJSON() : <any>undefined;
        data["pushNotificationsBranchStats"] = this.pushNotificationsBranchStats ? this.pushNotificationsBranchStats.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlertMenuItem {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    menuItemType?: MenuItemType;
    name?: string;
    isActionable?: boolean | undefined;
    emailDisabled?: boolean | undefined;
    pushNotificationDisabled?: boolean | undefined;
    emailBranchStats?: AlertMenuBranchStats | undefined;
    pushNotificationsBranchStats?: AlertMenuBranchStats | undefined;
    children?: AlertMenuItem[] | undefined;
}

export class AlertMenuBranchStats implements IAlertMenuBranchStats {
    count?: number | undefined;
    hasAll?: boolean;

    constructor(data?: IAlertMenuBranchStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.hasAll = _data["hasAll"];
        }
    }

    static fromJS(data: any): AlertMenuBranchStats {
        data = typeof data === 'object' ? data : {};
        let result = new AlertMenuBranchStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["hasAll"] = this.hasAll;
        return data;
    }
}

export interface IAlertMenuBranchStats {
    count?: number | undefined;
    hasAll?: boolean;
}

export class SaveUserAlertDto implements ISaveUserAlertDto {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    disabled?: boolean;
    notificationType?: UserAlertNotificationType;

    constructor(data?: ISaveUserAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
            this.disabled = _data["disabled"];
            this.notificationType = _data["notificationType"];
        }
    }

    static fromJS(data: any): SaveUserAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        data["disabled"] = this.disabled;
        data["notificationType"] = this.notificationType;
        return data;
    }
}

export interface ISaveUserAlertDto {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    disabled?: boolean;
    notificationType?: UserAlertNotificationType;
}

export enum UserAlertNotificationType {
    Email = 0,
    PushNotification = 1,
}

export class SaveAllUserAlertDto implements ISaveAllUserAlertDto {
    disabled?: boolean;
    notificationType?: UserAlertNotificationType;

    constructor(data?: ISaveAllUserAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabled = _data["disabled"];
            this.notificationType = _data["notificationType"];
        }
    }

    static fromJS(data: any): SaveAllUserAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAllUserAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled;
        data["notificationType"] = this.notificationType;
        return data;
    }
}

export interface ISaveAllUserAlertDto {
    disabled?: boolean;
    notificationType?: UserAlertNotificationType;
}

export class GetUserBranchAlertsViewModel implements IGetUserBranchAlertsViewModel {
    branches?: BranchAlertMenuItem[] | undefined;

    constructor(data?: IGetUserBranchAlertsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchAlertMenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserBranchAlertsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserBranchAlertsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserBranchAlertsViewModel {
    branches?: BranchAlertMenuItem[] | undefined;
}

export class BranchAlertMenuItem implements IBranchAlertMenuItem {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    name?: string;
    emailDisabled?: boolean | undefined;
    pushNotificationDisabled?: boolean | undefined;

    constructor(data?: IBranchAlertMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
            this.name = _data["name"];
            this.emailDisabled = _data["emailDisabled"];
            this.pushNotificationDisabled = _data["pushNotificationDisabled"];
        }
    }

    static fromJS(data: any): BranchAlertMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new BranchAlertMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        data["name"] = this.name;
        data["emailDisabled"] = this.emailDisabled;
        data["pushNotificationDisabled"] = this.pushNotificationDisabled;
        return data;
    }
}

export interface IBranchAlertMenuItem {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    name?: string;
    emailDisabled?: boolean | undefined;
    pushNotificationDisabled?: boolean | undefined;
}

export class BranchListBulkViewModel implements IBranchListBulkViewModel {
    branches?: SubscriptionBranchDto[];
    branchGroups?: SubscriptionBranchGroupDto[];

    constructor(data?: IBranchListBulkViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(SubscriptionBranchDto.fromJS(item));
            }
            if (Array.isArray(_data["branchGroups"])) {
                this.branchGroups = [] as any;
                for (let item of _data["branchGroups"])
                    this.branchGroups!.push(SubscriptionBranchGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchListBulkViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchListBulkViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.branchGroups)) {
            data["branchGroups"] = [];
            for (let item of this.branchGroups)
                data["branchGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchListBulkViewModel {
    branches?: SubscriptionBranchDto[];
    branchGroups?: SubscriptionBranchGroupDto[];
}

export class SubscriptionBranchDto implements ISubscriptionBranchDto {
    id?: string;
    subjectPath?: string;
    code?: string | undefined;
    name?: string;
    subscriptionId?: string;
    subscriptionName?: string;

    constructor(data?: ISubscriptionBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subjectPath = _data["subjectPath"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionName = _data["subscriptionName"];
        }
    }

    static fromJS(data: any): SubscriptionBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subjectPath"] = this.subjectPath;
        data["code"] = this.code;
        data["name"] = this.name;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionName"] = this.subscriptionName;
        return data;
    }
}

export interface ISubscriptionBranchDto {
    id?: string;
    subjectPath?: string;
    code?: string | undefined;
    name?: string;
    subscriptionId?: string;
    subscriptionName?: string;
}

export class SubscriptionBranchGroupDto implements ISubscriptionBranchGroupDto {
    id?: string;
    subjectPath?: string;
    name?: string;
    subscriptionId?: string;
    subscriptionName?: string;
    children?: SubscriptionBranchGroupDto[];
    branchIds?: string[];

    constructor(data?: ISubscriptionBranchGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subjectPath = _data["subjectPath"];
            this.name = _data["name"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionName = _data["subscriptionName"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(SubscriptionBranchGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SubscriptionBranchGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionBranchGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subjectPath"] = this.subjectPath;
        data["name"] = this.name;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionName"] = this.subscriptionName;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        return data;
    }
}

export interface ISubscriptionBranchGroupDto {
    id?: string;
    subjectPath?: string;
    name?: string;
    subscriptionId?: string;
    subscriptionName?: string;
    children?: SubscriptionBranchGroupDto[];
    branchIds?: string[];
}

export class GetAnalystReportsViewModel implements IGetAnalystReportsViewModel {
    organizations?: HierarchySelectItem[];
    subscriptions?: HierarchySelectItem[];
    subscriptionServices?: HierarchySelectItem[];

    constructor(data?: IGetAnalystReportsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(HierarchySelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAnalystReportsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnalystReportsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAnalystReportsViewModel {
    organizations?: HierarchySelectItem[];
    subscriptions?: HierarchySelectItem[];
    subscriptionServices?: HierarchySelectItem[];
}

export class AnalystReportProjectsViewModel implements IAnalystReportProjectsViewModel {
    projects?: HierarchySelectItem[];

    constructor(data?: IAnalystReportProjectsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(HierarchySelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalystReportProjectsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalystReportProjectsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnalystReportProjectsViewModel {
    projects?: HierarchySelectItem[];
}

export class AnalystReportMandatesViewModel implements IAnalystReportMandatesViewModel {
    mandates?: HierarchySelectItem[];
    periods?: HierarchySelectItem[];
    questions?: HierarchySelectItem[];

    constructor(data?: IAnalystReportMandatesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mandates"])) {
                this.mandates = [] as any;
                for (let item of _data["mandates"])
                    this.mandates!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(HierarchySelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalystReportMandatesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalystReportMandatesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mandates)) {
            data["mandates"] = [];
            for (let item of this.mandates)
                data["mandates"].push(item.toJSON());
        }
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnalystReportMandatesViewModel {
    mandates?: HierarchySelectItem[];
    periods?: HierarchySelectItem[];
    questions?: HierarchySelectItem[];
}

export class AnalystReportOptions implements IAnalystReportOptions {
    sheetName?: string | undefined;
    reportLanguage?: string;
    projectId?: string | undefined;
    mysteryShoppingCurrent?: AnalystReportMysteryShoppingOptions[] | undefined;
    mysteryShoppingCumulative?: AnalystReportMysteryShoppingOptions[] | undefined;
    addBranchGroupColumn?: boolean;
    addProvinceColumn?: boolean;
    addBranchGroupRow?: boolean;
    addBranchRow?: boolean;
    addEntryRow?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IAnalystReportOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sheetName = _data["sheetName"];
            this.reportLanguage = _data["reportLanguage"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["mysteryShoppingCurrent"])) {
                this.mysteryShoppingCurrent = [] as any;
                for (let item of _data["mysteryShoppingCurrent"])
                    this.mysteryShoppingCurrent!.push(AnalystReportMysteryShoppingOptions.fromJS(item));
            }
            if (Array.isArray(_data["mysteryShoppingCumulative"])) {
                this.mysteryShoppingCumulative = [] as any;
                for (let item of _data["mysteryShoppingCumulative"])
                    this.mysteryShoppingCumulative!.push(AnalystReportMysteryShoppingOptions.fromJS(item));
            }
            this.addBranchGroupColumn = _data["addBranchGroupColumn"];
            this.addProvinceColumn = _data["addProvinceColumn"];
            this.addBranchGroupRow = _data["addBranchGroupRow"];
            this.addBranchRow = _data["addBranchRow"];
            this.addEntryRow = _data["addEntryRow"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AnalystReportOptions {
        data = typeof data === 'object' ? data : {};
        let result = new AnalystReportOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sheetName"] = this.sheetName;
        data["reportLanguage"] = this.reportLanguage;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.mysteryShoppingCurrent)) {
            data["mysteryShoppingCurrent"] = [];
            for (let item of this.mysteryShoppingCurrent)
                data["mysteryShoppingCurrent"].push(item.toJSON());
        }
        if (Array.isArray(this.mysteryShoppingCumulative)) {
            data["mysteryShoppingCumulative"] = [];
            for (let item of this.mysteryShoppingCumulative)
                data["mysteryShoppingCumulative"].push(item.toJSON());
        }
        data["addBranchGroupColumn"] = this.addBranchGroupColumn;
        data["addProvinceColumn"] = this.addProvinceColumn;
        data["addBranchGroupRow"] = this.addBranchGroupRow;
        data["addBranchRow"] = this.addBranchRow;
        data["addEntryRow"] = this.addEntryRow;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAnalystReportOptions {
    sheetName?: string | undefined;
    reportLanguage?: string;
    projectId?: string | undefined;
    mysteryShoppingCurrent?: AnalystReportMysteryShoppingOptions[] | undefined;
    mysteryShoppingCumulative?: AnalystReportMysteryShoppingOptions[] | undefined;
    addBranchGroupColumn?: boolean;
    addProvinceColumn?: boolean;
    addBranchGroupRow?: boolean;
    addBranchRow?: boolean;
    addEntryRow?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class AnalystReportMysteryShoppingOptions implements IAnalystReportMysteryShoppingOptions {
    mandateId?: number;
    periodIds?: number[];
    npsId?: number | undefined;

    constructor(data?: IAnalystReportMysteryShoppingOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mandateId = _data["mandateId"];
            if (Array.isArray(_data["periodIds"])) {
                this.periodIds = [] as any;
                for (let item of _data["periodIds"])
                    this.periodIds!.push(item);
            }
            this.npsId = _data["npsId"];
        }
    }

    static fromJS(data: any): AnalystReportMysteryShoppingOptions {
        data = typeof data === 'object' ? data : {};
        let result = new AnalystReportMysteryShoppingOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandateId"] = this.mandateId;
        if (Array.isArray(this.periodIds)) {
            data["periodIds"] = [];
            for (let item of this.periodIds)
                data["periodIds"].push(item);
        }
        data["npsId"] = this.npsId;
        return data;
    }
}

export interface IAnalystReportMysteryShoppingOptions {
    mandateId?: number;
    periodIds?: number[];
    npsId?: number | undefined;
}

export class BranchPageViewModel implements IBranchPageViewModel {
    results?: BranchDto[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;
    canCreate?: boolean;
    canEdit?: boolean;
    canDelete?: boolean;

    constructor(data?: IBranchPageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BranchDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.pageCount = _data["pageCount"];
            this.canCreate = _data["canCreate"];
            this.canEdit = _data["canEdit"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): BranchPageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchPageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["pageCount"] = this.pageCount;
        data["canCreate"] = this.canCreate;
        data["canEdit"] = this.canEdit;
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface IBranchPageViewModel {
    results?: BranchDto[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;
    canCreate?: boolean;
    canEdit?: boolean;
    canDelete?: boolean;
}

export class BranchDto implements IBranchDto {
    id?: string;
    code?: string | undefined;
    displayName?: string;
    isEnabled?: boolean;
    groups?: BranchGroupDto[];

    constructor(data?: IBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(BranchGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchDto {
    id?: string;
    code?: string | undefined;
    displayName?: string;
    isEnabled?: boolean;
    groups?: BranchGroupDto[];
}

export class BranchGroupDto implements IBranchGroupDto {
    id?: string;
    name?: string;

    constructor(data?: IBranchGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BranchGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBranchGroupDto {
    id?: string;
    name?: string;
}

export enum BranchSortingField {
    IsEnabled = 0,
    Code = 1,
    DisplayName = 2,
    Groups = 3,
}

export class BranchViewModel implements IBranchViewModel {
    id?: string;
    branch?: EditableBranchDto;
    hasLocaltracService?: boolean;

    constructor(data?: IBranchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branch = _data["branch"] ? EditableBranchDto.fromJS(_data["branch"]) : <any>undefined;
            this.hasLocaltracService = _data["hasLocaltracService"];
        }
    }

    static fromJS(data: any): BranchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["hasLocaltracService"] = this.hasLocaltracService;
        return data;
    }
}

export interface IBranchViewModel {
    id?: string;
    branch?: EditableBranchDto;
    hasLocaltracService?: boolean;
}

export class EditableBranchDto implements IEditableBranchDto {
    isEnabled?: boolean | undefined;
    code?: string | undefined;
    names?: BranchNameDto[] | undefined;
    logos?: BranchLogoDto[] | undefined;
    address?: BranchAddressDto | undefined;
    socialMedia?: BranchSocialMediaDto[] | undefined;
    providerMediaLibrary?: BranchProviderMediaLibraryDto[];
    mediaLibraryItems?: MediaLibraryItemDto[];
    phone?: string | undefined;
    googleCategories?: BranchGoogleCategoryDto[];
    additionalPhones?: BranchAdditionalPhoneDto[];
    googleAttributes?: BranchGoogleAttributeDto[];
    specialOpenings?: BranchSpecialOpeningDto[];
    branchKeywords?: BranchKeywordBranchDto[];
    openingHours?: BranchOpeningHourDto[];
    doNotServeCustomerAtAddress?: boolean | undefined;
    email?: string | undefined;
    website?: string | undefined;
    description?: string | undefined;

    constructor(data?: IEditableBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.code = _data["code"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(BranchNameDto.fromJS(item));
            }
            if (Array.isArray(_data["logos"])) {
                this.logos = [] as any;
                for (let item of _data["logos"])
                    this.logos!.push(BranchLogoDto.fromJS(item));
            }
            this.address = _data["address"] ? BranchAddressDto.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["socialMedia"])) {
                this.socialMedia = [] as any;
                for (let item of _data["socialMedia"])
                    this.socialMedia!.push(BranchSocialMediaDto.fromJS(item));
            }
            if (Array.isArray(_data["providerMediaLibrary"])) {
                this.providerMediaLibrary = [] as any;
                for (let item of _data["providerMediaLibrary"])
                    this.providerMediaLibrary!.push(BranchProviderMediaLibraryDto.fromJS(item));
            }
            if (Array.isArray(_data["mediaLibraryItems"])) {
                this.mediaLibraryItems = [] as any;
                for (let item of _data["mediaLibraryItems"])
                    this.mediaLibraryItems!.push(MediaLibraryItemDto.fromJS(item));
            }
            this.phone = _data["phone"];
            if (Array.isArray(_data["googleCategories"])) {
                this.googleCategories = [] as any;
                for (let item of _data["googleCategories"])
                    this.googleCategories!.push(BranchGoogleCategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["additionalPhones"])) {
                this.additionalPhones = [] as any;
                for (let item of _data["additionalPhones"])
                    this.additionalPhones!.push(BranchAdditionalPhoneDto.fromJS(item));
            }
            if (Array.isArray(_data["googleAttributes"])) {
                this.googleAttributes = [] as any;
                for (let item of _data["googleAttributes"])
                    this.googleAttributes!.push(BranchGoogleAttributeDto.fromJS(item));
            }
            if (Array.isArray(_data["specialOpenings"])) {
                this.specialOpenings = [] as any;
                for (let item of _data["specialOpenings"])
                    this.specialOpenings!.push(BranchSpecialOpeningDto.fromJS(item));
            }
            if (Array.isArray(_data["branchKeywords"])) {
                this.branchKeywords = [] as any;
                for (let item of _data["branchKeywords"])
                    this.branchKeywords!.push(BranchKeywordBranchDto.fromJS(item));
            }
            if (Array.isArray(_data["openingHours"])) {
                this.openingHours = [] as any;
                for (let item of _data["openingHours"])
                    this.openingHours!.push(BranchOpeningHourDto.fromJS(item));
            }
            this.doNotServeCustomerAtAddress = _data["doNotServeCustomerAtAddress"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EditableBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditableBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["code"] = this.code;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        if (Array.isArray(this.logos)) {
            data["logos"] = [];
            for (let item of this.logos)
                data["logos"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.socialMedia)) {
            data["socialMedia"] = [];
            for (let item of this.socialMedia)
                data["socialMedia"].push(item.toJSON());
        }
        if (Array.isArray(this.providerMediaLibrary)) {
            data["providerMediaLibrary"] = [];
            for (let item of this.providerMediaLibrary)
                data["providerMediaLibrary"].push(item.toJSON());
        }
        if (Array.isArray(this.mediaLibraryItems)) {
            data["mediaLibraryItems"] = [];
            for (let item of this.mediaLibraryItems)
                data["mediaLibraryItems"].push(item.toJSON());
        }
        data["phone"] = this.phone;
        if (Array.isArray(this.googleCategories)) {
            data["googleCategories"] = [];
            for (let item of this.googleCategories)
                data["googleCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalPhones)) {
            data["additionalPhones"] = [];
            for (let item of this.additionalPhones)
                data["additionalPhones"].push(item.toJSON());
        }
        if (Array.isArray(this.googleAttributes)) {
            data["googleAttributes"] = [];
            for (let item of this.googleAttributes)
                data["googleAttributes"].push(item.toJSON());
        }
        if (Array.isArray(this.specialOpenings)) {
            data["specialOpenings"] = [];
            for (let item of this.specialOpenings)
                data["specialOpenings"].push(item.toJSON());
        }
        if (Array.isArray(this.branchKeywords)) {
            data["branchKeywords"] = [];
            for (let item of this.branchKeywords)
                data["branchKeywords"].push(item.toJSON());
        }
        if (Array.isArray(this.openingHours)) {
            data["openingHours"] = [];
            for (let item of this.openingHours)
                data["openingHours"].push(item.toJSON());
        }
        data["doNotServeCustomerAtAddress"] = this.doNotServeCustomerAtAddress;
        data["email"] = this.email;
        data["website"] = this.website;
        data["description"] = this.description;
        return data;
    }
}

export interface IEditableBranchDto {
    isEnabled?: boolean | undefined;
    code?: string | undefined;
    names?: BranchNameDto[] | undefined;
    logos?: BranchLogoDto[] | undefined;
    address?: BranchAddressDto | undefined;
    socialMedia?: BranchSocialMediaDto[] | undefined;
    providerMediaLibrary?: BranchProviderMediaLibraryDto[];
    mediaLibraryItems?: MediaLibraryItemDto[];
    phone?: string | undefined;
    googleCategories?: BranchGoogleCategoryDto[];
    additionalPhones?: BranchAdditionalPhoneDto[];
    googleAttributes?: BranchGoogleAttributeDto[];
    specialOpenings?: BranchSpecialOpeningDto[];
    branchKeywords?: BranchKeywordBranchDto[];
    openingHours?: BranchOpeningHourDto[];
    doNotServeCustomerAtAddress?: boolean | undefined;
    email?: string | undefined;
    website?: string | undefined;
    description?: string | undefined;
}

export class BranchNameDto implements IBranchNameDto {
    name?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;

    constructor(data?: IBranchNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): BranchNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IBranchNameDto {
    name?: string | undefined;
    isPrimary?: boolean;
    cultureCode?: string;
}

export class BranchLogoDto implements IBranchLogoDto {
    isPrimary?: boolean;
    cultureCode?: string;
    logoUrl?: string;
    isCustomized?: boolean;

    constructor(data?: IBranchLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPrimary = _data["isPrimary"];
            this.cultureCode = _data["cultureCode"];
            this.logoUrl = _data["logoUrl"];
            this.isCustomized = _data["isCustomized"];
        }
    }

    static fromJS(data: any): BranchLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPrimary"] = this.isPrimary;
        data["cultureCode"] = this.cultureCode;
        data["logoUrl"] = this.logoUrl;
        data["isCustomized"] = this.isCustomized;
        return data;
    }
}

export interface IBranchLogoDto {
    isPrimary?: boolean;
    cultureCode?: string;
    logoUrl?: string;
    isCustomized?: boolean;
}

export class BranchAddressDto implements IBranchAddressDto {
    country?: Alpha3Code | undefined;
    locality?: string;
    province?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    longitude?: number;
    latitude?: number;

    constructor(data?: IBranchAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.locality = _data["locality"];
            this.province = _data["province"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
        }
    }

    static fromJS(data: any): BranchAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["locality"] = this.locality;
        data["province"] = this.province;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    }
}

export interface IBranchAddressDto {
    country?: Alpha3Code | undefined;
    locality?: string;
    province?: string;
    address?: string;
    city?: string;
    postalCode?: string;
    longitude?: number;
    latitude?: number;
}

/** Alpha3 code (ISO-3166-1) */
export enum Alpha3Code {
    AFG = 0,
    ALA = 1,
    ALB = 2,
    DZA = 3,
    ASM = 4,
    AND = 5,
    AGO = 6,
    AIA = 7,
    ATA = 8,
    ATG = 9,
    ARG = 10,
    ARM = 11,
    ABW = 12,
    AUS = 13,
    AUT = 14,
    AZE = 15,
    BHS = 16,
    BHR = 17,
    BGD = 18,
    BRB = 19,
    BLR = 20,
    BEL = 21,
    BLZ = 22,
    BEN = 23,
    BMU = 24,
    BTN = 25,
    BOL = 26,
    BES = 27,
    BIH = 28,
    BWA = 29,
    BVT = 30,
    BRA = 31,
    IOT = 32,
    BRN = 33,
    BGR = 34,
    BFA = 35,
    BDI = 36,
    KHM = 37,
    CMR = 38,
    CAN = 39,
    CPV = 40,
    CYM = 41,
    CAF = 42,
    TCD = 43,
    CHL = 44,
    CHN = 45,
    CXR = 46,
    CCK = 47,
    COL = 48,
    COM = 49,
    COG = 50,
    COD = 51,
    COK = 52,
    CRI = 53,
    CIV = 54,
    HRV = 55,
    CUB = 56,
    CUW = 57,
    CYP = 58,
    CZE = 59,
    DNK = 60,
    DJI = 61,
    DMA = 62,
    DOM = 63,
    ECU = 64,
    EGY = 65,
    SLV = 66,
    GNQ = 67,
    ERI = 68,
    EST = 69,
    ETH = 70,
    FLK = 71,
    FRO = 72,
    FJI = 73,
    FIN = 74,
    FRA = 75,
    GUF = 76,
    PYF = 77,
    ATF = 78,
    GAB = 79,
    GMB = 80,
    GEO = 81,
    DEU = 82,
    GHA = 83,
    GIB = 84,
    GRC = 85,
    GRL = 86,
    GRD = 87,
    GLP = 88,
    GUM = 89,
    GTM = 90,
    GGY = 91,
    GIN = 92,
    GNB = 93,
    GUY = 94,
    HTI = 95,
    HMD = 96,
    HND = 97,
    HKG = 98,
    HUN = 99,
    ISL = 100,
    IND = 101,
    IDN = 102,
    IRN = 103,
    IRQ = 104,
    IRL = 105,
    IMN = 106,
    ISR = 107,
    ITA = 108,
    JAM = 109,
    JPN = 110,
    JEY = 111,
    JOR = 112,
    KAZ = 113,
    KEN = 114,
    KIR = 115,
    PRK = 116,
    KOR = 117,
    KWT = 118,
    KGZ = 119,
    LAO = 120,
    LVA = 121,
    LBN = 122,
    LSO = 123,
    LBR = 124,
    LBY = 125,
    LIE = 126,
    LTU = 127,
    LUX = 128,
    MAC = 129,
    MKD = 130,
    MDG = 131,
    MWI = 132,
    MYS = 133,
    MDV = 134,
    MLI = 135,
    MLT = 136,
    MHL = 137,
    MTQ = 138,
    MRT = 139,
    MUS = 140,
    MYT = 141,
    MEX = 142,
    FSM = 143,
    MDA = 144,
    MCO = 145,
    MNG = 146,
    MNE = 147,
    MSR = 148,
    MAR = 149,
    MOZ = 150,
    MMR = 151,
    NAM = 152,
    NRU = 153,
    NPL = 154,
    NLD = 155,
    NCL = 156,
    NZL = 157,
    NIC = 158,
    NER = 159,
    NGA = 160,
    NIU = 161,
    NFK = 162,
    MNP = 163,
    NOR = 164,
    OMN = 165,
    PAK = 166,
    PLW = 167,
    PSE = 168,
    PAN = 169,
    PNG = 170,
    PRY = 171,
    PER = 172,
    PHL = 173,
    PCN = 174,
    POL = 175,
    PRT = 176,
    PRI = 177,
    QAT = 178,
    REU = 179,
    ROU = 180,
    RUS = 181,
    RWA = 182,
    BLM = 183,
    SHN = 184,
    KNA = 185,
    LCA = 186,
    MAF = 187,
    SPM = 188,
    VCT = 189,
    WSM = 190,
    SMR = 191,
    STP = 192,
    SAU = 193,
    SEN = 194,
    SRB = 195,
    SYC = 196,
    SLE = 197,
    SGP = 198,
    SXM = 199,
    SVK = 200,
    SVN = 201,
    SLB = 202,
    SOM = 203,
    ZAF = 204,
    SGS = 205,
    SSD = 206,
    ESP = 207,
    LKA = 208,
    SDN = 209,
    SUR = 210,
    SJM = 211,
    SWZ = 212,
    SWE = 213,
    CHE = 214,
    SYR = 215,
    TWN = 216,
    TJK = 217,
    TZA = 218,
    THA = 219,
    TLS = 220,
    TGO = 221,
    TKL = 222,
    TON = 223,
    TTO = 224,
    TUN = 225,
    TUR = 226,
    TKM = 227,
    TCA = 228,
    TUV = 229,
    UGA = 230,
    UKR = 231,
    ARE = 232,
    GBR = 233,
    UMI = 234,
    USA = 235,
    URY = 236,
    UZB = 237,
    VUT = 238,
    VAT = 239,
    VEN = 240,
    VNM = 241,
    VGB = 242,
    VIR = 243,
    WLF = 244,
    ESH = 245,
    YEM = 246,
    ZMB = 247,
    ZWE = 248,
}

export class BranchSocialMediaDto implements IBranchSocialMediaDto {
    type?: SocialMedia;
    url?: string | undefined;

    constructor(data?: IBranchSocialMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): BranchSocialMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchSocialMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["url"] = this.url;
        return data;
    }
}

export interface IBranchSocialMediaDto {
    type?: SocialMedia;
    url?: string | undefined;
}

export enum SocialMedia {
    None = 0,
    GoogleReviews = 1,
    Facebook = 2,
    TripAdvisor = 3,
    BingReviews = 4,
    FourSquare = 5,
    Yelp = 6,
    Twitter = 7,
    Pinterest = 8,
    LinkedIn = 9,
    Instagram = 10,
    Youtube = 11,
}

export class BranchProviderMediaLibraryDto implements IBranchProviderMediaLibraryDto {
    id?: string;
    name?: string;
    mediaLibraryProviderImageCategories?: ProviderImageCategoryDto[];

    constructor(data?: IBranchProviderMediaLibraryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["mediaLibraryProviderImageCategories"])) {
                this.mediaLibraryProviderImageCategories = [] as any;
                for (let item of _data["mediaLibraryProviderImageCategories"])
                    this.mediaLibraryProviderImageCategories!.push(ProviderImageCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchProviderMediaLibraryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchProviderMediaLibraryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.mediaLibraryProviderImageCategories)) {
            data["mediaLibraryProviderImageCategories"] = [];
            for (let item of this.mediaLibraryProviderImageCategories)
                data["mediaLibraryProviderImageCategories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchProviderMediaLibraryDto {
    id?: string;
    name?: string;
    mediaLibraryProviderImageCategories?: ProviderImageCategoryDto[];
}

export class ProviderImageCategoryDto implements IProviderImageCategoryDto {
    id?: string;
    name?: string | undefined;
    order?: number | undefined;
    height?: number | undefined;
    width?: number | undefined;
    hasDescription?: boolean;
    isSingular?: boolean;
    mediaLibraryProviderItems?: MediaLibraryItemDto[];

    constructor(data?: IProviderImageCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.hasDescription = _data["hasDescription"];
            this.isSingular = _data["isSingular"];
            if (Array.isArray(_data["mediaLibraryProviderItems"])) {
                this.mediaLibraryProviderItems = [] as any;
                for (let item of _data["mediaLibraryProviderItems"])
                    this.mediaLibraryProviderItems!.push(MediaLibraryItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderImageCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderImageCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["order"] = this.order;
        data["height"] = this.height;
        data["width"] = this.width;
        data["hasDescription"] = this.hasDescription;
        data["isSingular"] = this.isSingular;
        if (Array.isArray(this.mediaLibraryProviderItems)) {
            data["mediaLibraryProviderItems"] = [];
            for (let item of this.mediaLibraryProviderItems)
                data["mediaLibraryProviderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProviderImageCategoryDto {
    id?: string;
    name?: string | undefined;
    order?: number | undefined;
    height?: number | undefined;
    width?: number | undefined;
    hasDescription?: boolean;
    isSingular?: boolean;
    mediaLibraryProviderItems?: MediaLibraryItemDto[];
}

export class MediaLibraryItemDto implements IMediaLibraryItemDto {
    id?: string;
    url?: string | undefined;

    constructor(data?: IMediaLibraryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): MediaLibraryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaLibraryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        return data;
    }
}

export interface IMediaLibraryItemDto {
    id?: string;
    url?: string | undefined;
}

export class BranchGoogleCategoryDto implements IBranchGoogleCategoryDto {
    googleKey?: string;
    description?: string;

    constructor(data?: IBranchGoogleCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleKey = _data["googleKey"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BranchGoogleCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGoogleCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleKey"] = this.googleKey;
        data["description"] = this.description;
        return data;
    }
}

export interface IBranchGoogleCategoryDto {
    googleKey?: string;
    description?: string;
}

export class BranchAdditionalPhoneDto implements IBranchAdditionalPhoneDto {
    phone?: string;

    constructor(data?: IBranchAdditionalPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): BranchAdditionalPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchAdditionalPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        return data;
    }
}

export interface IBranchAdditionalPhoneDto {
    phone?: string;
}

export class BranchGoogleAttributeDto implements IBranchGoogleAttributeDto {
    googleKey?: string;
    description?: string;

    constructor(data?: IBranchGoogleAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleKey = _data["googleKey"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BranchGoogleAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGoogleAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleKey"] = this.googleKey;
        data["description"] = this.description;
        return data;
    }
}

export interface IBranchGoogleAttributeDto {
    googleKey?: string;
    description?: string;
}

export class BranchSpecialOpeningDto implements IBranchSpecialOpeningDto {
    date?: Date;
    state?: BranchOpeningState;
    frequency?: BranchOpeningFrequency;

    constructor(data?: IBranchSpecialOpeningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.frequency = _data["frequency"];
        }
    }

    static fromJS(data: any): BranchSpecialOpeningDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchSpecialOpeningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["frequency"] = this.frequency;
        return data;
    }
}

export interface IBranchSpecialOpeningDto {
    date?: Date;
    state?: BranchOpeningState;
    frequency?: BranchOpeningFrequency;
}

export enum BranchOpeningState {
    Open = 0,
    Closed = 1,
}

export enum BranchOpeningFrequency {
    Once = 0,
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
    Yearly = 4,
}

export class BranchKeywordBranchDto implements IBranchKeywordBranchDto {

    constructor(data?: IBranchKeywordBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BranchKeywordBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchKeywordBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBranchKeywordBranchDto {
}

export class BranchOpeningHourDto implements IBranchOpeningHourDto {
    weekDay?: WeekDay;
    openHour?: string;
    closeHour?: string;

    constructor(data?: IBranchOpeningHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekDay = _data["weekDay"];
            this.openHour = _data["openHour"];
            this.closeHour = _data["closeHour"];
        }
    }

    static fromJS(data: any): BranchOpeningHourDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchOpeningHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekDay"] = this.weekDay;
        data["openHour"] = this.openHour;
        data["closeHour"] = this.closeHour;
        return data;
    }
}

export interface IBranchOpeningHourDto {
    weekDay?: WeekDay;
    openHour?: string;
    closeHour?: string;
}

export enum WeekDay {
    Monday = 0,
    Tuesday = 1,
    Wednesday = 2,
    Thursday = 3,
    Friday = 4,
    Saturday = 5,
    Sunday = 6,
}

export class VerifyCodeUnicityDto implements IVerifyCodeUnicityDto {
    branchId?: string | undefined;
    code?: string;

    constructor(data?: IVerifyCodeUnicityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): VerifyCodeUnicityDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyCodeUnicityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["code"] = this.code;
        return data;
    }
}

export interface IVerifyCodeUnicityDto {
    branchId?: string | undefined;
    code?: string;
}

export class UpsertBranchDto implements IUpsertBranchDto {
    code?: string | undefined;
    phone?: string | undefined;
    isEnabled?: boolean;
    address?: AddressDto;
    socialMedia?: SocialMediaDto[];
    cultures?: CultureDto[];
    googleCategories?: BranchGoogleCategory[];
    additionalPhones?: BranchAdditionalPhone[];
    googleAttributes?: BranchGoogleAttribute[];
    specialOpenings?: BranchSpecialOpening[];
    branchKeywords?: BranchKeywordBranch[];
    openingHours?: BranchOpeningHour[];
    doNotServeCustomerAtAddress?: boolean;
    email?: string | undefined;
    website?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUpsertBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phone = _data["phone"];
            this.isEnabled = _data["isEnabled"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["socialMedia"])) {
                this.socialMedia = [] as any;
                for (let item of _data["socialMedia"])
                    this.socialMedia!.push(SocialMediaDto.fromJS(item));
            }
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(CultureDto.fromJS(item));
            }
            if (Array.isArray(_data["googleCategories"])) {
                this.googleCategories = [] as any;
                for (let item of _data["googleCategories"])
                    this.googleCategories!.push(BranchGoogleCategory.fromJS(item));
            }
            if (Array.isArray(_data["additionalPhones"])) {
                this.additionalPhones = [] as any;
                for (let item of _data["additionalPhones"])
                    this.additionalPhones!.push(BranchAdditionalPhone.fromJS(item));
            }
            if (Array.isArray(_data["googleAttributes"])) {
                this.googleAttributes = [] as any;
                for (let item of _data["googleAttributes"])
                    this.googleAttributes!.push(BranchGoogleAttribute.fromJS(item));
            }
            if (Array.isArray(_data["specialOpenings"])) {
                this.specialOpenings = [] as any;
                for (let item of _data["specialOpenings"])
                    this.specialOpenings!.push(BranchSpecialOpening.fromJS(item));
            }
            if (Array.isArray(_data["branchKeywords"])) {
                this.branchKeywords = [] as any;
                for (let item of _data["branchKeywords"])
                    this.branchKeywords!.push(BranchKeywordBranch.fromJS(item));
            }
            if (Array.isArray(_data["openingHours"])) {
                this.openingHours = [] as any;
                for (let item of _data["openingHours"])
                    this.openingHours!.push(BranchOpeningHour.fromJS(item));
            }
            this.doNotServeCustomerAtAddress = _data["doNotServeCustomerAtAddress"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpsertBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phone"] = this.phone;
        data["isEnabled"] = this.isEnabled;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.socialMedia)) {
            data["socialMedia"] = [];
            for (let item of this.socialMedia)
                data["socialMedia"].push(item.toJSON());
        }
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.googleCategories)) {
            data["googleCategories"] = [];
            for (let item of this.googleCategories)
                data["googleCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalPhones)) {
            data["additionalPhones"] = [];
            for (let item of this.additionalPhones)
                data["additionalPhones"].push(item.toJSON());
        }
        if (Array.isArray(this.googleAttributes)) {
            data["googleAttributes"] = [];
            for (let item of this.googleAttributes)
                data["googleAttributes"].push(item.toJSON());
        }
        if (Array.isArray(this.specialOpenings)) {
            data["specialOpenings"] = [];
            for (let item of this.specialOpenings)
                data["specialOpenings"].push(item.toJSON());
        }
        if (Array.isArray(this.branchKeywords)) {
            data["branchKeywords"] = [];
            for (let item of this.branchKeywords)
                data["branchKeywords"].push(item.toJSON());
        }
        if (Array.isArray(this.openingHours)) {
            data["openingHours"] = [];
            for (let item of this.openingHours)
                data["openingHours"].push(item.toJSON());
        }
        data["doNotServeCustomerAtAddress"] = this.doNotServeCustomerAtAddress;
        data["email"] = this.email;
        data["website"] = this.website;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpsertBranchDto {
    code?: string | undefined;
    phone?: string | undefined;
    isEnabled?: boolean;
    address?: AddressDto;
    socialMedia?: SocialMediaDto[];
    cultures?: CultureDto[];
    googleCategories?: BranchGoogleCategory[];
    additionalPhones?: BranchAdditionalPhone[];
    googleAttributes?: BranchGoogleAttribute[];
    specialOpenings?: BranchSpecialOpening[];
    branchKeywords?: BranchKeywordBranch[];
    openingHours?: BranchOpeningHour[];
    doNotServeCustomerAtAddress?: boolean;
    email?: string | undefined;
    website?: string | undefined;
    description?: string | undefined;
}

export class AddressDto implements IAddressDto {
    country?: Alpha3Code;
    locality?: string;
    province?: string;
    address?: string;
    city?: string;
    postalCode?: string;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.locality = _data["locality"];
            this.province = _data["province"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["locality"] = this.locality;
        data["province"] = this.province;
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IAddressDto {
    country?: Alpha3Code;
    locality?: string;
    province?: string;
    address?: string;
    city?: string;
    postalCode?: string;
}

export class SocialMediaDto implements ISocialMediaDto {
    type?: SocialMedia;
    url?: string | undefined;

    constructor(data?: ISocialMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SocialMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["url"] = this.url;
        return data;
    }
}

export interface ISocialMediaDto {
    type?: SocialMedia;
    url?: string | undefined;
}

export class CultureDto implements ICultureDto {
    name?: string | undefined;
    isPrimary?: boolean;
    culture?: string;

    constructor(data?: ICultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): CultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        data["culture"] = this.culture;
        return data;
    }
}

export interface ICultureDto {
    name?: string | undefined;
    isPrimary?: boolean;
    culture?: string;
}

export class BranchGoogleCategory extends EntityBase implements IBranchGoogleCategory {
    branchId?: string;
    googleKey?: string | undefined;
    description?: string | undefined;

    constructor(data?: IBranchGoogleCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchId = _data["branchId"];
            this.googleKey = _data["googleKey"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BranchGoogleCategory {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGoogleCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["googleKey"] = this.googleKey;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IBranchGoogleCategory extends IEntityBase {
    branchId?: string;
    googleKey?: string | undefined;
    description?: string | undefined;
}

export class BranchAdditionalPhone extends EntityBase implements IBranchAdditionalPhone {
    branchId?: string;
    phone?: string | undefined;

    constructor(data?: IBranchAdditionalPhone) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchId = _data["branchId"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): BranchAdditionalPhone {
        data = typeof data === 'object' ? data : {};
        let result = new BranchAdditionalPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["phone"] = this.phone;
        super.toJSON(data);
        return data;
    }
}

export interface IBranchAdditionalPhone extends IEntityBase {
    branchId?: string;
    phone?: string | undefined;
}

export class BranchGoogleAttribute extends EntityBase implements IBranchGoogleAttribute {
    branchId?: string;
    googleKey?: string | undefined;
    description?: string | undefined;

    constructor(data?: IBranchGoogleAttribute) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchId = _data["branchId"];
            this.googleKey = _data["googleKey"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BranchGoogleAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGoogleAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["googleKey"] = this.googleKey;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IBranchGoogleAttribute extends IEntityBase {
    branchId?: string;
    googleKey?: string | undefined;
    description?: string | undefined;
}

export class BranchSpecialOpening extends EntityBase implements IBranchSpecialOpening {
    branchId?: string;
    date?: Date;
    state?: BranchOpeningState;
    frequency?: BranchOpeningFrequency;

    constructor(data?: IBranchSpecialOpening) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchId = _data["branchId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.frequency = _data["frequency"];
        }
    }

    static fromJS(data: any): BranchSpecialOpening {
        data = typeof data === 'object' ? data : {};
        let result = new BranchSpecialOpening();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["frequency"] = this.frequency;
        super.toJSON(data);
        return data;
    }
}

export interface IBranchSpecialOpening extends IEntityBase {
    branchId?: string;
    date?: Date;
    state?: BranchOpeningState;
    frequency?: BranchOpeningFrequency;
}

export class BranchKeywordBranch implements IBranchKeywordBranch {
    branchId?: string;
    branchKeywordId?: string;
    branchKeyword?: BranchKeyword | undefined;

    constructor(data?: IBranchKeywordBranch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.branchKeywordId = _data["branchKeywordId"];
            this.branchKeyword = _data["branchKeyword"] ? BranchKeyword.fromJS(_data["branchKeyword"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchKeywordBranch {
        data = typeof data === 'object' ? data : {};
        let result = new BranchKeywordBranch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["branchKeywordId"] = this.branchKeywordId;
        data["branchKeyword"] = this.branchKeyword ? this.branchKeyword.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBranchKeywordBranch {
    branchId?: string;
    branchKeywordId?: string;
    branchKeyword?: BranchKeyword | undefined;
}

export class BranchKeyword extends EntityBase implements IBranchKeyword {
    subscriptionId?: string;
    keyword?: string | undefined;
    subscription?: Subscription | undefined;
    cultures?: BranchKeywordCulture[] | undefined;

    constructor(data?: IBranchKeyword) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.keyword = _data["keyword"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(BranchKeywordCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchKeyword {
        data = typeof data === 'object' ? data : {};
        let result = new BranchKeyword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["keyword"] = this.keyword;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBranchKeyword extends IEntityBase {
    subscriptionId?: string;
    keyword?: string | undefined;
    subscription?: Subscription | undefined;
    cultures?: BranchKeywordCulture[] | undefined;
}

export abstract class HierarchyEntityBase extends EntityBase implements IHierarchyEntityBase {
    subjectPath?: string | undefined;

    constructor(data?: IHierarchyEntityBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subjectPath = _data["subjectPath"];
        }
    }

    static fromJS(data: any): HierarchyEntityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'HierarchyEntityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectPath"] = this.subjectPath;
        super.toJSON(data);
        return data;
    }
}

export interface IHierarchyEntityBase extends IEntityBase {
    subjectPath?: string | undefined;
}

export class Subscription extends HierarchyEntityBase implements ISubscription {
    name?: string | undefined;
    normalizedName?: string | undefined;
    email?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    industryId?: string | undefined;
    organizationId?: string;
    organization?: Organization | undefined;
    industry?: Industry | undefined;
    subscriptionsSharing?: SubscriptionSharing[] | undefined;
    authenticationProviders?: AuthenticationProvider[] | undefined;
    subscriptionServices?: SubscriptionService[] | undefined;
    branches?: Branch[] | undefined;
    cultures?: SubscriptionCulture[] | undefined;
    infos?: SubscriptionInformation[] | undefined;
    subscriptionDomains?: SubscriptionDomain[] | undefined;
    brandGroups?: BrandGroup[] | undefined;
    competitorBranchGroups?: CompetitorBranchGroup[] | undefined;
    state?: string | undefined;

    constructor(data?: ISubscription) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.email = _data["email"];
            this.cultureCode = _data["cultureCode"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.industryId = _data["industryId"];
            this.organizationId = _data["organizationId"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.industry = _data["industry"] ? Industry.fromJS(_data["industry"]) : <any>undefined;
            if (Array.isArray(_data["subscriptionsSharing"])) {
                this.subscriptionsSharing = [] as any;
                for (let item of _data["subscriptionsSharing"])
                    this.subscriptionsSharing!.push(SubscriptionSharing.fromJS(item));
            }
            if (Array.isArray(_data["authenticationProviders"])) {
                this.authenticationProviders = [] as any;
                for (let item of _data["authenticationProviders"])
                    this.authenticationProviders!.push(AuthenticationProvider.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(SubscriptionService.fromJS(item));
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(Branch.fromJS(item));
            }
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SubscriptionCulture.fromJS(item));
            }
            if (Array.isArray(_data["infos"])) {
                this.infos = [] as any;
                for (let item of _data["infos"])
                    this.infos!.push(SubscriptionInformation.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionDomains"])) {
                this.subscriptionDomains = [] as any;
                for (let item of _data["subscriptionDomains"])
                    this.subscriptionDomains!.push(SubscriptionDomain.fromJS(item));
            }
            if (Array.isArray(_data["brandGroups"])) {
                this.brandGroups = [] as any;
                for (let item of _data["brandGroups"])
                    this.brandGroups!.push(BrandGroup.fromJS(item));
            }
            if (Array.isArray(_data["competitorBranchGroups"])) {
                this.competitorBranchGroups = [] as any;
                for (let item of _data["competitorBranchGroups"])
                    this.competitorBranchGroups!.push(CompetitorBranchGroup.fromJS(item));
            }
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["email"] = this.email;
        data["cultureCode"] = this.cultureCode;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["industryId"] = this.industryId;
        data["organizationId"] = this.organizationId;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["industry"] = this.industry ? this.industry.toJSON() : <any>undefined;
        if (Array.isArray(this.subscriptionsSharing)) {
            data["subscriptionsSharing"] = [];
            for (let item of this.subscriptionsSharing)
                data["subscriptionsSharing"].push(item.toJSON());
        }
        if (Array.isArray(this.authenticationProviders)) {
            data["authenticationProviders"] = [];
            for (let item of this.authenticationProviders)
                data["authenticationProviders"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.infos)) {
            data["infos"] = [];
            for (let item of this.infos)
                data["infos"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionDomains)) {
            data["subscriptionDomains"] = [];
            for (let item of this.subscriptionDomains)
                data["subscriptionDomains"].push(item.toJSON());
        }
        if (Array.isArray(this.brandGroups)) {
            data["brandGroups"] = [];
            for (let item of this.brandGroups)
                data["brandGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.competitorBranchGroups)) {
            data["competitorBranchGroups"] = [];
            for (let item of this.competitorBranchGroups)
                data["competitorBranchGroups"].push(item.toJSON());
        }
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscription extends IHierarchyEntityBase {
    name?: string | undefined;
    normalizedName?: string | undefined;
    email?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    industryId?: string | undefined;
    organizationId?: string;
    organization?: Organization | undefined;
    industry?: Industry | undefined;
    subscriptionsSharing?: SubscriptionSharing[] | undefined;
    authenticationProviders?: AuthenticationProvider[] | undefined;
    subscriptionServices?: SubscriptionService[] | undefined;
    branches?: Branch[] | undefined;
    cultures?: SubscriptionCulture[] | undefined;
    infos?: SubscriptionInformation[] | undefined;
    subscriptionDomains?: SubscriptionDomain[] | undefined;
    brandGroups?: BrandGroup[] | undefined;
    competitorBranchGroups?: CompetitorBranchGroup[] | undefined;
    state?: string | undefined;
}

export class Organization extends HierarchyEntityBase implements IOrganization {
    name?: string | undefined;
    displayName?: string | undefined;
    normalizedName?: string | undefined;
    email?: string | undefined;
    isSaas?: boolean;
    imageBlobStorageId?: string | undefined;
    addresses?: AddressType[] | undefined;
    subscriptions?: Subscription[] | undefined;
    subscriptionsSharings?: SubscriptionSharing[] | undefined;
    organizationDomains?: OrganizationDomain[] | undefined;
    cultures?: OrganizationCulture[] | undefined;

    constructor(data?: IOrganization) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.email = _data["email"];
            this.isSaas = _data["isSaas"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(AddressType.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(Subscription.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionsSharings"])) {
                this.subscriptionsSharings = [] as any;
                for (let item of _data["subscriptionsSharings"])
                    this.subscriptionsSharings!.push(SubscriptionSharing.fromJS(item));
            }
            if (Array.isArray(_data["organizationDomains"])) {
                this.organizationDomains = [] as any;
                for (let item of _data["organizationDomains"])
                    this.organizationDomains!.push(OrganizationDomain.fromJS(item));
            }
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(OrganizationCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["email"] = this.email;
        data["isSaas"] = this.isSaas;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionsSharings)) {
            data["subscriptionsSharings"] = [];
            for (let item of this.subscriptionsSharings)
                data["subscriptionsSharings"].push(item.toJSON());
        }
        if (Array.isArray(this.organizationDomains)) {
            data["organizationDomains"] = [];
            for (let item of this.organizationDomains)
                data["organizationDomains"].push(item.toJSON());
        }
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOrganization extends IHierarchyEntityBase {
    name?: string | undefined;
    displayName?: string | undefined;
    normalizedName?: string | undefined;
    email?: string | undefined;
    isSaas?: boolean;
    imageBlobStorageId?: string | undefined;
    addresses?: AddressType[] | undefined;
    subscriptions?: Subscription[] | undefined;
    subscriptionsSharings?: SubscriptionSharing[] | undefined;
    organizationDomains?: OrganizationDomain[] | undefined;
    cultures?: OrganizationCulture[] | undefined;
}

export class AddressType extends EntityBase implements IAddressType {
    organizationId?: string;
    country?: string | undefined;
    department?: string | undefined;
    locality?: string | undefined;
    city?: string | undefined;
    latitude?: number;
    longitude?: number;
    address?: string | undefined;
    postalCode?: string | undefined;
    organization?: Organization | undefined;
    branches?: Branch[] | undefined;

    constructor(data?: IAddressType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.country = _data["country"];
            this.department = _data["department"];
            this.locality = _data["locality"];
            this.city = _data["city"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(Branch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddressType {
        data = typeof data === 'object' ? data : {};
        let result = new AddressType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["country"] = this.country;
        data["department"] = this.department;
        data["locality"] = this.locality;
        data["city"] = this.city;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAddressType extends IEntityBase {
    organizationId?: string;
    country?: string | undefined;
    department?: string | undefined;
    locality?: string | undefined;
    city?: string | undefined;
    latitude?: number;
    longitude?: number;
    address?: string | undefined;
    postalCode?: string | undefined;
    organization?: Organization | undefined;
    branches?: Branch[] | undefined;
}

export class Branch extends HierarchyEntityBase implements IBranch {
    name?: string | undefined;
    addressId?: string;
    subscriptionId?: string;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
    imageBlobStorageId?: string | undefined;
    code?: string | undefined;
    longitude?: number | undefined;
    latitude?: number | undefined;
    geocoordinate?: Point | undefined;
    address?: AddressType | undefined;
    doNotServeCustomerAtAddress?: boolean;
    subscription?: Subscription | undefined;
    branchGroupBranches?: BranchGroupBranch[] | undefined;
    branchServiceBranches?: BranchServiceBranch[] | undefined;
    cultures?: BranchCulture[] | undefined;
    socialMedia?: BranchSocialMedia[] | undefined;
    participatesIn?: ParticipatingBranch[] | undefined;
    googleCategories?: BranchGoogleCategory[] | undefined;
    additionalPhones?: BranchAdditionalPhone[] | undefined;
    googleAttributes?: BranchGoogleAttribute[] | undefined;
    specialOpenings?: BranchSpecialOpening[] | undefined;
    branchKeywords?: BranchKeywordBranch[] | undefined;
    openingHours?: BranchOpeningHour[] | undefined;
    competitorBranchGroups?: CompetitorBranchGroup[] | undefined;
    brandGroups?: BrandGroup[] | undefined;

    constructor(data?: IBranch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.addressId = _data["addressId"];
            this.subscriptionId = _data["subscriptionId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.code = _data["code"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.geocoordinate = _data["geocoordinate"] ? Point.fromJS(_data["geocoordinate"]) : <any>undefined;
            this.address = _data["address"] ? AddressType.fromJS(_data["address"]) : <any>undefined;
            this.doNotServeCustomerAtAddress = _data["doNotServeCustomerAtAddress"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            if (Array.isArray(_data["branchGroupBranches"])) {
                this.branchGroupBranches = [] as any;
                for (let item of _data["branchGroupBranches"])
                    this.branchGroupBranches!.push(BranchGroupBranch.fromJS(item));
            }
            if (Array.isArray(_data["branchServiceBranches"])) {
                this.branchServiceBranches = [] as any;
                for (let item of _data["branchServiceBranches"])
                    this.branchServiceBranches!.push(BranchServiceBranch.fromJS(item));
            }
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(BranchCulture.fromJS(item));
            }
            if (Array.isArray(_data["socialMedia"])) {
                this.socialMedia = [] as any;
                for (let item of _data["socialMedia"])
                    this.socialMedia!.push(BranchSocialMedia.fromJS(item));
            }
            if (Array.isArray(_data["participatesIn"])) {
                this.participatesIn = [] as any;
                for (let item of _data["participatesIn"])
                    this.participatesIn!.push(ParticipatingBranch.fromJS(item));
            }
            if (Array.isArray(_data["googleCategories"])) {
                this.googleCategories = [] as any;
                for (let item of _data["googleCategories"])
                    this.googleCategories!.push(BranchGoogleCategory.fromJS(item));
            }
            if (Array.isArray(_data["additionalPhones"])) {
                this.additionalPhones = [] as any;
                for (let item of _data["additionalPhones"])
                    this.additionalPhones!.push(BranchAdditionalPhone.fromJS(item));
            }
            if (Array.isArray(_data["googleAttributes"])) {
                this.googleAttributes = [] as any;
                for (let item of _data["googleAttributes"])
                    this.googleAttributes!.push(BranchGoogleAttribute.fromJS(item));
            }
            if (Array.isArray(_data["specialOpenings"])) {
                this.specialOpenings = [] as any;
                for (let item of _data["specialOpenings"])
                    this.specialOpenings!.push(BranchSpecialOpening.fromJS(item));
            }
            if (Array.isArray(_data["branchKeywords"])) {
                this.branchKeywords = [] as any;
                for (let item of _data["branchKeywords"])
                    this.branchKeywords!.push(BranchKeywordBranch.fromJS(item));
            }
            if (Array.isArray(_data["openingHours"])) {
                this.openingHours = [] as any;
                for (let item of _data["openingHours"])
                    this.openingHours!.push(BranchOpeningHour.fromJS(item));
            }
            if (Array.isArray(_data["competitorBranchGroups"])) {
                this.competitorBranchGroups = [] as any;
                for (let item of _data["competitorBranchGroups"])
                    this.competitorBranchGroups!.push(CompetitorBranchGroup.fromJS(item));
            }
            if (Array.isArray(_data["brandGroups"])) {
                this.brandGroups = [] as any;
                for (let item of _data["brandGroups"])
                    this.brandGroups!.push(BrandGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Branch {
        data = typeof data === 'object' ? data : {};
        let result = new Branch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["addressId"] = this.addressId;
        data["subscriptionId"] = this.subscriptionId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["code"] = this.code;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["doNotServeCustomerAtAddress"] = this.doNotServeCustomerAtAddress;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        if (Array.isArray(this.branchGroupBranches)) {
            data["branchGroupBranches"] = [];
            for (let item of this.branchGroupBranches)
                data["branchGroupBranches"].push(item.toJSON());
        }
        if (Array.isArray(this.branchServiceBranches)) {
            data["branchServiceBranches"] = [];
            for (let item of this.branchServiceBranches)
                data["branchServiceBranches"].push(item.toJSON());
        }
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.socialMedia)) {
            data["socialMedia"] = [];
            for (let item of this.socialMedia)
                data["socialMedia"].push(item.toJSON());
        }
        if (Array.isArray(this.participatesIn)) {
            data["participatesIn"] = [];
            for (let item of this.participatesIn)
                data["participatesIn"].push(item.toJSON());
        }
        if (Array.isArray(this.googleCategories)) {
            data["googleCategories"] = [];
            for (let item of this.googleCategories)
                data["googleCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalPhones)) {
            data["additionalPhones"] = [];
            for (let item of this.additionalPhones)
                data["additionalPhones"].push(item.toJSON());
        }
        if (Array.isArray(this.googleAttributes)) {
            data["googleAttributes"] = [];
            for (let item of this.googleAttributes)
                data["googleAttributes"].push(item.toJSON());
        }
        if (Array.isArray(this.specialOpenings)) {
            data["specialOpenings"] = [];
            for (let item of this.specialOpenings)
                data["specialOpenings"].push(item.toJSON());
        }
        if (Array.isArray(this.branchKeywords)) {
            data["branchKeywords"] = [];
            for (let item of this.branchKeywords)
                data["branchKeywords"].push(item.toJSON());
        }
        if (Array.isArray(this.openingHours)) {
            data["openingHours"] = [];
            for (let item of this.openingHours)
                data["openingHours"].push(item.toJSON());
        }
        if (Array.isArray(this.competitorBranchGroups)) {
            data["competitorBranchGroups"] = [];
            for (let item of this.competitorBranchGroups)
                data["competitorBranchGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.brandGroups)) {
            data["brandGroups"] = [];
            for (let item of this.brandGroups)
                data["brandGroups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBranch extends IHierarchyEntityBase {
    name?: string | undefined;
    addressId?: string;
    subscriptionId?: string;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
    imageBlobStorageId?: string | undefined;
    code?: string | undefined;
    longitude?: number | undefined;
    latitude?: number | undefined;
    geocoordinate?: Point | undefined;
    address?: AddressType | undefined;
    doNotServeCustomerAtAddress?: boolean;
    subscription?: Subscription | undefined;
    branchGroupBranches?: BranchGroupBranch[] | undefined;
    branchServiceBranches?: BranchServiceBranch[] | undefined;
    cultures?: BranchCulture[] | undefined;
    socialMedia?: BranchSocialMedia[] | undefined;
    participatesIn?: ParticipatingBranch[] | undefined;
    googleCategories?: BranchGoogleCategory[] | undefined;
    additionalPhones?: BranchAdditionalPhone[] | undefined;
    googleAttributes?: BranchGoogleAttribute[] | undefined;
    specialOpenings?: BranchSpecialOpening[] | undefined;
    branchKeywords?: BranchKeywordBranch[] | undefined;
    openingHours?: BranchOpeningHour[] | undefined;
    competitorBranchGroups?: CompetitorBranchGroup[] | undefined;
    brandGroups?: BrandGroup[] | undefined;
}

export class BranchGroupBranch implements IBranchGroupBranch {
    branchId?: string;
    branchGroupId?: string;
    branch?: Branch | undefined;
    branchGroup?: BranchGroup | undefined;

    constructor(data?: IBranchGroupBranch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.branchGroupId = _data["branchGroupId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
            this.branchGroup = _data["branchGroup"] ? BranchGroup.fromJS(_data["branchGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchGroupBranch {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGroupBranch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["branchGroupId"] = this.branchGroupId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchGroup"] = this.branchGroup ? this.branchGroup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBranchGroupBranch {
    branchId?: string;
    branchGroupId?: string;
    branch?: Branch | undefined;
    branchGroup?: BranchGroup | undefined;
}

export class BranchGroup extends HierarchyEntityBase implements IBranchGroup {
    name?: string | undefined;
    parentId?: string | undefined;
    subscriptionId?: string;
    parent?: BranchGroup | undefined;
    subscription?: Subscription | undefined;
    cultures?: BranchGroupCulture[] | undefined;
    branchGroupBranches?: BranchGroupBranch[] | undefined;
    children?: BranchGroup[] | undefined;

    constructor(data?: IBranchGroup) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.subscriptionId = _data["subscriptionId"];
            this.parent = _data["parent"] ? BranchGroup.fromJS(_data["parent"]) : <any>undefined;
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(BranchGroupCulture.fromJS(item));
            }
            if (Array.isArray(_data["branchGroupBranches"])) {
                this.branchGroupBranches = [] as any;
                for (let item of _data["branchGroupBranches"])
                    this.branchGroupBranches!.push(BranchGroupBranch.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BranchGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchGroup {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["subscriptionId"] = this.subscriptionId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.branchGroupBranches)) {
            data["branchGroupBranches"] = [];
            for (let item of this.branchGroupBranches)
                data["branchGroupBranches"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBranchGroup extends IHierarchyEntityBase {
    name?: string | undefined;
    parentId?: string | undefined;
    subscriptionId?: string;
    parent?: BranchGroup | undefined;
    subscription?: Subscription | undefined;
    cultures?: BranchGroupCulture[] | undefined;
    branchGroupBranches?: BranchGroupBranch[] | undefined;
    children?: BranchGroup[] | undefined;
}

export class BranchGroupCulture extends EntityBase implements IBranchGroupCulture {
    branchGroupId?: string;
    name?: string | undefined;
    cultureCode?: string;
    branchGroup?: BranchGroup;

    constructor(data?: IBranchGroupCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchGroupId = _data["branchGroupId"];
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
            this.branchGroup = _data["branchGroup"] ? BranchGroup.fromJS(_data["branchGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchGroupCulture {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGroupCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchGroupId"] = this.branchGroupId;
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        data["branchGroup"] = this.branchGroup ? this.branchGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBranchGroupCulture extends IEntityBase {
    branchGroupId?: string;
    name?: string | undefined;
    cultureCode?: string;
    branchGroup?: BranchGroup;
}

export class BranchServiceBranch implements IBranchServiceBranch {
    branchId?: string;
    branchServiceId?: string;
    branch?: Branch | undefined;
    branchService?: BranchService | undefined;

    constructor(data?: IBranchServiceBranch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.branchServiceId = _data["branchServiceId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
            this.branchService = _data["branchService"] ? BranchService.fromJS(_data["branchService"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchServiceBranch {
        data = typeof data === 'object' ? data : {};
        let result = new BranchServiceBranch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["branchServiceId"] = this.branchServiceId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branchService"] = this.branchService ? this.branchService.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBranchServiceBranch {
    branchId?: string;
    branchServiceId?: string;
    branch?: Branch | undefined;
    branchService?: BranchService | undefined;
}

export class BranchService extends HierarchyEntityBase implements IBranchService {
    subscriptionId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;
    subscription?: Subscription | undefined;
    branchServiceBranches?: BranchServiceBranch[] | undefined;
    cultures?: BranchServiceCulture[] | undefined;

    constructor(data?: IBranchService) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            if (Array.isArray(_data["branchServiceBranches"])) {
                this.branchServiceBranches = [] as any;
                for (let item of _data["branchServiceBranches"])
                    this.branchServiceBranches!.push(BranchServiceBranch.fromJS(item));
            }
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(BranchServiceCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchService {
        data = typeof data === 'object' ? data : {};
        let result = new BranchService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        if (Array.isArray(this.branchServiceBranches)) {
            data["branchServiceBranches"] = [];
            for (let item of this.branchServiceBranches)
                data["branchServiceBranches"].push(item.toJSON());
        }
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBranchService extends IHierarchyEntityBase {
    subscriptionId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;
    subscription?: Subscription | undefined;
    branchServiceBranches?: BranchServiceBranch[] | undefined;
    cultures?: BranchServiceCulture[] | undefined;
}

export class BranchServiceCulture extends EntityBase implements IBranchServiceCulture {
    branchServiceId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    cultureCode?: string | undefined;
    branchService?: BranchService | undefined;

    constructor(data?: IBranchServiceCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchServiceId = _data["branchServiceId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.cultureCode = _data["cultureCode"];
            this.branchService = _data["branchService"] ? BranchService.fromJS(_data["branchService"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchServiceCulture {
        data = typeof data === 'object' ? data : {};
        let result = new BranchServiceCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchServiceId"] = this.branchServiceId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["cultureCode"] = this.cultureCode;
        data["branchService"] = this.branchService ? this.branchService.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBranchServiceCulture extends IEntityBase {
    branchServiceId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    cultureCode?: string | undefined;
    branchService?: BranchService | undefined;
}

export class BranchCulture extends EntityBase implements IBranchCulture {
    branchId?: string;
    name?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    branch?: Branch | undefined;

    constructor(data?: IBranchCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchCulture {
        data = typeof data === 'object' ? data : {};
        let result = new BranchCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBranchCulture extends IEntityBase {
    branchId?: string;
    name?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    branch?: Branch | undefined;
}

export class BranchSocialMedia extends EntityBase implements IBranchSocialMedia {
    branchId?: string;
    type?: SocialMedia;
    url?: string | undefined;

    constructor(data?: IBranchSocialMedia) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchId = _data["branchId"];
            this.type = _data["type"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): BranchSocialMedia {
        data = typeof data === 'object' ? data : {};
        let result = new BranchSocialMedia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["type"] = this.type;
        data["url"] = this.url;
        super.toJSON(data);
        return data;
    }
}

export interface IBranchSocialMedia extends IEntityBase {
    branchId?: string;
    type?: SocialMedia;
    url?: string | undefined;
}

export class ParticipatingBranch extends EntityBase implements IParticipatingBranch {
    branchId?: string;
    subjectType?: string;
    subjectId?: string;
    subjectPath?: any[];
    enabled?: boolean;
    included?: boolean;
    branch?: Branch;

    constructor(data?: IParticipatingBranch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchId = _data["branchId"];
            this.subjectType = _data["subjectType"];
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.enabled = _data["enabled"];
            this.included = _data["included"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipatingBranch {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipatingBranch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["subjectType"] = this.subjectType;
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["enabled"] = this.enabled;
        data["included"] = this.included;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IParticipatingBranch extends IEntityBase {
    branchId?: string;
    subjectType?: string;
    subjectId?: string;
    subjectPath?: any[];
    enabled?: boolean;
    included?: boolean;
    branch?: Branch;
}

export class BranchOpeningHour extends EntityBase implements IBranchOpeningHour {
    branchId?: string;
    weekDay?: WeekDay;
    openHour?: string | undefined;
    closeHour?: string | undefined;

    constructor(data?: IBranchOpeningHour) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchId = _data["branchId"];
            this.weekDay = _data["weekDay"];
            this.openHour = _data["openHour"];
            this.closeHour = _data["closeHour"];
        }
    }

    static fromJS(data: any): BranchOpeningHour {
        data = typeof data === 'object' ? data : {};
        let result = new BranchOpeningHour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["weekDay"] = this.weekDay;
        data["openHour"] = this.openHour;
        data["closeHour"] = this.closeHour;
        super.toJSON(data);
        return data;
    }
}

export interface IBranchOpeningHour extends IEntityBase {
    branchId?: string;
    weekDay?: WeekDay;
    openHour?: string | undefined;
    closeHour?: string | undefined;
}

export abstract class PortalEntityBase implements IPortalEntityBase {
    id?: string;
    createdBy?: string;
    createdDate?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;

    constructor(data?: IPortalEntityBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PortalEntityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PortalEntityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPortalEntityBase {
    id?: string;
    createdBy?: string;
    createdDate?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
}

export class CompetitorBranchGroup extends PortalEntityBase implements ICompetitorBranchGroup {
    name?: string;
    subscriptionId?: string;
    subscription?: Subscription;
    cultures?: CompetitorBranchGroupCulture[];
    competitorBranches?: CompetitorBranch[];
    branches?: Branch[];

    constructor(data?: ICompetitorBranchGroup) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(CompetitorBranchGroupCulture.fromJS(item));
            }
            if (Array.isArray(_data["competitorBranches"])) {
                this.competitorBranches = [] as any;
                for (let item of _data["competitorBranches"])
                    this.competitorBranches!.push(CompetitorBranch.fromJS(item));
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(Branch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitorBranchGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorBranchGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["subscriptionId"] = this.subscriptionId;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.competitorBranches)) {
            data["competitorBranches"] = [];
            for (let item of this.competitorBranches)
                data["competitorBranches"].push(item.toJSON());
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICompetitorBranchGroup extends IPortalEntityBase {
    name?: string;
    subscriptionId?: string;
    subscription?: Subscription;
    cultures?: CompetitorBranchGroupCulture[];
    competitorBranches?: CompetitorBranch[];
    branches?: Branch[];
}

export class CompetitorBranchGroupCulture extends PortalEntityBase implements ICompetitorBranchGroupCulture {
    cultureCode?: string;
    name?: string | undefined;
    competitorBranchGroupId?: string;
    competitorBranchGroup?: CompetitorBranchGroup;

    constructor(data?: ICompetitorBranchGroupCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.name = _data["name"];
            this.competitorBranchGroupId = _data["competitorBranchGroupId"];
            this.competitorBranchGroup = _data["competitorBranchGroup"] ? CompetitorBranchGroup.fromJS(_data["competitorBranchGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompetitorBranchGroupCulture {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorBranchGroupCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["name"] = this.name;
        data["competitorBranchGroupId"] = this.competitorBranchGroupId;
        data["competitorBranchGroup"] = this.competitorBranchGroup ? this.competitorBranchGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICompetitorBranchGroupCulture extends IPortalEntityBase {
    cultureCode?: string;
    name?: string | undefined;
    competitorBranchGroupId?: string;
    competitorBranchGroup?: CompetitorBranchGroup;
}

export class CompetitorBranch extends PortalEntityBase implements ICompetitorBranch {
    code?: string | undefined;
    deletedBy?: string | undefined;
    deletedDate?: Date | undefined;
    globalCompetitorBranchId?: string;
    subscriptionId?: string;
    globalCompetitorBranch?: GlobalCompetitorBranch;
    subscription?: Subscription;
    competitorBranchGroups?: CompetitorBranchGroup[];
    brandGroups?: BrandGroup[];

    constructor(data?: ICompetitorBranch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.deletedBy = _data["deletedBy"];
            this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : <any>undefined;
            this.globalCompetitorBranchId = _data["globalCompetitorBranchId"];
            this.subscriptionId = _data["subscriptionId"];
            this.globalCompetitorBranch = _data["globalCompetitorBranch"] ? GlobalCompetitorBranch.fromJS(_data["globalCompetitorBranch"]) : <any>undefined;
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            if (Array.isArray(_data["competitorBranchGroups"])) {
                this.competitorBranchGroups = [] as any;
                for (let item of _data["competitorBranchGroups"])
                    this.competitorBranchGroups!.push(CompetitorBranchGroup.fromJS(item));
            }
            if (Array.isArray(_data["brandGroups"])) {
                this.brandGroups = [] as any;
                for (let item of _data["brandGroups"])
                    this.brandGroups!.push(BrandGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitorBranch {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorBranch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["deletedBy"] = this.deletedBy;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
        data["globalCompetitorBranchId"] = this.globalCompetitorBranchId;
        data["subscriptionId"] = this.subscriptionId;
        data["globalCompetitorBranch"] = this.globalCompetitorBranch ? this.globalCompetitorBranch.toJSON() : <any>undefined;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        if (Array.isArray(this.competitorBranchGroups)) {
            data["competitorBranchGroups"] = [];
            for (let item of this.competitorBranchGroups)
                data["competitorBranchGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.brandGroups)) {
            data["brandGroups"] = [];
            for (let item of this.brandGroups)
                data["brandGroups"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICompetitorBranch extends IPortalEntityBase {
    code?: string | undefined;
    deletedBy?: string | undefined;
    deletedDate?: Date | undefined;
    globalCompetitorBranchId?: string;
    subscriptionId?: string;
    globalCompetitorBranch?: GlobalCompetitorBranch;
    subscription?: Subscription;
    competitorBranchGroups?: CompetitorBranchGroup[];
    brandGroups?: BrandGroup[];
}

export class GlobalCompetitorBranch extends PortalEntityBase implements IGlobalCompetitorBranch {
    name?: string;
    imageBlobStorageId?: string | undefined;
    address?: AddressType2;
    deletedBy?: string | undefined;
    deletedDate?: Date | undefined;
    cultures?: GlobalCompetitorBranchCulture[];

    constructor(data?: IGlobalCompetitorBranch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.address = _data["address"] ? AddressType2.fromJS(_data["address"]) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(GlobalCompetitorBranchCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalCompetitorBranch {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalCompetitorBranch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGlobalCompetitorBranch extends IPortalEntityBase {
    name?: string;
    imageBlobStorageId?: string | undefined;
    address?: AddressType2;
    deletedBy?: string | undefined;
    deletedDate?: Date | undefined;
    cultures?: GlobalCompetitorBranchCulture[];
}

export class AddressType2 implements IAddressType2 {
    address?: string;
    city?: string;
    department?: string;
    locality?: string;
    country?: string;
    postalCode?: string;
    geocoordinate?: Point | undefined;

    constructor(data?: IAddressType2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.department = _data["department"];
            this.locality = _data["locality"];
            this.country = _data["country"];
            this.postalCode = _data["postalCode"];
            this.geocoordinate = _data["geocoordinate"] ? Point.fromJS(_data["geocoordinate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddressType2 {
        data = typeof data === 'object' ? data : {};
        let result = new AddressType2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["department"] = this.department;
        data["locality"] = this.locality;
        data["country"] = this.country;
        data["postalCode"] = this.postalCode;
        data["geocoordinate"] = this.geocoordinate ? this.geocoordinate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddressType2 {
    address?: string;
    city?: string;
    department?: string;
    locality?: string;
    country?: string;
    postalCode?: string;
    geocoordinate?: Point | undefined;
}

export class GlobalCompetitorBranchCulture extends PortalEntityBase implements IGlobalCompetitorBranchCulture {
    cultureCode?: string;
    name?: string | undefined;
    globalCompetitorBranchId?: string;
    globalCompetitorBranch?: GlobalCompetitorBranch;

    constructor(data?: IGlobalCompetitorBranchCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.name = _data["name"];
            this.globalCompetitorBranchId = _data["globalCompetitorBranchId"];
            this.globalCompetitorBranch = _data["globalCompetitorBranch"] ? GlobalCompetitorBranch.fromJS(_data["globalCompetitorBranch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GlobalCompetitorBranchCulture {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalCompetitorBranchCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["name"] = this.name;
        data["globalCompetitorBranchId"] = this.globalCompetitorBranchId;
        data["globalCompetitorBranch"] = this.globalCompetitorBranch ? this.globalCompetitorBranch.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGlobalCompetitorBranchCulture extends IPortalEntityBase {
    cultureCode?: string;
    name?: string | undefined;
    globalCompetitorBranchId?: string;
    globalCompetitorBranch?: GlobalCompetitorBranch;
}

export class BrandGroup extends PortalEntityBase implements IBrandGroup {
    name?: string;
    order?: number;
    subscriptionId?: string;
    subscription?: Subscription;
    cultures?: BrandGroupCulture[];
    competitorBranches?: CompetitorBranch[];
    branches?: Branch[];

    constructor(data?: IBrandGroup) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.order = _data["order"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(BrandGroupCulture.fromJS(item));
            }
            if (Array.isArray(_data["competitorBranches"])) {
                this.competitorBranches = [] as any;
                for (let item of _data["competitorBranches"])
                    this.competitorBranches!.push(CompetitorBranch.fromJS(item));
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(Branch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BrandGroup {
        data = typeof data === 'object' ? data : {};
        let result = new BrandGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        data["subscriptionId"] = this.subscriptionId;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.competitorBranches)) {
            data["competitorBranches"] = [];
            for (let item of this.competitorBranches)
                data["competitorBranches"].push(item.toJSON());
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBrandGroup extends IPortalEntityBase {
    name?: string;
    order?: number;
    subscriptionId?: string;
    subscription?: Subscription;
    cultures?: BrandGroupCulture[];
    competitorBranches?: CompetitorBranch[];
    branches?: Branch[];
}

export class BrandGroupCulture extends PortalEntityBase implements IBrandGroupCulture {
    cultureCode?: string;
    name?: string | undefined;
    brandGroupId?: string;
    brandGroup?: BrandGroup;

    constructor(data?: IBrandGroupCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.name = _data["name"];
            this.brandGroupId = _data["brandGroupId"];
            this.brandGroup = _data["brandGroup"] ? BrandGroup.fromJS(_data["brandGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BrandGroupCulture {
        data = typeof data === 'object' ? data : {};
        let result = new BrandGroupCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["name"] = this.name;
        data["brandGroupId"] = this.brandGroupId;
        data["brandGroup"] = this.brandGroup ? this.brandGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBrandGroupCulture extends IPortalEntityBase {
    cultureCode?: string;
    name?: string | undefined;
    brandGroupId?: string;
    brandGroup?: BrandGroup;
}

export class SubscriptionSharing extends EntityBase implements ISubscriptionSharing {
    organization?: Organization | undefined;
    organizationId?: string;
    subscription?: Subscription | undefined;
    subscriptionId?: string;

    constructor(data?: ISubscriptionSharing) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.organizationId = _data["organizationId"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): SubscriptionSharing {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionSharing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["organizationId"] = this.organizationId;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        data["subscriptionId"] = this.subscriptionId;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionSharing extends IEntityBase {
    organization?: Organization | undefined;
    organizationId?: string;
    subscription?: Subscription | undefined;
    subscriptionId?: string;
}

export class OrganizationCulture extends EntityBase implements IOrganizationCulture {
    organizationId?: string;
    name?: string | undefined;
    displayName?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    organization?: Organization | undefined;
    state?: string | undefined;

    constructor(data?: IOrganizationCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.cultureCode = _data["cultureCode"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): OrganizationCulture {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["cultureCode"] = this.cultureCode;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationCulture extends IEntityBase {
    organizationId?: string;
    name?: string | undefined;
    displayName?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    organization?: Organization | undefined;
    state?: string | undefined;
}

export class Industry extends EntityBase implements IIndustry {
    name?: string | undefined;
    text?: string | undefined;
    code?: string | undefined;
    imageBlobStorageId?: string | undefined;
    parentId?: string | undefined;
    order?: number;
    isEnabled?: boolean;
    isOversightWidgetEnabled?: boolean;
    parent?: Industry | undefined;
    cultures?: IndustryCulture[] | undefined;
    services?: IndustryService[] | undefined;
    infos?: IndustryInformation[] | undefined;
    children?: Industry[] | undefined;

    constructor(data?: IIndustry) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.text = _data["text"];
            this.code = _data["code"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.parentId = _data["parentId"];
            this.order = _data["order"];
            this.isEnabled = _data["isEnabled"];
            this.isOversightWidgetEnabled = _data["isOversightWidgetEnabled"];
            this.parent = _data["parent"] ? Industry.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(IndustryCulture.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(IndustryService.fromJS(item));
            }
            if (Array.isArray(_data["infos"])) {
                this.infos = [] as any;
                for (let item of _data["infos"])
                    this.infos!.push(IndustryInformation.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Industry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Industry {
        data = typeof data === 'object' ? data : {};
        let result = new Industry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["text"] = this.text;
        data["code"] = this.code;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["parentId"] = this.parentId;
        data["order"] = this.order;
        data["isEnabled"] = this.isEnabled;
        data["isOversightWidgetEnabled"] = this.isOversightWidgetEnabled;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.infos)) {
            data["infos"] = [];
            for (let item of this.infos)
                data["infos"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIndustry extends IEntityBase {
    name?: string | undefined;
    text?: string | undefined;
    code?: string | undefined;
    imageBlobStorageId?: string | undefined;
    parentId?: string | undefined;
    order?: number;
    isEnabled?: boolean;
    isOversightWidgetEnabled?: boolean;
    parent?: Industry | undefined;
    cultures?: IndustryCulture[] | undefined;
    services?: IndustryService[] | undefined;
    infos?: IndustryInformation[] | undefined;
    children?: Industry[] | undefined;
}

export class IndustryCulture extends EntityBase implements IIndustryCulture {
    industryId?: string;
    name?: string | undefined;
    text?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    industry?: Industry | undefined;

    constructor(data?: IIndustryCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.industryId = _data["industryId"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.cultureCode = _data["cultureCode"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.industry = _data["industry"] ? Industry.fromJS(_data["industry"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IndustryCulture {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryId"] = this.industryId;
        data["name"] = this.name;
        data["text"] = this.text;
        data["cultureCode"] = this.cultureCode;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["industry"] = this.industry ? this.industry.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IIndustryCulture extends IEntityBase {
    industryId?: string;
    name?: string | undefined;
    text?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    industry?: Industry | undefined;
}

export class IndustryService extends EntityBase implements IIndustryService {
    industryId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;
    order?: number;
    industry?: Industry | undefined;
    cultures?: IndustryServiceCulture[] | undefined;

    constructor(data?: IIndustryService) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.industryId = _data["industryId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
            this.order = _data["order"];
            this.industry = _data["industry"] ? Industry.fromJS(_data["industry"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(IndustryServiceCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndustryService {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryId"] = this.industryId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        data["order"] = this.order;
        data["industry"] = this.industry ? this.industry.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIndustryService extends IEntityBase {
    industryId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;
    order?: number;
    industry?: Industry | undefined;
    cultures?: IndustryServiceCulture[] | undefined;
}

export class IndustryServiceCulture extends EntityBase implements IIndustryServiceCulture {
    industryServiceId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    industryService?: IndustryService | undefined;

    constructor(data?: IIndustryServiceCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.industryServiceId = _data["industryServiceId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.cultureCode = _data["cultureCode"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.industryService = _data["industryService"] ? IndustryService.fromJS(_data["industryService"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IndustryServiceCulture {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryServiceCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryServiceId"] = this.industryServiceId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["cultureCode"] = this.cultureCode;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["industryService"] = this.industryService ? this.industryService.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IIndustryServiceCulture extends IEntityBase {
    industryServiceId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    industryService?: IndustryService | undefined;
}

export class IndustryInformation extends EntityBase implements IIndustryInformation {
    industryId?: string;
    questionType?: QuestionType;
    order?: number;
    industry?: Industry | undefined;

    constructor(data?: IIndustryInformation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.industryId = _data["industryId"];
            this.questionType = _data["questionType"];
            this.order = _data["order"];
            this.industry = _data["industry"] ? Industry.fromJS(_data["industry"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IndustryInformation {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryId"] = this.industryId;
        data["questionType"] = this.questionType;
        data["order"] = this.order;
        data["industry"] = this.industry ? this.industry.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IIndustryInformation extends IEntityBase {
    industryId?: string;
    questionType?: QuestionType;
    order?: number;
    industry?: Industry | undefined;
}

export class AuthenticationProvider extends EntityBase implements IAuthenticationProvider {
    name?: string | undefined;
    remoteAuthenticationOptionsId?: string;
    subscriptionId?: string;
    remoteAuthenticationOptions?: RemoteAuthenticationOptions | undefined;
    subscription?: Subscription | undefined;
    domains?: Domain[] | undefined;

    constructor(data?: IAuthenticationProvider) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.remoteAuthenticationOptionsId = _data["remoteAuthenticationOptionsId"];
            this.subscriptionId = _data["subscriptionId"];
            this.remoteAuthenticationOptions = _data["remoteAuthenticationOptions"] ? RemoteAuthenticationOptions.fromJS(_data["remoteAuthenticationOptions"]) : <any>undefined;
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            if (Array.isArray(_data["domains"])) {
                this.domains = [] as any;
                for (let item of _data["domains"])
                    this.domains!.push(Domain.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthenticationProvider {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["remoteAuthenticationOptionsId"] = this.remoteAuthenticationOptionsId;
        data["subscriptionId"] = this.subscriptionId;
        data["remoteAuthenticationOptions"] = this.remoteAuthenticationOptions ? this.remoteAuthenticationOptions.toJSON() : <any>undefined;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        if (Array.isArray(this.domains)) {
            data["domains"] = [];
            for (let item of this.domains)
                data["domains"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAuthenticationProvider extends IEntityBase {
    name?: string | undefined;
    remoteAuthenticationOptionsId?: string;
    subscriptionId?: string;
    remoteAuthenticationOptions?: RemoteAuthenticationOptions | undefined;
    subscription?: Subscription | undefined;
    domains?: Domain[] | undefined;
}

export class RemoteAuthenticationOptions extends EntityBase implements IRemoteAuthenticationOptions {
    authority?: string | undefined;
    authenticationProvider?: AuthenticationProvider | undefined;
    authenticationProviderId?: string;

    constructor(data?: IRemoteAuthenticationOptions) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authority = _data["authority"];
            this.authenticationProvider = _data["authenticationProvider"] ? AuthenticationProvider.fromJS(_data["authenticationProvider"]) : <any>undefined;
            this.authenticationProviderId = _data["authenticationProviderId"];
        }
    }

    static fromJS(data: any): RemoteAuthenticationOptions {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteAuthenticationOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority;
        data["authenticationProvider"] = this.authenticationProvider ? this.authenticationProvider.toJSON() : <any>undefined;
        data["authenticationProviderId"] = this.authenticationProviderId;
        super.toJSON(data);
        return data;
    }
}

export interface IRemoteAuthenticationOptions extends IEntityBase {
    authority?: string | undefined;
    authenticationProvider?: AuthenticationProvider | undefined;
    authenticationProviderId?: string;
}

export class Domain extends EntityBase implements IDomain {
    authenticationProvider?: AuthenticationProvider | undefined;
    authenticationProviderId?: string;
    name?: string | undefined;

    constructor(data?: IDomain) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.authenticationProvider = _data["authenticationProvider"] ? AuthenticationProvider.fromJS(_data["authenticationProvider"]) : <any>undefined;
            this.authenticationProviderId = _data["authenticationProviderId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Domain {
        data = typeof data === 'object' ? data : {};
        let result = new Domain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationProvider"] = this.authenticationProvider ? this.authenticationProvider.toJSON() : <any>undefined;
        data["authenticationProviderId"] = this.authenticationProviderId;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IDomain extends IEntityBase {
    authenticationProvider?: AuthenticationProvider | undefined;
    authenticationProviderId?: string;
    name?: string | undefined;
}

export class SubscriptionService extends HierarchyEntityBase implements ISubscriptionService {
    displayName?: string | undefined;
    shortName?: string | undefined;
    service?: Service | undefined;
    serviceId?: string;
    order?: number;
    imageBlobStorageId?: string | undefined;
    subscription?: Subscription | undefined;
    subscriptionId?: string;
    cultures?: SubscriptionServiceCulture[] | undefined;

    constructor(data?: ISubscriptionService) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.displayName = _data["displayName"];
            this.shortName = _data["shortName"];
            this.service = _data["service"] ? Service.fromJS(_data["service"]) : <any>undefined;
            this.serviceId = _data["serviceId"];
            this.order = _data["order"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            this.subscriptionId = _data["subscriptionId"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SubscriptionServiceCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionService {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["shortName"] = this.shortName;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["serviceId"] = this.serviceId;
        data["order"] = this.order;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        data["subscriptionId"] = this.subscriptionId;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionService extends IHierarchyEntityBase {
    displayName?: string | undefined;
    shortName?: string | undefined;
    service?: Service | undefined;
    serviceId?: string;
    order?: number;
    imageBlobStorageId?: string | undefined;
    subscription?: Subscription | undefined;
    subscriptionId?: string;
    cultures?: SubscriptionServiceCulture[] | undefined;
}

export class SubscriptionServiceCulture extends EntityBase implements ISubscriptionServiceCulture {
    subscriptionServiceId?: string;
    displayName?: string | undefined;
    shortName?: string | undefined;
    cultureCode?: string | undefined;
    subscriptionService?: SubscriptionService | undefined;
    imageBlobStorageId?: string | undefined;
    state?: string | undefined;

    constructor(data?: ISubscriptionServiceCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.displayName = _data["displayName"];
            this.shortName = _data["shortName"];
            this.cultureCode = _data["cultureCode"];
            this.subscriptionService = _data["subscriptionService"] ? SubscriptionService.fromJS(_data["subscriptionService"]) : <any>undefined;
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): SubscriptionServiceCulture {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionServiceCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["displayName"] = this.displayName;
        data["shortName"] = this.shortName;
        data["cultureCode"] = this.cultureCode;
        data["subscriptionService"] = this.subscriptionService ? this.subscriptionService.toJSON() : <any>undefined;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionServiceCulture extends IEntityBase {
    subscriptionServiceId?: string;
    displayName?: string | undefined;
    shortName?: string | undefined;
    cultureCode?: string | undefined;
    subscriptionService?: SubscriptionService | undefined;
    imageBlobStorageId?: string | undefined;
    state?: string | undefined;
}

export class SubscriptionCulture extends EntityBase implements ISubscriptionCulture {
    subscriptionId?: string;
    name?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    subscription?: Subscription | undefined;
    state?: string | undefined;

    constructor(data?: ISubscriptionCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
            this.imageBlobStorageId = _data["imageBlobStorageId"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): SubscriptionCulture {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        data["imageBlobStorageId"] = this.imageBlobStorageId;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionCulture extends IEntityBase {
    subscriptionId?: string;
    name?: string | undefined;
    cultureCode?: string | undefined;
    imageBlobStorageId?: string | undefined;
    subscription?: Subscription | undefined;
    state?: string | undefined;
}

export class SubscriptionInformation extends EntityBase implements ISubscriptionInformation {
    subscriptionId?: string;
    key?: QuestionType;
    value?: string | undefined;

    constructor(data?: ISubscriptionInformation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SubscriptionInformation {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["key"] = this.key;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionInformation extends IEntityBase {
    subscriptionId?: string;
    key?: QuestionType;
    value?: string | undefined;
}

export class BranchKeywordCulture extends EntityBase implements IBranchKeywordCulture {
    branchServiceId?: string;
    keyword?: string | undefined;
    cultureCode?: string | undefined;
    branchKeyword?: BranchKeyword | undefined;

    constructor(data?: IBranchKeywordCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.branchServiceId = _data["branchServiceId"];
            this.keyword = _data["keyword"];
            this.cultureCode = _data["cultureCode"];
            this.branchKeyword = _data["branchKeyword"] ? BranchKeyword.fromJS(_data["branchKeyword"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchKeywordCulture {
        data = typeof data === 'object' ? data : {};
        let result = new BranchKeywordCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchServiceId"] = this.branchServiceId;
        data["keyword"] = this.keyword;
        data["cultureCode"] = this.cultureCode;
        data["branchKeyword"] = this.branchKeyword ? this.branchKeyword.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBranchKeywordCulture extends IEntityBase {
    branchServiceId?: string;
    keyword?: string | undefined;
    cultureCode?: string | undefined;
    branchKeyword?: BranchKeyword | undefined;
}

export class ImportBranchOptions implements IImportBranchOptions {
    fileName?: string;
    fileContents?: string;

    constructor(data?: IImportBranchOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileContents = _data["fileContents"];
        }
    }

    static fromJS(data: any): ImportBranchOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ImportBranchOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileContents"] = this.fileContents;
        return data;
    }
}

export interface IImportBranchOptions {
    fileName?: string;
    fileContents?: string;
}

export enum State {
    Disable = 0,
    Enable = 1,
}

export class GetSummaryViewModel implements IGetSummaryViewModel {
    summarySubject?: SummarySubjectDto[];
    totalActiveParticipatingBranchCount?: number;
    totalParticipatingBranchCount?: number;
    activeBranchCount?: number;
    branchCount?: number;

    constructor(data?: IGetSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["summarySubject"])) {
                this.summarySubject = [] as any;
                for (let item of _data["summarySubject"])
                    this.summarySubject!.push(SummarySubjectDto.fromJS(item));
            }
            this.totalActiveParticipatingBranchCount = _data["totalActiveParticipatingBranchCount"];
            this.totalParticipatingBranchCount = _data["totalParticipatingBranchCount"];
            this.activeBranchCount = _data["activeBranchCount"];
            this.branchCount = _data["branchCount"];
        }
    }

    static fromJS(data: any): GetSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.summarySubject)) {
            data["summarySubject"] = [];
            for (let item of this.summarySubject)
                data["summarySubject"].push(item.toJSON());
        }
        data["totalActiveParticipatingBranchCount"] = this.totalActiveParticipatingBranchCount;
        data["totalParticipatingBranchCount"] = this.totalParticipatingBranchCount;
        data["activeBranchCount"] = this.activeBranchCount;
        data["branchCount"] = this.branchCount;
        return data;
    }
}

export interface IGetSummaryViewModel {
    summarySubject?: SummarySubjectDto[];
    totalActiveParticipatingBranchCount?: number;
    totalParticipatingBranchCount?: number;
    activeBranchCount?: number;
    branchCount?: number;
}

export class SummarySubjectDto implements ISummarySubjectDto {
    subjectId?: string;
    displayName?: string;
    activePartipatingBranchCount?: number;
    partipatingBranchCount?: number;

    constructor(data?: ISummarySubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            this.displayName = _data["displayName"];
            this.activePartipatingBranchCount = _data["activePartipatingBranchCount"];
            this.partipatingBranchCount = _data["partipatingBranchCount"];
        }
    }

    static fromJS(data: any): SummarySubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummarySubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        data["displayName"] = this.displayName;
        data["activePartipatingBranchCount"] = this.activePartipatingBranchCount;
        data["partipatingBranchCount"] = this.partipatingBranchCount;
        return data;
    }
}

export interface ISummarySubjectDto {
    subjectId?: string;
    displayName?: string;
    activePartipatingBranchCount?: number;
    partipatingBranchCount?: number;
}

export class BranchGroupListViewModel implements IBranchGroupListViewModel {
    flatBranchGroups?: BranchGroupItem[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;
    canCreate?: boolean;
    canEdit?: boolean;
    canDelete?: boolean;

    constructor(data?: IBranchGroupListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["flatBranchGroups"])) {
                this.flatBranchGroups = [] as any;
                for (let item of _data["flatBranchGroups"])
                    this.flatBranchGroups!.push(BranchGroupItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.pageCount = _data["pageCount"];
            this.canCreate = _data["canCreate"];
            this.canEdit = _data["canEdit"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): BranchGroupListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGroupListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flatBranchGroups)) {
            data["flatBranchGroups"] = [];
            for (let item of this.flatBranchGroups)
                data["flatBranchGroups"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["pageCount"] = this.pageCount;
        data["canCreate"] = this.canCreate;
        data["canEdit"] = this.canEdit;
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface IBranchGroupListViewModel {
    flatBranchGroups?: BranchGroupItem[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;
    canCreate?: boolean;
    canEdit?: boolean;
    canDelete?: boolean;
}

export class BranchGroupItem implements IBranchGroupItem {
    id?: string;
    parentId?: string | undefined;
    name?: string;
    parentName?: string | undefined;
    branches?: BranchItem[] | undefined;
    children?: BranchGroupItem[] | undefined;
    branchesCount?: number;

    constructor(data?: IBranchGroupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.parentName = _data["parentName"];
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchItem.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BranchGroupItem.fromJS(item));
            }
            this.branchesCount = _data["branchesCount"];
        }
    }

    static fromJS(data: any): BranchGroupItem {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGroupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["parentName"] = this.parentName;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["branchesCount"] = this.branchesCount;
        return data;
    }
}

export interface IBranchGroupItem {
    id?: string;
    parentId?: string | undefined;
    name?: string;
    parentName?: string | undefined;
    branches?: BranchItem[] | undefined;
    children?: BranchGroupItem[] | undefined;
    branchesCount?: number;
}

export class BranchItem implements IBranchItem {
    id?: string;
    code?: string;
    name?: string;

    constructor(data?: IBranchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BranchItem {
        data = typeof data === 'object' ? data : {};
        let result = new BranchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IBranchItem {
    id?: string;
    code?: string;
    name?: string;
}

export enum BranchGroupSortingField {
    Name = 0,
    Parent = 1,
    BranchGroupBranches = 2,
}

export class BranchGroupViewModel implements IBranchGroupViewModel {
    branchGroupDto?: CommandsBranchGroupDto;

    constructor(data?: IBranchGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchGroupDto = _data["branchGroupDto"] ? CommandsBranchGroupDto.fromJS(_data["branchGroupDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchGroupDto"] = this.branchGroupDto ? this.branchGroupDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBranchGroupViewModel {
    branchGroupDto?: CommandsBranchGroupDto;
}

export class CommandsBranchGroupDto implements ICommandsBranchGroupDto {
    id?: string | undefined;
    name?: string;
    parentGroupId?: string | undefined;
    branches?: BranchGroupBranchDto[] | undefined;
    cultures?: BranchGroupCultureDto[] | undefined;

    constructor(data?: ICommandsBranchGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentGroupId = _data["parentGroupId"];
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchGroupBranchDto.fromJS(item));
            }
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(BranchGroupCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommandsBranchGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommandsBranchGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentGroupId"] = this.parentGroupId;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommandsBranchGroupDto {
    id?: string | undefined;
    name?: string;
    parentGroupId?: string | undefined;
    branches?: BranchGroupBranchDto[] | undefined;
    cultures?: BranchGroupCultureDto[] | undefined;
}

export class BranchGroupBranchDto implements IBranchGroupBranchDto {
    id?: string;
    name?: string;
    code?: string;

    constructor(data?: IBranchGroupBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): BranchGroupBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGroupBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IBranchGroupBranchDto {
    id?: string;
    name?: string;
    code?: string;
}

export class BranchGroupCultureDto implements IBranchGroupCultureDto {
    id?: string;
    cultureCode?: string;
    name?: string;

    constructor(data?: IBranchGroupCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cultureCode = _data["cultureCode"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BranchGroupCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGroupCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cultureCode"] = this.cultureCode;
        data["name"] = this.name;
        return data;
    }
}

export interface IBranchGroupCultureDto {
    id?: string;
    cultureCode?: string;
    name?: string;
}

export class DeleteBranchGroupViewModel implements IDeleteBranchGroupViewModel {
    success?: boolean;

    constructor(data?: IDeleteBranchGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeleteBranchGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBranchGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeleteBranchGroupViewModel {
    success?: boolean;
}

export class CreateBranchGroupViewModel implements ICreateBranchGroupViewModel {
    branchGroupId?: string;

    constructor(data?: ICreateBranchGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchGroupId = _data["branchGroupId"];
        }
    }

    static fromJS(data: any): CreateBranchGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBranchGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchGroupId"] = this.branchGroupId;
        return data;
    }
}

export interface ICreateBranchGroupViewModel {
    branchGroupId?: string;
}

export class UpdateBranchGroupViewModel implements IUpdateBranchGroupViewModel {
    success?: boolean;

    constructor(data?: IUpdateBranchGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UpdateBranchGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBranchGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IUpdateBranchGroupViewModel {
    success?: boolean;
}

export class GetBranchGroupChildrenViewModel implements IGetBranchGroupChildrenViewModel {
    branches?: GetBranchGroupChildrenBranchDto[];

    constructor(data?: IGetBranchGroupChildrenViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetBranchGroupChildrenBranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBranchGroupChildrenViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchGroupChildrenViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBranchGroupChildrenViewModel {
    branches?: GetBranchGroupChildrenBranchDto[];
}

export class GetBranchGroupChildrenBranchDto implements IGetBranchGroupChildrenBranchDto {
    name?: string;

    constructor(data?: IGetBranchGroupChildrenBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetBranchGroupChildrenBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchGroupChildrenBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetBranchGroupChildrenBranchDto {
    name?: string;
}

export class GlobalNotificationPageViewModel implements IGlobalNotificationPageViewModel {
    notifications?: GlobalNotificationPageDto[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;

    constructor(data?: IGlobalNotificationPageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(GlobalNotificationPageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GlobalNotificationPageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalNotificationPageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGlobalNotificationPageViewModel {
    notifications?: GlobalNotificationPageDto[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;
}

export class GlobalNotificationPageDto implements IGlobalNotificationPageDto {
    id?: string;
    title?: string;
    data?: string;
    startDate?: Date | undefined;
    endDate?: Date;
    supportedCultures?: string[];

    constructor(data?: IGlobalNotificationPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.data = _data["data"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["supportedCultures"])) {
                this.supportedCultures = [] as any;
                for (let item of _data["supportedCultures"])
                    this.supportedCultures!.push(item);
            }
        }
    }

    static fromJS(data: any): GlobalNotificationPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalNotificationPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["data"] = this.data;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.supportedCultures)) {
            data["supportedCultures"] = [];
            for (let item of this.supportedCultures)
                data["supportedCultures"].push(item);
        }
        return data;
    }
}

export interface IGlobalNotificationPageDto {
    id?: string;
    title?: string;
    data?: string;
    startDate?: Date | undefined;
    endDate?: Date;
    supportedCultures?: string[];
}

export enum GlobalNotificationSortingField {
    StartDate = 0,
    EndDate = 1,
    Title = 2,
}

export class GetGlobalNotificationByIdViewModel implements IGetGlobalNotificationByIdViewModel {
    availableCultures?: GeneralCultureDto[];
    dto?: GetGlobalNotificationByIdDto;

    constructor(data?: IGetGlobalNotificationByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableCultures"])) {
                this.availableCultures = [] as any;
                for (let item of _data["availableCultures"])
                    this.availableCultures!.push(GeneralCultureDto.fromJS(item));
            }
            this.dto = _data["dto"] ? GetGlobalNotificationByIdDto.fromJS(_data["dto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGlobalNotificationByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetGlobalNotificationByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableCultures)) {
            data["availableCultures"] = [];
            for (let item of this.availableCultures)
                data["availableCultures"].push(item.toJSON());
        }
        data["dto"] = this.dto ? this.dto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGlobalNotificationByIdViewModel {
    availableCultures?: GeneralCultureDto[];
    dto?: GetGlobalNotificationByIdDto;
}

export class GlobalNotificationDto2 implements IGlobalNotificationDto2 {
    title?: string;
    data?: string;
    startDate?: Date | undefined;
    endDate?: Date;
    cultures?: GlobalNotificationCultureDto[];

    constructor(data?: IGlobalNotificationDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.data = _data["data"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(GlobalNotificationCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalNotificationDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalNotificationDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["data"] = this.data;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGlobalNotificationDto2 {
    title?: string;
    data?: string;
    startDate?: Date | undefined;
    endDate?: Date;
    cultures?: GlobalNotificationCultureDto[];
}

export class GetGlobalNotificationByIdDto extends GlobalNotificationDto2 implements IGetGlobalNotificationByIdDto {
    id?: string;

    constructor(data?: IGetGlobalNotificationByIdDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGlobalNotificationByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGlobalNotificationByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IGetGlobalNotificationByIdDto extends IGlobalNotificationDto2 {
    id?: string;
}

export class GlobalNotificationCultureDto implements IGlobalNotificationCultureDto {
    cultureCode?: string;
    title?: string;
    data?: string;

    constructor(data?: IGlobalNotificationCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.title = _data["title"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GlobalNotificationCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalNotificationCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["title"] = this.title;
        data["data"] = this.data;
        return data;
    }
}

export interface IGlobalNotificationCultureDto {
    cultureCode?: string;
    title?: string;
    data?: string;
}

export class MenuSettingsDto2 implements IMenuSettingsDto2 {
    id?: string | undefined;
    subjectId?: string;
    subjectType?: SubjectType;
    subjectPath?: any[];
    name?: string;
    type?: string;
    parentId?: string | undefined;
    order?: number;
    enabled?: boolean;
    cultures?: MenuSettingsCultureDto[];

    constructor(data?: IMenuSettingsDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subjectId = _data["subjectId"];
            this.subjectType = _data["subjectType"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.name = _data["name"];
            this.type = _data["type"];
            this.parentId = _data["parentId"];
            this.order = _data["order"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(MenuSettingsCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuSettingsDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new MenuSettingsDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subjectId"] = this.subjectId;
        data["subjectType"] = this.subjectType;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["name"] = this.name;
        data["type"] = this.type;
        data["parentId"] = this.parentId;
        data["order"] = this.order;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMenuSettingsDto2 {
    id?: string | undefined;
    subjectId?: string;
    subjectType?: SubjectType;
    subjectPath?: any[];
    name?: string;
    type?: string;
    parentId?: string | undefined;
    order?: number;
    enabled?: boolean;
    cultures?: MenuSettingsCultureDto[];
}

export class MenuSettingsCultureDto implements IMenuSettingsCultureDto {
    name?: string;
    cultureCode?: string;

    constructor(data?: IMenuSettingsCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): MenuSettingsCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuSettingsCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IMenuSettingsCultureDto {
    name?: string;
    cultureCode?: string;
}

export class GetMenuSettingsListViewModel implements IGetMenuSettingsListViewModel {
    menuSettings?: MenuSettingsDto2[];

    constructor(data?: IGetMenuSettingsListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["menuSettings"])) {
                this.menuSettings = [] as any;
                for (let item of _data["menuSettings"])
                    this.menuSettings!.push(MenuSettingsDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMenuSettingsListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMenuSettingsListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuSettings)) {
            data["menuSettings"] = [];
            for (let item of this.menuSettings)
                data["menuSettings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMenuSettingsListViewModel {
    menuSettings?: MenuSettingsDto2[];
}

export class GetOrganizationsViewModel implements IGetOrganizationsViewModel {
    organizations?: OrganizationDto2[];

    constructor(data?: IGetOrganizationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(OrganizationDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrganizationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrganizationsViewModel {
    organizations?: OrganizationDto2[];
}

export class OrganizationDto2 implements IOrganizationDto2 {
    id?: string;
    name?: string;
    displayName?: string;
    normalizedName?: string;
    email?: string;
    isSaas?: boolean;
    cultures?: OrganizationCultureDto[];

    constructor(data?: IOrganizationDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.email = _data["email"];
            this.isSaas = _data["isSaas"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(OrganizationCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["email"] = this.email;
        data["isSaas"] = this.isSaas;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationDto2 {
    id?: string;
    name?: string;
    displayName?: string;
    normalizedName?: string;
    email?: string;
    isSaas?: boolean;
    cultures?: OrganizationCultureDto[];
}

export class OrganizationCultureDto implements IOrganizationCultureDto {
    name?: string;
    displayName?: string;
    cultureCode?: string;

    constructor(data?: IOrganizationCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): OrganizationCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IOrganizationCultureDto {
    name?: string;
    displayName?: string;
    cultureCode?: string;
}

export class GetOrganizationViewModel implements IGetOrganizationViewModel {
    organization?: OrganizationDto2;

    constructor(data?: IGetOrganizationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organization = _data["organization"] ? OrganizationDto2.fromJS(_data["organization"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrganizationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrganizationViewModel {
    organization?: OrganizationDto2;
}

export class GetUserAssignmentsViewModel implements IGetUserAssignmentsViewModel {
    userAssignments?: GetUserAssignmentDto[] | undefined;
    total?: number;

    constructor(data?: IGetUserAssignmentsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userAssignments"])) {
                this.userAssignments = [] as any;
                for (let item of _data["userAssignments"])
                    this.userAssignments!.push(GetUserAssignmentDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): GetUserAssignmentsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserAssignmentsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userAssignments)) {
            data["userAssignments"] = [];
            for (let item of this.userAssignments)
                data["userAssignments"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IGetUserAssignmentsViewModel {
    userAssignments?: GetUserAssignmentDto[] | undefined;
    total?: number;
}

export class GetUserAssignmentDto implements IGetUserAssignmentDto {
    id?: string;
    userInformation?: UserAssignmentUserInformationDto;
    hasIndividualPermissions?: boolean;
    groups?: GetUserAssignmentUserGroupDto[];
    enabled?: boolean;

    constructor(data?: IGetUserAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userInformation = _data["userInformation"] ? UserAssignmentUserInformationDto.fromJS(_data["userInformation"]) : <any>undefined;
            this.hasIndividualPermissions = _data["hasIndividualPermissions"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GetUserAssignmentUserGroupDto.fromJS(item));
            }
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): GetUserAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userInformation"] = this.userInformation ? this.userInformation.toJSON() : <any>undefined;
        data["hasIndividualPermissions"] = this.hasIndividualPermissions;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IGetUserAssignmentDto {
    id?: string;
    userInformation?: UserAssignmentUserInformationDto;
    hasIndividualPermissions?: boolean;
    groups?: GetUserAssignmentUserGroupDto[];
    enabled?: boolean;
}

export class UserAssignmentUserInformationDto implements IUserAssignmentUserInformationDto {
    email?: string;
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    cultureCode?: string;
    emailConfirmed?: boolean;
    canConfirmEmail?: boolean;
    isLockout?: boolean;
    isLockoutForever?: boolean;
    lockoutEndUntil?: Date | undefined;
    accessFailedCount?: number;
    isSso?: boolean;
    canResetPassword?: boolean;

    constructor(data?: IUserAssignmentUserInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.cultureCode = _data["cultureCode"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.canConfirmEmail = _data["canConfirmEmail"];
            this.isLockout = _data["isLockout"];
            this.isLockoutForever = _data["isLockoutForever"];
            this.lockoutEndUntil = _data["lockoutEndUntil"] ? new Date(_data["lockoutEndUntil"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isSso = _data["isSso"];
            this.canResetPassword = _data["canResetPassword"];
        }
    }

    static fromJS(data: any): UserAssignmentUserInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAssignmentUserInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["cultureCode"] = this.cultureCode;
        data["emailConfirmed"] = this.emailConfirmed;
        data["canConfirmEmail"] = this.canConfirmEmail;
        data["isLockout"] = this.isLockout;
        data["isLockoutForever"] = this.isLockoutForever;
        data["lockoutEndUntil"] = this.lockoutEndUntil ? this.lockoutEndUntil.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isSso"] = this.isSso;
        data["canResetPassword"] = this.canResetPassword;
        return data;
    }
}

export interface IUserAssignmentUserInformationDto {
    email?: string;
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    cultureCode?: string;
    emailConfirmed?: boolean;
    canConfirmEmail?: boolean;
    isLockout?: boolean;
    isLockoutForever?: boolean;
    lockoutEndUntil?: Date | undefined;
    accessFailedCount?: number;
    isSso?: boolean;
    canResetPassword?: boolean;
}

export class GetUserAssignmentUserGroupDto implements IGetUserAssignmentUserGroupDto {
    id?: string;
    name?: string;

    constructor(data?: IGetUserAssignmentUserGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetUserAssignmentUserGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserAssignmentUserGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetUserAssignmentUserGroupDto {
    id?: string;
    name?: string;
}

export enum UsersSortingField {
    FirstName = 0,
    LastName = 1,
    Email = 2,
}

export class GetUserAssignmentByEmailViewModel implements IGetUserAssignmentByEmailViewModel {
    userInformation?: UserAssignmentUserInformationDto;
    hierarchy?: GetPermissionHierarchyDto;
    branches?: GetPermissionBranchDto[];
    branchGroups?: GetPermissionBranchGroupDto[];
    branchGroupsAll?: GetPermissionBranchGroupAllDto[];
    userGroups?: GetPermissionUserGroupDto[];
    userAlerts?: GetPermissionAlertMenuItem[];
    canDelete?: boolean;

    constructor(data?: IGetUserAssignmentByEmailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userInformation = _data["userInformation"] ? UserAssignmentUserInformationDto.fromJS(_data["userInformation"]) : <any>undefined;
            this.hierarchy = _data["hierarchy"] ? GetPermissionHierarchyDto.fromJS(_data["hierarchy"]) : <any>undefined;
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetPermissionBranchDto.fromJS(item));
            }
            if (Array.isArray(_data["branchGroups"])) {
                this.branchGroups = [] as any;
                for (let item of _data["branchGroups"])
                    this.branchGroups!.push(GetPermissionBranchGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["branchGroupsAll"])) {
                this.branchGroupsAll = [] as any;
                for (let item of _data["branchGroupsAll"])
                    this.branchGroupsAll!.push(GetPermissionBranchGroupAllDto.fromJS(item));
            }
            if (Array.isArray(_data["userGroups"])) {
                this.userGroups = [] as any;
                for (let item of _data["userGroups"])
                    this.userGroups!.push(GetPermissionUserGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["userAlerts"])) {
                this.userAlerts = [] as any;
                for (let item of _data["userAlerts"])
                    this.userAlerts!.push(GetPermissionAlertMenuItem.fromJS(item));
            }
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): GetUserAssignmentByEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserAssignmentByEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userInformation"] = this.userInformation ? this.userInformation.toJSON() : <any>undefined;
        data["hierarchy"] = this.hierarchy ? this.hierarchy.toJSON() : <any>undefined;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.branchGroups)) {
            data["branchGroups"] = [];
            for (let item of this.branchGroups)
                data["branchGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.branchGroupsAll)) {
            data["branchGroupsAll"] = [];
            for (let item of this.branchGroupsAll)
                data["branchGroupsAll"].push(item.toJSON());
        }
        if (Array.isArray(this.userGroups)) {
            data["userGroups"] = [];
            for (let item of this.userGroups)
                data["userGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.userAlerts)) {
            data["userAlerts"] = [];
            for (let item of this.userAlerts)
                data["userAlerts"].push(item.toJSON());
        }
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface IGetUserAssignmentByEmailViewModel {
    userInformation?: UserAssignmentUserInformationDto;
    hierarchy?: GetPermissionHierarchyDto;
    branches?: GetPermissionBranchDto[];
    branchGroups?: GetPermissionBranchGroupDto[];
    branchGroupsAll?: GetPermissionBranchGroupAllDto[];
    userGroups?: GetPermissionUserGroupDto[];
    userAlerts?: GetPermissionAlertMenuItem[];
    canDelete?: boolean;
}

export class GetPermissionHierarchyDto implements IGetPermissionHierarchyDto {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    menuItemType?: MenuItemType;
    role?: HierarchyRoleType;
    hasConfidentialInformation?: boolean | undefined;
    displayConfidentialInfo?: boolean;
    name?: string;
    upperBoundRole?: HierarchyRoleType;
    canManage?: boolean;
    children?: GetPermissionHierarchyDto[] | undefined;

    constructor(data?: IGetPermissionHierarchyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
            this.menuItemType = _data["menuItemType"];
            this.role = _data["role"];
            this.hasConfidentialInformation = _data["hasConfidentialInformation"];
            this.displayConfidentialInfo = _data["displayConfidentialInfo"];
            this.name = _data["name"];
            this.upperBoundRole = _data["upperBoundRole"];
            this.canManage = _data["canManage"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(GetPermissionHierarchyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPermissionHierarchyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionHierarchyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        data["menuItemType"] = this.menuItemType;
        data["role"] = this.role;
        data["hasConfidentialInformation"] = this.hasConfidentialInformation;
        data["displayConfidentialInfo"] = this.displayConfidentialInfo;
        data["name"] = this.name;
        data["upperBoundRole"] = this.upperBoundRole;
        data["canManage"] = this.canManage;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPermissionHierarchyDto {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    menuItemType?: MenuItemType;
    role?: HierarchyRoleType;
    hasConfidentialInformation?: boolean | undefined;
    displayConfidentialInfo?: boolean;
    name?: string;
    upperBoundRole?: HierarchyRoleType;
    canManage?: boolean;
    children?: GetPermissionHierarchyDto[] | undefined;
}

export class GetPermissionBranchDto implements IGetPermissionBranchDto {
    subjectId?: string;
    subjectPath?: any[];
    name?: string;
    parentName?: string;
    isEnabled?: boolean;

    constructor(data?: IGetPermissionBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.name = _data["name"];
            this.parentName = _data["parentName"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): GetPermissionBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["name"] = this.name;
        data["parentName"] = this.parentName;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IGetPermissionBranchDto {
    subjectId?: string;
    subjectPath?: any[];
    name?: string;
    parentName?: string;
    isEnabled?: boolean;
}

export class GetPermissionBranchGroupDto implements IGetPermissionBranchGroupDto {
    subjectId?: string;
    subjectPath?: any[];
    name?: string;
    parentName?: string;
    isEnabled?: boolean;

    constructor(data?: IGetPermissionBranchGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.name = _data["name"];
            this.parentName = _data["parentName"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): GetPermissionBranchGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionBranchGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["name"] = this.name;
        data["parentName"] = this.parentName;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IGetPermissionBranchGroupDto {
    subjectId?: string;
    subjectPath?: any[];
    name?: string;
    parentName?: string;
    isEnabled?: boolean;
}

export class GetPermissionBranchGroupAllDto implements IGetPermissionBranchGroupAllDto {
    subjectId?: string;
    subjectPath?: any[];
    name?: string;
    isEnabled?: boolean;

    constructor(data?: IGetPermissionBranchGroupAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.name = _data["name"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): GetPermissionBranchGroupAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionBranchGroupAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["name"] = this.name;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IGetPermissionBranchGroupAllDto {
    subjectId?: string;
    subjectPath?: any[];
    name?: string;
    isEnabled?: boolean;
}

export class GetPermissionUserGroupDto implements IGetPermissionUserGroupDto {
    subjectId?: string;
    subjectPath?: any[];
    name?: string;
    parentName?: string | undefined;
    isEnabled?: boolean;
    canManage?: boolean;
    hasHierarchyPermissions?: boolean;
    hasBranchPermissions?: boolean;
    hasBranchGroupPermissions?: boolean;

    constructor(data?: IGetPermissionUserGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.name = _data["name"];
            this.parentName = _data["parentName"];
            this.isEnabled = _data["isEnabled"];
            this.canManage = _data["canManage"];
            this.hasHierarchyPermissions = _data["hasHierarchyPermissions"];
            this.hasBranchPermissions = _data["hasBranchPermissions"];
            this.hasBranchGroupPermissions = _data["hasBranchGroupPermissions"];
        }
    }

    static fromJS(data: any): GetPermissionUserGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionUserGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["name"] = this.name;
        data["parentName"] = this.parentName;
        data["isEnabled"] = this.isEnabled;
        data["canManage"] = this.canManage;
        data["hasHierarchyPermissions"] = this.hasHierarchyPermissions;
        data["hasBranchPermissions"] = this.hasBranchPermissions;
        data["hasBranchGroupPermissions"] = this.hasBranchGroupPermissions;
        return data;
    }
}

export interface IGetPermissionUserGroupDto {
    subjectId?: string;
    subjectPath?: any[];
    name?: string;
    parentName?: string | undefined;
    isEnabled?: boolean;
    canManage?: boolean;
    hasHierarchyPermissions?: boolean;
    hasBranchPermissions?: boolean;
    hasBranchGroupPermissions?: boolean;
}

export class GetPermissionAlertMenuItem implements IGetPermissionAlertMenuItem {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    menuItemType?: MenuItemType;
    name?: string;
    isActionable?: boolean | undefined;
    emailDisabled?: boolean | undefined;
    pushNotificationDisabled?: boolean | undefined;
    emailBranchStats?: GetPermissionAlertMenuBranchStats | undefined;
    pushNotificationsBranchStats?: GetPermissionAlertMenuBranchStats | undefined;
    children?: GetPermissionAlertMenuItem[] | undefined;
    branches?: GetPermissionBranchAlertMenuItem[] | undefined;

    constructor(data?: IGetPermissionAlertMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
            this.menuItemType = _data["menuItemType"];
            this.name = _data["name"];
            this.isActionable = _data["isActionable"];
            this.emailDisabled = _data["emailDisabled"];
            this.pushNotificationDisabled = _data["pushNotificationDisabled"];
            this.emailBranchStats = _data["emailBranchStats"] ? GetPermissionAlertMenuBranchStats.fromJS(_data["emailBranchStats"]) : <any>undefined;
            this.pushNotificationsBranchStats = _data["pushNotificationsBranchStats"] ? GetPermissionAlertMenuBranchStats.fromJS(_data["pushNotificationsBranchStats"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(GetPermissionAlertMenuItem.fromJS(item));
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetPermissionBranchAlertMenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPermissionAlertMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionAlertMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        data["menuItemType"] = this.menuItemType;
        data["name"] = this.name;
        data["isActionable"] = this.isActionable;
        data["emailDisabled"] = this.emailDisabled;
        data["pushNotificationDisabled"] = this.pushNotificationDisabled;
        data["emailBranchStats"] = this.emailBranchStats ? this.emailBranchStats.toJSON() : <any>undefined;
        data["pushNotificationsBranchStats"] = this.pushNotificationsBranchStats ? this.pushNotificationsBranchStats.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPermissionAlertMenuItem {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    menuItemType?: MenuItemType;
    name?: string;
    isActionable?: boolean | undefined;
    emailDisabled?: boolean | undefined;
    pushNotificationDisabled?: boolean | undefined;
    emailBranchStats?: GetPermissionAlertMenuBranchStats | undefined;
    pushNotificationsBranchStats?: GetPermissionAlertMenuBranchStats | undefined;
    children?: GetPermissionAlertMenuItem[] | undefined;
    branches?: GetPermissionBranchAlertMenuItem[] | undefined;
}

export class GetPermissionAlertMenuBranchStats implements IGetPermissionAlertMenuBranchStats {
    count?: number | undefined;
    hasAll?: boolean;

    constructor(data?: IGetPermissionAlertMenuBranchStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.hasAll = _data["hasAll"];
        }
    }

    static fromJS(data: any): GetPermissionAlertMenuBranchStats {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionAlertMenuBranchStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["hasAll"] = this.hasAll;
        return data;
    }
}

export interface IGetPermissionAlertMenuBranchStats {
    count?: number | undefined;
    hasAll?: boolean;
}

export class GetPermissionBranchAlertMenuItem implements IGetPermissionBranchAlertMenuItem {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    name?: string;
    emailDisabled?: boolean | undefined;
    pushNotificationDisabled?: boolean | undefined;

    constructor(data?: IGetPermissionBranchAlertMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectType = _data["subjectType"];
            this.name = _data["name"];
            this.emailDisabled = _data["emailDisabled"];
            this.pushNotificationDisabled = _data["pushNotificationDisabled"];
        }
    }

    static fromJS(data: any): GetPermissionBranchAlertMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionBranchAlertMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectType"] = this.subjectType;
        data["name"] = this.name;
        data["emailDisabled"] = this.emailDisabled;
        data["pushNotificationDisabled"] = this.pushNotificationDisabled;
        return data;
    }
}

export interface IGetPermissionBranchAlertMenuItem {
    subjectId?: string;
    subjectPath?: any[];
    subjectType?: SubjectType;
    name?: string;
    emailDisabled?: boolean | undefined;
    pushNotificationDisabled?: boolean | undefined;
}

export class GetUserInformationByUserAssignmentEmailViewModel implements IGetUserInformationByUserAssignmentEmailViewModel {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    cultureCode?: string | undefined;
    userInformationExists?: boolean;
    userAssignmentExists?: boolean;

    constructor(data?: IGetUserInformationByUserAssignmentEmailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.cultureCode = _data["cultureCode"];
            this.userInformationExists = _data["userInformationExists"];
            this.userAssignmentExists = _data["userAssignmentExists"];
        }
    }

    static fromJS(data: any): GetUserInformationByUserAssignmentEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserInformationByUserAssignmentEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["cultureCode"] = this.cultureCode;
        data["userInformationExists"] = this.userInformationExists;
        data["userAssignmentExists"] = this.userAssignmentExists;
        return data;
    }
}

export interface IGetUserInformationByUserAssignmentEmailViewModel {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    cultureCode?: string | undefined;
    userInformationExists?: boolean;
    userAssignmentExists?: boolean;
}

export class ManageUserAssignmentByEmailRequest implements IManageUserAssignmentByEmailRequest {
    userInformation?: UserAssignmentUserInformationDto;
    hierarchy?: ManagePermissionHierarchyDto;
    branches?: ManagePermissionsBranchDto[];
    branchGroups?: ManagePermissionBranchGroupDto[];
    branchGroupsAll?: ManagePermissionBranchGroupAllDto[];
    userGroups?: ManagePermissionUserGroupDto[];
    userAlerts?: GetPermissionAlertMenuItem[];

    constructor(data?: IManageUserAssignmentByEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userInformation = _data["userInformation"] ? UserAssignmentUserInformationDto.fromJS(_data["userInformation"]) : <any>undefined;
            this.hierarchy = _data["hierarchy"] ? ManagePermissionHierarchyDto.fromJS(_data["hierarchy"]) : <any>undefined;
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(ManagePermissionsBranchDto.fromJS(item));
            }
            if (Array.isArray(_data["branchGroups"])) {
                this.branchGroups = [] as any;
                for (let item of _data["branchGroups"])
                    this.branchGroups!.push(ManagePermissionBranchGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["branchGroupsAll"])) {
                this.branchGroupsAll = [] as any;
                for (let item of _data["branchGroupsAll"])
                    this.branchGroupsAll!.push(ManagePermissionBranchGroupAllDto.fromJS(item));
            }
            if (Array.isArray(_data["userGroups"])) {
                this.userGroups = [] as any;
                for (let item of _data["userGroups"])
                    this.userGroups!.push(ManagePermissionUserGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["userAlerts"])) {
                this.userAlerts = [] as any;
                for (let item of _data["userAlerts"])
                    this.userAlerts!.push(GetPermissionAlertMenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManageUserAssignmentByEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ManageUserAssignmentByEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userInformation"] = this.userInformation ? this.userInformation.toJSON() : <any>undefined;
        data["hierarchy"] = this.hierarchy ? this.hierarchy.toJSON() : <any>undefined;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.branchGroups)) {
            data["branchGroups"] = [];
            for (let item of this.branchGroups)
                data["branchGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.branchGroupsAll)) {
            data["branchGroupsAll"] = [];
            for (let item of this.branchGroupsAll)
                data["branchGroupsAll"].push(item.toJSON());
        }
        if (Array.isArray(this.userGroups)) {
            data["userGroups"] = [];
            for (let item of this.userGroups)
                data["userGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.userAlerts)) {
            data["userAlerts"] = [];
            for (let item of this.userAlerts)
                data["userAlerts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManageUserAssignmentByEmailRequest {
    userInformation?: UserAssignmentUserInformationDto;
    hierarchy?: ManagePermissionHierarchyDto;
    branches?: ManagePermissionsBranchDto[];
    branchGroups?: ManagePermissionBranchGroupDto[];
    branchGroupsAll?: ManagePermissionBranchGroupAllDto[];
    userGroups?: ManagePermissionUserGroupDto[];
    userAlerts?: GetPermissionAlertMenuItem[];
}

export class ManagePermissionHierarchyDto implements IManagePermissionHierarchyDto {
    subjectId?: string;
    subjectPath?: any[];
    role?: HierarchyRoleType;
    hasConfidentialInformation?: boolean | undefined;
    children?: ManagePermissionHierarchyDto[] | undefined;

    constructor(data?: IManagePermissionHierarchyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.role = _data["role"];
            this.hasConfidentialInformation = _data["hasConfidentialInformation"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ManagePermissionHierarchyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManagePermissionHierarchyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagePermissionHierarchyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["role"] = this.role;
        data["hasConfidentialInformation"] = this.hasConfidentialInformation;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManagePermissionHierarchyDto {
    subjectId?: string;
    subjectPath?: any[];
    role?: HierarchyRoleType;
    hasConfidentialInformation?: boolean | undefined;
    children?: ManagePermissionHierarchyDto[] | undefined;
}

export class ManagePermissionsBranchDto implements IManagePermissionsBranchDto {
    subjectId?: string;
    subjectPath?: any[];
    isEnabled?: boolean;

    constructor(data?: IManagePermissionsBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ManagePermissionsBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagePermissionsBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IManagePermissionsBranchDto {
    subjectId?: string;
    subjectPath?: any[];
    isEnabled?: boolean;
}

export class ManagePermissionBranchGroupDto implements IManagePermissionBranchGroupDto {
    subjectId?: string;
    subjectPath?: any[];
    isEnabled?: boolean;

    constructor(data?: IManagePermissionBranchGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ManagePermissionBranchGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagePermissionBranchGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IManagePermissionBranchGroupDto {
    subjectId?: string;
    subjectPath?: any[];
    isEnabled?: boolean;
}

export class ManagePermissionBranchGroupAllDto implements IManagePermissionBranchGroupAllDto {
    subjectId?: string;
    subjectPath?: any[];
    isEnabled?: boolean;

    constructor(data?: IManagePermissionBranchGroupAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ManagePermissionBranchGroupAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagePermissionBranchGroupAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IManagePermissionBranchGroupAllDto {
    subjectId?: string;
    subjectPath?: any[];
    isEnabled?: boolean;
}

export class ManagePermissionUserGroupDto implements IManagePermissionUserGroupDto {
    subjectId?: string;
    subjectPath?: any[];
    isEnabled?: boolean;

    constructor(data?: IManagePermissionUserGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectId = _data["subjectId"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ManagePermissionUserGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagePermissionUserGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectId"] = this.subjectId;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IManagePermissionUserGroupDto {
    subjectId?: string;
    subjectPath?: any[];
    isEnabled?: boolean;
}

export class ManageMultipleUserAssignmentsByEmailRequest implements IManageMultipleUserAssignmentsByEmailRequest {
    fileName?: string;
    fileContents?: string;
    hierarchy?: ManagePermissionHierarchyDto;

    constructor(data?: IManageMultipleUserAssignmentsByEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileContents = _data["fileContents"];
            this.hierarchy = _data["hierarchy"] ? ManagePermissionHierarchyDto.fromJS(_data["hierarchy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ManageMultipleUserAssignmentsByEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ManageMultipleUserAssignmentsByEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileContents"] = this.fileContents;
        data["hierarchy"] = this.hierarchy ? this.hierarchy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IManageMultipleUserAssignmentsByEmailRequest {
    fileName?: string;
    fileContents?: string;
    hierarchy?: ManagePermissionHierarchyDto;
}

export class PartialUpdateUserPermissionsDto implements IPartialUpdateUserPermissionsDto {
    enabled?: boolean | undefined;

    constructor(data?: IPartialUpdateUserPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): PartialUpdateUserPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartialUpdateUserPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IPartialUpdateUserPermissionsDto {
    enabled?: boolean | undefined;
}

export class GetUserGroupsViewModel implements IGetUserGroupsViewModel {
    userGroups?: GetUserGroupsDto[];
    total?: number;

    constructor(data?: IGetUserGroupsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userGroups"])) {
                this.userGroups = [] as any;
                for (let item of _data["userGroups"])
                    this.userGroups!.push(GetUserGroupsDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): GetUserGroupsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserGroupsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userGroups)) {
            data["userGroups"] = [];
            for (let item of this.userGroups)
                data["userGroups"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IGetUserGroupsViewModel {
    userGroups?: GetUserGroupsDto[];
    total?: number;
}

export class GetUserGroupsDto implements IGetUserGroupsDto {
    id?: string;
    name?: string;
    isSystem?: boolean;
    canDelete?: boolean;

    constructor(data?: IGetUserGroupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isSystem = _data["isSystem"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): GetUserGroupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserGroupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isSystem"] = this.isSystem;
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface IGetUserGroupsDto {
    id?: string;
    name?: string;
    isSystem?: boolean;
    canDelete?: boolean;
}

export class GetUserGroupByIdViewModel implements IGetUserGroupByIdViewModel {
    information?: UserGroupInformationDto;
    hierarchy?: GetPermissionHierarchyDto;
    branches?: GetPermissionBranchDto[];
    branchGroups?: GetPermissionBranchGroupDto[];
    branchGroupsAll?: GetPermissionBranchGroupAllDto[];

    constructor(data?: IGetUserGroupByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.information = _data["information"] ? UserGroupInformationDto.fromJS(_data["information"]) : <any>undefined;
            this.hierarchy = _data["hierarchy"] ? GetPermissionHierarchyDto.fromJS(_data["hierarchy"]) : <any>undefined;
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(GetPermissionBranchDto.fromJS(item));
            }
            if (Array.isArray(_data["branchGroups"])) {
                this.branchGroups = [] as any;
                for (let item of _data["branchGroups"])
                    this.branchGroups!.push(GetPermissionBranchGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["branchGroupsAll"])) {
                this.branchGroupsAll = [] as any;
                for (let item of _data["branchGroupsAll"])
                    this.branchGroupsAll!.push(GetPermissionBranchGroupAllDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserGroupByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserGroupByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["information"] = this.information ? this.information.toJSON() : <any>undefined;
        data["hierarchy"] = this.hierarchy ? this.hierarchy.toJSON() : <any>undefined;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.branchGroups)) {
            data["branchGroups"] = [];
            for (let item of this.branchGroups)
                data["branchGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.branchGroupsAll)) {
            data["branchGroupsAll"] = [];
            for (let item of this.branchGroupsAll)
                data["branchGroupsAll"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserGroupByIdViewModel {
    information?: UserGroupInformationDto;
    hierarchy?: GetPermissionHierarchyDto;
    branches?: GetPermissionBranchDto[];
    branchGroups?: GetPermissionBranchGroupDto[];
    branchGroupsAll?: GetPermissionBranchGroupAllDto[];
}

export class UserGroupInformationDto implements IUserGroupInformationDto {
    name?: string;
    isSystem?: boolean;

    constructor(data?: IUserGroupInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSystem = _data["isSystem"];
        }
    }

    static fromJS(data: any): UserGroupInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSystem"] = this.isSystem;
        return data;
    }
}

export interface IUserGroupInformationDto {
    name?: string;
    isSystem?: boolean;
}

export class ManageUserGroupByIdRequest implements IManageUserGroupByIdRequest {
    information?: UserGroupInformationDto;
    hierarchy?: ManagePermissionHierarchyDto;
    branches?: ManagePermissionsBranchDto[];
    branchGroups?: ManagePermissionBranchGroupDto[];
    branchGroupsAll?: ManagePermissionBranchGroupAllDto[];

    constructor(data?: IManageUserGroupByIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.information = _data["information"] ? UserGroupInformationDto.fromJS(_data["information"]) : <any>undefined;
            this.hierarchy = _data["hierarchy"] ? ManagePermissionHierarchyDto.fromJS(_data["hierarchy"]) : <any>undefined;
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(ManagePermissionsBranchDto.fromJS(item));
            }
            if (Array.isArray(_data["branchGroups"])) {
                this.branchGroups = [] as any;
                for (let item of _data["branchGroups"])
                    this.branchGroups!.push(ManagePermissionBranchGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["branchGroupsAll"])) {
                this.branchGroupsAll = [] as any;
                for (let item of _data["branchGroupsAll"])
                    this.branchGroupsAll!.push(ManagePermissionBranchGroupAllDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManageUserGroupByIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ManageUserGroupByIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["information"] = this.information ? this.information.toJSON() : <any>undefined;
        data["hierarchy"] = this.hierarchy ? this.hierarchy.toJSON() : <any>undefined;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        if (Array.isArray(this.branchGroups)) {
            data["branchGroups"] = [];
            for (let item of this.branchGroups)
                data["branchGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.branchGroupsAll)) {
            data["branchGroupsAll"] = [];
            for (let item of this.branchGroupsAll)
                data["branchGroupsAll"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManageUserGroupByIdRequest {
    information?: UserGroupInformationDto;
    hierarchy?: ManagePermissionHierarchyDto;
    branches?: ManagePermissionsBranchDto[];
    branchGroups?: ManagePermissionBranchGroupDto[];
    branchGroupsAll?: ManagePermissionBranchGroupAllDto[];
}

export class GetParticipatingBranchesViewModel implements IGetParticipatingBranchesViewModel {
    results?: GetParticipatingBranchesBranchDto[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;

    constructor(data?: IGetParticipatingBranchesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(GetParticipatingBranchesBranchDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): GetParticipatingBranchesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetParticipatingBranchesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IGetParticipatingBranchesViewModel {
    results?: GetParticipatingBranchesBranchDto[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;
}

export class GetParticipatingBranchesBranchDto implements IGetParticipatingBranchesBranchDto {
    id?: string;
    code?: string | undefined;
    displayName?: string;
    isEnabled?: boolean;
    isIncluded?: boolean;
    groups?: GetParticipatingBranchesBranchGroupDto[];

    constructor(data?: IGetParticipatingBranchesBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.isEnabled = _data["isEnabled"];
            this.isIncluded = _data["isIncluded"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GetParticipatingBranchesBranchGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetParticipatingBranchesBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetParticipatingBranchesBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["isEnabled"] = this.isEnabled;
        data["isIncluded"] = this.isIncluded;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetParticipatingBranchesBranchDto {
    id?: string;
    code?: string | undefined;
    displayName?: string;
    isEnabled?: boolean;
    isIncluded?: boolean;
    groups?: GetParticipatingBranchesBranchGroupDto[];
}

export class GetParticipatingBranchesBranchGroupDto implements IGetParticipatingBranchesBranchGroupDto {
    id?: string;
    name?: string;

    constructor(data?: IGetParticipatingBranchesBranchGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetParticipatingBranchesBranchGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetParticipatingBranchesBranchGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetParticipatingBranchesBranchGroupDto {
    id?: string;
    name?: string;
}

export enum ParticipatingBranchSortingField {
    IsEnabled = 0,
    Code = 1,
    DisplayName = 2,
    Groups = 3,
}

export class GetParticipatingBranchesSummaryViewModel implements IGetParticipatingBranchesSummaryViewModel {
    activeParticipatingBranchCount?: number;
    participatingBranchCount?: number;
    activeBranchCount?: number;
    branchCount?: number;

    constructor(data?: IGetParticipatingBranchesSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeParticipatingBranchCount = _data["activeParticipatingBranchCount"];
            this.participatingBranchCount = _data["participatingBranchCount"];
            this.activeBranchCount = _data["activeBranchCount"];
            this.branchCount = _data["branchCount"];
        }
    }

    static fromJS(data: any): GetParticipatingBranchesSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetParticipatingBranchesSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeParticipatingBranchCount"] = this.activeParticipatingBranchCount;
        data["participatingBranchCount"] = this.participatingBranchCount;
        data["activeBranchCount"] = this.activeBranchCount;
        data["branchCount"] = this.branchCount;
        return data;
    }
}

export interface IGetParticipatingBranchesSummaryViewModel {
    activeParticipatingBranchCount?: number;
    participatingBranchCount?: number;
    activeBranchCount?: number;
    branchCount?: number;
}

export enum BranchRoleType {
    None = 0,
    Access = 1,
}

export class PermissionTreeOptionsViewModel implements IPermissionTreeOptionsViewModel {
    subscriptionOptions?: PermissionTreeSubscriptionOption[];
    maxHierarchyRole?: HierarchyRoleType;

    constructor(data?: IPermissionTreeOptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subscriptionOptions"])) {
                this.subscriptionOptions = [] as any;
                for (let item of _data["subscriptionOptions"])
                    this.subscriptionOptions!.push(PermissionTreeSubscriptionOption.fromJS(item));
            }
            this.maxHierarchyRole = _data["maxHierarchyRole"];
        }
    }

    static fromJS(data: any): PermissionTreeOptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionTreeOptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscriptionOptions)) {
            data["subscriptionOptions"] = [];
            for (let item of this.subscriptionOptions)
                data["subscriptionOptions"].push(item.toJSON());
        }
        data["maxHierarchyRole"] = this.maxHierarchyRole;
        return data;
    }
}

export interface IPermissionTreeOptionsViewModel {
    subscriptionOptions?: PermissionTreeSubscriptionOption[];
    maxHierarchyRole?: HierarchyRoleType;
}

export class PermissionTreeOptionBase implements IPermissionTreeOptionBase {
    id?: string;
    name?: string;
    subjectPath?: any[];
    maxHierarchyRole?: HierarchyRoleType;

    constructor(data?: IPermissionTreeOptionBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.maxHierarchyRole = _data["maxHierarchyRole"];
        }
    }

    static fromJS(data: any): PermissionTreeOptionBase {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionTreeOptionBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["maxHierarchyRole"] = this.maxHierarchyRole;
        return data;
    }
}

export interface IPermissionTreeOptionBase {
    id?: string;
    name?: string;
    subjectPath?: any[];
    maxHierarchyRole?: HierarchyRoleType;
}

export class PermissionTreeSubscriptionOption extends PermissionTreeOptionBase implements IPermissionTreeSubscriptionOption {
    permissionServices?: PermissionTreeServiceOption[];

    constructor(data?: IPermissionTreeSubscriptionOption) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["permissionServices"])) {
                this.permissionServices = [] as any;
                for (let item of _data["permissionServices"])
                    this.permissionServices!.push(PermissionTreeServiceOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionTreeSubscriptionOption {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionTreeSubscriptionOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissionServices)) {
            data["permissionServices"] = [];
            for (let item of this.permissionServices)
                data["permissionServices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPermissionTreeSubscriptionOption extends IPermissionTreeOptionBase {
    permissionServices?: PermissionTreeServiceOption[];
}

export class PermissionTreeServiceOption extends PermissionTreeOptionBase implements IPermissionTreeServiceOption {

    constructor(data?: IPermissionTreeServiceOption) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PermissionTreeServiceOption {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionTreeServiceOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPermissionTreeServiceOption extends IPermissionTreeOptionBase {
}

export class PermissionTreeOptionsBySubscriptionViewModel implements IPermissionTreeOptionsBySubscriptionViewModel {
    subscriptionOptions?: PermissionTreeSubscriptionOption[];
    maxHierarchyRole?: HierarchyRoleType;

    constructor(data?: IPermissionTreeOptionsBySubscriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subscriptionOptions"])) {
                this.subscriptionOptions = [] as any;
                for (let item of _data["subscriptionOptions"])
                    this.subscriptionOptions!.push(PermissionTreeSubscriptionOption.fromJS(item));
            }
            this.maxHierarchyRole = _data["maxHierarchyRole"];
        }
    }

    static fromJS(data: any): PermissionTreeOptionsBySubscriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionTreeOptionsBySubscriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscriptionOptions)) {
            data["subscriptionOptions"] = [];
            for (let item of this.subscriptionOptions)
                data["subscriptionOptions"].push(item.toJSON());
        }
        data["maxHierarchyRole"] = this.maxHierarchyRole;
        return data;
    }
}

export interface IPermissionTreeOptionsBySubscriptionViewModel {
    subscriptionOptions?: PermissionTreeSubscriptionOption[];
    maxHierarchyRole?: HierarchyRoleType;
}

export class SubscriptionLogosViewModel implements ISubscriptionLogosViewModel {
    logos?: LogoDto[];

    constructor(data?: ISubscriptionLogosViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["logos"])) {
                this.logos = [] as any;
                for (let item of _data["logos"])
                    this.logos!.push(LogoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionLogosViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionLogosViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logos)) {
            data["logos"] = [];
            for (let item of this.logos)
                data["logos"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscriptionLogosViewModel {
    logos?: LogoDto[];
}

export class LogoDto implements ILogoDto {
    entityId?: string;
    isDefault?: boolean;
    culture?: string;
    logo?: string;

    constructor(data?: ILogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.isDefault = _data["isDefault"];
            this.culture = _data["culture"];
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): LogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["isDefault"] = this.isDefault;
        data["culture"] = this.culture;
        data["logo"] = this.logo;
        return data;
    }
}

export interface ILogoDto {
    entityId?: string;
    isDefault?: boolean;
    culture?: string;
    logo?: string;
}

export class AvailableCultureViewModel implements IAvailableCultureViewModel {
    cultures?: CultureDto2[];

    constructor(data?: IAvailableCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(CultureDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailableCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailableCultureViewModel {
    cultures?: CultureDto2[];
}

export class CultureDto2 implements ICultureDto2 {
    isPrimary?: boolean;
    culture?: string;
    logo?: LogoDto2;

    constructor(data?: ICultureDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPrimary = _data["isPrimary"];
            this.culture = _data["culture"];
            this.logo = _data["logo"] ? LogoDto2.fromJS(_data["logo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CultureDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new CultureDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPrimary"] = this.isPrimary;
        data["culture"] = this.culture;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICultureDto2 {
    isPrimary?: boolean;
    culture?: string;
    logo?: LogoDto2;
}

export class LogoDto2 implements ILogoDto2 {
    logoUrl?: string;

    constructor(data?: ILogoDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): LogoDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new LogoDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}

export interface ILogoDto2 {
    logoUrl?: string;
}

export class BranchKeywordViewModel implements IBranchKeywordViewModel {
    keywords?: BranchKeyword[];

    constructor(data?: IBranchKeywordViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(BranchKeyword.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchKeywordViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchKeywordViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchKeywordViewModel {
    keywords?: BranchKeyword[];
}

export class GetSubscriptionsViewModel implements IGetSubscriptionsViewModel {
    subscriptions?: SubscriptionDto2[];

    constructor(data?: IGetSubscriptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(SubscriptionDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSubscriptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSubscriptionsViewModel {
    subscriptions?: SubscriptionDto2[];
}

export class SubscriptionDto2 implements ISubscriptionDto2 {
    id?: string;
    name?: string;
    normalizedName?: string;
    email?: string;
    cultureCode?: string;
    logo?: LogoDto3 | undefined;
    cultures?: SubscriptionCultureDto[];

    constructor(data?: ISubscriptionDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.email = _data["email"];
            this.cultureCode = _data["cultureCode"];
            this.logo = _data["logo"] ? LogoDto3.fromJS(_data["logo"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SubscriptionCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["email"] = this.email;
        data["cultureCode"] = this.cultureCode;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscriptionDto2 {
    id?: string;
    name?: string;
    normalizedName?: string;
    email?: string;
    cultureCode?: string;
    logo?: LogoDto3 | undefined;
    cultures?: SubscriptionCultureDto[];
}

export class LogoDto3 implements ILogoDto3 {
    id?: string;
    logoUrl?: string;

    constructor(data?: ILogoDto3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): LogoDto3 {
        data = typeof data === 'object' ? data : {};
        let result = new LogoDto3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}

export interface ILogoDto3 {
    id?: string;
    logoUrl?: string;
}

export class SubscriptionCultureDto implements ISubscriptionCultureDto {
    name?: string;
    cultureCode?: string;
    logo?: LogoDto3 | undefined;

    constructor(data?: ISubscriptionCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
            this.logo = _data["logo"] ? LogoDto3.fromJS(_data["logo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubscriptionCultureDto {
    name?: string;
    cultureCode?: string;
    logo?: LogoDto3 | undefined;
}

export class GetSubscriptionViewModel implements IGetSubscriptionViewModel {
    subscription?: SubscriptionDto2;

    constructor(data?: IGetSubscriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscription = _data["subscription"] ? SubscriptionDto2.fromJS(_data["subscription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSubscriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSubscriptionViewModel {
    subscription?: SubscriptionDto2;
}

export class GetMoveSubscriptionViewModel implements IGetMoveSubscriptionViewModel {
    organizations?: GetMoveSubscriptionOrganizationsDto[];
    canMove?: boolean;

    constructor(data?: IGetMoveSubscriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(GetMoveSubscriptionOrganizationsDto.fromJS(item));
            }
            this.canMove = _data["canMove"];
        }
    }

    static fromJS(data: any): GetMoveSubscriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoveSubscriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        data["canMove"] = this.canMove;
        return data;
    }
}

export interface IGetMoveSubscriptionViewModel {
    organizations?: GetMoveSubscriptionOrganizationsDto[];
    canMove?: boolean;
}

export class GetMoveSubscriptionOrganizationsDto implements IGetMoveSubscriptionOrganizationsDto {
    id?: string;
    name?: string;

    constructor(data?: IGetMoveSubscriptionOrganizationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetMoveSubscriptionOrganizationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoveSubscriptionOrganizationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetMoveSubscriptionOrganizationsDto {
    id?: string;
    name?: string;
}

export class MoveSubscriptionViewModel implements IMoveSubscriptionViewModel {
    organizationId?: string;
    subscriptionId?: string;

    constructor(data?: IMoveSubscriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): MoveSubscriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MoveSubscriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface IMoveSubscriptionViewModel {
    organizationId?: string;
    subscriptionId?: string;
}

export class GetSubscriptionManagerViewModel implements IGetSubscriptionManagerViewModel {
    organizations?: HierarchySelectItem[];
    subscriptions?: HierarchySelectItem[];

    constructor(data?: IGetSubscriptionManagerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(HierarchySelectItem.fromJS(item));
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(HierarchySelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSubscriptionManagerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionManagerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSubscriptionManagerViewModel {
    organizations?: HierarchySelectItem[];
    subscriptions?: HierarchySelectItem[];
}

export class GetCorporateClientsViewModel implements IGetCorporateClientsViewModel {
    corporateClients?: HierarchySelectItem[];

    constructor(data?: IGetCorporateClientsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["corporateClients"])) {
                this.corporateClients = [] as any;
                for (let item of _data["corporateClients"])
                    this.corporateClients!.push(HierarchySelectItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCorporateClientsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCorporateClientsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.corporateClients)) {
            data["corporateClients"] = [];
            for (let item of this.corporateClients)
                data["corporateClients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCorporateClientsViewModel {
    corporateClients?: HierarchySelectItem[];
}

export class SubscriptionServiceDto2 implements ISubscriptionServiceDto2 {
    id?: string;
    displayName?: string;
    shortName?: string;
    serviceId?: string;
    order?: number;
    allowProjects?: boolean;
    allowCustomImport?: boolean;
    logo?: LogoDto3 | undefined;
    cultures?: SubscriptionServiceCultureDto[];

    constructor(data?: ISubscriptionServiceDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.shortName = _data["shortName"];
            this.serviceId = _data["serviceId"];
            this.order = _data["order"];
            this.allowProjects = _data["allowProjects"];
            this.allowCustomImport = _data["allowCustomImport"];
            this.logo = _data["logo"] ? LogoDto3.fromJS(_data["logo"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SubscriptionServiceCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionServiceDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionServiceDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["shortName"] = this.shortName;
        data["serviceId"] = this.serviceId;
        data["order"] = this.order;
        data["allowProjects"] = this.allowProjects;
        data["allowCustomImport"] = this.allowCustomImport;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscriptionServiceDto2 {
    id?: string;
    displayName?: string;
    shortName?: string;
    serviceId?: string;
    order?: number;
    allowProjects?: boolean;
    allowCustomImport?: boolean;
    logo?: LogoDto3 | undefined;
    cultures?: SubscriptionServiceCultureDto[];
}

export class SubscriptionServiceCultureDto implements ISubscriptionServiceCultureDto {
    displayName?: string;
    shortName?: string;
    cultureCode?: string;
    logo?: LogoDto3 | undefined;

    constructor(data?: ISubscriptionServiceCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.shortName = _data["shortName"];
            this.cultureCode = _data["cultureCode"];
            this.logo = _data["logo"] ? LogoDto3.fromJS(_data["logo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionServiceCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionServiceCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["shortName"] = this.shortName;
        data["cultureCode"] = this.cultureCode;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubscriptionServiceCultureDto {
    displayName?: string;
    shortName?: string;
    cultureCode?: string;
    logo?: LogoDto3 | undefined;
}

export class DeleteSubscriptionServiceViewModel implements IDeleteSubscriptionServiceViewModel {
    id?: string;

    constructor(data?: IDeleteSubscriptionServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteSubscriptionServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSubscriptionServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteSubscriptionServiceViewModel {
    id?: string;
}

export class GetSubscriptionServicesViewModel2 implements IGetSubscriptionServicesViewModel2 {
    subscriptionServices?: SubscriptionServiceDto2[];

    constructor(data?: IGetSubscriptionServicesViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(SubscriptionServiceDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSubscriptionServicesViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionServicesViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSubscriptionServicesViewModel2 {
    subscriptionServices?: SubscriptionServiceDto2[];
}

export class GetSubscriptionServiceViewModel implements IGetSubscriptionServiceViewModel {
    subscriptionService?: SubscriptionServiceDto2;

    constructor(data?: IGetSubscriptionServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionService = _data["subscriptionService"] ? SubscriptionServiceDto2.fromJS(_data["subscriptionService"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSubscriptionServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionService"] = this.subscriptionService ? this.subscriptionService.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSubscriptionServiceViewModel {
    subscriptionService?: SubscriptionServiceDto2;
}

export class GetSurveyQuestionsViewModel implements IGetSurveyQuestionsViewModel {
    surveyQuestions?: SurveyQuestionListItem[];

    constructor(data?: IGetSurveyQuestionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyQuestions"])) {
                this.surveyQuestions = [] as any;
                for (let item of _data["surveyQuestions"])
                    this.surveyQuestions!.push(SurveyQuestionListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSurveyQuestionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyQuestionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyQuestions)) {
            data["surveyQuestions"] = [];
            for (let item of this.surveyQuestions)
                data["surveyQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSurveyQuestionsViewModel {
    surveyQuestions?: SurveyQuestionListItem[];
}

export class SurveyQuestionListItem implements ISurveyQuestionListItem {
    id?: string;
    text?: string;
    origin?: string;
    subjectType?: SubjectType | undefined;

    constructor(data?: ISurveyQuestionListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.origin = _data["origin"];
            this.subjectType = _data["subjectType"];
        }
    }

    static fromJS(data: any): SurveyQuestionListItem {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["origin"] = this.origin;
        data["subjectType"] = this.subjectType;
        return data;
    }
}

export interface ISurveyQuestionListItem {
    id?: string;
    text?: string;
    origin?: string;
    subjectType?: SubjectType | undefined;
}

export class GetSurveyQuestionViewModel implements IGetSurveyQuestionViewModel {
    surveyQuestion?: SurveyQuestionDto;

    constructor(data?: IGetSurveyQuestionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyQuestion = _data["surveyQuestion"] ? SurveyQuestionDto.fromJS(_data["surveyQuestion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyQuestionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyQuestionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestion"] = this.surveyQuestion ? this.surveyQuestion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyQuestionViewModel {
    surveyQuestion?: SurveyQuestionDto;
}

export class SurveyQuestionDto implements ISurveyQuestionDto {
    jsonSearchable?: string;
    tags?: SurveyQuestionTagDto[];

    constructor(data?: ISurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jsonSearchable = _data["jsonSearchable"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(SurveyQuestionTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jsonSearchable"] = this.jsonSearchable;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyQuestionDto {
    jsonSearchable?: string;
    tags?: SurveyQuestionTagDto[];
}

export class SurveyQuestionTagDto implements ISurveyQuestionTagDto {
    id?: string | undefined;
    text?: string;
    cultures?: SurveyQuestionTagCultureDto[];

    constructor(data?: ISurveyQuestionTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SurveyQuestionTagCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestionTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyQuestionTagDto {
    id?: string | undefined;
    text?: string;
    cultures?: SurveyQuestionTagCultureDto[];
}

export class SurveyQuestionTagCultureDto implements ISurveyQuestionTagCultureDto {
    id?: string | undefined;
    cultureCode?: string;
    text?: string;

    constructor(data?: ISurveyQuestionTagCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cultureCode = _data["cultureCode"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SurveyQuestionTagCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionTagCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cultureCode"] = this.cultureCode;
        data["text"] = this.text;
        return data;
    }
}

export interface ISurveyQuestionTagCultureDto {
    id?: string | undefined;
    cultureCode?: string;
    text?: string;
}

export class SearchForSurveyQuestionsViewModel implements ISearchForSurveyQuestionsViewModel {
    surveyQuestions?: SearchForSurveyQuestionDto[];

    constructor(data?: ISearchForSurveyQuestionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyQuestions"])) {
                this.surveyQuestions = [] as any;
                for (let item of _data["surveyQuestions"])
                    this.surveyQuestions!.push(SearchForSurveyQuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchForSurveyQuestionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchForSurveyQuestionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyQuestions)) {
            data["surveyQuestions"] = [];
            for (let item of this.surveyQuestions)
                data["surveyQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchForSurveyQuestionsViewModel {
    surveyQuestions?: SearchForSurveyQuestionDto[];
}

export class SearchForSurveyQuestionDto implements ISearchForSurveyQuestionDto {
    text?: string;
    json?: string;
    choices?: SearchForSurveyQuestionChoiceDto[] | undefined;

    constructor(data?: ISearchForSurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.json = _data["json"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(SearchForSurveyQuestionChoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchForSurveyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchForSurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["json"] = this.json;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchForSurveyQuestionDto {
    text?: string;
    json?: string;
    choices?: SearchForSurveyQuestionChoiceDto[] | undefined;
}

export class SearchForSurveyQuestionChoiceDto implements ISearchForSurveyQuestionChoiceDto {
    text?: string;

    constructor(data?: ISearchForSurveyQuestionChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SearchForSurveyQuestionChoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchForSurveyQuestionChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

export interface ISearchForSurveyQuestionChoiceDto {
    text?: string;
}

export class UpsertSurveyQuestionDto implements IUpsertSurveyQuestionDto {
    tags?: string[];
    json?: string;
    origin?: SurveyQuestionPathDto | undefined;
    scope?: SurveyQuestionPathDto | undefined;

    constructor(data?: IUpsertSurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.json = _data["json"];
            this.origin = _data["origin"] ? SurveyQuestionPathDto.fromJS(_data["origin"]) : <any>undefined;
            this.scope = _data["scope"] ? SurveyQuestionPathDto.fromJS(_data["scope"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpsertSurveyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertSurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["json"] = this.json;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["scope"] = this.scope ? this.scope.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpsertSurveyQuestionDto {
    tags?: string[];
    json?: string;
    origin?: SurveyQuestionPathDto | undefined;
    scope?: SurveyQuestionPathDto | undefined;
}

export class SurveyQuestionPathDto implements ISurveyQuestionPathDto {
    subjectPath?: string[];
    subjectId?: string;
    subjectType?: SubjectType;

    constructor(data?: ISurveyQuestionPathDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.subjectId = _data["subjectId"];
            this.subjectType = _data["subjectType"];
        }
    }

    static fromJS(data: any): SurveyQuestionPathDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionPathDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["subjectId"] = this.subjectId;
        data["subjectType"] = this.subjectType;
        return data;
    }
}

export interface ISurveyQuestionPathDto {
    subjectPath?: string[];
    subjectId?: string;
    subjectType?: SubjectType;
}

export class CountriesViewModel implements ICountriesViewModel {
    countries?: Country[];

    constructor(data?: ICountriesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(Country.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountriesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountriesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICountriesViewModel {
    countries?: Country[];
}

export class Country implements ICountry {
    alpha3Code?: Alpha3Code;
    displayName?: string;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alpha3Code = _data["alpha3Code"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alpha3Code"] = this.alpha3Code;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICountry {
    alpha3Code?: Alpha3Code;
    displayName?: string;
}

export class SocialMediasViewModel implements ISocialMediasViewModel {
    socialMedias?: SocialMediaType[];

    constructor(data?: ISocialMediasViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["socialMedias"])) {
                this.socialMedias = [] as any;
                for (let item of _data["socialMedias"])
                    this.socialMedias!.push(SocialMediaType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SocialMediasViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SocialMediasViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.socialMedias)) {
            data["socialMedias"] = [];
            for (let item of this.socialMedias)
                data["socialMedias"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISocialMediasViewModel {
    socialMedias?: SocialMediaType[];
}

export class SocialMediaType implements ISocialMediaType {
    type?: SocialMedia;
    displayName?: string;

    constructor(data?: ISocialMediaType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SocialMediaType {
        data = typeof data === 'object' ? data : {};
        let result = new SocialMediaType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISocialMediaType {
    type?: SocialMedia;
    displayName?: string;
}

export class SystemNotificationPageViewModel implements ISystemNotificationPageViewModel {
    notifications?: SystemNotificationPageDto[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;

    constructor(data?: ISystemNotificationPageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(SystemNotificationPageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): SystemNotificationPageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemNotificationPageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface ISystemNotificationPageViewModel {
    notifications?: SystemNotificationPageDto[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;
}

export class SystemNotificationPageDto implements ISystemNotificationPageDto {
    id?: string;
    abstract?: string;
    startDate?: Date | undefined;
    endDate?: Date;
    externalLink?: string | undefined;
    supportedCultures?: string[];

    constructor(data?: ISystemNotificationPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.abstract = _data["abstract"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.externalLink = _data["externalLink"];
            if (Array.isArray(_data["supportedCultures"])) {
                this.supportedCultures = [] as any;
                for (let item of _data["supportedCultures"])
                    this.supportedCultures!.push(item);
            }
        }
    }

    static fromJS(data: any): SystemNotificationPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemNotificationPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["abstract"] = this.abstract;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["externalLink"] = this.externalLink;
        if (Array.isArray(this.supportedCultures)) {
            data["supportedCultures"] = [];
            for (let item of this.supportedCultures)
                data["supportedCultures"].push(item);
        }
        return data;
    }
}

export interface ISystemNotificationPageDto {
    id?: string;
    abstract?: string;
    startDate?: Date | undefined;
    endDate?: Date;
    externalLink?: string | undefined;
    supportedCultures?: string[];
}

export enum SystemNotificationSortingField {
    StartDate = 0,
    EndDate = 1,
    Abstract = 2,
}

export class GetSystemNotificationByIdViewModel implements IGetSystemNotificationByIdViewModel {
    availableCultures?: GeneralCultureDto[];
    dto?: GetSystemNotificationByIdDto;

    constructor(data?: IGetSystemNotificationByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableCultures"])) {
                this.availableCultures = [] as any;
                for (let item of _data["availableCultures"])
                    this.availableCultures!.push(GeneralCultureDto.fromJS(item));
            }
            this.dto = _data["dto"] ? GetSystemNotificationByIdDto.fromJS(_data["dto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSystemNotificationByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemNotificationByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableCultures)) {
            data["availableCultures"] = [];
            for (let item of this.availableCultures)
                data["availableCultures"].push(item.toJSON());
        }
        data["dto"] = this.dto ? this.dto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSystemNotificationByIdViewModel {
    availableCultures?: GeneralCultureDto[];
    dto?: GetSystemNotificationByIdDto;
}

export class SystemNotificationDto implements ISystemNotificationDto {
    abstract?: string;
    startDate?: Date | undefined;
    endDate?: Date;
    externalLink?: string | undefined;
    cultures?: SystemNotificationCultureDto[];

    constructor(data?: ISystemNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abstract = _data["abstract"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.externalLink = _data["externalLink"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SystemNotificationCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abstract"] = this.abstract;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["externalLink"] = this.externalLink;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISystemNotificationDto {
    abstract?: string;
    startDate?: Date | undefined;
    endDate?: Date;
    externalLink?: string | undefined;
    cultures?: SystemNotificationCultureDto[];
}

export class GetSystemNotificationByIdDto extends SystemNotificationDto implements IGetSystemNotificationByIdDto {
    id?: string;

    constructor(data?: IGetSystemNotificationByIdDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSystemNotificationByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemNotificationByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IGetSystemNotificationByIdDto extends ISystemNotificationDto {
    id?: string;
}

export class SystemNotificationCultureDto implements ISystemNotificationCultureDto {
    cultureCode?: string;
    abstract?: string;
    externalLink?: string;

    constructor(data?: ISystemNotificationCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.abstract = _data["abstract"];
            this.externalLink = _data["externalLink"];
        }
    }

    static fromJS(data: any): SystemNotificationCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemNotificationCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["abstract"] = this.abstract;
        data["externalLink"] = this.externalLink;
        return data;
    }
}

export interface ISystemNotificationCultureDto {
    cultureCode?: string;
    abstract?: string;
    externalLink?: string;
}

export class AlertStatusHistoryModel implements IAlertStatusHistoryModel {
    id?: string;
    createdDate?: Date;
    alertStatusType?: AlertStatusType;
    historyOption?: HistoryOptions;
    reason?: string | undefined;
    comment?: string | undefined;
    authorName?: string | undefined;
    authorUserId?: string | undefined;

    constructor(data?: IAlertStatusHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.alertStatusType = _data["alertStatusType"];
            this.historyOption = _data["historyOption"];
            this.reason = _data["reason"];
            this.comment = _data["comment"];
            this.authorName = _data["authorName"];
            this.authorUserId = _data["authorUserId"];
        }
    }

    static fromJS(data: any): AlertStatusHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new AlertStatusHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["alertStatusType"] = this.alertStatusType;
        data["historyOption"] = this.historyOption;
        data["reason"] = this.reason;
        data["comment"] = this.comment;
        data["authorName"] = this.authorName;
        data["authorUserId"] = this.authorUserId;
        return data;
    }
}

export interface IAlertStatusHistoryModel {
    id?: string;
    createdDate?: Date;
    alertStatusType?: AlertStatusType;
    historyOption?: HistoryOptions;
    reason?: string | undefined;
    comment?: string | undefined;
    authorName?: string | undefined;
    authorUserId?: string | undefined;
}

export enum AlertStatusType {
    Unopened = 0,
    Opened = 1,
    Resolved = 2,
    OnHold = 3,
    Cancelled = 4,
    Forwarded = 5,
    Read = 6,
    Closed = 7,
}

export enum HistoryOptions {
    None = "none",
    NoAnswer = "no_answer",
    Apology = "apology",
    Appointment = "appointment",
    GiftCard = "gift_card",
    Headquarter = "headquarter",
    Machine = "machine",
    Number = "number",
    Shop = "shop",
    EmailSent = "email_sent",
    Other = "other",
}

export class AlertStatusHistoryDto implements IAlertStatusHistoryDto {
    alertId?: string;
    status?: AlertStatusHistoryModel | undefined;

    constructor(data?: IAlertStatusHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alertId"];
            this.status = _data["status"] ? AlertStatusHistoryModel.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertStatusHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertStatusHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlertStatusHistoryDto {
    alertId?: string;
    status?: AlertStatusHistoryModel | undefined;
}

export class AlertDetailModel implements IAlertDetailModel {
    clientVisit?: AlertClientVisitModel | undefined;
    alert?: AlertDto | undefined;
    clientInformation?: AlertClientInformationModel | undefined;
    canEdit?: boolean;
    canForward?: boolean;

    constructor(data?: IAlertDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientVisit = _data["clientVisit"] ? AlertClientVisitModel.fromJS(_data["clientVisit"]) : <any>undefined;
            this.alert = _data["alert"] ? AlertDto.fromJS(_data["alert"]) : <any>undefined;
            this.clientInformation = _data["clientInformation"] ? AlertClientInformationModel.fromJS(_data["clientInformation"]) : <any>undefined;
            this.canEdit = _data["canEdit"];
            this.canForward = _data["canForward"];
        }
    }

    static fromJS(data: any): AlertDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientVisit"] = this.clientVisit ? this.clientVisit.toJSON() : <any>undefined;
        data["alert"] = this.alert ? this.alert.toJSON() : <any>undefined;
        data["clientInformation"] = this.clientInformation ? this.clientInformation.toJSON() : <any>undefined;
        data["canEdit"] = this.canEdit;
        data["canForward"] = this.canForward;
        return data;
    }
}

export interface IAlertDetailModel {
    clientVisit?: AlertClientVisitModel | undefined;
    alert?: AlertDto | undefined;
    clientInformation?: AlertClientInformationModel | undefined;
    canEdit?: boolean;
    canForward?: boolean;
}

export class AlertClientVisitModel implements IAlertClientVisitModel {
    date?: Date | undefined;
    timeOfVisit?: string | undefined;
    pointOfSale?: string | undefined;
    alertIssued?: Date;
    alertConcluded?: Date | undefined;
    surveyGlobalScore?: number;

    constructor(data?: IAlertClientVisitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.timeOfVisit = _data["timeOfVisit"];
            this.pointOfSale = _data["pointOfSale"];
            this.alertIssued = _data["alertIssued"] ? new Date(_data["alertIssued"].toString()) : <any>undefined;
            this.alertConcluded = _data["alertConcluded"] ? new Date(_data["alertConcluded"].toString()) : <any>undefined;
            this.surveyGlobalScore = _data["surveyGlobalScore"];
        }
    }

    static fromJS(data: any): AlertClientVisitModel {
        data = typeof data === 'object' ? data : {};
        let result = new AlertClientVisitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["timeOfVisit"] = this.timeOfVisit;
        data["pointOfSale"] = this.pointOfSale;
        data["alertIssued"] = this.alertIssued ? this.alertIssued.toISOString() : <any>undefined;
        data["alertConcluded"] = this.alertConcluded ? this.alertConcluded.toISOString() : <any>undefined;
        data["surveyGlobalScore"] = this.surveyGlobalScore;
        return data;
    }
}

export interface IAlertClientVisitModel {
    date?: Date | undefined;
    timeOfVisit?: string | undefined;
    pointOfSale?: string | undefined;
    alertIssued?: Date;
    alertConcluded?: Date | undefined;
    surveyGlobalScore?: number;
}

export class AlertDto implements IAlertDto {
    id?: string;
    alertType?: AlertType;
    alertStatus?: AlertStatusType;
    title?: string | undefined;
    surveyAnswerId?: string;
    description?: string | undefined;
    statusHistories?: AlertStatusHistoryModel[] | undefined;
    triggeredItemsJson?: string | undefined;
    surveyAnswer?: SurveyAnswerDto[] | undefined;

    constructor(data?: IAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alertType = _data["alertType"];
            this.alertStatus = _data["alertStatus"];
            this.title = _data["title"];
            this.surveyAnswerId = _data["surveyAnswerId"];
            this.description = _data["description"];
            if (Array.isArray(_data["statusHistories"])) {
                this.statusHistories = [] as any;
                for (let item of _data["statusHistories"])
                    this.statusHistories!.push(AlertStatusHistoryModel.fromJS(item));
            }
            this.triggeredItemsJson = _data["triggeredItemsJson"];
            if (Array.isArray(_data["surveyAnswer"])) {
                this.surveyAnswer = [] as any;
                for (let item of _data["surveyAnswer"])
                    this.surveyAnswer!.push(SurveyAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alertType"] = this.alertType;
        data["alertStatus"] = this.alertStatus;
        data["title"] = this.title;
        data["surveyAnswerId"] = this.surveyAnswerId;
        data["description"] = this.description;
        if (Array.isArray(this.statusHistories)) {
            data["statusHistories"] = [];
            for (let item of this.statusHistories)
                data["statusHistories"].push(item.toJSON());
        }
        data["triggeredItemsJson"] = this.triggeredItemsJson;
        if (Array.isArray(this.surveyAnswer)) {
            data["surveyAnswer"] = [];
            for (let item of this.surveyAnswer)
                data["surveyAnswer"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlertDto {
    id?: string;
    alertType?: AlertType;
    alertStatus?: AlertStatusType;
    title?: string | undefined;
    surveyAnswerId?: string;
    description?: string | undefined;
    statusHistories?: AlertStatusHistoryModel[] | undefined;
    triggeredItemsJson?: string | undefined;
    surveyAnswer?: SurveyAnswerDto[] | undefined;
}

export enum AlertType {
    ToBeRead = 0,
    ToBeSolved = 1,
}

export class SurveyAnswerDto implements ISurveyAnswerDto {
    questionLanguageMetadata?: QuestionLanguageMetadata[] | undefined;
    questionName?: string | undefined;
    answer?: QuestionLanguageMetadata[] | undefined;

    constructor(data?: ISurveyAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questionLanguageMetadata"])) {
                this.questionLanguageMetadata = [] as any;
                for (let item of _data["questionLanguageMetadata"])
                    this.questionLanguageMetadata!.push(QuestionLanguageMetadata.fromJS(item));
            }
            this.questionName = _data["questionName"];
            if (Array.isArray(_data["answer"])) {
                this.answer = [] as any;
                for (let item of _data["answer"])
                    this.answer!.push(QuestionLanguageMetadata.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questionLanguageMetadata)) {
            data["questionLanguageMetadata"] = [];
            for (let item of this.questionLanguageMetadata)
                data["questionLanguageMetadata"].push(item.toJSON());
        }
        data["questionName"] = this.questionName;
        if (Array.isArray(this.answer)) {
            data["answer"] = [];
            for (let item of this.answer)
                data["answer"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyAnswerDto {
    questionLanguageMetadata?: QuestionLanguageMetadata[] | undefined;
    questionName?: string | undefined;
    answer?: QuestionLanguageMetadata[] | undefined;
}

export class QuestionLanguageMetadata implements IQuestionLanguageMetadata {
    lang?: string | undefined;
    value?: Value | undefined;

    constructor(data?: IQuestionLanguageMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lang = _data["lang"];
            this.value = _data["value"] ? Value.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionLanguageMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionLanguageMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lang"] = this.lang;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuestionLanguageMetadata {
    lang?: string | undefined;
    value?: Value | undefined;
}

export class Value implements IValue {
    longText?: string | undefined;
    shortText?: string | undefined;

    constructor(data?: IValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.longText = _data["longText"];
            this.shortText = _data["shortText"];
        }
    }

    static fromJS(data: any): Value {
        data = typeof data === 'object' ? data : {};
        let result = new Value();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["longText"] = this.longText;
        data["shortText"] = this.shortText;
        return data;
    }
}

export interface IValue {
    longText?: string | undefined;
    shortText?: string | undefined;
}

export class AlertClientInformationModel implements IAlertClientInformationModel {
    clientNumber?: string | undefined;
    gender?: QuestionLanguageMetadata[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ageGroup?: QuestionLanguageMetadata[] | undefined;
    email?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IAlertClientInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            if (Array.isArray(_data["gender"])) {
                this.gender = [] as any;
                for (let item of _data["gender"])
                    this.gender!.push(QuestionLanguageMetadata.fromJS(item));
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["ageGroup"])) {
                this.ageGroup = [] as any;
                for (let item of _data["ageGroup"])
                    this.ageGroup!.push(QuestionLanguageMetadata.fromJS(item));
            }
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): AlertClientInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new AlertClientInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        if (Array.isArray(this.gender)) {
            data["gender"] = [];
            for (let item of this.gender)
                data["gender"].push(item.toJSON());
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.ageGroup)) {
            data["ageGroup"] = [];
            for (let item of this.ageGroup)
                data["ageGroup"].push(item.toJSON());
        }
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IAlertClientInformationModel {
    clientNumber?: string | undefined;
    gender?: QuestionLanguageMetadata[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ageGroup?: QuestionLanguageMetadata[] | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export class AlertForward implements IAlertForward {
    alertId?: string;
    comments?: string | undefined;
    userId?: string;
    authorName?: string | undefined;
    callbackUrl?: string | undefined;

    constructor(data?: IAlertForward) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alertId"];
            this.comments = _data["comments"];
            this.userId = _data["userId"];
            this.authorName = _data["authorName"];
            this.callbackUrl = _data["callbackUrl"];
        }
    }

    static fromJS(data: any): AlertForward {
        data = typeof data === 'object' ? data : {};
        let result = new AlertForward();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["comments"] = this.comments;
        data["userId"] = this.userId;
        data["authorName"] = this.authorName;
        data["callbackUrl"] = this.callbackUrl;
        return data;
    }
}

export interface IAlertForward {
    alertId?: string;
    comments?: string | undefined;
    userId?: string;
    authorName?: string | undefined;
    callbackUrl?: string | undefined;
}

export class BranchDto2 implements IBranchDto2 {
    id?: string;
    name?: string;

    constructor(data?: IBranchDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BranchDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBranchDto2 {
    id?: string;
    name?: string;
}

export class LocalityDto implements ILocalityDto {
    id?: string;
    name?: string;

    constructor(data?: ILocalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocalityDto {
    id?: string;
    name?: string;
}

export class CustomImportEntryCountViewModel implements ICustomImportEntryCountViewModel {
    entries?: CustomImportEntryCountDto[];

    constructor(data?: ICustomImportEntryCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(CustomImportEntryCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomImportEntryCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomImportEntryCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomImportEntryCountViewModel {
    entries?: CustomImportEntryCountDto[];
}

export class CustomImportEntryCountDto implements ICustomImportEntryCountDto {
    vocServiceId?: string;
    subscriptionName?: string | undefined;
    projectId?: string;
    projectName?: string | undefined;
    customImportConfigurationId?: string;
    customImportProjectConfigurationId?: string;
    date?: Date;
    unprocessed?: number;
    processed?: number;
    bounceDropped?: number;
    deferred?: number;
    bounced?: number;
    sent?: number;
    opened?: number;
    clicked?: number;
    spamReport?: number;
    unsubscribed?: number;
    answered?: number;
    notAnswered?: number;
    total?: number;

    constructor(data?: ICustomImportEntryCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vocServiceId = _data["vocServiceId"];
            this.subscriptionName = _data["subscriptionName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.customImportConfigurationId = _data["customImportConfigurationId"];
            this.customImportProjectConfigurationId = _data["customImportProjectConfigurationId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.unprocessed = _data["unprocessed"];
            this.processed = _data["processed"];
            this.bounceDropped = _data["bounceDropped"];
            this.deferred = _data["deferred"];
            this.bounced = _data["bounced"];
            this.sent = _data["sent"];
            this.opened = _data["opened"];
            this.clicked = _data["clicked"];
            this.spamReport = _data["spamReport"];
            this.unsubscribed = _data["unsubscribed"];
            this.answered = _data["answered"];
            this.notAnswered = _data["notAnswered"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): CustomImportEntryCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomImportEntryCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vocServiceId"] = this.vocServiceId;
        data["subscriptionName"] = this.subscriptionName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["customImportConfigurationId"] = this.customImportConfigurationId;
        data["customImportProjectConfigurationId"] = this.customImportProjectConfigurationId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["unprocessed"] = this.unprocessed;
        data["processed"] = this.processed;
        data["bounceDropped"] = this.bounceDropped;
        data["deferred"] = this.deferred;
        data["bounced"] = this.bounced;
        data["sent"] = this.sent;
        data["opened"] = this.opened;
        data["clicked"] = this.clicked;
        data["spamReport"] = this.spamReport;
        data["unsubscribed"] = this.unsubscribed;
        data["answered"] = this.answered;
        data["notAnswered"] = this.notAnswered;
        data["total"] = this.total;
        return data;
    }
}

export interface ICustomImportEntryCountDto {
    vocServiceId?: string;
    subscriptionName?: string | undefined;
    projectId?: string;
    projectName?: string | undefined;
    customImportConfigurationId?: string;
    customImportProjectConfigurationId?: string;
    date?: Date;
    unprocessed?: number;
    processed?: number;
    bounceDropped?: number;
    deferred?: number;
    bounced?: number;
    sent?: number;
    opened?: number;
    clicked?: number;
    spamReport?: number;
    unsubscribed?: number;
    answered?: number;
    notAnswered?: number;
    total?: number;
}

export class ResetCustomImportFunctionsViewModel implements IResetCustomImportFunctionsViewModel {
    hasError?: boolean;
    errorMessage?: string;

    constructor(data?: IResetCustomImportFunctionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasError = _data["hasError"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ResetCustomImportFunctionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetCustomImportFunctionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasError"] = this.hasError;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IResetCustomImportFunctionsViewModel {
    hasError?: boolean;
    errorMessage?: string;
}

export class CustomImportFilesViewModel implements ICustomImportFilesViewModel {
    customImportFiles?: CustomImportFileDto[];

    constructor(data?: ICustomImportFilesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customImportFiles"])) {
                this.customImportFiles = [] as any;
                for (let item of _data["customImportFiles"])
                    this.customImportFiles!.push(CustomImportFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomImportFilesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomImportFilesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customImportFiles)) {
            data["customImportFiles"] = [];
            for (let item of this.customImportFiles)
                data["customImportFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomImportFilesViewModel {
    customImportFiles?: CustomImportFileDto[];
}

export class CustomImportFileDto implements ICustomImportFileDto {
    subscriptionServiceId?: string;
    customImportConfigurationId?: string;
    customImportConfigurationName?: string;
    azureStoragePath?: string;
    shareFiles?: ShareFile[];

    constructor(data?: ICustomImportFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.customImportConfigurationId = _data["customImportConfigurationId"];
            this.customImportConfigurationName = _data["customImportConfigurationName"];
            this.azureStoragePath = _data["azureStoragePath"];
            if (Array.isArray(_data["shareFiles"])) {
                this.shareFiles = [] as any;
                for (let item of _data["shareFiles"])
                    this.shareFiles!.push(ShareFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomImportFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomImportFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["customImportConfigurationId"] = this.customImportConfigurationId;
        data["customImportConfigurationName"] = this.customImportConfigurationName;
        data["azureStoragePath"] = this.azureStoragePath;
        if (Array.isArray(this.shareFiles)) {
            data["shareFiles"] = [];
            for (let item of this.shareFiles)
                data["shareFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomImportFileDto {
    subscriptionServiceId?: string;
    customImportConfigurationId?: string;
    customImportConfigurationName?: string;
    azureStoragePath?: string;
    shareFiles?: ShareFile[];
}

export class ShareFile implements IShareFile {
    name?: string | undefined;
    fullPath?: string | undefined;
    directoryPath?: string | undefined;

    constructor(data?: IShareFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fullPath = _data["fullPath"];
            this.directoryPath = _data["directoryPath"];
        }
    }

    static fromJS(data: any): ShareFile {
        data = typeof data === 'object' ? data : {};
        let result = new ShareFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fullPath"] = this.fullPath;
        data["directoryPath"] = this.directoryPath;
        return data;
    }
}

export interface IShareFile {
    name?: string | undefined;
    fullPath?: string | undefined;
    directoryPath?: string | undefined;
}

export class CustomImportEntryCountByProjectViewModel implements ICustomImportEntryCountByProjectViewModel {
    entries?: CustomImportEntryCountByProjectDto[];

    constructor(data?: ICustomImportEntryCountByProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(CustomImportEntryCountByProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomImportEntryCountByProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomImportEntryCountByProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomImportEntryCountByProjectViewModel {
    entries?: CustomImportEntryCountByProjectDto[];
}

export class CustomImportEntryCountByProjectDto implements ICustomImportEntryCountByProjectDto {
    date?: Date;
    processed?: number;
    bounceDropped?: number;
    deferred?: number;
    bounced?: number;
    sent?: number;
    opened?: number;
    clicked?: number;
    spamReport?: number;
    unsubscribed?: number;
    answered?: number;
    notAnswered?: number;
    total?: number;

    constructor(data?: ICustomImportEntryCountByProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.processed = _data["processed"];
            this.bounceDropped = _data["bounceDropped"];
            this.deferred = _data["deferred"];
            this.bounced = _data["bounced"];
            this.sent = _data["sent"];
            this.opened = _data["opened"];
            this.clicked = _data["clicked"];
            this.spamReport = _data["spamReport"];
            this.unsubscribed = _data["unsubscribed"];
            this.answered = _data["answered"];
            this.notAnswered = _data["notAnswered"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): CustomImportEntryCountByProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomImportEntryCountByProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["processed"] = this.processed;
        data["bounceDropped"] = this.bounceDropped;
        data["deferred"] = this.deferred;
        data["bounced"] = this.bounced;
        data["sent"] = this.sent;
        data["opened"] = this.opened;
        data["clicked"] = this.clicked;
        data["spamReport"] = this.spamReport;
        data["unsubscribed"] = this.unsubscribed;
        data["answered"] = this.answered;
        data["notAnswered"] = this.notAnswered;
        data["total"] = this.total;
        return data;
    }
}

export interface ICustomImportEntryCountByProjectDto {
    date?: Date;
    processed?: number;
    bounceDropped?: number;
    deferred?: number;
    bounced?: number;
    sent?: number;
    opened?: number;
    clicked?: number;
    spamReport?: number;
    unsubscribed?: number;
    answered?: number;
    notAnswered?: number;
    total?: number;
}

export class ResendCustomImportEntryViewModel implements IResendCustomImportEntryViewModel {
    updatedEntries?: ResendCustomImportEntryDto[];

    constructor(data?: IResendCustomImportEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["updatedEntries"])) {
                this.updatedEntries = [] as any;
                for (let item of _data["updatedEntries"])
                    this.updatedEntries!.push(ResendCustomImportEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResendCustomImportEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResendCustomImportEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.updatedEntries)) {
            data["updatedEntries"] = [];
            for (let item of this.updatedEntries)
                data["updatedEntries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResendCustomImportEntryViewModel {
    updatedEntries?: ResendCustomImportEntryDto[];
}

export class ResendCustomImportEntryDto implements IResendCustomImportEntryDto {
    id?: string;

    constructor(data?: IResendCustomImportEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ResendCustomImportEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResendCustomImportEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IResendCustomImportEntryDto {
    id?: string;
}

export class GetOverviewResponse implements IGetOverviewResponse {
    widgets?: CxRayWidget[];

    constructor(data?: IGetOverviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(CxRayWidget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOverviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOverviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOverviewResponse {
    widgets?: CxRayWidget[];
}

export class CxRayWidget implements ICxRayWidget {
    order?: number;
    code?: string;

    constructor(data?: ICxRayWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CxRayWidget {
        data = typeof data === 'object' ? data : {};
        let result = new CxRayWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["code"] = this.code;
        return data;
    }
}

export interface ICxRayWidget {
    order?: number;
    code?: string;
}

export class FilterViewModel implements IFilterViewModel {
    filter?: FilterModel;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    searchText?: string;
    sorting?: SortingModel[];
    exportType?: ExportTableType;
    tableLevel?: TableLevel;
    demoMode?: boolean;

    constructor(data?: IFilterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? FilterModel.fromJS(_data["filter"]) : <any>undefined;
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["sorting"])) {
                this.sorting = [] as any;
                for (let item of _data["sorting"])
                    this.sorting!.push(SortingModel.fromJS(item));
            }
            this.exportType = _data["exportType"];
            this.tableLevel = _data["tableLevel"];
            this.demoMode = _data["demoMode"];
        }
    }

    static fromJS(data: any): FilterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.sorting)) {
            data["sorting"] = [];
            for (let item of this.sorting)
                data["sorting"].push(item.toJSON());
        }
        data["exportType"] = this.exportType;
        data["tableLevel"] = this.tableLevel;
        data["demoMode"] = this.demoMode;
        return data;
    }
}

export interface IFilterViewModel {
    filter?: FilterModel;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    searchText?: string;
    sorting?: SortingModel[];
    exportType?: ExportTableType;
    tableLevel?: TableLevel;
    demoMode?: boolean;
}

export class FilterModel implements IFilterModel {
    branchFilter?: BranchFilterModel | undefined;
    periodFilter?: PeriodFilterModel | undefined;
    customFilter?: CustomFilterModel | undefined;
    questionFilter?: QuestionFilterModel | undefined;
    advancedFilter?: AdvancedFilterModel | undefined;

    constructor(data?: IFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchFilter = _data["branchFilter"] ? BranchFilterModel.fromJS(_data["branchFilter"]) : <any>undefined;
            this.periodFilter = _data["periodFilter"] ? PeriodFilterModel.fromJS(_data["periodFilter"]) : <any>undefined;
            this.customFilter = _data["customFilter"] ? CustomFilterModel.fromJS(_data["customFilter"]) : <any>undefined;
            this.questionFilter = _data["questionFilter"] ? QuestionFilterModel.fromJS(_data["questionFilter"]) : <any>undefined;
            this.advancedFilter = _data["advancedFilter"] ? AdvancedFilterModel.fromJS(_data["advancedFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchFilter"] = this.branchFilter ? this.branchFilter.toJSON() : <any>undefined;
        data["periodFilter"] = this.periodFilter ? this.periodFilter.toJSON() : <any>undefined;
        data["customFilter"] = this.customFilter ? this.customFilter.toJSON() : <any>undefined;
        data["questionFilter"] = this.questionFilter ? this.questionFilter.toJSON() : <any>undefined;
        data["advancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFilterModel {
    branchFilter?: BranchFilterModel | undefined;
    periodFilter?: PeriodFilterModel | undefined;
    customFilter?: CustomFilterModel | undefined;
    questionFilter?: QuestionFilterModel | undefined;
    advancedFilter?: AdvancedFilterModel | undefined;
}

export class BranchFilterModel implements IBranchFilterModel {
    branchGroupsIds?: string[] | undefined;
    branchIds?: string[] | undefined;

    constructor(data?: IBranchFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branchGroupsIds"])) {
                this.branchGroupsIds = [] as any;
                for (let item of _data["branchGroupsIds"])
                    this.branchGroupsIds!.push(item);
            }
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BranchFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branchGroupsIds)) {
            data["branchGroupsIds"] = [];
            for (let item of this.branchGroupsIds)
                data["branchGroupsIds"].push(item);
        }
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        return data;
    }
}

export interface IBranchFilterModel {
    branchGroupsIds?: string[] | undefined;
    branchIds?: string[] | undefined;
}

export class PeriodFilterModel implements IPeriodFilterModel {
    dateType?: DateType;
    timePeriod?: string;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IPeriodFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateType = _data["dateType"];
            this.timePeriod = _data["timePeriod"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PeriodFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateType"] = this.dateType;
        data["timePeriod"] = this.timePeriod;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPeriodFilterModel {
    dateType?: DateType;
    timePeriod?: string;
    startDate?: Date;
    endDate?: Date;
}

export enum DateType {
    Submitted = 0,
    Visit = 1,
}

export class CustomFilterModel implements ICustomFilterModel {
    customFilters?: { [key: string]: string[]; } | undefined;

    constructor(data?: ICustomFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["customFilters"]) {
                this.customFilters = {} as any;
                for (let key in _data["customFilters"]) {
                    if (_data["customFilters"].hasOwnProperty(key))
                        (<any>this.customFilters)![key] = _data["customFilters"][key] !== undefined ? _data["customFilters"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): CustomFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.customFilters) {
            data["customFilters"] = {};
            for (let key in this.customFilters) {
                if (this.customFilters.hasOwnProperty(key))
                    (<any>data["customFilters"])[key] = (<any>this.customFilters)[key];
            }
        }
        return data;
    }
}

export interface ICustomFilterModel {
    customFilters?: { [key: string]: string[]; } | undefined;
}

export class QuestionFilterModel implements IQuestionFilterModel {
    questionFilters?: { [key: string]: string[]; } | undefined;
    textQuestionFilters?: { [key: string]: string; } | undefined;
    matrixQuestionFilters?: { [key: string]: MatrixQuestionFilterModel[]; } | undefined;

    constructor(data?: IQuestionFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["questionFilters"]) {
                this.questionFilters = {} as any;
                for (let key in _data["questionFilters"]) {
                    if (_data["questionFilters"].hasOwnProperty(key))
                        (<any>this.questionFilters)![key] = _data["questionFilters"][key] !== undefined ? _data["questionFilters"][key] : [];
                }
            }
            if (_data["textQuestionFilters"]) {
                this.textQuestionFilters = {} as any;
                for (let key in _data["textQuestionFilters"]) {
                    if (_data["textQuestionFilters"].hasOwnProperty(key))
                        (<any>this.textQuestionFilters)![key] = _data["textQuestionFilters"][key];
                }
            }
            if (_data["matrixQuestionFilters"]) {
                this.matrixQuestionFilters = {} as any;
                for (let key in _data["matrixQuestionFilters"]) {
                    if (_data["matrixQuestionFilters"].hasOwnProperty(key))
                        (<any>this.matrixQuestionFilters)![key] = _data["matrixQuestionFilters"][key] ? _data["matrixQuestionFilters"][key].map((i: any) => MatrixQuestionFilterModel.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): QuestionFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.questionFilters) {
            data["questionFilters"] = {};
            for (let key in this.questionFilters) {
                if (this.questionFilters.hasOwnProperty(key))
                    (<any>data["questionFilters"])[key] = (<any>this.questionFilters)[key];
            }
        }
        if (this.textQuestionFilters) {
            data["textQuestionFilters"] = {};
            for (let key in this.textQuestionFilters) {
                if (this.textQuestionFilters.hasOwnProperty(key))
                    (<any>data["textQuestionFilters"])[key] = (<any>this.textQuestionFilters)[key];
            }
        }
        if (this.matrixQuestionFilters) {
            data["matrixQuestionFilters"] = {};
            for (let key in this.matrixQuestionFilters) {
                if (this.matrixQuestionFilters.hasOwnProperty(key))
                    (<any>data["matrixQuestionFilters"])[key] = (<any>this.matrixQuestionFilters)[key];
            }
        }
        return data;
    }
}

export interface IQuestionFilterModel {
    questionFilters?: { [key: string]: string[]; } | undefined;
    textQuestionFilters?: { [key: string]: string; } | undefined;
    matrixQuestionFilters?: { [key: string]: MatrixQuestionFilterModel[]; } | undefined;
}

export class MatrixQuestionFilterModel implements IMatrixQuestionFilterModel {
    option?: string | undefined;
    value?: string | undefined;

    constructor(data?: IMatrixQuestionFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.option = _data["option"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MatrixQuestionFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixQuestionFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["option"] = this.option;
        data["value"] = this.value;
        return data;
    }
}

export interface IMatrixQuestionFilterModel {
    option?: string | undefined;
    value?: string | undefined;
}

export class AdvancedFilterModel implements IAdvancedFilterModel {
    recommendationFilter?: RecommendationFilter | undefined;
    alertStatusFilter?: AlertStatusFilter | undefined;
    rangeFilters?: RangeFilterModel[] | undefined;
    categoryFilters?: CategoryFilterModel[] | undefined;

    constructor(data?: IAdvancedFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommendationFilter = _data["recommendationFilter"] ? RecommendationFilter.fromJS(_data["recommendationFilter"]) : <any>undefined;
            this.alertStatusFilter = _data["alertStatusFilter"] ? AlertStatusFilter.fromJS(_data["alertStatusFilter"]) : <any>undefined;
            if (Array.isArray(_data["rangeFilters"])) {
                this.rangeFilters = [] as any;
                for (let item of _data["rangeFilters"])
                    this.rangeFilters!.push(RangeFilterModel.fromJS(item));
            }
            if (Array.isArray(_data["categoryFilters"])) {
                this.categoryFilters = [] as any;
                for (let item of _data["categoryFilters"])
                    this.categoryFilters!.push(CategoryFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdvancedFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommendationFilter"] = this.recommendationFilter ? this.recommendationFilter.toJSON() : <any>undefined;
        data["alertStatusFilter"] = this.alertStatusFilter ? this.alertStatusFilter.toJSON() : <any>undefined;
        if (Array.isArray(this.rangeFilters)) {
            data["rangeFilters"] = [];
            for (let item of this.rangeFilters)
                data["rangeFilters"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryFilters)) {
            data["categoryFilters"] = [];
            for (let item of this.categoryFilters)
                data["categoryFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdvancedFilterModel {
    recommendationFilter?: RecommendationFilter | undefined;
    alertStatusFilter?: AlertStatusFilter | undefined;
    rangeFilters?: RangeFilterModel[] | undefined;
    categoryFilters?: CategoryFilterModel[] | undefined;
}

export class RecommendationFilter implements IRecommendationFilter {
    promoter?: boolean;
    passive?: boolean;
    detractor?: boolean;

    constructor(data?: IRecommendationFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promoter = _data["promoter"];
            this.passive = _data["passive"];
            this.detractor = _data["detractor"];
        }
    }

    static fromJS(data: any): RecommendationFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendationFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoter"] = this.promoter;
        data["passive"] = this.passive;
        data["detractor"] = this.detractor;
        return data;
    }
}

export interface IRecommendationFilter {
    promoter?: boolean;
    passive?: boolean;
    detractor?: boolean;
}

export class AlertStatusFilter implements IAlertStatusFilter {
    allStatus?: boolean;
    noAlerts?: boolean;
    toRead?: boolean;
    toSolve?: boolean;
    opened?: boolean;
    onHold?: boolean;
    wasRead?: boolean;
    solved?: boolean;
    closed?: boolean;
    forwarded?: boolean;

    constructor(data?: IAlertStatusFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allStatus = _data["allStatus"];
            this.noAlerts = _data["noAlerts"];
            this.toRead = _data["toRead"];
            this.toSolve = _data["toSolve"];
            this.opened = _data["opened"];
            this.onHold = _data["onHold"];
            this.wasRead = _data["wasRead"];
            this.solved = _data["solved"];
            this.closed = _data["closed"];
            this.forwarded = _data["forwarded"];
        }
    }

    static fromJS(data: any): AlertStatusFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AlertStatusFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allStatus"] = this.allStatus;
        data["noAlerts"] = this.noAlerts;
        data["toRead"] = this.toRead;
        data["toSolve"] = this.toSolve;
        data["opened"] = this.opened;
        data["onHold"] = this.onHold;
        data["wasRead"] = this.wasRead;
        data["solved"] = this.solved;
        data["closed"] = this.closed;
        data["forwarded"] = this.forwarded;
        return data;
    }
}

export interface IAlertStatusFilter {
    allStatus?: boolean;
    noAlerts?: boolean;
    toRead?: boolean;
    toSolve?: boolean;
    opened?: boolean;
    onHold?: boolean;
    wasRead?: boolean;
    solved?: boolean;
    closed?: boolean;
    forwarded?: boolean;
}

export class RangeFilterModel implements IRangeFilterModel {
    type?: RangeType;
    minimum?: number;
    maximum?: number;

    constructor(data?: IRangeFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
        }
    }

    static fromJS(data: any): RangeFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new RangeFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        return data;
    }
}

export interface IRangeFilterModel {
    type?: RangeType;
    minimum?: number;
    maximum?: number;
}

export enum RangeType {
    Nps = 0,
    General = 1,
}

export class CategoryFilterModel implements ICategoryFilterModel {
    code?: string | undefined;
    name?: string | undefined;
    minimum?: number;
    maximum?: number;

    constructor(data?: ICategoryFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
        }
    }

    static fromJS(data: any): CategoryFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        return data;
    }
}

export interface ICategoryFilterModel {
    code?: string | undefined;
    name?: string | undefined;
    minimum?: number;
    maximum?: number;
}

export class SortingModel implements ISortingModel {
    fieldName?: string;
    direction?: SortDirection2 | undefined;

    constructor(data?: ISortingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): SortingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SortingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["direction"] = this.direction;
        return data;
    }
}

export interface ISortingModel {
    fieldName?: string;
    direction?: SortDirection2 | undefined;
}

export enum SortDirection2 {
    Ascending = 0,
    Descending = 1,
}

export enum TableLevel {
    BranchGroup = 1,
    Branch = 2,
    Surveys = 3,
    Country = 4,
    Province = 5,
    Locality = 6,
}

export class GetSatisfactionRateResponse implements IGetSatisfactionRateResponse {
    generalSatisfaction?: SatisfactionRateGeneralSatisfactionDto;
    horizontalChartData?: SatisfactionRateHorizontalChartDto[];

    constructor(data?: IGetSatisfactionRateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalSatisfaction = _data["generalSatisfaction"] ? SatisfactionRateGeneralSatisfactionDto.fromJS(_data["generalSatisfaction"]) : <any>undefined;
            if (Array.isArray(_data["horizontalChartData"])) {
                this.horizontalChartData = [] as any;
                for (let item of _data["horizontalChartData"])
                    this.horizontalChartData!.push(SatisfactionRateHorizontalChartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSatisfactionRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSatisfactionRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalSatisfaction"] = this.generalSatisfaction ? this.generalSatisfaction.toJSON() : <any>undefined;
        if (Array.isArray(this.horizontalChartData)) {
            data["horizontalChartData"] = [];
            for (let item of this.horizontalChartData)
                data["horizontalChartData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSatisfactionRateResponse {
    generalSatisfaction?: SatisfactionRateGeneralSatisfactionDto;
    horizontalChartData?: SatisfactionRateHorizontalChartDto[];
}

export class SatisfactionRateGeneralSatisfactionDto implements ISatisfactionRateGeneralSatisfactionDto {
    totalCount?: number | undefined;
    value?: number | undefined;
    variance?: string | undefined;

    constructor(data?: ISatisfactionRateGeneralSatisfactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.value = _data["value"];
            this.variance = _data["variance"];
        }
    }

    static fromJS(data: any): SatisfactionRateGeneralSatisfactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SatisfactionRateGeneralSatisfactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["value"] = this.value;
        data["variance"] = this.variance;
        return data;
    }
}

export interface ISatisfactionRateGeneralSatisfactionDto {
    totalCount?: number | undefined;
    value?: number | undefined;
    variance?: string | undefined;
}

export class SatisfactionRateHorizontalChartDto implements ISatisfactionRateHorizontalChartDto {
    label?: string | undefined;
    value?: number | undefined;
    variance?: string | undefined;

    constructor(data?: ISatisfactionRateHorizontalChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.variance = _data["variance"];
        }
    }

    static fromJS(data: any): SatisfactionRateHorizontalChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new SatisfactionRateHorizontalChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["variance"] = this.variance;
        return data;
    }
}

export interface ISatisfactionRateHorizontalChartDto {
    label?: string | undefined;
    value?: number | undefined;
    variance?: string | undefined;
}

export class GetSentimentTrendsResponse implements IGetSentimentTrendsResponse {
    series?: SentimentTrendsLineDto[];

    constructor(data?: IGetSentimentTrendsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(SentimentTrendsLineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSentimentTrendsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSentimentTrendsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSentimentTrendsResponse {
    series?: SentimentTrendsLineDto[];
}

export class SentimentTrendsLineDto implements ISentimentTrendsLineDto {
    name?: string | undefined;
    values?: SentimentTrendsPointDto[];

    constructor(data?: ISentimentTrendsLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(SentimentTrendsPointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SentimentTrendsLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new SentimentTrendsLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISentimentTrendsLineDto {
    name?: string | undefined;
    values?: SentimentTrendsPointDto[];
}

export class SentimentTrendsPointDto implements ISentimentTrendsPointDto {
    date?: Date | undefined;
    value?: number | undefined;

    constructor(data?: ISentimentTrendsPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SentimentTrendsPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new SentimentTrendsPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ISentimentTrendsPointDto {
    date?: Date | undefined;
    value?: number | undefined;
}

export class Top5CommentsResponse implements ITop5CommentsResponse {
    serie?: Top5Comment[];

    constructor(data?: ITop5CommentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serie"])) {
                this.serie = [] as any;
                for (let item of _data["serie"])
                    this.serie!.push(Top5Comment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Top5CommentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Top5CommentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serie)) {
            data["serie"] = [];
            for (let item of this.serie)
                data["serie"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITop5CommentsResponse {
    serie?: Top5Comment[];
}

export class Top5Comment implements ITop5Comment {
    name?: string | undefined;
    label?: string | undefined;
    color?: string | undefined;
    value?: number | undefined;

    constructor(data?: ITop5Comment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"];
            this.color = _data["color"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Top5Comment {
        data = typeof data === 'object' ? data : {};
        let result = new Top5Comment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label;
        data["color"] = this.color;
        data["value"] = this.value;
        return data;
    }
}

export interface ITop5Comment {
    name?: string | undefined;
    label?: string | undefined;
    color?: string | undefined;
    value?: number | undefined;
}

export class StrengthsAndWeaknessesResponse implements IStrengthsAndWeaknessesResponse {
    bestPerformance?: PerformanceDto[];
    worstPerformance?: PerformanceDto[];

    constructor(data?: IStrengthsAndWeaknessesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bestPerformance"])) {
                this.bestPerformance = [] as any;
                for (let item of _data["bestPerformance"])
                    this.bestPerformance!.push(PerformanceDto.fromJS(item));
            }
            if (Array.isArray(_data["worstPerformance"])) {
                this.worstPerformance = [] as any;
                for (let item of _data["worstPerformance"])
                    this.worstPerformance!.push(PerformanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StrengthsAndWeaknessesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StrengthsAndWeaknessesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bestPerformance)) {
            data["bestPerformance"] = [];
            for (let item of this.bestPerformance)
                data["bestPerformance"].push(item.toJSON());
        }
        if (Array.isArray(this.worstPerformance)) {
            data["worstPerformance"] = [];
            for (let item of this.worstPerformance)
                data["worstPerformance"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStrengthsAndWeaknessesResponse {
    bestPerformance?: PerformanceDto[];
    worstPerformance?: PerformanceDto[];
}

export class PerformanceDto implements IPerformanceDto {
    category?: string | undefined;
    subject?: string | undefined;
    successRate?: number | undefined;
    gap?: number | undefined;

    constructor(data?: IPerformanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.subject = _data["subject"];
            this.successRate = _data["successRate"];
            this.gap = _data["gap"];
        }
    }

    static fromJS(data: any): PerformanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["subject"] = this.subject;
        data["successRate"] = this.successRate;
        data["gap"] = this.gap;
        return data;
    }
}

export interface IPerformanceDto {
    category?: string | undefined;
    subject?: string | undefined;
    successRate?: number | undefined;
    gap?: number | undefined;
}

export class SentimentsByCategoryResponse implements ISentimentsByCategoryResponse {
    data?: { [key: string]: { [key: string]: { [key: string]: any; }; }; };

    constructor(data?: ISentimentsByCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key] !== undefined ? _data["data"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): SentimentsByCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SentimentsByCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        return data;
    }
}

export interface ISentimentsByCategoryResponse {
    data?: { [key: string]: { [key: string]: { [key: string]: any; }; }; };
}

export class RecommendationCommentsResponse implements IRecommendationCommentsResponse {
    totalComments?: number;
    comments?: RecommendationComment[];

    constructor(data?: IRecommendationCommentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalComments = _data["totalComments"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(RecommendationComment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RecommendationCommentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendationCommentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalComments"] = this.totalComments;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRecommendationCommentsResponse {
    totalComments?: number;
    comments?: RecommendationComment[];
}

export class RecommendationComment implements IRecommendationComment {
    comment?: string | undefined;
    date?: string | undefined;
    name?: string | undefined;
    type?: number;

    constructor(data?: IRecommendationComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.date = _data["date"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RecommendationComment {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendationComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["date"] = this.date;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IRecommendationComment {
    comment?: string | undefined;
    date?: string | undefined;
    name?: string | undefined;
    type?: number;
}

export class GetSummaryResponse implements IGetSummaryResponse {
    generalSatisfaction?: number | undefined;
    topics?: TopicDto[];

    constructor(data?: IGetSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalSatisfaction = _data["generalSatisfaction"];
            if (Array.isArray(_data["topics"])) {
                this.topics = [] as any;
                for (let item of _data["topics"])
                    this.topics!.push(TopicDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalSatisfaction"] = this.generalSatisfaction;
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSummaryResponse {
    generalSatisfaction?: number | undefined;
    topics?: TopicDto[];
}

export class TopicDto implements ITopicDto {
    name?: string;
    sentimentScore?: number | undefined;

    constructor(data?: ITopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sentimentScore = _data["sentimentScore"];
        }
    }

    static fromJS(data: any): TopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sentimentScore"] = this.sentimentScore;
        return data;
    }
}

export interface ITopicDto {
    name?: string;
    sentimentScore?: number | undefined;
}

export class AnalysisTopicsResponse implements IAnalysisTopicsResponse {
    topics?: AnalysisTopicDto[];

    constructor(data?: IAnalysisTopicsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["topics"])) {
                this.topics = [] as any;
                for (let item of _data["topics"])
                    this.topics!.push(AnalysisTopicDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalysisTopicsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisTopicsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnalysisTopicsResponse {
    topics?: AnalysisTopicDto[];
}

export class AnalysisTopicDto implements IAnalysisTopicDto {
    name?: string;
    sentimentScore?: number | undefined;
    topics?: AnalysisSubTopicDto[];

    constructor(data?: IAnalysisTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sentimentScore = _data["sentimentScore"];
            if (Array.isArray(_data["topics"])) {
                this.topics = [] as any;
                for (let item of _data["topics"])
                    this.topics!.push(AnalysisSubTopicDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalysisTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sentimentScore"] = this.sentimentScore;
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnalysisTopicDto {
    name?: string;
    sentimentScore?: number | undefined;
    topics?: AnalysisSubTopicDto[];
}

export class AnalysisSubTopicDto implements IAnalysisSubTopicDto {
    label?: string;
    value?: number | undefined;

    constructor(data?: IAnalysisSubTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AnalysisSubTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisSubTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IAnalysisSubTopicDto {
    label?: string;
    value?: number | undefined;
}

export class GetResultsResponse implements IGetResultsResponse {
    totalCount?: number;
    analyses?: AnalysisDto[];

    constructor(data?: IGetResultsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["analyses"])) {
                this.analyses = [] as any;
                for (let item of _data["analyses"])
                    this.analyses!.push(AnalysisDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetResultsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResultsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.analyses)) {
            data["analyses"] = [];
            for (let item of this.analyses)
                data["analyses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetResultsResponse {
    totalCount?: number;
    analyses?: AnalysisDto[];
}

export class AnalysisDto implements IAnalysisDto {
    questionName?: string | undefined;
    questionText?: string | undefined;
    comment?: string | undefined;
    submittedDate?: Date | undefined;
    clientName?: string | undefined;
    branchName?: string | undefined;
    topics?: AnalysisTopicDto2[];

    constructor(data?: IAnalysisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionName = _data["questionName"];
            this.questionText = _data["questionText"];
            this.comment = _data["comment"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.clientName = _data["clientName"];
            this.branchName = _data["branchName"];
            if (Array.isArray(_data["topics"])) {
                this.topics = [] as any;
                for (let item of _data["topics"])
                    this.topics!.push(AnalysisTopicDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalysisDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionName"] = this.questionName;
        data["questionText"] = this.questionText;
        data["comment"] = this.comment;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["clientName"] = this.clientName;
        data["branchName"] = this.branchName;
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnalysisDto {
    questionName?: string | undefined;
    questionText?: string | undefined;
    comment?: string | undefined;
    submittedDate?: Date | undefined;
    clientName?: string | undefined;
    branchName?: string | undefined;
    topics?: AnalysisTopicDto2[];
}

export class AnalysisTopicDto2 implements IAnalysisTopicDto2 {
    topic?: string | undefined;
    sentimentScore?: number | undefined;
    subTopics?: AnalysisTopicDto2[];

    constructor(data?: IAnalysisTopicDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topic = _data["topic"];
            this.sentimentScore = _data["sentimentScore"];
            if (Array.isArray(_data["subTopics"])) {
                this.subTopics = [] as any;
                for (let item of _data["subTopics"])
                    this.subTopics!.push(AnalysisTopicDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalysisTopicDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisTopicDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topic"] = this.topic;
        data["sentimentScore"] = this.sentimentScore;
        if (Array.isArray(this.subTopics)) {
            data["subTopics"] = [];
            for (let item of this.subTopics)
                data["subTopics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnalysisTopicDto2 {
    topic?: string | undefined;
    sentimentScore?: number | undefined;
    subTopics?: AnalysisTopicDto2[];
}

export class SurveyAnswerDateRangeViewModel implements ISurveyAnswerDateRangeViewModel {
    surveryAnswerDateRangeDto?: SurveyAnswerDateRangeDto;
    dates?: Date[];

    constructor(data?: ISurveyAnswerDateRangeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveryAnswerDateRangeDto = _data["surveryAnswerDateRangeDto"] ? SurveyAnswerDateRangeDto.fromJS(_data["surveryAnswerDateRangeDto"]) : <any>undefined;
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(new Date(item));
            }
        }
    }

    static fromJS(data: any): SurveyAnswerDateRangeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerDateRangeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveryAnswerDateRangeDto"] = this.surveryAnswerDateRangeDto ? this.surveryAnswerDateRangeDto.toJSON() : <any>undefined;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item.toISOString());
        }
        return data;
    }
}

export interface ISurveyAnswerDateRangeViewModel {
    surveryAnswerDateRangeDto?: SurveyAnswerDateRangeDto;
    dates?: Date[];
}

export class SurveyAnswerDateRangeDto implements ISurveyAnswerDateRangeDto {
    label?: string;
    earliest?: Date | undefined;
    latest?: Date | undefined;
    dateType?: DateType;

    constructor(data?: ISurveyAnswerDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.earliest = _data["earliest"] ? new Date(_data["earliest"].toString()) : <any>undefined;
            this.latest = _data["latest"] ? new Date(_data["latest"].toString()) : <any>undefined;
            this.dateType = _data["dateType"];
        }
    }

    static fromJS(data: any): SurveyAnswerDateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerDateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["earliest"] = this.earliest ? this.earliest.toISOString() : <any>undefined;
        data["latest"] = this.latest ? this.latest.toISOString() : <any>undefined;
        data["dateType"] = this.dateType;
        return data;
    }
}

export interface ISurveyAnswerDateRangeDto {
    label?: string;
    earliest?: Date | undefined;
    latest?: Date | undefined;
    dateType?: DateType;
}

export class SummaryViewModel implements ISummaryViewModel {
    summaryGeneralModelDto?: SummaryGeneralModelDto;
    summaryCategoriesModelDto?: SummaryCategoriesModelDto | undefined;

    constructor(data?: ISummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summaryGeneralModelDto = _data["summaryGeneralModelDto"] ? SummaryGeneralModelDto.fromJS(_data["summaryGeneralModelDto"]) : <any>undefined;
            this.summaryCategoriesModelDto = _data["summaryCategoriesModelDto"] ? SummaryCategoriesModelDto.fromJS(_data["summaryCategoriesModelDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summaryGeneralModelDto"] = this.summaryGeneralModelDto ? this.summaryGeneralModelDto.toJSON() : <any>undefined;
        data["summaryCategoriesModelDto"] = this.summaryCategoriesModelDto ? this.summaryCategoriesModelDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISummaryViewModel {
    summaryGeneralModelDto?: SummaryGeneralModelDto;
    summaryCategoriesModelDto?: SummaryCategoriesModelDto | undefined;
}

export class SummaryGeneralModelDto implements ISummaryGeneralModelDto {
    surveys?: number;
    alerts?: number;
    activeAlerts?: number;
    alertsRate?: number;
    nps?: number | undefined;
    promotersPerc?: number | undefined;
    passivesPerc?: number | undefined;
    detractorsPerc?: number | undefined;
    generalSatisfaction?: number;

    constructor(data?: ISummaryGeneralModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveys = _data["surveys"];
            this.alerts = _data["alerts"];
            this.activeAlerts = _data["activeAlerts"];
            this.alertsRate = _data["alertsRate"];
            this.nps = _data["nps"];
            this.promotersPerc = _data["promotersPerc"];
            this.passivesPerc = _data["passivesPerc"];
            this.detractorsPerc = _data["detractorsPerc"];
            this.generalSatisfaction = _data["generalSatisfaction"];
        }
    }

    static fromJS(data: any): SummaryGeneralModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryGeneralModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveys"] = this.surveys;
        data["alerts"] = this.alerts;
        data["activeAlerts"] = this.activeAlerts;
        data["alertsRate"] = this.alertsRate;
        data["nps"] = this.nps;
        data["promotersPerc"] = this.promotersPerc;
        data["passivesPerc"] = this.passivesPerc;
        data["detractorsPerc"] = this.detractorsPerc;
        data["generalSatisfaction"] = this.generalSatisfaction;
        return data;
    }
}

export interface ISummaryGeneralModelDto {
    surveys?: number;
    alerts?: number;
    activeAlerts?: number;
    alertsRate?: number;
    nps?: number | undefined;
    promotersPerc?: number | undefined;
    passivesPerc?: number | undefined;
    detractorsPerc?: number | undefined;
    generalSatisfaction?: number;
}

export class SummaryCategoriesModelDto implements ISummaryCategoriesModelDto {
    totalCount?: number;
    categoriesJson?: string | undefined;
    categories?: AnswerCategory[] | undefined;

    constructor(data?: ISummaryCategoriesModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.categoriesJson = _data["categoriesJson"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(AnswerCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SummaryCategoriesModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryCategoriesModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["categoriesJson"] = this.categoriesJson;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISummaryCategoriesModelDto {
    totalCount?: number;
    categoriesJson?: string | undefined;
    categories?: AnswerCategory[] | undefined;
}

export class AnswerCategory implements IAnswerCategory {
    code?: string | undefined;
    name?: string | undefined;
    order?: number | undefined;
    percentage?: number | undefined;

    constructor(data?: IAnswerCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): AnswerCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["order"] = this.order;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IAnswerCategory {
    code?: string | undefined;
    name?: string | undefined;
    order?: number | undefined;
    percentage?: number | undefined;
}

export class SummaryAlertsViewModel implements ISummaryAlertsViewModel {
    alertSummaryWidget?: AlertsSummaryWidget;

    constructor(data?: ISummaryAlertsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertSummaryWidget = _data["alertSummaryWidget"] ? AlertsSummaryWidget.fromJS(_data["alertSummaryWidget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SummaryAlertsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryAlertsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertSummaryWidget"] = this.alertSummaryWidget ? this.alertSummaryWidget.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISummaryAlertsViewModel {
    alertSummaryWidget?: AlertsSummaryWidget;
}

export class AlertsSummaryWidget implements IAlertsSummaryWidget {
    totalAlerts?: number;
    pendingTotal?: number;
    treatedTotal?: number;
    toSolve?: number;
    solved?: number;
    onHold?: number;
    opened?: number;
    forwarded?: number;
    toRead?: number;
    read?: number;
    pendingTimeToOpen?: number;
    pendingTimeToContact?: number;
    treatedTimeToOpen?: number;
    treatedTimeToSolve?: number;

    constructor(data?: IAlertsSummaryWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAlerts = _data["totalAlerts"];
            this.pendingTotal = _data["pendingTotal"];
            this.treatedTotal = _data["treatedTotal"];
            this.toSolve = _data["toSolve"];
            this.solved = _data["solved"];
            this.onHold = _data["onHold"];
            this.opened = _data["opened"];
            this.forwarded = _data["forwarded"];
            this.toRead = _data["toRead"];
            this.read = _data["read"];
            this.pendingTimeToOpen = _data["pendingTimeToOpen"];
            this.pendingTimeToContact = _data["pendingTimeToContact"];
            this.treatedTimeToOpen = _data["treatedTimeToOpen"];
            this.treatedTimeToSolve = _data["treatedTimeToSolve"];
        }
    }

    static fromJS(data: any): AlertsSummaryWidget {
        data = typeof data === 'object' ? data : {};
        let result = new AlertsSummaryWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAlerts"] = this.totalAlerts;
        data["pendingTotal"] = this.pendingTotal;
        data["treatedTotal"] = this.treatedTotal;
        data["toSolve"] = this.toSolve;
        data["solved"] = this.solved;
        data["onHold"] = this.onHold;
        data["opened"] = this.opened;
        data["forwarded"] = this.forwarded;
        data["toRead"] = this.toRead;
        data["read"] = this.read;
        data["pendingTimeToOpen"] = this.pendingTimeToOpen;
        data["pendingTimeToContact"] = this.pendingTimeToContact;
        data["treatedTimeToOpen"] = this.treatedTimeToOpen;
        data["treatedTimeToSolve"] = this.treatedTimeToSolve;
        return data;
    }
}

export interface IAlertsSummaryWidget {
    totalAlerts?: number;
    pendingTotal?: number;
    treatedTotal?: number;
    toSolve?: number;
    solved?: number;
    onHold?: number;
    opened?: number;
    forwarded?: number;
    toRead?: number;
    read?: number;
    pendingTimeToOpen?: number;
    pendingTimeToContact?: number;
    treatedTimeToOpen?: number;
    treatedTimeToSolve?: number;
}

export class DetailsByCountryViewModel implements IDetailsByCountryViewModel {
    headerNames?: string[];
    values?: any[][];
    branchIds?: string[];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;

    constructor(data?: IDetailsByCountryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headerNames"])) {
                this.headerNames = [] as any;
                for (let item of _data["headerNames"])
                    this.headerNames!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DetailsByCountryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DetailsByCountryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headerNames)) {
            data["headerNames"] = [];
            for (let item of this.headerNames)
                data["headerNames"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IDetailsByCountryViewModel {
    headerNames?: string[];
    values?: any[][];
    branchIds?: string[];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;
}

export class DetailsByProvinceViewModel implements IDetailsByProvinceViewModel {
    headerNames?: string[];
    values?: any[][];
    branchIds?: string[];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;

    constructor(data?: IDetailsByProvinceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headerNames"])) {
                this.headerNames = [] as any;
                for (let item of _data["headerNames"])
                    this.headerNames!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DetailsByProvinceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DetailsByProvinceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headerNames)) {
            data["headerNames"] = [];
            for (let item of this.headerNames)
                data["headerNames"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IDetailsByProvinceViewModel {
    headerNames?: string[];
    values?: any[][];
    branchIds?: string[];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;
}

export class DetailsByLocalityViewModel implements IDetailsByLocalityViewModel {
    headerNames?: string[];
    values?: any[][];
    branchIds?: string[];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;

    constructor(data?: IDetailsByLocalityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headerNames"])) {
                this.headerNames = [] as any;
                for (let item of _data["headerNames"])
                    this.headerNames!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DetailsByLocalityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DetailsByLocalityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headerNames)) {
            data["headerNames"] = [];
            for (let item of this.headerNames)
                data["headerNames"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IDetailsByLocalityViewModel {
    headerNames?: string[];
    values?: any[][];
    branchIds?: string[];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;
}

export class DetailsByBranchGroupViewModel implements IDetailsByBranchGroupViewModel {
    headerNames?: string[];
    values?: any[][];
    branchIds?: string[];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;

    constructor(data?: IDetailsByBranchGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headerNames"])) {
                this.headerNames = [] as any;
                for (let item of _data["headerNames"])
                    this.headerNames!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DetailsByBranchGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DetailsByBranchGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headerNames)) {
            data["headerNames"] = [];
            for (let item of this.headerNames)
                data["headerNames"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IDetailsByBranchGroupViewModel {
    headerNames?: string[];
    values?: any[][];
    branchIds?: string[];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;
}

export class DetailsByBranchViewModel implements IDetailsByBranchViewModel {
    headerNames?: string[];
    values?: any[][];
    branchIds?: string[];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;

    constructor(data?: IDetailsByBranchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headerNames"])) {
                this.headerNames = [] as any;
                for (let item of _data["headerNames"])
                    this.headerNames!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DetailsByBranchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DetailsByBranchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headerNames)) {
            data["headerNames"] = [];
            for (let item of this.headerNames)
                data["headerNames"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IDetailsByBranchViewModel {
    headerNames?: string[];
    values?: any[][];
    branchIds?: string[];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;
}

export class AllDetailedViewModel implements IAllDetailedViewModel {
    headerNames?: string[];
    values?: any[][];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;

    constructor(data?: IAllDetailedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headerNames"])) {
                this.headerNames = [] as any;
                for (let item of _data["headerNames"])
                    this.headerNames!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AllDetailedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllDetailedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headerNames)) {
            data["headerNames"] = [];
            for (let item of this.headerNames)
                data["headerNames"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IAllDetailedViewModel {
    headerNames?: string[];
    values?: any[][];
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;
}

export class CategoriesViewModel implements ICategoriesViewModel {
    categories?: CategoryDto[] | undefined;

    constructor(data?: ICategoriesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoriesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoriesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoriesViewModel {
    categories?: CategoryDto[] | undefined;
}

export class CategoryDto implements ICategoryDto {
    id?: string;
    shortName?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortName = _data["shortName"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortName"] = this.shortName;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface ICategoryDto {
    id?: string;
    shortName?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
}

export class CustomFiltersViewModel implements ICustomFiltersViewModel {
    questionsToShow?: QuestionDetailsModel[] | undefined;

    constructor(data?: ICustomFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questionsToShow"])) {
                this.questionsToShow = [] as any;
                for (let item of _data["questionsToShow"])
                    this.questionsToShow!.push(QuestionDetailsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questionsToShow)) {
            data["questionsToShow"] = [];
            for (let item of this.questionsToShow)
                data["questionsToShow"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomFiltersViewModel {
    questionsToShow?: QuestionDetailsModel[] | undefined;
}

export class QuestionDetailsModel implements IQuestionDetailsModel {
    questionName?: string | undefined;
    shortNames?: QuestionShortName[] | undefined;
    choices?: QuestionChoices[] | undefined;

    constructor(data?: IQuestionDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionName = _data["questionName"];
            if (Array.isArray(_data["shortNames"])) {
                this.shortNames = [] as any;
                for (let item of _data["shortNames"])
                    this.shortNames!.push(QuestionShortName.fromJS(item));
            }
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(QuestionChoices.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionName"] = this.questionName;
        if (Array.isArray(this.shortNames)) {
            data["shortNames"] = [];
            for (let item of this.shortNames)
                data["shortNames"].push(item.toJSON());
        }
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionDetailsModel {
    questionName?: string | undefined;
    shortNames?: QuestionShortName[] | undefined;
    choices?: QuestionChoices[] | undefined;
}

export class QuestionShortName implements IQuestionShortName {
    lang?: string | undefined;
    value?: QuestionShortNameValues | undefined;

    constructor(data?: IQuestionShortName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lang = _data["lang"];
            this.value = _data["value"] ? QuestionShortNameValues.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionShortName {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionShortName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lang"] = this.lang;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuestionShortName {
    lang?: string | undefined;
    value?: QuestionShortNameValues | undefined;
}

export class QuestionShortNameValues implements IQuestionShortNameValues {
    shortText?: string | undefined;
    longText?: string | undefined;

    constructor(data?: IQuestionShortNameValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortText = _data["shortText"];
            this.longText = _data["longText"];
        }
    }

    static fromJS(data: any): QuestionShortNameValues {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionShortNameValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortText"] = this.shortText;
        data["longText"] = this.longText;
        return data;
    }
}

export interface IQuestionShortNameValues {
    shortText?: string | undefined;
    longText?: string | undefined;
}

export class QuestionChoices implements IQuestionChoices {
    value?: string | undefined;
    text?: QuestionChoicesText | undefined;

    constructor(data?: IQuestionChoices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"] ? QuestionChoicesText.fromJS(_data["text"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionChoices {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionChoices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text ? this.text.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuestionChoices {
    value?: string | undefined;
    text?: QuestionChoicesText | undefined;
}

export class QuestionChoicesText implements IQuestionChoicesText {
    fr?: string | undefined;
    default?: string | undefined;

    constructor(data?: IQuestionChoicesText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fr = _data["fr"];
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): QuestionChoicesText {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionChoicesText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fr"] = this.fr;
        data["default"] = this.default;
        return data;
    }
}

export interface IQuestionChoicesText {
    fr?: string | undefined;
    default?: string | undefined;
}

export class QuestionFiltersViewModel implements IQuestionFiltersViewModel {
    selectionQuestionsToReturn?: SelectionQuestionViewModel[] | undefined;
    sliderQuestionsToReturn?: SliderQuestionViewModel[] | undefined;
    matrixQuestionsToReturn?: MatrixQuestionViewModel[] | undefined;
    textQuestionsToReturn?: TextQuestionViewModel[] | undefined;

    constructor(data?: IQuestionFiltersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectionQuestionsToReturn"])) {
                this.selectionQuestionsToReturn = [] as any;
                for (let item of _data["selectionQuestionsToReturn"])
                    this.selectionQuestionsToReturn!.push(SelectionQuestionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["sliderQuestionsToReturn"])) {
                this.sliderQuestionsToReturn = [] as any;
                for (let item of _data["sliderQuestionsToReturn"])
                    this.sliderQuestionsToReturn!.push(SliderQuestionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["matrixQuestionsToReturn"])) {
                this.matrixQuestionsToReturn = [] as any;
                for (let item of _data["matrixQuestionsToReturn"])
                    this.matrixQuestionsToReturn!.push(MatrixQuestionViewModel.fromJS(item));
            }
            if (Array.isArray(_data["textQuestionsToReturn"])) {
                this.textQuestionsToReturn = [] as any;
                for (let item of _data["textQuestionsToReturn"])
                    this.textQuestionsToReturn!.push(TextQuestionViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionFiltersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionFiltersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectionQuestionsToReturn)) {
            data["selectionQuestionsToReturn"] = [];
            for (let item of this.selectionQuestionsToReturn)
                data["selectionQuestionsToReturn"].push(item.toJSON());
        }
        if (Array.isArray(this.sliderQuestionsToReturn)) {
            data["sliderQuestionsToReturn"] = [];
            for (let item of this.sliderQuestionsToReturn)
                data["sliderQuestionsToReturn"].push(item.toJSON());
        }
        if (Array.isArray(this.matrixQuestionsToReturn)) {
            data["matrixQuestionsToReturn"] = [];
            for (let item of this.matrixQuestionsToReturn)
                data["matrixQuestionsToReturn"].push(item.toJSON());
        }
        if (Array.isArray(this.textQuestionsToReturn)) {
            data["textQuestionsToReturn"] = [];
            for (let item of this.textQuestionsToReturn)
                data["textQuestionsToReturn"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionFiltersViewModel {
    selectionQuestionsToReturn?: SelectionQuestionViewModel[] | undefined;
    sliderQuestionsToReturn?: SliderQuestionViewModel[] | undefined;
    matrixQuestionsToReturn?: MatrixQuestionViewModel[] | undefined;
    textQuestionsToReturn?: TextQuestionViewModel[] | undefined;
}

export class SelectionQuestionViewModel implements ISelectionQuestionViewModel {
    order?: number;
    name?: string | undefined;
    title?: string | undefined;
    fromOldForm?: boolean;
    choices?: SelectChoice[] | undefined;

    constructor(data?: ISelectionQuestionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.fromOldForm = _data["fromOldForm"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(SelectChoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectionQuestionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionQuestionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["title"] = this.title;
        data["fromOldForm"] = this.fromOldForm;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISelectionQuestionViewModel {
    order?: number;
    name?: string | undefined;
    title?: string | undefined;
    fromOldForm?: boolean;
    choices?: SelectChoice[] | undefined;
}

export class SelectChoice implements ISelectChoice {
    text?: string | undefined;
    value?: string | undefined;
    fromOldForm?: boolean;

    constructor(data?: ISelectChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
            this.fromOldForm = _data["fromOldForm"];
        }
    }

    static fromJS(data: any): SelectChoice {
        data = typeof data === 'object' ? data : {};
        let result = new SelectChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        data["fromOldForm"] = this.fromOldForm;
        return data;
    }
}

export interface ISelectChoice {
    text?: string | undefined;
    value?: string | undefined;
    fromOldForm?: boolean;
}

export class SliderQuestionViewModel implements ISliderQuestionViewModel {
    order?: number;
    name?: string | undefined;
    title?: string | undefined;
    fromOldForm?: boolean;
    choices?: SliderChoice[] | undefined;

    constructor(data?: ISliderQuestionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.fromOldForm = _data["fromOldForm"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(SliderChoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SliderQuestionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SliderQuestionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["title"] = this.title;
        data["fromOldForm"] = this.fromOldForm;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISliderQuestionViewModel {
    order?: number;
    name?: string | undefined;
    title?: string | undefined;
    fromOldForm?: boolean;
    choices?: SliderChoice[] | undefined;
}

export class SliderChoice implements ISliderChoice {
    text?: string | undefined;
    value?: string | undefined;
    fromOldForm?: boolean;
    order?: number;

    constructor(data?: ISliderChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
            this.fromOldForm = _data["fromOldForm"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): SliderChoice {
        data = typeof data === 'object' ? data : {};
        let result = new SliderChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        data["fromOldForm"] = this.fromOldForm;
        data["order"] = this.order;
        return data;
    }
}

export interface ISliderChoice {
    text?: string | undefined;
    value?: string | undefined;
    fromOldForm?: boolean;
    order?: number;
}

export class MatrixQuestionViewModel implements IMatrixQuestionViewModel {
    order?: number;
    name?: string | undefined;
    title?: string | undefined;
    fromOldForm?: boolean;
    columns?: MatrixCell[] | undefined;
    rows?: MatrixCell[] | undefined;

    constructor(data?: IMatrixQuestionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.fromOldForm = _data["fromOldForm"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(MatrixCell.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MatrixCell.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MatrixQuestionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixQuestionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["title"] = this.title;
        data["fromOldForm"] = this.fromOldForm;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMatrixQuestionViewModel {
    order?: number;
    name?: string | undefined;
    title?: string | undefined;
    fromOldForm?: boolean;
    columns?: MatrixCell[] | undefined;
    rows?: MatrixCell[] | undefined;
}

export class MatrixCell implements IMatrixCell {
    text?: string | undefined;
    value?: string | undefined;
    fromOldForm?: boolean;

    constructor(data?: IMatrixCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
            this.fromOldForm = _data["fromOldForm"];
        }
    }

    static fromJS(data: any): MatrixCell {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        data["fromOldForm"] = this.fromOldForm;
        return data;
    }
}

export interface IMatrixCell {
    text?: string | undefined;
    value?: string | undefined;
    fromOldForm?: boolean;
}

export class TextQuestionViewModel implements ITextQuestionViewModel {
    order?: number;
    name?: string | undefined;
    title?: string | undefined;
    fromOldForm?: boolean;

    constructor(data?: ITextQuestionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.fromOldForm = _data["fromOldForm"];
        }
    }

    static fromJS(data: any): TextQuestionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TextQuestionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["title"] = this.title;
        data["fromOldForm"] = this.fromOldForm;
        return data;
    }
}

export interface ITextQuestionViewModel {
    order?: number;
    name?: string | undefined;
    title?: string | undefined;
    fromOldForm?: boolean;
}

export class GetFlowByIdModel implements IGetFlowByIdModel {
    id?: string;
    sourceId?: string | undefined;
    flowJson?: string | undefined;

    constructor(data?: IGetFlowByIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.flowJson = _data["flowJson"];
        }
    }

    static fromJS(data: any): GetFlowByIdModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlowByIdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["flowJson"] = this.flowJson;
        return data;
    }
}

export interface IGetFlowByIdModel {
    id?: string;
    sourceId?: string | undefined;
    flowJson?: string | undefined;
}

export class CreateFlowViewModel implements ICreateFlowViewModel {
    id?: string;

    constructor(data?: ICreateFlowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateFlowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFlowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateFlowViewModel {
    id?: string;
}

export class CreateFlowCommandDto implements ICreateFlowCommandDto {
    sourceId?: string | undefined;
    flowJson?: string | undefined;

    constructor(data?: ICreateFlowCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.flowJson = _data["flowJson"];
        }
    }

    static fromJS(data: any): CreateFlowCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFlowCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["flowJson"] = this.flowJson;
        return data;
    }
}

export interface ICreateFlowCommandDto {
    sourceId?: string | undefined;
    flowJson?: string | undefined;
}

export class UpdateFlowViewModel implements IUpdateFlowViewModel {
    id?: string;

    constructor(data?: IUpdateFlowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFlowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFlowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateFlowViewModel {
    id?: string;
}

export class UpdateFlowCommandDto implements IUpdateFlowCommandDto {
    id?: string;
    sourceId?: string | undefined;
    flowJson?: string | undefined;

    constructor(data?: IUpdateFlowCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.flowJson = _data["flowJson"];
        }
    }

    static fromJS(data: any): UpdateFlowCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFlowCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["flowJson"] = this.flowJson;
        return data;
    }
}

export interface IUpdateFlowCommandDto {
    id?: string;
    sourceId?: string | undefined;
    flowJson?: string | undefined;
}

export class DeleteFlowViewModel implements IDeleteFlowViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteFlowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteFlowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFlowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteFlowViewModel {
    id?: string | undefined;
}

export class GetFormByIdViewModel implements IGetFormByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    projectId?: string;
    name?: string | undefined;

    constructor(data?: IGetFormByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetFormByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetFormByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    projectId?: string;
    name?: string | undefined;
}

export class CreateFormViewModel implements ICreateFormViewModel {
    id?: string;

    constructor(data?: ICreateFormViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateFormViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateFormViewModel {
    id?: string;
}

export class CreateFormCommandDto implements ICreateFormCommandDto {
    sourceId?: string | undefined;
    projectId?: string;
    name?: string | undefined;

    constructor(data?: ICreateFormCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateFormCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateFormCommandDto {
    sourceId?: string | undefined;
    projectId?: string;
    name?: string | undefined;
}

export class UpdateFormViewModel implements IUpdateFormViewModel {
    id?: string;

    constructor(data?: IUpdateFormViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFormViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateFormViewModel {
    id?: string;
}

export class UpdateFormCommandDto implements IUpdateFormCommandDto {
    id?: string;
    sourceId?: string | undefined;
    projectId?: string;
    name?: string | undefined;

    constructor(data?: IUpdateFormCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateFormCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateFormCommandDto {
    id?: string;
    sourceId?: string | undefined;
    projectId?: string;
    name?: string | undefined;
}

export class DeleteFormViewModel implements IDeleteFormViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteFormViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteFormViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFormViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteFormViewModel {
    id?: string | undefined;
}

export class GetFormVersionByIdViewModel implements IGetFormVersionByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;

    constructor(data?: IGetFormVersionByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.formId = _data["formId"];
            this.state = _data["state"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): GetFormVersionByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormVersionByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["formId"] = this.formId;
        data["state"] = this.state;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IGetFormVersionByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;
}

export enum FormState {
    Preview = 0,
    Published = 1,
}

export class CreateFormVersionViewModel implements ICreateFormVersionViewModel {
    id?: string;

    constructor(data?: ICreateFormVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateFormVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateFormVersionViewModel {
    id?: string;
}

export class CreateFormVersionCommandDto implements ICreateFormVersionCommandDto {
    sourceId?: string | undefined;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;

    constructor(data?: ICreateFormVersionCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.formId = _data["formId"];
            this.state = _data["state"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): CreateFormVersionCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormVersionCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["formId"] = this.formId;
        data["state"] = this.state;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface ICreateFormVersionCommandDto {
    sourceId?: string | undefined;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;
}

export class UpdateFormVersionViewModel implements IUpdateFormVersionViewModel {
    id?: string;

    constructor(data?: IUpdateFormVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFormVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateFormVersionViewModel {
    id?: string;
}

export class UpdateFormVersionCommandDto implements IUpdateFormVersionCommandDto {
    id?: string;
    sourceId?: string | undefined;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;

    constructor(data?: IUpdateFormVersionCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.formId = _data["formId"];
            this.state = _data["state"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): UpdateFormVersionCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormVersionCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["formId"] = this.formId;
        data["state"] = this.state;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IUpdateFormVersionCommandDto {
    id?: string;
    sourceId?: string | undefined;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;
}

export class DeleteFormVersionViewModel implements IDeleteFormVersionViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteFormVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteFormVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFormVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteFormVersionViewModel {
    id?: string | undefined;
}

export class GetLayoutCultureByIdViewModel implements IGetLayoutCultureByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: IGetLayoutCultureByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): GetLayoutCultureByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetLayoutCultureByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IGetLayoutCultureByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class CreateLayoutCultureViewModel implements ICreateLayoutCultureViewModel {
    id?: string;

    constructor(data?: ICreateLayoutCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateLayoutCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLayoutCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateLayoutCultureViewModel {
    id?: string;
}

export class CreateLayoutCultureCommandDto implements ICreateLayoutCultureCommandDto {
    sourceId?: string | undefined;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: ICreateLayoutCultureCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): CreateLayoutCultureCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLayoutCultureCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface ICreateLayoutCultureCommandDto {
    sourceId?: string | undefined;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class UpdateLayoutCultureViewModel implements IUpdateLayoutCultureViewModel {
    id?: string;

    constructor(data?: IUpdateLayoutCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateLayoutCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLayoutCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateLayoutCultureViewModel {
    id?: string;
}

export class UpdateLayoutCultureCommandDto implements IUpdateLayoutCultureCommandDto {
    id?: string;
    sourceId?: string | undefined;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: IUpdateLayoutCultureCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): UpdateLayoutCultureCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLayoutCultureCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IUpdateLayoutCultureCommandDto {
    id?: string;
    sourceId?: string | undefined;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class DeleteLayoutCultureViewModel implements IDeleteLayoutCultureViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteLayoutCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteLayoutCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLayoutCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteLayoutCultureViewModel {
    id?: string | undefined;
}

export class GetLayoutCultureValueByIdViewModel implements IGetLayoutCultureValueByIdViewModel {
    id?: string;
    layoutLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;

    constructor(data?: IGetLayoutCultureValueByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layoutLanguageId = _data["layoutLanguageId"];
            this.surveyId = _data["surveyId"];
            this.valuesJson = _data["valuesJson"];
        }
    }

    static fromJS(data: any): GetLayoutCultureValueByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetLayoutCultureValueByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layoutLanguageId"] = this.layoutLanguageId;
        data["surveyId"] = this.surveyId;
        data["valuesJson"] = this.valuesJson;
        return data;
    }
}

export interface IGetLayoutCultureValueByIdViewModel {
    id?: string;
    layoutLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;
}

export class CreateLayoutCultureValueViewModel implements ICreateLayoutCultureValueViewModel {
    id?: string;

    constructor(data?: ICreateLayoutCultureValueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateLayoutCultureValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLayoutCultureValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateLayoutCultureValueViewModel {
    id?: string;
}

export class CreateLayoutCultureValueCommandDto implements ICreateLayoutCultureValueCommandDto {
    layoutLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;

    constructor(data?: ICreateLayoutCultureValueCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutLanguageId = _data["layoutLanguageId"];
            this.surveyId = _data["surveyId"];
            this.valuesJson = _data["valuesJson"];
        }
    }

    static fromJS(data: any): CreateLayoutCultureValueCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLayoutCultureValueCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutLanguageId"] = this.layoutLanguageId;
        data["surveyId"] = this.surveyId;
        data["valuesJson"] = this.valuesJson;
        return data;
    }
}

export interface ICreateLayoutCultureValueCommandDto {
    layoutLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;
}

export class UpdateLayoutCultureValueViewModel implements IUpdateLayoutCultureValueViewModel {
    id?: string;

    constructor(data?: IUpdateLayoutCultureValueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateLayoutCultureValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLayoutCultureValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateLayoutCultureValueViewModel {
    id?: string;
}

export class UpdateLayoutCultureValueCommandDto implements IUpdateLayoutCultureValueCommandDto {
    id?: string;
    layoutLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;

    constructor(data?: IUpdateLayoutCultureValueCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layoutLanguageId = _data["layoutLanguageId"];
            this.surveyId = _data["surveyId"];
            this.valuesJson = _data["valuesJson"];
        }
    }

    static fromJS(data: any): UpdateLayoutCultureValueCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLayoutCultureValueCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layoutLanguageId"] = this.layoutLanguageId;
        data["surveyId"] = this.surveyId;
        data["valuesJson"] = this.valuesJson;
        return data;
    }
}

export interface IUpdateLayoutCultureValueCommandDto {
    id?: string;
    layoutLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;
}

export class DeleteLayoutCultureValueViewModel implements IDeleteLayoutCultureValueViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteLayoutCultureValueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteLayoutCultureValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLayoutCultureValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteLayoutCultureValueViewModel {
    id?: string | undefined;
}

export class GetLayoutByIdViewModel implements IGetLayoutByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    name?: string | undefined;
    data?: string | undefined;
    projectId?: string;

    constructor(data?: IGetLayoutByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetLayoutByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetLayoutByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetLayoutByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    name?: string | undefined;
    data?: string | undefined;
    projectId?: string;
}

export class CreateLayoutViewModel implements ICreateLayoutViewModel {
    id?: string;

    constructor(data?: ICreateLayoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateLayoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLayoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateLayoutViewModel {
    id?: string;
}

export class CreateLayoutCommandDto implements ICreateLayoutCommandDto {
    sourceId?: string | undefined;
    name?: string | undefined;
    data?: string | undefined;
    projectId?: string;

    constructor(data?: ICreateLayoutCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateLayoutCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLayoutCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ICreateLayoutCommandDto {
    sourceId?: string | undefined;
    name?: string | undefined;
    data?: string | undefined;
    projectId?: string;
}

export class UpdateLayoutViewModel implements IUpdateLayoutViewModel {
    id?: string;

    constructor(data?: IUpdateLayoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateLayoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLayoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateLayoutViewModel {
    id?: string;
}

export class UpdateLayoutCommandDto implements IUpdateLayoutCommandDto {
    id?: string;
    sourceId?: string | undefined;
    name?: string | undefined;
    data?: string | undefined;
    projectId?: string;

    constructor(data?: IUpdateLayoutCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): UpdateLayoutCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLayoutCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IUpdateLayoutCommandDto {
    id?: string;
    sourceId?: string | undefined;
    name?: string | undefined;
    data?: string | undefined;
    projectId?: string;
}

export class DeleteLayoutViewModel implements IDeleteLayoutViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteLayoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteLayoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteLayoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteLayoutViewModel {
    id?: string | undefined;
}

export class GetMySurveysViewModel implements IGetMySurveysViewModel {
    mySurveys?: MySurvey[];

    constructor(data?: IGetMySurveysViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mySurveys"])) {
                this.mySurveys = [] as any;
                for (let item of _data["mySurveys"])
                    this.mySurveys!.push(MySurvey.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMySurveysViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMySurveysViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mySurveys)) {
            data["mySurveys"] = [];
            for (let item of this.mySurveys)
                data["mySurveys"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMySurveysViewModel {
    mySurveys?: MySurvey[];
}

export class MySurvey implements IMySurvey {
    id?: string;
    url?: string;
    count?: number;
    name?: string;
    isPublished?: boolean;

    constructor(data?: IMySurvey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.count = _data["count"];
            this.name = _data["name"];
            this.isPublished = _data["isPublished"];
        }
    }

    static fromJS(data: any): MySurvey {
        data = typeof data === 'object' ? data : {};
        let result = new MySurvey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["count"] = this.count;
        data["name"] = this.name;
        data["isPublished"] = this.isPublished;
        return data;
    }
}

export interface IMySurvey {
    id?: string;
    url?: string;
    count?: number;
    name?: string;
    isPublished?: boolean;
}

export class GenerateQrCodeDto implements IGenerateQrCodeDto {
    url?: string;
    culture?: string;
    templateType?: PaperKind;

    constructor(data?: IGenerateQrCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.culture = _data["culture"];
            this.templateType = _data["templateType"];
        }
    }

    static fromJS(data: any): GenerateQrCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateQrCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["culture"] = this.culture;
        data["templateType"] = this.templateType;
        return data;
    }
}

export interface IGenerateQrCodeDto {
    url?: string;
    culture?: string;
    templateType?: PaperKind;
}

/** Enumaration of paper kinds from  http://msdn.microsoft.com/en-us/library/system.drawing.printing.paperkind.aspx Implemented here because Syste.Drawing.Printing is not ported to NET Core */
export enum PaperKind {
    Custom = 0,
    Letter = 1,
    LetterSmall = 2,
    Tabloid = 3,
    Ledger = 4,
    Legal = 5,
    Statement = 6,
    Executive = 7,
    A3 = 8,
    A4 = 9,
    A4Small = 10,
    A5 = 11,
    B4 = 12,
    B5 = 13,
    Folio = 14,
    Quarto = 15,
    Standard10x14 = 16,
    Standard11x17 = 17,
    Note = 18,
    Number9Envelope = 19,
    Number10Envelope = 20,
    Number11Envelope = 21,
    Number12Envelope = 22,
    Number14Envelope = 23,
    CSheet = 24,
    DSheet = 25,
    ESheet = 26,
    DLEnvelope = 27,
    C5Envelope = 28,
    C3Envelope = 29,
    C4Envelope = 30,
    C6Envelope = 31,
    C65Envelope = 32,
    B4Envelope = 33,
    B5Envelope = 34,
    B6Envelope = 35,
    ItalyEnvelope = 36,
    MonarchEnvelope = 37,
    PersonalEnvelope = 38,
    USStandardFanfold = 39,
    GermanStandardFanfold = 40,
    GermanLegalFanfold = 41,
    IsoB4 = 42,
    JapanesePostcard = 43,
    Standard9x11 = 44,
    Standard10x11 = 45,
    Standard15x11 = 46,
    InviteEnvelope = 47,
    LetterExtra = 50,
    LegalExtra = 51,
    TabloidExtra = 52,
    A4Extra = 53,
    LetterTransverse = 54,
    A4Transverse = 55,
    LetterExtraTransverse = 56,
    APlus = 57,
    BPlus = 58,
    LetterPlus = 59,
    A4Plus = 60,
    A5Transverse = 61,
    B5Transverse = 62,
    A3Extra = 63,
    A5Extra = 64,
    B5Extra = 65,
    A2 = 66,
    A3Transverse = 67,
    A3ExtraTransverse = 68,
    JapaneseDoublePostcard = 69,
    A6 = 70,
    JapaneseEnvelopeKakuNumber2 = 71,
    JapaneseEnvelopeKakuNumber3 = 72,
    JapaneseEnvelopeChouNumber3 = 73,
    JapaneseEnvelopeChouNumber4 = 74,
    LetterRotated = 75,
    A3Rotated = 76,
    A4Rotated = 77,
    A5Rotated = 78,
    B4JisRotated = 79,
    B5JisRotated = 80,
    JapanesePostcardRotated = 81,
    JapaneseDoublePostcardRotated = 82,
    A6Rotated = 83,
    JapaneseEnvelopeKakuNumber2Rotated = 84,
    JapaneseEnvelopeKakuNumber3Rotated = 85,
    JapaneseEnvelopeChouNumber3Rotated = 86,
    JapaneseEnvelopeChouNumber4Rotated = 87,
    B6Jis = 88,
    B6JisRotated = 89,
    Standard12x11 = 90,
    JapaneseEnvelopeYouNumber4 = 91,
    JapaneseEnvelopeYouNumber4Rotated = 92,
    Prc16K = 93,
    Prc32K = 94,
    Prc32KBig = 95,
    PrcEnvelopeNumber1 = 96,
    PrcEnvelopeNumber2 = 97,
    PrcEnvelopeNumber3 = 98,
    PrcEnvelopeNumber4 = 99,
    PrcEnvelopeNumber5 = 100,
    PrcEnvelopeNumber6 = 101,
    PrcEnvelopeNumber7 = 102,
    PrcEnvelopeNumber8 = 103,
    PrcEnvelopeNumber9 = 104,
    PrcEnvelopeNumber10 = 105,
    Prc16KRotated = 106,
    Prc32KRotated = 107,
    Prc32KBigRotated = 108,
    PrcEnvelopeNumber1Rotated = 109,
    PrcEnvelopeNumber2Rotated = 110,
    PrcEnvelopeNumber3Rotated = 111,
    PrcEnvelopeNumber4Rotated = 112,
    PrcEnvelopeNumber5Rotated = 113,
    PrcEnvelopeNumber6Rotated = 114,
    PrcEnvelopeNumber7Rotated = 115,
    PrcEnvelopeNumber8Rotated = 116,
    PrcEnvelopeNumber9Rotated = 117,
    PrcEnvelopeNumber10Rotated = 118,
}

export class AlertsWidgetViewModel implements IAlertsWidgetViewModel {
    model?: DashboardWidget;

    constructor(data?: IAlertsWidgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? DashboardWidget.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertsWidgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AlertsWidgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlertsWidgetViewModel {
    model?: DashboardWidget;
}

export class DashboardWidget implements IDashboardWidget {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: AlertsSummaryWidget2;

    constructor(data?: IDashboardWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.titleHelp = _data["titleHelp"];
            this.additionalInfo = _data["additionalInfo"];
            this.showDetailsLink = _data["showDetailsLink"];
            this.children = _data["children"] ? AlertsSummaryWidget2.fromJS(_data["children"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardWidget {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleHelp"] = this.titleHelp;
        data["additionalInfo"] = this.additionalInfo;
        data["showDetailsLink"] = this.showDetailsLink;
        data["children"] = this.children ? this.children.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardWidget {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: AlertsSummaryWidget2;
}

export class AlertsSummaryWidget2 implements IAlertsSummaryWidget2 {
    pendingTotal?: number;
    treatedTotal?: number;
    toSolve?: number;
    solved?: number;
    onHold?: number;
    opened?: number;
    toRead?: number;
    read?: number;
    pendingTimeToOpen?: number;
    pendingTimeToContact?: number;
    treatedTimeToOpen?: number;
    treatedTimeToSolve?: number;

    constructor(data?: IAlertsSummaryWidget2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingTotal = _data["pendingTotal"];
            this.treatedTotal = _data["treatedTotal"];
            this.toSolve = _data["toSolve"];
            this.solved = _data["solved"];
            this.onHold = _data["onHold"];
            this.opened = _data["opened"];
            this.toRead = _data["toRead"];
            this.read = _data["read"];
            this.pendingTimeToOpen = _data["pendingTimeToOpen"];
            this.pendingTimeToContact = _data["pendingTimeToContact"];
            this.treatedTimeToOpen = _data["treatedTimeToOpen"];
            this.treatedTimeToSolve = _data["treatedTimeToSolve"];
        }
    }

    static fromJS(data: any): AlertsSummaryWidget2 {
        data = typeof data === 'object' ? data : {};
        let result = new AlertsSummaryWidget2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingTotal"] = this.pendingTotal;
        data["treatedTotal"] = this.treatedTotal;
        data["toSolve"] = this.toSolve;
        data["solved"] = this.solved;
        data["onHold"] = this.onHold;
        data["opened"] = this.opened;
        data["toRead"] = this.toRead;
        data["read"] = this.read;
        data["pendingTimeToOpen"] = this.pendingTimeToOpen;
        data["pendingTimeToContact"] = this.pendingTimeToContact;
        data["treatedTimeToOpen"] = this.treatedTimeToOpen;
        data["treatedTimeToSolve"] = this.treatedTimeToSolve;
        return data;
    }
}

export interface IAlertsSummaryWidget2 {
    pendingTotal?: number;
    treatedTotal?: number;
    toSolve?: number;
    solved?: number;
    onHold?: number;
    opened?: number;
    toRead?: number;
    read?: number;
    pendingTimeToOpen?: number;
    pendingTimeToContact?: number;
    treatedTimeToOpen?: number;
    treatedTimeToSolve?: number;
}

export class CesWidgetViewModel implements ICesWidgetViewModel {
    model?: DashboardWidget2;

    constructor(data?: ICesWidgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? DashboardWidget2.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CesWidgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CesWidgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICesWidgetViewModel {
    model?: DashboardWidget2;
}

export class DashboardWidget2 implements IDashboardWidget2 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: DistributionGaugeWidget;

    constructor(data?: IDashboardWidget2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.titleHelp = _data["titleHelp"];
            this.additionalInfo = _data["additionalInfo"];
            this.showDetailsLink = _data["showDetailsLink"];
            this.children = _data["children"] ? DistributionGaugeWidget.fromJS(_data["children"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardWidget2 {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWidget2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleHelp"] = this.titleHelp;
        data["additionalInfo"] = this.additionalInfo;
        data["showDetailsLink"] = this.showDetailsLink;
        data["children"] = this.children ? this.children.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardWidget2 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: DistributionGaugeWidget;
}

export class DistributionGaugeWidget implements IDistributionGaugeWidget {
    series?: DataPoint[];
    middleValue?: string;
    middleValueUnit?: string;
    variance?: string;
    varianceUnit?: string;
    varianceLabel?: string;
    colors?: string[];
    location?: string;
    surveyCount?: number;

    constructor(data?: IDistributionGaugeWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(DataPoint.fromJS(item));
            }
            this.middleValue = _data["middleValue"];
            this.middleValueUnit = _data["middleValueUnit"];
            this.variance = _data["variance"];
            this.varianceUnit = _data["varianceUnit"];
            this.varianceLabel = _data["varianceLabel"];
            if (Array.isArray(_data["colors"])) {
                this.colors = [] as any;
                for (let item of _data["colors"])
                    this.colors!.push(item);
            }
            this.location = _data["location"];
            this.surveyCount = _data["surveyCount"];
        }
    }

    static fromJS(data: any): DistributionGaugeWidget {
        data = typeof data === 'object' ? data : {};
        let result = new DistributionGaugeWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        data["middleValue"] = this.middleValue;
        data["middleValueUnit"] = this.middleValueUnit;
        data["variance"] = this.variance;
        data["varianceUnit"] = this.varianceUnit;
        data["varianceLabel"] = this.varianceLabel;
        if (Array.isArray(this.colors)) {
            data["colors"] = [];
            for (let item of this.colors)
                data["colors"].push(item);
        }
        data["location"] = this.location;
        data["surveyCount"] = this.surveyCount;
        return data;
    }
}

export interface IDistributionGaugeWidget {
    series?: DataPoint[];
    middleValue?: string;
    middleValueUnit?: string;
    variance?: string;
    varianceUnit?: string;
    varianceLabel?: string;
    colors?: string[];
    location?: string;
    surveyCount?: number;
}

export class DataPoint implements IDataPoint {
    key?: string;
    value?: number | undefined;

    constructor(data?: IDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new DataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IDataPoint {
    key?: string;
    value?: number | undefined;
}

export class CompetitorsWidgetViewModel implements ICompetitorsWidgetViewModel {
    model?: DashboardWidget3;

    constructor(data?: ICompetitorsWidgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? DashboardWidget3.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompetitorsWidgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorsWidgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompetitorsWidgetViewModel {
    model?: DashboardWidget3;
}

export class DashboardWidget3 implements IDashboardWidget3 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: CompetitorsWidget;

    constructor(data?: IDashboardWidget3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.titleHelp = _data["titleHelp"];
            this.additionalInfo = _data["additionalInfo"];
            this.showDetailsLink = _data["showDetailsLink"];
            this.children = _data["children"] ? CompetitorsWidget.fromJS(_data["children"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardWidget3 {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWidget3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleHelp"] = this.titleHelp;
        data["additionalInfo"] = this.additionalInfo;
        data["showDetailsLink"] = this.showDetailsLink;
        data["children"] = this.children ? this.children.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardWidget3 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: CompetitorsWidget;
}

export class CompetitorsWidget implements ICompetitorsWidget {
    clientName?: string;
    competitors?: Competitor[];

    constructor(data?: ICompetitorsWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"];
            if (Array.isArray(_data["competitors"])) {
                this.competitors = [] as any;
                for (let item of _data["competitors"])
                    this.competitors!.push(Competitor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitorsWidget {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorsWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName;
        if (Array.isArray(this.competitors)) {
            data["competitors"] = [];
            for (let item of this.competitors)
                data["competitors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompetitorsWidget {
    clientName?: string;
    competitors?: Competitor[];
}

export class Competitor implements ICompetitor {
    name?: string;
    additionalInfo?: string;
    values?: HorizontalBar[];

    constructor(data?: ICompetitor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.additionalInfo = _data["additionalInfo"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(HorizontalBar.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Competitor {
        data = typeof data === 'object' ? data : {};
        let result = new Competitor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["additionalInfo"] = this.additionalInfo;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompetitor {
    name?: string;
    additionalInfo?: string;
    values?: HorizontalBar[];
}

export class HorizontalBar implements IHorizontalBar {
    label?: string;
    value?: number | undefined;
    variance?: string;

    constructor(data?: IHorizontalBar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.variance = _data["variance"];
        }
    }

    static fromJS(data: any): HorizontalBar {
        data = typeof data === 'object' ? data : {};
        let result = new HorizontalBar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["variance"] = this.variance;
        return data;
    }
}

export interface IHorizontalBar {
    label?: string;
    value?: number | undefined;
    variance?: string;
}

export class GeneralViewModel implements IGeneralViewModel {
    general?: General;

    constructor(data?: IGeneralViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? General.fromJS(_data["general"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeneralViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeneralViewModel {
    general?: General;
}

export class General implements IGeneral {
    count?: number;

    constructor(data?: IGeneral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): General {
        data = typeof data === 'object' ? data : {};
        let result = new General();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }
}

export interface IGeneral {
    count?: number;
}

export class GeneralByCategoryViewModel implements IGeneralByCategoryViewModel {
    dashboardWidget?: DashboardWidget4;

    constructor(data?: IGeneralByCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardWidget = _data["dashboardWidget"] ? DashboardWidget4.fromJS(_data["dashboardWidget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeneralByCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralByCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardWidget"] = this.dashboardWidget ? this.dashboardWidget.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeneralByCategoryViewModel {
    dashboardWidget?: DashboardWidget4;
}

export class DashboardWidget4 implements IDashboardWidget4 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: HorizontalBarsWidget;

    constructor(data?: IDashboardWidget4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.titleHelp = _data["titleHelp"];
            this.additionalInfo = _data["additionalInfo"];
            this.showDetailsLink = _data["showDetailsLink"];
            this.children = _data["children"] ? HorizontalBarsWidget.fromJS(_data["children"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardWidget4 {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWidget4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleHelp"] = this.titleHelp;
        data["additionalInfo"] = this.additionalInfo;
        data["showDetailsLink"] = this.showDetailsLink;
        data["children"] = this.children ? this.children.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardWidget4 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: HorizontalBarsWidget;
}

export class HorizontalBarsWidget implements IHorizontalBarsWidget {
    series?: HorizontalBar2[];

    constructor(data?: IHorizontalBarsWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(HorizontalBar2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HorizontalBarsWidget {
        data = typeof data === 'object' ? data : {};
        let result = new HorizontalBarsWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHorizontalBarsWidget {
    series?: HorizontalBar2[];
}

export class HorizontalBar2 implements IHorizontalBar2 {
    label?: string;
    value?: number | undefined;
    variance?: string;

    constructor(data?: IHorizontalBar2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.variance = _data["variance"];
        }
    }

    static fromJS(data: any): HorizontalBar2 {
        data = typeof data === 'object' ? data : {};
        let result = new HorizontalBar2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["variance"] = this.variance;
        return data;
    }
}

export interface IHorizontalBar2 {
    label?: string;
    value?: number | undefined;
    variance?: string;
}

export class GeneralSatisfactionViewModel implements IGeneralSatisfactionViewModel {
    dashboardWidget?: DashboardWidget5;

    constructor(data?: IGeneralSatisfactionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardWidget = _data["dashboardWidget"] ? DashboardWidget5.fromJS(_data["dashboardWidget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeneralSatisfactionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSatisfactionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardWidget"] = this.dashboardWidget ? this.dashboardWidget.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeneralSatisfactionViewModel {
    dashboardWidget?: DashboardWidget5;
}

export class DashboardWidget5 implements IDashboardWidget5 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: PercentageGaugeWidget;

    constructor(data?: IDashboardWidget5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.titleHelp = _data["titleHelp"];
            this.additionalInfo = _data["additionalInfo"];
            this.showDetailsLink = _data["showDetailsLink"];
            this.children = _data["children"] ? PercentageGaugeWidget.fromJS(_data["children"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardWidget5 {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWidget5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleHelp"] = this.titleHelp;
        data["additionalInfo"] = this.additionalInfo;
        data["showDetailsLink"] = this.showDetailsLink;
        data["children"] = this.children ? this.children.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardWidget5 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: PercentageGaugeWidget;
}

export class PercentageGaugeWidget implements IPercentageGaugeWidget {
    serie?: DataPoint2;
    middleValue?: string;
    middleValueUnit?: string;
    variance?: string;
    varianceUnit?: string;
    varianceLabel?: string;

    constructor(data?: IPercentageGaugeWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serie = _data["serie"] ? DataPoint2.fromJS(_data["serie"]) : <any>undefined;
            this.middleValue = _data["middleValue"];
            this.middleValueUnit = _data["middleValueUnit"];
            this.variance = _data["variance"];
            this.varianceUnit = _data["varianceUnit"];
            this.varianceLabel = _data["varianceLabel"];
        }
    }

    static fromJS(data: any): PercentageGaugeWidget {
        data = typeof data === 'object' ? data : {};
        let result = new PercentageGaugeWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serie"] = this.serie ? this.serie.toJSON() : <any>undefined;
        data["middleValue"] = this.middleValue;
        data["middleValueUnit"] = this.middleValueUnit;
        data["variance"] = this.variance;
        data["varianceUnit"] = this.varianceUnit;
        data["varianceLabel"] = this.varianceLabel;
        return data;
    }
}

export interface IPercentageGaugeWidget {
    serie?: DataPoint2;
    middleValue?: string;
    middleValueUnit?: string;
    variance?: string;
    varianceUnit?: string;
    varianceLabel?: string;
}

export class DataPoint2 implements IDataPoint2 {
    key?: string;
    value?: number | undefined;

    constructor(data?: IDataPoint2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DataPoint2 {
        data = typeof data === 'object' ? data : {};
        let result = new DataPoint2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IDataPoint2 {
    key?: string;
    value?: number | undefined;
}

export class NpsWidgetViewModel implements INpsWidgetViewModel {
    dashboardWidget?: DashboardWidget6;

    constructor(data?: INpsWidgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardWidget = _data["dashboardWidget"] ? DashboardWidget6.fromJS(_data["dashboardWidget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NpsWidgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NpsWidgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardWidget"] = this.dashboardWidget ? this.dashboardWidget.toJSON() : <any>undefined;
        return data;
    }
}

export interface INpsWidgetViewModel {
    dashboardWidget?: DashboardWidget6;
}

export class DashboardWidget6 implements IDashboardWidget6 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: DistributionGaugeWidget2;

    constructor(data?: IDashboardWidget6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.titleHelp = _data["titleHelp"];
            this.additionalInfo = _data["additionalInfo"];
            this.showDetailsLink = _data["showDetailsLink"];
            this.children = _data["children"] ? DistributionGaugeWidget2.fromJS(_data["children"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardWidget6 {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWidget6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleHelp"] = this.titleHelp;
        data["additionalInfo"] = this.additionalInfo;
        data["showDetailsLink"] = this.showDetailsLink;
        data["children"] = this.children ? this.children.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardWidget6 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: DistributionGaugeWidget2;
}

export class DistributionGaugeWidget2 implements IDistributionGaugeWidget2 {
    series?: DataPoint3[];
    middleValue?: string;
    middleValueUnit?: string;
    variance?: string;
    varianceUnit?: string;
    varianceLabel?: string;
    colors?: string[];
    location?: string;
    surveyCount?: number;

    constructor(data?: IDistributionGaugeWidget2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(DataPoint3.fromJS(item));
            }
            this.middleValue = _data["middleValue"];
            this.middleValueUnit = _data["middleValueUnit"];
            this.variance = _data["variance"];
            this.varianceUnit = _data["varianceUnit"];
            this.varianceLabel = _data["varianceLabel"];
            if (Array.isArray(_data["colors"])) {
                this.colors = [] as any;
                for (let item of _data["colors"])
                    this.colors!.push(item);
            }
            this.location = _data["location"];
            this.surveyCount = _data["surveyCount"];
        }
    }

    static fromJS(data: any): DistributionGaugeWidget2 {
        data = typeof data === 'object' ? data : {};
        let result = new DistributionGaugeWidget2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        data["middleValue"] = this.middleValue;
        data["middleValueUnit"] = this.middleValueUnit;
        data["variance"] = this.variance;
        data["varianceUnit"] = this.varianceUnit;
        data["varianceLabel"] = this.varianceLabel;
        if (Array.isArray(this.colors)) {
            data["colors"] = [];
            for (let item of this.colors)
                data["colors"].push(item);
        }
        data["location"] = this.location;
        data["surveyCount"] = this.surveyCount;
        return data;
    }
}

export interface IDistributionGaugeWidget2 {
    series?: DataPoint3[];
    middleValue?: string;
    middleValueUnit?: string;
    variance?: string;
    varianceUnit?: string;
    varianceLabel?: string;
    colors?: string[];
    location?: string;
    surveyCount?: number;
}

export class DataPoint3 implements IDataPoint3 {
    key?: string;
    value?: number | undefined;

    constructor(data?: IDataPoint3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DataPoint3 {
        data = typeof data === 'object' ? data : {};
        let result = new DataPoint3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IDataPoint3 {
    key?: string;
    value?: number | undefined;
}

export class TrendsViewModel implements ITrendsViewModel {
    dashboardWidget?: DashboardWidget7;

    constructor(data?: ITrendsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardWidget = _data["dashboardWidget"] ? DashboardWidget7.fromJS(_data["dashboardWidget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrendsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrendsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardWidget"] = this.dashboardWidget ? this.dashboardWidget.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrendsViewModel {
    dashboardWidget?: DashboardWidget7;
}

export class DashboardWidget7 implements IDashboardWidget7 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: LineChartWidget;

    constructor(data?: IDashboardWidget7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.titleHelp = _data["titleHelp"];
            this.additionalInfo = _data["additionalInfo"];
            this.showDetailsLink = _data["showDetailsLink"];
            this.children = _data["children"] ? LineChartWidget.fromJS(_data["children"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardWidget7 {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWidget7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleHelp"] = this.titleHelp;
        data["additionalInfo"] = this.additionalInfo;
        data["showDetailsLink"] = this.showDetailsLink;
        data["children"] = this.children ? this.children.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardWidget7 {
    title?: string;
    titleHelp?: string;
    additionalInfo?: string;
    showDetailsLink?: boolean;
    children?: LineChartWidget;
}

export class LineChartWidget implements ILineChartWidget {
    series?: Line[];

    constructor(data?: ILineChartWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(Line.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LineChartWidget {
        data = typeof data === 'object' ? data : {};
        let result = new LineChartWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILineChartWidget {
    series?: Line[];
}

export class Line implements ILine {
    key?: string;
    name?: string;
    values?: DatePoint[];

    constructor(data?: ILine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(DatePoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Line {
        data = typeof data === 'object' ? data : {};
        let result = new Line();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILine {
    key?: string;
    name?: string;
    values?: DatePoint[];
}

export class DatePoint implements IDatePoint {
    value?: number;
    date?: Date;

    constructor(data?: IDatePoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DatePoint {
        data = typeof data === 'object' ? data : {};
        let result = new DatePoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDatePoint {
    value?: number;
    date?: Date;
}

export class DashboardOverview implements IDashboardOverview {
    filterSet?: DashboardFilterSet | undefined;

    constructor(data?: IDashboardOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterSet = _data["filterSet"] ? DashboardFilterSet.fromJS(_data["filterSet"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardOverview {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterSet"] = this.filterSet ? this.filterSet.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardOverview {
    filterSet?: DashboardFilterSet | undefined;
}

export class DashboardFilterSet implements IDashboardFilterSet {
    maxPage?: number;
    dateRange?: SurveyAnswerDateRangeDto[] | undefined;
    services?: KeyValuePairOfGuidAndString[] | undefined;
    locations?: KeyValuePairOfLocationTypeAndIEnumerableOfKeyValuePairOfStringAndString[] | undefined;
    categories?: Category[] | undefined;
    questionFilterJson?: string | undefined;

    constructor(data?: IDashboardFilterSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxPage = _data["maxPage"];
            if (Array.isArray(_data["dateRange"])) {
                this.dateRange = [] as any;
                for (let item of _data["dateRange"])
                    this.dateRange!.push(SurveyAnswerDateRangeDto.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(KeyValuePairOfGuidAndString.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(KeyValuePairOfLocationTypeAndIEnumerableOfKeyValuePairOfStringAndString.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(Category.fromJS(item));
            }
            this.questionFilterJson = _data["questionFilterJson"];
        }
    }

    static fromJS(data: any): DashboardFilterSet {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardFilterSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxPage"] = this.maxPage;
        if (Array.isArray(this.dateRange)) {
            data["dateRange"] = [];
            for (let item of this.dateRange)
                data["dateRange"].push(item.toJSON());
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["questionFilterJson"] = this.questionFilterJson;
        return data;
    }
}

export interface IDashboardFilterSet {
    maxPage?: number;
    dateRange?: SurveyAnswerDateRangeDto[] | undefined;
    services?: KeyValuePairOfGuidAndString[] | undefined;
    locations?: KeyValuePairOfLocationTypeAndIEnumerableOfKeyValuePairOfStringAndString[] | undefined;
    categories?: Category[] | undefined;
    questionFilterJson?: string | undefined;
}

export class KeyValuePairOfGuidAndString implements IKeyValuePairOfGuidAndString {
    key?: string;
    value?: string | undefined;

    constructor(data?: IKeyValuePairOfGuidAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfGuidAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfGuidAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfGuidAndString {
    key?: string;
    value?: string | undefined;
}

export class KeyValuePairOfLocationTypeAndIEnumerableOfKeyValuePairOfStringAndString implements IKeyValuePairOfLocationTypeAndIEnumerableOfKeyValuePairOfStringAndString {
    key?: LocationType;
    value?: KeyValuePairOfStringAndString[] | undefined;

    constructor(data?: IKeyValuePairOfLocationTypeAndIEnumerableOfKeyValuePairOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KeyValuePairOfLocationTypeAndIEnumerableOfKeyValuePairOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfLocationTypeAndIEnumerableOfKeyValuePairOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKeyValuePairOfLocationTypeAndIEnumerableOfKeyValuePairOfStringAndString {
    key?: LocationType;
    value?: KeyValuePairOfStringAndString[] | undefined;
}

export enum LocationType {
    All = 0,
    Country = 1,
    Department = 2,
    Locality = 3,
    City = 4,
    Branch = 5,
    Unassigned = 6,
}

export class Category extends HierarchyEntityBase implements ICategory {
    projectId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;
    order?: number;
    project?: Project | undefined;
    cultures?: CategoryCulture[] | undefined;

    constructor(data?: ICategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
            this.order = _data["order"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(CategoryCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        data["order"] = this.order;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICategory extends IHierarchyEntityBase {
    projectId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;
    order?: number;
    project?: Project | undefined;
    cultures?: CategoryCulture[] | undefined;
}

export class Project extends EntityBase implements IProject {
    name!: string;
    order?: number;
    options?: ProjectOption[] | undefined;
    forms?: Form[] | undefined;
    surveys?: Survey[] | undefined;
    layouts?: Layout[] | undefined;
    templates?: Template[] | undefined;
    categories?: Category[] | undefined;
    cultures?: ProjectCulture[] | undefined;

    constructor(data?: IProject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.order = _data["order"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(ProjectOption.fromJS(item));
            }
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(Form.fromJS(item));
            }
            if (Array.isArray(_data["surveys"])) {
                this.surveys = [] as any;
                for (let item of _data["surveys"])
                    this.surveys!.push(Survey.fromJS(item));
            }
            if (Array.isArray(_data["layouts"])) {
                this.layouts = [] as any;
                for (let item of _data["layouts"])
                    this.layouts!.push(Layout.fromJS(item));
            }
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(Template.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(ProjectCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        if (Array.isArray(this.surveys)) {
            data["surveys"] = [];
            for (let item of this.surveys)
                data["surveys"].push(item.toJSON());
        }
        if (Array.isArray(this.layouts)) {
            data["layouts"] = [];
            for (let item of this.layouts)
                data["layouts"].push(item.toJSON());
        }
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProject extends IEntityBase {
    name: string;
    order?: number;
    options?: ProjectOption[] | undefined;
    forms?: Form[] | undefined;
    surveys?: Survey[] | undefined;
    layouts?: Layout[] | undefined;
    templates?: Template[] | undefined;
    categories?: Category[] | undefined;
    cultures?: ProjectCulture[] | undefined;
}

export class ProjectOption extends EntityBase implements IProjectOption {
    projectId?: string;
    type?: ProjectOptionType;
    valueJson?: string | undefined;

    constructor(data?: IProjectOption) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectId = _data["projectId"];
            this.type = _data["type"];
            this.valueJson = _data["valueJson"];
        }
    }

    static fromJS(data: any): ProjectOption {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["type"] = this.type;
        data["valueJson"] = this.valueJson;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectOption extends IEntityBase {
    projectId?: string;
    type?: ProjectOptionType;
    valueJson?: string | undefined;
}

export enum ProjectOptionType {
    HideBranchServicesInFilter = 0,
    QuestionFilter = 1,
    WidgetOrder = 2,
    ReceiptUnique = 3,
    HideLocationInFilter = 4,
    CodeRequired = 5,
    CodeMapping = 6,
    IpSecurity = 7,
    EmailSecurity = 8,
    ReCaptcha = 9,
    PostSurveySocialMedia = 10,
    ReceiptUniqueBranch = 11,
    HideCustomGroupTab = 12,
    Theme = 13,
    PrependBranchCode = 14,
    DisableAlertsEmail = 15,
    ReceiptMatchWithBranch = 16,
}

export class Form extends EntityBase implements IForm {
    sourceId?: string | undefined;
    projectId!: string;
    name!: string;
    project?: Project | undefined;
    formVersions?: FormVersion[] | undefined;

    constructor(data?: IForm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["formVersions"])) {
                this.formVersions = [] as any;
                for (let item of _data["formVersions"])
                    this.formVersions!.push(FormVersion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Form {
        data = typeof data === 'object' ? data : {};
        let result = new Form();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.formVersions)) {
            data["formVersions"] = [];
            for (let item of this.formVersions)
                data["formVersions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IForm extends IEntityBase {
    sourceId?: string | undefined;
    projectId: string;
    name: string;
    project?: Project | undefined;
    formVersions?: FormVersion[] | undefined;
}

export class FormVersion extends EntityBase implements IFormVersion {
    sourceId?: string | undefined;
    formId!: string;
    state!: FormState;
    majorVersion!: number;
    minorVersion?: number;
    formJson?: string | undefined;
    form?: Form | undefined;
    alertConfiguration?: AlertConfiguration | undefined;
    formVersionMetadata?: FormVersionMetadata[] | undefined;

    constructor(data?: IFormVersion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.formId = _data["formId"];
            this.state = _data["state"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.formJson = _data["formJson"];
            this.form = _data["form"] ? Form.fromJS(_data["form"]) : <any>undefined;
            this.alertConfiguration = _data["alertConfiguration"] ? AlertConfiguration.fromJS(_data["alertConfiguration"]) : <any>undefined;
            if (Array.isArray(_data["formVersionMetadata"])) {
                this.formVersionMetadata = [] as any;
                for (let item of _data["formVersionMetadata"])
                    this.formVersionMetadata!.push(FormVersionMetadata.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormVersion {
        data = typeof data === 'object' ? data : {};
        let result = new FormVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["formId"] = this.formId;
        data["state"] = this.state;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["formJson"] = this.formJson;
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        data["alertConfiguration"] = this.alertConfiguration ? this.alertConfiguration.toJSON() : <any>undefined;
        if (Array.isArray(this.formVersionMetadata)) {
            data["formVersionMetadata"] = [];
            for (let item of this.formVersionMetadata)
                data["formVersionMetadata"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFormVersion extends IEntityBase {
    sourceId?: string | undefined;
    formId: string;
    state: FormState;
    majorVersion: number;
    minorVersion?: number;
    formJson?: string | undefined;
    form?: Form | undefined;
    alertConfiguration?: AlertConfiguration | undefined;
    formVersionMetadata?: FormVersionMetadata[] | undefined;
}

export class AlertConfiguration extends EntityBase implements IAlertConfiguration {
    rulesJson?: string | undefined;
    formVersionId?: string;
    formVersion?: FormVersion | undefined;

    constructor(data?: IAlertConfiguration) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rulesJson = _data["rulesJson"];
            this.formVersionId = _data["formVersionId"];
            this.formVersion = _data["formVersion"] ? FormVersion.fromJS(_data["formVersion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new AlertConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rulesJson"] = this.rulesJson;
        data["formVersionId"] = this.formVersionId;
        data["formVersion"] = this.formVersion ? this.formVersion.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAlertConfiguration extends IEntityBase {
    rulesJson?: string | undefined;
    formVersionId?: string;
    formVersion?: FormVersion | undefined;
}

export class FormVersionMetadata extends EntityBase implements IFormVersionMetadata {
    formVersionId?: string;
    type?: FormVersionMetadataType;
    dataJson?: string | undefined;
    formVersion?: FormVersion | undefined;

    constructor(data?: IFormVersionMetadata) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formVersionId = _data["formVersionId"];
            this.type = _data["type"];
            this.dataJson = _data["dataJson"];
            this.formVersion = _data["formVersion"] ? FormVersion.fromJS(_data["formVersion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormVersionMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new FormVersionMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formVersionId"] = this.formVersionId;
        data["type"] = this.type;
        data["dataJson"] = this.dataJson;
        data["formVersion"] = this.formVersion ? this.formVersion.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFormVersionMetadata extends IEntityBase {
    formVersionId?: string;
    type?: FormVersionMetadataType;
    dataJson?: string | undefined;
    formVersion?: FormVersion | undefined;
}

export enum FormVersionMetadataType {
    Taxonomy = 0,
    QuestionMetadata = 1,
}

export class Survey extends EntityBase implements ISurvey {
    name!: string;
    defaultLanguage?: string | undefined;
    supportedLanguages?: string | undefined;
    flowId!: string;
    projectId!: string;
    flow?: Flow | undefined;
    project?: Project | undefined;
    surveyAnswers?: SurveyAnswer[] | undefined;

    constructor(data?: ISurvey) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.supportedLanguages = _data["supportedLanguages"];
            this.flowId = _data["flowId"];
            this.projectId = _data["projectId"];
            this.flow = _data["flow"] ? Flow.fromJS(_data["flow"]) : <any>undefined;
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["surveyAnswers"])) {
                this.surveyAnswers = [] as any;
                for (let item of _data["surveyAnswers"])
                    this.surveyAnswers!.push(SurveyAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Survey {
        data = typeof data === 'object' ? data : {};
        let result = new Survey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["defaultLanguage"] = this.defaultLanguage;
        data["supportedLanguages"] = this.supportedLanguages;
        data["flowId"] = this.flowId;
        data["projectId"] = this.projectId;
        data["flow"] = this.flow ? this.flow.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.surveyAnswers)) {
            data["surveyAnswers"] = [];
            for (let item of this.surveyAnswers)
                data["surveyAnswers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISurvey extends IEntityBase {
    name: string;
    defaultLanguage?: string | undefined;
    supportedLanguages?: string | undefined;
    flowId: string;
    projectId: string;
    flow?: Flow | undefined;
    project?: Project | undefined;
    surveyAnswers?: SurveyAnswer[] | undefined;
}

export class Flow extends EntityBase implements IFlow {
    sourceId?: string | undefined;
    flowJson?: string | undefined;

    constructor(data?: IFlow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.flowJson = _data["flowJson"];
        }
    }

    static fromJS(data: any): Flow {
        data = typeof data === 'object' ? data : {};
        let result = new Flow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["flowJson"] = this.flowJson;
        super.toJSON(data);
        return data;
    }
}

export interface IFlow extends IEntityBase {
    sourceId?: string | undefined;
    flowJson?: string | undefined;
}

export class SurveyAnswer extends EntityBase implements ISurveyAnswer {
    surveyId!: string;
    state!: SurveyState;
    submittedDate?: Date | undefined;
    dateOfVisitUtc?: Date | undefined;
    answersJson!: string;
    answersJsonDocument?: JsonDocument | undefined;
    timezoneOffset!: number;
    userAgent?: string | undefined;
    userIp?: string | undefined;
    answerLanguage?: string | undefined;
    branchId?: string | undefined;
    contactLevel?: ContactLevel | undefined;
    pageDisplayed?: boolean;
    survey?: Survey | undefined;
    alert?: Alert | undefined;
    result?: SurveyResult | undefined;
    taxonomies?: SurveyAnswerTaxonomy[] | undefined;

    constructor(data?: ISurveyAnswer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.state = _data["state"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.dateOfVisitUtc = _data["dateOfVisitUtc"] ? new Date(_data["dateOfVisitUtc"].toString()) : <any>undefined;
            this.answersJson = _data["answersJson"];
            this.answersJsonDocument = _data["answersJsonDocument"] ? JsonDocument.fromJS(_data["answersJsonDocument"]) : <any>undefined;
            this.timezoneOffset = _data["timezoneOffset"];
            this.userAgent = _data["userAgent"];
            this.userIp = _data["userIp"];
            this.answerLanguage = _data["answerLanguage"];
            this.branchId = _data["branchId"];
            this.contactLevel = _data["contactLevel"];
            this.pageDisplayed = _data["pageDisplayed"];
            this.survey = _data["survey"] ? Survey.fromJS(_data["survey"]) : <any>undefined;
            this.alert = _data["alert"] ? Alert.fromJS(_data["alert"]) : <any>undefined;
            this.result = _data["result"] ? SurveyResult.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["taxonomies"])) {
                this.taxonomies = [] as any;
                for (let item of _data["taxonomies"])
                    this.taxonomies!.push(SurveyAnswerTaxonomy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["state"] = this.state;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["dateOfVisitUtc"] = this.dateOfVisitUtc ? this.dateOfVisitUtc.toISOString() : <any>undefined;
        data["answersJson"] = this.answersJson;
        data["answersJsonDocument"] = this.answersJsonDocument ? this.answersJsonDocument.toJSON() : <any>undefined;
        data["timezoneOffset"] = this.timezoneOffset;
        data["userAgent"] = this.userAgent;
        data["userIp"] = this.userIp;
        data["answerLanguage"] = this.answerLanguage;
        data["branchId"] = this.branchId;
        data["contactLevel"] = this.contactLevel;
        data["pageDisplayed"] = this.pageDisplayed;
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        data["alert"] = this.alert ? this.alert.toJSON() : <any>undefined;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.taxonomies)) {
            data["taxonomies"] = [];
            for (let item of this.taxonomies)
                data["taxonomies"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISurveyAnswer extends IEntityBase {
    surveyId: string;
    state: SurveyState;
    submittedDate?: Date | undefined;
    dateOfVisitUtc?: Date | undefined;
    answersJson: string;
    answersJsonDocument?: JsonDocument | undefined;
    timezoneOffset: number;
    userAgent?: string | undefined;
    userIp?: string | undefined;
    answerLanguage?: string | undefined;
    branchId?: string | undefined;
    contactLevel?: ContactLevel | undefined;
    pageDisplayed?: boolean;
    survey?: Survey | undefined;
    alert?: Alert | undefined;
    result?: SurveyResult | undefined;
    taxonomies?: SurveyAnswerTaxonomy[] | undefined;
}

export enum SurveyState {
    InProgress = 0,
    Completed = 1,
    BlockedBySecurity = -3,
    Deleted = -2,
    Disabled = -1,
}

export enum ContactLevel {
    Unknown = 0,
    Anyone = 1,
    NoContact = 2,
    HeadOffice = 3,
}

export class Alert extends EntityBase implements IAlert {
    alertType?: AlertType;
    alertStatus?: AlertStatusType;
    title?: string | undefined;
    surveyAnswerId?: string;
    description?: string | undefined;
    statusHistoryJson?: string | undefined;
    triggeredItemsJson?: string | undefined;
    surveyAnswer?: SurveyAnswer | undefined;
    alertNotifications?: AlertNotification[] | undefined;

    constructor(data?: IAlert) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.alertType = _data["alertType"];
            this.alertStatus = _data["alertStatus"];
            this.title = _data["title"];
            this.surveyAnswerId = _data["surveyAnswerId"];
            this.description = _data["description"];
            this.statusHistoryJson = _data["statusHistoryJson"];
            this.triggeredItemsJson = _data["triggeredItemsJson"];
            this.surveyAnswer = _data["surveyAnswer"] ? SurveyAnswer.fromJS(_data["surveyAnswer"]) : <any>undefined;
            if (Array.isArray(_data["alertNotifications"])) {
                this.alertNotifications = [] as any;
                for (let item of _data["alertNotifications"])
                    this.alertNotifications!.push(AlertNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Alert {
        data = typeof data === 'object' ? data : {};
        let result = new Alert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertType"] = this.alertType;
        data["alertStatus"] = this.alertStatus;
        data["title"] = this.title;
        data["surveyAnswerId"] = this.surveyAnswerId;
        data["description"] = this.description;
        data["statusHistoryJson"] = this.statusHistoryJson;
        data["triggeredItemsJson"] = this.triggeredItemsJson;
        data["surveyAnswer"] = this.surveyAnswer ? this.surveyAnswer.toJSON() : <any>undefined;
        if (Array.isArray(this.alertNotifications)) {
            data["alertNotifications"] = [];
            for (let item of this.alertNotifications)
                data["alertNotifications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAlert extends IEntityBase {
    alertType?: AlertType;
    alertStatus?: AlertStatusType;
    title?: string | undefined;
    surveyAnswerId?: string;
    description?: string | undefined;
    statusHistoryJson?: string | undefined;
    triggeredItemsJson?: string | undefined;
    surveyAnswer?: SurveyAnswer | undefined;
    alertNotifications?: AlertNotification[] | undefined;
}

export class AlertNotification extends EntityBase implements IAlertNotification {
    alertId?: string;
    userEmailAddress?: string | undefined;
    isRead?: boolean;
    alert?: Alert | undefined;

    constructor(data?: IAlertNotification) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.alertId = _data["alertId"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.isRead = _data["isRead"];
            this.alert = _data["alert"] ? Alert.fromJS(_data["alert"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertNotification {
        data = typeof data === 'object' ? data : {};
        let result = new AlertNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["userEmailAddress"] = this.userEmailAddress;
        data["isRead"] = this.isRead;
        data["alert"] = this.alert ? this.alert.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAlertNotification extends IEntityBase {
    alertId?: string;
    userEmailAddress?: string | undefined;
    isRead?: boolean;
    alert?: Alert | undefined;
}

export class SurveyResult implements ISurveyResult {
    surveyAnswerId?: string;
    score?: number | undefined;
    scoreMax?: number | undefined;
    percentage?: number | undefined;
    surveyAnswer?: SurveyAnswer | undefined;
    categories?: SurveyResultCategory[] | undefined;
    details?: SurveyResultDetail[] | undefined;

    constructor(data?: ISurveyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyAnswerId = _data["surveyAnswerId"];
            this.score = _data["score"];
            this.scoreMax = _data["scoreMax"];
            this.percentage = _data["percentage"];
            this.surveyAnswer = _data["surveyAnswer"] ? SurveyAnswer.fromJS(_data["surveyAnswer"]) : <any>undefined;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(SurveyResultCategory.fromJS(item));
            }
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(SurveyResultDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResult {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyAnswerId"] = this.surveyAnswerId;
        data["score"] = this.score;
        data["scoreMax"] = this.scoreMax;
        data["percentage"] = this.percentage;
        data["surveyAnswer"] = this.surveyAnswer ? this.surveyAnswer.toJSON() : <any>undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyResult {
    surveyAnswerId?: string;
    score?: number | undefined;
    scoreMax?: number | undefined;
    percentage?: number | undefined;
    surveyAnswer?: SurveyAnswer | undefined;
    categories?: SurveyResultCategory[] | undefined;
    details?: SurveyResultDetail[] | undefined;
}

export class SurveyResultCategory implements ISurveyResultCategory {
    surveyAnswerId?: string;
    score?: number | undefined;
    scoreMax?: number | undefined;
    percentage?: number | undefined;
    categoryCode?: string | undefined;
    surveyAnswer?: SurveyResult | undefined;

    constructor(data?: ISurveyResultCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyAnswerId = _data["surveyAnswerId"];
            this.score = _data["score"];
            this.scoreMax = _data["scoreMax"];
            this.percentage = _data["percentage"];
            this.categoryCode = _data["categoryCode"];
            this.surveyAnswer = _data["surveyAnswer"] ? SurveyResult.fromJS(_data["surveyAnswer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyResultCategory {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyAnswerId"] = this.surveyAnswerId;
        data["score"] = this.score;
        data["scoreMax"] = this.scoreMax;
        data["percentage"] = this.percentage;
        data["categoryCode"] = this.categoryCode;
        data["surveyAnswer"] = this.surveyAnswer ? this.surveyAnswer.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISurveyResultCategory {
    surveyAnswerId?: string;
    score?: number | undefined;
    scoreMax?: number | undefined;
    percentage?: number | undefined;
    categoryCode?: string | undefined;
    surveyAnswer?: SurveyResult | undefined;
}

export class SurveyResultDetail implements ISurveyResultDetail {
    surveyAnswerId?: string;
    formVersionId?: string;
    questionName?: string | undefined;
    categoryCode?: string | undefined;
    score?: number | undefined;
    scoreMax?: number | undefined;
    formVersion?: FormVersion | undefined;

    constructor(data?: ISurveyResultDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyAnswerId = _data["surveyAnswerId"];
            this.formVersionId = _data["formVersionId"];
            this.questionName = _data["questionName"];
            this.categoryCode = _data["categoryCode"];
            this.score = _data["score"];
            this.scoreMax = _data["scoreMax"];
            this.formVersion = _data["formVersion"] ? FormVersion.fromJS(_data["formVersion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyResultDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyAnswerId"] = this.surveyAnswerId;
        data["formVersionId"] = this.formVersionId;
        data["questionName"] = this.questionName;
        data["categoryCode"] = this.categoryCode;
        data["score"] = this.score;
        data["scoreMax"] = this.scoreMax;
        data["formVersion"] = this.formVersion ? this.formVersion.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISurveyResultDetail {
    surveyAnswerId?: string;
    formVersionId?: string;
    questionName?: string | undefined;
    categoryCode?: string | undefined;
    score?: number | undefined;
    scoreMax?: number | undefined;
    formVersion?: FormVersion | undefined;
}

export class SurveyAnswerTaxonomy implements ISurveyAnswerTaxonomy {
    surveyAnswerId?: string;
    formVersionId?: string;
    taxonomy?: TaxonomyType;
    value?: string | undefined;
    surveyAnswer?: SurveyAnswer | undefined;
    formVersion?: FormVersion | undefined;

    constructor(data?: ISurveyAnswerTaxonomy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyAnswerId = _data["surveyAnswerId"];
            this.formVersionId = _data["formVersionId"];
            this.taxonomy = _data["taxonomy"];
            this.value = _data["value"];
            this.surveyAnswer = _data["surveyAnswer"] ? SurveyAnswer.fromJS(_data["surveyAnswer"]) : <any>undefined;
            this.formVersion = _data["formVersion"] ? FormVersion.fromJS(_data["formVersion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyAnswerTaxonomy {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerTaxonomy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyAnswerId"] = this.surveyAnswerId;
        data["formVersionId"] = this.formVersionId;
        data["taxonomy"] = this.taxonomy;
        data["value"] = this.value;
        data["surveyAnswer"] = this.surveyAnswer ? this.surveyAnswer.toJSON() : <any>undefined;
        data["formVersion"] = this.formVersion ? this.formVersion.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISurveyAnswerTaxonomy {
    surveyAnswerId?: string;
    formVersionId?: string;
    taxonomy?: TaxonomyType;
    value?: string | undefined;
    surveyAnswer?: SurveyAnswer | undefined;
    formVersion?: FormVersion | undefined;
}

export enum TaxonomyType {
    FirstName = 0,
    LastName = 1,
    Gender = 2,
    AgeGroup = 3,
    DateOfBirth = 4,
    Email = 5,
    Phone = 6,
    DateOfVisit = 7,
    ClientNumber = 8,
    NPS = 9,
    CES = 10,
    Motivation = 11,
    Contest = 12,
    AllowNewsletter = 13,
    TimeOfVisit = 14,
    CompetitorRating = 15,
    CompetitorName = 16,
    Receipt = 17,
}

export class Layout extends EntityBase implements ILayout {
    sourceId?: string | undefined;
    name?: string | undefined;
    data?: string | undefined;
    projectId!: string;
    project?: Project | undefined;
    layoutLanguages?: LayoutLanguage[] | undefined;

    constructor(data?: ILayout) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["layoutLanguages"])) {
                this.layoutLanguages = [] as any;
                for (let item of _data["layoutLanguages"])
                    this.layoutLanguages!.push(LayoutLanguage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Layout {
        data = typeof data === 'object' ? data : {};
        let result = new Layout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.layoutLanguages)) {
            data["layoutLanguages"] = [];
            for (let item of this.layoutLanguages)
                data["layoutLanguages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILayout extends IEntityBase {
    sourceId?: string | undefined;
    name?: string | undefined;
    data?: string | undefined;
    projectId: string;
    project?: Project | undefined;
    layoutLanguages?: LayoutLanguage[] | undefined;
}

export class LayoutLanguage extends EntityBase implements ILayoutLanguage {
    sourceId?: string | undefined;
    layoutId!: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
    layout?: Layout | undefined;
    layoutLanguageValues?: LayoutLanguageValues[] | undefined;

    constructor(data?: ILayoutLanguage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
            this.layout = _data["layout"] ? Layout.fromJS(_data["layout"]) : <any>undefined;
            if (Array.isArray(_data["layoutLanguageValues"])) {
                this.layoutLanguageValues = [] as any;
                for (let item of _data["layoutLanguageValues"])
                    this.layoutLanguageValues!.push(LayoutLanguageValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LayoutLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        if (Array.isArray(this.layoutLanguageValues)) {
            data["layoutLanguageValues"] = [];
            for (let item of this.layoutLanguageValues)
                data["layoutLanguageValues"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILayoutLanguage extends IEntityBase {
    sourceId?: string | undefined;
    layoutId: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
    layout?: Layout | undefined;
    layoutLanguageValues?: LayoutLanguageValues[] | undefined;
}

export class LayoutLanguageValues extends EntityBase implements ILayoutLanguageValues {
    layoutLanguageId!: string;
    surveyId!: string;
    valuesJson?: string | undefined;
    survey?: Survey | undefined;
    layoutLanguage?: LayoutLanguage | undefined;

    constructor(data?: ILayoutLanguageValues) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.layoutLanguageId = _data["layoutLanguageId"];
            this.surveyId = _data["surveyId"];
            this.valuesJson = _data["valuesJson"];
            this.survey = _data["survey"] ? Survey.fromJS(_data["survey"]) : <any>undefined;
            this.layoutLanguage = _data["layoutLanguage"] ? LayoutLanguage.fromJS(_data["layoutLanguage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LayoutLanguageValues {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutLanguageValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutLanguageId"] = this.layoutLanguageId;
        data["surveyId"] = this.surveyId;
        data["valuesJson"] = this.valuesJson;
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        data["layoutLanguage"] = this.layoutLanguage ? this.layoutLanguage.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILayoutLanguageValues extends IEntityBase {
    layoutLanguageId: string;
    surveyId: string;
    valuesJson?: string | undefined;
    survey?: Survey | undefined;
    layoutLanguage?: LayoutLanguage | undefined;
}

export class Template extends EntityBase implements ITemplate {
    sourceId?: string | undefined;
    layoutId?: string | undefined;
    projectId!: string;
    name?: string | undefined;
    data?: string | undefined;
    layout?: Layout | undefined;
    project?: Project | undefined;
    templateLanguages?: TemplateLanguage[] | undefined;

    constructor(data?: ITemplate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.layoutId = _data["layoutId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.layout = _data["layout"] ? Layout.fromJS(_data["layout"]) : <any>undefined;
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["templateLanguages"])) {
                this.templateLanguages = [] as any;
                for (let item of _data["templateLanguages"])
                    this.templateLanguages!.push(TemplateLanguage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Template {
        data = typeof data === 'object' ? data : {};
        let result = new Template();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["layoutId"] = this.layoutId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.templateLanguages)) {
            data["templateLanguages"] = [];
            for (let item of this.templateLanguages)
                data["templateLanguages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITemplate extends IEntityBase {
    sourceId?: string | undefined;
    layoutId?: string | undefined;
    projectId: string;
    name?: string | undefined;
    data?: string | undefined;
    layout?: Layout | undefined;
    project?: Project | undefined;
    templateLanguages?: TemplateLanguage[] | undefined;
}

export class TemplateLanguage extends EntityBase implements ITemplateLanguage {
    sourceId?: string | undefined;
    templateId!: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
    template?: Template | undefined;
    templateLanguageValues?: TemplateLanguageValues[] | undefined;

    constructor(data?: ITemplateLanguage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.templateId = _data["templateId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
            this.template = _data["template"] ? Template.fromJS(_data["template"]) : <any>undefined;
            if (Array.isArray(_data["templateLanguageValues"])) {
                this.templateLanguageValues = [] as any;
                for (let item of _data["templateLanguageValues"])
                    this.templateLanguageValues!.push(TemplateLanguageValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["templateId"] = this.templateId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        if (Array.isArray(this.templateLanguageValues)) {
            data["templateLanguageValues"] = [];
            for (let item of this.templateLanguageValues)
                data["templateLanguageValues"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateLanguage extends IEntityBase {
    sourceId?: string | undefined;
    templateId: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
    template?: Template | undefined;
    templateLanguageValues?: TemplateLanguageValues[] | undefined;
}

export class TemplateLanguageValues extends EntityBase implements ITemplateLanguageValues {
    templateLanguageId!: string;
    surveyId!: string;
    valuesJson?: string | undefined;
    survey?: Survey | undefined;
    templateLanguage?: TemplateLanguage | undefined;
    headTitle?: string | undefined;

    constructor(data?: ITemplateLanguageValues) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateLanguageId = _data["templateLanguageId"];
            this.surveyId = _data["surveyId"];
            this.valuesJson = _data["valuesJson"];
            this.survey = _data["survey"] ? Survey.fromJS(_data["survey"]) : <any>undefined;
            this.templateLanguage = _data["templateLanguage"] ? TemplateLanguage.fromJS(_data["templateLanguage"]) : <any>undefined;
            this.headTitle = _data["headTitle"];
        }
    }

    static fromJS(data: any): TemplateLanguageValues {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateLanguageValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateLanguageId"] = this.templateLanguageId;
        data["surveyId"] = this.surveyId;
        data["valuesJson"] = this.valuesJson;
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        data["templateLanguage"] = this.templateLanguage ? this.templateLanguage.toJSON() : <any>undefined;
        data["headTitle"] = this.headTitle;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateLanguageValues extends IEntityBase {
    templateLanguageId: string;
    surveyId: string;
    valuesJson?: string | undefined;
    survey?: Survey | undefined;
    templateLanguage?: TemplateLanguage | undefined;
    headTitle?: string | undefined;
}

export class ProjectCulture extends EntityBase implements IProjectCulture {
    projectId?: string;
    name?: string | undefined;
    cultureCode?: string | undefined;
    project?: Project | undefined;
    state?: string | undefined;

    constructor(data?: IProjectCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ProjectCulture {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectCulture extends IEntityBase {
    projectId?: string;
    name?: string | undefined;
    cultureCode?: string | undefined;
    project?: Project | undefined;
    state?: string | undefined;
}

export class CategoryCulture extends EntityBase implements ICategoryCulture {
    categoryId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    cultureCode?: string | undefined;
    category?: Category | undefined;

    constructor(data?: ICategoryCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.cultureCode = _data["cultureCode"];
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CategoryCulture {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["cultureCode"] = this.cultureCode;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICategoryCulture extends IEntityBase {
    categoryId?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    cultureCode?: string | undefined;
    category?: Category | undefined;
}

export class DashboardOptions implements IDashboardOptions {
    subscriptionServiceId?: string;
    langCode?: string | undefined;
    detailed?: boolean | undefined;
    compareCategories?: boolean | undefined;
    locations?: string[] | undefined;
    categories?: string[] | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    loadDemoData?: boolean | undefined;
    branchServiceId?: string | undefined;
    branchIds?: string[] | undefined;
    startDate?: Date;
    endDate?: Date;
    dateType?: DateType;
    questionFilters?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;

    constructor(data?: IDashboardOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.langCode = _data["langCode"];
            this.detailed = _data["detailed"];
            this.compareCategories = _data["compareCategories"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(item);
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.loadDemoData = _data["loadDemoData"];
            this.branchServiceId = _data["branchServiceId"];
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.dateType = _data["dateType"];
            if (Array.isArray(_data["questionFilters"])) {
                this.questionFilters = [] as any;
                for (let item of _data["questionFilters"])
                    this.questionFilters!.push(KeyValuePairOfStringAndIEnumerableOfString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOptions {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["langCode"] = this.langCode;
        data["detailed"] = this.detailed;
        data["compareCategories"] = this.compareCategories;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["loadDemoData"] = this.loadDemoData;
        data["branchServiceId"] = this.branchServiceId;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["dateType"] = this.dateType;
        if (Array.isArray(this.questionFilters)) {
            data["questionFilters"] = [];
            for (let item of this.questionFilters)
                data["questionFilters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardOptions {
    subscriptionServiceId?: string;
    langCode?: string | undefined;
    detailed?: boolean | undefined;
    compareCategories?: boolean | undefined;
    locations?: string[] | undefined;
    categories?: string[] | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    loadDemoData?: boolean | undefined;
    branchServiceId?: string | undefined;
    branchIds?: string[] | undefined;
    startDate?: Date;
    endDate?: Date;
    dateType?: DateType;
    questionFilters?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;
}

export class KeyValuePairOfStringAndIEnumerableOfString implements IKeyValuePairOfStringAndIEnumerableOfString {
    key?: string | undefined;
    value?: string[] | undefined;

    constructor(data?: IKeyValuePairOfStringAndIEnumerableOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndIEnumerableOfString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndIEnumerableOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IKeyValuePairOfStringAndIEnumerableOfString {
    key?: string | undefined;
    value?: string[] | undefined;
}

export class GetPredefinedFlowViewModel implements IGetPredefinedFlowViewModel {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    serviceId?: string;
    flowJson?: string | undefined;

    constructor(data?: IGetPredefinedFlowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.serviceId = _data["serviceId"];
            this.flowJson = _data["flowJson"];
        }
    }

    static fromJS(data: any): GetPredefinedFlowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredefinedFlowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["serviceId"] = this.serviceId;
        data["flowJson"] = this.flowJson;
        return data;
    }
}

export interface IGetPredefinedFlowViewModel {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    serviceId?: string;
    flowJson?: string | undefined;
}

export class CreatePredefinedFlowViewModel implements ICreatePredefinedFlowViewModel {
    id?: string;

    constructor(data?: ICreatePredefinedFlowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePredefinedFlowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedFlowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreatePredefinedFlowViewModel {
    id?: string;
}

export class CreatePredefinedFlowCommandDto implements ICreatePredefinedFlowCommandDto {
    serviceId?: string;
    flowJson?: string | undefined;

    constructor(data?: ICreatePredefinedFlowCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.flowJson = _data["flowJson"];
        }
    }

    static fromJS(data: any): CreatePredefinedFlowCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedFlowCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["flowJson"] = this.flowJson;
        return data;
    }
}

export interface ICreatePredefinedFlowCommandDto {
    serviceId?: string;
    flowJson?: string | undefined;
}

export class UpdatePredefinedFlowViewModel implements IUpdatePredefinedFlowViewModel {
    id?: string;

    constructor(data?: IUpdatePredefinedFlowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePredefinedFlowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedFlowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdatePredefinedFlowViewModel {
    id?: string;
}

export class UpdatePredefinedFlowCommandDto implements IUpdatePredefinedFlowCommandDto {
    id?: string;
    serviceId?: string;
    flowJson?: string | undefined;

    constructor(data?: IUpdatePredefinedFlowCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.flowJson = _data["flowJson"];
        }
    }

    static fromJS(data: any): UpdatePredefinedFlowCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedFlowCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["flowJson"] = this.flowJson;
        return data;
    }
}

export interface IUpdatePredefinedFlowCommandDto {
    id?: string;
    serviceId?: string;
    flowJson?: string | undefined;
}

export class DeletePredefinedFlowViewModel implements IDeletePredefinedFlowViewModel {
    id?: string;

    constructor(data?: IDeletePredefinedFlowViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeletePredefinedFlowViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePredefinedFlowViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeletePredefinedFlowViewModel {
    id?: string;
}

export class GetPredefinedFormViewModel implements IGetPredefinedFormViewModel {
    predefinedForm?: PredefinedFormDto | undefined;

    constructor(data?: IGetPredefinedFormViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predefinedForm = _data["predefinedForm"] ? PredefinedFormDto.fromJS(_data["predefinedForm"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPredefinedFormViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredefinedFormViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predefinedForm"] = this.predefinedForm ? this.predefinedForm.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPredefinedFormViewModel {
    predefinedForm?: PredefinedFormDto | undefined;
}

export class PredefinedFormDto implements IPredefinedFormDto {
    id?: string;
    serviceId?: string;
    name?: string | undefined;
    formVersions?: PredefinedFormVersionDto[] | undefined;

    constructor(data?: IPredefinedFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.name = _data["name"];
            if (Array.isArray(_data["formVersions"])) {
                this.formVersions = [] as any;
                for (let item of _data["formVersions"])
                    this.formVersions!.push(PredefinedFormVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PredefinedFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["name"] = this.name;
        if (Array.isArray(this.formVersions)) {
            data["formVersions"] = [];
            for (let item of this.formVersions)
                data["formVersions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPredefinedFormDto {
    id?: string;
    serviceId?: string;
    name?: string | undefined;
    formVersions?: PredefinedFormVersionDto[] | undefined;
}

export class PredefinedFormVersionDto implements IPredefinedFormVersionDto {
    id?: string;
    serviceId?: string;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;

    constructor(data?: IPredefinedFormVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.formId = _data["formId"];
            this.state = _data["state"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): PredefinedFormVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedFormVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["formId"] = this.formId;
        data["state"] = this.state;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IPredefinedFormVersionDto {
    id?: string;
    serviceId?: string;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;
}

export class CreatePredefinedFormViewModel implements ICreatePredefinedFormViewModel {
    id?: string;

    constructor(data?: ICreatePredefinedFormViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePredefinedFormViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedFormViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreatePredefinedFormViewModel {
    id?: string;
}

export class CreatePredefinedFormCommandDto implements ICreatePredefinedFormCommandDto {
    serviceId?: string;
    name?: string | undefined;

    constructor(data?: ICreatePredefinedFormCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePredefinedFormCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedFormCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreatePredefinedFormCommandDto {
    serviceId?: string;
    name?: string | undefined;
}

export class UpdatePredefinedFormViewModel implements IUpdatePredefinedFormViewModel {
    id?: string;

    constructor(data?: IUpdatePredefinedFormViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePredefinedFormViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedFormViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdatePredefinedFormViewModel {
    id?: string;
}

export class UpdatePredefinedFormCommandDto implements IUpdatePredefinedFormCommandDto {
    id?: string;
    serviceId?: string;
    name?: string | undefined;

    constructor(data?: IUpdatePredefinedFormCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdatePredefinedFormCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedFormCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdatePredefinedFormCommandDto {
    id?: string;
    serviceId?: string;
    name?: string | undefined;
}

export class DeletePredefinedFormViewModel implements IDeletePredefinedFormViewModel {
    id?: string;

    constructor(data?: IDeletePredefinedFormViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeletePredefinedFormViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePredefinedFormViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeletePredefinedFormViewModel {
    id?: string;
}

export class GetPredefinedFormVersionViewModel implements IGetPredefinedFormVersionViewModel {
    predefinedFormVersion?: PredefinedFormVersionDto2 | undefined;

    constructor(data?: IGetPredefinedFormVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predefinedFormVersion = _data["predefinedFormVersion"] ? PredefinedFormVersionDto2.fromJS(_data["predefinedFormVersion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPredefinedFormVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredefinedFormVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predefinedFormVersion"] = this.predefinedFormVersion ? this.predefinedFormVersion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPredefinedFormVersionViewModel {
    predefinedFormVersion?: PredefinedFormVersionDto2 | undefined;
}

export class PredefinedFormVersionDto2 implements IPredefinedFormVersionDto2 {
    id?: string;
    serviceId?: string;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;

    constructor(data?: IPredefinedFormVersionDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.formId = _data["formId"];
            this.state = _data["state"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): PredefinedFormVersionDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedFormVersionDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["formId"] = this.formId;
        data["state"] = this.state;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IPredefinedFormVersionDto2 {
    id?: string;
    serviceId?: string;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;
}

export class CreatePredefinedFormVersionViewModel implements ICreatePredefinedFormVersionViewModel {
    id?: string;

    constructor(data?: ICreatePredefinedFormVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePredefinedFormVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedFormVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreatePredefinedFormVersionViewModel {
    id?: string;
}

export class CreatePredefinedFormVersionCommandDto implements ICreatePredefinedFormVersionCommandDto {
    serviceId?: string;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;

    constructor(data?: ICreatePredefinedFormVersionCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.formId = _data["formId"];
            this.state = _data["state"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): CreatePredefinedFormVersionCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedFormVersionCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["formId"] = this.formId;
        data["state"] = this.state;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface ICreatePredefinedFormVersionCommandDto {
    serviceId?: string;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;
}

export class UpdatePredefinedFormVersionViewModel implements IUpdatePredefinedFormVersionViewModel {
    id?: string;

    constructor(data?: IUpdatePredefinedFormVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePredefinedFormVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedFormVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdatePredefinedFormVersionViewModel {
    id?: string;
}

export class UpdatePredefinedFormVersionCommandDto implements IUpdatePredefinedFormVersionCommandDto {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    serviceId?: string;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;

    constructor(data?: IUpdatePredefinedFormVersionCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.serviceId = _data["serviceId"];
            this.formId = _data["formId"];
            this.state = _data["state"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): UpdatePredefinedFormVersionCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedFormVersionCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["serviceId"] = this.serviceId;
        data["formId"] = this.formId;
        data["state"] = this.state;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IUpdatePredefinedFormVersionCommandDto {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    serviceId?: string;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string | undefined;
}

export class DeletePredefinedFormVersionViewModel implements IDeletePredefinedFormVersionViewModel {
    id?: string;

    constructor(data?: IDeletePredefinedFormVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeletePredefinedFormVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePredefinedFormVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeletePredefinedFormVersionViewModel {
    id?: string;
}

export class GetPredefinedLayoutViewModel implements IGetPredefinedLayoutViewModel {
    predefinedForm?: PredefinedLayoutDto | undefined;

    constructor(data?: IGetPredefinedLayoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predefinedForm = _data["predefinedForm"] ? PredefinedLayoutDto.fromJS(_data["predefinedForm"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPredefinedLayoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredefinedLayoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predefinedForm"] = this.predefinedForm ? this.predefinedForm.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPredefinedLayoutViewModel {
    predefinedForm?: PredefinedLayoutDto | undefined;
}

export class PredefinedLayoutDto implements IPredefinedLayoutDto {
    id?: string;
    serviceId?: string;
    name?: string | undefined;
    data?: string | undefined;
    layoutLanguages?: PredefinedLayoutLanguageDto[] | undefined;

    constructor(data?: IPredefinedLayoutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.name = _data["name"];
            this.data = _data["data"];
            if (Array.isArray(_data["layoutLanguages"])) {
                this.layoutLanguages = [] as any;
                for (let item of _data["layoutLanguages"])
                    this.layoutLanguages!.push(PredefinedLayoutLanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PredefinedLayoutDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedLayoutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["name"] = this.name;
        data["data"] = this.data;
        if (Array.isArray(this.layoutLanguages)) {
            data["layoutLanguages"] = [];
            for (let item of this.layoutLanguages)
                data["layoutLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPredefinedLayoutDto {
    id?: string;
    serviceId?: string;
    name?: string | undefined;
    data?: string | undefined;
    layoutLanguages?: PredefinedLayoutLanguageDto[] | undefined;
}

export class PredefinedLayoutLanguageDto implements IPredefinedLayoutLanguageDto {
    id?: string;
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: IPredefinedLayoutLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): PredefinedLayoutLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedLayoutLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IPredefinedLayoutLanguageDto {
    id?: string;
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class CreatePredefinedLayoutViewModel implements ICreatePredefinedLayoutViewModel {
    id?: string;

    constructor(data?: ICreatePredefinedLayoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePredefinedLayoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedLayoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreatePredefinedLayoutViewModel {
    id?: string;
}

export class CreatePredefinedLayoutCommandDto implements ICreatePredefinedLayoutCommandDto {
    serviceId?: string;
    name?: string | undefined;
    data?: string | undefined;

    constructor(data?: ICreatePredefinedLayoutCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.name = _data["name"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CreatePredefinedLayoutCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedLayoutCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["name"] = this.name;
        data["data"] = this.data;
        return data;
    }
}

export interface ICreatePredefinedLayoutCommandDto {
    serviceId?: string;
    name?: string | undefined;
    data?: string | undefined;
}

export class UpdatePredefinedLayoutViewModel implements IUpdatePredefinedLayoutViewModel {
    id?: string;

    constructor(data?: IUpdatePredefinedLayoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePredefinedLayoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedLayoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdatePredefinedLayoutViewModel {
    id?: string;
}

export class UpdatePredefinedLayoutCommandDto implements IUpdatePredefinedLayoutCommandDto {
    id?: string;
    serviceId?: string;
    name?: string | undefined;
    data?: string | undefined;

    constructor(data?: IUpdatePredefinedLayoutCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.name = _data["name"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UpdatePredefinedLayoutCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedLayoutCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["name"] = this.name;
        data["data"] = this.data;
        return data;
    }
}

export interface IUpdatePredefinedLayoutCommandDto {
    id?: string;
    serviceId?: string;
    name?: string | undefined;
    data?: string | undefined;
}

export class DeletePredefinedLayoutViewModel implements IDeletePredefinedLayoutViewModel {
    id?: string;

    constructor(data?: IDeletePredefinedLayoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeletePredefinedLayoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePredefinedLayoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeletePredefinedLayoutViewModel {
    id?: string;
}

export class GetPredefinedLayoutCultureViewModel implements IGetPredefinedLayoutCultureViewModel {
    predefinedLayoutLanguage?: PredefinedLayoutLanguageDto2 | undefined;

    constructor(data?: IGetPredefinedLayoutCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predefinedLayoutLanguage = _data["predefinedLayoutLanguage"] ? PredefinedLayoutLanguageDto2.fromJS(_data["predefinedLayoutLanguage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPredefinedLayoutCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredefinedLayoutCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predefinedLayoutLanguage"] = this.predefinedLayoutLanguage ? this.predefinedLayoutLanguage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPredefinedLayoutCultureViewModel {
    predefinedLayoutLanguage?: PredefinedLayoutLanguageDto2 | undefined;
}

export class PredefinedLayoutLanguageDto2 implements IPredefinedLayoutLanguageDto2 {
    id?: string;
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: IPredefinedLayoutLanguageDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): PredefinedLayoutLanguageDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedLayoutLanguageDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IPredefinedLayoutLanguageDto2 {
    id?: string;
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class CreatePredefinedLayoutCultureViewModel implements ICreatePredefinedLayoutCultureViewModel {
    id?: string;

    constructor(data?: ICreatePredefinedLayoutCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePredefinedLayoutCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedLayoutCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreatePredefinedLayoutCultureViewModel {
    id?: string;
}

export class CreatePredefinedLayoutCultureCommandDto implements ICreatePredefinedLayoutCultureCommandDto {
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: ICreatePredefinedLayoutCultureCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): CreatePredefinedLayoutCultureCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedLayoutCultureCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface ICreatePredefinedLayoutCultureCommandDto {
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class UpdatePredefinedLayoutCultureViewModel implements IUpdatePredefinedLayoutCultureViewModel {
    id?: string;

    constructor(data?: IUpdatePredefinedLayoutCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePredefinedLayoutCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedLayoutCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdatePredefinedLayoutCultureViewModel {
    id?: string;
}

export class UpdatePredefinedLayoutCultureCommandDto implements IUpdatePredefinedLayoutCultureCommandDto {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: IUpdatePredefinedLayoutCultureCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.serviceId = _data["serviceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): UpdatePredefinedLayoutCultureCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedLayoutCultureCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["serviceId"] = this.serviceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IUpdatePredefinedLayoutCultureCommandDto {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class DeletePredefinedLayoutCultureViewModel implements IDeletePredefinedLayoutCultureViewModel {
    id?: string;

    constructor(data?: IDeletePredefinedLayoutCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeletePredefinedLayoutCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePredefinedLayoutCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeletePredefinedLayoutCultureViewModel {
    id?: string;
}

export class GetPredefinedTemplateViewModel implements IGetPredefinedTemplateViewModel {
    predefinedTemplate?: PredefinedTemplateDto | undefined;

    constructor(data?: IGetPredefinedTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predefinedTemplate = _data["predefinedTemplate"] ? PredefinedTemplateDto.fromJS(_data["predefinedTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPredefinedTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredefinedTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predefinedTemplate"] = this.predefinedTemplate ? this.predefinedTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPredefinedTemplateViewModel {
    predefinedTemplate?: PredefinedTemplateDto | undefined;
}

export class PredefinedTemplateDto implements IPredefinedTemplateDto {
    id?: string;
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;

    constructor(data?: IPredefinedTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): PredefinedTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        return data;
    }
}

export interface IPredefinedTemplateDto {
    id?: string;
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
}

export class CreatePredefinedTemplateViewModel implements ICreatePredefinedTemplateViewModel {
    id?: string;

    constructor(data?: ICreatePredefinedTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePredefinedTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreatePredefinedTemplateViewModel {
    id?: string;
}

export class CreatePredefinedTemplateCommandDto implements ICreatePredefinedTemplateCommandDto {
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;

    constructor(data?: ICreatePredefinedTemplateCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CreatePredefinedTemplateCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedTemplateCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        return data;
    }
}

export interface ICreatePredefinedTemplateCommandDto {
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
}

export class UpdatePredefinedTemplateViewModel implements IUpdatePredefinedTemplateViewModel {
    id?: string;

    constructor(data?: IUpdatePredefinedTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePredefinedTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdatePredefinedTemplateViewModel {
    id?: string;
}

export class UpdatePredefinedTemplateCommandDto implements IUpdatePredefinedTemplateCommandDto {
    id?: string;
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;

    constructor(data?: IUpdatePredefinedTemplateCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.layoutId = _data["layoutId"];
            this.name = _data["name"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UpdatePredefinedTemplateCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedTemplateCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["layoutId"] = this.layoutId;
        data["name"] = this.name;
        data["data"] = this.data;
        return data;
    }
}

export interface IUpdatePredefinedTemplateCommandDto {
    id?: string;
    serviceId?: string;
    layoutId?: string;
    name?: string | undefined;
    data?: string | undefined;
}

export class DeletePredefinedTemplateViewModel implements IDeletePredefinedTemplateViewModel {
    id?: string;

    constructor(data?: IDeletePredefinedTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeletePredefinedTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePredefinedTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeletePredefinedTemplateViewModel {
    id?: string;
}

export class GetPredefinedTemplateCultureViewModel implements IGetPredefinedTemplateCultureViewModel {
    predefinedTemplate?: PredefinedTemplateLanguageDto | undefined;

    constructor(data?: IGetPredefinedTemplateCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predefinedTemplate = _data["predefinedTemplate"] ? PredefinedTemplateLanguageDto.fromJS(_data["predefinedTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPredefinedTemplateCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredefinedTemplateCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predefinedTemplate"] = this.predefinedTemplate ? this.predefinedTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPredefinedTemplateCultureViewModel {
    predefinedTemplate?: PredefinedTemplateLanguageDto | undefined;
}

export class PredefinedTemplateLanguageDto implements IPredefinedTemplateLanguageDto {
    id?: string;
    serviceId?: string;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: IPredefinedTemplateLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.templateId = _data["templateId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): PredefinedTemplateLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedTemplateLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["templateId"] = this.templateId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IPredefinedTemplateLanguageDto {
    id?: string;
    serviceId?: string;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class CreatePredefinedTemplateCultureViewModel implements ICreatePredefinedTemplateCultureViewModel {
    id?: string;

    constructor(data?: ICreatePredefinedTemplateCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePredefinedTemplateCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedTemplateCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreatePredefinedTemplateCultureViewModel {
    id?: string;
}

export class CreatePredefinedTemplateCultureCommandDto implements ICreatePredefinedTemplateCultureCommandDto {
    serviceId?: string;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: ICreatePredefinedTemplateCultureCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.templateId = _data["templateId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): CreatePredefinedTemplateCultureCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePredefinedTemplateCultureCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["templateId"] = this.templateId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface ICreatePredefinedTemplateCultureCommandDto {
    serviceId?: string;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class UpdatePredefinedTemplateCultureViewModel implements IUpdatePredefinedTemplateCultureViewModel {
    id?: string;

    constructor(data?: IUpdatePredefinedTemplateCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePredefinedTemplateCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedTemplateCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdatePredefinedTemplateCultureViewModel {
    id?: string;
}

export class UpdatePredefinedTemplateCultureCommandDto implements IUpdatePredefinedTemplateCultureCommandDto {
    id?: string;
    serviceId?: string;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: IUpdatePredefinedTemplateCultureCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.templateId = _data["templateId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): UpdatePredefinedTemplateCultureCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePredefinedTemplateCultureCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["templateId"] = this.templateId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IUpdatePredefinedTemplateCultureCommandDto {
    id?: string;
    serviceId?: string;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class DeletePredefinedTemplateCultureViewModel implements IDeletePredefinedTemplateCultureViewModel {
    id?: string;

    constructor(data?: IDeletePredefinedTemplateCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeletePredefinedTemplateCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePredefinedTemplateCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeletePredefinedTemplateCultureViewModel {
    id?: string;
}

export class UrlViewModel implements IUrlViewModel {
    location?: string | undefined;

    constructor(data?: IUrlViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): UrlViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UrlViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        return data;
    }
}

export interface IUrlViewModel {
    location?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export enum ReportType {
    StatisticSummary = 0,
    SuccessRatePerQuestion = 1,
    ListOfNewsLetterSubscribers = 2,
    ConnectionsReport = 3,
    RawSurveyData = 4,
    SurveyData = 5,
    CompletionRate = 6,
    ListOfEmailUnsubscribers = 7,
    CustomerStatements = 8,
    CustomReportSsq = 99,
    CustomCompletionReportSsq = 100,
}

export class ReportsOption implements IReportsOption {
    reportType?: ReportType;
    subscriptionServiceId?: string;
    startDate?: Date;
    endDate?: Date;
    dateType?: DateType;
    locations?: string[] | undefined;
    delimiter?: string | undefined;
    locationDescription?: string | undefined;
    questionFilters?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;
    customReportKey?: string | undefined;
    includeCustomImportFields?: boolean;
    loadDemoData?: boolean;
    unsubscribeFilter?: UnsubscribeTypes;

    constructor(data?: IReportsOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportType = _data["reportType"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.dateType = _data["dateType"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(item);
            }
            this.delimiter = _data["delimiter"];
            this.locationDescription = _data["locationDescription"];
            if (Array.isArray(_data["questionFilters"])) {
                this.questionFilters = [] as any;
                for (let item of _data["questionFilters"])
                    this.questionFilters!.push(KeyValuePairOfStringAndIEnumerableOfString.fromJS(item));
            }
            this.customReportKey = _data["customReportKey"];
            this.includeCustomImportFields = _data["includeCustomImportFields"];
            this.loadDemoData = _data["loadDemoData"];
            this.unsubscribeFilter = _data["unsubscribeFilter"];
        }
    }

    static fromJS(data: any): ReportsOption {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportType"] = this.reportType;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["dateType"] = this.dateType;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item);
        }
        data["delimiter"] = this.delimiter;
        data["locationDescription"] = this.locationDescription;
        if (Array.isArray(this.questionFilters)) {
            data["questionFilters"] = [];
            for (let item of this.questionFilters)
                data["questionFilters"].push(item.toJSON());
        }
        data["customReportKey"] = this.customReportKey;
        data["includeCustomImportFields"] = this.includeCustomImportFields;
        data["loadDemoData"] = this.loadDemoData;
        data["unsubscribeFilter"] = this.unsubscribeFilter;
        return data;
    }
}

export interface IReportsOption {
    reportType?: ReportType;
    subscriptionServiceId?: string;
    startDate?: Date;
    endDate?: Date;
    dateType?: DateType;
    locations?: string[] | undefined;
    delimiter?: string | undefined;
    locationDescription?: string | undefined;
    questionFilters?: KeyValuePairOfStringAndIEnumerableOfString[] | undefined;
    customReportKey?: string | undefined;
    includeCustomImportFields?: boolean;
    loadDemoData?: boolean;
    unsubscribeFilter?: UnsubscribeTypes;
}

export enum UnsubscribeTypes {
    ClientOnly = 0,
    InternalOnly = 1,
    All = 99,
}

export class CanAccessViewModel implements ICanAccessViewModel {
    canAccess?: boolean;

    constructor(data?: ICanAccessViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAccess = _data["canAccess"];
        }
    }

    static fromJS(data: any): CanAccessViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CanAccessViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAccess"] = this.canAccess;
        return data;
    }
}

export interface ICanAccessViewModel {
    canAccess?: boolean;
}

export class ProjectUrlAvailabilityViewModel implements IProjectUrlAvailabilityViewModel {
    requestedUrl?: string;
    isAvailable?: boolean;
    suggestions?: string[];

    constructor(data?: IProjectUrlAvailabilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedUrl = _data["requestedUrl"];
            this.isAvailable = _data["isAvailable"];
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectUrlAvailabilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUrlAvailabilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedUrl"] = this.requestedUrl;
        data["isAvailable"] = this.isAvailable;
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item);
        }
        return data;
    }
}

export interface IProjectUrlAvailabilityViewModel {
    requestedUrl?: string;
    isAvailable?: boolean;
    suggestions?: string[];
}

export class ProjectUrlAvailabilityDto implements IProjectUrlAvailabilityDto {
    requestedUrl!: string;
    voiceOfCustomerServiceId?: string | undefined;

    constructor(data?: IProjectUrlAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedUrl = _data["requestedUrl"];
            this.voiceOfCustomerServiceId = _data["voiceOfCustomerServiceId"];
        }
    }

    static fromJS(data: any): ProjectUrlAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUrlAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedUrl"] = this.requestedUrl;
        data["voiceOfCustomerServiceId"] = this.voiceOfCustomerServiceId;
        return data;
    }
}

export interface IProjectUrlAvailabilityDto {
    requestedUrl: string;
    voiceOfCustomerServiceId?: string | undefined;
}

export class GetSurveyAddressViewModel implements IGetSurveyAddressViewModel {
    id?: string;
    url?: string;

    constructor(data?: IGetSurveyAddressViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GetSurveyAddressViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAddressViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        return data;
    }
}

export interface IGetSurveyAddressViewModel {
    id?: string;
    url?: string;
}

export class RegisterProjectUrlViewModel implements IRegisterProjectUrlViewModel {
    id?: string;

    constructor(data?: IRegisterProjectUrlViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegisterProjectUrlViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterProjectUrlViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRegisterProjectUrlViewModel {
    id?: string;
}

export class UserOrganizationOwnerHasSurveysViewModel implements IUserOrganizationOwnerHasSurveysViewModel {
    requiresRedirectToSignup?: boolean;
    missingLevel?: SubjectType | undefined;

    constructor(data?: IUserOrganizationOwnerHasSurveysViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requiresRedirectToSignup = _data["requiresRedirectToSignup"];
            this.missingLevel = _data["missingLevel"];
        }
    }

    static fromJS(data: any): UserOrganizationOwnerHasSurveysViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganizationOwnerHasSurveysViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiresRedirectToSignup"] = this.requiresRedirectToSignup;
        data["missingLevel"] = this.missingLevel;
        return data;
    }
}

export interface IUserOrganizationOwnerHasSurveysViewModel {
    requiresRedirectToSignup?: boolean;
    missingLevel?: SubjectType | undefined;
}

export class GetIfDemoModeViewModel implements IGetIfDemoModeViewModel {
    sendToDemoMode?: boolean;

    constructor(data?: IGetIfDemoModeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendToDemoMode = _data["sendToDemoMode"];
        }
    }

    static fromJS(data: any): GetIfDemoModeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetIfDemoModeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendToDemoMode"] = this.sendToDemoMode;
        return data;
    }
}

export interface IGetIfDemoModeViewModel {
    sendToDemoMode?: boolean;
}

export class SignupDetailsViewModel implements ISignupDetailsViewModel {
    industryId?: string | undefined;
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    branch?: BranchDto3 | undefined;
    businessName?: string | undefined;
    subscriptionInformation?: SubscriptionInformationDto2[] | undefined;

    constructor(data?: ISignupDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.industryId = _data["industryId"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.branch = _data["branch"] ? BranchDto3.fromJS(_data["branch"]) : <any>undefined;
            this.businessName = _data["businessName"];
            if (Array.isArray(_data["subscriptionInformation"])) {
                this.subscriptionInformation = [] as any;
                for (let item of _data["subscriptionInformation"])
                    this.subscriptionInformation!.push(SubscriptionInformationDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignupDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SignupDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryId"] = this.industryId;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["businessName"] = this.businessName;
        if (Array.isArray(this.subscriptionInformation)) {
            data["subscriptionInformation"] = [];
            for (let item of this.subscriptionInformation)
                data["subscriptionInformation"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISignupDetailsViewModel {
    industryId?: string | undefined;
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    branch?: BranchDto3 | undefined;
    businessName?: string | undefined;
    subscriptionInformation?: SubscriptionInformationDto2[] | undefined;
}

export class BranchDto3 implements IBranchDto3 {
    id?: string;
    phone?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    department?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    services?: BranchServiceDto[];

    constructor(data?: IBranchDto3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.country = _data["country"];
            this.department = _data["department"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(BranchServiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchDto3 {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDto3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["country"] = this.country;
        data["department"] = this.department;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchDto3 {
    id?: string;
    phone?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    department?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    services?: BranchServiceDto[];
}

export class BranchServiceDto implements IBranchServiceDto {
    id?: string | undefined;
    subscriptionId?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;

    constructor(data?: IBranchServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriptionId = _data["subscriptionId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): BranchServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriptionId"] = this.subscriptionId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        return data;
    }
}

export interface IBranchServiceDto {
    id?: string | undefined;
    subscriptionId?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;
}

export class SubscriptionInformationDto2 implements ISubscriptionInformationDto2 {
    id?: string;
    subscriptionId?: string;
    key?: QuestionType;
    value?: string | undefined;

    constructor(data?: ISubscriptionInformationDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriptionId = _data["subscriptionId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SubscriptionInformationDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInformationDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriptionId"] = this.subscriptionId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ISubscriptionInformationDto2 {
    id?: string;
    subscriptionId?: string;
    key?: QuestionType;
    value?: string | undefined;
}

export class OrganizationPlaceholderViewModel implements IOrganizationPlaceholderViewModel {
    organizationId?: string;

    constructor(data?: IOrganizationPlaceholderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): OrganizationPlaceholderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationPlaceholderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IOrganizationPlaceholderViewModel {
    organizationId?: string;
}

export class SignupDetailsViewModel2 implements ISignupDetailsViewModel2 {
    industryId?: string | undefined;
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    branch?: BranchDto4 | undefined;
    businessName?: string | undefined;

    constructor(data?: ISignupDetailsViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.industryId = _data["industryId"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.branch = _data["branch"] ? BranchDto4.fromJS(_data["branch"]) : <any>undefined;
            this.businessName = _data["businessName"];
        }
    }

    static fromJS(data: any): SignupDetailsViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new SignupDetailsViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryId"] = this.industryId;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["businessName"] = this.businessName;
        return data;
    }
}

export interface ISignupDetailsViewModel2 {
    industryId?: string | undefined;
    organizationId?: string | undefined;
    subscriptionId?: string | undefined;
    subscriptionServiceId?: string | undefined;
    branch?: BranchDto4 | undefined;
    businessName?: string | undefined;
}

export class BranchDto4 implements IBranchDto4 {
    id?: string;
    phone?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    department?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    services?: BranchServiceDto2[] | undefined;

    constructor(data?: IBranchDto4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.country = _data["country"];
            this.department = _data["department"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(BranchServiceDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchDto4 {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDto4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["country"] = this.country;
        data["department"] = this.department;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchDto4 {
    id?: string;
    phone?: string | undefined;
    address?: string | undefined;
    country?: string | undefined;
    department?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    services?: BranchServiceDto2[] | undefined;
}

export class BranchServiceDto2 implements IBranchServiceDto2 {
    id?: string | undefined;
    subscriptionId?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;

    constructor(data?: IBranchServiceDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriptionId = _data["subscriptionId"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): BranchServiceDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new BranchServiceDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriptionId"] = this.subscriptionId;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        return data;
    }
}

export interface IBranchServiceDto2 {
    id?: string | undefined;
    subscriptionId?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;
}

export class SetupSubscriptionViewModel implements ISetupSubscriptionViewModel {
    name?: string | undefined;
    industryId?: string | undefined;
    subscriptionInformation?: SubscriptionInformationDto3[] | undefined;
    branch?: BranchDto4 | undefined;

    constructor(data?: ISetupSubscriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.industryId = _data["industryId"];
            if (Array.isArray(_data["subscriptionInformation"])) {
                this.subscriptionInformation = [] as any;
                for (let item of _data["subscriptionInformation"])
                    this.subscriptionInformation!.push(SubscriptionInformationDto3.fromJS(item));
            }
            this.branch = _data["branch"] ? BranchDto4.fromJS(_data["branch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SetupSubscriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetupSubscriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["industryId"] = this.industryId;
        if (Array.isArray(this.subscriptionInformation)) {
            data["subscriptionInformation"] = [];
            for (let item of this.subscriptionInformation)
                data["subscriptionInformation"].push(item.toJSON());
        }
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISetupSubscriptionViewModel {
    name?: string | undefined;
    industryId?: string | undefined;
    subscriptionInformation?: SubscriptionInformationDto3[] | undefined;
    branch?: BranchDto4 | undefined;
}

export class SubscriptionInformationDto3 implements ISubscriptionInformationDto3 {
    subscriptionId?: string;
    key?: QuestionType;
    value?: string | undefined;

    constructor(data?: ISubscriptionInformationDto3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SubscriptionInformationDto3 {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInformationDto3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ISubscriptionInformationDto3 {
    subscriptionId?: string;
    key?: QuestionType;
    value?: string | undefined;
}

export class SetupBranchServicesViewModel implements ISetupBranchServicesViewModel {
    branchServices?: BranchServiceDto3[];

    constructor(data?: ISetupBranchServicesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branchServices"])) {
                this.branchServices = [] as any;
                for (let item of _data["branchServices"])
                    this.branchServices!.push(BranchServiceDto3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetupBranchServicesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetupBranchServicesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branchServices)) {
            data["branchServices"] = [];
            for (let item of this.branchServices)
                data["branchServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetupBranchServicesViewModel {
    branchServices?: BranchServiceDto3[];
}

export class BranchServiceDto3 implements IBranchServiceDto3 {
    id?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;

    constructor(data?: IBranchServiceDto3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): BranchServiceDto3 {
        data = typeof data === 'object' ? data : {};
        let result = new BranchServiceDto3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        return data;
    }
}

export interface IBranchServiceDto3 {
    id?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    code?: string | undefined;
}

export class PredefinedFlowListViewModel implements IPredefinedFlowListViewModel {
    flows?: FlowDto[];

    constructor(data?: IPredefinedFlowListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["flows"])) {
                this.flows = [] as any;
                for (let item of _data["flows"])
                    this.flows!.push(FlowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PredefinedFlowListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedFlowListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flows)) {
            data["flows"] = [];
            for (let item of this.flows)
                data["flows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPredefinedFlowListViewModel {
    flows?: FlowDto[];
}

export class FlowDto implements IFlowDto {
    id?: string;
    code?: string;

    constructor(data?: IFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): FlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        return data;
    }
}

export interface IFlowDto {
    id?: string;
    code?: string;
}

export class BuildSurveyViewModel implements IBuildSurveyViewModel {
    subscriptionServiceId?: string;
    projectId?: string;

    constructor(data?: IBuildSurveyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): BuildSurveyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BuildSurveyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IBuildSurveyViewModel {
    subscriptionServiceId?: string;
    projectId?: string;
}

export class BuildSurveyDto implements IBuildSurveyDto {
    predefinedFlowId?: string;
    colors?: { [key: string]: string; };
    titles?: BuildSurveyTitleCultureDto[];
    introductions?: BuildSurveyIntroductionCultureDto[] | undefined;

    constructor(data?: IBuildSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predefinedFlowId = _data["predefinedFlowId"];
            if (_data["colors"]) {
                this.colors = {} as any;
                for (let key in _data["colors"]) {
                    if (_data["colors"].hasOwnProperty(key))
                        (<any>this.colors)![key] = _data["colors"][key];
                }
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(BuildSurveyTitleCultureDto.fromJS(item));
            }
            if (Array.isArray(_data["introductions"])) {
                this.introductions = [] as any;
                for (let item of _data["introductions"])
                    this.introductions!.push(BuildSurveyIntroductionCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuildSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predefinedFlowId"] = this.predefinedFlowId;
        if (this.colors) {
            data["colors"] = {};
            for (let key in this.colors) {
                if (this.colors.hasOwnProperty(key))
                    (<any>data["colors"])[key] = (<any>this.colors)[key];
            }
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.introductions)) {
            data["introductions"] = [];
            for (let item of this.introductions)
                data["introductions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBuildSurveyDto {
    predefinedFlowId?: string;
    colors?: { [key: string]: string; };
    titles?: BuildSurveyTitleCultureDto[];
    introductions?: BuildSurveyIntroductionCultureDto[] | undefined;
}

export class BuildSurveyTitleCultureDto implements IBuildSurveyTitleCultureDto {
    title?: string;
    culture?: string | undefined;

    constructor(data?: IBuildSurveyTitleCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): BuildSurveyTitleCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildSurveyTitleCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["culture"] = this.culture;
        return data;
    }
}

export interface IBuildSurveyTitleCultureDto {
    title?: string;
    culture?: string | undefined;
}

export class BuildSurveyIntroductionCultureDto implements IBuildSurveyIntroductionCultureDto {
    text?: string;
    culture?: string | undefined;

    constructor(data?: IBuildSurveyIntroductionCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): BuildSurveyIntroductionCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildSurveyIntroductionCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["culture"] = this.culture;
        return data;
    }
}

export interface IBuildSurveyIntroductionCultureDto {
    text?: string;
    culture?: string | undefined;
}

export class ReportViewModel implements IReportViewModel {
    newSubscriberPerDayViewModels?: NewSubscriberPerDayViewModel[];
    saaSSurveyCompletionCountViewModel?: SaasSurveyCompletionCountViewModel;
    signUpCompletionCountViewModel?: SignUpCompletionCountViewModel;
    totalAccountCountViewModel?: TotalAccountCountViewModel;
    churnCountViewModel?: ChurnCountViewModel;

    constructor(data?: IReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["newSubscriberPerDayViewModels"])) {
                this.newSubscriberPerDayViewModels = [] as any;
                for (let item of _data["newSubscriberPerDayViewModels"])
                    this.newSubscriberPerDayViewModels!.push(NewSubscriberPerDayViewModel.fromJS(item));
            }
            this.saaSSurveyCompletionCountViewModel = _data["saaSSurveyCompletionCountViewModel"] ? SaasSurveyCompletionCountViewModel.fromJS(_data["saaSSurveyCompletionCountViewModel"]) : <any>undefined;
            this.signUpCompletionCountViewModel = _data["signUpCompletionCountViewModel"] ? SignUpCompletionCountViewModel.fromJS(_data["signUpCompletionCountViewModel"]) : <any>undefined;
            this.totalAccountCountViewModel = _data["totalAccountCountViewModel"] ? TotalAccountCountViewModel.fromJS(_data["totalAccountCountViewModel"]) : <any>undefined;
            this.churnCountViewModel = _data["churnCountViewModel"] ? ChurnCountViewModel.fromJS(_data["churnCountViewModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.newSubscriberPerDayViewModels)) {
            data["newSubscriberPerDayViewModels"] = [];
            for (let item of this.newSubscriberPerDayViewModels)
                data["newSubscriberPerDayViewModels"].push(item.toJSON());
        }
        data["saaSSurveyCompletionCountViewModel"] = this.saaSSurveyCompletionCountViewModel ? this.saaSSurveyCompletionCountViewModel.toJSON() : <any>undefined;
        data["signUpCompletionCountViewModel"] = this.signUpCompletionCountViewModel ? this.signUpCompletionCountViewModel.toJSON() : <any>undefined;
        data["totalAccountCountViewModel"] = this.totalAccountCountViewModel ? this.totalAccountCountViewModel.toJSON() : <any>undefined;
        data["churnCountViewModel"] = this.churnCountViewModel ? this.churnCountViewModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReportViewModel {
    newSubscriberPerDayViewModels?: NewSubscriberPerDayViewModel[];
    saaSSurveyCompletionCountViewModel?: SaasSurveyCompletionCountViewModel;
    signUpCompletionCountViewModel?: SignUpCompletionCountViewModel;
    totalAccountCountViewModel?: TotalAccountCountViewModel;
    churnCountViewModel?: ChurnCountViewModel;
}

export class NewSubscriberPerDayViewModel implements INewSubscriberPerDayViewModel {
    date?: string;
    count?: number;

    constructor(data?: INewSubscriberPerDayViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): NewSubscriberPerDayViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSubscriberPerDayViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["count"] = this.count;
        return data;
    }
}

export interface INewSubscriberPerDayViewModel {
    date?: string;
    count?: number;
}

export class SaasSurveyCompletionCountViewModel implements ISaasSurveyCompletionCountViewModel {
    completedCount?: number;
    inProgressCount?: number;

    constructor(data?: ISaasSurveyCompletionCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedCount = _data["completedCount"];
            this.inProgressCount = _data["inProgressCount"];
        }
    }

    static fromJS(data: any): SaasSurveyCompletionCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaasSurveyCompletionCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedCount"] = this.completedCount;
        data["inProgressCount"] = this.inProgressCount;
        return data;
    }
}

export interface ISaasSurveyCompletionCountViewModel {
    completedCount?: number;
    inProgressCount?: number;
}

export class SignUpCompletionCountViewModel implements ISignUpCompletionCountViewModel {
    completedSignUpCount?: number;
    incompletedSignUpCount?: number;

    constructor(data?: ISignUpCompletionCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedSignUpCount = _data["completedSignUpCount"];
            this.incompletedSignUpCount = _data["incompletedSignUpCount"];
        }
    }

    static fromJS(data: any): SignUpCompletionCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpCompletionCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedSignUpCount"] = this.completedSignUpCount;
        data["incompletedSignUpCount"] = this.incompletedSignUpCount;
        return data;
    }
}

export interface ISignUpCompletionCountViewModel {
    completedSignUpCount?: number;
    incompletedSignUpCount?: number;
}

export class TotalAccountCountViewModel implements ITotalAccountCountViewModel {
    proAccountCount?: number;
    saaSAccountCount?: number;

    constructor(data?: ITotalAccountCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proAccountCount = _data["proAccountCount"];
            this.saaSAccountCount = _data["saaSAccountCount"];
        }
    }

    static fromJS(data: any): TotalAccountCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TotalAccountCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proAccountCount"] = this.proAccountCount;
        data["saaSAccountCount"] = this.saaSAccountCount;
        return data;
    }
}

export interface ITotalAccountCountViewModel {
    proAccountCount?: number;
    saaSAccountCount?: number;
}

export class ChurnCountViewModel implements IChurnCountViewModel {
    inactiveUsersCount?: number;

    constructor(data?: IChurnCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inactiveUsersCount = _data["inactiveUsersCount"];
        }
    }

    static fromJS(data: any): ChurnCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChurnCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inactiveUsersCount"] = this.inactiveUsersCount;
        return data;
    }
}

export interface IChurnCountViewModel {
    inactiveUsersCount?: number;
}

export class GetSurveyAnswerViewModel implements IGetSurveyAnswerViewModel {
    surveyAnswer?: SurveyAnswerDto2;

    constructor(data?: IGetSurveyAnswerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyAnswer = _data["surveyAnswer"] ? SurveyAnswerDto2.fromJS(_data["surveyAnswer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyAnswerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAnswerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyAnswer"] = this.surveyAnswer ? this.surveyAnswer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyAnswerViewModel {
    surveyAnswer?: SurveyAnswerDto2;
}

export class SurveyAnswerDto2 implements ISurveyAnswerDto2 {
    id?: string;
    branchId?: string | undefined;
    answerJson?: string;
    ipAddress?: string;
    state?: SurveyState;

    constructor(data?: ISurveyAnswerDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branchId = _data["branchId"];
            this.answerJson = _data["answerJson"];
            this.ipAddress = _data["ipAddress"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): SurveyAnswerDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branchId"] = this.branchId;
        data["answerJson"] = this.answerJson;
        data["ipAddress"] = this.ipAddress;
        data["state"] = this.state;
        return data;
    }
}

export interface ISurveyAnswerDto2 {
    id?: string;
    branchId?: string | undefined;
    answerJson?: string;
    ipAddress?: string;
    state?: SurveyState;
}

export class GetProjectByAnswerIdViewModel implements IGetProjectByAnswerIdViewModel {
    id?: string;
    voiceOfCustomerServiceId?: string;

    constructor(data?: IGetProjectByAnswerIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voiceOfCustomerServiceId = _data["voiceOfCustomerServiceId"];
        }
    }

    static fromJS(data: any): GetProjectByAnswerIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectByAnswerIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voiceOfCustomerServiceId"] = this.voiceOfCustomerServiceId;
        return data;
    }
}

export interface IGetProjectByAnswerIdViewModel {
    id?: string;
    voiceOfCustomerServiceId?: string;
}

export class GetSurveyAnswersByStateViewModel implements IGetSurveyAnswersByStateViewModel {
    surveyAnswers?: SurveyAnswerRecord[];
    maxPage?: number;
    totalRecords?: number;

    constructor(data?: IGetSurveyAnswersByStateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["surveyAnswers"])) {
                this.surveyAnswers = [] as any;
                for (let item of _data["surveyAnswers"])
                    this.surveyAnswers!.push(SurveyAnswerRecord.fromJS(item));
            }
            this.maxPage = _data["maxPage"];
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): GetSurveyAnswersByStateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAnswersByStateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.surveyAnswers)) {
            data["surveyAnswers"] = [];
            for (let item of this.surveyAnswers)
                data["surveyAnswers"].push(item.toJSON());
        }
        data["maxPage"] = this.maxPage;
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface IGetSurveyAnswersByStateViewModel {
    surveyAnswers?: SurveyAnswerRecord[];
    maxPage?: number;
    totalRecords?: number;
}

export class SurveyAnswerRecord implements ISurveyAnswerRecord {
    id?: string;
    submittedDate?: Date | undefined;
    createdDate?: Date;
    branchId?: string;
    userIp?: string;

    constructor(data?: ISurveyAnswerRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.branchId = _data["branchId"];
            this.userIp = _data["userIp"];
        }
    }

    static fromJS(data: any): SurveyAnswerRecord {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["branchId"] = this.branchId;
        data["userIp"] = this.userIp;
        return data;
    }
}

export interface ISurveyAnswerRecord {
    id?: string;
    submittedDate?: Date | undefined;
    createdDate?: Date;
    branchId?: string;
    userIp?: string;
}

export class GetSurveyAnswersByStateFilter implements IGetSurveyAnswersByStateFilter {
    startDate?: Date;
    endDate?: Date;
    pageSize?: number;
    page?: number;

    constructor(data?: IGetSurveyAnswersByStateFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.pageSize = _data["pageSize"];
            this.page = _data["page"];
        }
    }

    static fromJS(data: any): GetSurveyAnswersByStateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAnswersByStateFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["pageSize"] = this.pageSize;
        data["page"] = this.page;
        return data;
    }
}

export interface IGetSurveyAnswersByStateFilter {
    startDate?: Date;
    endDate?: Date;
    pageSize?: number;
    page?: number;
}

export class GetSurveyAnswerExtraDetailsViewModel implements IGetSurveyAnswerExtraDetailsViewModel {
    organizationName?: string;
    subscriptionName?: string;
    subscriptionServiceName?: string;
    projectName?: string;
    branchName?: string | undefined;
    startDate?: Date;
    dateOfVisit?: Date | undefined;
    submissionDate?: Date | undefined;
    total?: number | undefined;
    formJson?: string;
    answersJson?: string | undefined;
    clientInfo?: ClientInfoDto;
    categoryScores?: CategoryScoreDto[];

    constructor(data?: IGetSurveyAnswerExtraDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationName = _data["organizationName"];
            this.subscriptionName = _data["subscriptionName"];
            this.subscriptionServiceName = _data["subscriptionServiceName"];
            this.projectName = _data["projectName"];
            this.branchName = _data["branchName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.dateOfVisit = _data["dateOfVisit"] ? new Date(_data["dateOfVisit"].toString()) : <any>undefined;
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : <any>undefined;
            this.total = _data["total"];
            this.formJson = _data["formJson"];
            this.answersJson = _data["answersJson"];
            this.clientInfo = _data["clientInfo"] ? ClientInfoDto.fromJS(_data["clientInfo"]) : <any>undefined;
            if (Array.isArray(_data["categoryScores"])) {
                this.categoryScores = [] as any;
                for (let item of _data["categoryScores"])
                    this.categoryScores!.push(CategoryScoreDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSurveyAnswerExtraDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAnswerExtraDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName;
        data["subscriptionName"] = this.subscriptionName;
        data["subscriptionServiceName"] = this.subscriptionServiceName;
        data["projectName"] = this.projectName;
        data["branchName"] = this.branchName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["dateOfVisit"] = this.dateOfVisit ? this.dateOfVisit.toISOString() : <any>undefined;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["formJson"] = this.formJson;
        data["answersJson"] = this.answersJson;
        data["clientInfo"] = this.clientInfo ? this.clientInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.categoryScores)) {
            data["categoryScores"] = [];
            for (let item of this.categoryScores)
                data["categoryScores"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSurveyAnswerExtraDetailsViewModel {
    organizationName?: string;
    subscriptionName?: string;
    subscriptionServiceName?: string;
    projectName?: string;
    branchName?: string | undefined;
    startDate?: Date;
    dateOfVisit?: Date | undefined;
    submissionDate?: Date | undefined;
    total?: number | undefined;
    formJson?: string;
    answersJson?: string | undefined;
    clientInfo?: ClientInfoDto;
    categoryScores?: CategoryScoreDto[];
}

export class ClientInfoDto implements IClientInfoDto {
    clientNumber?: string | undefined;
    gender?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ageGroup?: string | undefined;
    callbackAuthorization?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IClientInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            this.gender = _data["gender"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.ageGroup = _data["ageGroup"];
            this.callbackAuthorization = _data["callbackAuthorization"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): ClientInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        data["gender"] = this.gender;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["ageGroup"] = this.ageGroup;
        data["callbackAuthorization"] = this.callbackAuthorization;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IClientInfoDto {
    clientNumber?: string | undefined;
    gender?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ageGroup?: string | undefined;
    callbackAuthorization?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export class CategoryScoreDto implements ICategoryScoreDto {
    category?: string;
    scorePercent?: number | undefined;

    constructor(data?: ICategoryScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.scorePercent = _data["scorePercent"];
        }
    }

    static fromJS(data: any): CategoryScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["scorePercent"] = this.scorePercent;
        return data;
    }
}

export interface ICategoryScoreDto {
    category?: string;
    scorePercent?: number | undefined;
}

export class GetCustomImportJobsViewModel implements IGetCustomImportJobsViewModel {
    jobs?: SurveyAnswerCustomImportJobDto[];

    constructor(data?: IGetCustomImportJobsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(SurveyAnswerCustomImportJobDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomImportJobsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomImportJobsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCustomImportJobsViewModel {
    jobs?: SurveyAnswerCustomImportJobDto[];
}

export class SurveyAnswerCustomImportJobDto implements ISurveyAnswerCustomImportJobDto {
    id?: string;
    status?: SurveyAnswerCustomImportFieldJobStatus;
    createdDate?: Date;

    constructor(data?: ISurveyAnswerCustomImportJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyAnswerCustomImportJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerCustomImportJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISurveyAnswerCustomImportJobDto {
    id?: string;
    status?: SurveyAnswerCustomImportFieldJobStatus;
    createdDate?: Date;
}

export enum SurveyAnswerCustomImportFieldJobStatus {
    Initial = 0,
    Running = 1,
    Cancelled = 2,
    Completed = 3,
    Failed = 4,
}

export class SurveyAnswerCustomImportFieldJobOptions implements ISurveyAnswerCustomImportFieldJobOptions {
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: ISurveyAnswerCustomImportFieldJobOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyAnswerCustomImportFieldJobOptions {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerCustomImportFieldJobOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISurveyAnswerCustomImportFieldJobOptions {
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class GetSurveyViewModel implements IGetSurveyViewModel {
    id?: string;
    name?: string | undefined;
    defaultLanguage?: string | undefined;
    supportedLanguages?: string | undefined;
    flowId?: string;
    projectId?: string;

    constructor(data?: IGetSurveyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.supportedLanguages = _data["supportedLanguages"];
            this.flowId = _data["flowId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetSurveyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["defaultLanguage"] = this.defaultLanguage;
        data["supportedLanguages"] = this.supportedLanguages;
        data["flowId"] = this.flowId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetSurveyViewModel {
    id?: string;
    name?: string | undefined;
    defaultLanguage?: string | undefined;
    supportedLanguages?: string | undefined;
    flowId?: string;
    projectId?: string;
}

export class CreateSurveyViewModel implements ICreateSurveyViewModel {
    id?: string;

    constructor(data?: ICreateSurveyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateSurveyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSurveyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateSurveyViewModel {
    id?: string;
}

export class CreateSurveyCommandDto implements ICreateSurveyCommandDto {
    name?: string | undefined;
    defaultLanguage?: string | undefined;
    supportedLanguages?: string | undefined;
    flowId?: string;
    projectId?: string;

    constructor(data?: ICreateSurveyCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.supportedLanguages = _data["supportedLanguages"];
            this.flowId = _data["flowId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateSurveyCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSurveyCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["defaultLanguage"] = this.defaultLanguage;
        data["supportedLanguages"] = this.supportedLanguages;
        data["flowId"] = this.flowId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ICreateSurveyCommandDto {
    name?: string | undefined;
    defaultLanguage?: string | undefined;
    supportedLanguages?: string | undefined;
    flowId?: string;
    projectId?: string;
}

export class UpdateSurveyViewModel implements IUpdateSurveyViewModel {
    id?: string;

    constructor(data?: IUpdateSurveyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateSurveyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSurveyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateSurveyViewModel {
    id?: string;
}

export class UpdateSurveyCommandDto implements IUpdateSurveyCommandDto {
    id?: string;
    name?: string | undefined;
    defaultLanguage?: string | undefined;
    supportedLanguages?: string | undefined;
    flowId?: string;
    projectId?: string;

    constructor(data?: IUpdateSurveyCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.supportedLanguages = _data["supportedLanguages"];
            this.flowId = _data["flowId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): UpdateSurveyCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSurveyCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["defaultLanguage"] = this.defaultLanguage;
        data["supportedLanguages"] = this.supportedLanguages;
        data["flowId"] = this.flowId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IUpdateSurveyCommandDto {
    id?: string;
    name?: string | undefined;
    defaultLanguage?: string | undefined;
    supportedLanguages?: string | undefined;
    flowId?: string;
    projectId?: string;
}

export class DeleteSurveyViewModel implements IDeleteSurveyViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteSurveyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteSurveyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSurveyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteSurveyViewModel {
    id?: string | undefined;
}

export class GetSurveyProjectByIdViewModel implements IGetSurveyProjectByIdViewModel {
    id?: string;
    name?: string | undefined;

    constructor(data?: IGetSurveyProjectByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetSurveyProjectByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyProjectByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetSurveyProjectByIdViewModel {
    id?: string;
    name?: string | undefined;
}

export class CreateSurveyProjectViewModel implements ICreateSurveyProjectViewModel {
    id?: string;

    constructor(data?: ICreateSurveyProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateSurveyProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSurveyProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateSurveyProjectViewModel {
    id?: string;
}

export class CreateSurveyProjectCommandDto implements ICreateSurveyProjectCommandDto {
    name?: string | undefined;

    constructor(data?: ICreateSurveyProjectCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateSurveyProjectCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSurveyProjectCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateSurveyProjectCommandDto {
    name?: string | undefined;
}

export class UpdateSurveyProjectViewModel implements IUpdateSurveyProjectViewModel {
    id?: string;

    constructor(data?: IUpdateSurveyProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateSurveyProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSurveyProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateSurveyProjectViewModel {
    id?: string;
}

export class UpdateSurveyProjectCommandDto implements IUpdateSurveyProjectCommandDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: IUpdateSurveyProjectCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateSurveyProjectCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSurveyProjectCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateSurveyProjectCommandDto {
    id?: string;
    name?: string | undefined;
}

export class DeleteSurveyProjectViewModel implements IDeleteSurveyProjectViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteSurveyProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteSurveyProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSurveyProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteSurveyProjectViewModel {
    id?: string | undefined;
}

export class GetTemplateByIdViewModel implements IGetTemplateByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    layoutId?: string | undefined;
    projectId?: string;
    name?: string | undefined;
    data?: string | undefined;

    constructor(data?: IGetTemplateByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.layoutId = _data["layoutId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GetTemplateByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["layoutId"] = this.layoutId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["data"] = this.data;
        return data;
    }
}

export interface IGetTemplateByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    layoutId?: string | undefined;
    projectId?: string;
    name?: string | undefined;
    data?: string | undefined;
}

export class CreateTemplateViewModel implements ICreateTemplateViewModel {
    id?: string;

    constructor(data?: ICreateTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateTemplateViewModel {
    id?: string;
}

export class CreateTemplateCommandDto implements ICreateTemplateCommandDto {
    sourceId?: string | undefined;
    layoutId?: string | undefined;
    projectId?: string;
    name?: string | undefined;
    data?: string | undefined;

    constructor(data?: ICreateTemplateCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.layoutId = _data["layoutId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CreateTemplateCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["layoutId"] = this.layoutId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["data"] = this.data;
        return data;
    }
}

export interface ICreateTemplateCommandDto {
    sourceId?: string | undefined;
    layoutId?: string | undefined;
    projectId?: string;
    name?: string | undefined;
    data?: string | undefined;
}

export class UpdateTemplateViewModel implements IUpdateTemplateViewModel {
    id?: string;

    constructor(data?: IUpdateTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTemplateViewModel {
    id?: string;
}

export class UpdateTemplateCommandDto implements IUpdateTemplateCommandDto {
    id?: string;
    sourceId?: string | undefined;
    layoutId?: string | undefined;
    projectId?: string;
    name?: string | undefined;
    data?: string | undefined;

    constructor(data?: IUpdateTemplateCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.layoutId = _data["layoutId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): UpdateTemplateCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["layoutId"] = this.layoutId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["data"] = this.data;
        return data;
    }
}

export interface IUpdateTemplateCommandDto {
    id?: string;
    sourceId?: string | undefined;
    layoutId?: string | undefined;
    projectId?: string;
    name?: string | undefined;
    data?: string | undefined;
}

export class DeleteTemplateViewModel implements IDeleteTemplateViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteTemplateViewModel {
    id?: string | undefined;
}

export class GetTemplateCultureByIdViewModel implements IGetTemplateCultureByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: IGetTemplateCultureByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.templateId = _data["templateId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): GetTemplateCultureByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateCultureByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["templateId"] = this.templateId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IGetTemplateCultureByIdViewModel {
    id?: string;
    sourceId?: string | undefined;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class CreateTemplateCultureViewModel implements ICreateTemplateCultureViewModel {
    id?: string;

    constructor(data?: ICreateTemplateCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateTemplateCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateTemplateCultureViewModel {
    id?: string;
}

export class CreateTemplateCultureCommandDto implements ICreateTemplateCultureCommandDto {
    sourceId?: string | undefined;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: ICreateTemplateCultureCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.templateId = _data["templateId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): CreateTemplateCultureCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateCultureCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["templateId"] = this.templateId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface ICreateTemplateCultureCommandDto {
    sourceId?: string | undefined;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class UpdateTemplateCultureViewModel implements IUpdateTemplateCultureViewModel {
    id?: string;

    constructor(data?: IUpdateTemplateCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTemplateCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTemplateCultureViewModel {
    id?: string;
}

export class UpdateTemplateCultureCommandDto implements IUpdateTemplateCultureCommandDto {
    id?: string;
    sourceId?: string | undefined;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;

    constructor(data?: IUpdateTemplateCultureCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.templateId = _data["templateId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): UpdateTemplateCultureCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateCultureCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["templateId"] = this.templateId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IUpdateTemplateCultureCommandDto {
    id?: string;
    sourceId?: string | undefined;
    templateId?: string;
    name?: string | undefined;
    data?: string | undefined;
    formJson?: string | undefined;
}

export class DeleteTemplateCultureViewModel implements IDeleteTemplateCultureViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteTemplateCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteTemplateCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTemplateCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteTemplateCultureViewModel {
    id?: string | undefined;
}

export class GetTemplateCultureValueByIdViewModel implements IGetTemplateCultureValueByIdViewModel {
    id?: string;
    templateLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;
    headTitle?: string | undefined;

    constructor(data?: IGetTemplateCultureValueByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateLanguageId = _data["templateLanguageId"];
            this.surveyId = _data["surveyId"];
            this.valuesJson = _data["valuesJson"];
            this.headTitle = _data["headTitle"];
        }
    }

    static fromJS(data: any): GetTemplateCultureValueByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateCultureValueByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateLanguageId"] = this.templateLanguageId;
        data["surveyId"] = this.surveyId;
        data["valuesJson"] = this.valuesJson;
        data["headTitle"] = this.headTitle;
        return data;
    }
}

export interface IGetTemplateCultureValueByIdViewModel {
    id?: string;
    templateLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;
    headTitle?: string | undefined;
}

export class CreateTemplateCultureValueViewModel implements ICreateTemplateCultureValueViewModel {
    id?: string;

    constructor(data?: ICreateTemplateCultureValueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateTemplateCultureValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateCultureValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateTemplateCultureValueViewModel {
    id?: string;
}

export class CreateTemplateCultureValueCommandDto implements ICreateTemplateCultureValueCommandDto {
    templateLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;
    headTitle?: string | undefined;

    constructor(data?: ICreateTemplateCultureValueCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateLanguageId = _data["templateLanguageId"];
            this.surveyId = _data["surveyId"];
            this.valuesJson = _data["valuesJson"];
            this.headTitle = _data["headTitle"];
        }
    }

    static fromJS(data: any): CreateTemplateCultureValueCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateCultureValueCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateLanguageId"] = this.templateLanguageId;
        data["surveyId"] = this.surveyId;
        data["valuesJson"] = this.valuesJson;
        data["headTitle"] = this.headTitle;
        return data;
    }
}

export interface ICreateTemplateCultureValueCommandDto {
    templateLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;
    headTitle?: string | undefined;
}

export class UpdateTemplateCultureValueViewModel implements IUpdateTemplateCultureValueViewModel {
    id?: string;

    constructor(data?: IUpdateTemplateCultureValueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTemplateCultureValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateCultureValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTemplateCultureValueViewModel {
    id?: string;
}

export class UpdateTemplateCultureValueCommandDto implements IUpdateTemplateCultureValueCommandDto {
    id?: string;
    templateLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;
    headTitle?: string | undefined;

    constructor(data?: IUpdateTemplateCultureValueCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateLanguageId = _data["templateLanguageId"];
            this.surveyId = _data["surveyId"];
            this.valuesJson = _data["valuesJson"];
            this.headTitle = _data["headTitle"];
        }
    }

    static fromJS(data: any): UpdateTemplateCultureValueCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateCultureValueCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateLanguageId"] = this.templateLanguageId;
        data["surveyId"] = this.surveyId;
        data["valuesJson"] = this.valuesJson;
        data["headTitle"] = this.headTitle;
        return data;
    }
}

export interface IUpdateTemplateCultureValueCommandDto {
    id?: string;
    templateLanguageId?: string;
    surveyId?: string;
    valuesJson?: string | undefined;
    headTitle?: string | undefined;
}

export class DeleteTemplateCultureValueViewModel implements IDeleteTemplateCultureValueViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteTemplateCultureValueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteTemplateCultureValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTemplateCultureValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteTemplateCultureValueViewModel {
    id?: string | undefined;
}

export class CreateUserBookmarkViewModel implements ICreateUserBookmarkViewModel {
    id?: string;
    projectId?: string;
    userId?: string;
    name?: string;
    section?: UserBookmarkSection;
    isFavorite?: boolean;
    isDefault?: boolean;
    filter?: string;

    constructor(data?: ICreateUserBookmarkViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.section = _data["section"];
            this.isFavorite = _data["isFavorite"];
            this.isDefault = _data["isDefault"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): CreateUserBookmarkViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserBookmarkViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["section"] = this.section;
        data["isFavorite"] = this.isFavorite;
        data["isDefault"] = this.isDefault;
        data["filter"] = this.filter;
        return data;
    }
}

export interface ICreateUserBookmarkViewModel {
    id?: string;
    projectId?: string;
    userId?: string;
    name?: string;
    section?: UserBookmarkSection;
    isFavorite?: boolean;
    isDefault?: boolean;
    filter?: string;
}

export enum UserBookmarkSection {
    Overview = 0,
    DetailResult = 1,
    CompetitorResult = 2,
    AlertDetail = 3,
    Statistic = 4,
}

export class CreateUserBookmarkDto implements ICreateUserBookmarkDto {
    name?: string;
    section?: UserBookmarkSection;
    isFavorite?: boolean;
    isDefault?: boolean;
    filter?: string;

    constructor(data?: ICreateUserBookmarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.section = _data["section"];
            this.isFavorite = _data["isFavorite"];
            this.isDefault = _data["isDefault"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): CreateUserBookmarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserBookmarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["section"] = this.section;
        data["isFavorite"] = this.isFavorite;
        data["isDefault"] = this.isDefault;
        data["filter"] = this.filter;
        return data;
    }
}

export interface ICreateUserBookmarkDto {
    name?: string;
    section?: UserBookmarkSection;
    isFavorite?: boolean;
    isDefault?: boolean;
    filter?: string;
}

export class GetUserBookmarkByCurrentUserViewModel implements IGetUserBookmarkByCurrentUserViewModel {
    id?: string;
    projectId?: string;
    userId?: string;
    name?: string;
    section?: UserBookmarkSection;
    isFavorite?: boolean;
    isDefault?: boolean;
    filter?: string;

    constructor(data?: IGetUserBookmarkByCurrentUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.section = _data["section"];
            this.isFavorite = _data["isFavorite"];
            this.isDefault = _data["isDefault"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): GetUserBookmarkByCurrentUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserBookmarkByCurrentUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["section"] = this.section;
        data["isFavorite"] = this.isFavorite;
        data["isDefault"] = this.isDefault;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IGetUserBookmarkByCurrentUserViewModel {
    id?: string;
    projectId?: string;
    userId?: string;
    name?: string;
    section?: UserBookmarkSection;
    isFavorite?: boolean;
    isDefault?: boolean;
    filter?: string;
}

export class CompareBranchInputsViewModel implements ICompareBranchInputsViewModel {
    result?: boolean;
    message?: any | undefined;

    constructor(data?: ICompareBranchInputsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CompareBranchInputsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompareBranchInputsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["message"] = this.message;
        return data;
    }
}

export interface ICompareBranchInputsViewModel {
    result?: boolean;
    message?: any | undefined;
}

export class ProjectLangDto implements IProjectLangDto {
    id?: string;
    order?: number;
    subjectPath?: any[] | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    name!: string;
    options?: ProjectOption[] | undefined;
    cultures?: ProjectCultureDto2[] | undefined;

    constructor(data?: IProjectLangDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(ProjectOption.fromJS(item));
            }
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(ProjectCultureDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectLangDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLangDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectLangDto {
    id?: string;
    order?: number;
    subjectPath?: any[] | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    name: string;
    options?: ProjectOption[] | undefined;
    cultures?: ProjectCultureDto2[] | undefined;
}

export class ProjectCultureDto2 implements IProjectCultureDto2 {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    projectId?: string;
    name?: string | undefined;
    cultureCode?: string | undefined;
    state?: string | undefined;

    constructor(data?: IProjectCultureDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ProjectCultureDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCultureDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        data["state"] = this.state;
        return data;
    }
}

export interface IProjectCultureDto2 {
    id?: string;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    projectId?: string;
    name?: string | undefined;
    cultureCode?: string | undefined;
    state?: string | undefined;
}

export class GetVocProjectByIdViewModel implements IGetVocProjectByIdViewModel {
    id?: string;
    voiceOfCustomerServiceId?: string;
    email?: string | undefined;

    constructor(data?: IGetVocProjectByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voiceOfCustomerServiceId = _data["voiceOfCustomerServiceId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GetVocProjectByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetVocProjectByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voiceOfCustomerServiceId"] = this.voiceOfCustomerServiceId;
        data["email"] = this.email;
        return data;
    }
}

export interface IGetVocProjectByIdViewModel {
    id?: string;
    voiceOfCustomerServiceId?: string;
    email?: string | undefined;
}

export class CreateVocProjectViewModel implements ICreateVocProjectViewModel {
    id?: string;

    constructor(data?: ICreateVocProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateVocProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVocProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateVocProjectViewModel {
    id?: string;
}

export class CreateVocProjectCommandDto implements ICreateVocProjectCommandDto {
    id?: string;
    organizationId?: string;
    subscriptionId?: string;
    voiceOfCustomerServiceId?: string;
    email?: string | undefined;

    constructor(data?: ICreateVocProjectCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.voiceOfCustomerServiceId = _data["voiceOfCustomerServiceId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateVocProjectCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVocProjectCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["voiceOfCustomerServiceId"] = this.voiceOfCustomerServiceId;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateVocProjectCommandDto {
    id?: string;
    organizationId?: string;
    subscriptionId?: string;
    voiceOfCustomerServiceId?: string;
    email?: string | undefined;
}

export class UpdateVocProjectViewModel implements IUpdateVocProjectViewModel {
    id?: string;

    constructor(data?: IUpdateVocProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateVocProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVocProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateVocProjectViewModel {
    id?: string;
}

export class UpdateVocProjectCommandDto implements IUpdateVocProjectCommandDto {
    id?: string;
    voiceOfCustomerServiceId?: string;
    organizationId?: string;
    subscriptionId?: string;
    email?: string | undefined;

    constructor(data?: IUpdateVocProjectCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voiceOfCustomerServiceId = _data["voiceOfCustomerServiceId"];
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateVocProjectCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVocProjectCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voiceOfCustomerServiceId"] = this.voiceOfCustomerServiceId;
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["email"] = this.email;
        return data;
    }
}

export interface IUpdateVocProjectCommandDto {
    id?: string;
    voiceOfCustomerServiceId?: string;
    organizationId?: string;
    subscriptionId?: string;
    email?: string | undefined;
}

export class DeleteVocProjectViewModel implements IDeleteVocProjectViewModel {
    id?: string | undefined;

    constructor(data?: IDeleteVocProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteVocProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteVocProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteVocProjectViewModel {
    id?: string | undefined;
}

export class ProjectOptionsViewModel implements IProjectOptionsViewModel {
    projectOptions?: ProjectOptionsDto[] | undefined;

    constructor(data?: IProjectOptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectOptions"])) {
                this.projectOptions = [] as any;
                for (let item of _data["projectOptions"])
                    this.projectOptions!.push(ProjectOptionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectOptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectOptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectOptions)) {
            data["projectOptions"] = [];
            for (let item of this.projectOptions)
                data["projectOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectOptionsViewModel {
    projectOptions?: ProjectOptionsDto[] | undefined;
}

export class ProjectOptionsDto implements IProjectOptionsDto {
    projectId?: string;
    type?: ProjectOptionType;
    valueJson?: string | undefined;

    constructor(data?: IProjectOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.type = _data["type"];
            this.valueJson = _data["valueJson"];
        }
    }

    static fromJS(data: any): ProjectOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["type"] = this.type;
        data["valueJson"] = this.valueJson;
        return data;
    }
}

export interface IProjectOptionsDto {
    projectId?: string;
    type?: ProjectOptionType;
    valueJson?: string | undefined;
}

export class ProjectDashboardViewModel implements IProjectDashboardViewModel {
    widgets?: WidgetInfo[] | undefined;

    constructor(data?: IProjectDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(WidgetInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectDashboardViewModel {
    widgets?: WidgetInfo[] | undefined;
}

export class WidgetInfo implements IWidgetInfo {
    code?: DashboardWidgetType;
    order?: number;
    active?: boolean;
    pageOrder?: VocDashboardPageType;
    apiCall?: string | undefined;

    constructor(data?: IWidgetInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.order = _data["order"];
            this.active = _data["active"];
            this.pageOrder = _data["pageOrder"];
            this.apiCall = _data["apiCall"];
        }
    }

    static fromJS(data: any): WidgetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["order"] = this.order;
        data["active"] = this.active;
        data["pageOrder"] = this.pageOrder;
        data["apiCall"] = this.apiCall;
        return data;
    }
}

export interface IWidgetInfo {
    code?: DashboardWidgetType;
    order?: number;
    active?: boolean;
    pageOrder?: VocDashboardPageType;
    apiCall?: string | undefined;
}

export enum DashboardWidgetType {
    General = 0,
    GeneralByCategory = 1,
    NPS = 2,
    Trends = 3,
    Alerts = 4,
    CES = 5,
    Competitors = 6,
    Oversight = 7,
    StatisticsTrendCompletedSurveys = 8,
    StatisticsCompletedSurveys = 9,
    StatisticsEmailsSummary = 10,
    StatisticsDailyBreakdown = 11,
    StatisticsHourlyBreakdown = 12,
    StatisticsSocialMediaPage = 13,
    StatisticsSocialMediaRanking = 14,
    AlertsAllNotSolved = 15,
}

export enum VocDashboardPageType {
    Overview = 0,
    OtherMetrics = 1,
    Statistics = 2,
}

export class DashboardWidgetViewModel implements IDashboardWidgetViewModel {
    title?: string | undefined;
    titleHelp?: string | undefined;
    additionalInfo?: string | undefined;
    showDetailsLink?: boolean;
    children?: any[] | undefined;

    constructor(data?: IDashboardWidgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.titleHelp = _data["titleHelp"];
            this.additionalInfo = _data["additionalInfo"];
            this.showDetailsLink = _data["showDetailsLink"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(item);
            }
        }
    }

    static fromJS(data: any): DashboardWidgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWidgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleHelp"] = this.titleHelp;
        data["additionalInfo"] = this.additionalInfo;
        data["showDetailsLink"] = this.showDetailsLink;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item);
        }
        return data;
    }
}

export interface IDashboardWidgetViewModel {
    title?: string | undefined;
    titleHelp?: string | undefined;
    additionalInfo?: string | undefined;
    showDetailsLink?: boolean;
    children?: any[] | undefined;
}

export enum DashboardWidgetType2 {
    General = 0,
    GeneralByCategory = 1,
    NPS = 2,
    Trends = 3,
    Alerts = 4,
    CES = 5,
    Competitors = 6,
    Oversight = 7,
    StatisticsTrendCompletedSurveys = 8,
    StatisticsCompletedSurveys = 9,
    StatisticsEmailsSummary = 10,
    StatisticsDailyBreakdown = 11,
    StatisticsHourlyBreakdown = 12,
    StatisticsSocialMediaPage = 13,
    StatisticsSocialMediaRanking = 14,
    AlertsAllNotSolved = 15,
}

export class TrendsPageViewModel implements ITrendsPageViewModel {
    series?: Line2[] | undefined;

    constructor(data?: ITrendsPageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(Line2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrendsPageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrendsPageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrendsPageViewModel {
    series?: Line2[] | undefined;
}

export class Line2 implements ILine2 {
    key?: string | undefined;
    name?: string | undefined;
    values?: DatePoint2[] | undefined;

    constructor(data?: ILine2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(DatePoint2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Line2 {
        data = typeof data === 'object' ? data : {};
        let result = new Line2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILine2 {
    key?: string | undefined;
    name?: string | undefined;
    values?: DatePoint2[] | undefined;
}

export class DatePoint2 implements IDatePoint2 {
    value?: number;
    date?: Date;

    constructor(data?: IDatePoint2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DatePoint2 {
        data = typeof data === 'object' ? data : {};
        let result = new DatePoint2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDatePoint2 {
    value?: number;
    date?: Date;
}

export class CompetitorDetailPage implements ICompetitorDetailPage {
    filterSet?: DashboardFilterSet | undefined;
    name?: string | undefined;
    rows?: CompetitorRow[] | undefined;

    constructor(data?: ICompetitorDetailPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterSet = _data["filterSet"] ? DashboardFilterSet.fromJS(_data["filterSet"]) : <any>undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CompetitorRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitorDetailPage {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorDetailPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterSet"] = this.filterSet ? this.filterSet.toJSON() : <any>undefined;
        data["name"] = this.name;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompetitorDetailPage {
    filterSet?: DashboardFilterSet | undefined;
    name?: string | undefined;
    rows?: CompetitorRow[] | undefined;
}

export class CompetitorRow implements ICompetitorRow {
    id?: string | undefined;
    name?: string | undefined;
    surveyCount?: number | undefined;
    plus?: GradedValue | undefined;
    equal?: GradedValue | undefined;
    minus?: GradedValue | undefined;
    competitors?: CompetitorRow[] | undefined;

    constructor(data?: ICompetitorRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surveyCount = _data["surveyCount"];
            this.plus = _data["plus"] ? GradedValue.fromJS(_data["plus"]) : <any>undefined;
            this.equal = _data["equal"] ? GradedValue.fromJS(_data["equal"]) : <any>undefined;
            this.minus = _data["minus"] ? GradedValue.fromJS(_data["minus"]) : <any>undefined;
            if (Array.isArray(_data["competitors"])) {
                this.competitors = [] as any;
                for (let item of _data["competitors"])
                    this.competitors!.push(CompetitorRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitorRow {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surveyCount"] = this.surveyCount;
        data["plus"] = this.plus ? this.plus.toJSON() : <any>undefined;
        data["equal"] = this.equal ? this.equal.toJSON() : <any>undefined;
        data["minus"] = this.minus ? this.minus.toJSON() : <any>undefined;
        if (Array.isArray(this.competitors)) {
            data["competitors"] = [];
            for (let item of this.competitors)
                data["competitors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompetitorRow {
    id?: string | undefined;
    name?: string | undefined;
    surveyCount?: number | undefined;
    plus?: GradedValue | undefined;
    equal?: GradedValue | undefined;
    minus?: GradedValue | undefined;
    competitors?: CompetitorRow[] | undefined;
}

export class GradedValue implements IGradedValue {
    value?: number | undefined;
    grade?: number | undefined;

    constructor(data?: IGradedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.grade = _data["grade"];
        }
    }

    static fromJS(data: any): GradedValue {
        data = typeof data === 'object' ? data : {};
        let result = new GradedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["grade"] = this.grade;
        return data;
    }
}

export interface IGradedValue {
    value?: number | undefined;
    grade?: number | undefined;
}

export class ProjectUrl extends EntityBase implements IProjectUrl {
    projectId!: string;
    type?: UrlType;
    domain?: string | undefined;
    subdomain?: string | undefined;
    path?: string | undefined;
    custom?: string | undefined;
    secured?: boolean;
    ttlSeconds?: number;
    vocProject?: VocProject | undefined;
    host?: string | undefined;
    url?: string | undefined;
    uri?: string | undefined;

    constructor(data?: IProjectUrl) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.projectId = _data["projectId"];
            this.type = _data["type"];
            this.domain = _data["domain"];
            this.subdomain = _data["subdomain"];
            this.path = _data["path"];
            this.custom = _data["custom"];
            this.secured = _data["secured"];
            this.ttlSeconds = _data["ttlSeconds"];
            this.vocProject = _data["vocProject"] ? VocProject.fromJS(_data["vocProject"]) : <any>undefined;
            this.host = _data["host"];
            this.url = _data["url"];
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): ProjectUrl {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["type"] = this.type;
        data["domain"] = this.domain;
        data["subdomain"] = this.subdomain;
        data["path"] = this.path;
        data["custom"] = this.custom;
        data["secured"] = this.secured;
        data["ttlSeconds"] = this.ttlSeconds;
        data["vocProject"] = this.vocProject ? this.vocProject.toJSON() : <any>undefined;
        data["host"] = this.host;
        data["url"] = this.url;
        data["uri"] = this.uri;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectUrl extends IEntityBase {
    projectId: string;
    type?: UrlType;
    domain?: string | undefined;
    subdomain?: string | undefined;
    path?: string | undefined;
    custom?: string | undefined;
    secured?: boolean;
    ttlSeconds?: number;
    vocProject?: VocProject | undefined;
    host?: string | undefined;
    url?: string | undefined;
    uri?: string | undefined;
}

export enum UrlType {
    Custom = 0,
    Predefined = 1,
}

export class VocProject extends HierarchyEntityBase implements IVocProject {
    voiceOfCustomerServiceId?: string;
    email?: string | undefined;
    project?: Project | undefined;
    voiceOfCustomerService?: VoiceOfCustomerSubscriptionService | undefined;
    datePickerSequences?: DatePickerSequence[] | undefined;
    projectUrls?: ProjectUrl[] | undefined;
    emailLayouts?: EmailLayout[] | undefined;
    emailTemplates?: EmailTemplate[] | undefined;
    userBookmarks?: UserBookmark[] | undefined;

    constructor(data?: IVocProject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voiceOfCustomerServiceId = _data["voiceOfCustomerServiceId"];
            this.email = _data["email"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.voiceOfCustomerService = _data["voiceOfCustomerService"] ? VoiceOfCustomerSubscriptionService.fromJS(_data["voiceOfCustomerService"]) : <any>undefined;
            if (Array.isArray(_data["datePickerSequences"])) {
                this.datePickerSequences = [] as any;
                for (let item of _data["datePickerSequences"])
                    this.datePickerSequences!.push(DatePickerSequence.fromJS(item));
            }
            if (Array.isArray(_data["projectUrls"])) {
                this.projectUrls = [] as any;
                for (let item of _data["projectUrls"])
                    this.projectUrls!.push(ProjectUrl.fromJS(item));
            }
            if (Array.isArray(_data["emailLayouts"])) {
                this.emailLayouts = [] as any;
                for (let item of _data["emailLayouts"])
                    this.emailLayouts!.push(EmailLayout.fromJS(item));
            }
            if (Array.isArray(_data["emailTemplates"])) {
                this.emailTemplates = [] as any;
                for (let item of _data["emailTemplates"])
                    this.emailTemplates!.push(EmailTemplate.fromJS(item));
            }
            if (Array.isArray(_data["userBookmarks"])) {
                this.userBookmarks = [] as any;
                for (let item of _data["userBookmarks"])
                    this.userBookmarks!.push(UserBookmark.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VocProject {
        data = typeof data === 'object' ? data : {};
        let result = new VocProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voiceOfCustomerServiceId"] = this.voiceOfCustomerServiceId;
        data["email"] = this.email;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["voiceOfCustomerService"] = this.voiceOfCustomerService ? this.voiceOfCustomerService.toJSON() : <any>undefined;
        if (Array.isArray(this.datePickerSequences)) {
            data["datePickerSequences"] = [];
            for (let item of this.datePickerSequences)
                data["datePickerSequences"].push(item.toJSON());
        }
        if (Array.isArray(this.projectUrls)) {
            data["projectUrls"] = [];
            for (let item of this.projectUrls)
                data["projectUrls"].push(item.toJSON());
        }
        if (Array.isArray(this.emailLayouts)) {
            data["emailLayouts"] = [];
            for (let item of this.emailLayouts)
                data["emailLayouts"].push(item.toJSON());
        }
        if (Array.isArray(this.emailTemplates)) {
            data["emailTemplates"] = [];
            for (let item of this.emailTemplates)
                data["emailTemplates"].push(item.toJSON());
        }
        if (Array.isArray(this.userBookmarks)) {
            data["userBookmarks"] = [];
            for (let item of this.userBookmarks)
                data["userBookmarks"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IVocProject extends IHierarchyEntityBase {
    voiceOfCustomerServiceId?: string;
    email?: string | undefined;
    project?: Project | undefined;
    voiceOfCustomerService?: VoiceOfCustomerSubscriptionService | undefined;
    datePickerSequences?: DatePickerSequence[] | undefined;
    projectUrls?: ProjectUrl[] | undefined;
    emailLayouts?: EmailLayout[] | undefined;
    emailTemplates?: EmailTemplate[] | undefined;
    userBookmarks?: UserBookmark[] | undefined;
}

export class VoiceOfCustomerSubscriptionService implements IVoiceOfCustomerSubscriptionService {
    subscriptionServiceId?: string;
    subscriptionService?: SubscriptionService | undefined;

    constructor(data?: IVoiceOfCustomerSubscriptionService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.subscriptionService = _data["subscriptionService"] ? SubscriptionService.fromJS(_data["subscriptionService"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoiceOfCustomerSubscriptionService {
        data = typeof data === 'object' ? data : {};
        let result = new VoiceOfCustomerSubscriptionService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["subscriptionService"] = this.subscriptionService ? this.subscriptionService.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoiceOfCustomerSubscriptionService {
    subscriptionServiceId?: string;
    subscriptionService?: SubscriptionService | undefined;
}

export class DatePickerSequence extends EntityBase implements IDatePickerSequence {
    text?: string | undefined;
    order?: number;
    dateType?: DateType;
    isEnabled?: boolean;
    vocProjectId?: string;
    project?: VocProject | undefined;
    cultures?: DatePickerSequenceCulture[] | undefined;

    constructor(data?: IDatePickerSequence) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
            this.order = _data["order"];
            this.dateType = _data["dateType"];
            this.isEnabled = _data["isEnabled"];
            this.vocProjectId = _data["vocProjectId"];
            this.project = _data["project"] ? VocProject.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(DatePickerSequenceCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DatePickerSequence {
        data = typeof data === 'object' ? data : {};
        let result = new DatePickerSequence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["order"] = this.order;
        data["dateType"] = this.dateType;
        data["isEnabled"] = this.isEnabled;
        data["vocProjectId"] = this.vocProjectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDatePickerSequence extends IEntityBase {
    text?: string | undefined;
    order?: number;
    dateType?: DateType;
    isEnabled?: boolean;
    vocProjectId?: string;
    project?: VocProject | undefined;
    cultures?: DatePickerSequenceCulture[] | undefined;
}

export class DatePickerSequenceCulture extends EntityBase implements IDatePickerSequenceCulture {
    cultureCode?: string | undefined;
    text?: string | undefined;
    datePickerSequenceId?: string;
    datePickerSequence?: DatePickerSequence | undefined;

    constructor(data?: IDatePickerSequenceCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.text = _data["text"];
            this.datePickerSequenceId = _data["datePickerSequenceId"];
            this.datePickerSequence = _data["datePickerSequence"] ? DatePickerSequence.fromJS(_data["datePickerSequence"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DatePickerSequenceCulture {
        data = typeof data === 'object' ? data : {};
        let result = new DatePickerSequenceCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["text"] = this.text;
        data["datePickerSequenceId"] = this.datePickerSequenceId;
        data["datePickerSequence"] = this.datePickerSequence ? this.datePickerSequence.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDatePickerSequenceCulture extends IEntityBase {
    cultureCode?: string | undefined;
    text?: string | undefined;
    datePickerSequenceId?: string;
    datePickerSequence?: DatePickerSequence | undefined;
}

export class EmailLayout extends EntityBase implements IEmailLayout {
    name!: string;
    data?: string | undefined;
    projectId!: string;
    project?: VocProject | undefined;
    emailLayoutCultures?: EmailLayoutCulture[] | undefined;
    emailTemplates?: EmailTemplate[] | undefined;

    constructor(data?: IEmailLayout) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.data = _data["data"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? VocProject.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["emailLayoutCultures"])) {
                this.emailLayoutCultures = [] as any;
                for (let item of _data["emailLayoutCultures"])
                    this.emailLayoutCultures!.push(EmailLayoutCulture.fromJS(item));
            }
            if (Array.isArray(_data["emailTemplates"])) {
                this.emailTemplates = [] as any;
                for (let item of _data["emailTemplates"])
                    this.emailTemplates!.push(EmailTemplate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailLayout {
        data = typeof data === 'object' ? data : {};
        let result = new EmailLayout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["data"] = this.data;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.emailLayoutCultures)) {
            data["emailLayoutCultures"] = [];
            for (let item of this.emailLayoutCultures)
                data["emailLayoutCultures"].push(item.toJSON());
        }
        if (Array.isArray(this.emailTemplates)) {
            data["emailTemplates"] = [];
            for (let item of this.emailTemplates)
                data["emailTemplates"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEmailLayout extends IEntityBase {
    name: string;
    data?: string | undefined;
    projectId: string;
    project?: VocProject | undefined;
    emailLayoutCultures?: EmailLayoutCulture[] | undefined;
    emailTemplates?: EmailTemplate[] | undefined;
}

export class EmailLayoutCulture extends EntityBase implements IEmailLayoutCulture {
    cultureCode!: string;
    formJson?: string | undefined;
    layoutId!: string;
    data?: string | undefined;
    layout?: EmailLayout | undefined;

    constructor(data?: IEmailLayoutCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.formJson = _data["formJson"];
            this.layoutId = _data["layoutId"];
            this.data = _data["data"];
            this.layout = _data["layout"] ? EmailLayout.fromJS(_data["layout"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailLayoutCulture {
        data = typeof data === 'object' ? data : {};
        let result = new EmailLayoutCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["formJson"] = this.formJson;
        data["layoutId"] = this.layoutId;
        data["data"] = this.data;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailLayoutCulture extends IEntityBase {
    cultureCode: string;
    formJson?: string | undefined;
    layoutId: string;
    data?: string | undefined;
    layout?: EmailLayout | undefined;
}

export class EmailTemplate extends EntityBase implements IEmailTemplate {
    emailLayoutId?: string | undefined;
    projectId!: string;
    name!: string;
    data?: string | undefined;
    emailLayout?: EmailLayout | undefined;
    project?: VocProject | undefined;
    emailTemplateCultures?: EmailTemplateCulture[] | undefined;

    constructor(data?: IEmailTemplate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailLayoutId = _data["emailLayoutId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.data = _data["data"];
            this.emailLayout = _data["emailLayout"] ? EmailLayout.fromJS(_data["emailLayout"]) : <any>undefined;
            this.project = _data["project"] ? VocProject.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["emailTemplateCultures"])) {
                this.emailTemplateCultures = [] as any;
                for (let item of _data["emailTemplateCultures"])
                    this.emailTemplateCultures!.push(EmailTemplateCulture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailLayoutId"] = this.emailLayoutId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["data"] = this.data;
        data["emailLayout"] = this.emailLayout ? this.emailLayout.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.emailTemplateCultures)) {
            data["emailTemplateCultures"] = [];
            for (let item of this.emailTemplateCultures)
                data["emailTemplateCultures"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEmailTemplate extends IEntityBase {
    emailLayoutId?: string | undefined;
    projectId: string;
    name: string;
    data?: string | undefined;
    emailLayout?: EmailLayout | undefined;
    project?: VocProject | undefined;
    emailTemplateCultures?: EmailTemplateCulture[] | undefined;
}

export class EmailTemplateCulture extends EntityBase implements IEmailTemplateCulture {
    templateId!: string;
    cultureCode!: string;
    data?: string | undefined;
    formJson?: string | undefined;
    template?: EmailTemplate | undefined;

    constructor(data?: IEmailTemplateCulture) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateId = _data["templateId"];
            this.cultureCode = _data["cultureCode"];
            this.data = _data["data"];
            this.formJson = _data["formJson"];
            this.template = _data["template"] ? EmailTemplate.fromJS(_data["template"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailTemplateCulture {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateCulture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["cultureCode"] = this.cultureCode;
        data["data"] = this.data;
        data["formJson"] = this.formJson;
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailTemplateCulture extends IEntityBase {
    templateId: string;
    cultureCode: string;
    data?: string | undefined;
    formJson?: string | undefined;
    template?: EmailTemplate | undefined;
}

export class UserBookmark extends EntityBase implements IUserBookmark {
    name?: string;
    section?: UserBookmarkSection;
    isFavorite?: boolean;
    isDefault?: boolean;
    filter?: string;
    userId?: string;
    projectId?: string;
    project?: VocProject;

    constructor(data?: IUserBookmark) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.section = _data["section"];
            this.isFavorite = _data["isFavorite"];
            this.isDefault = _data["isDefault"];
            this.filter = _data["filter"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? VocProject.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserBookmark {
        data = typeof data === 'object' ? data : {};
        let result = new UserBookmark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["section"] = this.section;
        data["isFavorite"] = this.isFavorite;
        data["isDefault"] = this.isDefault;
        data["filter"] = this.filter;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserBookmark extends IEntityBase {
    name?: string;
    section?: UserBookmarkSection;
    isFavorite?: boolean;
    isDefault?: boolean;
    filter?: string;
    userId?: string;
    projectId?: string;
    project?: VocProject;
}

export class GetVoiceOfCustomerServiceViewModel implements IGetVoiceOfCustomerServiceViewModel {
    subscriptionServiceId?: string;

    constructor(data?: IGetVoiceOfCustomerServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionServiceId = _data["subscriptionServiceId"];
        }
    }

    static fromJS(data: any): GetVoiceOfCustomerServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoiceOfCustomerServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        return data;
    }
}

export interface IGetVoiceOfCustomerServiceViewModel {
    subscriptionServiceId?: string;
}

export class CreateVoiceOfCustomerServiceViewModel implements ICreateVoiceOfCustomerServiceViewModel {
    id?: string;

    constructor(data?: ICreateVoiceOfCustomerServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateVoiceOfCustomerServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVoiceOfCustomerServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateVoiceOfCustomerServiceViewModel {
    id?: string;
}

export class CreateVoiceOfCustomerServiceCommandDto implements ICreateVoiceOfCustomerServiceCommandDto {
    id?: string;

    constructor(data?: ICreateVoiceOfCustomerServiceCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateVoiceOfCustomerServiceCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVoiceOfCustomerServiceCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateVoiceOfCustomerServiceCommandDto {
    id?: string;
}

export class UpdateVoiceOfCustomerViewModel implements IUpdateVoiceOfCustomerViewModel {
    id?: string;

    constructor(data?: IUpdateVoiceOfCustomerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateVoiceOfCustomerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoiceOfCustomerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateVoiceOfCustomerViewModel {
    id?: string;
}

export class UpdateVoiceOfCustomerServiceCommandDto implements IUpdateVoiceOfCustomerServiceCommandDto {
    id?: string;

    constructor(data?: IUpdateVoiceOfCustomerServiceCommandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateVoiceOfCustomerServiceCommandDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVoiceOfCustomerServiceCommandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateVoiceOfCustomerServiceCommandDto {
    id?: string;
}

export class DeleteVoiceOfCustomerServiceViewModel implements IDeleteVoiceOfCustomerServiceViewModel {
    id?: string;

    constructor(data?: IDeleteVoiceOfCustomerServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteVoiceOfCustomerServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteVoiceOfCustomerServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteVoiceOfCustomerServiceViewModel {
    id?: string;
}

export class BranchPageViewModel2 implements IBranchPageViewModel2 {
    results?: BranchDto5[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;

    constructor(data?: IBranchPageViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BranchDto5.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): BranchPageViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new BranchPageViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["pageCount"] = this.pageCount;
        return data;
    }
}

export interface IBranchPageViewModel2 {
    results?: BranchDto5[];
    totalCount?: number;
    pageSize?: number;
    pageNumber?: number;
    pageCount?: number;
}

export class BranchDto5 implements IBranchDto5 {
    id?: string;
    code?: string | undefined;
    displayName?: string;
    isEnabled?: boolean;
    isIncluded?: boolean;
    groups?: BranchGroupDto2[];

    constructor(data?: IBranchDto5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.isEnabled = _data["isEnabled"];
            this.isIncluded = _data["isIncluded"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(BranchGroupDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BranchDto5 {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDto5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["isEnabled"] = this.isEnabled;
        data["isIncluded"] = this.isIncluded;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBranchDto5 {
    id?: string;
    code?: string | undefined;
    displayName?: string;
    isEnabled?: boolean;
    isIncluded?: boolean;
    groups?: BranchGroupDto2[];
}

export class BranchGroupDto2 implements IBranchGroupDto2 {
    id?: string;
    name?: string;

    constructor(data?: IBranchGroupDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BranchGroupDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new BranchGroupDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBranchGroupDto2 {
    id?: string;
    name?: string;
}

export enum BranchSortingField2 {
    IsEnabled = 0,
    Code = 1,
    DisplayName = 2,
    Groups = 3,
}

export class GetCategoriesViewModel implements IGetCategoriesViewModel {
    categories?: GetCategoriesDto[];

    constructor(data?: IGetCategoriesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(GetCategoriesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCategoriesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoriesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCategoriesViewModel {
    categories?: GetCategoriesDto[];
}

export class GetCategoriesDto implements IGetCategoriesDto {
    id?: string;
    name?: string;
    supportedCultures?: string[];
    code?: string;

    constructor(data?: IGetCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["supportedCultures"])) {
                this.supportedCultures = [] as any;
                for (let item of _data["supportedCultures"])
                    this.supportedCultures!.push(item);
            }
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): GetCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.supportedCultures)) {
            data["supportedCultures"] = [];
            for (let item of this.supportedCultures)
                data["supportedCultures"].push(item);
        }
        data["code"] = this.code;
        return data;
    }
}

export interface IGetCategoriesDto {
    id?: string;
    name?: string;
    supportedCultures?: string[];
    code?: string;
}

export class GetCategoryByIdViewModel implements IGetCategoryByIdViewModel {
    categoryId?: string;
    category?: CategoryDto2;
    availableCultures?: GeneralCultureDto[];

    constructor(data?: IGetCategoryByIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.category = _data["category"] ? CategoryDto2.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["availableCultures"])) {
                this.availableCultures = [] as any;
                for (let item of _data["availableCultures"])
                    this.availableCultures!.push(GeneralCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCategoryByIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryByIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.availableCultures)) {
            data["availableCultures"] = [];
            for (let item of this.availableCultures)
                data["availableCultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCategoryByIdViewModel {
    categoryId?: string;
    category?: CategoryDto2;
    availableCultures?: GeneralCultureDto[];
}

export class CategoryDto2 implements ICategoryDto2 {
    name?: string;
    shortName?: string;
    code?: string;
    order?: number;
    cultures?: CategoryCultureDto[];

    constructor(data?: ICategoryDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.code = _data["code"];
            this.order = _data["order"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(CategoryCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["code"] = this.code;
        data["order"] = this.order;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryDto2 {
    name?: string;
    shortName?: string;
    code?: string;
    order?: number;
    cultures?: CategoryCultureDto[];
}

export class CategoryCultureDto implements ICategoryCultureDto {
    name?: string;
    shortName?: string;
    cultureCode?: string;

    constructor(data?: ICategoryCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): CategoryCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface ICategoryCultureDto {
    name?: string;
    shortName?: string;
    cultureCode?: string;
}

export class PromptCommandViewModel implements IPromptCommandViewModel {
    response?: string;
    success?: boolean;

    constructor(data?: IPromptCommandViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.response = _data["response"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): PromptCommandViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PromptCommandViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response;
        data["success"] = this.success;
        return data;
    }
}

export interface IPromptCommandViewModel {
    response?: string;
    success?: boolean;
}

export class PromptDto implements IPromptDto {
    prompt?: string;

    constructor(data?: IPromptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any): PromptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        return data;
    }
}

export interface IPromptDto {
    prompt?: string;
}

export class GetCustomImportConfigurationsViewModel implements IGetCustomImportConfigurationsViewModel {
    customImportConfigurationDtos?: GetCustomImportConfigurationDto[];

    constructor(data?: IGetCustomImportConfigurationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customImportConfigurationDtos"])) {
                this.customImportConfigurationDtos = [] as any;
                for (let item of _data["customImportConfigurationDtos"])
                    this.customImportConfigurationDtos!.push(GetCustomImportConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomImportConfigurationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomImportConfigurationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customImportConfigurationDtos)) {
            data["customImportConfigurationDtos"] = [];
            for (let item of this.customImportConfigurationDtos)
                data["customImportConfigurationDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCustomImportConfigurationsViewModel {
    customImportConfigurationDtos?: GetCustomImportConfigurationDto[];
}

export class GetCustomImportConfigurationDto implements IGetCustomImportConfigurationDto {
    id?: string;
    name?: string;
    enabled?: boolean;
    apiEnabled?: boolean;
    azureEnabled?: boolean;

    constructor(data?: IGetCustomImportConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            this.apiEnabled = _data["apiEnabled"];
            this.azureEnabled = _data["azureEnabled"];
        }
    }

    static fromJS(data: any): GetCustomImportConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomImportConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["apiEnabled"] = this.apiEnabled;
        data["azureEnabled"] = this.azureEnabled;
        return data;
    }
}

export interface IGetCustomImportConfigurationDto {
    id?: string;
    name?: string;
    enabled?: boolean;
    apiEnabled?: boolean;
    azureEnabled?: boolean;
}

export class GetCustomImportConfigurationViewModel implements IGetCustomImportConfigurationViewModel {
    customImportConfiguration?: EditCustomImportConfigurationDto;

    constructor(data?: IGetCustomImportConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customImportConfiguration = _data["customImportConfiguration"] ? EditCustomImportConfigurationDto.fromJS(_data["customImportConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCustomImportConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomImportConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customImportConfiguration"] = this.customImportConfiguration ? this.customImportConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCustomImportConfigurationViewModel {
    customImportConfiguration?: EditCustomImportConfigurationDto;
}

export class EditCustomImportConfigurationDto implements IEditCustomImportConfigurationDto {
    name?: string;
    apiKey?: string | undefined;
    azureStoragePath?: string | undefined;
    azureStorageFrequency?: string | undefined;
    azureStorageSeparator?: string | undefined;
    jsonValidatorSchema?: string;
    enabled?: boolean;
    apiEnabled?: boolean;
    azureStorageEnabled?: boolean;

    constructor(data?: IEditCustomImportConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.apiKey = _data["apiKey"];
            this.azureStoragePath = _data["azureStoragePath"];
            this.azureStorageFrequency = _data["azureStorageFrequency"];
            this.azureStorageSeparator = _data["azureStorageSeparator"];
            this.jsonValidatorSchema = _data["jsonValidatorSchema"];
            this.enabled = _data["enabled"];
            this.apiEnabled = _data["apiEnabled"];
            this.azureStorageEnabled = _data["azureStorageEnabled"];
        }
    }

    static fromJS(data: any): EditCustomImportConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCustomImportConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["apiKey"] = this.apiKey;
        data["azureStoragePath"] = this.azureStoragePath;
        data["azureStorageFrequency"] = this.azureStorageFrequency;
        data["azureStorageSeparator"] = this.azureStorageSeparator;
        data["jsonValidatorSchema"] = this.jsonValidatorSchema;
        data["enabled"] = this.enabled;
        data["apiEnabled"] = this.apiEnabled;
        data["azureStorageEnabled"] = this.azureStorageEnabled;
        return data;
    }
}

export interface IEditCustomImportConfigurationDto {
    name?: string;
    apiKey?: string | undefined;
    azureStoragePath?: string | undefined;
    azureStorageFrequency?: string | undefined;
    azureStorageSeparator?: string | undefined;
    jsonValidatorSchema?: string;
    enabled?: boolean;
    apiEnabled?: boolean;
    azureStorageEnabled?: boolean;
}

export class UpdateCustomImportConfigurationDto implements IUpdateCustomImportConfigurationDto {
    name?: string | undefined;
    apiKey?: string | undefined;
    azureStoragePath?: string | undefined;
    azureStorageSeparator?: string | undefined;
    azureStorageFrequency?: string | undefined;
    jsonValidatorSchema?: string | undefined;
    enabled?: boolean;
    apiEnabled?: boolean;
    azureStorageEnabled?: boolean;

    constructor(data?: IUpdateCustomImportConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.apiKey = _data["apiKey"];
            this.azureStoragePath = _data["azureStoragePath"];
            this.azureStorageSeparator = _data["azureStorageSeparator"];
            this.azureStorageFrequency = _data["azureStorageFrequency"];
            this.jsonValidatorSchema = _data["jsonValidatorSchema"];
            this.enabled = _data["enabled"];
            this.apiEnabled = _data["apiEnabled"];
            this.azureStorageEnabled = _data["azureStorageEnabled"];
        }
    }

    static fromJS(data: any): UpdateCustomImportConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomImportConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["apiKey"] = this.apiKey;
        data["azureStoragePath"] = this.azureStoragePath;
        data["azureStorageSeparator"] = this.azureStorageSeparator;
        data["azureStorageFrequency"] = this.azureStorageFrequency;
        data["jsonValidatorSchema"] = this.jsonValidatorSchema;
        data["enabled"] = this.enabled;
        data["apiEnabled"] = this.apiEnabled;
        data["azureStorageEnabled"] = this.azureStorageEnabled;
        return data;
    }
}

export interface IUpdateCustomImportConfigurationDto {
    name?: string | undefined;
    apiKey?: string | undefined;
    azureStoragePath?: string | undefined;
    azureStorageSeparator?: string | undefined;
    azureStorageFrequency?: string | undefined;
    jsonValidatorSchema?: string | undefined;
    enabled?: boolean;
    apiEnabled?: boolean;
    azureStorageEnabled?: boolean;
}

export class GetCustomImportProjectConfigurationsViewModel implements IGetCustomImportProjectConfigurationsViewModel {
    customImportProjectConfigurationsDtos?: GetCustomImportProjectConfigurationsDto[];

    constructor(data?: IGetCustomImportProjectConfigurationsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customImportProjectConfigurationsDtos"])) {
                this.customImportProjectConfigurationsDtos = [] as any;
                for (let item of _data["customImportProjectConfigurationsDtos"])
                    this.customImportProjectConfigurationsDtos!.push(GetCustomImportProjectConfigurationsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomImportProjectConfigurationsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomImportProjectConfigurationsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customImportProjectConfigurationsDtos)) {
            data["customImportProjectConfigurationsDtos"] = [];
            for (let item of this.customImportProjectConfigurationsDtos)
                data["customImportProjectConfigurationsDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCustomImportProjectConfigurationsViewModel {
    customImportProjectConfigurationsDtos?: GetCustomImportProjectConfigurationsDto[];
}

export class GetCustomImportProjectConfigurationsDto implements IGetCustomImportProjectConfigurationsDto {
    id?: string;
    name?: string;
    enabled?: boolean;
    sendEmail?: boolean;

    constructor(data?: IGetCustomImportProjectConfigurationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            this.sendEmail = _data["sendEmail"];
        }
    }

    static fromJS(data: any): GetCustomImportProjectConfigurationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomImportProjectConfigurationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["sendEmail"] = this.sendEmail;
        return data;
    }
}

export interface IGetCustomImportProjectConfigurationsDto {
    id?: string;
    name?: string;
    enabled?: boolean;
    sendEmail?: boolean;
}

export class GetCustomImportProjectConfigurationViewModel implements IGetCustomImportProjectConfigurationViewModel {
    customImportProjectConfiguration?: EditCustomImportProjectConfigurationDto;
    customImportConfigurations?: KeyValuePairOfStringAndString[];
    customImportConfigurationDefinedProperties?: KeyValuePairOfStringAndIEnumerableOfString[];
    forms?: KeyValuePairOfStringAndString[];
    formDefinedProperties?: KeyValuePairOfStringAndIEnumerableOfString[];
    emailTemplates?: KeyValuePairOfStringAndString[];
    cultures?: string[];

    constructor(data?: IGetCustomImportProjectConfigurationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customImportProjectConfiguration = _data["customImportProjectConfiguration"] ? EditCustomImportProjectConfigurationDto.fromJS(_data["customImportProjectConfiguration"]) : <any>undefined;
            if (Array.isArray(_data["customImportConfigurations"])) {
                this.customImportConfigurations = [] as any;
                for (let item of _data["customImportConfigurations"])
                    this.customImportConfigurations!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
            if (Array.isArray(_data["customImportConfigurationDefinedProperties"])) {
                this.customImportConfigurationDefinedProperties = [] as any;
                for (let item of _data["customImportConfigurationDefinedProperties"])
                    this.customImportConfigurationDefinedProperties!.push(KeyValuePairOfStringAndIEnumerableOfString.fromJS(item));
            }
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
            if (Array.isArray(_data["formDefinedProperties"])) {
                this.formDefinedProperties = [] as any;
                for (let item of _data["formDefinedProperties"])
                    this.formDefinedProperties!.push(KeyValuePairOfStringAndIEnumerableOfString.fromJS(item));
            }
            if (Array.isArray(_data["emailTemplates"])) {
                this.emailTemplates = [] as any;
                for (let item of _data["emailTemplates"])
                    this.emailTemplates!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCustomImportProjectConfigurationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomImportProjectConfigurationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customImportProjectConfiguration"] = this.customImportProjectConfiguration ? this.customImportProjectConfiguration.toJSON() : <any>undefined;
        if (Array.isArray(this.customImportConfigurations)) {
            data["customImportConfigurations"] = [];
            for (let item of this.customImportConfigurations)
                data["customImportConfigurations"].push(item.toJSON());
        }
        if (Array.isArray(this.customImportConfigurationDefinedProperties)) {
            data["customImportConfigurationDefinedProperties"] = [];
            for (let item of this.customImportConfigurationDefinedProperties)
                data["customImportConfigurationDefinedProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        if (Array.isArray(this.formDefinedProperties)) {
            data["formDefinedProperties"] = [];
            for (let item of this.formDefinedProperties)
                data["formDefinedProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.emailTemplates)) {
            data["emailTemplates"] = [];
            for (let item of this.emailTemplates)
                data["emailTemplates"].push(item.toJSON());
        }
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item);
        }
        return data;
    }
}

export interface IGetCustomImportProjectConfigurationViewModel {
    customImportProjectConfiguration?: EditCustomImportProjectConfigurationDto;
    customImportConfigurations?: KeyValuePairOfStringAndString[];
    customImportConfigurationDefinedProperties?: KeyValuePairOfStringAndIEnumerableOfString[];
    forms?: KeyValuePairOfStringAndString[];
    formDefinedProperties?: KeyValuePairOfStringAndIEnumerableOfString[];
    emailTemplates?: KeyValuePairOfStringAndString[];
    cultures?: string[];
}

export class EditCustomImportProjectConfigurationDto implements IEditCustomImportProjectConfigurationDto {
    customImportConfigurationId?: string;
    projectId?: string;
    conditionJsonProperty?: string | undefined;
    conditionOperator?: CustomConfigurationOperator | undefined;
    conditionValue?: string | undefined;
    cultureProperty?: string | undefined;
    branchIdProperty?: string | undefined;
    branchCodeProperty?: string | undefined;
    branchNameProperty?: string | undefined;
    sendEmailEnabled?: boolean;
    defaultSender?: string | undefined;
    defaultEmailSubject?: string | undefined;
    emailProperty?: string | undefined;
    defaultEmailTemplate?: string | undefined;
    recallAfterXDays?: number | undefined;
    enabled?: boolean;
    propertyMappings?: EditCustomImportMappingDto[];
    emailCultures?: EditCustomImportEmailCultureDto[];
    conditionalTemplates?: EditCustomImportConditionalTemplateDto[];

    constructor(data?: IEditCustomImportProjectConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customImportConfigurationId = _data["customImportConfigurationId"];
            this.projectId = _data["projectId"];
            this.conditionJsonProperty = _data["conditionJsonProperty"];
            this.conditionOperator = _data["conditionOperator"];
            this.conditionValue = _data["conditionValue"];
            this.cultureProperty = _data["cultureProperty"];
            this.branchIdProperty = _data["branchIdProperty"];
            this.branchCodeProperty = _data["branchCodeProperty"];
            this.branchNameProperty = _data["branchNameProperty"];
            this.sendEmailEnabled = _data["sendEmailEnabled"];
            this.defaultSender = _data["defaultSender"];
            this.defaultEmailSubject = _data["defaultEmailSubject"];
            this.emailProperty = _data["emailProperty"];
            this.defaultEmailTemplate = _data["defaultEmailTemplate"];
            this.recallAfterXDays = _data["recallAfterXDays"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["propertyMappings"])) {
                this.propertyMappings = [] as any;
                for (let item of _data["propertyMappings"])
                    this.propertyMappings!.push(EditCustomImportMappingDto.fromJS(item));
            }
            if (Array.isArray(_data["emailCultures"])) {
                this.emailCultures = [] as any;
                for (let item of _data["emailCultures"])
                    this.emailCultures!.push(EditCustomImportEmailCultureDto.fromJS(item));
            }
            if (Array.isArray(_data["conditionalTemplates"])) {
                this.conditionalTemplates = [] as any;
                for (let item of _data["conditionalTemplates"])
                    this.conditionalTemplates!.push(EditCustomImportConditionalTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditCustomImportProjectConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCustomImportProjectConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customImportConfigurationId"] = this.customImportConfigurationId;
        data["projectId"] = this.projectId;
        data["conditionJsonProperty"] = this.conditionJsonProperty;
        data["conditionOperator"] = this.conditionOperator;
        data["conditionValue"] = this.conditionValue;
        data["cultureProperty"] = this.cultureProperty;
        data["branchIdProperty"] = this.branchIdProperty;
        data["branchCodeProperty"] = this.branchCodeProperty;
        data["branchNameProperty"] = this.branchNameProperty;
        data["sendEmailEnabled"] = this.sendEmailEnabled;
        data["defaultSender"] = this.defaultSender;
        data["defaultEmailSubject"] = this.defaultEmailSubject;
        data["emailProperty"] = this.emailProperty;
        data["defaultEmailTemplate"] = this.defaultEmailTemplate;
        data["recallAfterXDays"] = this.recallAfterXDays;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.propertyMappings)) {
            data["propertyMappings"] = [];
            for (let item of this.propertyMappings)
                data["propertyMappings"].push(item.toJSON());
        }
        if (Array.isArray(this.emailCultures)) {
            data["emailCultures"] = [];
            for (let item of this.emailCultures)
                data["emailCultures"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionalTemplates)) {
            data["conditionalTemplates"] = [];
            for (let item of this.conditionalTemplates)
                data["conditionalTemplates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditCustomImportProjectConfigurationDto {
    customImportConfigurationId?: string;
    projectId?: string;
    conditionJsonProperty?: string | undefined;
    conditionOperator?: CustomConfigurationOperator | undefined;
    conditionValue?: string | undefined;
    cultureProperty?: string | undefined;
    branchIdProperty?: string | undefined;
    branchCodeProperty?: string | undefined;
    branchNameProperty?: string | undefined;
    sendEmailEnabled?: boolean;
    defaultSender?: string | undefined;
    defaultEmailSubject?: string | undefined;
    emailProperty?: string | undefined;
    defaultEmailTemplate?: string | undefined;
    recallAfterXDays?: number | undefined;
    enabled?: boolean;
    propertyMappings?: EditCustomImportMappingDto[];
    emailCultures?: EditCustomImportEmailCultureDto[];
    conditionalTemplates?: EditCustomImportConditionalTemplateDto[];
}

export enum CustomConfigurationOperator {
    Equal = 0,
    Different = 1,
    SmallerThanOrEqual = 2,
    SmallerThan = 3,
    GreaterThanOrEqual = 4,
    GreaterThan = 5,
}

export class EditCustomImportMappingDto implements IEditCustomImportMappingDto {
    formId?: string | undefined;
    jsonProperty?: string | undefined;
    questionName?: string | undefined;

    constructor(data?: IEditCustomImportMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.jsonProperty = _data["jsonProperty"];
            this.questionName = _data["questionName"];
        }
    }

    static fromJS(data: any): EditCustomImportMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCustomImportMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["jsonProperty"] = this.jsonProperty;
        data["questionName"] = this.questionName;
        return data;
    }
}

export interface IEditCustomImportMappingDto {
    formId?: string | undefined;
    jsonProperty?: string | undefined;
    questionName?: string | undefined;
}

export class EditCustomImportEmailCultureDto implements IEditCustomImportEmailCultureDto {
    cultureCode?: string | undefined;
    sender?: string | undefined;
    subject?: string | undefined;

    constructor(data?: IEditCustomImportEmailCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.sender = _data["sender"];
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): EditCustomImportEmailCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCustomImportEmailCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["sender"] = this.sender;
        data["subject"] = this.subject;
        return data;
    }
}

export interface IEditCustomImportEmailCultureDto {
    cultureCode?: string | undefined;
    sender?: string | undefined;
    subject?: string | undefined;
}

export class EditCustomImportConditionalTemplateDto implements IEditCustomImportConditionalTemplateDto {
    priority?: number | undefined;
    emailTemplate?: string | undefined;
    jsonProperty?: string | undefined;
    operator?: CustomConfigurationOperator | undefined;
    value?: string | undefined;

    constructor(data?: IEditCustomImportConditionalTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"];
            this.emailTemplate = _data["emailTemplate"];
            this.jsonProperty = _data["jsonProperty"];
            this.operator = _data["operator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EditCustomImportConditionalTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCustomImportConditionalTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority;
        data["emailTemplate"] = this.emailTemplate;
        data["jsonProperty"] = this.jsonProperty;
        data["operator"] = this.operator;
        data["value"] = this.value;
        return data;
    }
}

export interface IEditCustomImportConditionalTemplateDto {
    priority?: number | undefined;
    emailTemplate?: string | undefined;
    jsonProperty?: string | undefined;
    operator?: CustomConfigurationOperator | undefined;
    value?: string | undefined;
}

export class GetExportCustomImportLinksViewModel implements IGetExportCustomImportLinksViewModel {
    fileNames?: string[];

    constructor(data?: IGetExportCustomImportLinksViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileNames"])) {
                this.fileNames = [] as any;
                for (let item of _data["fileNames"])
                    this.fileNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetExportCustomImportLinksViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetExportCustomImportLinksViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileNames)) {
            data["fileNames"] = [];
            for (let item of this.fileNames)
                data["fileNames"].push(item);
        }
        return data;
    }
}

export interface IGetExportCustomImportLinksViewModel {
    fileNames?: string[];
}

export class ExportCustomImportFilterOptions implements IExportCustomImportFilterOptions {
    filename?: string | undefined;

    constructor(data?: IExportCustomImportFilterOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
        }
    }

    static fromJS(data: any): ExportCustomImportFilterOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCustomImportFilterOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        return data;
    }
}

export interface IExportCustomImportFilterOptions {
    filename?: string | undefined;
}

export class GetCreateFormWizardViewModel2 implements IGetCreateFormWizardViewModel2 {
    parents?: GetCreateFormWizardProjectDto2[];

    constructor(data?: IGetCreateFormWizardViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(GetCreateFormWizardProjectDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreateFormWizardViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateFormWizardViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreateFormWizardViewModel2 {
    parents?: GetCreateFormWizardProjectDto2[];
}

export class GetCreateFormWizardProjectDto2 implements IGetCreateFormWizardProjectDto2 {
    id?: string;
    name?: string;
    forms?: GetCreateFormWizardFormDto2[];

    constructor(data?: IGetCreateFormWizardProjectDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(GetCreateFormWizardFormDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreateFormWizardProjectDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateFormWizardProjectDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreateFormWizardProjectDto2 {
    id?: string;
    name?: string;
    forms?: GetCreateFormWizardFormDto2[];
}

export class GetCreateFormWizardFormDto2 implements IGetCreateFormWizardFormDto2 {
    id?: string;
    name?: string;

    constructor(data?: IGetCreateFormWizardFormDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCreateFormWizardFormDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateFormWizardFormDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCreateFormWizardFormDto2 {
    id?: string;
    name?: string;
}

export class FormVersionTransferDto2 implements IFormVersionTransferDto2 {
    questionTransfers?: QuestionTransfer2[];

    constructor(data?: IFormVersionTransferDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questionTransfers"])) {
                this.questionTransfers = [] as any;
                for (let item of _data["questionTransfers"])
                    this.questionTransfers!.push(QuestionTransfer2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormVersionTransferDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new FormVersionTransferDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questionTransfers)) {
            data["questionTransfers"] = [];
            for (let item of this.questionTransfers)
                data["questionTransfers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormVersionTransferDto2 {
    questionTransfers?: QuestionTransfer2[];
}

export class QuestionTransfer2 implements IQuestionTransfer2 {
    source?: string;
    target?: string;
    rows?: ChoiceTransfer2[] | undefined;
    choices?: ChoiceTransfer2[];

    constructor(data?: IQuestionTransfer2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.target = _data["target"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ChoiceTransfer2.fromJS(item));
            }
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(ChoiceTransfer2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionTransfer2 {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionTransfer2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["target"] = this.target;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionTransfer2 {
    source?: string;
    target?: string;
    rows?: ChoiceTransfer2[] | undefined;
    choices?: ChoiceTransfer2[];
}

export class ChoiceTransfer2 implements IChoiceTransfer2 {
    source?: string;
    target?: string;

    constructor(data?: IChoiceTransfer2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): ChoiceTransfer2 {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceTransfer2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["target"] = this.target;
        return data;
    }
}

export interface IChoiceTransfer2 {
    source?: string;
    target?: string;
}

export class WordExportModel implements IWordExportModel {
    header?: string;
    conditionMessage?: string;
    welcomeMessage?: string;
    en?: boolean;
    fr?: boolean;

    constructor(data?: IWordExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.conditionMessage = _data["conditionMessage"];
            this.welcomeMessage = _data["welcomeMessage"];
            this.en = _data["en"];
            this.fr = _data["fr"];
        }
    }

    static fromJS(data: any): WordExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new WordExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["conditionMessage"] = this.conditionMessage;
        data["welcomeMessage"] = this.welcomeMessage;
        data["en"] = this.en;
        data["fr"] = this.fr;
        return data;
    }
}

export interface IWordExportModel {
    header?: string;
    conditionMessage?: string;
    welcomeMessage?: string;
    en?: boolean;
    fr?: boolean;
}

export class GetMoveProjectViewModel implements IGetMoveProjectViewModel {
    subscriptionServices?: GetMoveProjectSubscriptionServiceDto[];
    canMove?: boolean;

    constructor(data?: IGetMoveProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subscriptionServices"])) {
                this.subscriptionServices = [] as any;
                for (let item of _data["subscriptionServices"])
                    this.subscriptionServices!.push(GetMoveProjectSubscriptionServiceDto.fromJS(item));
            }
            this.canMove = _data["canMove"];
        }
    }

    static fromJS(data: any): GetMoveProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoveProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscriptionServices)) {
            data["subscriptionServices"] = [];
            for (let item of this.subscriptionServices)
                data["subscriptionServices"].push(item.toJSON());
        }
        data["canMove"] = this.canMove;
        return data;
    }
}

export interface IGetMoveProjectViewModel {
    subscriptionServices?: GetMoveProjectSubscriptionServiceDto[];
    canMove?: boolean;
}

export class GetMoveProjectSubscriptionServiceDto implements IGetMoveProjectSubscriptionServiceDto {
    id?: string;
    organizationId?: string;
    organizationName?: string;
    subscriptionId?: string;
    subscriptionName?: string;
    subscriptionServiceId?: string;
    subscriptionServiceName?: string;
    displayName?: string;

    constructor(data?: IGetMoveProjectSubscriptionServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionName = _data["subscriptionName"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.subscriptionServiceName = _data["subscriptionServiceName"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): GetMoveProjectSubscriptionServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoveProjectSubscriptionServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionName"] = this.subscriptionName;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["subscriptionServiceName"] = this.subscriptionServiceName;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGetMoveProjectSubscriptionServiceDto {
    id?: string;
    organizationId?: string;
    organizationName?: string;
    subscriptionId?: string;
    subscriptionName?: string;
    subscriptionServiceId?: string;
    subscriptionServiceName?: string;
    displayName?: string;
}

export class MoveProjectViewModel implements IMoveProjectViewModel {
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;

    constructor(data?: IMoveProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): MoveProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MoveProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IMoveProjectViewModel {
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;
}

export class VocProjectDto implements IVocProjectDto {
    name?: string;
    order?: number | undefined;
    cultures?: VocProjectCultureDto[];

    constructor(data?: IVocProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.order = _data["order"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(VocProjectCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VocProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new VocProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVocProjectDto {
    name?: string;
    order?: number | undefined;
    cultures?: VocProjectCultureDto[];
}

export class VocProjectCultureDto implements IVocProjectCultureDto {
    name?: string;
    cultureCode?: string;

    constructor(data?: IVocProjectCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): VocProjectCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new VocProjectCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IVocProjectCultureDto {
    name?: string;
    cultureCode?: string;
}

export class GetCreateProjectViewModel2 implements IGetCreateProjectViewModel2 {
    availableCultures?: GeneralCultureDto[];

    constructor(data?: IGetCreateProjectViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["availableCultures"])) {
                this.availableCultures = [] as any;
                for (let item of _data["availableCultures"])
                    this.availableCultures!.push(GeneralCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCreateProjectViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateProjectViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.availableCultures)) {
            data["availableCultures"] = [];
            for (let item of this.availableCultures)
                data["availableCultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCreateProjectViewModel2 {
    availableCultures?: GeneralCultureDto[];
}

export class GetProjectViewModel2 implements IGetProjectViewModel2 {
    project?: VocProjectDto;
    availableCultures?: GeneralCultureDto[];

    constructor(data?: IGetProjectViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? VocProjectDto.fromJS(_data["project"]) : <any>undefined;
            if (Array.isArray(_data["availableCultures"])) {
                this.availableCultures = [] as any;
                for (let item of _data["availableCultures"])
                    this.availableCultures!.push(GeneralCultureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        if (Array.isArray(this.availableCultures)) {
            data["availableCultures"] = [];
            for (let item of this.availableCultures)
                data["availableCultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectViewModel2 {
    project?: VocProjectDto;
    availableCultures?: GeneralCultureDto[];
}

export class SurveyJsBuilderViewModel implements ISurveyJsBuilderViewModel {
    branchesUrl?: string;
    categories?: SurveyJsCategoryDto[];
    taxonomies?: TaxonomyDto2[];

    constructor(data?: ISurveyJsBuilderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchesUrl = _data["branchesUrl"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(SurveyJsCategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["taxonomies"])) {
                this.taxonomies = [] as any;
                for (let item of _data["taxonomies"])
                    this.taxonomies!.push(TaxonomyDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyJsBuilderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyJsBuilderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchesUrl"] = this.branchesUrl;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.taxonomies)) {
            data["taxonomies"] = [];
            for (let item of this.taxonomies)
                data["taxonomies"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyJsBuilderViewModel {
    branchesUrl?: string;
    categories?: SurveyJsCategoryDto[];
    taxonomies?: TaxonomyDto2[];
}

export class SurveyJsCategoryDto implements ISurveyJsCategoryDto {
    id?: string;
    code?: string;
    name?: string;
    projectId?: string;
    order?: number;
    cultures?: SurveyJsCategoryCultureDto[];
    shortName?: string;

    constructor(data?: ISurveyJsCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.order = _data["order"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(SurveyJsCategoryCultureDto.fromJS(item));
            }
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): SurveyJsCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyJsCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["order"] = this.order;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface ISurveyJsCategoryDto {
    id?: string;
    code?: string;
    name?: string;
    projectId?: string;
    order?: number;
    cultures?: SurveyJsCategoryCultureDto[];
    shortName?: string;
}

export class SurveyJsCategoryCultureDto implements ISurveyJsCategoryCultureDto {
    id?: string;
    name?: string;
    shortName?: string;
    cultureCode?: string;
    categoryId?: string;

    constructor(data?: ISurveyJsCategoryCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.cultureCode = _data["cultureCode"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): SurveyJsCategoryCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyJsCategoryCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["cultureCode"] = this.cultureCode;
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface ISurveyJsCategoryCultureDto {
    id?: string;
    name?: string;
    shortName?: string;
    cultureCode?: string;
    categoryId?: string;
}

export class TaxonomyDto2 implements ITaxonomyDto2 {
    code?: string;
    name?: string;

    constructor(data?: ITaxonomyDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaxonomyDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new TaxonomyDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ITaxonomyDto2 {
    code?: string;
    name?: string;
}

export class GetProjectUrlsViewModel implements IGetProjectUrlsViewModel {
    projectUrls?: EditProjectUrlDto[];

    constructor(data?: IGetProjectUrlsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectUrls"])) {
                this.projectUrls = [] as any;
                for (let item of _data["projectUrls"])
                    this.projectUrls!.push(EditProjectUrlDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectUrlsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectUrlsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectUrls)) {
            data["projectUrls"] = [];
            for (let item of this.projectUrls)
                data["projectUrls"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectUrlsViewModel {
    projectUrls?: EditProjectUrlDto[];
}

export class EditProjectUrlDto implements IEditProjectUrlDto {
    id?: string | undefined;
    type?: UrlType;
    custom?: string | undefined;
    domain?: string | undefined;
    subDomain?: string | undefined;
    path?: string | undefined;
    secured?: boolean;

    constructor(data?: IEditProjectUrlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.custom = _data["custom"];
            this.domain = _data["domain"];
            this.subDomain = _data["subDomain"];
            this.path = _data["path"];
            this.secured = _data["secured"];
        }
    }

    static fromJS(data: any): EditProjectUrlDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditProjectUrlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["custom"] = this.custom;
        data["domain"] = this.domain;
        data["subDomain"] = this.subDomain;
        data["path"] = this.path;
        data["secured"] = this.secured;
        return data;
    }
}

export interface IEditProjectUrlDto {
    id?: string | undefined;
    type?: UrlType;
    custom?: string | undefined;
    domain?: string | undefined;
    subDomain?: string | undefined;
    path?: string | undefined;
    secured?: boolean;
}

export class ProjectUrlSaveResult implements IProjectUrlSaveResult {
    projectUrlId?: string;
    success?: boolean;
    conflictingUrl?: ProjectUrl2 | undefined;

    constructor(data?: IProjectUrlSaveResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectUrlId = _data["projectUrlId"];
            this.success = _data["success"];
            this.conflictingUrl = _data["conflictingUrl"] ? ProjectUrl2.fromJS(_data["conflictingUrl"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectUrlSaveResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUrlSaveResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectUrlId"] = this.projectUrlId;
        data["success"] = this.success;
        data["conflictingUrl"] = this.conflictingUrl ? this.conflictingUrl.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectUrlSaveResult {
    projectUrlId?: string;
    success?: boolean;
    conflictingUrl?: ProjectUrl2 | undefined;
}

export class ProjectUrl2 implements IProjectUrl2 {
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;
    projectUrlId?: string;

    constructor(data?: IProjectUrl2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.projectId = _data["projectId"];
            this.projectUrlId = _data["projectUrlId"];
        }
    }

    static fromJS(data: any): ProjectUrl2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUrl2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["projectId"] = this.projectId;
        data["projectUrlId"] = this.projectUrlId;
        return data;
    }
}

export interface IProjectUrl2 {
    organizationId?: string;
    subscriptionId?: string;
    subscriptionServiceId?: string;
    projectId?: string;
    projectUrlId?: string;
}

export class GetFormsViewModel implements IGetFormsViewModel {
    forms?: Form[];

    constructor(data?: IGetFormsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(Form.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFormsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFormsViewModel {
    forms?: Form[];
}

export class GetFormViewModel2 implements IGetFormViewModel2 {
    form?: GetFormDto;

    constructor(data?: IGetFormViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.form = _data["form"] ? GetFormDto.fromJS(_data["form"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFormViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFormViewModel2 {
    form?: GetFormDto;
}

export class GetFormDto implements IGetFormDto {
    id?: string;
    projectId?: string;
    name?: string;
    formVersions?: GetFormVersionDto2[];

    constructor(data?: IGetFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            if (Array.isArray(_data["formVersions"])) {
                this.formVersions = [] as any;
                for (let item of _data["formVersions"])
                    this.formVersions!.push(GetFormVersionDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        if (Array.isArray(this.formVersions)) {
            data["formVersions"] = [];
            for (let item of this.formVersions)
                data["formVersions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFormDto {
    id?: string;
    projectId?: string;
    name?: string;
    formVersions?: GetFormVersionDto2[];
}

export class GetFormVersionDto2 implements IGetFormVersionDto2 {
    id?: string;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string;

    constructor(data?: IGetFormVersionDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formId = _data["formId"];
            this.state = _data["state"];
            this.majorVersion = _data["majorVersion"];
            this.minorVersion = _data["minorVersion"];
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): GetFormVersionDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormVersionDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formId"] = this.formId;
        data["state"] = this.state;
        data["majorVersion"] = this.majorVersion;
        data["minorVersion"] = this.minorVersion;
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IGetFormVersionDto2 {
    id?: string;
    formId?: string;
    state?: FormState;
    majorVersion?: number;
    minorVersion?: number;
    formJson?: string;
}

export class GetVersionViewModel implements IGetVersionViewModel {
    formVersion?: GetFormVersionDto2;

    constructor(data?: IGetVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formVersion = _data["formVersion"] ? GetFormVersionDto2.fromJS(_data["formVersion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formVersion"] = this.formVersion ? this.formVersion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVersionViewModel {
    formVersion?: GetFormVersionDto2;
}

export class FormVersionPatchDto implements IFormVersionPatchDto {
    formJson?: string;

    constructor(data?: IFormVersionPatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formJson = _data["formJson"];
        }
    }

    static fromJS(data: any): FormVersionPatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormVersionPatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formJson"] = this.formJson;
        return data;
    }
}

export interface IFormVersionPatchDto {
    formJson?: string;
}

export class GetDatePickerSequenceListViewModel2 implements IGetDatePickerSequenceListViewModel2 {
    datePickerSequences?: GetDatePickerSequenceListDto2[];

    constructor(data?: IGetDatePickerSequenceListViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datePickerSequences"])) {
                this.datePickerSequences = [] as any;
                for (let item of _data["datePickerSequences"])
                    this.datePickerSequences!.push(GetDatePickerSequenceListDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDatePickerSequenceListViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatePickerSequenceListViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datePickerSequences)) {
            data["datePickerSequences"] = [];
            for (let item of this.datePickerSequences)
                data["datePickerSequences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDatePickerSequenceListViewModel2 {
    datePickerSequences?: GetDatePickerSequenceListDto2[];
}

export class GetDatePickerSequenceListDto2 implements IGetDatePickerSequenceListDto2 {
    id?: string;
    dateType?: DateType;
    order?: number;
    enabled?: boolean;
    cultures?: GetDatePickerSequenceListCultureDto2[];

    constructor(data?: IGetDatePickerSequenceListDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateType = _data["dateType"];
            this.order = _data["order"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(GetDatePickerSequenceListCultureDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDatePickerSequenceListDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatePickerSequenceListDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateType"] = this.dateType;
        data["order"] = this.order;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDatePickerSequenceListDto2 {
    id?: string;
    dateType?: DateType;
    order?: number;
    enabled?: boolean;
    cultures?: GetDatePickerSequenceListCultureDto2[];
}

export class GetDatePickerSequenceListCultureDto2 implements IGetDatePickerSequenceListCultureDto2 {
    cultureCode?: string;
    text?: string;
    isDefault?: boolean;

    constructor(data?: IGetDatePickerSequenceListCultureDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.text = _data["text"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): GetDatePickerSequenceListCultureDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetDatePickerSequenceListCultureDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["text"] = this.text;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IGetDatePickerSequenceListCultureDto2 {
    cultureCode?: string;
    text?: string;
    isDefault?: boolean;
}

export class UpdateDatePickerSequenceListRequest2 implements IUpdateDatePickerSequenceListRequest2 {
    datePickerSequences?: UpdateDatePickerSequenceListDto2[];

    constructor(data?: IUpdateDatePickerSequenceListRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["datePickerSequences"])) {
                this.datePickerSequences = [] as any;
                for (let item of _data["datePickerSequences"])
                    this.datePickerSequences!.push(UpdateDatePickerSequenceListDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDatePickerSequenceListRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDatePickerSequenceListRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.datePickerSequences)) {
            data["datePickerSequences"] = [];
            for (let item of this.datePickerSequences)
                data["datePickerSequences"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateDatePickerSequenceListRequest2 {
    datePickerSequences?: UpdateDatePickerSequenceListDto2[];
}

export class UpdateDatePickerSequenceListDto2 implements IUpdateDatePickerSequenceListDto2 {
    dateType?: DateType;
    order?: number | undefined;
    enabled?: boolean | undefined;
    cultures?: UpdateDatePickerSequenceListCultureDto2[] | undefined;

    constructor(data?: IUpdateDatePickerSequenceListDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateType = _data["dateType"];
            this.order = _data["order"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(UpdateDatePickerSequenceListCultureDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDatePickerSequenceListDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDatePickerSequenceListDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateType"] = this.dateType;
        data["order"] = this.order;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateDatePickerSequenceListDto2 {
    dateType?: DateType;
    order?: number | undefined;
    enabled?: boolean | undefined;
    cultures?: UpdateDatePickerSequenceListCultureDto2[] | undefined;
}

export class UpdateDatePickerSequenceListCultureDto2 implements IUpdateDatePickerSequenceListCultureDto2 {
    cultureCode?: string;
    text?: string;
    isDefault?: boolean;

    constructor(data?: IUpdateDatePickerSequenceListCultureDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.text = _data["text"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UpdateDatePickerSequenceListCultureDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDatePickerSequenceListCultureDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["text"] = this.text;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IUpdateDatePickerSequenceListCultureDto2 {
    cultureCode?: string;
    text?: string;
    isDefault?: boolean;
}

export class ProjectsListViewModel implements IProjectsListViewModel {
    projects?: VocProjectResult[];

    constructor(data?: IProjectsListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(VocProjectResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectsListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectsListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectsListViewModel {
    projects?: VocProjectResult[];
}

export class VocProjectResult implements IVocProjectResult {
    subscriptionServiceId?: string;
    id?: string;
    name?: string;
    subjectPath?: any[];
    maxHierarchyRole?: HierarchyRoleType;

    constructor(data?: IVocProjectResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionServiceId = _data["subscriptionServiceId"];
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["subjectPath"])) {
                this.subjectPath = [] as any;
                for (let item of _data["subjectPath"])
                    this.subjectPath!.push(item);
            }
            this.maxHierarchyRole = _data["maxHierarchyRole"];
        }
    }

    static fromJS(data: any): VocProjectResult {
        data = typeof data === 'object' ? data : {};
        let result = new VocProjectResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionServiceId"] = this.subscriptionServiceId;
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.subjectPath)) {
            data["subjectPath"] = [];
            for (let item of this.subjectPath)
                data["subjectPath"].push(item);
        }
        data["maxHierarchyRole"] = this.maxHierarchyRole;
        return data;
    }
}

export interface IVocProjectResult {
    subscriptionServiceId?: string;
    id?: string;
    name?: string;
    subjectPath?: any[];
    maxHierarchyRole?: HierarchyRoleType;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

// examples: https://github.com/NSwag/Samples/blob/master/src/SampleWebApiCoreAngular/ClientApp/app/services.extensions.ts